// data taken from https://github.com/datasets/harmonized-system/blob/main/data/harmonized-system.csv
// they got their data from https://comtradeplus.un.org/
// cspell:disable

export interface HarmonizationCode {
  section: string;
  hscode: string;
  description: string;
  parent: string;
  level: string;
}

// A chapter is a 2 digit number, a heading is a 4 digit number, and a subheading is a 6 digit number
// HS Codes are the subheadings, the 6 digit numbers
// https://trade.ec.europa.eu/access-to-markets/en/glossary/chapters-headings-and-subheadings
const HS_CODE_CHAPTERS_HEADINGS_AND_SUBHEADINGS: HarmonizationCode[] = [
  {
    section: "I",
    hscode: "01",
    description: "Animals; live",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "I",
    hscode: "0101",
    description: "Horses, asses, mules and hinnies; live",
    parent: "01",
    level: "4",
  },
  {
    section: "I",
    hscode: "010121",
    description: "Horses; live, pure-bred breeding animals",
    parent: "0101",
    level: "6",
  },
  {
    section: "I",
    hscode: "010129",
    description: "Horses; live, other than pure-bred breeding animals",
    parent: "0101",
    level: "6",
  },
  {
    section: "I",
    hscode: "010130",
    description: "Asses; live",
    parent: "0101",
    level: "6",
  },
  {
    section: "I",
    hscode: "010190",
    description: "Mules and hinnies; live",
    parent: "0101",
    level: "6",
  },
  {
    section: "I",
    hscode: "0102",
    description: "Bovine animals; live",
    parent: "01",
    level: "4",
  },
  {
    section: "I",
    hscode: "010221",
    description: "Cattle; live, pure-bred breeding animals",
    parent: "0102",
    level: "6",
  },
  {
    section: "I",
    hscode: "010229",
    description: "Cattle; live, other than pure-bred breeding animals",
    parent: "0102",
    level: "6",
  },
  {
    section: "I",
    hscode: "010231",
    description: "Buffalo; live, pure-bred breeding animals",
    parent: "0102",
    level: "6",
  },
  {
    section: "I",
    hscode: "010239",
    description: "Buffalo; live, other than pure-bred breeding animals",
    parent: "0102",
    level: "6",
  },
  {
    section: "I",
    hscode: "010290",
    description: "Bovine animals; live, other than cattle and buffalo",
    parent: "0102",
    level: "6",
  },
  {
    section: "I",
    hscode: "0103",
    description: "Swine; live",
    parent: "01",
    level: "4",
  },
  {
    section: "I",
    hscode: "010310",
    description: "Swine; live, pure-bred breeding animals",
    parent: "0103",
    level: "6",
  },
  {
    section: "I",
    hscode: "010391",
    description:
      "Swine; live, other than pure-bred breeding animals, weighing less than 50kg",
    parent: "0103",
    level: "6",
  },
  {
    section: "I",
    hscode: "010392",
    description:
      "Swine; live, other than pure-bred breeding animals, weighing 50kg or more",
    parent: "0103",
    level: "6",
  },
  {
    section: "I",
    hscode: "0104",
    description: "Sheep and goats; live",
    parent: "01",
    level: "4",
  },
  {
    section: "I",
    hscode: "010410",
    description: "Sheep; live",
    parent: "0104",
    level: "6",
  },
  {
    section: "I",
    hscode: "010420",
    description: "Goats; live",
    parent: "0104",
    level: "6",
  },
  {
    section: "I",
    hscode: "0105",
    description:
      "Poultry; live, fowls of the species Gallus domesticus, ducks, geese, turkeys and guinea fowls",
    parent: "01",
    level: "4",
  },
  {
    section: "I",
    hscode: "010511",
    description:
      "Poultry; live, fowls of the species Gallus domesticus, weighing not more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "010512",
    description: "Poultry; live, turkeys, weighing not more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "010513",
    description: "Poultry; live, ducks, weighing not more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "010514",
    description: "Poultry; live, geese, weighing not more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "010515",
    description: "Poultry; live, guinea fowls, weighing not more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "010594",
    description:
      "Poultry; live, fowls of the species Gallus domesticus, weighing more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "010599",
    description:
      "Poultry; live, ducks, geese, turkeys and guinea fowls, weighing more than 185g",
    parent: "0105",
    level: "6",
  },
  {
    section: "I",
    hscode: "0106",
    description: "Animals; live, n.e.c. in chapter 01",
    parent: "01",
    level: "4",
  },
  {
    section: "I",
    hscode: "010611",
    description: "Mammals; live, primates",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010612",
    description:
      "Mammals; live, whales, dolphins and porpoises (mammals of the order Cetacea); manatees and dugongs (mammals of the order Sirenia); seals, sea lions and walruses (mammals of the suborder Pinnipedia)",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010613",
    description: "Mammals; live, camels and other camelids (Camelidae)",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010614",
    description: "Mammals; live, rabbits and hares",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010619",
    description:
      "Mammals; live, other than primates, whales, dolphins, porpoises (mammals of the order Cetacea); manatees, dugongs (mammals of the order Sirenia); seals, sea lions, walruses (mammals of the suborder Pinnipedia), camels, other camelids, rabbits and hares",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010620",
    description: "Reptiles; live (including snakes and turtles)",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010631",
    description: "Birds; live, birds of prey",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010632",
    description: "Birds; live, Psittaciformes",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010633",
    description: "Birds; live, ostriches; emus (Dromaius novaehollandiae)",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010639",
    description:
      "Birds; live, other than birds of prey, Psittaciformes, ostriches and emus (Dromaius novaehollandiae)",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010641",
    description: "Insects; live, bees",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010649",
    description: "Insects; live, other than bees",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "010690",
    description:
      "Animals; live, n.e.c. in chapter 01, other than mammals, reptiles, birds and insects",
    parent: "0106",
    level: "6",
  },
  {
    section: "I",
    hscode: "02",
    description: "Meat and edible meat offal",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "I",
    hscode: "0201",
    description: "Meat of bovine animals; fresh or chilled",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020110",
    description:
      "Meat; of bovine animals, carcasses and half-carcasses, fresh or chilled",
    parent: "0201",
    level: "6",
  },
  {
    section: "I",
    hscode: "020120",
    description:
      "Meat; of bovine animals, cuts with bone in (excluding carcasses and half-carcasses), fresh or chilled",
    parent: "0201",
    level: "6",
  },
  {
    section: "I",
    hscode: "020130",
    description: "Meat; of bovine animals, boneless cuts, fresh or chilled",
    parent: "0201",
    level: "6",
  },
  {
    section: "I",
    hscode: "0202",
    description: "Meat of bovine animals; frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020210",
    description:
      "Meat; of bovine animals, carcasses and half-carcasses, frozen",
    parent: "0202",
    level: "6",
  },
  {
    section: "I",
    hscode: "020220",
    description:
      "Meat; of bovine animals, cuts with bone in (excluding carcasses and half-carcasses), frozen",
    parent: "0202",
    level: "6",
  },
  {
    section: "I",
    hscode: "020230",
    description: "Meat; of bovine animals, boneless cuts, frozen",
    parent: "0202",
    level: "6",
  },
  {
    section: "I",
    hscode: "0203",
    description: "Meat of swine; fresh, chilled or frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020311",
    description:
      "Meat; of swine, carcasses and half-carcasses, fresh or chilled",
    parent: "0203",
    level: "6",
  },
  {
    section: "I",
    hscode: "020312",
    description:
      "Meat; of swine, hams, shoulders and cuts thereof, with bone in, fresh or chilled",
    parent: "0203",
    level: "6",
  },
  {
    section: "I",
    hscode: "020319",
    description: "Meat; of swine, n.e.c. in item no. 0203.1, fresh or chilled",
    parent: "0203",
    level: "6",
  },
  {
    section: "I",
    hscode: "020321",
    description: "Meat; of swine, carcasses and half-carcasses, frozen",
    parent: "0203",
    level: "6",
  },
  {
    section: "I",
    hscode: "020322",
    description:
      "Meat; of swine, hams, shoulders and cuts thereof, with bone in, frozen",
    parent: "0203",
    level: "6",
  },
  {
    section: "I",
    hscode: "020329",
    description: "Meat; of swine, n.e.c. in item no. 0203.2, frozen",
    parent: "0203",
    level: "6",
  },
  {
    section: "I",
    hscode: "0204",
    description: "Meat of sheep or goats; fresh, chilled or frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020410",
    description:
      "Meat; of sheep, lamb carcasses and half-carcasses, fresh or chilled",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020421",
    description:
      "Meat; of sheep, carcasses and half-carcasses (excluding carcasses and half-carcasses of lamb), fresh or chilled",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020422",
    description:
      "Meat; of sheep (including lamb), cuts with bone in (excluding carcasses and half-carcasses), fresh or chilled",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020423",
    description:
      "Meat; of sheep (including lamb), boneless cuts, fresh or chilled",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020430",
    description: "Meat; of sheep, lamb carcasses and half-carcasses, frozen",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020441",
    description:
      "Meat; of sheep, carcasses and half-carcasses (excluding carcasses and half-carcasses of lamb), frozen",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020442",
    description:
      "Meat; of sheep (including lamb), cuts with bone in (excluding carcasses and half-carcasses), frozen",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020443",
    description: "Meat; of sheep (including lamb), boneless cuts, frozen",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "020450",
    description: "Meat; of goats, fresh, chilled or frozen",
    parent: "0204",
    level: "6",
  },
  {
    section: "I",
    hscode: "0205",
    description:
      "Meat; of horses, asses, mules or hinnies, fresh, chilled or frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020500",
    description:
      "Meat; of horses, asses, mules or hinnies, fresh, chilled or frozen",
    parent: "0205",
    level: "6",
  },
  {
    section: "I",
    hscode: "0206",
    description:
      "Edible offal of bovine animals, swine, sheep, goats, horses, asses, mules or hinnies; fresh, chilled or frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020610",
    description: "Offal, edible; of bovine animals, fresh or chilled",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020621",
    description: "Offal, edible; of bovine animals, tongues, frozen",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020622",
    description: "Offal, edible; of bovine animals, livers, frozen",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020629",
    description:
      "Offal, edible; of bovine animals, (other than tongues and livers), frozen",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020630",
    description: "Offal, edible; of swine, fresh or chilled",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020641",
    description: "Offal, edible; of swine, livers, frozen",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020649",
    description: "Offal, edible; of swine, (other than livers), frozen",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020680",
    description:
      "Offal, edible; of sheep, goats, horses, asses, mules or hinnies, fresh or chilled",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "020690",
    description:
      "Offal, edible; of sheep, goats, horses, asses, mules or hinnies, frozen",
    parent: "0206",
    level: "6",
  },
  {
    section: "I",
    hscode: "0207",
    description:
      "Meat and edible offal of poultry; of the poultry of heading no. 0105, (i.e. fowls of the species Gallus domesticus), fresh, chilled or frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020711",
    description:
      "Meat and edible offal; of fowls of the species Gallus domesticus, not cut in pieces, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020712",
    description:
      "Meat and edible offal; of fowls of the species Gallus domesticus, not cut in pieces, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020713",
    description:
      "Meat and edible offal; of fowls of the species Gallus domesticus, cuts and offal, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020714",
    description:
      "Meat and edible offal; of fowls of the species Gallus domesticus, cuts and offal, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020724",
    description:
      "Meat and edible offal; of turkeys, not cut in pieces, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020725",
    description: "Meat and edible offal; of turkeys, not cut in pieces, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020726",
    description:
      "Meat and edible offal; of turkeys, cuts and offal, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020727",
    description: "Meat and edible offal; of turkeys, cuts and offal, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020741",
    description:
      "Meat and edible offal; of ducks, not cut in pieces, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020742",
    description: "Meat and edible offal; of ducks, not cut in pieces, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020743",
    description:
      "Meat and edible offal; of ducks, fatty livers (foie gras), fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020744",
    description:
      "Meat and edible offal; of ducks, cuts and offal, excluding fatty livers, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020745",
    description:
      "Meat and edible offal; of ducks, cuts and offal, excluding fatty livers, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020751",
    description:
      "Meat and edible offal; of geese, not cut in pieces, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020752",
    description: "Meat and edible offal; of geese, not cut in pieces, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020753",
    description:
      "Meat and edible offal; of geese, fatty livers (foie gras), fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020754",
    description:
      "Meat and edible offal; of geese, cuts and offal, excluding fatty livers, fresh or chilled",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020755",
    description:
      "Meat and edible offal; of geese, cuts and offal, excluding fatty livers, frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "020760",
    description:
      "Meat and edible offal; of guinea fowls, fresh, chilled or frozen",
    parent: "0207",
    level: "6",
  },
  {
    section: "I",
    hscode: "0208",
    description:
      "Meat and edible meat offal, n.e.c. in chapter 2; fresh, chilled or frozen",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020810",
    description:
      "Meat and edible meat offal; of rabbits or hares, fresh, chilled or frozen",
    parent: "0208",
    level: "6",
  },
  {
    section: "I",
    hscode: "020830",
    description:
      "Meat and edible meat offal; of primates, fresh, chilled or frozen",
    parent: "0208",
    level: "6",
  },
  {
    section: "I",
    hscode: "020840",
    description:
      "Meat and edible meat offal; of whales, dolphins and porpoises (mammals of the order Cetacea); of manatees and dugongs (mammals of the order Sirenia); of seals, sea lions and walruses (mammals of the suborder Pinnipedia), fresh, chilled or frozen",
    parent: "0208",
    level: "6",
  },
  {
    section: "I",
    hscode: "020850",
    description:
      "Meat and edible meat offal; of reptiles (including snakes and turtles), fresh, chilled or frozen",
    parent: "0208",
    level: "6",
  },
  {
    section: "I",
    hscode: "020860",
    description:
      "Meat and edible meat offal; of camels and other camelids (Camelidae), fresh, chilled or frozen",
    parent: "0208",
    level: "6",
  },
  {
    section: "I",
    hscode: "020890",
    description:
      "Meat and edible meat offal; n.e.c. in chapter 2, fresh, chilled or frozen",
    parent: "0208",
    level: "6",
  },
  {
    section: "I",
    hscode: "0209",
    description:
      "Pig fat, free of lean meat, and poultry fat, not rendered or otherwise extracted, fresh, chilled, frozen, salted, in brine, dried or smoked",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "020910",
    description:
      "Fat; pig fat, free of lean meat, not rendered or otherwise extracted, fresh, chilled, frozen, salted, in brine, dried or smoked",
    parent: "0209",
    level: "6",
  },
  {
    section: "I",
    hscode: "020990",
    description:
      "Fat; poultry fat, not rendered or otherwise extracted, fresh, chilled, frozen, salted, in brine, dried or smoked",
    parent: "0209",
    level: "6",
  },
  {
    section: "I",
    hscode: "0210",
    description:
      "Meat and edible meat offal; salted, in brine, dried or smoked; edible flours and meals of meat or meat offal",
    parent: "02",
    level: "4",
  },
  {
    section: "I",
    hscode: "021011",
    description:
      "Meat; salted, in brine, dried or smoked, of swine, hams, shoulders and cuts thereof, with bone in",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021012",
    description:
      "Meat; salted, in brine, dried or smoked, of swine, bellies (streaky) and cuts thereof",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021019",
    description:
      "Meat; salted in brine, dried or smoked, of swine, n.e.c. in item no. 0210.1",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021020",
    description: "Meat; salted, in brine, dried or smoked, of bovine animals",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021091",
    description:
      "Meat and edible meat offal; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, of primates",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021092",
    description:
      "Meat and edible meat offal; salted, in brine, dried or smoked; edible flours, meals of meat or meat offal, of whales, dolphins, porpoises (of order Cetacea); manatees, dugongs (of order Sirenia); seals, sea lions, and walruses (of suborder Pinnipedia)",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021093",
    description:
      "Meat and edible meat offal; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, of reptiles (including snakes and turtles)",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "021099",
    description:
      "Meat and edible meat offal; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, other than of primates, whales, dolphins, porpoises, manatees, dugongs, seals, sea lions, walruses, reptiles (including snakes and turtles)",
    parent: "0210",
    level: "6",
  },
  {
    section: "I",
    hscode: "03",
    description:
      "Fish and crustaceans, molluscs and other aquatic invertebrates",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "I",
    hscode: "0301",
    description: "Fish; live",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030111",
    description: "Fish; live, ornamental, freshwater",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030119",
    description: "Fish; live, ornamental, other than freshwater",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030191",
    description:
      "Fish; live, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster)",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030192",
    description: "Fish; live, eels (Anguilla spp.)",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030193",
    description:
      "Fish; live, carp (Cyprinus spp., Carassius spp., Ctenopharyngodon idellus, Hypophthalmichthys spp., Cirrhinus spp., Mylopharyngodon piceus, Catla catla, Labeo spp., Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama spp.)",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030194",
    description:
      "Fish; live, Atlantic and Pacific bluefin tunas (Thunnus thynnus, Thunnus orientalis)",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030195",
    description: "Fish; live, southern bluefin tunas (Thunnus maccoyii)",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "030199",
    description: "Fish; live, n.e.c. in heading 0301",
    parent: "0301",
    level: "6",
  },
  {
    section: "I",
    hscode: "0302",
    description:
      "Fish; fresh or chilled, excluding fish fillets and other fish meat of heading 0304",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030211",
    description:
      "Fish; fresh or chilled, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster), excluding fillets, fish meat of 0304, and edible fish offal of 0302.9",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030213",
    description:
      "Fish; fresh or chilled, Pacific salmon (Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou, Oncorhynchus rhodurus), not fillets, meat of 0304, and edible fish offal of 0302.9",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030214",
    description:
      "Fish; fresh or chilled, Atlantic salmon (Salmo salar) and Danube salmon (Hucho hucho), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030219",
    description:
      "Fish; fresh or chilled, salmonidae, n.e.c. in item no. 0302.1, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030221",
    description:
      "Fish; fresh or chilled, halibut (Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030222",
    description:
      "Fish; fresh or chilled, plaice (Pleuronectes platessa), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030223",
    description:
      "Fish; fresh or chilled, sole (Solea spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030224",
    description:
      "Fish; fresh or chilled, turbots (Psetta maxima, Scophthalmidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030229",
    description:
      "Fish; fresh or chilled, flat fish, n.e.c. in item no. 0302.2, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030231",
    description:
      "Fish; fresh or chilled, albacore or longfinned tunas (Thunnus alalunga), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030232",
    description:
      "Fish; fresh or chilled, yellowfin tunas (Thunnus albacares), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030233",
    description:
      "Fish; fresh or chilled, skipjack tuna (stripe-bellied bonito) (Katsuwonus pelamis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030234",
    description:
      "Fish; fresh or chilled, bigeye tunas (Thunnus obesus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030235",
    description:
      "Fish; fresh or chilled, Atlantic and Pacific bluefin tunas (Thunnus thynnus, Thunnus orientalis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030236",
    description:
      "Fish; fresh or chilled, southern bluefin tunas (Thunnus maccoyii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030239",
    description:
      "Fish; fresh or chilled, tuna, n.e.c. in item no. 0302.3, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030241",
    description:
      "Fish; fresh or chilled, herrings (Clupea harengus, Clupea pallasii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030242",
    description:
      "Fish; fresh or chilled, anchovies (Engraulis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030243",
    description:
      "Fish; fresh or chilled, sardines (Sardina pilchardus, Sardinops spp.), sardinella (Sardinella spp.), brisling or sprats (Sprattus sprattus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030244",
    description:
      "Fish; fresh or chilled, mackerel (Scomber scombrus, Scomber australasicus, Scomber japonicus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030245",
    description:
      "Fish; fresh or chilled, jack and horse mackerel (Trachurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030246",
    description:
      "Fish; fresh or chilled, cobia (Rachycentron canadum), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030247",
    description:
      "Fish; fresh or chilled, swordfish (Xiphias gladius), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030249",
    description:
      "Fish; fresh or chilled, n.e.c. in item no. 0302.4, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030251",
    description:
      "Fish; fresh or chilled, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030252",
    description:
      "Fish; fresh or chilled, haddock (Melanogrammus aeglefinus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030253",
    description:
      "Fish; fresh or chilled, coalfish (Pollachius virens), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030254",
    description:
      "Fish; fresh or chilled, hake (Merluccius spp., Urophycis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030255",
    description:
      "Fish; fresh or chilled, Alaska pollock (Theragra chalcogramma), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030256",
    description:
      "Fish; fresh or chilled, blue whitings (Micromesistius poutassou, Micromesistius australis),excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030259",
    description:
      "Fish; fresh or chilled, n.e.c. in item no. 0302.5, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030271",
    description:
      "Fish; fresh or chilled, tilapias (Oreochromis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030272",
    description:
      "Fish; fresh or chilled, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030273",
    description:
      "Fish; fresh or chilled, Carp (as specified by the WCO.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030274",
    description:
      "Fish; fresh or chilled, eels (Anguilla spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030279",
    description:
      "Fish; fresh or chilled, Nile perch (Lates niloticus) and snakeheads (Channa spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030281",
    description:
      "Fish; fresh or chilled, dogfish and other sharks, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030282",
    description:
      "Fish; fresh or chilled, rays and skates (Rajidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030283",
    description:
      "Fish; fresh or chilled, toothfish (Dissostichus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030284",
    description:
      "Fish; fresh or chilled, seabass (Dicentrarchus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030285",
    description:
      "Fish; fresh or chilled, seabream (Sparidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030289",
    description:
      "Fish; fresh or chilled, n.e.c. in heading 0302, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030291",
    description: "Fish; fresh or chilled, livers, roes and milt",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030292",
    description: "Fish; fresh or chilled, shark fins",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "030299",
    description:
      "Fish; fresh or chilled, fish fins (other than shark fins), heads, tails, maws and other edible fish offal",
    parent: "0302",
    level: "6",
  },
  {
    section: "I",
    hscode: "0303",
    description:
      "Fish; frozen, excluding fish fillets and other fish meat of heading 0304",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030311",
    description:
      "Fish; frozen, Pacific salmon, sockeye salmon (red salmon) (Oncorhynchus nerka), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030312",
    description:
      "Fish; frozen, Pacific salmon (Oncorhynchus gorbuscha/keta/tschawytscha/ kisutch/masou/rhodurus) other than sockeye salmon (Oncorhynchus nerka), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030313",
    description:
      "Fish; frozen, Atlantic salmon (Salmo salar) and Danube salmon (Hucho hucho), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030314",
    description:
      "Fish; frozen, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster), excluding fillets, meat of 0304, and edible fish offal of 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030319",
    description:
      "Fish; frozen, salmonidae, n.e.c. in item no. 0303.1, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030323",
    description:
      "Fish; frozen, tilapias (Oreochromis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030324",
    description:
      "Fish; frozen, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030325",
    description:
      "Fish; frozen, carp (as specified by the WCO), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030326",
    description:
      "Fish; frozen, eels (Anguilla spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030329",
    description:
      "Fish; frozen, Nile perch (Lates niloticus) and snakeheads (Channa spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030331",
    description:
      "Fish; frozen, halibut (Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030332",
    description:
      "Fish; frozen, plaice (Pleuronectes platessa), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030333",
    description:
      "Fish; frozen, sole (Solea spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030334",
    description:
      "Fish; frozen, turbots (Psetta maxima, Scophthalmidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030339",
    description:
      "Fish; frozen, flat fish, n.e.c. in item no. 0303.3, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030341",
    description:
      "Fish; frozen, albacore or longfinned tunas (Thunnus alalunga), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030342",
    description:
      "Fish; frozen, yellowfin tunas (Thunnus albacares), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030343",
    description:
      "Fish; frozen, skipjack tuna (stripe-bellied bonito) (Katsuwonus pelamis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030344",
    description:
      "Fish; frozen, bigeye tunas (Thunnus obesus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030345",
    description:
      "Fish; frozen, Atlantic and Pacific bluefin tunas (Thunnus thynnus, Thunnus orientalis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030346",
    description:
      "Fish; frozen, southern bluefin tunas (Thunnus maccoyii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030349",
    description:
      "Fish; frozen, tuna, n.e.c. in item no. 0303.4, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030351",
    description:
      "Fish; frozen, herrings (Clupea harengus, Clupea pallasii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030353",
    description:
      "Fish; frozen, sardines (Sardina pilchardus, Sardinops spp.), sardinella (Sardinella spp.), brisling or sprats (Sprattus sprattus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030354",
    description:
      "Fish; frozen, mackerel (Scomber scombrus, Scomber australasicus, Scomber japonicus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030355",
    description:
      "Fish; frozen, jack and horse mackerel (Trachurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030356",
    description:
      "Fish; frozen, cobia (Rachycentron canadum), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030357",
    description:
      "Fish; frozen, swordfish (Xiphias gladius), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030359",
    description:
      "Fish; frozen, n.e.c. in item no. 0303.5, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030363",
    description:
      "Fish; frozen, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030364",
    description:
      "Fish; frozen, haddock (Melanogrammus aeglefinus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030365",
    description:
      "Fish; frozen, coalfish (Pollachius virens), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030366",
    description:
      "Fish; frozen, hake (Merluccius spp., Urophycis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030367",
    description:
      "Fish; frozen, Alaska pollock (Theragra chalcogramma), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030368",
    description:
      "Fish; frozen, blue whitings (Micromesistius poutassou, Micromesistius australis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030369",
    description:
      "Fish; frozen, of Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae, Muraenolepididae, other than cod, haddock, coalfish, hake, Alaska pollack, blue whitings, not fillets, meat of 0304, and edible offal of 0303.9",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030381",
    description:
      "Fish; frozen, dogfish and other sharks, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030382",
    description:
      "Fish; frozen, rays and skates (Rajidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030383",
    description:
      "Fish; frozen, toothfish (Dissostichus spp.), excluding fillets, livers, roes, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030384",
    description:
      "Fish; frozen, seabass (Dicentrarchus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030389",
    description:
      "Fish; frozen, n.e.c. in heading 0303, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030391",
    description: "Fish; frozen, livers, roes and milt",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030392",
    description: "Fish; frozen, shark fins",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "030399",
    description:
      "Fish; frozen, fish fins (other than shark fins), heads, tails, maws and other edible fish offal",
    parent: "0303",
    level: "6",
  },
  {
    section: "I",
    hscode: "0304",
    description:
      "Fish fillets and other fish meat (whether or not minced); fresh, chilled or frozen",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030431",
    description: "Fish fillets; fresh or chilled, tilapias (Oreochromis spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030432",
    description:
      "Fish fillets; fresh or chilled, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030433",
    description: "Fish fillets; fresh or chilled, Nile perch (Lates niloticus)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030439",
    description:
      "Fish fillets; fresh or chilled, carp (as specified by the WCO), eels (Anguilla spp.), and snakeheads (Channa spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030441",
    description:
      "Fish fillets; fresh or chilled, salmon, Pacific (Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou and Oncorhynchus rhodurus), Atlantic (Salmo salar), Danube (Hucho hucho)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030442",
    description:
      "Fish fillets; fresh or chilled, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030443",
    description:
      "Fish fillets; fresh or chilled, flat fish (Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae and Citharidae)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030444",
    description:
      "Fish fillets; fresh or chilled, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae, and Muraenolepididae",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030445",
    description: "Fish fillets; fresh or chilled, swordfish (Xiphias gladius)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030446",
    description:
      "Fish fillets; fresh or chilled, toothfish (Dissostichus spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030447",
    description: "Fish fillets; fresh or chilled, dogfish and other sharks",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030448",
    description: "Fish fillets; fresh or chilled, rays and skates (Rajidae)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030449",
    description:
      "Fish fillets; fresh or chilled, other than fish of heading 0304.4",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030451",
    description:
      "Fish meat, excluding fillets, whether or not minced; fresh or chilled, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030452",
    description:
      "Fish meat, excluding fillets, whether or not minced; fresh or chilled, salmonidae",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030453",
    description:
      "Fish meat, excluding fillets, whether or not minced; fresh or chilled, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae, and Muraenolepididae",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030454",
    description:
      "Fish meat, excluding fillets, whether or not minced; fresh or chilled, swordfish (Xiphias gladius)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030455",
    description:
      "Fish meat, excluding fillets, whether or not minced; fresh or chilled, toothfish (Dissostichus spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030456",
    description:
      "Fish meat; excluding fillets, whether or not minced; fresh or chilled, dogfish and other sharks",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030457",
    description:
      "Fish meat; excluding fillets, whether or not minced; fresh or chilled, rays and skates (Rajidae)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030459",
    description:
      "Fish meat; excluding fillets, whether or not minced; fresh or chilled, of fish n.e.c. in item no. 0304.5",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030461",
    description: "Fish fillets; frozen, tilapias (Oreochromis spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030462",
    description:
      "Fish fillets; frozen, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030463",
    description: "Fish fillets; frozen, Nile Perch (Lates niloticus)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030469",
    description:
      "Fish fillets; frozen, carp (Cyprinus/Carassius/Ctenopharyngodon idellus/Hypophthalmichthys/Cirrhinus/Mylopharyngodon piceus/Catla catla/Labeo/Osteochilus hasselti/Leptobarbus hoeveni/Megalobrama), eels (Anguilla) and snakeheads (Channa)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030471",
    description:
      "Fish fillets; frozen, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030472",
    description: "Fish fillets; frozen, haddock (Melanogrammus aeglefinus)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030473",
    description: "Fish fillets; frozen, coalfish (Pollachius virens)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030474",
    description: "Fish fillets; frozen, hake (Merluccius spp., Urophycis spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030475",
    description: "Fish fillets; frozen, Alaska pollock (Theragra chalcogramma)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030479",
    description:
      "Fish fillets; frozen, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae other than cod, haddock, coalfish, hake, and Alaska pollock",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030481",
    description:
      "Fish fillets; frozen, salmon, Pacific (Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou, Oncorhynchus rhodurus), Atlantic (Salmo salar), and Danube (Hucho hucho)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030482",
    description:
      "Fish fillets; frozen, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030483",
    description:
      "Fish fillets; frozen, flat fish (Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae and Citharidae)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030484",
    description: "Fish fillets; frozen, swordfish (Xiphias gladius)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030485",
    description: "Fish fillets; frozen, toothfish (Dissostichus spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030486",
    description:
      "Fish fillets; frozen, herrings (Clupea harengus, Clupea pallasii)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030487",
    description:
      "Fish fillets; frozen, tunas (of the genus Thunnus), skipjack tuna (stripe-bellied bonito) (Katsuwonus pelamis)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030488",
    description:
      "Fish fillets; frozen, dogfish, other sharks, rays and skates (Rajidae)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030489",
    description: "Fish fillets; frozen, of fish n.e.c. in heading 0304.8",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030491",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, swordfish (Xiphias gladius)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030492",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, toothfish (Dissostichus spp.)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030493",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030494",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, Alaska Pollock (Theragra chalcogramma)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030495",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae, other than Alaska Pollock (Theragra chalcogramma)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030496",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, dogfish and other sharks",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030497",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, rays and skates (Rajidae)",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "030499",
    description:
      "Fish meat, excluding fillets, whether or not minced; frozen, n.e.c. in item no. 0304.9",
    parent: "0304",
    level: "6",
  },
  {
    section: "I",
    hscode: "0305",
    description:
      "Fish, dried, salted or in brine; smoked fish, whether or not cooked before, or during the smoking process",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030520",
    description:
      "Fish; livers, roes and milt of fish, dried, smoked, salted or in brine",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030531",
    description:
      "Fish fillets; dried, salted or in brine, but not smoked, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030532",
    description:
      "Fish fillets; dried, salted or in brine, but not smoked, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030539",
    description:
      "Fish fillets; dried, salted or in brine, but not smoked, n.e.c. in item no. 0305.3",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030541",
    description:
      "Fish; smoked, whether or not cooked before or during smoking, salmon, Pacific (Oncorhynchus nerka, gorbuscha, keta, tschawytscha, kisutch, masou, rhodurus), Atlantic (Salmo salar) and Danube (Hucho hucho), includes fillets, but excludes edible fish offal",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030542",
    description:
      "Fish; smoked, whether or not cooked before or during smoking, herrings (Clupea harengus, Clupea pallasii), includes fillets, but excludes edible fish offal",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030543",
    description:
      "Fish; smoked, whether or not cooked before or during smoking, trout (Salmo trutta, Oncorhynchus mykiss/clarki/aguabonita/gilae/apache/chrysogaster), includes fillets, but excludes edible fish offal",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030544",
    description:
      "Fish; smoked, whether or not cooked before or during smoking, tilapias, catfish, carp, eels, Nile perch, and snakeheads, includes fillets, but excludes edible fish offal",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030549",
    description:
      "Fish; smoked, whether or not cooked before or during smoking, n.e.c. in item no. 0305.4, includes fillets, but excludes edible fish offal",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030551",
    description:
      "Fish; dried, whether or not salted but not smoked, other than edible fish offal, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus)",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030552",
    description:
      "Fish; dried, whether or not salted but not smoked, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030553",
    description:
      "Fish; dried, whether or not salted but not smoked, fish of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae, other than cod",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030554",
    description:
      "Dried herrings, anchovies, sardines, sardinella, brisling or sprats, mackerel (incl Indian, jack, or horse), seerfishes, jacks, crevalles, cobia, silver pomfrets, Pacific saury, scads, capelin, swordfish, Kawakawa, bonitos, marlins, sailfishes, spearfish",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030559",
    description:
      "Fish; dried, whether or not salted but not smoked, other than edible fish offal, n.e.c. in item no. 0305.5",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030561",
    description:
      "Fish; salted or in brine, not dried or smoked, other than edible fish offal, herrings (Clupea harengas, Clupea pallasii)",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030562",
    description:
      "Fish; salted or in brine, not dried or smoked, other than edible fish offal, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus)",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030563",
    description:
      "Fish; salted or in brine, not dried or smoked, other than edible fish offal, anchovies (Engrails spp.)",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030564",
    description:
      "Fish; salted or in brine, not dried or smoked, other than edible fish offal, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030569",
    description:
      "Fish; salted or in brine, not dried or smoked, other than edible fish offal, n.e.c. in item no. 0305.6",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030571",
    description: "Fish; edible offal, shark fins",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030572",
    description: "Fish; edible offal, fish heads, tails and maws",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "030579",
    description:
      "Fish; edible offal, other than shark fins, fish heads, tails and maws",
    parent: "0305",
    level: "6",
  },
  {
    section: "I",
    hscode: "0306",
    description:
      "Crustaceans; in shell or not, live, fresh, chilled, frozen, dried, salted or in brine; smoked, cooked or not before or during smoking; in shell, steamed or boiled, whether or not chilled, frozen, dried, salted or in brine",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030611",
    description:
      "Crustaceans; frozen, rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030612",
    description:
      "Crustaceans; frozen, lobsters (Homarus spp.), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030614",
    description:
      "Crustaceans; frozen, crabs, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030615",
    description:
      "Crustaceans; frozen, Norway lobsters (Nephrops norvegicus), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030616",
    description:
      "Crustaceans; frozen, cold-water shrimps and prawns (Pandalus spp., Crangon crangon), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030617",
    description:
      "Crustaceans; frozen, shrimps and prawns, excluding cold-water varieties, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030619",
    description:
      "Crustaceans; frozen, n.e.c. in item no. 0306.1, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030631",
    description:
      "Crustaceans; live, fresh or chilled, rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030632",
    description:
      "Crustaceans; live, fresh or chilled, lobsters (Homarus spp.), whether in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030633",
    description:
      "Crustaceans; live, fresh or chilled, crabs, whether in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030634",
    description:
      "Crustaceans; live, fresh or chilled, Norway lobsters (Nephrops norvegicus), in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030635",
    description:
      "Crustaceans; live, fresh or chilled, cold-water shrimps and prawns (Pandalus spp., Crangon crangon), in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030636",
    description:
      "Crustaceans; live, fresh or chilled, shrimps and prawns excluding cold-water varieties, in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030639",
    description:
      "Crustaceans; live, fresh or chilled, n.e.c. in item no. 0306.3, in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030691",
    description:
      "Crustaceans; rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030692",
    description:
      "Crustaceans; lobsters (Homarus spp.), smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030693",
    description:
      "Crustaceans; crabs, smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030694",
    description:
      "Crustaceans; Norway lobsters (Nephrops norvegicus), smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030695",
    description:
      "Crustaceans; shrimps and prawns, smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "030699",
    description:
      "Crustaceans; smoked, whole, cooked or not, n.e.c. in item no. 0306.9, in shell or not",
    parent: "0306",
    level: "6",
  },
  {
    section: "I",
    hscode: "0307",
    description:
      "Molluscs; whether in shell or not, live, fresh, chilled, frozen, dried, salted or in brine; smoked molluscs, whether in shell or not, whether or not cooked before or during the smoking process",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030711",
    description:
      "Molluscs; oysters, whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030712",
    description: "Molluscs; oysters, whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030719",
    description:
      "Molluscs; oysters, whether in shell or not, dried, salted or in brine, smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030721",
    description:
      "Molluscs; scallops and other molluscs of the family Pectinidae, whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030722",
    description:
      "Molluscs; scallops and other molluscs of the family Pectinidae, whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030729",
    description:
      "Molluscs; scallops and other molluscs of the family Pectinidae, whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030731",
    description:
      "Molluscs; mussels (Mytilus spp., Perna spp.), whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030732",
    description:
      "Molluscs; mussels (Mytilus spp., Perna spp.), whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030739",
    description:
      "Molluscs; mussels (Mytilus spp., Perna spp.), whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030742",
    description:
      "Molluscs; cuttle fish and squid, whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030743",
    description:
      "Molluscs; cuttle fish and squid, whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030749",
    description:
      "Molluscs; cuttle fish and squid, whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030751",
    description: "Molluscs; octopus (Octopus spp.), live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030752",
    description: "Molluscs; octopus (Octopus spp.), frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030759",
    description:
      "Molluscs; octopus (Octopus spp.), dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030760",
    description:
      "Molluscs; snails, other than sea snails, whether in shell or not, live, fresh, chilled, frozen, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030771",
    description:
      "Molluscs; clams, cockles and ark shells (families Arcidae, Arcticidae, Cardiidae, Donacidae, Hiatellidae, Mactridae, Mesodesmatidae, Myidae, Semelidae, Solecurtidae, Solenidae, Tridacnidae and Veneridae), whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030772",
    description:
      "Molluscs; clams, cockles, ark shells (Arcidae, Arcticidae, Cardiidae, Donacidae, Hiatellidae, Mactridae, Mesodesmatidae, Myidae, Semelidae, Solecurtidae, Solenidae, Tridacnidae and Veneridae), whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030779",
    description:
      "Molluscs; clams, cockle, ark shells (families Arcidae, Arcticidae, Cardiidae, Donacidae, Hiatellidae, Mactridae, Mesodesmatidae, Myidae, Semelidae, Solecurtidae, Solenidae, Tridacnidae, Veneridae), whether in shell or not, dried, salted, in brine, smoked",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030781",
    description:
      "Molluscs; abalone (Haliotis spp.), whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030782",
    description:
      "Molluscs; stromboid conchs (Strombus spp.), whether in shell or not, live, fresh or chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030783",
    description:
      "Molluscs; abalone (Haliotis spp.), whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030784",
    description:
      "Molluscs; stromboid conchs (Strombus spp.), whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030787",
    description:
      "Molluscs; abalone (Haliotis spp.), whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030788",
    description:
      "Molluscs; stromboid conchs (Strombus spp.), whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030791",
    description:
      "Molluscs; n.e.c. in heading 0307, whether in shell or not, live or fresh, chilled",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030792",
    description:
      "Molluscs; n.e.c. in heading 0307, whether in shell or not, frozen",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "030799",
    description:
      "Molluscs; n.e.c. in heading 0307, whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
    parent: "0307",
    level: "6",
  },
  {
    section: "I",
    hscode: "0308",
    description:
      "Aquatic invertebrates other than crustaceans and molluscs, live, fresh, chilled, frozen, dried, salted or in brine; smoked aquatic invertebrates other than crustaceans and molluscs, whether or not cooked before or during the smoking process",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030811",
    description:
      "Aquatic invertebrates; sea cucumbers (Stichopus japonicus, Holothuroidea), live, fresh or chilled",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030812",
    description:
      "Aquatic invertebrates; sea cucumbers (Stichopus japonicus, Holothuroidea), frozen",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030819",
    description:
      "Aquatic invertebrates; sea cucumbers (Stichopus japonicus, Holothuroidea), dried, salted or in brine, smoked, whether or not cooked before or during the smoking process",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030821",
    description:
      "Aquatic invertebrates; sea urchins (Strongylocentrotus spp., Paracentrotus lividus, Loxechinus albus, Echinus esculentus), live, fresh or chilled",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030822",
    description:
      "Aquatic invertebrates; sea urchins (Strongylocentrotus spp., Paracentrotus lividus, Loxechinus albus, Echinus esculentus), frozen",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030829",
    description:
      "Aquatic invertebrates; sea urchins (Strongylocentrotus spp., Paracentrotus lividus, Loxechinus albus, Echinus esculentus), dried, salted or in brine, smoked, whether or not cooked before or during smoking process",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030830",
    description:
      "Aquatic invertebrates; jellyfish (Rhopilema spp.), live, fresh, chilled, frozen, dried, salted or in brine, smoked, whether or not cooked before or during smoking",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "030890",
    description:
      "Aquatic invertebrates; other than crustaceans, molluscs, sea urchins, sea cucumbers and jellyfish, live, fresh, chilled, frozen, dried, salted or in brine, smoked, cooked or not before or during smoking",
    parent: "0308",
    level: "6",
  },
  {
    section: "I",
    hscode: "0309",
    description:
      "Flours, meals and pellets of fish, crustaceans, molluscs and other aquatic invertebrates, fit for human consumption",
    parent: "03",
    level: "4",
  },
  {
    section: "I",
    hscode: "030910",
    description: "Flours, meals and pellets of fish, fit for human consumption",
    parent: "0309",
    level: "6",
  },
  {
    section: "I",
    hscode: "030990",
    description:
      "Flours, meals and pellets of crustaceans, molluscs and other aquatic invertebrates, fit for human consumption",
    parent: "0309",
    level: "6",
  },
  {
    section: "I",
    hscode: "04",
    description:
      "Dairy produce; birds' eggs; natural honey; edible products of animal origin, not elsewhere specified or included",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "I",
    hscode: "0401",
    description:
      "Milk and cream; not concentrated, not containing added sugar or other sweetening matter",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040110",
    description:
      "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, not exceeding 1%",
    parent: "0401",
    level: "6",
  },
  {
    section: "I",
    hscode: "040120",
    description:
      "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, exceeding 1% but not exceeding 6%",
    parent: "0401",
    level: "6",
  },
  {
    section: "I",
    hscode: "040140",
    description:
      "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, exceeding 6% but not exceeding 10%",
    parent: "0401",
    level: "6",
  },
  {
    section: "I",
    hscode: "040150",
    description:
      "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, exceeding 10%",
    parent: "0401",
    level: "6",
  },
  {
    section: "I",
    hscode: "0402",
    description:
      "Milk and cream; concentrated or containing added sugar or other sweetening matter",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040210",
    description:
      "Dairy produce; milk and cream, concentrated or containing added sugar or other sweetening matter, in powder, granules or other solid forms, of a fat content not exceeding 1.5% (by weight)",
    parent: "0402",
    level: "6",
  },
  {
    section: "I",
    hscode: "040221",
    description:
      "Dairy produce; milk and cream, concentrated, not containing added sugar or other sweetening matter, in powder, granules or other solid forms, of a fat content exceeding 1.5% (by weight)",
    parent: "0402",
    level: "6",
  },
  {
    section: "I",
    hscode: "040229",
    description:
      "Dairy produce; milk and cream, containing added sugar or other sweetening matter, in powder, granules or other solid forms, of a fat content exceeding 1.5% (by weight)",
    parent: "0402",
    level: "6",
  },
  {
    section: "I",
    hscode: "040291",
    description:
      "Dairy produce; milk and cream, concentrated, not containing added sugar or other sweetening matter, other than in powder, granules or other solid forms",
    parent: "0402",
    level: "6",
  },
  {
    section: "I",
    hscode: "040299",
    description:
      "Dairy produce; milk and cream, containing added sugar or other sweetening matter, other than in powder, granules or other solid forms",
    parent: "0402",
    level: "6",
  },
  {
    section: "I",
    hscode: "0403",
    description:
      "Yogurt; buttermilk, curdled milk and cream, kephir and other fermented or acidified milk and cream, whether or not concentrated or containing added sugar or other sweetening matter or flavoured or containing added fruit, nuts or cocoa.",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040320",
    description:
      "Dairy produce; yoghurt, whether or not concentrated or containing added sugar or other sweetening matter or flavoured or containing added fruit, nuts or cocoa",
    parent: "0403",
    level: "6",
  },
  {
    section: "I",
    hscode: "040390",
    description:
      "Dairy produce; buttermilk, curdled milk or cream, kephir, fermented or acidified milk or cream, whether or not concentrated or containing added sweetening, flavouring, fruit, nuts or cocoa (excluding yoghurt)",
    parent: "0403",
    level: "6",
  },
  {
    section: "I",
    hscode: "0404",
    description:
      "Whey and products consisting of natural milk constituents; whether or not containing added sugar or other sweetening matter, not elsewhere specified or included",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040410",
    description:
      "Dairy produce; whey, whether or not concentrated or containing added sugar or other sweetening matter",
    parent: "0404",
    level: "6",
  },
  {
    section: "I",
    hscode: "040490",
    description:
      "Dairy produce; natural milk constituents (excluding whey), whether or not containing added sugar or other sweetening matter, n.e.c. in chapter 04",
    parent: "0404",
    level: "6",
  },
  {
    section: "I",
    hscode: "0405",
    description:
      "Butter and other fats and oils derived from milk; dairy spreads",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040510",
    description: "Dairy produce; derived from milk, butter",
    parent: "0405",
    level: "6",
  },
  {
    section: "I",
    hscode: "040520",
    description: "Dairy produce; dairy spreads",
    parent: "0405",
    level: "6",
  },
  {
    section: "I",
    hscode: "040590",
    description:
      "Dairy produce; fats and oils derived from milk (other than butter or dairy spreads)",
    parent: "0405",
    level: "6",
  },
  {
    section: "I",
    hscode: "0406",
    description: "Cheese and curd",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040610",
    description:
      "Dairy produce; fresh cheese (including whey cheese), not fermented, and curd",
    parent: "0406",
    level: "6",
  },
  {
    section: "I",
    hscode: "040620",
    description: "Dairy produce; cheese of all kinds, grated or powdered",
    parent: "0406",
    level: "6",
  },
  {
    section: "I",
    hscode: "040630",
    description: "Dairy produce; cheese, processed (not grated or powdered)",
    parent: "0406",
    level: "6",
  },
  {
    section: "I",
    hscode: "040640",
    description:
      "Dairy produce; cheese, blue-veined and other cheese containing veins produced by Penicillium roqueforti (not grated, powdered or processed)",
    parent: "0406",
    level: "6",
  },
  {
    section: "I",
    hscode: "040690",
    description:
      "Dairy produce; cheese (not grated, powdered or processed), n.e.c. in heading no. 0406",
    parent: "0406",
    level: "6",
  },
  {
    section: "I",
    hscode: "0407",
    description: "Birds' eggs, in shell; fresh, preserved or cooked",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040711",
    description:
      "Birds' eggs, in shell; fresh, fertilised eggs for incubation, of fowls of the species Gallus domesticus (domestic hens)",
    parent: "0407",
    level: "6",
  },
  {
    section: "I",
    hscode: "040719",
    description:
      "Birds' eggs, in shell; fresh, fertilised eggs for incubation, other than fowls of the species Gallus domesticus (domestic hens)",
    parent: "0407",
    level: "6",
  },
  {
    section: "I",
    hscode: "040721",
    description:
      "Birds' eggs, in shell; fresh, not for incubation, of fowls of the species Gallus domesticus (domestic hens)",
    parent: "0407",
    level: "6",
  },
  {
    section: "I",
    hscode: "040729",
    description:
      "Birds' eggs, in shell; fresh, not for incubation, other than fowls of the species Gallus domesticus (domestic hens)",
    parent: "0407",
    level: "6",
  },
  {
    section: "I",
    hscode: "040790",
    description: "Birds' eggs, in shell; preserved or cooked",
    parent: "0407",
    level: "6",
  },
  {
    section: "I",
    hscode: "0408",
    description:
      "Birds' eggs, not in shell; egg yolks, fresh, dried, cooked by steaming or boiling in water, moulded, frozen or otherwise preserved, whether or not containing added sugar or other sweetening matter",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040811",
    description:
      "Eggs; birds' eggs, yolks, dried, whether or not containing added sugar or other sweetening matter",
    parent: "0408",
    level: "6",
  },
  {
    section: "I",
    hscode: "040819",
    description:
      "Eggs; birds' eggs, yolks, fresh, cooked by steaming or by boiling in water, moulded, frozen or otherwise preserved, whether or not containing added sugar or other sweetening matter",
    parent: "0408",
    level: "6",
  },
  {
    section: "I",
    hscode: "040891",
    description:
      "Eggs; birds' eggs (not in shell, excluding yolks only), dried, whether or not containing added sugar or other sweetening matter",
    parent: "0408",
    level: "6",
  },
  {
    section: "I",
    hscode: "040899",
    description:
      "Eggs; birds' eggs (not in shell, excluding yolks only), fresh, cooked by steaming or boiling in water, moulded, frozen, otherwise preserved, whether or not containing added sugar or other sweetening matter",
    parent: "0408",
    level: "6",
  },
  {
    section: "I",
    hscode: "0409",
    description: "Honey; natural",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "040900",
    description: "Honey; natural",
    parent: "0409",
    level: "6",
  },
  {
    section: "I",
    hscode: "0410",
    description:
      "Animal products; insects and other edible products of animal origin, not elsewhere specified or included",
    parent: "04",
    level: "4",
  },
  {
    section: "I",
    hscode: "041010",
    description: "Animal products; insects",
    parent: "0410",
    level: "6",
  },
  {
    section: "I",
    hscode: "041090",
    description:
      "Animal products; edible products of animal origin, not elsewhere specified or included, other than insects",
    parent: "0410",
    level: "6",
  },
  {
    section: "I",
    hscode: "05",
    description:
      "Animal originated products; not elsewhere specified or included",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "I",
    hscode: "0501",
    description:
      "Human hair; unworked, whether or not washed or scoured; waste of human hair",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050100",
    description:
      "Animal products; hair, human, unworked, whether or not washed or scoured, and waste of human hair",
    parent: "0501",
    level: "6",
  },
  {
    section: "I",
    hscode: "0502",
    description: "Pigs', hogs' or boars' bristles and hair; and waste thereof",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050210",
    description:
      "Animal products; hair and bristles, of pigs, hogs or boars, and waste thereof",
    parent: "0502",
    level: "6",
  },
  {
    section: "I",
    hscode: "050290",
    description:
      "Animal products; badger hair and other brush making hair and waste of such bristles or hair, n.e.c. in heading no. 0502 (excluding horsehair)",
    parent: "0502",
    level: "6",
  },
  {
    section: "I",
    hscode: "0504",
    description:
      "Guts, bladders and stomachs of animals (other than fish); whole and pieces thereof, fresh, chilled, frozen, salted, in brine, dried or smoked",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050400",
    description:
      "Animal products; guts, bladders and stomachs of animals (other than fish), whole and pieces thereof, fresh, chilled, frozen, salted, in brine, dried or smoked",
    parent: "0504",
    level: "6",
  },
  {
    section: "I",
    hscode: "0505",
    description:
      "Skins and other parts of birds with feathers, down; feathers, down and parts thereof; not further worked than cleaned, disinfected, treated for preservation; powder, waste and parts of feathers",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050510",
    description:
      "Animal products; feathers and down used for stuffing, not further worked than cleaned, disinfected or treated for preservation",
    parent: "0505",
    level: "6",
  },
  {
    section: "I",
    hscode: "050590",
    description:
      "Animal products; skins and other parts of birds, feathers and down (not for stuffing), powder and waste of such, not further worked than cleaned, disinfected or treated for preservation",
    parent: "0505",
    level: "6",
  },
  {
    section: "I",
    hscode: "0506",
    description:
      "Bones and horn-cores, unworked, defatted, simply prepared (but not cut to shape), treated with acid or degelatinised; powder and waste of these products",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050610",
    description: "Animal products; ossein and bones treated with acid",
    parent: "0506",
    level: "6",
  },
  {
    section: "I",
    hscode: "050690",
    description:
      "Animal products; bones and horn-cores and powder or waste of such, unworked, defatted, simply prepared (not cut to shape), or treated with acid or degelatinised, n.e.c. in heading no. 0506",
    parent: "0506",
    level: "6",
  },
  {
    section: "I",
    hscode: "0507",
    description:
      "Ivory, tortoise-shell, whalebone and whalebone hair, horns, antlers, hooves, nails, claws and beaks unworked or simply prepared, not cut to shape; waste and powder of these products",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050710",
    description:
      "Animal products; ivory, unworked or simply prepared but not cut to shape, ivory powder and waste",
    parent: "0507",
    level: "6",
  },
  {
    section: "I",
    hscode: "050790",
    description:
      "Animal products; tortoise-shell, whalebone and whalebone hair, horns, antlers, hooves, nails, claws and beaks, unworked or simply prepared but not cut to shape, waste and powder of these products",
    parent: "0507",
    level: "6",
  },
  {
    section: "I",
    hscode: "0508",
    description:
      "Coral and similar materials, unworked or simply prepared, shells of molluscs, crustaceans or echinoderms and cuttle-bone, not cut to shape powder and waste thereof",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "050800",
    description:
      "Animal products; coral and similar materials, shells of molluscs, crustaceans, echinoderms, cuttle-bone, unworked or simply prepared but not cut to shape, powder and waste thereof",
    parent: "0508",
    level: "6",
  },
  {
    section: "I",
    hscode: "0510",
    description:
      "Ambergris, castoreum, civet and musk; cantharides; bile, dried or not glands, other animal products used in preparation of pharmaceutical products, fresh chilled, frozen or otherwise provisionally preserved",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "051000",
    description:
      "Animal products; ambergris, castoreum, civet, musk, cantharides, bile (dried or not) glands and other animal products, for pharmaceutical purposes, fresh, chilled, frozen or otherwise provisionally preserved",
    parent: "0510",
    level: "6",
  },
  {
    section: "I",
    hscode: "0511",
    description:
      "Animal products not elsewhere specified or included; dead animals of chapter 1 or 3, unfit for human consumption",
    parent: "05",
    level: "4",
  },
  {
    section: "I",
    hscode: "051110",
    description: "Animal products; bovine semen",
    parent: "0511",
    level: "6",
  },
  {
    section: "I",
    hscode: "051191",
    description:
      "Animal products; of fish or crustaceans, molluscs or other aquatic invertebrates; dead animals of chapter 03, unfit for human consumption",
    parent: "0511",
    level: "6",
  },
  {
    section: "I",
    hscode: "051199",
    description: "Animal products; n.e.c. in chapter 5",
    parent: "0511",
    level: "6",
  },
  {
    section: "II",
    hscode: "06",
    description:
      "Trees and other plants, live; bulbs, roots and the like; cut flowers and ornamental foliage",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "0601",
    description:
      "Bulbs, tubers, tuberous roots, corms, crowns and rhizomes; dormant, in growth or in flower; chicory plants and roots other than roots of heading no. 1212",
    parent: "06",
    level: "4",
  },
  {
    section: "II",
    hscode: "060110",
    description:
      "Plants, live; bulbs, tubers, tuberous roots, corms, crowns and rhizomes, dormant",
    parent: "0601",
    level: "6",
  },
  {
    section: "II",
    hscode: "060120",
    description:
      "Plants, live; bulbs, tubers, tuberous roots, corms, crowns and rhizomes, in growth or in flower, chicory plants and roots other than of heading no. 1212",
    parent: "0601",
    level: "6",
  },
  {
    section: "II",
    hscode: "0602",
    description:
      "Plants, live; n.e.c. in heading no. 0601, (including their roots) cuttings and slips; mushroom spawn",
    parent: "06",
    level: "4",
  },
  {
    section: "II",
    hscode: "060210",
    description: "Plants, live; unrooted cuttings and slips",
    parent: "0602",
    level: "6",
  },
  {
    section: "II",
    hscode: "060220",
    description:
      "Plants, live; edible fruit or nut trees, shrubs and bushes, grafted or not",
    parent: "0602",
    level: "6",
  },
  {
    section: "II",
    hscode: "060230",
    description: "Plants, live; rhododendrons and azaleas, grafted or not",
    parent: "0602",
    level: "6",
  },
  {
    section: "II",
    hscode: "060240",
    description: "Plants, live; roses, grafted or not",
    parent: "0602",
    level: "6",
  },
  {
    section: "II",
    hscode: "060290",
    description: "Plants, live; n.e.c. in heading no. 0602",
    parent: "0602",
    level: "6",
  },
  {
    section: "II",
    hscode: "0603",
    description:
      "Flowers; cut flowers and flower buds of a kind suitable for bouquets or for ornamental purposes, fresh, dried, dyed, bleached, impregnated or otherwise prepared",
    parent: "06",
    level: "4",
  },
  {
    section: "II",
    hscode: "060311",
    description:
      "Flowers, cut; roses, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "060312",
    description:
      "Flowers, cut; carnations, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "060313",
    description:
      "Flowers, cut; orchids, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "060314",
    description:
      "Flowers, cut; chrysanthemums, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "060315",
    description:
      "Flowers, cut; lilies (Lilium spp.), flowers and flower buds of a kind suitable for bouquets or ornamental purposes, fresh",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "060319",
    description:
      "Flowers, cut; flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh, other than roses, carnations, orchids, chrysanthemums or lillies",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "060390",
    description:
      "Flowers, cut; flowers and flower buds of a kind suitable for bouquets or ornamental purposes, dried, dyed, bleached, impregnated or otherwise prepared",
    parent: "0603",
    level: "6",
  },
  {
    section: "II",
    hscode: "0604",
    description:
      "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses, mosses and lichens; suitable for bouquets or for ornamental purposes, fresh, dried, dyed, bleached, impregnated etc.",
    parent: "06",
    level: "4",
  },
  {
    section: "II",
    hscode: "060420",
    description:
      "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses, mosses and lichens; suitable for bouquets or for ornamental purposes, fresh",
    parent: "0604",
    level: "6",
  },
  {
    section: "II",
    hscode: "060490",
    description:
      "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses, mosses and lichens; suitable for bouquets or for ornamental purposes, dried, dyed, bleached, impregnated or otherwise prepared",
    parent: "0604",
    level: "6",
  },
  {
    section: "II",
    hscode: "07",
    description: "Vegetables and certain roots and tubers; edible",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "0701",
    description: "Potatoes; fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070110",
    description: "Vegetables; seed potatoes, fresh or chilled",
    parent: "0701",
    level: "6",
  },
  {
    section: "II",
    hscode: "070190",
    description: "Vegetables; potatoes (other than seed), fresh or chilled",
    parent: "0701",
    level: "6",
  },
  {
    section: "II",
    hscode: "0702",
    description: "Tomatoes; fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070200",
    description: "Vegetables; tomatoes, fresh or chilled",
    parent: "0702",
    level: "6",
  },
  {
    section: "II",
    hscode: "0703",
    description:
      "Onions, shallots, garlic, leeks and other alliaceous vegetables; fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070310",
    description:
      "Vegetables, alliaceous; onions and shallots, fresh or chilled",
    parent: "0703",
    level: "6",
  },
  {
    section: "II",
    hscode: "070320",
    description: "Vegetables, alliaceous; garlic, fresh or chilled",
    parent: "0703",
    level: "6",
  },
  {
    section: "II",
    hscode: "070390",
    description:
      "Vegetables, alliaceous; leeks and other kinds n.e.c. in heading no. 0703, fresh or chilled",
    parent: "0703",
    level: "6",
  },
  {
    section: "II",
    hscode: "0704",
    description:
      "Cabbages, cauliflowers, kohlrabi, kale and similar edible brassicas; fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070410",
    description:
      "Vegetables, brassica; cauliflowers and broccoli, fresh or chilled",
    parent: "0704",
    level: "6",
  },
  {
    section: "II",
    hscode: "070420",
    description: "Vegetables, brassica; brussel sprouts, fresh or chilled",
    parent: "0704",
    level: "6",
  },
  {
    section: "II",
    hscode: "070490",
    description:
      "Vegetables, brassica; edible, n.e.c. in heading no. 0704, fresh or chilled",
    parent: "0704",
    level: "6",
  },
  {
    section: "II",
    hscode: "0705",
    description:
      "Lettuce (lactuca sativa) and chicory (cichorium spp.) fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070511",
    description:
      "Vegetables; cabbage (head) lettuce (lactuca sativa), fresh or chilled",
    parent: "0705",
    level: "6",
  },
  {
    section: "II",
    hscode: "070519",
    description:
      "Vegetables; lettuce (lactuca sativa), (other than cabbage lettuce), fresh or chilled",
    parent: "0705",
    level: "6",
  },
  {
    section: "II",
    hscode: "070521",
    description:
      "Vegetables; witloff chicory (cichorium intybus var. foliosum), fresh or chilled",
    parent: "0705",
    level: "6",
  },
  {
    section: "II",
    hscode: "070529",
    description:
      "Vegetables; chicory (cichorium spp.), (other than witloof chicory), fresh or chilled",
    parent: "0705",
    level: "6",
  },
  {
    section: "II",
    hscode: "0706",
    description:
      "Carrots, turnips, salad beetroot, salsify, celeriac, radishes and similar edible roots; fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070610",
    description: "Vegetables, root; carrots and turnips, fresh or chilled",
    parent: "0706",
    level: "6",
  },
  {
    section: "II",
    hscode: "070690",
    description:
      "Vegetables, root; salad beetroot, salsify, celeric, radishes and similar edible roots, fresh or chilled",
    parent: "0706",
    level: "6",
  },
  {
    section: "II",
    hscode: "0707",
    description: "Cucumbers and gherkins; fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070700",
    description: "Vegetables; cucumbers and gherkins, fresh or chilled",
    parent: "0707",
    level: "6",
  },
  {
    section: "II",
    hscode: "0708",
    description:
      "Leguminous vegetables; shelled or unshelled, fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070810",
    description:
      "Vegetables, leguminous; peas (pisum sativum), shelled or unshelled, fresh or chilled",
    parent: "0708",
    level: "6",
  },
  {
    section: "II",
    hscode: "070820",
    description:
      "Vegetables, leguminous; beans (vigna spp., phaseolus spp.), shelled or unshelled, fresh or chilled",
    parent: "0708",
    level: "6",
  },
  {
    section: "II",
    hscode: "070890",
    description:
      "Vegetables, leguminous; (other than peas and beans), shelled or unshelled, fresh or chilled",
    parent: "0708",
    level: "6",
  },
  {
    section: "II",
    hscode: "0709",
    description: "Vegetables; n.e.c. in chapter 07, fresh or chilled",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "070920",
    description: "Vegetables; asparagus, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070930",
    description: "Vegetables; aubergines, (e.g. plants), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070940",
    description: "Vegetables; celery (other than celeriac), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070951",
    description:
      "Vegetables; mushrooms of the genus Agaricus, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070952",
    description: "Vegetables; mushrooms of the genus Boletus, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070953",
    description:
      "Vegetables; mushrooms of the genus Cantharellus, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070954",
    description:
      "Vegetables; shiitake mushrooms (Lentinus edodes), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070955",
    description:
      "Vegetables; matsutake mushrooms (Tricholoma matsutake, Tricholoma magnivelare, Tricholoma anatolicum, Tricholoma dulciolens, Tricholoma caligatum), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070956",
    description: "Vegetables; truffles (Tuber spp.), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070959",
    description:
      "Vegetables; truffles and mushrooms n.e.c. in heading 0709, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070960",
    description:
      "Vegetables; fruits of the genus capsicum or of the genus pimenta, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070970",
    description:
      "Vegetables; spinach, New Zealand spinach and orache spinach (garden spinach), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070991",
    description: "Vegetables; globe artichokes, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070992",
    description: "Vegetables; olives, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070993",
    description:
      "Vegetables; pumpkins, squash and gourds (Cucurbita spp.), fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "070999",
    description: "Vegetables; edible, n.e.c. in chapter 07, fresh or chilled",
    parent: "0709",
    level: "6",
  },
  {
    section: "II",
    hscode: "0710",
    description:
      "Vegetables (uncooked or cooked by steaming or boiling in water); frozen",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "071010",
    description:
      "Vegetables; potatoes, uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071021",
    description:
      "Vegetables, leguminous; peas (pisum sativum), shelled or unshelled, uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071022",
    description:
      "Vegetables, leguminous; beans (vigna spp., phaseolus spp.), shelled or unshelled, uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071029",
    description:
      "Vegetables, leguminous; (other than peas or beans), shelled or unshelled, uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071030",
    description:
      "Vegetables; spinach, New Zealand spinach and orache spinach (garden spinach), uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071040",
    description:
      "Vegetables; sweetcorn, uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071080",
    description:
      "Vegetables; uncooked or cooked by steaming or boiling in water, n.e.c. in heading no. 0710, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "071090",
    description:
      "Vegetable mixtures; uncooked or cooked by steaming or boiling in water, frozen",
    parent: "0710",
    level: "6",
  },
  {
    section: "II",
    hscode: "0711",
    description:
      "Vegetables provisionally preserved, but unsuitable in that state for immediate consumption",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "071120",
    description:
      "Vegetables; olives, provisionally preserved but unsuitable in that state for immediate consumption",
    parent: "0711",
    level: "6",
  },
  {
    section: "II",
    hscode: "071140",
    description:
      "Vegetables; cucumbers and gherkins, provisionally preserved but unsuitable in that state for immediate consumption",
    parent: "0711",
    level: "6",
  },
  {
    section: "II",
    hscode: "071151",
    description:
      "Vegetables; mushrooms of the genus Agaricus, provisionally preserved but unsuitable in that state for immediate consumption",
    parent: "0711",
    level: "6",
  },
  {
    section: "II",
    hscode: "071159",
    description:
      "Vegetables; mushrooms other than of the genus Agaricus, provisionally preserved but unsuitable in that state for immediate consumption",
    parent: "0711",
    level: "6",
  },
  {
    section: "II",
    hscode: "071190",
    description:
      "Vegetables and mixed vegetables; n.e.c. in heading no. 0711, provisionally preserved but unsuitable in that state for immediate consumption",
    parent: "0711",
    level: "6",
  },
  {
    section: "II",
    hscode: "0712",
    description:
      "Vegetables, dried; whole, cut, sliced, broken or in powder, but not further prepared",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "071220",
    description:
      "Vegetables; onions, whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "071231",
    description:
      "Vegetables; mushrooms of the genus Agaricus, whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "071232",
    description:
      "Vegetables; wood ears (Auricularia spp), whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "071233",
    description:
      "Vegetables; jelly fungi (Tremella spp)), whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "071234",
    description:
      "Vegetables; shiitake mushrooms (Lentinus edodes), whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "071239",
    description:
      "Vegetables; mushrooms and truffles n.e.c. in item 0712.3, whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "071290",
    description:
      "Vegetables; mixtures of vegetables n.e.c. in heading no. 0712, whole, cut, sliced, broken or in powder but not further prepared, dried",
    parent: "0712",
    level: "6",
  },
  {
    section: "II",
    hscode: "0713",
    description:
      "Vegetables, leguminous; shelled, whether or not skinned or split, dried",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "071310",
    description:
      "Vegetables, leguminous; peas (pisum sativum), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071320",
    description:
      "Vegetables, leguminous; chickpeas (garbanzos), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071331",
    description:
      "Vegetables, leguminous; beans of the species vigna mungo (l.) hepper or vigna radiata (l.) wilczek, shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071332",
    description:
      "Vegetables, leguminous; small red (adzuki) beans (phaseolus or vigna angularis), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071333",
    description:
      "Vegetables, leguminous; kidney beans, including white pea beans (phaseolus vulgaris), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071334",
    description:
      "Vegetables, leguminous; bambara beans (Vigna subterranea or Voandzeia subterranea), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071335",
    description:
      "Vegetables, leguminous; cow peas (Vigna unguiculata), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071339",
    description:
      "Vegetables, leguminous; n.e.c. in item no. 0713.3, shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071340",
    description:
      "Vegetables, leguminous; lentils, shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071350",
    description:
      "Vegetables, leguminous; broad beans (vicia faba var. major) and horse beans (vicia faba var. equina, vicia faba var. minor), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071360",
    description:
      "Vegetables, leguminous; pigeon peas (Cajanus cajan), shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "071390",
    description:
      "Vegetables, leguminous; n.e.c. in heading no. 0713, shelled, whether or not skinned or split, dried",
    parent: "0713",
    level: "6",
  },
  {
    section: "II",
    hscode: "0714",
    description:
      "Manioc, arrowroot, salep, Jerusalem artichokes, sweet potatoes and similar roots and tubers with high starch or inulin content; fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets; sago pith",
    parent: "07",
    level: "4",
  },
  {
    section: "II",
    hscode: "071410",
    description:
      "Vegetable roots and tubers; manioc (cassava), with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
    parent: "0714",
    level: "6",
  },
  {
    section: "II",
    hscode: "071420",
    description:
      "Vegetable roots and tubers; sweet potatoes, with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
    parent: "0714",
    level: "6",
  },
  {
    section: "II",
    hscode: "071430",
    description:
      "Vegetable roots and tubers; yams (Dioscorea spp.) with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
    parent: "0714",
    level: "6",
  },
  {
    section: "II",
    hscode: "071440",
    description:
      "Vegetable roots and tubers; taro (Colocasia spp.) with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
    parent: "0714",
    level: "6",
  },
  {
    section: "II",
    hscode: "071450",
    description:
      "Vegetable roots and tubers; yautia (Xanthosoma spp.) with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
    parent: "0714",
    level: "6",
  },
  {
    section: "II",
    hscode: "071490",
    description:
      "Vegetable roots and tubers; arrowroot, salep, Jerusalem artichokes and similar roots and tubers (not manioc, sweet potatoes, yams, taro or yautia), high starch or inulin content, fresh, chilled, frozen, dried, sliced or not, or in pellet form; sago pith",
    parent: "0714",
    level: "6",
  },
  {
    section: "II",
    hscode: "08",
    description: "Fruit and nuts, edible; peel of citrus fruit or melons",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "0801",
    description:
      "Nuts, edible; coconuts, Brazil nuts and cashew nuts, fresh or dried, whether or not shelled or peeled",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080111",
    description: "Nuts, edible; coconuts, desiccated",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "080112",
    description: "Nuts, edible; coconuts, in the inner shell (endocarp)",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "080119",
    description:
      "Nuts, edible; coconuts, fresh or dried, other than desiccated or in the inner shell (endocarp)",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "080121",
    description: "Nuts, edible; brazil nuts, fresh or dried, in shell",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "080122",
    description: "Nuts, edible; brazil nuts, fresh or dried, shelled",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "080131",
    description: "Nuts, edible; cashew nuts, fresh or dried, in shell",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "080132",
    description: "Nuts, edible; cashew nuts, fresh or dried, shelled",
    parent: "0801",
    level: "6",
  },
  {
    section: "II",
    hscode: "0802",
    description:
      "Nuts (excluding coconuts, Brazils and cashew nuts); fresh or dried, whether or not shelled or peeled",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080211",
    description: "Nuts, edible; almonds, fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080212",
    description: "Nuts, edible; almonds, fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080221",
    description:
      "Nuts, edible; hazelnuts or filberts (corylus spp.), fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080222",
    description:
      "Nuts, edible; hazelnuts or filberts (corylus spp.), fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080231",
    description: "Nuts, edible; walnuts, fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080232",
    description: "Nuts, edible; walnuts, fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080241",
    description:
      "Nuts, edible; chestnuts (Castanea spp.), fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080242",
    description:
      "Nuts, edible; chestnuts (Castanea spp.), fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080251",
    description: "Nuts, edible; pistachios, fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080252",
    description: "Nuts, edible; pistachios, fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080261",
    description: "Nuts, edible; macadamia, fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080262",
    description: "Nuts, edible; macadamia, fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080270",
    description:
      "Nuts, edible; kola nuts (Cola spp.), fresh or dried, whether or not shelled or peeled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080280",
    description:
      "Nuts, edible; areca nuts, fresh or dried, whether or not shelled or peeled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080291",
    description: "Nuts, edible; pine nuts, fresh or dried, in shell",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080292",
    description: "Nuts, edible; pine nuts, fresh or dried, shelled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "080299",
    description:
      "Nuts, edible; n.e.c. in heading 0801 and 0802, fresh or dried, whether or not shelled or peeled",
    parent: "0802",
    level: "6",
  },
  {
    section: "II",
    hscode: "0803",
    description: "Bananas, including plantains; fresh or dried",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080310",
    description: "Fruit, edible; plantains, fresh or dried",
    parent: "0803",
    level: "6",
  },
  {
    section: "II",
    hscode: "080390",
    description: "Fruit, edible; bananas, other than plantains, fresh or dried",
    parent: "0803",
    level: "6",
  },
  {
    section: "II",
    hscode: "0804",
    description:
      "Dates, figs, pineapples, avocados, guavas, mangoes and mangosteens; fresh or dried",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080410",
    description: "Fruit, edible; dates, fresh or dried",
    parent: "0804",
    level: "6",
  },
  {
    section: "II",
    hscode: "080420",
    description: "Fruit, edible; figs, fresh or dried",
    parent: "0804",
    level: "6",
  },
  {
    section: "II",
    hscode: "080430",
    description: "Fruit, edible; pineapples, fresh or dried",
    parent: "0804",
    level: "6",
  },
  {
    section: "II",
    hscode: "080440",
    description: "Fruit, edible; avocados, fresh or dried",
    parent: "0804",
    level: "6",
  },
  {
    section: "II",
    hscode: "080450",
    description:
      "Fruit, edible; guavas, mangoes and mangosteens, fresh or dried",
    parent: "0804",
    level: "6",
  },
  {
    section: "II",
    hscode: "0805",
    description: "Citrus fruit; fresh or dried",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080510",
    description: "Fruit, edible; oranges, fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "080521",
    description:
      "Fruit, edible; mandarins (including tangerines and satsumas), fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "080522",
    description: "Fruit, edible; clementines, fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "080529",
    description:
      "Fruit, edible; tangelos, wilkings and similar citrus hybrid, fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "080540",
    description: "Fruit, edible; grapefruit and pomelos, fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "080550",
    description:
      "Fruit, edible; lemons (Citrus limon, Citrus limonum), limes (Citrus aurantifolia, Citrus latifolia), fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "080590",
    description:
      "Fruit, edible; citrus fruit n.e.c. in heading no. 0805, fresh or dried",
    parent: "0805",
    level: "6",
  },
  {
    section: "II",
    hscode: "0806",
    description: "Grapes; fresh or dried",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080610",
    description: "Fruit, edible; grapes, fresh",
    parent: "0806",
    level: "6",
  },
  {
    section: "II",
    hscode: "080620",
    description: "Fruit, edible; grapes, dried",
    parent: "0806",
    level: "6",
  },
  {
    section: "II",
    hscode: "0807",
    description: "Melons (including watermelons) and papaws (papayas); fresh",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080711",
    description: "Fruit, edible; watermelons, fresh",
    parent: "0807",
    level: "6",
  },
  {
    section: "II",
    hscode: "080719",
    description: "Fruit, edible; melons, other than watermelons, fresh",
    parent: "0807",
    level: "6",
  },
  {
    section: "II",
    hscode: "080720",
    description: "Fruit, edible; papaws (papayas), fresh",
    parent: "0807",
    level: "6",
  },
  {
    section: "II",
    hscode: "0808",
    description: "Apples, pears and quinces; fresh",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080810",
    description: "Fruit, edible; apples, fresh",
    parent: "0808",
    level: "6",
  },
  {
    section: "II",
    hscode: "080830",
    description: "Fruit, edible; pears, fresh",
    parent: "0808",
    level: "6",
  },
  {
    section: "II",
    hscode: "080840",
    description: "Fruit, edible; quinces, fresh",
    parent: "0808",
    level: "6",
  },
  {
    section: "II",
    hscode: "0809",
    description:
      "Apricots, cherries, peaches (including nectarines), plums and sloes, fresh",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "080910",
    description: "Fruit, edible; apricots, fresh",
    parent: "0809",
    level: "6",
  },
  {
    section: "II",
    hscode: "080921",
    description: "Fruit, edible; sour cherries (Prunus cerasus), fresh",
    parent: "0809",
    level: "6",
  },
  {
    section: "II",
    hscode: "080929",
    description:
      "Fruit, edible; cherries, other than sour cherries (Prunus cerasus), fresh",
    parent: "0809",
    level: "6",
  },
  {
    section: "II",
    hscode: "080930",
    description: "Fruit, edible; peaches, including nectarines, fresh",
    parent: "0809",
    level: "6",
  },
  {
    section: "II",
    hscode: "080940",
    description: "Fruit, edible; plums and sloes, fresh",
    parent: "0809",
    level: "6",
  },
  {
    section: "II",
    hscode: "0810",
    description: "Fruit, fresh; n.e.c. in chapter 08",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "081010",
    description: "Fruit, edible; strawberries, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081020",
    description:
      "Fruit, edible; raspberries, blackberries, mulberries, and loganberries, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081030",
    description:
      "Fruit, edible; black, white or red currants and gooseberries, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081040",
    description:
      "Fruit, edible; cranberries, bilberries and other fruits of the genus vaccinium, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081050",
    description: "Fruit, edible; kiwifruit, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081060",
    description: "Fruit, edible; durians, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081070",
    description: "Fruit, edible; persimmons, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "081090",
    description:
      "Fruit, edible; fruits n.e.c. in heading no. 0801 to 0810, fresh",
    parent: "0810",
    level: "6",
  },
  {
    section: "II",
    hscode: "0811",
    description:
      "Fruit and nuts; uncooked or cooked by steaming or boiling in water, frozen, whether or not containing added sugar or other sweetening matter",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "081110",
    description:
      "Fruit, edible; strawberries, uncooked or cooked by steaming or boiling in water, frozen, whether or not containing added sugar or other sweetening matter",
    parent: "0811",
    level: "6",
  },
  {
    section: "II",
    hscode: "081120",
    description:
      "Fruit, edible; raspberries, blackberries, mulberries, loganberries, black, white or red currants and gooseberries, uncooked or cooked, whether or not containing added sugar or other sweetening matter",
    parent: "0811",
    level: "6",
  },
  {
    section: "II",
    hscode: "081190",
    description:
      "Fruit, edible; fruit and nuts n.e.c. in heading no. 0811, uncooked or cooked, frozen whether or not containing added sugar or other sweetening matter",
    parent: "0811",
    level: "6",
  },
  {
    section: "II",
    hscode: "0812",
    description:
      "Fruit and nuts provisionally preserved, but unsuitable in that state for immediate consumption",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "081210",
    description:
      "Fruit, edible; cherries, provisionally preserved, but unsuitable in that state for immediate consumption",
    parent: "0812",
    level: "6",
  },
  {
    section: "II",
    hscode: "081290",
    description:
      "Fruit, edible; fruit and nuts n.e.c. in heading no. 0812, provisionally preserved, but unsuitable in that state for immediate consumption",
    parent: "0812",
    level: "6",
  },
  {
    section: "II",
    hscode: "0813",
    description:
      "Fruit, dried, other than that of heading no. 0801 to 0806; mixtures of nuts or dried fruits of this chapter",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "081310",
    description: "Fruit, edible; apricots, dried",
    parent: "0813",
    level: "6",
  },
  {
    section: "II",
    hscode: "081320",
    description: "Fruit, edible; prunes, dried",
    parent: "0813",
    level: "6",
  },
  {
    section: "II",
    hscode: "081330",
    description: "Fruit, edible; apples, dried",
    parent: "0813",
    level: "6",
  },
  {
    section: "II",
    hscode: "081340",
    description: "Fruit, edible; fruit n.e.c. in heading no. 0812, dried",
    parent: "0813",
    level: "6",
  },
  {
    section: "II",
    hscode: "081350",
    description: "Nuts, edible; mixtures of nuts or dried fruits of chapter 08",
    parent: "0813",
    level: "6",
  },
  {
    section: "II",
    hscode: "0814",
    description:
      "Peel of citrus fruit or melons (including watermelons); fresh, frozen dried or provisionally preserved in brine, in sulphur water or in other preservative solutions",
    parent: "08",
    level: "4",
  },
  {
    section: "II",
    hscode: "081400",
    description:
      "Peel; of citrus fruit or melons (including watermelons), fresh, frozen, dried or provisionally preserved in brine, in sulphur water and other preservative solutions",
    parent: "0814",
    level: "6",
  },
  {
    section: "II",
    hscode: "09",
    description: "Coffee, tea, mate and spices",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "0901",
    description:
      "Coffee, whether or not roasted or decaffeinated; husks and skins; coffee substitutes containing coffee in any proportion",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090111",
    description: "Coffee; not roasted or decaffeinated",
    parent: "0901",
    level: "6",
  },
  {
    section: "II",
    hscode: "090112",
    description: "Coffee; decaffeinated, not roasted",
    parent: "0901",
    level: "6",
  },
  {
    section: "II",
    hscode: "090121",
    description: "Coffee; roasted, not decaffeinated",
    parent: "0901",
    level: "6",
  },
  {
    section: "II",
    hscode: "090122",
    description: "Coffee; roasted, decaffeinated",
    parent: "0901",
    level: "6",
  },
  {
    section: "II",
    hscode: "090190",
    description:
      "Coffee; husks and skins, coffee substitutes containing coffee in any proportion",
    parent: "0901",
    level: "6",
  },
  {
    section: "II",
    hscode: "0902",
    description: "Tea",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090210",
    description:
      "Tea, green; (not fermented), in immediate packings of a content not exceeding 3kg",
    parent: "0902",
    level: "6",
  },
  {
    section: "II",
    hscode: "090220",
    description:
      "Tea, green; (not fermented), in immediate packings of a content exceeding 3kg",
    parent: "0902",
    level: "6",
  },
  {
    section: "II",
    hscode: "090230",
    description:
      "Tea, black; (fermented) and partly fermented tea, in immediate packings of a content not exceeding 3kg",
    parent: "0902",
    level: "6",
  },
  {
    section: "II",
    hscode: "090240",
    description:
      "Tea, black; (fermented) and partly fermented tea, in immediate packings of a content exceeding 3kg",
    parent: "0902",
    level: "6",
  },
  {
    section: "II",
    hscode: "0903",
    description: "Mate",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090300",
    description: "Mate",
    parent: "0903",
    level: "6",
  },
  {
    section: "II",
    hscode: "0904",
    description:
      "Pepper of the genus piper; dried or crushed or ground fruits of the genus capsicum or of the genus pimenta",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090411",
    description:
      "Spices; pepper (of the genus piper), neither crushed nor ground",
    parent: "0904",
    level: "6",
  },
  {
    section: "II",
    hscode: "090412",
    description: "Spices; pepper (of the genus piper), crushed or ground",
    parent: "0904",
    level: "6",
  },
  {
    section: "II",
    hscode: "090421",
    description:
      "Spices; fruits of the genus Capsicum or Pimenta, dried, neither crushed nor ground",
    parent: "0904",
    level: "6",
  },
  {
    section: "II",
    hscode: "090422",
    description:
      "Spices; fruits of the genus Capsicum or Pimenta, crushed or ground",
    parent: "0904",
    level: "6",
  },
  {
    section: "II",
    hscode: "0905",
    description: "Vanilla",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090510",
    description: "Spices; vanilla, neither crushed nor ground",
    parent: "0905",
    level: "6",
  },
  {
    section: "II",
    hscode: "090520",
    description: "Spices; vanilla, crushed or ground",
    parent: "0905",
    level: "6",
  },
  {
    section: "II",
    hscode: "0906",
    description: "Cinnamon and cinnamon-tree flowers",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090611",
    description:
      "Spices; cinnamon (Cinnamomum zeylanicum Blume), neither crushed nor ground",
    parent: "0906",
    level: "6",
  },
  {
    section: "II",
    hscode: "090619",
    description:
      "Spices; cinnamon and cinnamon-tree flowers, other than cinnamon (Cinnamomum zeylanicum Blume), neither crushed nor ground",
    parent: "0906",
    level: "6",
  },
  {
    section: "II",
    hscode: "090620",
    description:
      "Spices; cinnamon and cinnamon-tree flowers, crushed or ground",
    parent: "0906",
    level: "6",
  },
  {
    section: "II",
    hscode: "0907",
    description: "Cloves (whole fruit, cloves and stems)",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090710",
    description:
      "Spices; cloves (whole fruit, cloves and stems), neither crushed nor ground",
    parent: "0907",
    level: "6",
  },
  {
    section: "II",
    hscode: "090720",
    description:
      "Spices; cloves (whole fruit, cloves and stems), crushed or ground",
    parent: "0907",
    level: "6",
  },
  {
    section: "II",
    hscode: "0908",
    description: "Nutmeg, mace and cardamoms",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090811",
    description: "Spices; nutmeg, neither crushed nor ground",
    parent: "0908",
    level: "6",
  },
  {
    section: "II",
    hscode: "090812",
    description: "Spices; nutmeg, crushed or ground",
    parent: "0908",
    level: "6",
  },
  {
    section: "II",
    hscode: "090821",
    description: "Spices; mace, neither crushed nor ground",
    parent: "0908",
    level: "6",
  },
  {
    section: "II",
    hscode: "090822",
    description: "Spices; mace, crushed or ground",
    parent: "0908",
    level: "6",
  },
  {
    section: "II",
    hscode: "090831",
    description: "Spices; cardamoms, neither crushed nor ground",
    parent: "0908",
    level: "6",
  },
  {
    section: "II",
    hscode: "090832",
    description: "Spices; cardamoms, crushed or ground",
    parent: "0908",
    level: "6",
  },
  {
    section: "II",
    hscode: "0909",
    description:
      "Seeds of anise, badian, fennel, coriander, cumin, caraway or juniper",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "090921",
    description: "Spices; coriander seeds, neither crushed nor ground",
    parent: "0909",
    level: "6",
  },
  {
    section: "II",
    hscode: "090922",
    description: "Spices; coriander seeds, crushed or ground",
    parent: "0909",
    level: "6",
  },
  {
    section: "II",
    hscode: "090931",
    description: "Spices; cumin seeds, neither crushed nor ground",
    parent: "0909",
    level: "6",
  },
  {
    section: "II",
    hscode: "090932",
    description: "Spices; cumin seeds, crushed or ground",
    parent: "0909",
    level: "6",
  },
  {
    section: "II",
    hscode: "090961",
    description:
      "Spices; seeds of anise, badian, caraway or fennel; juniper berries, neither crushed nor ground",
    parent: "0909",
    level: "6",
  },
  {
    section: "II",
    hscode: "090962",
    description:
      "Spices; seeds of anise, badian, caraway or fennel; juniper berries, crushed or ground",
    parent: "0909",
    level: "6",
  },
  {
    section: "II",
    hscode: "0910",
    description:
      "Ginger, saffron, tumeric (curcuma), thyme, bay leaves, curry and other spices",
    parent: "09",
    level: "4",
  },
  {
    section: "II",
    hscode: "091011",
    description: "Spices; ginger, neither crushed nor ground",
    parent: "0910",
    level: "6",
  },
  {
    section: "II",
    hscode: "091012",
    description: "Spices; ginger, crushed or ground",
    parent: "0910",
    level: "6",
  },
  {
    section: "II",
    hscode: "091020",
    description: "Spices; saffron",
    parent: "0910",
    level: "6",
  },
  {
    section: "II",
    hscode: "091030",
    description: "Spices; turmeric (curcuma)",
    parent: "0910",
    level: "6",
  },
  {
    section: "II",
    hscode: "091091",
    description: "Spices; mixtures of 2 or more products of different headings",
    parent: "0910",
    level: "6",
  },
  {
    section: "II",
    hscode: "091099",
    description: "Spices; n.e.c. in heading no. 0910",
    parent: "0910",
    level: "6",
  },
  {
    section: "II",
    hscode: "10",
    description: "Cereals",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "1001",
    description: "Wheat and meslin",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100111",
    description: "Cereals; wheat and meslin, durum wheat, seed",
    parent: "1001",
    level: "6",
  },
  {
    section: "II",
    hscode: "100119",
    description: "Cereals; wheat and meslin, durum wheat, other than seed",
    parent: "1001",
    level: "6",
  },
  {
    section: "II",
    hscode: "100191",
    description: "Cereals; wheat and meslin, other than durum wheat, seed",
    parent: "1001",
    level: "6",
  },
  {
    section: "II",
    hscode: "100199",
    description:
      "Cereals; wheat and meslin, other than durum wheat, other than seed",
    parent: "1001",
    level: "6",
  },
  {
    section: "II",
    hscode: "1002",
    description: "Rye",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100210",
    description: "Cereals; rye, seed",
    parent: "1002",
    level: "6",
  },
  {
    section: "II",
    hscode: "100290",
    description: "Cereals; rye, other than seed",
    parent: "1002",
    level: "6",
  },
  {
    section: "II",
    hscode: "1003",
    description: "Barley",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100310",
    description: "Cereals; barley, seed",
    parent: "1003",
    level: "6",
  },
  {
    section: "II",
    hscode: "100390",
    description: "Cereals; barley, other than seed",
    parent: "1003",
    level: "6",
  },
  {
    section: "II",
    hscode: "1004",
    description: "Oats",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100410",
    description: "Cereals; oats, seeds",
    parent: "1004",
    level: "6",
  },
  {
    section: "II",
    hscode: "100490",
    description: "Cereals; oats, other than seed",
    parent: "1004",
    level: "6",
  },
  {
    section: "II",
    hscode: "1005",
    description: "Maize (corn)",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100510",
    description: "Cereals; maize (corn), seed",
    parent: "1005",
    level: "6",
  },
  {
    section: "II",
    hscode: "100590",
    description: "Cereals; maize (corn), other than seed",
    parent: "1005",
    level: "6",
  },
  {
    section: "II",
    hscode: "1006",
    description: "Rice",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100610",
    description: "Cereals; rice in the husk (paddy or rough)",
    parent: "1006",
    level: "6",
  },
  {
    section: "II",
    hscode: "100620",
    description: "Cereals; husked (brown) rice",
    parent: "1006",
    level: "6",
  },
  {
    section: "II",
    hscode: "100630",
    description:
      "Cereals; rice, semi-milled or wholly milled, whether or not polished or glazed",
    parent: "1006",
    level: "6",
  },
  {
    section: "II",
    hscode: "100640",
    description: "Cereals; rice, broken",
    parent: "1006",
    level: "6",
  },
  {
    section: "II",
    hscode: "1007",
    description: "Grain sorghum",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100710",
    description: "Cereals; grain sorghum, seed",
    parent: "1007",
    level: "6",
  },
  {
    section: "II",
    hscode: "100790",
    description: "Cereals; grain sorghum, other than seed",
    parent: "1007",
    level: "6",
  },
  {
    section: "II",
    hscode: "1008",
    description: "Buckwheat, millet and canary seeds; other cereals",
    parent: "10",
    level: "4",
  },
  {
    section: "II",
    hscode: "100810",
    description: "Cereals; buckwheat",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100821",
    description: "Cereals; millet, seed",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100829",
    description: "Cereals; millet, other than seed",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100830",
    description: "Cereals; canary seeds",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100840",
    description: "Cereals; fonio (Digitaria spp.)",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100850",
    description: "Cereals; quinoa (Chenopodium quinoa)",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100860",
    description: "Cereals; triticale",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "100890",
    description: "Cereals; n.e.c. in chapter 10",
    parent: "1008",
    level: "6",
  },
  {
    section: "II",
    hscode: "11",
    description:
      "Products of the milling industry; malt, starches, inulin, wheat gluten",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "1101",
    description: "Wheat or meslin flour",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110100",
    description: "Wheat or meslin flour",
    parent: "1101",
    level: "6",
  },
  {
    section: "II",
    hscode: "1102",
    description: "Cereal flours; other than of wheat or meslin",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110220",
    description: "Cereal flour; of maize (corn)",
    parent: "1102",
    level: "6",
  },
  {
    section: "II",
    hscode: "110290",
    description: "Cereal flours; other than wheat, meslin, and maize (corn)",
    parent: "1102",
    level: "6",
  },
  {
    section: "II",
    hscode: "1103",
    description: "Cereal groats; meal and pellets",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110311",
    description: "Cereal groats and meal; of wheat",
    parent: "1103",
    level: "6",
  },
  {
    section: "II",
    hscode: "110313",
    description: "Cereal groats and meal; of maize (corn)",
    parent: "1103",
    level: "6",
  },
  {
    section: "II",
    hscode: "110319",
    description: "Cereal groats and meal; n.e.c. in heading no. 1103",
    parent: "1103",
    level: "6",
  },
  {
    section: "II",
    hscode: "110320",
    description: "Cereal pellets",
    parent: "1103",
    level: "6",
  },
  {
    section: "II",
    hscode: "1104",
    description:
      "Cereal grains otherwise worked (e.g. hulled, rolled, flaked, pearled, sliced or kibbled) except rice of heading no. 1006; germ of cereals whole, rolled, flaked or ground",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110412",
    description: "Cereal grains; rolled or flaked, of oats",
    parent: "1104",
    level: "6",
  },
  {
    section: "II",
    hscode: "110419",
    description: "Cereal grains; rolled or flaked, other than oats",
    parent: "1104",
    level: "6",
  },
  {
    section: "II",
    hscode: "110422",
    description:
      "Cereal grains; worked (e.g. hulled, pearled, sliced or kibbled) of oats",
    parent: "1104",
    level: "6",
  },
  {
    section: "II",
    hscode: "110423",
    description:
      "Cereal grains; worked (e.g. hulled, pearled, sliced or kibbled) of maize (corn)",
    parent: "1104",
    level: "6",
  },
  {
    section: "II",
    hscode: "110429",
    description:
      "Cereal grains; worked, other than rolled or flaked (e.g. Hulled, pearled, sliced or kibbled) of cereals, excluding oats and maize, and rice of heading no.1006",
    parent: "1104",
    level: "6",
  },
  {
    section: "II",
    hscode: "110430",
    description: "Cereal; germ of cereals, whole, rolled, flaked or ground",
    parent: "1104",
    level: "6",
  },
  {
    section: "II",
    hscode: "1105",
    description:
      "Flour, meal, powder, flakes, granules and pellets of potatoes",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110510",
    description: "Flour, meal and powder; of potatoes",
    parent: "1105",
    level: "6",
  },
  {
    section: "II",
    hscode: "110520",
    description: "Flakes, granules and pellets; of potatoes",
    parent: "1105",
    level: "6",
  },
  {
    section: "II",
    hscode: "1106",
    description:
      "Flour, meal and powder; of the dried leguminous vegetables of heading no. 0713, of sago or of roots or tubers of heading no. 0714 or of the products of chapter 8",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110610",
    description:
      "Flour, meal and powder; of the dried leguminous vegetables of heading no. 0713",
    parent: "1106",
    level: "6",
  },
  {
    section: "II",
    hscode: "110620",
    description:
      "Flour, meal and powder; of sago or of roots or tubers of heading no. 0714",
    parent: "1106",
    level: "6",
  },
  {
    section: "II",
    hscode: "110630",
    description: "Flour, meal and powder; of the products of chapter 8",
    parent: "1106",
    level: "6",
  },
  {
    section: "II",
    hscode: "1107",
    description: "Malt; whether or not roasted",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110710",
    description: "Malt; not roasted",
    parent: "1107",
    level: "6",
  },
  {
    section: "II",
    hscode: "110720",
    description: "Malt; roasted",
    parent: "1107",
    level: "6",
  },
  {
    section: "II",
    hscode: "1108",
    description: "Starches; inulin",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110811",
    description: "Starch; wheat",
    parent: "1108",
    level: "6",
  },
  {
    section: "II",
    hscode: "110812",
    description: "Starch; maize (corn) starch",
    parent: "1108",
    level: "6",
  },
  {
    section: "II",
    hscode: "110813",
    description: "Starch; potato",
    parent: "1108",
    level: "6",
  },
  {
    section: "II",
    hscode: "110814",
    description: "Starch; manioc (cassava)",
    parent: "1108",
    level: "6",
  },
  {
    section: "II",
    hscode: "110819",
    description: "Starch; n.e.c. in item no. 1108.11 to 1108.14",
    parent: "1108",
    level: "6",
  },
  {
    section: "II",
    hscode: "110820",
    description: "Inulin",
    parent: "1108",
    level: "6",
  },
  {
    section: "II",
    hscode: "1109",
    description: "Wheat gluten; whether or not dried",
    parent: "11",
    level: "4",
  },
  {
    section: "II",
    hscode: "110900",
    description: "Wheat gluten; whether or not dried",
    parent: "1109",
    level: "6",
  },
  {
    section: "II",
    hscode: "12",
    description:
      "Oil seeds and oleaginous fruits; miscellaneous grains, seeds and fruit, industrial or medicinal plants; straw and fodder",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "1201",
    description: "Soya beans, whether or not broken",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120110",
    description: "Soya beans; seed, whether or not broken",
    parent: "1201",
    level: "6",
  },
  {
    section: "II",
    hscode: "120190",
    description: "Soya beans; other than seed, whether or not broken",
    parent: "1201",
    level: "6",
  },
  {
    section: "II",
    hscode: "1202",
    description:
      "Ground-nuts; not roasted or otherwise cooked, whether or not shelled or broken",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120230",
    description:
      "Ground-nuts; seed, not roasted or otherwise cooked, whether or not shelled or broken",
    parent: "1202",
    level: "6",
  },
  {
    section: "II",
    hscode: "120241",
    description:
      "Ground-nuts; other than seed, not roasted or otherwise cooked, in shell",
    parent: "1202",
    level: "6",
  },
  {
    section: "II",
    hscode: "120242",
    description:
      "Ground-nuts; other than seed, not roasted or otherwise cooked, shelled, whether or not broken,",
    parent: "1202",
    level: "6",
  },
  {
    section: "II",
    hscode: "1203",
    description: "Copra",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120300",
    description: "Copra",
    parent: "1203",
    level: "6",
  },
  {
    section: "II",
    hscode: "1204",
    description: "Oil seeds; linseed, whether or not broken",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120400",
    description: "Oil seeds; linseed, whether or not broken",
    parent: "1204",
    level: "6",
  },
  {
    section: "II",
    hscode: "1205",
    description: "Rape or colza seeds; whether or not broken",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120510",
    description:
      "Oil seeds; low erucic acid rape or colza seeds, whether or not broken",
    parent: "1205",
    level: "6",
  },
  {
    section: "II",
    hscode: "120590",
    description:
      "Oil seeds; rape or colza seeds, other than low erucic, whether or not broken",
    parent: "1205",
    level: "6",
  },
  {
    section: "II",
    hscode: "1206",
    description: "Sunflower seeds; whether or not broken",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120600",
    description: "Oil seeds; sunflower seeds, whether or not broken",
    parent: "1206",
    level: "6",
  },
  {
    section: "II",
    hscode: "1207",
    description:
      "Oil seeds and oleaginous fruits, n.e.c. in chapter 12; whether or not broken",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120710",
    description: "Oil seeds; palm nuts and kernels, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120721",
    description: "Oil seeds; cotton seeds, seed, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120729",
    description:
      "Oil seeds; cotton seeds, other than seed, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120730",
    description: "Oil seeds; castor oil seeds, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120740",
    description: "Oil seeds; sesamum seeds, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120750",
    description: "Oil seeds; mustard seeds, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120760",
    description:
      "Oil seeds; safflower (Carthamus tinctorius) seeds, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120770",
    description: "Oil seeds; melon seeds, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120791",
    description: "Oil seeds; poppy seeds, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "120799",
    description:
      "Oil seeds and oleaginous fruits; n.e.c. in heading no. 1207, whether or not broken",
    parent: "1207",
    level: "6",
  },
  {
    section: "II",
    hscode: "1208",
    description:
      "Flours and meals of oil seeds or oleaginous fruits; other than those of mustard",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120810",
    description: "Flours and meals; of soya beans",
    parent: "1208",
    level: "6",
  },
  {
    section: "II",
    hscode: "120890",
    description:
      "Flours and meals of oil seeds or oleaginous fruits; excluding soya beans and mustard seeds",
    parent: "1208",
    level: "6",
  },
  {
    section: "II",
    hscode: "1209",
    description: "Seeds, fruit and spores; of a kind used for sowing",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "120910",
    description: "Seed; sugar beet seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120921",
    description:
      "Seeds of forage plants; lucerne (alfalfa) seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120922",
    description:
      "Seeds of forage plants; clover (Trifolium spp.) seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120923",
    description:
      "Seeds of forage plants; fescue seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120924",
    description:
      "Seeds of forage plants; Kentucky blue grass (Poa pratensis L.) seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120925",
    description:
      "Seeds of forage plants; rye grass (Lolium multiflorum Lam., Lolium perenne L.) seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120929",
    description:
      "Seeds of forage plants; other than lucerne, clover, fescue, Kentucky blue grass, and rye grass seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120930",
    description:
      "Seeds of herbaceous plants; cultivated principally for their flowers, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120991",
    description: "Seeds; vegetable seeds, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "120999",
    description: "Seeds; n.e.c. in heading 1209, of a kind used for sowing",
    parent: "1209",
    level: "6",
  },
  {
    section: "II",
    hscode: "1210",
    description:
      "Hop cones, fresh or dried, whether or not ground, powdered or in the form of pellets; lupulin",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "121010",
    description:
      "Hop cones; neither ground nor powdered nor in the form of pellets",
    parent: "1210",
    level: "6",
  },
  {
    section: "II",
    hscode: "121020",
    description:
      "Hop cones; ground, powdered or in the form of pellets; lupulin",
    parent: "1210",
    level: "6",
  },
  {
    section: "II",
    hscode: "1211",
    description:
      "Plants and parts of plants (including seeds and fruits), of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "121120",
    description:
      "Ginseng roots, of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "1211",
    level: "6",
  },
  {
    section: "II",
    hscode: "121130",
    description:
      "Coca leaf; of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "1211",
    level: "6",
  },
  {
    section: "II",
    hscode: "121140",
    description:
      "Poppy straw; of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "1211",
    level: "6",
  },
  {
    section: "II",
    hscode: "121150",
    description:
      "Ephedra, of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "1211",
    level: "6",
  },
  {
    section: "II",
    hscode: "121160",
    description:
      "Bark of African cherry (Prunus africana); of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "1211",
    level: "6",
  },
  {
    section: "II",
    hscode: "121190",
    description:
      "Plants and parts (including seeds and fruits) n.e.c. in heading no. 1211, of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
    parent: "1211",
    level: "6",
  },
  {
    section: "II",
    hscode: "1212",
    description:
      "Locust beans, seaweeds and other algae, sugar beet, sugar cane, fresh, chilled, frozen or dried, whether or not ground; fruit stones, kernels and other vegetable products (including unroasted chicory roots) used primarily for human consumption, n.e.c.",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "121221",
    description:
      "Seaweeds and other algae; fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "121229",
    description:
      "Seaweeds and other algae; not fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "121291",
    description:
      "Sugar beet; fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "121292",
    description:
      "Locust beans (carob); fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "121293",
    description:
      "Sugar cane; fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "121294",
    description:
      "Chicory roots (Chicorium intybus sativum); fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "121299",
    description:
      "Vegetable products; fit for human consumption, n.e.c. in heading no. 1212, fresh, chilled, frozen or dried, whether or not ground",
    parent: "1212",
    level: "6",
  },
  {
    section: "II",
    hscode: "1213",
    description:
      "Cereal straw and husks, unprepared; whether or not chopped, ground, pressed or in the form of pellets",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "121300",
    description:
      "Cereal straw and husks; unprepared, whether or not chopped, ground, pressed or in the form of pellets",
    parent: "1213",
    level: "6",
  },
  {
    section: "II",
    hscode: "1214",
    description:
      "Swedes, mangolds, fodder roots, hay, lucerne (alfalfa), clover, sainfoin, forage kale, lupines, vetches and similar forage products, whether or not in the form of pellets",
    parent: "12",
    level: "4",
  },
  {
    section: "II",
    hscode: "121410",
    description: "Lucerne (alfalfa) meal and pellets",
    parent: "1214",
    level: "6",
  },
  {
    section: "II",
    hscode: "121490",
    description:
      "Forage products including swedes, mangolds, fodder roots, hay, sainfoin, clover, forage kale, lupines, vetches etc., pelletised or otherwise",
    parent: "1214",
    level: "6",
  },
  {
    section: "II",
    hscode: "13",
    description: "Lac; gums, resins and other vegetable saps and extracts",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "1301",
    description:
      "Lac; natural gums, resins, gum-resins and oleoresins (for example, balsams)",
    parent: "13",
    level: "4",
  },
  {
    section: "II",
    hscode: "130120",
    description: "Gum Arabic",
    parent: "1301",
    level: "6",
  },
  {
    section: "II",
    hscode: "130190",
    description:
      "Natural gums, resins, gum-resins and oleoresins, n.e.c. in heading no. 1301",
    parent: "1301",
    level: "6",
  },
  {
    section: "II",
    hscode: "1302",
    description:
      "Vegetable saps and extracts; pectic substances, pectinates and pectates; agar-agar and other mucilages and thickeners, whether or not modified, derived from vegetable products",
    parent: "13",
    level: "4",
  },
  {
    section: "II",
    hscode: "130211",
    description: "Vegetable saps and extracts; opium",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130212",
    description: "Vegetable saps and extracts; of liquorice",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130213",
    description: "Vegetable saps and extracts; of hops",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130214",
    description: "Vegetable saps and extracts; of ephedra",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130219",
    description: "Vegetable saps and extracts; n.e.c. in item no. 1302.1",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130220",
    description: "Pectic substances; pectinates and pectates",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130231",
    description:
      "Mucilages and thickeners; agar-agar, whether or not modified, derived from vegetable products",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130232",
    description:
      "Mucilages and thickeners; whether or not modified, derived from locust beans, locust bean seeds or guar seeds",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "130239",
    description:
      "Mucilages and thickeners; whether or not modified, derived from vegetable products, n.e.c. in item no. 1302.3",
    parent: "1302",
    level: "6",
  },
  {
    section: "II",
    hscode: "14",
    description:
      "Vegetable plaiting materials; vegetable products not elsewhere specified or included",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "II",
    hscode: "1401",
    description:
      "Vegetable materials of a kind used primarily for plaiting; (e.g. bamboos, rattans, reeds, rushes, osier, raffia, cleaned, bleached or dyed cereal straw and lime bark)",
    parent: "14",
    level: "4",
  },
  {
    section: "II",
    hscode: "140110",
    description: "Bamboo used primarily for plaiting",
    parent: "1401",
    level: "6",
  },
  {
    section: "II",
    hscode: "140120",
    description: "Rattans used primarily for plaiting",
    parent: "1401",
    level: "6",
  },
  {
    section: "II",
    hscode: "140190",
    description:
      "Vegetable materials of a kind used primarily for plaiting; n.e.c. in heading no. 1401",
    parent: "1401",
    level: "6",
  },
  {
    section: "II",
    hscode: "1404",
    description: "Vegetable products not elsewhere specified or included",
    parent: "14",
    level: "4",
  },
  {
    section: "II",
    hscode: "140420",
    description: "Vegetable products; cotton linters",
    parent: "1404",
    level: "6",
  },
  {
    section: "II",
    hscode: "140490",
    description: "Vegetable products; n.e.c. in chapter 14",
    parent: "1404",
    level: "6",
  },
  {
    section: "III",
    hscode: "15",
    description:
      "Animal, vegetable or microbial fats and oils and their cleavage products; prepared edible fats; animal or vegetable waxes",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "III",
    hscode: "1501",
    description:
      "Pig fat (including lard) and poultry fat, other than that of heading 0209 or 1503",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150110",
    description: "Pig fat; lard, other than that of heading 0209 and 1503",
    parent: "1501",
    level: "6",
  },
  {
    section: "III",
    hscode: "150120",
    description: "Pig fat; not lard, other than that of heading 0209 or 1503",
    parent: "1501",
    level: "6",
  },
  {
    section: "III",
    hscode: "150190",
    description: "Poultry fat; other than that of heading 0209 or 1503",
    parent: "1501",
    level: "6",
  },
  {
    section: "III",
    hscode: "1502",
    description:
      "Fats of bovine animals, sheep or goats, other than those of heading 1503",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150210",
    description: "Tallow; other than those of heading 1503",
    parent: "1502",
    level: "6",
  },
  {
    section: "III",
    hscode: "150290",
    description:
      "Fats of bovine animals, sheep or goats; excluding tallow, and other than those of heading 1503",
    parent: "1502",
    level: "6",
  },
  {
    section: "III",
    hscode: "1503",
    description:
      "Lard stearin, lard oil, oleostearin, oleo-oil and tallow oil; not emulsified or mixed or otherwise prepared",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150300",
    description:
      "Lard stearin, lard oil, oleostearin, oleo-oil and tallow oil; not emulsified or mixed or otherwise prepared",
    parent: "1503",
    level: "6",
  },
  {
    section: "III",
    hscode: "1504",
    description:
      "Fats and oils and their fractions of fish or marine mammals; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150410",
    description:
      "Oils of fish; fish-liver oils and their fractions, whether or not refined, but not chemically modified",
    parent: "1504",
    level: "6",
  },
  {
    section: "III",
    hscode: "150420",
    description:
      "Fats and oils and their fractions; of fish, (excluding liver-oils)",
    parent: "1504",
    level: "6",
  },
  {
    section: "III",
    hscode: "150430",
    description: "Fats and oils and their fractions; of marine mammals",
    parent: "1504",
    level: "6",
  },
  {
    section: "III",
    hscode: "1505",
    description:
      "Wool grease and fatty substances derived therefrom (including lanolin)",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150500",
    description:
      "Wool grease and fatty substances derived therefrom (including lanolin)",
    parent: "1505",
    level: "6",
  },
  {
    section: "III",
    hscode: "1506",
    description:
      "Animal fats and oils and their fractions; whether or not refined, but not chemically modified, n.e.c. in chapter 15",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150600",
    description:
      "Animal fats and oils and their fractions; whether or not refined, but not chemically modified, n.e.c. in chapter 15",
    parent: "1506",
    level: "6",
  },
  {
    section: "III",
    hscode: "1507",
    description:
      "Soya-bean oil and its fractions; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150710",
    description:
      "Vegetable oils; soya-bean oil and its fractions, crude, whether or not degummed, not chemically modified",
    parent: "1507",
    level: "6",
  },
  {
    section: "III",
    hscode: "150790",
    description:
      "Vegetable oils; soya-bean oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1507",
    level: "6",
  },
  {
    section: "III",
    hscode: "1508",
    description:
      "Ground nut oil and its fractions; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150810",
    description:
      "Vegetable oils; ground-nut oil and its fractions, crude, not chemically modified",
    parent: "1508",
    level: "6",
  },
  {
    section: "III",
    hscode: "150890",
    description:
      "Vegetable oils; ground-nut oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1508",
    level: "6",
  },
  {
    section: "III",
    hscode: "1509",
    description:
      "Olive oil and its fractions; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "150920",
    description:
      "Vegetable oils; olive oil and its fractions, extra virgin olive oil, whether or not refined, but not chemically modified",
    parent: "1509",
    level: "6",
  },
  {
    section: "III",
    hscode: "150930",
    description:
      "Vegetable oils; olive oil and its fractions, virgin olive oil, whether or not refined, but not chemically modified",
    parent: "1509",
    level: "6",
  },
  {
    section: "III",
    hscode: "150940",
    description:
      "Vegetable oils; olive oil and its fractions, virgin olive oils n.e.c. in heading 1509, whether or not refined, but not chemically modified",
    parent: "1509",
    level: "6",
  },
  {
    section: "III",
    hscode: "150990",
    description:
      "Vegetable oils; olive oil and its fractions, other than virgin, whether or not refined, but not chemically modified",
    parent: "1509",
    level: "6",
  },
  {
    section: "III",
    hscode: "1510",
    description:
      "Vegetable oils; oils and their fractions n.e.c. in chapter 15, obtained solely from olives, whether or not refined, but not chemically modified, including blends of these oils or fractions with oils or fractions of heading no. 1509",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151010",
    description:
      "Vegetable oils; crude olive pomace oil and their fractions, obtained solely from olives, whether or not refined, but not chemically modified",
    parent: "1510",
    level: "6",
  },
  {
    section: "III",
    hscode: "151090",
    description:
      "Vegetable oils; oils and their fractions n.e.c. in heading 1510, obtained solely from olives, whether or not refined, but not chemically modified, including blends of these oils or fractions with oils or fractions of heading no. 1509",
    parent: "1510",
    level: "6",
  },
  {
    section: "III",
    hscode: "1511",
    description:
      "Palm oil and its fractions; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151110",
    description:
      "Vegetable oils; palm oil and its fractions, crude, not chemically modified",
    parent: "1511",
    level: "6",
  },
  {
    section: "III",
    hscode: "151190",
    description:
      "Vegetable oils; palm oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1511",
    level: "6",
  },
  {
    section: "III",
    hscode: "1512",
    description:
      "Sun-flower seed, safflower or cotton-seed oil and their fractions; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151211",
    description:
      "Vegetable oils; sunflower seed or safflower oil and their fractions, crude, not chemically modified",
    parent: "1512",
    level: "6",
  },
  {
    section: "III",
    hscode: "151219",
    description:
      "Vegetable oils; sunflower seed or safflower oil and their fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1512",
    level: "6",
  },
  {
    section: "III",
    hscode: "151221",
    description:
      "Vegetable oils; cotton-seed oil and its fractions; crude, whether or not gossypol has been removed, not chemically modified",
    parent: "1512",
    level: "6",
  },
  {
    section: "III",
    hscode: "151229",
    description:
      "Vegetable oils; cotton-seed oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1512",
    level: "6",
  },
  {
    section: "III",
    hscode: "1513",
    description:
      "Coconut (copra), palm kernel or babassu oil and their fractions; whether or not refined but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151311",
    description:
      "Vegetable oils; coconut (copra) oil and its fractions, crude, not chemically modified",
    parent: "1513",
    level: "6",
  },
  {
    section: "III",
    hscode: "151319",
    description:
      "Vegetable oils; coconut (copra) oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1513",
    level: "6",
  },
  {
    section: "III",
    hscode: "151321",
    description:
      "Vegetable oils; palm kernel or babassu oil and their fractions, crude, not chemically modified",
    parent: "1513",
    level: "6",
  },
  {
    section: "III",
    hscode: "151329",
    description:
      "Vegetable oils; palm kernel or babassu oil and their fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1513",
    level: "6",
  },
  {
    section: "III",
    hscode: "1514",
    description:
      "Rape, colza or mustard oil and their fractions; whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151411",
    description:
      "Vegetable oils; low erucic acid rape or colza oil and its fractions, crude",
    parent: "1514",
    level: "6",
  },
  {
    section: "III",
    hscode: "151419",
    description:
      "Vegetable oils; low erucic acid rape or colza oil and its fractions, other than crude, but not chemically modified",
    parent: "1514",
    level: "6",
  },
  {
    section: "III",
    hscode: "151491",
    description:
      "Vegetable oils; excluding low erucic acid rape or colza oil and its fractions, crude",
    parent: "1514",
    level: "6",
  },
  {
    section: "III",
    hscode: "151499",
    description:
      "Vegetable oils; excluding low erucic acid rape or colza oil and its fractions, other than crude, but not chemically modified",
    parent: "1514",
    level: "6",
  },
  {
    section: "III",
    hscode: "1515",
    description:
      "Fixed vegetable or microbial fats and oils n.e.c. in chapter 15 (including jojoba oil) and their fractions, whether or not refined, but not chemically modified",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151511",
    description:
      "Vegetable oils; linseed oil and its fractions, crude, not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151519",
    description:
      "Vegetable oils; linseed oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151521",
    description:
      "Vegetable oils; maize (corn) oil and its fractions, crude, not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151529",
    description:
      "Vegetable oils; maize (corn) oil and its fractions, other than crude, whether or not refined, but not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151530",
    description:
      "Vegetable oils; castor oil and its fractions, whether or not refined, but not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151550",
    description:
      "Vegetable oils; sesame oil and its fractions, whether or not refined, but not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151560",
    description:
      "Vegetable oils; microbial fats and oils and their fractions, whether or not refined, but not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "151590",
    description:
      "Fixed vegetable fats and oils and their fractions n.e.c. in heading 1515; other than linseed, maize (corn), castor, sesame, microbial oils, whether or not refined, but not chemically modified",
    parent: "1515",
    level: "6",
  },
  {
    section: "III",
    hscode: "1516",
    description:
      "Animal, vegetable or microbial fats and oils and their fractions, partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151610",
    description:
      "Animal fats and oils and their fractions; partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
    parent: "1516",
    level: "6",
  },
  {
    section: "III",
    hscode: "151620",
    description:
      "Vegetable fats and oils and their fractions; partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
    parent: "1516",
    level: "6",
  },
  {
    section: "III",
    hscode: "151630",
    description:
      "Microbial fats and oils and their fractions; partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
    parent: "1516",
    level: "6",
  },
  {
    section: "III",
    hscode: "1517",
    description:
      "Margarine; edible mixtures or preparations of animal, vegetable or microbial fats or oils or of fractions of different fats or oils of this Chapter, other than edible fats and oils or their fractions of heading 15.16",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151710",
    description: "Margarine; excluding liquid margarine",
    parent: "1517",
    level: "6",
  },
  {
    section: "III",
    hscode: "151790",
    description:
      "Edible mixtures or preparations of animal, vegetable or microbial fats or oils or of fractions of different fats or oils of this Chapter, n.e.c. in heading 1517, other than edible fats and oils or their fractions of heading 15.16",
    parent: "1517",
    level: "6",
  },
  {
    section: "III",
    hscode: "1518",
    description:
      "Animal, vegetable or microbial fats, oils and their fractions; boiled, oxidised, dehydrated or otherwise chemically modified, excluding those of heading no. 1516, inedible mixtures or preparations of fats, oils or their fractions, n.e.c. in chapter 15",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "151800",
    description:
      "Animal, vegetable or microbial fats, oils and their fractions; boiled, oxidised, dehydrated or otherwise chemically modified, excluding those of heading no. 1516, inedible mixtures or preparations of fats, oils or their fractions, n.e.c. in chapter 15",
    parent: "1518",
    level: "6",
  },
  {
    section: "III",
    hscode: "1520",
    description: "Glycerol, crude; glycerol waters and glycerol lyes",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "152000",
    description: "Glycerol, crude; glycerol waters and glycerol lyes",
    parent: "1520",
    level: "6",
  },
  {
    section: "III",
    hscode: "1521",
    description:
      "Vegetable waxes (other than triglycerides), beeswax, other insect waxes and spermaceti; whether or not refined or coloured",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "152110",
    description:
      "Vegetable waxes (other than triglycerides); whether or not refined or coloured",
    parent: "1521",
    level: "6",
  },
  {
    section: "III",
    hscode: "152190",
    description:
      "Waxes, other than vegetable, n.e.c. in heading no. 1521; whether or not refined or coloured",
    parent: "1521",
    level: "6",
  },
  {
    section: "III",
    hscode: "1522",
    description:
      "Degras; residues resulting from the treatment of fatty substances or animal or vegetable waxes",
    parent: "15",
    level: "4",
  },
  {
    section: "III",
    hscode: "152200",
    description:
      "Degras; residues resulting from the treatment of fatty substances or animal or vegetable waxes",
    parent: "1522",
    level: "6",
  },
  {
    section: "IV",
    hscode: "16",
    description:
      "Meat, fish, crustaceans, molluscs or other aquatic invertebrates, or insects; preparations thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "1601",
    description:
      "Sausages and similar products, of meat, meat offal, blood or insects; food preparations based on these products",
    parent: "16",
    level: "4",
  },
  {
    section: "IV",
    hscode: "160100",
    description:
      "Meat preparations; sausages and similar products, of meat, meat offal, blood or insects, and food preparations based on these products",
    parent: "1601",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1602",
    description: "Prepared or preserved meat, meat offal, blood or insects",
    parent: "16",
    level: "4",
  },
  {
    section: "IV",
    hscode: "160210",
    description:
      "Meat preparations; homogenised preparations of meat, meat offal blood or insects",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160220",
    description:
      "Meat preparations; of the prepared or preserved liver of any animal (excluding homogenised preparations)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160231",
    description:
      "Meat preparations; of turkeys, prepared or preserved meat or meat offal (excluding livers and homogenised preparations)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160232",
    description:
      "Meat preparations; of the poultry of heading no. 0105, (i.e. of fowls of the species Gallus domesticus)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160239",
    description:
      "Meat preparations; of poultry (excluding turkeys), prepared or preserved meat or meat offal (excluding livers and homogenised preparations)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160241",
    description:
      "Meat preparations; of swine, hams and cuts thereof, prepared or preserved (excluding homogenised preparations)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160242",
    description:
      "Meat preparations; of swine, shoulders and cuts thereof, prepared or preserved (excluding homogenised preparations)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160249",
    description:
      "Meat preparations; of swine, meat or meat offal (including mixtures), prepared or preserved, n.e.c. in heading no. 1602",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160250",
    description:
      "Meat preparations; of bovine animals, meat or meat offal, prepared or preserved (excluding livers and homogenised preparations)",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160290",
    description:
      "Meat preparations; of meat, meat offal or the blood of any animal, n.e.c. in heading no. 1602",
    parent: "1602",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1603",
    description:
      "Extracts and juices of meat, fish or crustaceans, molluscs or other aquatic invertebrates",
    parent: "16",
    level: "4",
  },
  {
    section: "IV",
    hscode: "160300",
    description:
      "Extracts and juices; of meat, fish or crustaceans, molluscs or other aquatic invertebrates",
    parent: "1603",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1604",
    description:
      "Prepared or preserved fish; caviar and caviar substitutes prepared from fish eggs",
    parent: "16",
    level: "4",
  },
  {
    section: "IV",
    hscode: "160411",
    description:
      "Fish preparations; salmon, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160412",
    description:
      "Fish preparations; herrings, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160413",
    description:
      "Fish preparations; sardines, sardinella and brisling or sprats, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160414",
    description:
      "Fish preparations; tunas, skipjack tuna and bonito (Sarda spp.), prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160415",
    description:
      "Fish preparations; mackerel, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160416",
    description:
      "Fish preparations; anchovies, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160417",
    description:
      "Fish preparations; eels, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160418",
    description:
      "Fish preparations; shark fins, prepared or preserved, whole or in pieces (but not minced)",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160419",
    description:
      "Fish preparations; fish prepared or preserved, whole or in pieces (but not minced), n.e.c. in heading no. 1604",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160420",
    description:
      "Fish preparations; fish minced or in forms n.e.c. in heading no. 1604, prepared or preserved",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160431",
    description: "Fish preparations; caviar",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160432",
    description:
      "Fish preparations; caviar substitutes, prepared from fish eggs",
    parent: "1604",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1605",
    description:
      "Crustaceans, molluscs and other aquatic invertebrates, prepared or preserved",
    parent: "16",
    level: "4",
  },
  {
    section: "IV",
    hscode: "160510",
    description: "Crustacean preparations; crab, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160521",
    description:
      "Crustacean preparations; shrimps and prawns, prepared or preserved, not in airtight containers",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160529",
    description:
      "Crustacean preparations; shrimps and prawns, prepared or preserved, in airtight containers",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160530",
    description: "Crustacean preparations; lobster, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160540",
    description:
      "Crustacean preparations; other than crab, shrimps, prawns, and lobsters, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160551",
    description: "Mollusc preparations; oysters, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160552",
    description:
      "Mollusc preparations; scallops, including queen scallops, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160553",
    description: "Mollusc preparations; mussels, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160554",
    description:
      "Mollusc preparations; cuttle fish and squid, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160555",
    description: "Mollusc preparations; octopus, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160556",
    description:
      "Mollusc preparations; clams, cockles and arkshells, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160557",
    description: "Mollusc preparations; abalone, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160558",
    description:
      "Mollusc preparations; snails, other than sea snails, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160559",
    description:
      "Mollusc preparations; n.e.c. in item no. 1605.5, preparations such as pastes, sausages, prepared meals and the like",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160561",
    description: "Aquatic invertebrates; sea cucumbers, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160562",
    description: "Aquatic invertebrates; sea urchins, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160563",
    description: "Aquatic invertebrates; jellyfish, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "160569",
    description:
      "Aquatic invertebrates; other than crustaceans, molluscs, sea cucumbers, sea urchins, and jellyfish, prepared or preserved",
    parent: "1605",
    level: "6",
  },
  {
    section: "IV",
    hscode: "17",
    description: "Sugars and sugar confectionery",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "1701",
    description:
      "Cane or beet sugar and chemically pure sucrose, in solid form",
    parent: "17",
    level: "4",
  },
  {
    section: "IV",
    hscode: "170112",
    description:
      "Sugars; beet sugar, raw, in solid form, not containing added flavouring or colouring matter",
    parent: "1701",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170113",
    description:
      "Sugars; cane sugar, raw, in solid form, as specified in Subheading Note 2 to this chapter, not containing added flavouring or colouring matter",
    parent: "1701",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170114",
    description:
      "Sugars; cane sugar, raw, in solid form, other than as specified in Subheading Note 2 to this chapter, not containing added flavouring or colouring matter",
    parent: "1701",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170191",
    description:
      "Sugars; sucrose, chemically pure, in solid form, containing added flavouring or colouring matter",
    parent: "1701",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170199",
    description:
      "Sugars; sucrose, chemically pure, in solid form, not containing added flavouring or colouring matter",
    parent: "1701",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1702",
    description:
      "Sugars, including lactose, maltose, glucose or fructose in solid form; sugar syrups without added flavouring or colouring matter; artificial honey, whether or not mixed with natural honey; caramel",
    parent: "17",
    level: "4",
  },
  {
    section: "IV",
    hscode: "170211",
    description:
      "Sugars; lactose and lactose syrup, containing by weight 99% or more lactose, expressed as anhydrous lactose, calculated on the dry matter",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170219",
    description:
      "Sugars; lactose and lactose syrup, containing by weight less than 99% lactose, expressed as anhydrous lactose, calculated on the dry matter",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170220",
    description:
      "Sugars; maple sugar, chemically pure, in solid form; maple syrup, not containing added flavouring or colouring matter",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170230",
    description:
      "Sugars; glucose and glucose syrup, not containing fructose or containing in the dry state less than 20% by weight of fructose, the syrup not containing added flavouring or colouring matter",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170240",
    description:
      "Sugars; glucose and glucose syrup, containing in the dry state at least 20% but less than 50% by weight of fructose, excluding invert sugar, the syrup not containing added flavouring or colouring matter",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170250",
    description: "Sugars; fructose, chemically pure, in solid form",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170260",
    description:
      "Sugars; fructose, other than chemically pure fructose, and fructose syrup (containing in the dry state more than 50% by weight of fructose), excluding invert sugar",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170290",
    description:
      "Sugars; n.e.c. in heading no. 1702, including invert sugar and other sugar and sugar syrup blends containing, in the dry state, 50% by weight of fructose",
    parent: "1702",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1703",
    description: "Molasses; resulting from the extraction or refining of sugar",
    parent: "17",
    level: "4",
  },
  {
    section: "IV",
    hscode: "170310",
    description:
      "Sugars; molasses, from sugar cane, resulting from the extraction or refining of sugar",
    parent: "1703",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170390",
    description:
      "Sugars; molasses, from sugar beet, resulting from the extraction or refining of sugar",
    parent: "1703",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1704",
    description:
      "Sugar confectionery (including white chocolate), not containing cocoa",
    parent: "17",
    level: "4",
  },
  {
    section: "IV",
    hscode: "170410",
    description:
      "Sugar confectionery; chewing gum, whether or not sugar-coated, not containing cocoa",
    parent: "1704",
    level: "6",
  },
  {
    section: "IV",
    hscode: "170490",
    description:
      "Sugar confectionery; (excluding chewing gum, including white chocolate), not containing cocoa",
    parent: "1704",
    level: "6",
  },
  {
    section: "IV",
    hscode: "18",
    description: "Cocoa and cocoa preparations",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "1801",
    description: "Cocoa beans; whole or broken, raw or roasted",
    parent: "18",
    level: "4",
  },
  {
    section: "IV",
    hscode: "180100",
    description: "Cocoa beans; whole or broken, raw or roasted",
    parent: "1801",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1802",
    description: "Cocoa; shells, husks, skins and other cocoa waste",
    parent: "18",
    level: "4",
  },
  {
    section: "IV",
    hscode: "180200",
    description: "Cocoa; shells, husks, skins and other cocoa waste",
    parent: "1802",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1803",
    description: "Cocoa; paste; whether or not defatted",
    parent: "18",
    level: "4",
  },
  {
    section: "IV",
    hscode: "180310",
    description: "Cocoa; paste, not defatted",
    parent: "1803",
    level: "6",
  },
  {
    section: "IV",
    hscode: "180320",
    description: "Cocoa; paste, wholly or partly defatted",
    parent: "1803",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1804",
    description: "Cocoa; butter, fat and oil",
    parent: "18",
    level: "4",
  },
  {
    section: "IV",
    hscode: "180400",
    description: "Cocoa; butter, fat and oil",
    parent: "1804",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1805",
    description:
      "Cocoa; powder, not containing added sugar or other sweetening matter",
    parent: "18",
    level: "4",
  },
  {
    section: "IV",
    hscode: "180500",
    description:
      "Cocoa; powder, not containing added sugar or other sweetening matter",
    parent: "1805",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1806",
    description: "Chocolate and other food preparations containing cocoa",
    parent: "18",
    level: "4",
  },
  {
    section: "IV",
    hscode: "180610",
    description:
      "Cocoa; powder, containing added sugar or other sweetening matter",
    parent: "1806",
    level: "6",
  },
  {
    section: "IV",
    hscode: "180620",
    description:
      "Chocolate & other food preparations containing cocoa; in blocks, slabs or bars weighing more than 2kg or in liquid, paste, powder, granular or other bulk form in containers or immediate packings, content exceeding 2kg",
    parent: "1806",
    level: "6",
  },
  {
    section: "IV",
    hscode: "180631",
    description:
      "Chocolate and other food preparations containing cocoa; in blocks, slabs or bars, filled, weighing 2kg or less",
    parent: "1806",
    level: "6",
  },
  {
    section: "IV",
    hscode: "180632",
    description:
      "Chocolate and other food preparations containing cocoa; in blocks, slabs or bars, (not filled), weighing 2kg or less",
    parent: "1806",
    level: "6",
  },
  {
    section: "IV",
    hscode: "180690",
    description:
      "Chocolate and other food preparations containing cocoa; n.e.c. in chapter 18",
    parent: "1806",
    level: "6",
  },
  {
    section: "IV",
    hscode: "19",
    description:
      "Preparations of cereals, flour, starch or milk; pastrycooks' products",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "1901",
    description:
      "Malt extract; flour/groats/meal/starch/malt extract products, no cocoa (or less than 40% by weight) and food preparations of goods of headings 04.01 to 04.04, no cocoa (or less than 5% by weight), weights calculated on a totally defatted basis, n.e.c.",
    parent: "19",
    level: "4",
  },
  {
    section: "IV",
    hscode: "190110",
    description:
      "Food preparations; of flour, meal, starch, malt extract or milk products, suitable for infants or young children, put up for retail sale",
    parent: "1901",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190120",
    description:
      "Food preparations; mixes and doughs for the preparation of bread, pastry, cakes, biscuits and other bakers' wares",
    parent: "1901",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190190",
    description:
      "Food preparations; of flour, meal, starch, malt extract or milk products, for uses n.e.c. in heading no. 1901",
    parent: "1901",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1902",
    description:
      "Pasta; whether or not cooked or stuffed with meat or other substance, or otherwise prepared, egg spaghetti, macaroni, noodles, lasagne, gnocchi, ravioli, cannelloni; couscous, whether or not prepared",
    parent: "19",
    level: "4",
  },
  {
    section: "IV",
    hscode: "190211",
    description:
      "Food preparations; pasta, containing eggs, uncooked, not stuffed or otherwise prepared",
    parent: "1902",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190219",
    description:
      "Food preparations; pasta, uncooked (excluding that containing eggs), not stuffed or otherwise prepared",
    parent: "1902",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190220",
    description:
      "Food preparations; pasta, stuffed (with meat or other substances), whether or not cooked or otherwise prepared",
    parent: "1902",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190230",
    description:
      "Food preparations; pasta (excluding stuffed), cooked or otherwise prepared",
    parent: "1902",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190240",
    description: "Food preparations; couscous",
    parent: "1902",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1903",
    description:
      "Tapioca and substitutes therefor prepared from starch; in the form of flakes, grains, pearls, siftings or similar forms",
    parent: "19",
    level: "4",
  },
  {
    section: "IV",
    hscode: "190300",
    description:
      "Food preparations; tapioca and substitutes thereof, prepared from starch in the form of flakes, grains, pearls, siftings or similar",
    parent: "1903",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1904",
    description:
      "Prepared foods obtained by swelling or roasting cereals or cereal products (e.g. corn flakes); cereals (other than maize (corn)) in grain form or in the form of flakes or other worked grains (not flour and meal), pre-cooked or otherwise prepared, n.e.c.",
    parent: "19",
    level: "4",
  },
  {
    section: "IV",
    hscode: "190410",
    description:
      "Food preparations; obtained by the swelling or roasting of cereals or cereal products",
    parent: "1904",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190420",
    description:
      "Food preparations; obtained from unroasted cereal flakes or from mixtures of unroasted cereal flakes and roasted cereal flakes or swelled cereals",
    parent: "1904",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190430",
    description:
      "Prepared foods obtained by the swelling or roasting of cereals or cereal products (e.g. corn flakes); cereals, not maize (corn), in grain form or in the form of flakes or other worked grains, from bulgur wheat",
    parent: "1904",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190490",
    description:
      "Food preparations; cereal or cereal products (excluding maize), in grain form, pre-cooked or otherwise prepared",
    parent: "1904",
    level: "6",
  },
  {
    section: "IV",
    hscode: "1905",
    description:
      "Bread, pastry, cakes, biscuits, other bakers' wares, whether or not containing cocoa; communion wafers, empty cachets suitable for pharmaceutical use, sealing wafers, rice paper and similar products",
    parent: "19",
    level: "4",
  },
  {
    section: "IV",
    hscode: "190510",
    description:
      "Food preparations; crispbread, whether or not containing cocoa",
    parent: "1905",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190520",
    description:
      "Food preparations; gingerbread and the like, whether or not containing cocoa",
    parent: "1905",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190531",
    description:
      "Food preparations; sweet biscuits, whether or not containing cocoa",
    parent: "1905",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190532",
    description:
      "Food preparations; waffles and wafers, whether or not containing cocoa",
    parent: "1905",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190540",
    description:
      "Food preparations; rusks, toasted bread and similar toasted products, whether or not containing cocoa",
    parent: "1905",
    level: "6",
  },
  {
    section: "IV",
    hscode: "190590",
    description:
      "Food preparations; bakers' wares n.e.c. in heading no. 1605, whether or not containing cocoa; communion wafers, empty cachets suitable for pharmaceutical use, sealing wafers, rice papers and similar products",
    parent: "1905",
    level: "6",
  },
  {
    section: "IV",
    hscode: "20",
    description:
      "Preparations of vegetables, fruit, nuts or other parts of plants",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "2001",
    description:
      "Vegetables, fruit, nuts and other edible parts of plants; prepared or preserved by vinegar or acetic acid",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200110",
    description:
      "Vegetable preparations; cucumbers and gherkins, prepared or preserved by vinegar or acetic acid",
    parent: "2001",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200190",
    description:
      "Vegetable preparations; vegetables, fruit, nuts and other edible parts of plants, prepared or preserved by vinegar or acetic acid (excluding cucumbers and gherkins)",
    parent: "2001",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2002",
    description:
      "Tomatoes; prepared or preserved otherwise than by vinegar or acetic acid",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200210",
    description:
      "Vegetable preparations; tomatoes, whole or in pieces, prepared or preserved otherwise than by vinegar or acetic acid",
    parent: "2002",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200290",
    description:
      "Vegetable preparations; tomatoes, (other than whole or in pieces), prepared or preserved otherwise than by vinegar or acetic acid",
    parent: "2002",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2003",
    description:
      "Mushrooms and truffles, prepared or preserved other than by vinegar or acetic acid",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200310",
    description:
      "Vegetable preparations; mushrooms of the genus Agaricus, prepared or preserved otherwise than by vinegar or acetic acid",
    parent: "2003",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200390",
    description:
      "Vegetable preparations; mushrooms and truffles, other than mushrooms of the genus Agaricus, prepared or preserved otherwise than by vinegar or acetic acid",
    parent: "2003",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2004",
    description:
      "Vegetables preparations n.e.c.; prepared or preserved otherwise than by vinegar or acetic acid, frozen, other than products of heading no. 2006",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200410",
    description:
      "Vegetable preparations; potatoes, prepared or preserved otherwise than by vinegar or acetic acid, frozen",
    parent: "2004",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200490",
    description:
      "Vegetable preparations; vegetables and mixtures of vegetables (excluding potatoes), prepared or preserved otherwise than by vinegar or acetic acid, frozen",
    parent: "2004",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2005",
    description:
      "Vegetables preparations n.e.c.; prepared or preserved otherwise than by vinegar or acetic acid, not frozen, other than products of heading no. 2006",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200510",
    description:
      "Vegetable preparations; homogenised vegetables, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200520",
    description:
      "Vegetable preparations; potatoes, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200540",
    description:
      "Vegetable preparations; peas (pisum sativum), prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200551",
    description:
      "Vegetable preparations; beans, shelled, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200559",
    description:
      "Vegetable preparations; beans, (not shelled), prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200560",
    description:
      "Vegetable preparations; asparagus, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200570",
    description:
      "Vegetable preparations; olives, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200580",
    description:
      "Vegetable preparations; sweetcorn (zea mays var. saccharata), prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200591",
    description:
      "Vegetable preparations; bamboo shoots, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200599",
    description:
      "Vegetable preparations; vegetables and mixtures of vegetables n.e.c. in heading no. 2005, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
    parent: "2005",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2006",
    description:
      "Vegetables, fruit, nuts, fruit-peel and other parts of plants, preserved by sugar (drained, glace or crystallised)",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200600",
    description:
      "Vegetables, fruit, nuts, fruit-peel and other parts of plants, preserved by sugar (drained, glace or crystallised)",
    parent: "2006",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2007",
    description:
      "Jams, fruit jellies, marmalades, fruit or nut puree and fruit or nut pastes, being cooked preparations; whether or not containing added sugar or other sweetening matter",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200710",
    description:
      "Jams, fruit jellies, marmalades, fruit or nut puree and fruit or nut pastes; homogenised, cooked preparations, whether or not containing added sugar or other sweetening matter",
    parent: "2007",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200791",
    description:
      "Jams, jellies, marmalades, purees and pastes; of citrus fruit, being cooked preparations (excluding homogenised), whether or not containing added sugar or other sweetening matter",
    parent: "2007",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200799",
    description:
      "Jams, fruit jellies, marmalades, purees and pastes; of fruit or nuts n.e.c. in heading no. 2007, cooked preparations (excluding homogenised), whether or not containing added sugar or other sweetening matter",
    parent: "2007",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2008",
    description:
      "Fruit, nuts and other edible parts of plants; prepared or preserved in ways n.e.c., whether or not containing added sugar or other sweetening matter or spirit, not elsewhere specified or included",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200811",
    description:
      "Nuts; ground-nuts, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200819",
    description:
      "Nuts and other seeds; whether or not containing added sugar, other sweetening matter or spirit (excluding ground-nuts except in mixtures)",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200820",
    description:
      "Fruit; pineapples, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200830",
    description:
      "Fruit; citrus, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200840",
    description:
      "Fruit; pears, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200850",
    description:
      "Fruit; apricots, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200860",
    description:
      "Fruit; cherries, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200870",
    description:
      "Fruit; peaches, including nectarines, prepared or preserved in ways n.e.c. in heading no. 2007 and 2008, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200880",
    description:
      "Fruit; strawberries, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200891",
    description:
      "Fruit, palm hearts; prepared or preserved, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200893",
    description:
      "Fruit; cranberries (Vaccinium macrocarpon, Vaccinium oxycoccos); Iingonberries (Vaccinium vitis-idaea), prepared or preserved, whether or not containing added sugar, other sweetening matter or spirit",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200897",
    description:
      "Fruit, nuts and other edible parts of plants; mixtures (other than those of subheading no 2008.19); prepared or preserved in ways n.e.c. in headings 2007 and 2008, whether or not containing added sugar, or other sweetening matter or spirit, n.e.c.",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200899",
    description:
      "Fruit, nuts and other edible parts of plants; prepared or preserved, whether or not containing added sugar, other sweetening matter or spirit, n.e.c. in heading no. 2008",
    parent: "2008",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2009",
    description:
      "Fruit or nut juices (including grape must and coconut water) and vegetable juices, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "20",
    level: "4",
  },
  {
    section: "IV",
    hscode: "200911",
    description:
      "Juice; orange, frozen, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200912",
    description:
      "Juice; orange, not frozen, of a Brix value not exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200919",
    description:
      "Juice; orange, not frozen, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200921",
    description:
      "Juice; grapefruit or pomelo, of a Brix value not exceeding 20, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200929",
    description:
      "Juice; grapefruit or pomelo, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200931",
    description:
      "Juice; of single citrus fruit (excluding orange, grapefruit or pomelo), of a Brix value not exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200939",
    description:
      "Juice; of single citrus fruit (excluding orange, grapefruit or pomelo), of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200941",
    description:
      "Juice; pineapple, of a Brix value not exceeding 20, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200949",
    description:
      "Juice; pineapple, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200950",
    description:
      "Juice; tomato, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200961",
    description:
      "Juice; grape, of a Brix value not exceeding 30, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200969",
    description:
      "Juice; grape, of a Brix value exceeding 30, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200971",
    description:
      "Juice; apple, of a Brix value not exceeding 20, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200979",
    description:
      "Juice; apple, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200981",
    description:
      "Juice; cranberry (Vaccinium macrocarpon, Vaccinium oxycoccos); Iingonberry (Vaccinium vitis-idaea), unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200989",
    description:
      "Juice; of any single fruit, nut or vegetable n.e.c. in heading no. 2009, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "200990",
    description:
      "Juices; mixtures of fruits or vegetables (but not nut juice), unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
    parent: "2009",
    level: "6",
  },
  {
    section: "IV",
    hscode: "21",
    description: "Miscellaneous edible preparations",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "2101",
    description:
      "Extracts, essences, concentrates of coffee, tea or mate; preparations with a basis of these products or with a basis of coffee, tea or mate; roasted chicory and other roasted coffee substitutes and extracts, essences and concentrates thereof",
    parent: "21",
    level: "4",
  },
  {
    section: "IV",
    hscode: "210111",
    description:
      "Extracts, essences and concentrates; of coffee, and preparations with a basis of these extracts, essences or concentrates or with a basis of coffee",
    parent: "2101",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210112",
    description:
      "Preparations with a basis of extracts, essences or concentrates or with a basis of coffee",
    parent: "2101",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210120",
    description:
      "Extracts, essences and concentrates; of tea or mate, and preparations with a basis of these extracts, essences or concentrates or with a basis of tea or mate",
    parent: "2101",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210130",
    description:
      "Chicory, roasted and other roasted coffee substitutes; extracts, essences and concentrates thereof",
    parent: "2101",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2102",
    description:
      "Yeasts (active or inactive); other single-cell micro-organisms, dead (but not including vaccines of heading no. 3002); prepared baking powders",
    parent: "21",
    level: "4",
  },
  {
    section: "IV",
    hscode: "210210",
    description: "Yeasts; active",
    parent: "2102",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210220",
    description: "Yeasts; inactive, other single-cell micro-organisms, dead",
    parent: "2102",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210230",
    description: "Baking powders; prepared",
    parent: "2102",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2103",
    description:
      "Sauces and preparations therefor; mixed condiments and mixed seasonings, mustard flour and meal and prepared mustard",
    parent: "21",
    level: "4",
  },
  {
    section: "IV",
    hscode: "210310",
    description: "Sauces; soya",
    parent: "2103",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210320",
    description: "Sauces; tomato ketchup and other tomato sauces",
    parent: "2103",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210330",
    description: "Mustard flour and meal and prepared mustard",
    parent: "2103",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210390",
    description:
      "Sauces and preparations therefor; mixed condiments and mixed seasonings",
    parent: "2103",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2104",
    description:
      "Soups and broths and preparations therefor; homogenised composite food preparations",
    parent: "21",
    level: "4",
  },
  {
    section: "IV",
    hscode: "210410",
    description: "Soups and broths and preparations therefor",
    parent: "2104",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210420",
    description: "Homogenised composite food preparations",
    parent: "2104",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2105",
    description:
      "Ice cream and other edible ice; whether or not containing cocoa",
    parent: "21",
    level: "4",
  },
  {
    section: "IV",
    hscode: "210500",
    description:
      "Ice cream and other edible ice; whether or not containing cocoa",
    parent: "2105",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2106",
    description: "Food preparations not elsewhere specified or included",
    parent: "21",
    level: "4",
  },
  {
    section: "IV",
    hscode: "210610",
    description: "Protein; concentrates and textured protein substances",
    parent: "2106",
    level: "6",
  },
  {
    section: "IV",
    hscode: "210690",
    description: "Food preparations; n.e.c. in item no. 2106.10",
    parent: "2106",
    level: "6",
  },
  {
    section: "IV",
    hscode: "22",
    description: "Beverages, spirits and vinegar",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "2201",
    description:
      "Waters, including natural or artificial mineral waters and aerated waters, not containing added sugar or other sweetening matter nor flavoured; ice and snow",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220110",
    description:
      "Waters; mineral and aerated, including natural or artificial, (not containing added sugar or other sweetening matter nor flavoured)",
    parent: "2201",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220190",
    description:
      "Waters; other than mineral and aerated, (not containing added sugar or other sweetening matter nor flavoured), ice and snow",
    parent: "2201",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2202",
    description:
      "Waters, including mineral and aerated waters, containing added sugar or sweetening matter, flavoured; other non-alcoholic beverages, not including fruit, nut or vegetable juices of heading no. 2009",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220210",
    description:
      "Waters; including mineral and aerated, containing added sugar or other sweetening matter or flavoured",
    parent: "2202",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220291",
    description: "Non-alcoholic beverages; non-alcoholic beer",
    parent: "2202",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220299",
    description:
      "Non-alcoholic beverages; other than non-alcoholic beer, n.e.c. in item no. 2202.10, not including fruit, nut or vegetable juices of heading no. 2009",
    parent: "2202",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2203",
    description: "Beer made from malt",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220300",
    description: "Beer; made from malt",
    parent: "2203",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2204",
    description:
      "Wine of fresh grapes, including fortified wines; grape must other than that of heading no. 2009",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220410",
    description: "Wine; sparkling",
    parent: "2204",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220421",
    description: "Wine; still, in containers holding 2 litres or less",
    parent: "2204",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220422",
    description:
      "Wine; still, in containers holding more than 2 litres but not more than 10 litres",
    parent: "2204",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220429",
    description: "Wine; still, in containers holding more than 10 litres",
    parent: "2204",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220430",
    description:
      "Grape must; n.e.c. in heading no. 2009, n.e.c. in item no. 2204.2",
    parent: "2204",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2205",
    description:
      "Vermouth and other wine of fresh grapes, flavoured with plants or aromatic substances",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220510",
    description:
      "Vermouth and other wine of fresh grapes, flavoured with plants or aromatic substances, in containers holding 2 litres or less",
    parent: "2205",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220590",
    description:
      "Vermouth and other wine of fresh grapes, flavoured with plants or aromatic substances, in containers holding more than 2 litres",
    parent: "2205",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2206",
    description:
      "Fermented beverages, n.e.c. in chapter 22; (e.g. cider, perry, mead, sake)",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220600",
    description: "Beverages, fermented; (e.g. cider, perry, mead, sake)",
    parent: "2206",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2207",
    description:
      "Ethyl alcohol, undenatured; of an alcoholic strength by volume of 80% vol. or higher; ethyl alcohol and other spirits, denatured, of any strength",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220710",
    description:
      "Undenatured ethyl alcohol; of an alcoholic strength by volume of 80% vol. or higher",
    parent: "2207",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220720",
    description: "Ethyl alcohol and other spirits; denatured, of any strength",
    parent: "2207",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2208",
    description:
      "Ethyl alcohol, undenatured; of an alcoholic strength by volume of less than 80% volume; spirits, liqueurs and other spirituous beverages",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220820",
    description: "Spirits obtained by distilling grape wine or grape marc",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220830",
    description: "Whiskies",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220840",
    description:
      "Rum and other spirits obtained by distilling fermented sugar-cane products",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220850",
    description: "Gin and geneva",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220860",
    description: "Vodka",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220870",
    description: "Liqueurs and cordials",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "220890",
    description:
      "Spirits, liqueurs and other spirituous beverages; n.e.c. in heading no. 2208",
    parent: "2208",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2209",
    description:
      "Vinegar and substitutes for vinegar obtained from acetic acid",
    parent: "22",
    level: "4",
  },
  {
    section: "IV",
    hscode: "220900",
    description:
      "Vinegar and substitutes for vinegar; obtained from acetic acid",
    parent: "2209",
    level: "6",
  },
  {
    section: "IV",
    hscode: "23",
    description:
      "Food industries, residues and wastes thereof; prepared animal fodder",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "2301",
    description:
      "Flours, meal and pellets, of meat or meat offal, of fish or of crustaceans, molluscs or other aquatic invertebrates, unfit for human consumption; greaves",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230110",
    description: "Flours, meals and pellets; of meat or meat offal, greaves",
    parent: "2301",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230120",
    description:
      "Flours, meals and pellets; of fish or of crustaceans, molluscs or other aquatic invertebrates",
    parent: "2301",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2302",
    description:
      "Bran, sharps and other residues; whether or not in the form of pellets derived from the sifting, milling or other working of cereals or of leguminous plants",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230210",
    description:
      "Bran, sharps and other residues; of maize (corn), whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
    parent: "2302",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230230",
    description:
      "Bran, sharps and other residues; of wheat, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
    parent: "2302",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230240",
    description:
      "Bran, sharps and other residues; of other cereals, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
    parent: "2302",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230250",
    description:
      "Bran, sharps and other residues; of leguminous plants, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
    parent: "2302",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2303",
    description:
      "Residues of starch manufacture, similar residues; beet-pulp, bagasse and other waste of sugar manufacture, brewing or distilling dregs and waste, whether or not in the form of pellets",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230310",
    description:
      "Residues of starch manufacture and similar residues; whether or not in the form of pellets",
    parent: "2303",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230320",
    description:
      "Beet-pulp, bagasse and other waste of sugar manufacture; whether or not in the form of pellets",
    parent: "2303",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230330",
    description:
      "Brewing or distilling dregs and waste; whether or not in the form of pellets",
    parent: "2303",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2304",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of soya-bean oil",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230400",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of soya-bean oil",
    parent: "2304",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2305",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of ground-nut oil",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230500",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of ground-nut oil",
    parent: "2305",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2306",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of vegetable or microbial fats or oils, other than those of heading no. 2304 or 2305",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230610",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of cotton seed oils",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230620",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of linseed oils",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230630",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of sunflower seed oils",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230641",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of low erucic acid rape or colza seed oils",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230649",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of rape seed oils (other than low erucic acid rape or colza)",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230650",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of coconut or copra seed oils",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230660",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of palm nuts or kernels oils",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230690",
    description:
      "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of oils, n.e.c. in heading no. 2306",
    parent: "2306",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2307",
    description: "Wine lees; argol",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230700",
    description: "Wine lees; argol",
    parent: "2307",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2308",
    description:
      "Vegetable materials and vegetable waste, vegetable residues and bi-products; whether or not in the form of pellets, of a kind used in animal feeding, not elsewhere specified or included",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230800",
    description:
      "Vegetable materials and vegetable waste, vegetable residues and by-products; whether or not in the form of pellets, of a kind used in animal feeding, not elsewhere specified or included",
    parent: "2308",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2309",
    description: "Preparations of a kind used in animal feeding",
    parent: "23",
    level: "4",
  },
  {
    section: "IV",
    hscode: "230910",
    description:
      "Dog or cat food; put up for retail sale, used in animal feeding",
    parent: "2309",
    level: "6",
  },
  {
    section: "IV",
    hscode: "230990",
    description:
      "Dog or cat food; (not put up for retail sale), used in animal feeding",
    parent: "2309",
    level: "6",
  },
  {
    section: "IV",
    hscode: "24",
    description:
      "Tobacco and manufactured tobacco substitutes; products, whether or not containing nicotine, intended for inhalation without combustion; other nicotine containing products intended for the intake of nicotine into the human body",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IV",
    hscode: "2401",
    description: "Tobacco, unmanufactured; tobacco refuse",
    parent: "24",
    level: "4",
  },
  {
    section: "IV",
    hscode: "240110",
    description: "Tobacco, (not stemmed or stripped)",
    parent: "2401",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240120",
    description: "Tobacco; partly or wholly stemmed or stripped",
    parent: "2401",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240130",
    description: "Tobacco refuse",
    parent: "2401",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2402",
    description:
      "Cigars, cheroots, cigarillos and cigarettes; of tobacco or of tobacco substitutes",
    parent: "24",
    level: "4",
  },
  {
    section: "IV",
    hscode: "240210",
    description:
      "Cigars, cheroots and cigarillos; containing tobacco including the weight of every band, wrapper or attachment thereto",
    parent: "2402",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240220",
    description: "Cigarettes; containing tobacco",
    parent: "2402",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240290",
    description:
      "Cigars, cigarillos and cheroots; containing tobacco substitutes including the weight of every band, wrapper or attachment thereto",
    parent: "2402",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2403",
    description:
      "Manufactured tobacco and manufactured tobacco substitutes n.e.c; homogenised or reconstituted tobacco; tobacco extracts and essences",
    parent: "24",
    level: "4",
  },
  {
    section: "IV",
    hscode: "240311",
    description:
      "Tobacco; smoking, water pipe tobacco as specified in Subheading Note 1 to this Chapter, whether or not containing tobacco substitutes in any proportion",
    parent: "2403",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240319",
    description:
      "Tobacco; smoking, other than water pipe tobacco, whether or not containing tobacco substitutes in any proportion",
    parent: "2403",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240391",
    description: "Tobacco; homogenised or reconstituted",
    parent: "2403",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240399",
    description: "Tobacco; other than homogenised or reconstituted or smoking",
    parent: "2403",
    level: "6",
  },
  {
    section: "IV",
    hscode: "2404",
    description:
      "Products containing tobacco, reconstituted tobacco, nicotine, or tobacco or nicotine substitutes, intended for inhalation without combustion; other nicotine containing products intended for the intake of nicotine into the human body",
    parent: "24",
    level: "4",
  },
  {
    section: "IV",
    hscode: "240411",
    description:
      "Products containing tobacco or reconstituted tobacco, intended for inhalation without combustion",
    parent: "2404",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240412",
    description:
      "Products containing nicotine, other than tobacco or reconstituted tobacco, intended for inhalation without combustion",
    parent: "2404",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240419",
    description:
      "Products containing tobacco or nicotine substitutes, intended for inhalation without combustion",
    parent: "2404",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240491",
    description:
      "Products n.e.c. in heading 2404, intended for the intake of nicotine into the human body, for oral application",
    parent: "2404",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240492",
    description:
      "Products n.e.c. in heading 2404, intended for the intake of nicotine into the human body, for transdermal application",
    parent: "2404",
    level: "6",
  },
  {
    section: "IV",
    hscode: "240499",
    description:
      "Products n.e.c. in heading 2404, intended for the intake of nicotine into the human body, by ways other than inhalation, and other than oral or transdermal application",
    parent: "2404",
    level: "6",
  },
  {
    section: "V",
    hscode: "25",
    description:
      "Salt; sulphur; earths, stone; plastering materials, lime and cement",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "V",
    hscode: "2501",
    description:
      "Salt (including table salt and denatured salt); pure sodium chloride whether or not in aqueous solution; sea water",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250100",
    description:
      "Salt (including table salt and denatured salt); pure sodium chloride whether or not in aqueous solution; sea water",
    parent: "2501",
    level: "6",
  },
  {
    section: "V",
    hscode: "2502",
    description: "Iron pyrites; unroasted",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250200",
    description: "Iron pyrites; unroasted",
    parent: "2502",
    level: "6",
  },
  {
    section: "V",
    hscode: "2503",
    description:
      "Sulphur of all kinds; other than sublimed, precipitated and colloidal sulphur",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250300",
    description:
      "Sulphur of all kinds; other than sublimed, precipitated and colloidal sulphur",
    parent: "2503",
    level: "6",
  },
  {
    section: "V",
    hscode: "2504",
    description: "Graphite; natural",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250410",
    description: "Graphite; natural, in powder or in flakes",
    parent: "2504",
    level: "6",
  },
  {
    section: "V",
    hscode: "250490",
    description:
      "Graphite; natural, in other forms, excluding powder or flakes",
    parent: "2504",
    level: "6",
  },
  {
    section: "V",
    hscode: "2505",
    description:
      "Sands of all kinds; natural, whether or not coloured, other than metal-bearing sands of chapter 26",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250510",
    description:
      "Sands; natural, silica and quartz sands, whether or not coloured",
    parent: "2505",
    level: "6",
  },
  {
    section: "V",
    hscode: "250590",
    description:
      "Sands; natural, (other than silica and quartz sands), whether or not coloured, (other than metal-bearing sands of chapter 26)",
    parent: "2505",
    level: "6",
  },
  {
    section: "V",
    hscode: "2506",
    description:
      "Quartz; (other than natural sands), quartzite, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250610",
    description: "Quartz; other than natural sands",
    parent: "2506",
    level: "6",
  },
  {
    section: "V",
    hscode: "250620",
    description:
      "Quartzite; whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "2506",
    level: "6",
  },
  {
    section: "V",
    hscode: "2507",
    description: "Kaolin and other kaolinic clays; whether or not calcined",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250700",
    description: "Kaolin and other kaolinic clays; whether or not calcined",
    parent: "2507",
    level: "6",
  },
  {
    section: "V",
    hscode: "2508",
    description:
      "Clays; (not including expanded clays of heading no. 6806), andalusite kyanite and sillimanite, whether or not calcined; mullite; chamotte or dinas earth",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250810",
    description:
      "Clays (excluding expanded clays of heading no. 6806); bentonite, whether or not calcined",
    parent: "2508",
    level: "6",
  },
  {
    section: "V",
    hscode: "250830",
    description:
      "Clays (excluding expanded clays of heading no. 6806); fireclay, whether or not calcined",
    parent: "2508",
    level: "6",
  },
  {
    section: "V",
    hscode: "250840",
    description:
      "Clays (excluding expanded clays of heading no. 6806); n.e.c. in heading no. 2508, whether or not calcined",
    parent: "2508",
    level: "6",
  },
  {
    section: "V",
    hscode: "250850",
    description:
      "Clays (excluding expanded clays of heading no. 6806); andalusite, kyanite and sillimanite, whether or not calcined",
    parent: "2508",
    level: "6",
  },
  {
    section: "V",
    hscode: "250860",
    description:
      "Clays (excluding expanded clays of heading no. 6806); mullite",
    parent: "2508",
    level: "6",
  },
  {
    section: "V",
    hscode: "250870",
    description:
      "Clays (excluding expanded clays of heading no. 6806); chamotte or dinas earths",
    parent: "2508",
    level: "6",
  },
  {
    section: "V",
    hscode: "2509",
    description: "Chalk",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "250900",
    description: "Chalk",
    parent: "2509",
    level: "6",
  },
  {
    section: "V",
    hscode: "2510",
    description:
      "Natural calcium phosphates; natural aluminium calcium phosphates and phosphatic chalk",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251010",
    description:
      "Natural calcium phosphates, natural aluminium calcium phosphates and phosphatic chalk; unground",
    parent: "2510",
    level: "6",
  },
  {
    section: "V",
    hscode: "251020",
    description:
      "Natural calcium phosphates, natural aluminium calcium phosphates and phosphatic chalk; ground",
    parent: "2510",
    level: "6",
  },
  {
    section: "V",
    hscode: "2511",
    description:
      "Natural barium sulphate (barytes); natural barium carbonate, (witherite) whether or not calcined, other than barium oxide of heading no. 2816",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251110",
    description: "Barium sulphate (barytes); natural",
    parent: "2511",
    level: "6",
  },
  {
    section: "V",
    hscode: "251120",
    description:
      "Barium carbonate (witherite); natural, whether or not calcined, other than barium oxide of heading no. 2816",
    parent: "2511",
    level: "6",
  },
  {
    section: "V",
    hscode: "2512",
    description:
      "Siliceous fossil meals (e.g. kieselguhr, tripolite and diatomite) and similar siliceous earths; whether or not calcined, of an apparent specific gravity of 1 or less",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251200",
    description:
      "Siliceous fossil meals (e.g. kieselguhr, tripolite and diatomite) and similar siliceous earths; whether or not calcined, of an apparent specific gravity of 1 or less",
    parent: "2512",
    level: "6",
  },
  {
    section: "V",
    hscode: "2513",
    description:
      "Pumice stone; emery; natural corundum, natural garnet and other natural abrasives, whether or not heat treated",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251310",
    description: "Pumice stone, whether or not heat treated",
    parent: "2513",
    level: "6",
  },
  {
    section: "V",
    hscode: "251320",
    description:
      "Emery, natural corundum, natural garnet and other natural abrasives, whether or not heat-treated",
    parent: "2513",
    level: "6",
  },
  {
    section: "V",
    hscode: "2514",
    description:
      "Slate, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251400",
    description:
      "Slate; whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "2514",
    level: "6",
  },
  {
    section: "V",
    hscode: "2515",
    description:
      "Marble, travertine, ecaussine and other calcareous stone; of an apparent specific gravity of less than 2.5, alabaster, whether cut by sawing etc, into blocks, slabs of a rectangular (square) shape",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251511",
    description:
      "Marble and travertine; having a specific gravity of 2.5 or more, crude or roughly trimmed by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "2515",
    level: "6",
  },
  {
    section: "V",
    hscode: "251512",
    description:
      "Marble and travertine; merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape, having a specific gravity of 2.5 or more",
    parent: "2515",
    level: "6",
  },
  {
    section: "V",
    hscode: "251520",
    description:
      "Ecaussine and other calcareous monumental or building stone; alabaster, having a specific gravity of 2.5 or more",
    parent: "2515",
    level: "6",
  },
  {
    section: "V",
    hscode: "2516",
    description:
      "Granite, porphyry, basalt, sandstone, other monumental and building stone, whether or not roughly trimmed, cut, by sawing etc, into blocks or slabs of a rectangular (including square) shape",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251611",
    description: "Granite; crude or roughly trimmed",
    parent: "2516",
    level: "6",
  },
  {
    section: "V",
    hscode: "251612",
    description:
      "Granite; merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "2516",
    level: "6",
  },
  {
    section: "V",
    hscode: "251620",
    description:
      "Sandstone;. whether or not roughly trimmed, cut, by sawing etc, into blocks or slabs of a rectangular (including square) shape",
    parent: "2516",
    level: "6",
  },
  {
    section: "V",
    hscode: "251690",
    description:
      "Monumental or building stone; n.e.c. in heading no. 2516, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "2516",
    level: "6",
  },
  {
    section: "V",
    hscode: "2517",
    description:
      "Pebbles, gravel, crushed stone for concrete aggregates for road or railway ballast, shingle or flint; macadam of slag, dross etc tarred granules, chippings, powder of stones of heading no. 2515 and 2516",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251710",
    description:
      "Pebbles, gravel, broken or crushed stone; of a kind commonly used for concrete aggregates, for road metalling or for railway or other ballast, shingle and flint, whether or not heat-treated",
    parent: "2517",
    level: "6",
  },
  {
    section: "V",
    hscode: "251720",
    description:
      "Macadam of slag, dross or similar industrial waste; whether or not incorporating the materials in Tariff item 2517.10.00",
    parent: "2517",
    level: "6",
  },
  {
    section: "V",
    hscode: "251730",
    description: "Tarred macadam",
    parent: "2517",
    level: "6",
  },
  {
    section: "V",
    hscode: "251741",
    description:
      "Stones; of marble, in granules, chippings and powder, whether or not heat-treated",
    parent: "2517",
    level: "6",
  },
  {
    section: "V",
    hscode: "251749",
    description:
      "Stones; of heading no. 2515 or 2516 (excluding marble), in granules, chippings and powder, whether or not heat-treated",
    parent: "2517",
    level: "6",
  },
  {
    section: "V",
    hscode: "2518",
    description:
      "Dolomite, whether or not calcined or sintered, including dolomite roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251810",
    description:
      "Dolomite, not calcined or sintered; including dolomite roughly trimmed, or merely cut by sawing or otherwise into blocks or slabs of rectangular (including square) shape",
    parent: "2518",
    level: "6",
  },
  {
    section: "V",
    hscode: "251820",
    description:
      "Dolomite, calcined or sintered; including dolomite roughly trimmed, or merely cut by sawing or otherwise into blocks or slabs of rectangular (including square) shape",
    parent: "2518",
    level: "6",
  },
  {
    section: "V",
    hscode: "2519",
    description:
      "Natural magnesium carbonate (magnesite); fused magnesia; dead-burned (sintered) magnesia, whether or not containing small quantities of other oxides added before sintering; magnesium oxide, pure or not",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "251910",
    description: "Magnesium carbonate (magnesite); natural",
    parent: "2519",
    level: "6",
  },
  {
    section: "V",
    hscode: "251990",
    description:
      "Magnesia, fused or dead-burned (sintered); whether or not containing small quantities of other oxides added before sintering, other magnesium oxide, whether or not pure, (not natural magnesium carbonate)",
    parent: "2519",
    level: "6",
  },
  {
    section: "V",
    hscode: "2520",
    description:
      "Gypsum; anhydrite; plasters (consisting of calcined gypsum or calcium sulphate), coloured or not, with or without small quantities of accelerators or retarders",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252010",
    description: "Gypsum; anhydrite",
    parent: "2520",
    level: "6",
  },
  {
    section: "V",
    hscode: "252020",
    description:
      "Plasters; (consisting of calcined gypsum or calcium sulphate), whether or not coloured, with or without small quantities of accelerators or retarders",
    parent: "2520",
    level: "6",
  },
  {
    section: "V",
    hscode: "2521",
    description:
      "Limestone flux; limestone and other calcareous stone, of a kind used for the manufacture of lime or cement",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252100",
    description:
      "Limestone flux; limestone and other calcareous stone, of a kind used for the manufacture of lime or cement",
    parent: "2521",
    level: "6",
  },
  {
    section: "V",
    hscode: "2522",
    description:
      "Quicklime, slaked lime and hydraulic lime; other than calcium oxide and hydroxide of heading no. 2825",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252210",
    description:
      "Quicklime; excluding calcium oxide and hydroxide of heading no. 2825",
    parent: "2522",
    level: "6",
  },
  {
    section: "V",
    hscode: "252220",
    description:
      "Slaked lime; excluding calcium oxide and hydroxide of heading no. 2825",
    parent: "2522",
    level: "6",
  },
  {
    section: "V",
    hscode: "252230",
    description:
      "Hydraulic lime; excluding calcium oxide and hydroxide of heading no. 2825",
    parent: "2522",
    level: "6",
  },
  {
    section: "V",
    hscode: "2523",
    description:
      "Portland cement, aluminous cement (ciment fondu), slag cement, supersulphate cement and similar hydraulic cements, whether or not coloured or in the form of clinkers",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252310",
    description: "Cement clinkers (whether or not coloured)",
    parent: "2523",
    level: "6",
  },
  {
    section: "V",
    hscode: "252321",
    description:
      "Cement; portland, white, whether or not artificially coloured",
    parent: "2523",
    level: "6",
  },
  {
    section: "V",
    hscode: "252329",
    description:
      "Cement; portland, other than white, whether or not artificially coloured",
    parent: "2523",
    level: "6",
  },
  {
    section: "V",
    hscode: "252330",
    description:
      "Cement; aluminous (ciment fondu), whether or not coloured or in the form of clinkers",
    parent: "2523",
    level: "6",
  },
  {
    section: "V",
    hscode: "252390",
    description: "Cement; hydraulic kinds n.e.c. in heading no. 2523",
    parent: "2523",
    level: "6",
  },
  {
    section: "V",
    hscode: "2524",
    description: "Asbestos",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252410",
    description: "Asbestos; crocidolite (blue asbestos)",
    parent: "2524",
    level: "6",
  },
  {
    section: "V",
    hscode: "252490",
    description: "Asbestos; other than crocidolite (blue asbestos)",
    parent: "2524",
    level: "6",
  },
  {
    section: "V",
    hscode: "2525",
    description: "Mica, including splittings; mica waste",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252510",
    description: "Mica; crude and rifted into sheets or splittings",
    parent: "2525",
    level: "6",
  },
  {
    section: "V",
    hscode: "252520",
    description: "Mica; powder",
    parent: "2525",
    level: "6",
  },
  {
    section: "V",
    hscode: "252530",
    description: "Mica; waste",
    parent: "2525",
    level: "6",
  },
  {
    section: "V",
    hscode: "2526",
    description:
      "Natural steatite; whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape; talc",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252610",
    description:
      "Steatite; natural, (not crushed or powdered), whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape; talc",
    parent: "2526",
    level: "6",
  },
  {
    section: "V",
    hscode: "252620",
    description:
      "Steatite; natural, crushed, powdered, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape; talc",
    parent: "2526",
    level: "6",
  },
  {
    section: "V",
    hscode: "2528",
    description:
      "Natural borates and concentrates thereof (whether or not calcined), but not including borates separated from natural brine; natural boric acid containing not more than 85 % of H3BO3 calculated on the dry weight",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252800",
    description:
      "Natural borates and concentrates thereof (whether or not calcined), but not including borates separated from natural brine; natural boric acid containing not more than 85 % of H3BO3 calculated on the dry weight",
    parent: "2528",
    level: "6",
  },
  {
    section: "V",
    hscode: "2529",
    description:
      "Feldspar; leucite; nepheline and nepheline syenite; fluorspar",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "252910",
    description: "Feldspar",
    parent: "2529",
    level: "6",
  },
  {
    section: "V",
    hscode: "252921",
    description:
      "Fluorspar; containing by weight 97% or less of calcium fluoride",
    parent: "2529",
    level: "6",
  },
  {
    section: "V",
    hscode: "252922",
    description:
      "Fluorspar; containing by weight more than 97% of calcium fluoride",
    parent: "2529",
    level: "6",
  },
  {
    section: "V",
    hscode: "252930",
    description: "Leucite; nepheline and nepheline syenite",
    parent: "2529",
    level: "6",
  },
  {
    section: "V",
    hscode: "2530",
    description: "Mineral substances not elsewhere specified or included",
    parent: "25",
    level: "4",
  },
  {
    section: "V",
    hscode: "253010",
    description: "Vermiculite, perlite and chlorites; unexpanded",
    parent: "2530",
    level: "6",
  },
  {
    section: "V",
    hscode: "253020",
    description: "Kieserite, epsomite (natural magnesium sulphates)",
    parent: "2530",
    level: "6",
  },
  {
    section: "V",
    hscode: "253090",
    description: "Mineral substances; n.e.c. in chapter 25",
    parent: "2530",
    level: "6",
  },
  {
    section: "V",
    hscode: "26",
    description: "Ores, slag and ash",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "V",
    hscode: "2601",
    description: "Iron ores and concentrates; including roasted iron pyrites",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260111",
    description: "Iron ores and concentrates; non-agglomerated",
    parent: "2601",
    level: "6",
  },
  {
    section: "V",
    hscode: "260112",
    description:
      "Iron ores and concentrates; agglomerated (excluding roasted iron pyrites)",
    parent: "2601",
    level: "6",
  },
  {
    section: "V",
    hscode: "260120",
    description: "Iron pyrites; roasted",
    parent: "2601",
    level: "6",
  },
  {
    section: "V",
    hscode: "2602",
    description:
      "Manganese ores and concentrates, including ferruginous manganese ores and concentrates with a manganese content of 20% or more, calculated on the dry weight",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260200",
    description:
      "Manganese ores and concentrates, including ferruginous manganese ores and concentrates with a manganese content of 20% or more, calculated on the dry weight",
    parent: "2602",
    level: "6",
  },
  {
    section: "V",
    hscode: "2603",
    description: "Copper ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260300",
    description: "Copper ores and concentrates",
    parent: "2603",
    level: "6",
  },
  {
    section: "V",
    hscode: "2604",
    description: "Nickel ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260400",
    description: "Nickel ores and concentrates",
    parent: "2604",
    level: "6",
  },
  {
    section: "V",
    hscode: "2605",
    description: "Cobalt ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260500",
    description: "Cobalt ores and concentrates",
    parent: "2605",
    level: "6",
  },
  {
    section: "V",
    hscode: "2606",
    description: "Aluminium ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260600",
    description: "Aluminium ores and concentrates",
    parent: "2606",
    level: "6",
  },
  {
    section: "V",
    hscode: "2607",
    description: "Lead ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260700",
    description: "Lead ores and concentrates",
    parent: "2607",
    level: "6",
  },
  {
    section: "V",
    hscode: "2608",
    description: "Zinc ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260800",
    description: "Zinc ores and concentrates",
    parent: "2608",
    level: "6",
  },
  {
    section: "V",
    hscode: "2609",
    description: "Tin ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "260900",
    description: "Tin ores and concentrates",
    parent: "2609",
    level: "6",
  },
  {
    section: "V",
    hscode: "2610",
    description: "Chromium ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261000",
    description: "Chromium ores and concentrates",
    parent: "2610",
    level: "6",
  },
  {
    section: "V",
    hscode: "2611",
    description: "Tungsten ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261100",
    description: "Tungsten ores and concentrates",
    parent: "2611",
    level: "6",
  },
  {
    section: "V",
    hscode: "2612",
    description: "Uranium or thorium ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261210",
    description: "Uranium ores and concentrates",
    parent: "2612",
    level: "6",
  },
  {
    section: "V",
    hscode: "261220",
    description: "Thorium ores and concentrates",
    parent: "2612",
    level: "6",
  },
  {
    section: "V",
    hscode: "2613",
    description: "Molybdenum ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261310",
    description: "Molybdenum ores and concentrates; roasted",
    parent: "2613",
    level: "6",
  },
  {
    section: "V",
    hscode: "261390",
    description: "Molybdenum ores and concentrates; other than roasted",
    parent: "2613",
    level: "6",
  },
  {
    section: "V",
    hscode: "2614",
    description: "Titanium ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261400",
    description: "Titanium ores and concentrates",
    parent: "2614",
    level: "6",
  },
  {
    section: "V",
    hscode: "2615",
    description:
      "Niobium, tantalum, vanadium or zirconium ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261510",
    description: "Zirconium ores and concentrates",
    parent: "2615",
    level: "6",
  },
  {
    section: "V",
    hscode: "261590",
    description: "Niobium, tantalum, vanadium ores and concentrates",
    parent: "2615",
    level: "6",
  },
  {
    section: "V",
    hscode: "2616",
    description: "Precious metal ores and concentrates",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261610",
    description: "Silver ores and concentrates",
    parent: "2616",
    level: "6",
  },
  {
    section: "V",
    hscode: "261690",
    description: "Precious metal ores and concentrates; (excluding silver)",
    parent: "2616",
    level: "6",
  },
  {
    section: "V",
    hscode: "2617",
    description: "Ores and concentrates; n.e.c. in heading no. 2601",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261710",
    description: "Antimony ores and concentrates",
    parent: "2617",
    level: "6",
  },
  {
    section: "V",
    hscode: "261790",
    description:
      "Ores and concentrates n.e.c. in chapter 26; other than antimony",
    parent: "2617",
    level: "6",
  },
  {
    section: "V",
    hscode: "2618",
    description:
      "Granulated slag (slag sand) from the manufacture of iron or steel",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261800",
    description:
      "Slag, granulated (slag sand); from the manufacture or iron or steel",
    parent: "2618",
    level: "6",
  },
  {
    section: "V",
    hscode: "2619",
    description:
      "Slag, dross; (other than granulated slag), scalings and other waste from the manufacture of iron or steel",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "261900",
    description:
      "Slag, dross; (other than granulated slag), scalings and other waste from the manufacture of iron or steel",
    parent: "2619",
    level: "6",
  },
  {
    section: "V",
    hscode: "2620",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel) containing metals, arsenic or their compounds",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "262011",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly zinc, hard zinc spelter",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262019",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly zinc, other than hard zinc spelter",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262021",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly lead; leaded gasoline sludges and leaded anti-knock compound sludges",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262029",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly lead; excluding leaded gasoline sludges and leaded anti-knock compound sludges",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262030",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly copper",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262040",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly aluminium",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262060",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing arsenic, mercury, thallium or their mixtures, of a kind used for the extraction of arsenic or those metals or for the manufacture of their chemical compounds",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262091",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing antimony, beryllium, cadmium, chromium or their mixtures",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "262099",
    description:
      "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly metals or their compounds, n.e.c. in heading no. 2620",
    parent: "2620",
    level: "6",
  },
  {
    section: "V",
    hscode: "2621",
    description:
      "Slag and ash n.e.c. in chapter 26; including seaweed ash (kelp) and ash and residues from the incineration of municipal waste",
    parent: "26",
    level: "4",
  },
  {
    section: "V",
    hscode: "262110",
    description:
      "Slag and ash; ash and residues from the incineration of municipal waste",
    parent: "2621",
    level: "6",
  },
  {
    section: "V",
    hscode: "262190",
    description:
      "Slag and ash n.e.c. in chapter 26; including seaweed ash (kelp) but excluding ash and residues from the incineration of municipal waste",
    parent: "2621",
    level: "6",
  },
  {
    section: "V",
    hscode: "27",
    description:
      "Mineral fuels, mineral oils and products of their distillation; bituminous substances; mineral waxes",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "V",
    hscode: "2701",
    description:
      "Coal; briquettes, ovoids and similar solid fuels manufactured from coal",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270111",
    description:
      "Coal; anthracite, whether or not pulverised, but not agglomerated",
    parent: "2701",
    level: "6",
  },
  {
    section: "V",
    hscode: "270112",
    description:
      "Coal; bituminous, whether or not pulverised, but not agglomerated",
    parent: "2701",
    level: "6",
  },
  {
    section: "V",
    hscode: "270119",
    description:
      "Coal; (other than anthracite and bituminous), whether or not pulverised but not agglomerated",
    parent: "2701",
    level: "6",
  },
  {
    section: "V",
    hscode: "270120",
    description:
      "Briquettes, ovoids and similar solid fuels; manufactured from coal",
    parent: "2701",
    level: "6",
  },
  {
    section: "V",
    hscode: "2702",
    description: "Lignite; whether or not agglomerated, excluding jet",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270210",
    description:
      "Lignite; whether or not pulverised, but not agglomerated, excluding jet",
    parent: "2702",
    level: "6",
  },
  {
    section: "V",
    hscode: "270220",
    description: "Lignite; agglomerated, excluding jet",
    parent: "2702",
    level: "6",
  },
  {
    section: "V",
    hscode: "2703",
    description: "Peat; (including peat litter), whether or not agglomerated",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270300",
    description: "Peat; (including peat litter), whether or not agglomerated",
    parent: "2703",
    level: "6",
  },
  {
    section: "V",
    hscode: "2704",
    description:
      "Coke and semi-coke; of coal, lignite or peat, whether or not agglomerated; retort carbon",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270400",
    description:
      "Coke and semi-coke; of coal, lignite or peat, whether or not agglomerated; retort carbon",
    parent: "2704",
    level: "6",
  },
  {
    section: "V",
    hscode: "2705",
    description:
      "Coal gas, water gas, producer gas and similar gases, other than petroleum gases and other gaseous hydrocarbons",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270500",
    description:
      "Gases; coal, water, producer and similar gases (excluding petroleum and other gaseous hydrocarbons)",
    parent: "2705",
    level: "6",
  },
  {
    section: "V",
    hscode: "2706",
    description:
      "Tar distilled from coal, from lignite, peat and other mineral tars, whether or not dehydrated or partially distilled; including reconstituted tars",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270600",
    description:
      "Tar; distilled from coal, lignite or peat, and other mineral tars, whether or not dehydrated or partially distilled, including reconstituted tars",
    parent: "2706",
    level: "6",
  },
  {
    section: "V",
    hscode: "2707",
    description:
      "Oils and other products of the distillation of high temperature coal tar; similar products in which the weight of the aromatic constituents exceeds that of the non-aromatic constituents",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270710",
    description:
      "Oils and products of the distillation of high temperature coal tar; benzol (benzene)",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "270720",
    description:
      "Oils and products of the distillation of high temperature coal tar; toluol (toluene)",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "270730",
    description:
      "Oils and products of the distillation of high temperature coal tar; xylol (xylenes)",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "270740",
    description:
      "Oils and products of the distillation of high temperature coal tar; naphthalene",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "270750",
    description:
      "Aromatic hydrocarbon mixtures; n.e.c. in heading no. 2707, of which 65% or more by volume (including losses) distils at 250 degrees Celsius by the ISO 3405 method (equivalent to the ASTM D 86 method)",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "270791",
    description:
      "Oils and other products of the distillation of high temperature coal tar; creosote oils",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "270799",
    description:
      "Oils and other products of the distillation of high temperature coal tar; n.e.c. in heading no. 2707",
    parent: "2707",
    level: "6",
  },
  {
    section: "V",
    hscode: "2708",
    description:
      "Pitch and pitch coke; obtained from coal tar or from other mineral tars",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270810",
    description: "Pitch; obtained from coal tar or from other mineral tars",
    parent: "2708",
    level: "6",
  },
  {
    section: "V",
    hscode: "270820",
    description:
      "Pitch coke; obtained from coal tar or from other mineral tars",
    parent: "2708",
    level: "6",
  },
  {
    section: "V",
    hscode: "2709",
    description:
      "Petroleum oils and oils obtained from bituminous minerals; crude",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "270900",
    description:
      "Oils; petroleum oils and oils obtained from bituminous minerals, crude",
    parent: "2709",
    level: "6",
  },
  {
    section: "V",
    hscode: "2710",
    description:
      "Petroleum oils and oils from bituminous minerals, not crude; preparations n.e.c, containing by weight 70% or more of petroleum oils or oils from bituminous minerals; these being the basic constituents of the preparations; waste oils",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271012",
    description:
      "Petroleum oils and oils from bituminous minerals, not containing biodiesel, not crude, not waste oils; preparations n.e.c, containing by weight 70% or more of petroleum oils or oils from bituminous minerals; light oils and preparations",
    parent: "2710",
    level: "6",
  },
  {
    section: "V",
    hscode: "271019",
    description:
      "Petroleum oils and oils from bituminous minerals, not containing biodiesel, not crude, not waste oils; preparations n.e.c, containing by weight 70% or more of petroleum oils or oils from bituminous minerals; not light oils and preparations",
    parent: "2710",
    level: "6",
  },
  {
    section: "V",
    hscode: "271020",
    description:
      "Petroleum oils and oils from bituminous minerals, containing biodiesel, not crude, not waste oils; preparations n.e.c, containing by weight 70% or more of petroleum oils or oils from bituminous minerals",
    parent: "2710",
    level: "6",
  },
  {
    section: "V",
    hscode: "271091",
    description:
      "Waste Oils; of petroleum or obtained from bituminous minerals, not crude; and preparations n.e.c., weight 70% or preparations of the same, containing polychlorinated biphenyls (PCBs), polychorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
    parent: "2710",
    level: "6",
  },
  {
    section: "V",
    hscode: "271099",
    description:
      "Waste Oils; of petroleum or obtained from bituminous minerals, not crude and preparations n.e.c., weight 70% or preparations of the same, not containing polychlorinated biphenyls (PCBs), polychorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
    parent: "2710",
    level: "6",
  },
  {
    section: "V",
    hscode: "2711",
    description: "Petroleum gases and other gaseous hydrocarbons",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271111",
    description:
      "Petroleum gases and other gaseous hydrocarbons; liquefied, natural gas",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "271112",
    description:
      "Petroleum gases and other gaseous hydrocarbons; liquefied, propane",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "271113",
    description:
      "Petroleum gases and other gaseous hydrocarbons; liquefied, butanes",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "271114",
    description:
      "Petroleum gases and other gaseous hydrocarbons; liquefied, ethylene, propylene, butylene and butadiene",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "271119",
    description:
      "Petroleum gases and other gaseous hydrocarbons; liquefied, n.e.c. in heading no. 2711",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "271121",
    description:
      "Petroleum gases and other gaseous hydrocarbons; in gaseous state, natural gas",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "271129",
    description:
      "Petroleum gases and other gaseous hydrocarbons; in gaseous state, other than natural gas",
    parent: "2711",
    level: "6",
  },
  {
    section: "V",
    hscode: "2712",
    description:
      "Petroleum jelly; paraffin wax, micro-crystalline petroleum wax, slack wax, ozokerite, lignite wax, peat wax, other mineral waxes, similar products obtained by synthesis, other processes; coloured or not",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271210",
    description: "Petroleum jelly",
    parent: "2712",
    level: "6",
  },
  {
    section: "V",
    hscode: "271220",
    description:
      "Paraffin wax; containing by weight less than 0.75% of oil, obtained by synthesis or by other processes, whether or not coloured",
    parent: "2712",
    level: "6",
  },
  {
    section: "V",
    hscode: "271290",
    description:
      "Paraffin wax; containing by weight 0.75% or more of oil, obtained by synthesis or by other processes, whether or not coloured",
    parent: "2712",
    level: "6",
  },
  {
    section: "V",
    hscode: "2713",
    description:
      "Petroleum coke, petroleum bitumen; other residues of petroleum oils or oils obtained from bituminous minerals",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271311",
    description:
      "Petroleum coke; (not calcined), obtained from bituminous minerals",
    parent: "2713",
    level: "6",
  },
  {
    section: "V",
    hscode: "271312",
    description: "Petroleum coke; calcined, obtained from bituminous minerals",
    parent: "2713",
    level: "6",
  },
  {
    section: "V",
    hscode: "271320",
    description: "Petroleum bitumen; obtained from bituminous minerals",
    parent: "2713",
    level: "6",
  },
  {
    section: "V",
    hscode: "271390",
    description:
      "Residues; of petroleum oils or of oils obtained from bituminous minerals",
    parent: "2713",
    level: "6",
  },
  {
    section: "V",
    hscode: "2714",
    description:
      "Bitumen and asphalt, natural; bituminous or oil shale and tar sands; asphaltites and asphaltic rocks",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271410",
    description: "Bituminous or oil shale and tar sands",
    parent: "2714",
    level: "6",
  },
  {
    section: "V",
    hscode: "271490",
    description: "Bitumen and asphalt, natural; asphaltites and asphaltic rock",
    parent: "2714",
    level: "6",
  },
  {
    section: "V",
    hscode: "2715",
    description:
      "Bituminous mixtures based on natural asphalt; on natural bitumen, on petroleum bitumen, on mineral tar or on mineral tar pitch (e.g. bituminous mastics, cut-backs)",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271500",
    description:
      "Bituminous mixtures based on natural asphalt, on natural bitumen, on petroleum bitumen, on mineral tar or on mineral tar pitch (e.g. bituminous mastics, cut-backs)",
    parent: "2715",
    level: "6",
  },
  {
    section: "V",
    hscode: "2716",
    description: "Electrical energy",
    parent: "27",
    level: "4",
  },
  {
    section: "V",
    hscode: "271600",
    description: "Electrical energy",
    parent: "2716",
    level: "6",
  },
  {
    section: "VI",
    hscode: "28",
    description:
      "Inorganic chemicals; organic and inorganic compounds of precious metals; of rare earth metals, of radio-active elements and of isotopes",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "2801",
    description: "Fluorine, chlorine, bromine and iodine",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280110",
    description: "Chlorine",
    parent: "2801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280120",
    description: "Iodine",
    parent: "2801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280130",
    description: "Fluorine; bromine",
    parent: "2801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2802",
    description: "Sulphur; sublimed or precipitated, colloidal sulphur",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280200",
    description: "Sulphur; sublimed or precipitated, colloidal sulphur",
    parent: "2802",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2803",
    description: "Carbon; carbon blacks and other forms of carbon n.e.c.",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280300",
    description: "Carbon; carbon blacks and other forms of carbon n.e.c.",
    parent: "2803",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2804",
    description: "Hydrogen, rare gases and other non-metals",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280410",
    description: "Hydrogen",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280421",
    description: "Gases, rare; argon",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280429",
    description: "Gases, rare; other than argon",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280430",
    description: "Nitrogen",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280440",
    description: "Oxygen",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280450",
    description: "Boron; tellurium",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280461",
    description:
      "Silicon; containing by weight not less than 99.99% of silicon",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280469",
    description: "Silicon; containing by weight less than 99.99% of silicon",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280470",
    description: "Phosphorus",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280480",
    description: "Arsenic",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280490",
    description: "Selenium",
    parent: "2804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2805",
    description:
      "Alkali or alkaline-earth metals; rare-earth metals, scandium and yttrium, whether or not intermixed or interalloyed; mercury",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280511",
    description: "Alkali or alkali-earth metals; sodium",
    parent: "2805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280512",
    description: "Alkali or alkali-earth metals; calcium",
    parent: "2805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280519",
    description: "Alkali or alkali-earth metals; other than sodium and calcium",
    parent: "2805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280530",
    description:
      "Earth-metals, rare; scandium and yttrium, whether or not intermixed or interalloyed",
    parent: "2805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280540",
    description: "Mercury",
    parent: "2805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2806",
    description: "Hydrogen chloride (hydrochloric acid); chlorosulphuric acid",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280610",
    description: "Hydrogen chloride (hydrochloric acid)",
    parent: "2806",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280620",
    description: "Chlorosulphuric acid",
    parent: "2806",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2807",
    description: "Sulphuric acid; oleum",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280700",
    description: "Sulphuric acid; oleum",
    parent: "2807",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2808",
    description: "Nitric acid; sulphonitric acids",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280800",
    description: "Nitric acid; sulphonitric acids",
    parent: "2808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2809",
    description:
      "Diphosphorus pentaoxide; phosphoric acid; polyphosphoric acids, whether or not chemically defined",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "280910",
    description: "Diphosphorus pentoxide",
    parent: "2809",
    level: "6",
  },
  {
    section: "VI",
    hscode: "280920",
    description: "Phosphoric acid and polyphosphoric acids",
    parent: "2809",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2810",
    description: "Oxides of boron; boric acids",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281000",
    description: "Oxides of boron; boric acids",
    parent: "2810",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2811",
    description:
      "Inorganic acids and other inorganic oxygen compounds of non-metals; n.e.c. in heading no. 2806 to 2810",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281111",
    description: "Hydrogen fluoride (hydrofluoric acid)",
    parent: "2811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281112",
    description: "Hydrogen cyanide (hydrocyanic acid)",
    parent: "2811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281119",
    description: "Inorganic acids; other than hydrogen fluoride",
    parent: "2811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281121",
    description: "Carbon dioxide",
    parent: "2811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281122",
    description: "Silicon dioxide",
    parent: "2811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281129",
    description:
      "Inorganic oxygen compounds; of non-metals, n.e.c. in item no. 2811.2",
    parent: "2811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2812",
    description: "Halides and halide oxides of non-metals",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281211",
    description: "Carbonyl dichloride (phosgene)",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281212",
    description: "Phosphorus oxychloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281213",
    description: "Phosphorus trichloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281214",
    description: "Phosphorus pentachloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281215",
    description: "Sulphur monochloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281216",
    description: "Sulphur dichloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281217",
    description: "Thionyl chloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281219",
    description:
      "Arsenic trichloride and other chlorides and chloride oxides, n.e.c. in item no. 2812",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281290",
    description: "Halides and halide oxides of non-metals; excluding chloride",
    parent: "2812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2813",
    description: "Sulphides of non-metals; commercial phosphorus trisulphide",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281310",
    description: "Carbon disulphide",
    parent: "2813",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281390",
    description:
      "Sulphides of non-metals, (excluding carbon); commercial phosphorus trisulphide",
    parent: "2813",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2814",
    description: "Ammonia; anhydrous or in aqueous solution",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281410",
    description: "Ammonia; anhydrous",
    parent: "2814",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281420",
    description: "Ammonia; in aqueous solution",
    parent: "2814",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2815",
    description:
      "Sodium hydroxide (caustic soda); potassium hydroxide (caustic potash) peroxides of sodium or potassium",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281511",
    description: "Sodium hydroxide (caustic soda); solid",
    parent: "2815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281512",
    description:
      "Sodium hydroxide (caustic soda); in aqueous solution (soda lye or liquid soda)",
    parent: "2815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281520",
    description: "Potassium hydroxide (caustic potash)",
    parent: "2815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281530",
    description: "Peroxides of sodium or potassium",
    parent: "2815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2816",
    description:
      "Hydroxide and peroxide of magnesium; oxides, hydroxides and peroxides of strontium or barium",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281610",
    description: "Hydroxide and peroxide of magnesium",
    parent: "2816",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281640",
    description: "Oxides, hydroxides and peroxides, of strontium or barium",
    parent: "2816",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2817",
    description: "Zinc; oxide and peroxide",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281700",
    description: "Zinc; oxide and peroxide",
    parent: "2817",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2818",
    description:
      "Aluminium oxide (including artificial corundum); aluminium hydroxide",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281810",
    description: "Aluminium oxide; artificial corundum",
    parent: "2818",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281820",
    description: "Aluminium oxide; other than artificial corundum",
    parent: "2818",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281830",
    description: "Aluminium hydroxide",
    parent: "2818",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2819",
    description: "Chromium oxides and hydroxides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "281910",
    description: "Chromium trioxide",
    parent: "2819",
    level: "6",
  },
  {
    section: "VI",
    hscode: "281990",
    description: "Chromium oxides and hydroxides; excluding chromium trioxide",
    parent: "2819",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2820",
    description: "Manganese oxides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282010",
    description: "Manganese dioxide",
    parent: "2820",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282090",
    description: "Manganese oxides; excluding manganese dioxide",
    parent: "2820",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2821",
    description:
      "Iron oxides and hydroxides; earth colours containing 70% or more by weight of combined iron evaluated as Fe2o3",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282110",
    description: "Iron oxides and hydroxides",
    parent: "2821",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282120",
    description:
      "Earth colours; containing 70% or more by weight of combined iron evaluated as Fe2o3",
    parent: "2821",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2822",
    description: "Cobalt oxides and hydroxides; commercial cobalt oxides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282200",
    description: "Cobalt oxides and hydroxides; commercial cobalt oxides",
    parent: "2822",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2823",
    description: "Titanium oxides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282300",
    description: "Titanium oxides",
    parent: "2823",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2824",
    description: "Lead oxides; red lead and orange lead",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282410",
    description: "Lead; lead monoxide (litharge, massicot)",
    parent: "2824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282490",
    description: "Lead oxides; n.e.c. in heading no. 2824",
    parent: "2824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2825",
    description:
      "Hydrazine and hydroxylamine and their inorganic salts; other inorganic bases; other metal oxides, hydroxides and peroxides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282510",
    description: "Hydrazine and hydroxylamine and their inorganic salts",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282520",
    description: "Lithium oxide and hydroxide",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282530",
    description: "Vanadium oxides and hydroxides",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282540",
    description: "Nickel oxides and hydroxides",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282550",
    description: "Copper oxides and hydroxides",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282560",
    description: "Germanium oxides and zirconium dioxide",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282570",
    description: "Molybdenum oxides and hydroxides",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282580",
    description: "Antimony oxides",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282590",
    description:
      "Inorganic bases, metal oxides, hydroxides and peroxides; n.e.c. in heading no. 2825",
    parent: "2825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2826",
    description:
      "Fluorides; fluorosilicates, fluoroaluminates and other complex fluorine salts",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282612",
    description: "Fluorides; of aluminium",
    parent: "2826",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282619",
    description: "Fluorides; other than of aluminium",
    parent: "2826",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282630",
    description: "Sodium hexafluoroaluminate (synthetic cryolite)",
    parent: "2826",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282690",
    description:
      "Fluorides; fluorosilicates, fluoroaluminates and other complex fluorine salts, n.e.c. in heading no. 2826",
    parent: "2826",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2827",
    description:
      "Chlorides; chloride oxides and chloride hydroxides; bromides and bromide oxides; iodides and iodide oxides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282710",
    description: "Chlorides; of ammonium",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282720",
    description: "Chlorides; of calcium",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282731",
    description: "Chlorides; of magnesium",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282732",
    description: "Chlorides; of aluminium",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282735",
    description: "Chlorides; of nickel",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282739",
    description:
      "Chlorides; other than of ammonium, calcium, magnesium, aluminium and nickel",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282741",
    description: "Chloride oxides and chloride hydroxides; of copper",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282749",
    description:
      "Chloride oxides and chloride hydroxides; other than of copper",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282751",
    description: "Bromides; of sodium or of potassium",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282759",
    description: "Bromides and bromide oxides; other than item no. 2827.51",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282760",
    description: "Iodides and iodide oxides",
    parent: "2827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2828",
    description:
      "Hypochlorites; commercial calcium hypochlorite; chlorites; hypobromites",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282810",
    description:
      "Hypochlorites; commercial calcium hypochlorite and other calcium hypochlorites",
    parent: "2828",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282890",
    description: "Hypochlorites; n.e.c. in heading no. 2828",
    parent: "2828",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2829",
    description:
      "Chlorates and perchlorates; bromates and perbromates; iodates and periodates",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "282911",
    description: "Chlorates; of sodium",
    parent: "2829",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282919",
    description: "Chlorates; other than sodium",
    parent: "2829",
    level: "6",
  },
  {
    section: "VI",
    hscode: "282990",
    description:
      "Perchlorates; bromates and perbromates; iodates and periodates",
    parent: "2829",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2830",
    description: "Sulphides; polysulphides whether or not chemically defined",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283010",
    description: "Sulphides; of sodium, whether or not chemically defined",
    parent: "2830",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283090",
    description:
      "Sulphides and polysulphides; whether or not chemically defined, other than sulphides of sodium",
    parent: "2830",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2831",
    description: "Dithionites and sulphoxylates",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283110",
    description: "Dithionites and sulphoxylates; of sodium",
    parent: "2831",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283190",
    description: "Dithionites and sulphoxylates; other than sodium",
    parent: "2831",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2832",
    description: "Sulphites; thiosulphates",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283210",
    description: "Sulphites; of sodium",
    parent: "2832",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283220",
    description: "Sulphites; other than of sodium",
    parent: "2832",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283230",
    description: "Thiosulphates",
    parent: "2832",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2833",
    description: "Sulphates; alums; peroxosulphates (persulphates)",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283311",
    description: "Sodium sulphates; disodium sulphate",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283319",
    description: "Sodium sulphates; other than disodium sulphate",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283321",
    description: "Sulphates; of magnesium",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283322",
    description: "Sulphates; of aluminium",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283324",
    description: "Sulphates; of nickel",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283325",
    description: "Sulphates; of copper",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283327",
    description: "Sulphates; of barium",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283329",
    description: "Sulphates; n.e.c. in item no. 2833.2",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283330",
    description: "Alums",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283340",
    description: "Peroxosulphates (persulphates)",
    parent: "2833",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2834",
    description: "Nitrites; nitrates",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283410",
    description: "Nitrites",
    parent: "2834",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283421",
    description: "Nitrates; of potassium",
    parent: "2834",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283429",
    description: "Nitrates; of other than potassium",
    parent: "2834",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2835",
    description:
      "Phosphinates (hypophosphites), phosphonates (phosphites), and phosphates; and polyphosphates, whether or not chemically defined",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283510",
    description:
      "Phosphinates (hypophosphites) and phosphonates (phosphites), whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283522",
    description:
      "Phosphates; of mono- or disodium, whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283524",
    description: "Phosphates; of potassium, whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283525",
    description:
      "Phosphates; calcium hydrogenorthophosphate (dicalcium phosphate), whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283526",
    description:
      "Phosphates; of calcium n.e.c. in item no. 2835.25, whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283529",
    description:
      "Phosphates; (other than of mono- or disodium, other than of potassium or of calcium hydrogenorthophosphate (dicalcium phosphate) and excluding other phosphates of calcium), whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283531",
    description:
      "Polyphosphates; sodium triphosphate (sodium tripolyphosphate), whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283539",
    description:
      "Polyphosphates; other than sodium triphosphate (sodium tripolyphosphate), whether or not chemically defined",
    parent: "2835",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2836",
    description:
      "Carbonates; peroxocarbonates (percarbonates); commercial ammonium carbonate containing ammonium carbamate",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283620",
    description: "Carbonates; disodium carbonate",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283630",
    description: "Carbonates; sodium hydrogen carbonate (sodium bicarbonate)",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283640",
    description: "Carbonates; potassium carbonate",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283650",
    description: "Carbonates; calcium carbonate",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283660",
    description: "Carbonates; barium carbonate",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283691",
    description: "Carbonates; lithium carbonate",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283692",
    description: "Carbonates; strontium carbonate",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283699",
    description:
      "Carbonates; n.e.c. in heading no. 2836 and other than lithium or strontium",
    parent: "2836",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2837",
    description: "Cyanides, cyanide oxides and complex cyanides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283711",
    description: "Cyanides and cyanide oxides; of sodium",
    parent: "2837",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283719",
    description: "Cyanides and cyanide oxides; other than of sodium",
    parent: "2837",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283720",
    description: "Complex cyanides",
    parent: "2837",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2839",
    description: "Silicates; commercial alkali metal silicates",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "283911",
    description: "Silicates; sodium metasilicates",
    parent: "2839",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283919",
    description: "Silicates; of sodium (excluding sodium metasilicates)",
    parent: "2839",
    level: "6",
  },
  {
    section: "VI",
    hscode: "283990",
    description:
      "Silicates; commercial alkali metal silicates, other than of sodium",
    parent: "2839",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2840",
    description: "Borates; peroxoborates (perborates)",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284011",
    description: "Borates; disodium tetraborate (refined borax), anhydrous",
    parent: "2840",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284019",
    description:
      "Borates; disodium tetraborate (refined borax), other than anhydrous",
    parent: "2840",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284020",
    description: "Borates; n.e.c. in heading no. 2840",
    parent: "2840",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284030",
    description: "Peroxoborates (perborates)",
    parent: "2840",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2841",
    description: "Salts of oxometallic or peroxometallic acids",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284130",
    description: "Salts; sodium dichromate",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284150",
    description:
      "Salts; chromates, dichromates, peroxochromates; n.e.c. in heading no. 2841",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284161",
    description:
      "Salts; of oxometallic or peroxometallic acids, manganites, manganates and permanganates, potassium permanganate",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284169",
    description:
      "Salts; of oxometallic or peroxometallic acids, manganites, manganates and permanganates, other than potassium permanganate",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284170",
    description: "Salts; molybdates",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284180",
    description: "Salts; tungstates (wolframates)",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284190",
    description:
      "Salts of oxometallic or peroxometallic acids; n.e.c. in heading no. 2841",
    parent: "2841",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2842",
    description:
      "Salts of inorganic acids or peroxoacids, n.e.c. including aluminosilicates whether or not chemically defined, but excluding azides",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284210",
    description:
      "Salts of inorganic acids or peroxoacids, double or complex silicates, including aluminosilicates, whether or not chemically defined, excluding azides",
    parent: "2842",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284290",
    description:
      "Salts; of inorganic acids or peroxoacids, other than double or complex silicates, including aluminosilicates, whether or not chemically, excluding azides",
    parent: "2842",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2843",
    description:
      "Colloidal precious metals; inorganic or organic compounds of precious metals, whether or not chemically defined; amalgams of precious metals",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284310",
    description: "Colloidal precious metals; whether or not chemically defined",
    parent: "2843",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284321",
    description: "Silver compounds; silver nitrates",
    parent: "2843",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284329",
    description: "Silver compounds; excluding silver nitrates",
    parent: "2843",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284330",
    description: "Gold compounds",
    parent: "2843",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284390",
    description:
      "Inorganic or organic compounds of precious metals, n.e.c.; amalgams",
    parent: "2843",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2844",
    description:
      "Radioactive chemical elements and radioactive isotopes (including the fissile or fertile chemical elements and isotopes); and their compounds; mixtures and residues containing these products",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284410",
    description:
      "Uranium; natural uranium and its compounds, alloys, dispersions (including cermets), ceramic products and mixtures containing natural uranium or natural uranium compounds",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284420",
    description:
      "Uranium; enriched in U235, plutonium, their compounds, alloys dispersions (including cermets), ceramic products and mixtures containing uranium enriched in U235, plutonium or compounds of these products",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284430",
    description:
      "Uranium; depleted in U235, thorium, their compounds, alloys, dispersions (including cermets), ceramic products and mixtures containing uranium depleted in U235, thorium; compounds of these products",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284441",
    description:
      "Radioactive elements; tritium and its compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing tritium or its compounds",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284442",
    description:
      "Radioactive elements; actinium-225, 227, californium-253, curium-240, 241, 242, 243, 244, einsteinium-253, 254, gadolinium-148, polonium-208, 209, 210, radium-223, uranium-230 or 232, compounds; alloys, dispersions, ceramic products and mixtures",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284443",
    description:
      "Radioactive elements, isotopes and compounds; other alloys, dispersions (including cermets), ceramic products and mixtures containing these elements, isotopes or compounds",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284444",
    description:
      "Radioactive elements, isotopes, compounds n.e.c. in heading no. 2844, alloys, dispersions (including cermets), ceramic products, mixtures containing the elements, isotopes, compounds; radioactive residues",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284450",
    description:
      "Spent (irradiated) fuel elements (cartridges) of nuclear reactors",
    parent: "2844",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2845",
    description:
      "Isotopes other than those of heading no. 2844; compounds, inorganic or organic, of such isotopes, whether or not chemically defined",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284510",
    description: "Heavy water (deuterium oxide)",
    parent: "2845",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284520",
    description: "Boron enriched in boron-10 and its compounds",
    parent: "2845",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284530",
    description: "Lithium enriched in lithium-6 and its compounds",
    parent: "2845",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284540",
    description: "Helium-3",
    parent: "2845",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284590",
    description:
      "Isotopes other than those of heading no. 2844, 2845.20, 2845.30 or 2845.40; compounds, inorganic or organic, of such isotopes, whether or not chemically defined",
    parent: "2845",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2846",
    description:
      "Compounds, inorganic or organic, of rare-earth metals; of yttrium or of scandium or of mixtures of these metals",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284610",
    description: "Cerium compounds",
    parent: "2846",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284690",
    description:
      "Compounds, inorganic or organic (excluding cerium), of rare-earth metals, of yttrium, scandium or of mixtures of these metals",
    parent: "2846",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2847",
    description: "Hydrogen peroxide; whether or not solidified with urea",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284700",
    description: "Hydrogen peroxide; whether or not solidified with urea",
    parent: "2847",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2849",
    description: "Carbides, whether or not chemically defined",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "284910",
    description: "Carbides; of calcium, whether or not chemically defined",
    parent: "2849",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284920",
    description: "Carbides; of silicon, whether or not chemically defined",
    parent: "2849",
    level: "6",
  },
  {
    section: "VI",
    hscode: "284990",
    description:
      "Carbides; whether or not chemically defined, other than of calcium or silicon",
    parent: "2849",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2850",
    description:
      "Hydrides, nitrides, azides, silicides and borides, whether or not chemically defined, other than compounds which are also carbides of heading no. 2849",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "285000",
    description:
      "Hydrides, nitrides, azides, silicides and borides, whether or not chemically defined, other than compounds which are also carbides of heading no. 2849",
    parent: "2850",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2852",
    description:
      "Inorganic or organic compounds of mercury, excluding amalgams, whether or not chemically defined",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "285210",
    description:
      "Inorganic or organic compounds of mercury, excluding amalgams, chemically defined",
    parent: "2852",
    level: "6",
  },
  {
    section: "VI",
    hscode: "285290",
    description:
      "Inorganic or organic compounds of mercury; excluding amalgams, not chemically defined,",
    parent: "2852",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2853",
    description:
      "Phosphides, chemically defined or not, not ferrophosphorus; other inorganic compounds n.e.c. (including distilled, conductivity water and water of like purity); liquid air, rare gases removed or not; compressed air; amalgams, not precious metal amalgams",
    parent: "28",
    level: "4",
  },
  {
    section: "VI",
    hscode: "285310",
    description: "Inorganic compounds; cyanogen chloride (chlorcyan)",
    parent: "2853",
    level: "6",
  },
  {
    section: "VI",
    hscode: "285390",
    description:
      "Phosphides, chemically defined or not, not ferrophosphorus; other inorganic compounds n.e.c. (including distilled, conductivity water and water of like purity); liquid air, rare gases removed or not; compressed air; amalgams, not precious metal amalgams",
    parent: "2853",
    level: "6",
  },
  {
    section: "VI",
    hscode: "29",
    description: "Organic chemicals",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "2901",
    description: "Acyclic hydrocarbons",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290110",
    description: "Acyclic hydrocarbons; saturated",
    parent: "2901",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290121",
    description: "Acyclic hydrocarbons; unsaturated, ethylene",
    parent: "2901",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290122",
    description: "Acyclic hydrocarbons; unsaturated, propene (propylene)",
    parent: "2901",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290123",
    description:
      "Acyclic hydrocarbons; unsaturated, butene (butylene) and isomers thereof",
    parent: "2901",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290124",
    description:
      "Acyclic hydrocarbons; unsaturated, buta-1,3-diene and isoprene",
    parent: "2901",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290129",
    description:
      "Acyclic hydrocarbons; unsaturated, n.e.c. in heading no. 2901",
    parent: "2901",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2902",
    description: "Cyclic hydrocarbons",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290211",
    description: "Cyclic hydrocarbons; cyclohexane",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290219",
    description:
      "Cyclic hydrocarbons; cyclanes, cyclenes and cycloterpenes, excluding cyclohexane",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290220",
    description: "Cyclic hydrocarbons; benzene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290230",
    description: "Cyclic hydrocarbons; toluene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290241",
    description: "Cyclic hydrocarbons; o-xylene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290242",
    description: "Cyclic hydrocarbons; m-xylene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290243",
    description: "Cyclic hydrocarbons; p-xylene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290244",
    description: "Cyclic hydrocarbons; mixed xylene isomers",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290250",
    description: "Cyclic hydrocarbons; styrene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290260",
    description: "Cyclic hydrocarbons; ethylbenzene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290270",
    description: "Cyclic hydrocarbons; cumene",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290290",
    description: "Cyclic hydrocarbons; n.e.c. in heading no. 2902",
    parent: "2902",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2903",
    description: "Halogenated derivatives of hydrocarbons",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290311",
    description:
      "Saturated chlorinated derivatives of acyclic hydrocarbons; chloromethane (methyl chloride) and chloroethane (ethyl chloride)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290312",
    description:
      "Saturated chlorinated derivatives of acyclic hydrocarbons; dichloromethane (methylene chloride)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290313",
    description:
      "Saturated chlorinated derivatives of acyclic hydrocarbons; chloroform (trichloromethane)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290314",
    description:
      "Saturated chlorinated derivatives of acyclic hydrocarbons; carbon tetrachloride",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290315",
    description:
      "Saturated chlorinated derivatives of acyclic hydrocarbons; ethylene dichloride (ISO) (1,2-dichloroethane)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290319",
    description:
      "Saturated chlorinated derivatives of acyclic hydrocarbons; n.e.c. in item no. 2903.1",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290321",
    description:
      "Unsaturated chlorinated derivatives of acyclic hydrocarbons; vinyl chloride (chloroethylene)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290322",
    description:
      "Unsaturated chlorinated derivatives of acyclic hydrocarbons; trichloroethylene",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290323",
    description:
      "Unsaturated chlorinated derivatives of acyclic hydrocarbons; tetrachloroethylene (perchloroethylene)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290329",
    description:
      "Unsaturated chlorinated derivatives of acyclic hydrocarbons; n.e.c. in item no. 2903.2",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290341",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; trifluoromethane (HFC-23)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290342",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; difluoromethane (HFC-32)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290343",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; fluoromethane (HFC-41), 1,2-difluoroethane (HFC-152) and 1,1-difluoroethane (HFC-152a)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290344",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; pentafluoroethane (HFC-125), 1,1,1-trifluoroethane (HFC-143a) and 1,1,2-trifluoroethane (HFC-143)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290345",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; 1,1,1,2-tetrafluoroethane (HFC-134a) and 1,1,2,2-tetrafluoroethane (HFC-134)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290346",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; 1,1,1,2,3,3,3-heptafluoropropane (HFC-227ea), 1,1,1,2,2,3-hexafluoropropane (HFC-236cb), 1,1,1,2,3,3-hexafluoropropane (HFC-236ea) and 1,1,1,3,3,3-hexafluoropropane (HFC-236fa)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290347",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; 1,1,1,3,3-pentafluoropropane (HFC-245fa) and 1,1,2,2,3-pentafluoropropane (HFC-245ca)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290348",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; 1,1,1,3,3-pentafluorobutane (HFC-365mfc) and 1,1,1,2,2,3,4,5,5,5-decafluoropentane (HFC-43-10mee)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290349",
    description:
      "Saturated fluorinated derivatives of acyclic hydrocarbons; n.e.c. in item no 2903.4",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290351",
    description:
      "Unsaturated fluorinated derivatives of acyclic hydrocarbons; 2,3,3,3-tetrafluoropropene (HFO-1234yf), 1,3,3,3-tetrafluoropropene (HFO-1234ze) and (Z)-1,1,1,4,4,4-hexafluoro-2-butene (HFO-1336mzz)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290359",
    description:
      "Unsaturated fluorinated derivatives of acyclic hydrocarbons; n.e.c. in item no. 2903.5",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290361",
    description:
      "Brominated or iodinated derivatives of acyclic hydrocarbons; methyl bromide (bromomethane)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290362",
    description:
      "Brominated or iodinated derivatives of acyclic hydrocarbons; ethylene dibromide (ISO) (1,2-dibromoethane)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290369",
    description:
      "Brominated or iodinated derivatives of acyclic hydrocarbons; n.e.c. in item no. 2903.6",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290371",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; chlorodifluoromethane (HCFC-22)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290372",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichlorotrifluoroethane (HCFC-123)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290373",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichlorofluoroethanes (HCFC-141, 141b)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290374",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; chlorodifluoroethanes HCFC-142, 142b)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290375",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichloropentafluoropropanes (HCFC-225, 225ca, 225cb)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290376",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; bromochlorodifluoromethane (Halon-1211), bromotrifluoromethane (Halon-1301), and dibromotetrafluoroethanes (Halon-2402)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290377",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; n.e.c. in headings 290371 to 290376, perhalogenated only with fluorine and chlorine",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290378",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; perhalogenated derivatives, other than those only with fluorine and chlorine, n.e.c. in item no. 2903.71 to 2903.76",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290379",
    description:
      "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; n.e.c. in item no. 2903.7",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290381",
    description:
      "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; 1,2,3,4,5,6-Hexachlorocyclohexane (HCH (ISO)), including lindane (ISO, INN)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290382",
    description:
      "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; aldrin (ISO), chlordane (ISO), and heptachlor (ISO)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290383",
    description:
      "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; mirex (ISO)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290389",
    description:
      "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; n.e.c. in item no. 2903.8",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290391",
    description:
      "Halogenated derivatives of aromatic hydrocarbons; chlorobenzene, o-dichlorobenzene, and p-dichlorobenzene",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290392",
    description:
      "Halogenated derivatives of aromatic hydrocarbons; hexachlorobenzene (ISO) and DDT (ISO) (clofenotane (INN), and 1,1,1-trichloro-2,2-bis(p-chlorophenyl)ethane)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290393",
    description:
      "Halogenated derivatives of aromatic hydrocarbons; pentachlorobenzene (ISO)",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290394",
    description:
      "Halogenated derivatives of aromatic hydrocarbons; hexabromobiphenyls",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290399",
    description:
      "Halogenated derivatives of aromatic hydrocarbons; n.e.c. in item no. 2903.91, 2903.92, 2903.93 and 2903.94",
    parent: "2903",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2904",
    description:
      "Sulphonated, nitrated or nitrosated derivatives of hydrocarbons; whether or not halogenated",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290410",
    description:
      "Derivatives of hydrocarbons; containing only sulpho groups, their salts and ethyl esters, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290420",
    description:
      "Derivatives of hydrocarbons; containing only nitro or only nitroso groups, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290431",
    description:
      "Derivatives of hydrocarbons; perfluorooctane sulphonic acid, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290432",
    description:
      "Derivatives of hydrocarbons; ammonium perfluorooctane sulphonate, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290433",
    description:
      "Derivatives of hydrocarbons; lithium perfluorooctane sulphonate, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290434",
    description:
      "Derivatives of hydrocarbons; potassium perfluorooctane sulphonate, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290435",
    description:
      "Derivatives of hydrocarbons; salts of perfluorooctane sulphonic acid n.e.c in heading no. 2904, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290436",
    description:
      "Derivatives of hydrocarbons; perfluorooctane sulphonyl fluoride, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290491",
    description:
      "Derivatives of hydrocarbons; trichloronitromethane (chloropicrin), whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290499",
    description:
      "Derivatives of hydrocarbons n.e.c. in heading no. 2904, whether or not halogenated",
    parent: "2904",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2905",
    description:
      "Acyclic alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290511",
    description: "Alcohols; saturated monohydric, methanol (methyl alcohol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290512",
    description:
      "Alcohols; saturated monohydric, propan-1-ol (propyl alcohol) and propan-2-ol (isopropyl alcohol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290513",
    description: "Alcohols; saturated monohydric, butan-1-ol (n-butyl alcohol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290514",
    description:
      "Alcohols; saturated monohydric, butanols excluding item no. 2905.13",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290516",
    description:
      "Alcohols; saturated monohydric, octanol (octyl alcohol) and isomers thereof",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290517",
    description:
      "Alcohols; saturated monohydric, dodecan-1-ol (lauryl alcohol), hexadecan-1-ol (cetyl alcohol) and octadecan-1-ol (stearyl alcohol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290519",
    description: "Alcohols; saturated monohydric, n.e.c. in item no. 2905.1",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290522",
    description: "Alcohols; unsaturated monohydric, acyclic terpene alcohols",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290529",
    description:
      "Alcohols; acyclic, unsaturated monohydric, (other than acyclic terpene alcohols)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290531",
    description: "Alcohols; acyclic, diols; ethylene glycol (ethanediol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290532",
    description:
      "Alcohols; acyclic, diols; propylene glycol (propane-1, 2-diol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290539",
    description:
      "Alcohols; acyclic, diols, other than ethylene glycol (ethandiol) or propylene glycol (propane-1,2-diol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290541",
    description:
      "Alcohols; polyhydric, 2-ethyl-2- (hydroxymethyl) propane-1,3-diol (trimethylolpropane)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290542",
    description: "Alcohols; polyhydric, pentaerythritol",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290543",
    description: "Alcohols; polyhydric, mannitol",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290544",
    description: "Alcohols; polyhydric, d-glucitol (sorbitol)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290545",
    description: "Alcohols; polyhydric, glycerol",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290549",
    description: "Alcohols; polyhydric, n.e.c. in item no. 2905.4",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290551",
    description:
      "Alcohols; acyclic; halogenated, sulphonated, nitrated or nitrosated derivatives thereof, ethchlorvynol (INN)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290559",
    description:
      "Alcohols; acyclic; halogenated, sulphonated, nitrated or nitrosated derivatives thereof, other than ethchlorvynol (INN)",
    parent: "2905",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2906",
    description:
      "Alcohols; cyclic, and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290611",
    description:
      "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, menthol",
    parent: "2906",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290612",
    description:
      "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, cyclohexanol, methylcyclohexanols and dimethylcyclohexanols",
    parent: "2906",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290613",
    description:
      "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, sterols and inositols",
    parent: "2906",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290619",
    description:
      "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, n.e.c. in item no. 2906.1",
    parent: "2906",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290621",
    description: "Alcohols; aromatic alcohols and derivatives, benzyl alcohol",
    parent: "2906",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290629",
    description:
      "Alcohols; aromatic and derivatives, other than benzyl alcohol",
    parent: "2906",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2907",
    description: "Phenols; monophenols, polyphenols, and phenol-alcohols",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290711",
    description: "Monophenols; phenol (hydroxybenzene) and its salts",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290712",
    description: "Monophenols; cresols and their salts",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290713",
    description:
      "Monophenols; octylphenol, nonylphenol and their isomers, salts thereof",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290715",
    description: "Monophenols; naphthols and their salts",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290719",
    description: "Monophenols; n.e.c. in item no. 2907.1",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290721",
    description: "Polyphenols; resorcinol and its salts",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290722",
    description: "Polyphenols; hydroquinone (quinol) and its salts",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290723",
    description:
      "Polyphenols; 4,4'-isopropylidenediphenol (bisphenol A, diphenylolpropane) and its salts",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290729",
    description: "Phenol-alcohols and polyphenols n.e.c. in item number 2907.2",
    parent: "2907",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2908",
    description:
      "Phenols or phenol-alcohols; halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290811",
    description:
      "Phenol or phenol-alcohol derivatives containing only halogen substituents and their salts; pentachlorophenol (ISO)",
    parent: "2908",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290819",
    description:
      "Phenol or phenol-alcohol derivatives containing only halogen substituents and their salts; other than pentachlorophenol (ISO)",
    parent: "2908",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290891",
    description:
      "Phenol or phenol-alcohol derivatives, sulphonated, nitrated or nitrosated derivatives thereof; dinoseb (ISO) and its salts",
    parent: "2908",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290892",
    description:
      "Phenol or phenol-alcohol derivatives, sulphonated, nitrated or nitrosated derivatives thereof; 4,6-dinitro-o-cresol (DNOC (ISO)) and its salts",
    parent: "2908",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290899",
    description:
      "Phenol or phenol-alcohol derivatives, sulphonated, nitrated or nitrosated derivatives thereof; other than dinoseb (ISO), and 4,6-dinitro-o-cresol (DNOC (ISO)), and their salts",
    parent: "2908",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2909",
    description:
      "Ethers, ether-alcohols, ether-phenols, ether-alcohol-phenols, alcohol peroxides, ether peroxides, acetal and hemiacetal peroxides, ketone peroxides (chemically defined or not), and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "290911",
    description:
      "Ethers; acyclic, and their halogenated, sulphonated, nitrated or nitrosated derivatives, diethyl ether",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290919",
    description:
      "Ethers; acyclic, and their halogenated, sulphonated, nitrated or nitrosated derivatives, other than diethyl ether",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290920",
    description:
      "Ethers; cyclanic, cyclenic or cycloterpenic and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290930",
    description:
      "Ethers; aromatic, and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290941",
    description:
      "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; 2,2-oxydiethanol (diethylene glycol, digol)",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290943",
    description:
      "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; monobutyl ethers of ethylene glycol or of diethylene glycol",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290944",
    description:
      "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; monoalkylethers of ethylene glycol or of diethylene glycol n.e.c. in heading no. 2909",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290949",
    description:
      "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; n.e.c. in item no. 2909.4",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290950",
    description:
      "Ether-phenols, ether-alcohol-phenols and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "290960",
    description:
      "Alcohol peroxides, ether peroxides, acetal and hemiacetal peroxides, ketone peroxides and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "2909",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2910",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291010",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives; oxirane (ethylene oxide)",
    parent: "2910",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291020",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, methyloxirane (propylene oxide)",
    parent: "2910",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291030",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, 1-chloro-2,3-epoxypropane (epichlorohydrin)",
    parent: "2910",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291040",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, dieldrin (ISO, INN)",
    parent: "2910",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291050",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, endrin (ISO)",
    parent: "2910",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291090",
    description:
      "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2910",
    parent: "2910",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2911",
    description:
      "Acetals and hemiacetals; whether or not with other oxygen function, and their halogenated, sulphonated, nitrated or nitrostated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291100",
    description:
      "Acetals and hemiacetals; whether or not with other oxygen function, and their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "2911",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2912",
    description:
      "Aldehydes, whether or not with other oxygen function; cyclic polymers of aldehydes; paraformaldehyde",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291211",
    description:
      "Aldehydes; acyclic, without other oxygen function, methanal (formaldehyde)",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291212",
    description:
      "Aldehydes; acyclic, without other oxygen function, ethanal (acetaldehyde)",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291219",
    description:
      "Aldehydes; acyclic, without other oxygen function, n.e.c. in item no. 2912.1",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291221",
    description:
      "Aldehydes; cyclic, without other oxygen function, benzaldehyde",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291229",
    description:
      "Aldehydes; cyclic, without other oxygen function, other than benzaldehyde",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291241",
    description:
      "Aldehydes; aldehyde-ethers, aldehyde-phenols and aldehydes with other oxygen function, vanillin (4-hydroxy-3-methoxybenzaldehyde)",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291242",
    description:
      "Aldehydes; aldehyde-ethers, aldehyde-phenols and aldehydes with other oxygen function, ethylvanillin (3-ethoxy-4-hydroxybenzaldehyde)",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291249",
    description:
      "Aldehyde-alcohols, aldehyde-ethers, aldehyde-phenols and aldehydes with other oxygen function; other than vanillin (4-hydroxy-3-methoxybenzaldehyde) and ethylvanillin (3-ethoxy-4-hydroxybenzaldehyde)",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291250",
    description: "Aldehydes; cyclic polymers of aldehydes",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291260",
    description: "Paraformaldehyde",
    parent: "2912",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2913",
    description:
      "Aldehydes; halogenated, sulphonated, nitrated or nitrosated derivatives of products of heading no. 2912",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291300",
    description:
      "Aldehydes; halogenated, sulphonated, nitrated or nitrosated derivatives of products of heading no. 2912",
    parent: "2913",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2914",
    description:
      "Ketones and quinones; whether or not with other oxygen function, and their halogenated, sulphonated, nitrated or nitrostated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291411",
    description: "Ketones; acyclic, without other oxygen function, acetone",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291412",
    description:
      "Ketones; acyclic, without other oxygen function, butanone (methyl ethyl ketone)",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291413",
    description:
      "Ketones; acyclic, without other oxygen function, 4-methylpentan-2-one (methyl isobutyl ketone)",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291419",
    description:
      "Ketones; acyclic, without other oxygen function, n.e.c. in item no. 2914.1",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291422",
    description:
      "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, cyclohexanone and methylcyclohexanones",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291423",
    description:
      "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, ionones and methylionones",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291429",
    description:
      "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, other than cyclohexanone, methylcyclohexanones, ionones, and methylionones",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291431",
    description:
      "Ketones; aromatic, (without other oxygen function), phenylacetone (phenylpropan-2-one)",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291439",
    description:
      "Ketones; aromatic, (without other oxygen function), excluding phenylacetone (phenylpropan-2-one)",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291440",
    description: "Ketone-alcohols and ketone-aldehydes",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291450",
    description: "Ketone-phenols and ketones with other oxygen function",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291461",
    description: "Quinones; anthraquinone",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291462",
    description: "Quinones; coenzyme Q10 (ubidecarenone (INN))",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291469",
    description:
      "Quinones; other than anthraquinone and coenzyme Q10 (ubidecarenone (INN))",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291471",
    description:
      "Ketones and quinones; halogenated, sulphonated, nitrated or nitrosated derivatives; chlordecone (ISO)",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291479",
    description:
      "Ketones and quinones; halogenated, sulphonated, nitrated or nitrosated derivatives, other than chlordecone (ISO)",
    parent: "2914",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2915",
    description:
      "Acids; saturated acyclic monocarboxylic acids and their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291511",
    description: "Acids; saturated acyclic monocarboxylic acids; formic acid",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291512",
    description:
      "Acids; saturated acyclic monocarboxylic acids; salts of formic acids",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291513",
    description:
      "Acids; saturated acyclic monocarboxylic acids; esters of formic acid",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291521",
    description: "Acids; saturated acyclic monocarboxylic acids; acetic acid",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291524",
    description:
      "Acids; saturated acyclic monocarboxylic acids; acetic anhydride",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291529",
    description:
      "Acids; saturated acyclic monocarboxylic acids; acetic acid and its salts n.e.c. in item no. 2915.2",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291531",
    description: "Acids; saturated acyclic monocarboxylic acids; ethyl acetate",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291532",
    description: "Acids; saturated acyclic monocarboxylic acids; vinyl acetate",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291533",
    description:
      "Acids; saturated acyclic monocarboxylic acids; n-butyl acetate",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291536",
    description:
      "Acids; saturated acyclic monocarboxylic acids; dinoseb (ISO) acetate",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291539",
    description:
      "Acids; saturated acyclic monocarboxylic acids; esters of acetic acid n.e.c. in item no. 2915.3",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291540",
    description:
      "Acids; saturated acyclic monocarboxylic acids; mono-, di- or trichloroacetic acids, their salts and esters",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291550",
    description:
      "Acids; saturated acyclic monocarboxylic acids; propionic acid, its salts and esters",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291560",
    description:
      "Acids; saturated acyclic monocarboxylic acids; butanoic acids, pentanoic acids, their salts and esters",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291570",
    description:
      "Acids; saturated acyclic monocarboxylic acids; palmitic acid, stearic acid, their salts and esters",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291590",
    description:
      "Acids; saturated acyclic monocarboxylic acids; anhydrides, halides, peroxides, peroxyacids and halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2915",
    parent: "2915",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2916",
    description:
      "Acids; unsaturated acyclic monocarboxylic, cyclic monocarboxylic, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291611",
    description:
      "Acids; unsaturated acyclic monocarboxylic acids; acrylic acid and its salts",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291612",
    description:
      "Acids; unsaturated acyclic monocarboxylic acids; esters of acrylic acid",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291613",
    description:
      "Acids; unsaturated acyclic monocarboxylic acids; methacrylic acid and its salts",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291614",
    description:
      "Acids; unsaturated acyclic monocarboxylic acids; esters of methacrylic acid",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291615",
    description:
      "Acids; unsaturated acyclic monocarboxylic acids; oleic, linoleic or linolenic acids, their salts and esters",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291616",
    description:
      "Acids; unsaturated acyclic monocarboxylic, cyclic monocarboxylic, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives, binapacryl (ISO)",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291619",
    description:
      "Acids; unsaturated acyclic monocarboxylic, cyclic monocarboxylic, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in item no. 2916.1",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291620",
    description:
      "Acids; cyclanic, cyclenic or cycloterpenic monocarboxylic acids, their anhydrides, halides, peroxides, peroxyacids and their derivatives",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291631",
    description:
      "Acids; aromatic monocarboxylic acids, benzoic acid, its salts and esters",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291632",
    description:
      "Acids; aromatic monocarboxylic acids, benzoyl peroxide and benzoyl chloride",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291634",
    description:
      "Acids; aromatic monocarboxylic acids, phenylacetic acid and its salts",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291639",
    description:
      "Acids; aromatic monocarboxylic acids, and their anhydrides, halides, peroxides, peroxyacids and their derivatives, other than benzoic acid, its salts and esters, benzoyl peroxide and benzoyl chloride, phenylacetic acid and its salts",
    parent: "2916",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2917",
    description:
      "Acids; polycarboxylic acids, their anhydrides, halides, peroxides and peroxy-acids; their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291711",
    description:
      "Acids; acyclic polycarboxylic acids; oxalic acid, its salts and esters",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291712",
    description:
      "Acids; acyclic polycarboxylic acids; adipic acid, its salts and esters",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291713",
    description:
      "Acids; acyclic polycarboxylic acids; azelaic acid, sebacic acid, their salts and esters",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291714",
    description: "Acids; acyclic polycarboxylic acids; maleic anhydride",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291719",
    description:
      "Acids; acyclic polycarboxylic acids; n.e.c. in item no. 2917.1",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291720",
    description:
      "Acids; cyclanic, cyclenic or cycloterpenic polycarboxylic acids, their anhydrides, halides, peroxides, peroxyacids and derivatives",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291732",
    description:
      "Acids; aromatic polycarboxylic acids; dioctyl orthophthalates",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291733",
    description:
      "Acids; aromatic polycarboxylic acids; dinonyl or didecyl orthophthalates",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291734",
    description:
      "Acids; aromatic polycarboxylic acids; other esters of orthophthalic acids",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291735",
    description: "Acids; aromatic polycarboxylic acids; phthalic anhydride",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291736",
    description:
      "Acids; aromatic polycarboxylic acids; terephthalic acid and its salts",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291737",
    description: "Acids; aromatic polycarboxylic acids; dimethyl terephthalate",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291739",
    description:
      "Acids; aromatic polycarboxylic acids; n.e.c. in item no. 2917.3",
    parent: "2917",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2918",
    description:
      "Acids; carboxylic acid with additional oxygen function and their anhydrides, halides, peroxides, peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291811",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), lactic acid, its salts and esters",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291812",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), tartaric acid",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291813",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function); salts and esters of tartaric acid",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291814",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), citric acid",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291815",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), salts and esters of citric acid",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291816",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), gluconic acid, its salts and esters",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291817",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), 2,2-Diphenyl-2-hydroxyacetic acid (benzilic acid)",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291818",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), chlorobenzilate (ISO)",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291819",
    description:
      "Acids; carboxylic acids, (with alcohol function but without other oxygen function), other than lactic, tartaric, citric, and gluconic acids and their salts and esters",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291821",
    description:
      "Acids; carboxylic acids, (with phenol function but without other oxygen function), salicylic acid and its salts",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291822",
    description:
      "Acids; carboxylic acids, (with phenol function but without other oxygen function), o-acetylsalicylic acid, its salts and esters",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291823",
    description:
      "Acids; carboxylic acids, (with phenol function but without other oxygen function), other esters of salicylic acid and its salts n.e.c. in item no. 2918.2",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291829",
    description:
      "Acids; carboxylic acids, (with phenol function but without other oxygen function), their anhydrides, halides, peroxides, peroxyacids and their derivatives, n.e.c. in item no. 2918.2",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291830",
    description:
      "Acids; carboxylic acids, (with aldehyde or ketone function but without other oxygen function), their anhydrides, halides, peroxides, peroxyacids and their derivatives",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291891",
    description:
      "Acids; carboxylic acids, with additional oxygen function (not alcohol, phenol, aldehyde or ketone) and their anhydrides, halides, peroxides and peroxyacids; 2,4,5-T (ISO) (2,4,5-trichlorophenoxyacetic acid), its salts and esters",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291899",
    description:
      "Acids; carboxylic acids, with additional oxygen function (not alcohol, phenol, aldehyde or ketone) and their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives; other than 2,4,5-T (ISO)",
    parent: "2918",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2919",
    description:
      "Esters; phosphoric, and their salts, including lactophosphates, their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "291910",
    description:
      "Esters; phosphoric, and their salts, including lactophosphates, their halogenated, sulphonated, nitrated or nitrosated derivatives; tris(2,3-dibromopropyl) phosphate",
    parent: "2919",
    level: "6",
  },
  {
    section: "VI",
    hscode: "291990",
    description:
      "Esters; phosphoric, and their salts, including lactophosphates, their halogenated, sulphonated, nitrated or nitrosated derivatives; other than tris(2,3-dibromopropyl) phosphate",
    parent: "2919",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2920",
    description:
      "Esters of other inorganic acids of non-metals (other than of hydrogen halides) and their salts, their halogenated, sulphonated, nitrated or nitrosated derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292011",
    description:
      "Esters; thiophosphoric esters (phosphorothioates) and their salts, their halogenated, sulphonated, nitrated or nitrosated derivatives, parathion (ISO) and parathion-methyl (ISO) (methyl-parathion)",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292019",
    description:
      "Esters; thiophosphoric esters (phosphorothioates) and their salts; other than parathion (ISO) and parathion-methyl (ISO) (methyl-parathion)",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292021",
    description:
      "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, dimethyl phosphite",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292022",
    description:
      "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, diethyl phosphite",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292023",
    description:
      "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, trimethyl phosphite",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292024",
    description:
      "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, triethyl phosphite",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292029",
    description:
      "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2920",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292030",
    description:
      "Esters; of other inorganic acids of non-metals (excluding esters of hydrogen halides) and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, endosulfan (ISO)",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292090",
    description:
      "Esters; other than thiophosphoric esters (phosphorothioates) and phosphite esters and their salts, their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2920",
    parent: "2920",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2921",
    description: "Amine-function compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292111",
    description:
      "Amine-function compounds; acyclic monoamines and their derivatives, methylamine, di- or trimethylamine and their salts",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292112",
    description:
      "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, 2-(N,N-Dimethylamino)ethylchloride hydrochloride",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292113",
    description:
      "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, 2-(N,N-Diethylamino)ethylchloride hydrochloride",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292114",
    description:
      "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, 2-(N,N-Diisopropylamino)ethylchloride hydrochloride",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292119",
    description:
      "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, n.e.c. in item no. 2921.1",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292121",
    description:
      "Amine-function compounds; acyclic polyamines and their derivatives, ethylenediamine and its salts",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292122",
    description:
      "Amine-function compounds; acyclic polyamines and their derivatives, hexamethylenediamine and its salts",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292129",
    description:
      "Amine-function compounds; acyclic polyamines and their derivatives, and salts thereof, n.e.c. in item no. 2921.2",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292130",
    description:
      "Amine-function compounds; cyclanic, cyclenic or cycloterpenic mono- or polyamines and their derivatives; salts thereof",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292141",
    description:
      "Amine-function compounds; aromatic monoamines and their derivatives, aniline and its salts",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292142",
    description:
      "Amine-function-compounds; aromatic monoamines and their derivatives, aniline derivatives and their salts",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292143",
    description:
      "Amine-function compounds; aromatic monoamines and their derivatives, toluidines and their derivatives; salts thereof",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292144",
    description:
      "Amine-function compounds; aromatic monoamines and their derivatives, diphenylamine and its derivatives; salts thereof",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292145",
    description:
      "Amine-function compounds; aromatic monoamines and their derivatives; 1-naphthylamine (alpha-naphthylamine), 2-naphthylamine (beta-naphthaylamine) and their derivatives; salts thereof",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292146",
    description:
      "Amine-function compounds; aromatic monoamines and derivatives; amfetamine (INN), benzfetamine (INN), dexamfetamine (INN), etilamfetamine (INN), fencamfamin (INN), lefetamine (INN), levamfetamine (INN), mefenorex (INN) and phentermine (INN); salts thereof",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292149",
    description:
      "Amine-function compounds; aromatic monoamines and their derivatives; salts thereof; n.e.c. in item no. 2921.4",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292151",
    description:
      "Amine-function compounds; aromatic amines and their derivatives; o-, m-, p-phenylenediamine, diaminotoluenes and their derivatives; salts thereof",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292159",
    description:
      "Amine-function compounds; aromatic polyamines and their derivatives, other than item no. 2921.51",
    parent: "2921",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2922",
    description: "Oxygen-function amino-compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292211",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, monoethanolamine and its salts",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292212",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, diethanolamine and its salts",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292214",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof; dextropropoxyphene (INN) and its salts",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292215",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, triethanolamine",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292216",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, Diethanolammonium perfluorooctane sulphonate",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292217",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, Methyldiethanolamine and ethyldiethanolamine",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292218",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, 2-(N,N- Diisopropylamino)ethanol",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292219",
    description:
      "Amino-alcohols, other than those containing more than one kind of oxygen function, their ethers and esters; salts thereof, n.e.c. in item no. 2922.1",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292221",
    description:
      "Amino-naphthols and other amino-phenols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, aminohydroxynaphthalenesulphonic acids and their salts",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292229",
    description:
      "Amino-naphthols and other amino-phenols, other than those containing more than one kind of oxygen function, their ethers and esters; salts thereof n.e.c. in item no. 2922.2",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292231",
    description:
      "Amino-aldehydes, amino-ketones and amino-quinones; other than those containing more than one kind of oxygen function, salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292239",
    description:
      "Amino-aldehydes, amino-ketones and amino-quinones; other than those containing more than one kind of oxygen function; salts thereof, excluding amfepramone (INN), methadone (INN), and normethadone (INN) and salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292241",
    description:
      "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; lysine and its esters; salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292242",
    description:
      "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; glutamic acid and its esters; salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292243",
    description:
      "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; anthranilic acid and its esters; salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292244",
    description:
      "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; tilidine (INN) and its esters; salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292249",
    description:
      "Amino-acids, other than those containing more than one kind of oxygen function, their esters; salts thereof, excluding lysine, glutamic acid, anthranalic acid and tilidine, their esters and salts thereof",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292250",
    description:
      "Amino-alcohol-phenols, amino-acid-phenols and other amino-compounds with oxygen function",
    parent: "2922",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2923",
    description:
      "Quaternary ammonium salts and hydroxides; lecithins and other phosphoaminolipids, whether or not chemically defined",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292310",
    description:
      "Quaternary ammonium salts and hydroxides; choline and its salts, whether or not chemically defined",
    parent: "2923",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292320",
    description:
      "Lecithins and other phosphoaminolipids, whether or not chemically defined",
    parent: "2923",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292330",
    description:
      "Quaternary ammonium salts and hydroxides; tetraethylammonium perfluorooctane sulphonate, whether or not chemically defined",
    parent: "2923",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292340",
    description:
      "Quaternary ammonium salts and hydroxides; didecyldimethylammonium perfluorooctane sulphonate, whether or not chemically defined",
    parent: "2923",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292390",
    description:
      "Quaternary ammonium salts and hydroxides; whether or not chemically defined n.e.c. in heading no. 2923",
    parent: "2923",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2924",
    description:
      "Carboxyamide-function compounds; amide-function compounds of carbonic acid",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292411",
    description:
      "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof; meprobamate (INN)",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292412",
    description:
      "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof; fluoroacetamide (ISO), monocrotophos (ISO) and phosphamidon (ISO)",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292419",
    description:
      "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof, other than meprobamate (INN), fluoroacetamide (ISO), monocrotophos (ISO) or phosphamidon (ISO)",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292421",
    description:
      "Cyclic amides (including cyclic carbamates) and their derivatives, ureines and their derivatives; salts thereof",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292423",
    description:
      "Cyclic amides (including cyclic carbamates) and their derivatives; 2-acetamidobenzoic acid (N-acetylanthranillic acid) and its salts",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292424",
    description:
      "Cyclic amides (including cyclic carbamates) and their derivatives; ethinamate and its salts",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292425",
    description:
      "Cyclic amides (including cyclic carbamates) and their derivatives; alachlor (ISO) and its salts",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292429",
    description:
      "Cyclic amides (including cyclic carbamates) and their derivatives; other than the derivatives and salts of ureines, 2-acetamidobenzoic acid (N-acetylanthancillic acid),ethinamate S, and alachlor (ISO) and their derivatives and salts",
    parent: "2924",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2925",
    description:
      "Carboxyimide-function compounds (including saccharin and its salts) and imine-function compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292511",
    description: "Imides and their derivatives; saccharin and its salts",
    parent: "2925",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292512",
    description: "Imides and their derivatives; glutethimide (INN)",
    parent: "2925",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292519",
    description:
      "Imides and their derivatives; other than saccharin and glutethimide (INN)",
    parent: "2925",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292521",
    description:
      "Imines and their derivatives; salts thereof; chlordimeform (ISO)",
    parent: "2925",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292529",
    description:
      "Imines and their derivatives; salts thereof; other than chlordimeform (ISO)",
    parent: "2925",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2926",
    description: "Nitrile-function compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292610",
    description: "Nitrile-function compounds; acrylonitrile",
    parent: "2926",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292620",
    description: "Nitrile-function compounds; 1-cyanoguanidine (dicyandiamide)",
    parent: "2926",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292630",
    description:
      "Nitrile-function compounds; fenproporex (INN) and its salts; methadone (INN) intermediate (4-cyano-2-dimethylamino-4,4-diphenylbutane)",
    parent: "2926",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292640",
    description: "Nitrile-function compounds; alpha-phenylacetoacetonitrile",
    parent: "2926",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292690",
    description: "Nitrile-function compounds; n.e.c. heading no. 2926",
    parent: "2926",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2927",
    description: "Diazo-, azo- or azoxy-compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292700",
    description: "Diazo-, azo- or azoxy compounds",
    parent: "2927",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2928",
    description: "Organic derivatives of hydrazine or of hydroxylamine",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292800",
    description: "Organic derivatives of hydrazine or of hydroxylamine",
    parent: "2928",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2929",
    description: "Nitrogen-function compounds, n.e.c. in chapter 29",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "292910",
    description:
      "Nitrogen-function compounds; n.e.c. in chapter 29, isocyanates",
    parent: "2929",
    level: "6",
  },
  {
    section: "VI",
    hscode: "292990",
    description:
      "Nitrogen-function compounds; n.e.c. in chapter 29, excluding isocyanates",
    parent: "2929",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2930",
    description: "Organo-sulphur compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293010",
    description: "Organo-sulphur compounds; 2-(N,N-Diethylamino) ethanethiol",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293020",
    description:
      "Organo-sulphur compounds; thiocarbamates and dithiocarbamates",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293030",
    description:
      "Organo-sulphur compounds; thiuram mono-, di- or tetrasulphides",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293040",
    description: "Organo-sulphur compounds; methionine",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293060",
    description: "Organo-sulphur compounds; 2-(N,N-Diethylamino)ethanethiol",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293070",
    description:
      "Organo-sulphur compounds; bis(2-hydroxyethyl)sulfide (thiodiglycol (INN))",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293080",
    description:
      "Organo-sulphur compounds; aldicarb (ISO), captafol (ISO) and methamidophos (ISO)",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293090",
    description: "Organo-sulphur compounds; n.e.c. in heading no. 2930",
    parent: "2930",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2931",
    description: "Other organo-inorganic compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293110",
    description:
      "Organo-inorganic compounds; tetramethyl lead and tetraethyl lead",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293120",
    description: "Organo-inorganic compounds; tributyltin compounds",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293141",
    description:
      "Non-halogenated organo-phosphorous derivatives; dimethyl methylphosphonate",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293142",
    description:
      "Non-halogenated organo-phosphorous derivatives; dimethyl propylphosphonate",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293143",
    description:
      "Non-halogenated organo-phosphorous derivatives; diethyl ethylphosphonate",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293144",
    description:
      "Non-halogenated organo-phosphorous derivatives; methylphosphonic acid",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293145",
    description:
      "Non-halogenated organo-phosphorous derivatives; salt of methylphosphonic acid and (aminominomethyl) urea (1:1)",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293146",
    description:
      "Non-halogenated organo-phosphorous derivatives; 2,4,6-tripropyl-1,3,5,2,4,6-trioxatriphosphinane 2,4,6-trioxide",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293147",
    description:
      "Non-halogenated organo-phosphorous derivatives; (5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl) methyl methyl methylphosphonate",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293148",
    description:
      "Non-halogenated organo-phosphorous derivatives; 3,9-dimethyl-2,4,8,10-tetraoxa-3,9-diphosphaspiro[5.5] undecane 3,9-dioxide",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293149",
    description:
      "Non-halogenated organo-phosphorous derivatives; other non-halogenated organo-phosphorous derivatives, n.e.c. in item no. 2931.4",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293151",
    description:
      "Halogenated organo-phosphorous derivatives; methylphosphonic dichloride",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293152",
    description:
      "Halogenated organo-phosphorous derivatives; propylphosphonic dichloride",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293153",
    description:
      "Halogenated organo-phosphorous derivatives; O-(3-chloropropyl) O-[4-nitro-3-(trifluoromethyl)phenyl] methylphosphonothionate",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293154",
    description:
      "Halogenated organo-phosphorous derivatives; trichlorfon (ISO)",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293159",
    description:
      "Halogenated organo-phosphorous derivatives; other halogenated organo-phosphorous derivatives, n.e.c. in item no. 2931.5",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293190",
    description:
      "Organo-inorganic compounds; other than tetramethyl lead, tetraethyl lead, tributyltin compounds, and other organo-phosphorous derivatives",
    parent: "2931",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2932",
    description: "Heterocyclic compounds with oxygen hetero-atom(s) only",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293211",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, tetrahydrofuran",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293212",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, 2-furaldehyde (furfuraldehyde)",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293213",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, furfuryl alcohol and tetrahydrofurfuryl alcohol",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293214",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, sucralose",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293219",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, n.e.c. in item no. 2932.1",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293220",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, lactones",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293291",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), isosafrole",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293292",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), 1-(1,3-Benzodioxol-5-yl)propan-2-one",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293293",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), piperonal",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293294",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), safrole",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293295",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), tetrahydrocannabinols (all isomers)",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293296",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), carbofuran (ISO)",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293299",
    description:
      "Heterocyclic compounds; with oxygen hetero-atom(s) only, no lactones or unfused furan rings in the structure, other than isosafrole, 1-(1,3-benzodiaxol-5-yl) propan-2-one, piperonal, safrole, tetrahydrocannabinols (all isomers), carbofuran (ISO)",
    parent: "2932",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2933",
    description: "Heterocyclic compounds with nitrogen hetero-atom(s) only",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293311",
    description:
      "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused pyrazole ring (whether or not hydrogenated) in the structure, phenazone (antipyrin) and its derivatives",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293319",
    description:
      "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused pyrazole ring (whether or not hydrogenated) in the structure, other than henazone (antipyrin) and its derivatives",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293321",
    description:
      "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused imidazole ring (whether or not hydrogenated) in the structure, hydantoin and its derivatives",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293329",
    description:
      "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused imidazole ring (whether or not hydrogenated) in the structure, other than hydantoin and its derivatives",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293331",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, pyridine and its salts",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293332",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, piperidine and its salts",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293333",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, alfentanil (INN), anileridine (INN), bezitramide (INN), bromazepam (INN), carfentanil (INN), difenoxin (INN), diphenoxylate (INN), dipipanone (INN)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293334",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, other fentanyls and their derivatives",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293335",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, 3-quinuclidinol",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293336",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, 4-anilino-N-phenethylpiperidine (ANPP)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293337",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, N-phenethyl-4-piperdone (NPP)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293339",
    description:
      "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, n.e.c. in 2933.3",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293341",
    description:
      "Heterocyclic compounds; containing a quinoline or isoquinoline ring-system (whether or not hydrogenated) in the structure, not further fused, levorphanol (INN) and its salts",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293349",
    description:
      "Heterocyclic compounds; containing a quinoline or isoquinoline ring-system (whether or not hydrogenated) in the structure, not further fused, other than levorphanol (INN) and its salts",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293352",
    description:
      "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, malonylurea (barbituric acid) and its salts",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293353",
    description:
      "Allobarbital (INN), amobarbital (INN), barbital (INN), butalbital (INN), butobarbital, cyclobarbital (INN), methylphenobarbital (INN), pentobarbital (INN), phenobarbital (INN), secbutabarbital (INN), secobarbital (INN) and vinylbital (INN); salts thereof",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293354",
    description:
      "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, other derivatives of malonylurea (barbituric acid) and salts thereof, n.e.c. in 2933.53",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293355",
    description:
      "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure; loprazolam (INN), mecloqualone (INN), methaqualone (INN), and zipeprol (INN); salts thereof",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293359",
    description:
      "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, (other than malonylurea and its derivatives, loprazolam, mecloqualone, methaqualone, zipeprol, and salts thereof) n.e.c. in 2933.5",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293361",
    description:
      "Heterocyclic compounds; containing an unfused triazine ring (whether or not hydrogenated) in the structure, melamine",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293369",
    description:
      "Heterocyclic compounds; containing an unfused triazine ring (whether or not hydrogenated) in the structure, others excluding melamine",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293371",
    description:
      "Heterocyclic compounds; lactams; 6-hexanelactam (epsilon-caprolactam)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293372",
    description:
      "Heterocyclic compounds; lactams; clobazam (INN) and methyprylon (INN)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293379",
    description:
      "Heterocyclic compounds; lactams; other than 6-hexanelactam (epsilon caprolactam) and clobazam (INN) and methyprylon (INN)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293391",
    description:
      "Heterocyclic compounds; alprazolam (INN), camazepam (INN), chlordiazepoxide (INN), clonazepam (INN), clorazepate, delorazepam (INN), diazepam (INN), estazolam (INN), ethyl loflazepate (INN), fludiazepam (INN), flunitrazepam (INN), (cont)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293392",
    description: "Heterocyclic compounds; azinphos-methyl (ISO)",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293399",
    description: "Heterocyclic compounds; n.e.c. in headings no. 2933",
    parent: "2933",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2934",
    description:
      "Nucleic acids and their salts, whether or not chemically defined; other heterocyclic compounds",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293410",
    description:
      "Heterocyclic compounds; containing an unfused thiazole ring (whether or not hydrogenated) in the structure",
    parent: "2934",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293420",
    description:
      "Heterocyclic compounds; containing in the structure, a benzothiazole ring-system (whether or not hydrogenated), not further fused",
    parent: "2934",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293430",
    description:
      "Heterocyclic compounds; containing in the structure, a phenothiazine ring-system (whether or not hydrogenated), not further fused",
    parent: "2934",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293491",
    description:
      "Heterocyclic compounds; other heterocyclic compounds, n.e.c. in 2934.1, 2934.2 and 2934.3",
    parent: "2934",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293492",
    description:
      "Heterocyclic compounds; other fentanyls n.e.c. in 2934, and their derivatives",
    parent: "2934",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293499",
    description:
      "Nucleic acids and their salts, other heterocyclic compounds, n.e.c. in heading number 2934",
    parent: "2934",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2935",
    description: "Sulphonamides",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293510",
    description: "Sulphonamides; N-methylperfluorooctane sulphonamide",
    parent: "2935",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293520",
    description: "Sulphonamides; N-ethylperfluorooctane sulphonamide",
    parent: "2935",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293530",
    description:
      "Sulphonamides; N-ethyl-N-(2-hydroxyethyl) perfluorooctane sulphonamide",
    parent: "2935",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293540",
    description:
      "Sulphonamides; N-(2-hydroxyethyl)-N-methylperfluorooctane sulphonamide",
    parent: "2935",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293550",
    description: "Sulphonamides; other perfluorooctane sulphonamides",
    parent: "2935",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293590",
    description: "Sulphonamides; n.e.c. in heading no. 2935",
    parent: "2935",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2936",
    description:
      "Provitamins, vitamins; natural or reproduced by synthesis (including natural concentrates) derivatives thereof used as vitamins, and intermixtures of the fore-going, whether or not in any solvent",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293621",
    description: "Vitamins; vitamins A and their derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293622",
    description: "Vitamins; vitamin B1 and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293623",
    description: "Vitamins; vitamin B2 and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293624",
    description:
      "Vitamins; D- or DL-pantothenic acid (vitamin B5) and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293625",
    description: "Vitamins; vitamin B6 and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293626",
    description: "Vitamins; vitamin B12 and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293627",
    description: "Vitamins; vitamin C and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293628",
    description: "Vitamins; vitamin E and its derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293629",
    description:
      "Vitamins; n.e.c. in item no. 2936.2, and their derivatives, unmixed",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293690",
    description:
      "Vitamins; n.e.c. in heading no. 2936, including natural concentrates",
    parent: "2936",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2937",
    description:
      "Hormones, prostaglandins, thromboxanes and leukotrienes, natural or reproduced by synthesis; derivatives and structural analogues thereof, including chain modified polypeptides, used primarily as hormones.",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293711",
    description:
      "Polypeptide hormones, protein hormones and glycoprotein hormones, their derivatives and structural analogues; somatotropin, its derivatives and structural analogues",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293712",
    description:
      "Polypeptide hormones, protein hormones and glycoprotein hormones, their derivatives and structural analogues; insulin and its salts",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293719",
    description:
      "Polypeptide hormones, protein hormones and glycoprotein hormones, their derivatives and structural analogues; other than somatotropin, (its derivatives and structural anaologues) and insulin and its salts",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293721",
    description:
      "Steroidal hormones, their derivatives and structural analogues; cortisone, hydrocortisone, prednisone (dehydrocortisone) and prednisolone (dehydrohydrocortisone)",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293722",
    description:
      "Steroidal hormones, their derivatives and structural analogues; halogenated derivatives of corticosteroidal hormones",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293723",
    description:
      "Steroidal hormones, their derivatives and structural analogues; oestrogens and progestogens",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293729",
    description:
      "Steroidal hormones, their derivatives and structural analogues; other than cortisone, hydrocortisone, prednisone (dehydrocortisone), prednisolone (dehydrohydrocortisone), halogenated derivatives of corticosteroidal hormones, oestrogen and progestogens",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293750",
    description:
      "Prostaglandins, thromboxanes and leukotrienes, their derivatives and structural analogues",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293790",
    description:
      "Hormones, prostaglandins, thromboxanes and leukotrienes, natural or reproduced by synthesis; derivatives and structural analogues thereof, including chain modified polypeptides, used primarily as hormones, n.e.c. in heading 2937",
    parent: "2937",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2938",
    description:
      "Glycosides, natural or reproduced by synthesis, and their salts, ethers, esters and other derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293810",
    description: "Glycosides; rutoside (rutin) and its derivatives",
    parent: "2938",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293890",
    description:
      "Glycosides; natural or reproduced by synthesis, other than rutoside (rutin) and its derivatives",
    parent: "2938",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2939",
    description:
      "Alkaloids; natural or reproduced by synthesis, and their salts, ethers, esters and other derivatives",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "293911",
    description: "Alkaloids; of opium and their derivatives; salts thereof",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293919",
    description:
      "Alkaloids; of opium and their derivatives; other than in 2939.11, salts thereof",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293920",
    description: "Alkaloids; of cinchona and their derivatives; salts thereof",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293930",
    description: "Alkaloids; caffeine and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293941",
    description: "Alkaloids; of ephedrine and their derivatives; salts thereof",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293942",
    description:
      "Alkaloids; of ephedrine and their derivatives; pseudoephedrine (INN) and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293943",
    description:
      "Alkaloids; of ephedrine and their derivatives; cathine (INN) and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293944",
    description:
      "Alkaloids; of ephedrine and their derivatives; norephedrine and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293945",
    description:
      "Alkaloids; of ephedrine and their derivatives; levometamfetamine, metamfetamine (INN), metamefetamine racemate and their salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293949",
    description:
      "Alkaloids; of ephedrine and their derivatives; other than ephedrine, pseudoephedrine (INN), norephedrine, cathine (INN), levometamfetamine, metamfetamine (INN), metamefetamine racemate and their salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293951",
    description:
      "Alkaloids; theophylline and aminophylline (theophylline-ethylenediamine) and their derivatives; salts thereof, fenetylline (INN) and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293959",
    description:
      "Alkaloids; theophylline and aminophylline (theophylline-ethylenediamine) and their derivatives; salts thereof, other than fenetylline",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293961",
    description:
      "Alkaloids; of rye ergot and their derivatives, ergometrine (INN) and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293962",
    description:
      "Alkaloids; of rye ergot and their derivatives, ergotamine (INN) and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293963",
    description:
      "Alkaloids; of rye ergot and their derivatives, lysergic acid and its salts",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293969",
    description:
      "Alkaloids; of rye ergot and their derivatives, salts thereof, n.e.c. in item no. 2939.6",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293972",
    description:
      "Alkaloids; of vegetal origin, cocaine, ecgonine; salts, esters and other derivatives thereof",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293979",
    description:
      "Alkaloids; of vegetal origin, other than cocaine, ecgonine; salts, esters and other derivatives; n.e.c. in heading no. 2939",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "293980",
    description:
      "Alkaloids; natural or reproduced by synthesis, and their salts, esters and other derivatives n.e.c. in heading no. 2939",
    parent: "2939",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2940",
    description:
      "Sugars, chemically pure, other than sucrose, lactose, maltose, glucose and fructose; sugar ethers, sugar acetals and sugar esters, and their salts, other than the products of heading 29.37, 29.38, or 29.39",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "294000",
    description:
      "Sugars, chemically pure, other than sucrose, lactose, maltose, glucose and fructose; sugar ethers, sugar acetals and sugar esters, and their salts, other than the products of heading 29.37, 29.38, or 29.39",
    parent: "2940",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2941",
    description: "Antibiotics",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "294110",
    description:
      "Antibiotics; penicillins and their derivatives with a penicillanic acid structure; salts thereof",
    parent: "2941",
    level: "6",
  },
  {
    section: "VI",
    hscode: "294120",
    description:
      "Antibiotics; streptomycins and their derivatives; salts thereof",
    parent: "2941",
    level: "6",
  },
  {
    section: "VI",
    hscode: "294130",
    description:
      "Antibiotics; tetracyclines and their derivatives; salts thereof",
    parent: "2941",
    level: "6",
  },
  {
    section: "VI",
    hscode: "294140",
    description:
      "Antibiotics; chloramphenicol and its derivatives; salts thereof",
    parent: "2941",
    level: "6",
  },
  {
    section: "VI",
    hscode: "294150",
    description: "Antibiotics; erythromycin and its derivatives; salts thereof",
    parent: "2941",
    level: "6",
  },
  {
    section: "VI",
    hscode: "294190",
    description: "Antibiotics; n.e.c. in heading no. 2941",
    parent: "2941",
    level: "6",
  },
  {
    section: "VI",
    hscode: "2942",
    description: "Organic compounds; n.e.c. in chapter 29",
    parent: "29",
    level: "4",
  },
  {
    section: "VI",
    hscode: "294200",
    description: "Organic compounds; n.e.c. in chapter 29",
    parent: "2942",
    level: "6",
  },
  {
    section: "VI",
    hscode: "30",
    description: "Pharmaceutical products",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3001",
    description:
      "Glands and other organs (extracts, secretions thereof) for organo-therapeutic uses, dried, powdered or not; heparin and its salts; other human or animal substances for therapeutic or prophylactic uses n.e.c.",
    parent: "30",
    level: "4",
  },
  {
    section: "VI",
    hscode: "300120",
    description:
      "Glands and other organs; extracts of glands or other organs or of their secretions, for organo-therapeutic uses",
    parent: "3001",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300190",
    description:
      "Glands and other organs; heparin and its salts; other human or animal substances prepared for therapeutic or prophylactic uses, n.e.c. in heading 3001",
    parent: "3001",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3002",
    description:
      "Human blood; animal blood for therapeutic, prophylactic or diagnostic uses; antisera, other blood fractions, immunological products, modified or obtained by biotechnological processes; vaccines, toxins, cultures of micro-organisms (excluding yeasts) etc",
    parent: "30",
    level: "4",
  },
  {
    section: "VI",
    hscode: "300212",
    description:
      "Blood, human or animal, antisera, other blood fractions and immunological products; antisera and other blood fractions",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300213",
    description:
      "Blood, human or animal, antisera, other blood fractions and immunological products; immunological products, unmixed, not put up in measured doses or in forms or packings for retail sale",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300214",
    description:
      "Blood, human or animal, antisera, other blood fractions and immunological products; immunological products, mixed, put up in measured doses or in forms or packings for retail sale",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300215",
    description:
      "Blood, human or animal, antisera, other blood fractions and immunological products; immunological products, put up in measured doses or in forms or packings for retail sale",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300241",
    description:
      "Vaccines, toxins, cultures of micro-organisms (excluding yeasts) and similar products; for human medicine",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300242",
    description:
      "Vaccines, toxins, cultures of micro-organisms (excluding yeasts) and similar products; for veterinary medicine",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300249",
    description:
      "Toxins, cultures of micro-organisms (excluding yeasts) and similar products; n.e.c. in item 3002.3",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300251",
    description:
      "Cell cultures, whether or not modified; cell therapy products",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300259",
    description:
      "Cell cultures, whether or not modified; other cell cultures not including cell therapy products",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300290",
    description:
      "Toxins, cultures of micro-organisms (excluding yeasts) and similar products",
    parent: "3002",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3003",
    description:
      "Medicaments; (not goods of heading no. 3002, 3005 or 3006) of two or more constituents mixed together for therapeutic or prophylactic use not in measured doses or in forms or packings for retail sale",
    parent: "30",
    level: "4",
  },
  {
    section: "VI",
    hscode: "300310",
    description:
      "Medicaments; containing penicillins, streptomycins or their derivatives, for therapeutic or prophylactic uses, (not in measured doses, not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300320",
    description:
      "Medicaments; containing antibiotics other than penicillins, streptomycins and their derivatives, for therapeutic or prophylactic uses, (not in measured doses, not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300331",
    description:
      "Medicaments; containing insulin, for therapeutic or prophylactic uses, not packaged for retail sale",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300339",
    description:
      "Medicaments; containing hormones (excluding insulin), (but not containing antibiotics), for therapeutic or prophylactic uses, not packaged for retail sale",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300341",
    description:
      "Medicaments; containing alkaloids or their derivatives, containing ephedrine or its salts, for therapeutic or prophylactic uses, (not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300342",
    description:
      "Medicaments; containing alkaloids or their derivatives, containing pseudoephedrine (INN) or its salts, for therapeutic or prophylactic uses, (not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300343",
    description:
      "Medicaments; containing alkaloids or their derivatives, containing norephedrine or its salts, for therapeutic or prophylactic uses, (not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300349",
    description:
      "Medicaments; containing alkaloids or their derivatives; other than ephedrine, pseudoephedrine (INN) or norephedrine or their salts; for therapeutic or prophylactic uses, (not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300360",
    description:
      "Medicaments; containing antimalarial active principles described in subheading note 2 to this chapter, for therapeutic or prophylactic uses, (not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300390",
    description:
      "Medicaments; (not containing antibiotics, hormones, alkaloids or their derivatives), for therapeutic or prophylactic uses, (not packaged for retail sale)",
    parent: "3003",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3004",
    description:
      "Medicaments; (not goods of heading no. 3002, 3005 or 3006) consisting of mixed or unmixed products for therapeutic or prophylactic use, put up in measured doses (incl. those in the form of transdermal admin. systems) or packed for retail sale",
    parent: "30",
    level: "4",
  },
  {
    section: "VI",
    hscode: "300410",
    description:
      "Medicaments; containing penicillins, streptomycins or their derivatives, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300420",
    description:
      "Medicaments; containing antibiotics (other than penicillins, streptomycins or their derivatives), for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300431",
    description:
      "Medicaments; containing insulin, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300432",
    description:
      "Medicaments; containing corticosteroid hormones, their derivatives or structural analogues (but not containing antibiotics), for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300439",
    description:
      "Medicaments; containing hormones (but not insulin), adrenal cortex hormones or antibiotics, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300441",
    description:
      "Medicaments; containing alkaloids or their derivatives, containing ephedrine or its salts, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300442",
    description:
      "Medicaments; containing alkaloids or their derivatives, containing pseudoephedrine (INN) or its salts, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300443",
    description:
      "Medicaments; containing alkaloids or their derivatives, containing norephedrine or its salts, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300449",
    description:
      "Medicaments; containing alkaloids or their derivatives; other than ephedrine, pseudoephedrine (INN) or norephedrine or their salts; for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300450",
    description:
      "Medicaments; containing vitamins or their derivatives, for therapeutic or prophylactic use, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300460",
    description:
      "Medicaments; containing antimalarial active principles described in Subheading Note 2 to this Chapter, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300490",
    description:
      "Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale",
    parent: "3004",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3005",
    description:
      "Wadding, gauze, bandages (dressings, adhesive plasters, poultices), impregnated or coated with pharmaceutical substances or in forms or packings for retail sale, for medical, surgical or veterinary use",
    parent: "30",
    level: "4",
  },
  {
    section: "VI",
    hscode: "300510",
    description:
      "Dressings, adhesive; and other articles having an adhesive layer, packed for retail sale for medical, surgical, dental or veterinary purposes",
    parent: "3005",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300590",
    description:
      "Wadding, gauze, bandages and similar articles; (excluding adhesive dressings), impregnated or coated with pharmaceutical substances, packaged for retail sale",
    parent: "3005",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3006",
    description: "Pharmaceutical goods",
    parent: "30",
    level: "4",
  },
  {
    section: "VI",
    hscode: "300610",
    description:
      "Pharmaceutical goods; sterile surgical catgut, suture materials, tissue adhesives, laminaria, laminaria tents, absorbable surgical or dental haemostatics, and surgical or dental adhesion barriers",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300630",
    description:
      "Pharmaceutical goods; opacifying preparations for x-ray examinations, diagnostic reagents designed to be administered to the patient",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300640",
    description:
      "Pharmaceutical goods; dental cements and other dental fillings, bone reconstruction cements",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300650",
    description: "Pharmaceutical goods; first aid boxes and kits",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300660",
    description:
      "Pharmaceutical goods; chemical contraceptive preparations based on hormones, on other products of heading 2937 or on spermicides",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300670",
    description:
      "Pharmaceutical goods; Gel preparations designed to be used in human or veterinary medicine as a lubricant for parts of the body for surgical operations or physical examinations or as a coupling agent between the body and medical instruments",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300691",
    description: "Pharmaceutical goods; appliances identifiable for ostomy use",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300692",
    description: "Pharmaceutical goods; waste pharmaceuticals",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "300693",
    description:
      "Pharmaceutical goods; placebos and blinded (or double-blinded) clinical trial kits for a recognised clinical trial, put up in measured doses",
    parent: "3006",
    level: "6",
  },
  {
    section: "VI",
    hscode: "31",
    description: "Fertilizers",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3101",
    description:
      "Fertilizers; animal or vegetable, whether or not mixed together or chemically treated; fertilizers produced by the mixing or chemical treatment of animal or vegetable products",
    parent: "31",
    level: "4",
  },
  {
    section: "VI",
    hscode: "310100",
    description:
      "Fertilizers, animal or vegetable; whether or not mixed together or chemically treated; fertilizers, produced by the mixing or chemical treatment of animal or vegetable products",
    parent: "3101",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3102",
    description: "Fertilizers; mineral or chemical, nitrogenous",
    parent: "31",
    level: "4",
  },
  {
    section: "VI",
    hscode: "310210",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, urea, whether or not in aqueous solution",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310221",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, ammonium sulphate",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310229",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, other than ammonium sulphate",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310230",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, ammonium nitrate, whether or not in aqueous solution",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310240",
    description:
      "Fertilizers, mineral or chemical; ammonium nitrate with calcium carbonate or other inorganic non-fertilizing substances, mixtures thereof",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310250",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, sodium nitrate",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310260",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, double salts and mixtures of calcium nitrate and ammonium nitrate",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310280",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, mixtures of urea and ammonium nitrate in aqueous or ammoniacal solution",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310290",
    description:
      "Fertilizers, mineral or chemical; nitrogenous, other kinds including mixtures not specified in the foregoing subheadings",
    parent: "3102",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3103",
    description: "Fertilizers; mineral or chemical, phosphatic",
    parent: "31",
    level: "4",
  },
  {
    section: "VI",
    hscode: "310311",
    description:
      "Fertilizers, mineral or chemical; phosphatic, superphosphates, containing by weight 35% or more of diphosphorus pentaoxide (P2O5)",
    parent: "3103",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310319",
    description:
      "Fertilizers, mineral or chemical; phosphatic, superphosphates, other than containing by weight 35% or more of diphosphorus pentaoxide (P2O5)",
    parent: "3103",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310390",
    description:
      "Fertilizers, mineral or chemical; phosphatic, n.e.c. in heading no. 3103",
    parent: "3103",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3104",
    description: "Fertilizers; mineral or chemical, potassic",
    parent: "31",
    level: "4",
  },
  {
    section: "VI",
    hscode: "310420",
    description:
      "Fertilizers, mineral or chemical; potassic, potassium chloride",
    parent: "3104",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310430",
    description:
      "Fertilizers, mineral or chemical; potassic, potassium sulphate",
    parent: "3104",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310490",
    description:
      "Fertilizers, mineral or chemical; potassic, n.e.c. in heading no. 3104",
    parent: "3104",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3105",
    description:
      "Fertilizers; mineral or chemical, containing 2 or 3 of the elements nitrogen, phosphorus, potassium; other fertilisers; goods of chapter 31 in tablets or packages of gross weight not exceeding 10kg",
    parent: "31",
    level: "4",
  },
  {
    section: "VI",
    hscode: "310510",
    description:
      "Fertilizers, mineral or chemical; in tablets or similar forms or in packages of a gross weight not exceeding 10kg",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310520",
    description:
      "Fertilizers, mineral or chemical; containing the three fertilizing elements nitrogen, phosphorus and potassium",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310530",
    description:
      "Fertilizers, mineral or chemical; diammonium hydrogenorthophosphate (diammonium phosphate)",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310540",
    description:
      "Fertilizers, mineral or chemical; ammonium dihydrogenorthophosphate (monoammonium phosphate) and mixtures thereof with diammonium hydrogenorthophosphate (diammonium phosphate)",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310551",
    description:
      "Fertilizers, mineral or chemical; containing nitrates and phosphates",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310559",
    description:
      "Fertilizers, mineral or chemical; containing the two fertilizing elements nitrogen and phosphorus, other than nitrates and phosphates",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310560",
    description:
      "Fertilizers, mineral or chemical; containing the two fertilizing elements phosphorus and potassium",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "310590",
    description: "Fertilizers, mineral or chemical; n.e.c. in heading no. 3105",
    parent: "3105",
    level: "6",
  },
  {
    section: "VI",
    hscode: "32",
    description:
      "Tanning or dyeing extracts; tannins and their derivatives; dyes, pigments and other colouring matter; paints, varnishes; putty, other mastics; inks",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3201",
    description:
      "Tanning extracts of vegetable origin; tannins and their salts, ethers, esters and other derivatives",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320110",
    description: "Tanning extracts of vegetable origin; quebracho extract",
    parent: "3201",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320120",
    description: "Tanning extracts of vegetable origin; wattle extract",
    parent: "3201",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320190",
    description:
      "Tanning extracts of vegetable origin; tannins and their salts, ethers, esters and other derivatives, (excluding quebracho or wattle extract)",
    parent: "3201",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3202",
    description:
      "Tanning substances; synthetic organic or inorganic tanning substances; tanning preparations, whether or not containing natural tanning substances, enzymatic preparations for pre-tanning",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320210",
    description: "Tanning substances; synthetic organic tanning substances",
    parent: "3202",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320290",
    description:
      "Tanning substances; inorganic tanning substances; tanning preparations, whether or not containing natural tanning substances; enzymatic preparations for pre- tanning",
    parent: "3202",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3203",
    description:
      "Colouring matter of vegetable or animal origin (including dyeing extracts, not animal black); whether or not chemically defined; preparations based on colouring matter of vegetable or animal origin",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320300",
    description:
      "Colouring matter of vegetable or animal origin, including dyeing extracts not animal black, whether or not chemically defined; preparations based on colouring matter of vegetable or animal origin",
    parent: "3203",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3204",
    description:
      "Synthetic organic colouring matter and preparations based thereon; synthetic organic products used as fluorescent brightening agents or as luminophores; whether or not chemically defined",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320411",
    description: "Dyes; disperse dyes and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320412",
    description:
      "Dyes; acid, whether or not premetallised and preparations based thereon, mordant dyes and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320413",
    description: "Dyes; basic dyes and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320414",
    description: "Dyes; direct dyes and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320415",
    description:
      "Dyes; vat dyes (including those usable in that state as pigments) and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320416",
    description: "Dyes; reactive dyes and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320417",
    description: "Dyes; pigments and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320418",
    description:
      "Dyes; carotenoid colouring matters and preparations based thereon",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320419",
    description:
      "Dyes; n.e.c., including mixtures of colouring matter of two or more of those from item no. 3204.11 to 3204.19",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320420",
    description:
      "Dyes; synthetic organic products of a kind used as fluorescent brightening agents",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320490",
    description:
      "Dyes; synthetic organic products n.e.c. in heading no. 3204 (e.g. of a kind used as luminophores), whether or not chemically defined",
    parent: "3204",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3205",
    description:
      "Colour lakes; preparations based on colour lakes as specified in note 3 to this chapter",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320500",
    description:
      "Colour lakes; preparations based on colour lakes as specified in note 3 to this chapter",
    parent: "3205",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3206",
    description:
      "Colouring matter and preparations thereof n.e.c. in heading no. 3203, 3204, 3205; inorganic products, kind used as luminophores whether or not chemically defined",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320611",
    description:
      "Colouring matter; pigments and preparations based on titanium dioxide, containing 80% or more by weight of titanium dioxide calculated on the dry matter",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320619",
    description:
      "Colouring matter; pigments and preparations based on titanium dioxide, containing less than 80% by weight of titanium dioxide calculated on the dry weight",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320620",
    description:
      "Colouring matter; pigments and preparations based on chromium compounds",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320641",
    description: "Colouring matter; ultramarine and preparations based thereon",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320642",
    description:
      "Colouring matter; lithopone and other pigments and preparations based on zinc sulphide",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320649",
    description:
      "Colouring matter; other preparations n.e.c. in item no. 3206.4",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320650",
    description:
      "Colouring matter; inorganic products of a kind used as luminophores",
    parent: "3206",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3207",
    description:
      "Pigments, prepared; opacifiers, colours, vitrifiable enamels, glazes, engobes (slips), liquid lustres etc as used in the ceramic enamelling or glass industry; glass frit and powder, granules or flakes",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320710",
    description:
      "Pigments; prepared pigments, opacifiers, colours and similar preparations",
    parent: "3207",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320720",
    description:
      "Enamels and glazes; vitrifiable enamels and glazes, engobes (slips) and similar preparations",
    parent: "3207",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320730",
    description: "Lustres; liquid lustres and similar preparations",
    parent: "3207",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320740",
    description:
      "Glass; glass frit and other glass, in the form of powder, granules or flakes",
    parent: "3207",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3208",
    description:
      "Paints, varnishes; (enamels and lacquers) based on synthetic polymers or chemically modified natural polymers, dispersed or dissolved in a non-aqueous medium",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320810",
    description:
      "Paints and varnishes; based on polyesters, dispersed or dissolved in a non-aqueous medium",
    parent: "3208",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320820",
    description:
      "Paints and varnishes; based on acrylic or vinyl polymers, dispersed or dissolved in a non-aqueous medium",
    parent: "3208",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320890",
    description:
      "Paints and varnishes; based on polymers n.e.c. in heading no. 3208, dispersed or dissolved in a non-aqueous medium",
    parent: "3208",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3209",
    description:
      "Paints and varnishes (including enamels and lacquers) based on synthetic or chemically modified natural polymers, dispersed or dissolved in an aqueous medium",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "320910",
    description:
      "Paints and varnishes; based on acrylic or vinyl polymers, dispersed or dissolved in an aqueous medium",
    parent: "3209",
    level: "6",
  },
  {
    section: "VI",
    hscode: "320990",
    description:
      "Paints and varnishes; (based on polymers other than acrylic or vinyl), dispersed or dissolved in an aqueous medium",
    parent: "3209",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3210",
    description:
      "Paints and varnishes (including enamels, lacquers and distempers), excluding those of heading no. 3209, prepared water pigments of a kind used for finishing leather",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "321000",
    description:
      "Paints and varnishes; (including enamels, lacquers and distempers), prepared water pigments of a kind used for finishing leather",
    parent: "3210",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3211",
    description: "Driers; prepared",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "321100",
    description: "Driers; prepared",
    parent: "3211",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3212",
    description:
      "Pigments (metallic powders and flakes) dispersed in non-aqueous media in liquid or paste form, as used in manufacture of paints (including enamels); stamping foils, dyes etc in forms, packing for retail sale",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "321210",
    description:
      "Pigments; of a kind used in the manufacture of paints, stamping foils",
    parent: "3212",
    level: "6",
  },
  {
    section: "VI",
    hscode: "321290",
    description:
      "Pigments; of a kind used in the manufacture of paints, other than stamping foils",
    parent: "3212",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3213",
    description:
      "Colours; artists, students, or signboard painters, modifying tints, amusement colours and the like; in tablets, tubes, jars, bottles, pan or in similar forms or packings",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "321310",
    description:
      "Colours; in sets, of a kind used by artists, students or signboard painters",
    parent: "3213",
    level: "6",
  },
  {
    section: "VI",
    hscode: "321390",
    description:
      "Colours; (other than in sets), of a kind used by artists, students or signboard painters",
    parent: "3213",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3214",
    description:
      "Glaziers' putty, grafting putty, resin cements, caulking compounds and other mastics; painters' fillings; non-refractory surfacing preparations for facades, indoor walls, floors, ceilings or the like",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "321410",
    description: "Mastics; painters' fillings",
    parent: "3214",
    level: "6",
  },
  {
    section: "VI",
    hscode: "321490",
    description: "Mastics; n.e.c. in heading no. 3214",
    parent: "3214",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3215",
    description:
      "Ink; printing, writing or drawing ink and other inks; whether or not concentrated or solid",
    parent: "32",
    level: "4",
  },
  {
    section: "VI",
    hscode: "321511",
    description:
      "Ink; for printing, black, whether or not concentrated or solid",
    parent: "3215",
    level: "6",
  },
  {
    section: "VI",
    hscode: "321519",
    description:
      "Ink; for printing, other than black, whether or not concentrated or solid",
    parent: "3215",
    level: "6",
  },
  {
    section: "VI",
    hscode: "321590",
    description:
      "Ink; writing, drawing and other inks, n.e.c. in heading no. 3215, whether or not concentrated or solid",
    parent: "3215",
    level: "6",
  },
  {
    section: "VI",
    hscode: "33",
    description:
      "Essential oils and resinoids; perfumery, cosmetic or toilet preparations",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3301",
    description:
      "Oils; essential (concretes, absolutes); concentrates thereof in fats, fixed oils, waxes or the like (obtained by enfleurage or maceration); aqueous distillates, solutions and terpenic by-products thereof; resinoids; extracted oleoresins",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330112",
    description:
      "Oils, essential; of orange (terpeneless or not), including concretes and absolutes",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330113",
    description:
      "Oils, essential; of lemon (terpeneless or not), including concretes and absolutes",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330119",
    description:
      "Oils, essential; of citrus fruits n.e.c. in heading no. 3301 (terpeneless or not), including concretes and absolutes",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330124",
    description:
      "Oils, essential; of peppermint (Mentha piperita), terpeneless or not, including concretes and absolutes",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330125",
    description:
      "Oils, essential; of mints (excluding peppermint), terpeneless or not, including concretes and absolutes",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330129",
    description:
      "Oils, essential; n.e.c. in heading no. 3301 (terpeneless or not), including concretes and absolutes",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330130",
    description: "Resinoids",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330190",
    description:
      "Oils, essential; concentrates in fats, fixed oils, waxes and the like, terpenic by-products, aqueous distillates and solutions, extracted oleoresins, n.e.c. in heading no. 3301",
    parent: "3301",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3302",
    description:
      "Odoriferous substances and mixtures (including alcoholic solutions) with a basis of one or more of these substances, of a kind used as raw materials in industry; other preparations based on odoriferous substances, of a kind used for beverage manufacture",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330210",
    description:
      "Odoriferous substances and mixtures; of a kind used in the food or drink industries",
    parent: "3302",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330290",
    description:
      "Odoriferous substances and mixtures; used as raw materials in industries other than the food or drink industries",
    parent: "3302",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3303",
    description: "Perfumes and toilet waters",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330300",
    description: "Perfumes and toilet waters",
    parent: "3303",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3304",
    description:
      "Cosmetic and toilet preparations; beauty, make-up and skin care preparations (excluding medicaments, including sunscreen or sun tan preparations), manicure or pedicure preparations",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330410",
    description: "Cosmetic and toilet preparations; lip make-up",
    parent: "3304",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330420",
    description: "Cosmetic and toilet preparations; eye make-up",
    parent: "3304",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330430",
    description:
      "Cosmetic and toilet preparations; manicure or pedicure preparations",
    parent: "3304",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330491",
    description:
      "Cosmetic and toilet preparations; powders, whether or not compressed (excluding lip, eye, manicure or pedicure preparations)",
    parent: "3304",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330499",
    description:
      "Cosmetic and toilet preparations; n.e.c. in heading no. 3304, for the care of the skin (excluding medicaments, including sunscreen or sun tan preparations)",
    parent: "3304",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3305",
    description: "Hair preparations; for use on the hair",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330510",
    description: "Hair preparations; shampoos",
    parent: "3305",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330520",
    description: "Hair preparations; for permanent waving or straightening",
    parent: "3305",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330530",
    description: "Hair preparations; lacquers",
    parent: "3305",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330590",
    description: "Hair preparations; n.e.c. in heading no. 3305",
    parent: "3305",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3306",
    description:
      "Oral or dental hygiene preparations; including fixative pastes and powders; yarn used to clean between the teeth (dental floss), in individual retail packages",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330610",
    description: "Oral or dental hygiene preparations; dentifrices",
    parent: "3306",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330620",
    description:
      "Oral or dental hygiene preparations; yarn used to clean between the teeth (dental floss)",
    parent: "3306",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330690",
    description: "Oral or dental hygiene preparations; other than dentifrices",
    parent: "3306",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3307",
    description:
      "Perfumery, cosmetic or toilet preparations; pre-shave, shaving, after-shave, bath preparations; personal deodorants and depilatories; room deodorisers, perfumed or not with disinfectant properties or not",
    parent: "33",
    level: "4",
  },
  {
    section: "VI",
    hscode: "330710",
    description:
      "Perfumery, cosmetic or toilet preparations; pre-shave, shaving or after-shave preparations",
    parent: "3307",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330720",
    description:
      "Perfumery, cosmetic or toilet preparations; personal deodorants and antiperspirants",
    parent: "3307",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330730",
    description:
      "Perfumery, cosmetic or toilet preparations; perfumed bath salts and other bath preparations",
    parent: "3307",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330741",
    description:
      "Perfumes and deodorizers; perfuming or deodorizing preparations for rooms, agarbatti and other odoriferous preparations which operate by burning (including those used during religious rites)",
    parent: "3307",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330749",
    description:
      "Perfumes and deodorizers; perfuming or deodorizing preparations for rooms, (excluding those which operate by burning)",
    parent: "3307",
    level: "6",
  },
  {
    section: "VI",
    hscode: "330790",
    description:
      "Perfumes and deodorizers; perfuming or deodorizing preparations n.e.c. in heading no. 3307",
    parent: "3307",
    level: "6",
  },
  {
    section: "VI",
    hscode: "34",
    description:
      "Soap, organic surface-active agents; washing, lubricating, polishing or scouring preparations; artificial or prepared waxes, candles and similar articles, modelling pastes, dental waxes and dental preparations with a basis of plaster",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3401",
    description:
      "Soap; organic surface-active preparations used as soap, skin washing, in bars, cakes, moulded pieces, shapes, liquid or cream, containing soap or not; for retail, paper, wadding, felt and nonwovens, impregnated, coated or covered with soap or detergent",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340111",
    description:
      "Soap and organic surface-active products; in the form of bars, cakes, moulded shapes, and paper, wadding, felt and nonwovens, impregnated, coated or covered with soap or detergent, for toilet use (including medicated products)",
    parent: "3401",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340119",
    description:
      "Soap and organic surface-active products; in the form of bars, cakes, moulded shapes, and paper, wadding, felt and nonwovens, impregnated, coated or covered with soap or detergent, not for toilet use",
    parent: "3401",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340120",
    description: "Soap; in forms n.e.c. in item no. 3401.11",
    parent: "3401",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340130",
    description:
      "Organic surface-active products and preparations for washing the skin, in the form of liquid or cream and put up for retail sale, whether or not containing soap",
    parent: "3401",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3402",
    description:
      "Organic surface-active agents (not soap); surface-active, washing (including auxiliary washing) and cleaning preparations, containing soap or not, excluding those of heading no. 3401",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340231",
    description:
      "Anionic organic surface-active agents (other than soap); linear alkylbenzene sulphonic acids and their salts, whether or not put up for retail sale",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340239",
    description:
      "Anionic organic surface-active agents (other than soap); other than linear alkylbenzene sulphonic acids and their salts, whether or not put up for retail sale",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340241",
    description:
      "Organic surface-active agents; cationic (other than soap), whether or not put up for retail sale",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340242",
    description:
      "Organic surface-active agents; non-ionic (other than soap), whether or not put up for retail sale",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340249",
    description:
      "Organic surface-active agents; whether or not put up for retail sale, n.e.c. in item no. 3402",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340250",
    description:
      "Washing and cleaning preparations; powders, flakes and granules, surface-active, whether or not containing soap (excluding those of heading no. 3401), put up for retail sale",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340290",
    description:
      "Washing and cleaning preparations; surface-active, whether or not containing soap (excluding those of heading no. 3401), including auxiliary washing preparations, not for retail sale",
    parent: "3402",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3403",
    description:
      "Lubricating preparations and those used in oil or grease treatment of textile and similar materials; excluding preparations containing 70% or more (by weight) of petroleum or bituminous mineral oils",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340311",
    description:
      "Lubricating preparations; for the treatment of textile and similar materials (leather, furskins etc), containing less than 70% (by weight) of petroleum oils or oils obtained from bituminous minerals",
    parent: "3403",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340319",
    description:
      "Lubricating preparations; (other than for the treatment of textile and similar materials), containing less than 70% (by weight) of petroleum oils or oils obtained from bituminous minerals",
    parent: "3403",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340391",
    description:
      "Lubricating preparations; for the treatment of textile and similar materials (leather, furskins etc), (not containing petroleum oils or oils obtained from bituminous minerals)",
    parent: "3403",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340399",
    description:
      "Lubricating preparations; other than for the treatment of textile and similar materials, not containing petroleum oils or oils obtained from bituminous minerals",
    parent: "3403",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3404",
    description: "Waxes; artificial, prepared",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340420",
    description:
      "Waxes; artificial and prepared, of poly(oxyethylene) (polyethylene glycol)",
    parent: "3404",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340490",
    description:
      "Waxes; artificial and prepared, other than of polyethylene glycol",
    parent: "3404",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3405",
    description:
      "Polishes, creams, scouring pastes, powders and similar; in any form, (including articles impregnated, coated or covered with such), for furniture, footwear, floors, coachwork, glass or metal",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340510",
    description:
      "Polishes, creams and similar preparations; for footwear or leather, excluding waxes of heading no. 3404",
    parent: "3405",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340520",
    description:
      "Polishes, creams and similar preparations; for the maintenance of wooden furniture, floors or other woodwork, excluding waxes of heading no. 3404",
    parent: "3405",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340530",
    description:
      "Polishes, creams and similar preparations; for coachwork, other than metal polishes, excluding waxes of heading no. 3404",
    parent: "3405",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340540",
    description:
      "Scouring pastes and powders and other scouring preparations; (whether or not in the form of paper, wadding, felt, nonwovens, cellular plastics, cellular rubber, impregnated, coated or covered)",
    parent: "3405",
    level: "6",
  },
  {
    section: "VI",
    hscode: "340590",
    description:
      "Polishes, creams and similar preparations; n.e.c. in heading no. 3405, excluding waxes of heading no. 3404",
    parent: "3405",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3406",
    description: "Candles, tapers and the like",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340600",
    description: "Candles, tapers and the like",
    parent: "3406",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3407",
    description:
      "Modelling pastes, including those for children; dental wax, impression compounds, in sets or packings for retail sale or in plates and similar forms; dentistry preparations with plaster base",
    parent: "34",
    level: "4",
  },
  {
    section: "VI",
    hscode: "340700",
    description:
      "Modelling pastes; preparations known as dental wax, put up in sets, in packings for retail sale or in plates, horseshoe shapes, sticks or similar forms, other preparations for use in dentistry",
    parent: "3407",
    level: "6",
  },
  {
    section: "VI",
    hscode: "35",
    description: "Albuminoidal substances; modified starches; glues; enzymes",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3501",
    description:
      "Casein, caseinates and other casein derivatives; casein glues",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350110",
    description: "Casein",
    parent: "3501",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350190",
    description: "Caseinates and other casein derivatives; casein glues",
    parent: "3501",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3502",
    description:
      "Albumins (including concentrates of two or more whey proteins, containing by weight more than 80% whey proteins, calculated on the dry matter), albuminates and other albumin derivatives",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350211",
    description: "Albumins; egg albumin, dried",
    parent: "3502",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350219",
    description: "Albumins; egg albumin, not dried",
    parent: "3502",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350220",
    description:
      "Albumins; milk albumin, including concentrates of two or more whey proteins",
    parent: "3502",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350290",
    description:
      "Albumins, albuminates and other albumin derivatives; other than egg or milk albumin, including concentrates of two or more whey proteins",
    parent: "3502",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3503",
    description:
      "Gelatin (including gelatin in rectangular sheets, whether or not surface-worked or coloured) and gelatin derivatives; isinglass; other glues of animal origin, excluding casein glues of heading no. 3501",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350300",
    description:
      "Gelatin (including gelatin in rectangular sheets, whether or not surface-worked or coloured) and gelatin derivatives; isinglass; other glues of animal origin, excluding casein glues of heading no. 3501",
    parent: "3503",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3504",
    description:
      "Peptones and their derivatives; other protein substances and their derivatives n.e.c. or included; hide powder, whether or not chromed",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350400",
    description:
      "Peptones and their derivatives; other protein substances and their derivatives n.e.c. or included, hide powder, whether or not chromed",
    parent: "3504",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3505",
    description:
      "Dextrins and other modified starches (e.g. pregelatinised or esterified starches); glues based on starches or on dextrins or other modified starches",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350510",
    description: "Dextrins and other modified starches",
    parent: "3505",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350520",
    description:
      "Glues; based on starches, or on dextrins or other modified starches",
    parent: "3505",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3506",
    description:
      "Prepared glues and other prepared adhesives, n.e.c. or included; products suitable for use as glues or adhesives, put up for retail sale as glues or adhesives, not exceeding 1kg net weight",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350610",
    description:
      "Glues or adhesives; prepared, products suitable for use as glues or adhesives, put up for retail sale as glues or adhesives, not exceeding a net weight of 1kg",
    parent: "3506",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350691",
    description:
      "Adhesives; prepared, based on polymers of heading 3901 to 3913 or on rubber",
    parent: "3506",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350699",
    description:
      "Glues and other adhesives; prepared, n.e.c. in heading no. 3506, not exceeding a net weight of 1kg",
    parent: "3506",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3507",
    description:
      "Enzymes; prepared enzymes not elsewhere specified or included",
    parent: "35",
    level: "4",
  },
  {
    section: "VI",
    hscode: "350710",
    description: "Enzymes; rennet and concentrates thereof",
    parent: "3507",
    level: "6",
  },
  {
    section: "VI",
    hscode: "350790",
    description:
      "Enzymes and prepared enzymes; other than rennet and concentrates thereof",
    parent: "3507",
    level: "6",
  },
  {
    section: "VI",
    hscode: "36",
    description:
      "Explosives; pyrotechnic products; matches; pyrophoric alloys; certain combustible preparations",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3601",
    description: "Explosives; propellent powders",
    parent: "36",
    level: "4",
  },
  {
    section: "VI",
    hscode: "360100",
    description: "Explosives; propellent powders",
    parent: "3601",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3602",
    description: "Prepared explosives, other than propellent powders",
    parent: "36",
    level: "4",
  },
  {
    section: "VI",
    hscode: "360200",
    description: "Explosives, prepared; other than propellent powders",
    parent: "3602",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3603",
    description:
      "Safety fuses; detonating cords; percussion or detonating caps; igniters; electric detonators",
    parent: "36",
    level: "4",
  },
  {
    section: "VI",
    hscode: "360310",
    description: "Safety fuses",
    parent: "3603",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360320",
    description: "Detonating cords",
    parent: "3603",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360330",
    description: "Percussion caps",
    parent: "3603",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360340",
    description: "Detonating caps",
    parent: "3603",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360350",
    description: "Igniters",
    parent: "3603",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360360",
    description: "Electric detonators",
    parent: "3603",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3604",
    description:
      "Fireworks, signalling flares, rain rockets, fog signals and other pyrotechnic articles",
    parent: "36",
    level: "4",
  },
  {
    section: "VI",
    hscode: "360410",
    description: "Pyrotechnic products; fireworks",
    parent: "3604",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360490",
    description:
      "Pyrotechnic products; signalling flares, rain rockets, fog signals and other pyrotechnic articles (excluding fireworks)",
    parent: "3604",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3605",
    description: "Matches; other than pyrotechnic articles of heading no. 3604",
    parent: "36",
    level: "4",
  },
  {
    section: "VI",
    hscode: "360500",
    description: "Matches; other than pyrotechnic articles of heading no. 3604",
    parent: "3605",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3606",
    description:
      "Ferro-cerium and other pyrophoric alloys in all forms; articles of combustible materials n.e.c. in chapter 36",
    parent: "36",
    level: "4",
  },
  {
    section: "VI",
    hscode: "360610",
    description:
      "Fuels; liquid or liquefied-gas, in containers, of a kind used for filling or refilling cigarette or similar lighters and of a capacity not exceeding 300cm3",
    parent: "3606",
    level: "6",
  },
  {
    section: "VI",
    hscode: "360690",
    description:
      "Ferro-cerium and other pyrophoric alloys in all forms; articles of combustible materials n.e.c. in chapter 36",
    parent: "3606",
    level: "6",
  },
  {
    section: "VI",
    hscode: "37",
    description: "Photographic or cinematographic goods",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3701",
    description:
      "Photographic plates and film in the flat, sensitised, unexposed, of any material other than paper, paperboard or textiles; instant print film in the flat, sensitised, unexposed, whether or not in packs",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370110",
    description:
      "Photographic plates and film; for x-ray, in the flat, sensitised, unexposed, of any material other than paper, paperboard or textiles",
    parent: "3701",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370120",
    description:
      "Photographic plates and film; instant print film, in the flat, sensitised, unexposed, whether or not in packs",
    parent: "3701",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370130",
    description:
      "Photographic plates and film; in the flat, sensitised, unexposed, with any side exceeding 225mm, of any materials other than paper, paperboard or textiles",
    parent: "3701",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370191",
    description:
      "Photographic plates and film; for colour photography (polychrome), in the flat, sensitised, unexposed, with no side exceeding 255mm, of any material other than paper, paperboard or textiles",
    parent: "3701",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370199",
    description:
      "Photographic plates and film; (for other than colour photography), in the flat, sensitised, unexposed, with no side exceeding 255mm, of any material other than paper, paperboard or textiles",
    parent: "3701",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3702",
    description:
      "Photographic film in rolls, sensitised, unexposed, of any material other than paper, paperboard or textiles; instant print film in rolls, sensitised, unexposed",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370210",
    description:
      "Photographic film; for x-rays, in rolls, sensitised and unexposed (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370231",
    description:
      "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, without sprocket holes, of a width not exceeding 105mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370232",
    description:
      "Photographic film; in rolls, with silver halide emulsion, sensitised, unexposed, without sprocket holes, of a width not exceeding 105mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370239",
    description:
      "Photographic film; in rolls, (other than with silver halide emulsion and for colour photography), sensitised, unexposed, without sprocket holes, of a width not exceeding 105mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370241",
    description:
      "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, without sprocket holes, of a width exceeding 610mm and of a length exceeding 200m (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370242",
    description:
      "Photographic film; in rolls, (other than for colour photography), sensitised, unexposed, without sprocket holes, of a width exceeding 610mm and of a length exceeding 200m (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370243",
    description:
      "Photographic film; in rolls, sensitised, unexposed, without sprocket holes, of a width exceeding 610mm and of a length not exceeding 200m (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370244",
    description:
      "Photographic film; in rolls, sensitised, unexposed, without sprocket holes, of a width exceeding 105mm but not exceeding 610mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370252",
    description:
      "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width not exceeding 16mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370253",
    description:
      "Photographic film; for colour photography (polychrome) slides, in rolls, sensitised, unexposed, of a width exceeding 16mm but not exceeding 35mm and of a length not exceeding 30m (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370254",
    description:
      "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width exceeding 16mm but not 35mm and of a length not exceeding 30m, excluding film for slides (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370255",
    description:
      "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width exceeding 16mm but not 35mm and of a length exceeding 30m (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370256",
    description:
      "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width exceeding 35mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370296",
    description:
      "Photographic film; other than for colour photography, in rolls, sensitised, unexposed, of a width not exceeding 35mm and of a length not exceeding 30m (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370297",
    description:
      "Photographic film; other than for colour photography, in rolls, sensitised, unexposed, of a width not exceeding 35mm and of a length exceeding 30m (other than paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370298",
    description:
      "Photographic film; other than for colour photography, in rolls, sensitised, unexposed, of a width exceeding 35mm (other than of paper, paperboard or textiles)",
    parent: "3702",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3703",
    description:
      "Photographic paper, paperboard and textiles; sensitised, unexposed",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370310",
    description:
      "Photographic paper, paperboard and textiles; in rolls, sensitised, unexposed, of a width exceeding 610mm",
    parent: "3703",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370320",
    description:
      "Photographic paper, paperboard and textiles; for colour photography (polychrome), (other than in rolls of a width exceeding 610mm), sensitised, unexposed",
    parent: "3703",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370390",
    description:
      "Photographic paper, paperboard and textiles; (for other than colour photography, other than in rolls of a width exceeding 610mm), sensitised, unexposed",
    parent: "3703",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3704",
    description:
      "Photographic plates, film, paper, paperboard and textiles, exposed but not developed",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370400",
    description:
      "Photographic plates, film, paper, paperboard and textiles; exposed but not developed",
    parent: "3704",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3705",
    description:
      "Photographic plates and film; exposed and developed, other than cinematographic film",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370500",
    description:
      "Photographic plates and film; exposed and developed, other than cinematographic film",
    parent: "3705",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3706",
    description:
      "Cinematographic film; exposed and developed, whether or not incorporating sound track or consisting only of sound track",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370610",
    description:
      "Cinematographic film; exposed and developed, whether or not incorporating sound track or consisting only of sound track, of a width of 35cm or more",
    parent: "3706",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370690",
    description:
      "Cinematographic film; exposed and developed, whether or not incorporating a sound track or consisting only of sound track, of a width less than 35mm",
    parent: "3706",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3707",
    description:
      "Chemical preparations for photographic uses (other than varnishes, glues, adhesives and similar preparations); unmixed products for photographic uses, put up in measured portions or for retail sale",
    parent: "37",
    level: "4",
  },
  {
    section: "VI",
    hscode: "370710",
    description:
      "Photographic goods; sensitised emulsions, put up in measured portions or put up for retail sale in a form ready for use",
    parent: "3707",
    level: "6",
  },
  {
    section: "VI",
    hscode: "370790",
    description:
      "Photographic goods; chemical preparations other than sensitised emulsions, put up in measured portions or put up for retail sale in a form ready for use",
    parent: "3707",
    level: "6",
  },
  {
    section: "VI",
    hscode: "38",
    description: "Chemical products n.e.c.",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VI",
    hscode: "3801",
    description:
      "Artificial graphite; colloidal or semi-colloidal graphite; preparations based on graphite or other carbon in the form of pastes, blocks, plates or other semi-manufactures",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380110",
    description: "Graphite; artificial",
    parent: "3801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380120",
    description: "Graphite; colloidal or semi-colloidal",
    parent: "3801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380130",
    description:
      "Carbonaceous pastes; for electrodes and similar pastes for furnace linings",
    parent: "3801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380190",
    description:
      "Graphite or other carbon based preparations; in the form of pastes, blocks, plates or other semi-manufactures",
    parent: "3801",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3802",
    description:
      "Activated carbon; activated natural mineral products; animal black, including spent animal black",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380210",
    description: "Carbon; activated",
    parent: "3802",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380290",
    description:
      "Chemical products; activated natural mineral products, animal black, including spent animal black",
    parent: "3802",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3803",
    description: "Tall oil, whether or not refined",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380300",
    description: "Chemical products; tall oil, whether or not refined",
    parent: "3803",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3804",
    description:
      "Residual lyes from the manufacture of wood pulp, whether or not concentrated, desugared or chemically treated, including lignin sulphonates, but excluding tall oil of heading no. 3803",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380400",
    description:
      "Lyes, residual; from the manufacture of wood pulp, whether or not concentrated, desugared or chemically treated, including lignin sulphonates but excluding tall oil of heading no. 3803",
    parent: "3804",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3805",
    description:
      "Gum, wood or sulphate turpentine, other terpenic oils; crude dipentene; sulphite turpentine, other crude para-cymene; pine oil containing alpha-terpineol as the main constituent",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380510",
    description: "Terpenic oils; gum, wood or sulphate turpentine oils",
    parent: "3805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380590",
    description:
      "Terpenic oils; produced by the treatment of coniferous woods, crude dipentene, sulphite turpentine and other crude para-cymene, n.e.c. in heading no. 3805",
    parent: "3805",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3806",
    description:
      "Rosin and resin acids and derivatives thereof; rosin spirit and rosin oils; run gums",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380610",
    description: "Rosin and resin acids",
    parent: "3806",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380620",
    description:
      "Rosin and resin; salts of rosin, of resin acids or of derivatives of rosin or resin acids, other than salts of rosin adducts",
    parent: "3806",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380630",
    description: "Ester gums",
    parent: "3806",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380690",
    description: "Rosin; spirit and oils, n.e.c. in heading no. 3806",
    parent: "3806",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3807",
    description:
      "Wood tar; wood tar oils; wood creosote; wood naphtha; vegetable pitch; brewers' pitch and similar preparations based on rosin, resin acids or on vegetable pitch",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380700",
    description:
      "Wood tar; wood tar oils; wood creosote; wood naphtha; vegetable pitch; brewers' pitch and similar preparations based on rosin, resin acids or on vegetable pitch",
    parent: "3807",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3808",
    description:
      "Insecticides, rodenticides, fungicides, herbicides, anti-sprouting products, plant growth regulators, disinfectants and the like, put up in forms or packings for retail sale or as preparations or articles",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380852",
    description:
      "Insecticides and the like; containing goods specified in Subheading Note 1 to this Chapter; for retail sale or as preparations or articles; DDT (ISO) (clofenotane (INN)), in packings of 300g or less",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380859",
    description:
      "Insecticides, rodenticides, fungicides, disinfectants, herbicides and the like; containing goods specified in Subheading Note 1 to this Chapter; not DDT (ISO) (clofenotane (INN)), put up in forms or packings for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380861",
    description:
      "Insecticides and the like; containing goods specified in Subheading Note 2 to this Chapter; in packings of a net weight content not exceeding 300g; for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380862",
    description:
      "Insecticides; containing goods specified in Subheading Note 2 to this Chapter; put up in forms or packings for retail sale or as preparations or articles, in packings of a net weight content exceeding 300g but not exceeding 7.5kg",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380869",
    description:
      "Insecticides; containing goods named in Subheading Note 2 to this Chapter, put up in forms or packings for retail sale or as preparations or articles, in packings of a net weight content exceeding 7.5kg",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380891",
    description:
      "Insecticides; other than containing goods specified in Subheading Notes 1 & 2 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380892",
    description:
      "Fungicides; other than containing goods specified in Subheading Note 1 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380893",
    description:
      "Herbicides, anti-sprouting products and plant-growth regulators; other than containing goods of Subheading Note 1 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380894",
    description:
      "Disinfectants; other than containing goods specified in Subheading Note 1 in this Chapter; put up in forms or packings for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380899",
    description:
      "Rodenticides and other similar products n.e.c. in heading no. 3808.9; other than containing goods specified in Subheading Note 1 in this Chapter, put up in forms or packings for retail sale or as preparations or articles",
    parent: "3808",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3809",
    description:
      "Finishing agents, dye carriers to accelerate the dyeing, fixing of dyestuffs, other products and preparations, of a kind used in the textile, paper, leather or like industries, n.e.c. or included",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "380910",
    description:
      "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in textile, paper, leather etc industries, with basis of amylaceous substances, n.e.c.",
    parent: "3809",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380991",
    description:
      "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in the textile industry (excluding those with a basis of amylaceous substances)",
    parent: "3809",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380992",
    description:
      "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in the paper industry (excluding those with a basis of amylaceous substances)",
    parent: "3809",
    level: "6",
  },
  {
    section: "VI",
    hscode: "380993",
    description:
      "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in the leather or like (excluding paper and textile) industries, (excluding those with a basis of amylaceous substances)",
    parent: "3809",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3810",
    description:
      "Metal-pickling preparations; fluxes etc for soldering, brazing; welding powders, pastes of metal and other materials; preparations used as cores or coatings for welding electrodes or rods",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381010",
    description:
      "Pickling preparations for metal surfaces; soldering, brazing or welding powders and pastes consisting of metal and other materials",
    parent: "3810",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381090",
    description:
      "Fluxes and other auxiliary preparations; for soldering, brazing or welding, or preparations used as cores or coatings for welding electrodes or rods",
    parent: "3810",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3811",
    description:
      "Anti-knock preparations, oxidation and gum inhibitors, viscosity improvers, anti-corrosive preparations and the like, for mineral oils (including gasoline) or other liquids used for the same purposes",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381111",
    description: "Anti-knock preparations; based on lead compounds",
    parent: "3811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381119",
    description:
      "Anti-knock preparations; other than those based on lead compounds",
    parent: "3811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381121",
    description:
      "Lubricating oil additives; containing petroleum oils or oils obtained from bituminous minerals",
    parent: "3811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381129",
    description:
      "Lubricating oil additives; not containing petroleum oils or oils obtained from bituminous minerals",
    parent: "3811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381190",
    description:
      "Oxidation and gum inhibitors, viscosity improvers, anti-corrosive preparations, other prepared additives for mineral oils or liquids used as mineral oils (including gasoline), n.e.c. in heading no. 3811",
    parent: "3811",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3812",
    description:
      "Prepared rubber accelerators; compound plasticisers for rubber or plastics, n.e.c. or included; anti-oxidising preparations and other compound stabilisers for rubber or plastics",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381210",
    description: "Rubber accelerators; prepared",
    parent: "3812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381220",
    description: "Plasticisers, compound; for rubber or plastics",
    parent: "3812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381231",
    description:
      "Anti-oxidising preparations and other compound stabilisers; for rubber or plastics, mixtures of oligomers of 2,2,4-trimethyl-1,2-dihydroquinoline (TMQ)",
    parent: "3812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381239",
    description:
      "Anti-oxidising preparations and other compound stabilisers; for rubber or plastics, other than mixtures of oligomers of 2,2,4-trimethyl-1,2-dihydroquinoline (TMQ)",
    parent: "3812",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3813",
    description:
      "Preparations and charges for fire extinguishers; charged fire-extinguishing grenades",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381300",
    description:
      "Fire-extinguishers; preparations and charges and charged fire-extinguishing grenades",
    parent: "3813",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3814",
    description:
      "Organic composite solvents and thinners, not elsewhere specified or included; prepared paint or varnish removers",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381400",
    description:
      "Solvents and thinners; organic composite solvents and thinners, n.e.c. or included, prepared paint or varnish removers",
    parent: "3814",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3815",
    description:
      "Reaction initiators, reaction accelerators and catalytic preparations n.e.c. or included",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381511",
    description:
      "Catalysts, supported; reaction initiators, reaction accelerators and catalytic preparations, with nickel or nickel compounds as the active substance, n.e.c. or included",
    parent: "3815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381512",
    description:
      "Catalysts, supported; reaction initiators, reaction accelerators and catalytic preparations, with precious metal or precious metal compounds as the active substance, n.e.c. or included",
    parent: "3815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381519",
    description:
      "Catalysts, supported; reaction initiators, reaction accelerators and catalytic preparations, with an active substance other than nickel or precious metals or their compounds, n.e.c. or included",
    parent: "3815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "381590",
    description:
      "Reaction initiators, reaction accelerators and catalytic preparations, unsupported, n.e.c. or included",
    parent: "3815",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3816",
    description:
      "Refractory cements, mortars, concretes and similar compositions, including dolomite ramming mix, other than products of heading 38.01",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381600",
    description:
      "Refractory cements, mortars, concretes and similar compositions, including dolomite ramming mix, other than products of heading 38.01",
    parent: "3816",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3817",
    description:
      "Mixed alkylbenzenes and mixed alkylnaphthalenes, other than those of heading no. 2707 or 2902",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381700",
    description:
      "Mixed alkylbenzenes and mixed alkylnaphthalenes, other than those of heading no. 2707 or 2902",
    parent: "3817",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3818",
    description:
      "Chemical elements doped for use in electronics, in the form of discs, wafers or similar forms; chemical compounds doped for use in electronics",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381800",
    description:
      "Chemical elements; doped for use in electronics, in the form of discs, wafers or similar forms; chemical compounds doped for use in electronics",
    parent: "3818",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3819",
    description:
      "Hydraulic brake fluids and other prepared liquids for hydraulic transmission, not containing or containing less than 70% by weight of petroleum oils or oils obtained from bituminous minerals",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "381900",
    description:
      "Hydraulic fluids; for brakes and other prepared liquids for hydraulic transmission, not containing or containing less than 70% by weight of petroleum oils or oils obtained from bituminous minerals",
    parent: "3819",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3820",
    description: "Anti-freezing preparations and prepared de-icing fluids",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382000",
    description: "Anti-freezing preparations and prepared de-icing fluids",
    parent: "3820",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3821",
    description:
      "Prepared culture media for the development or maintenance of micro-organisms (including viruses and the like) or of plant, human or animal cells",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382100",
    description:
      "Prepared culture media for the development or maintenance of micro-organisms (including viruses and the like) or of plant, human or animal cells",
    parent: "3821",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3822",
    description:
      "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits, other than those of heading 30.06; certified reference materials",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382211",
    description:
      "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; for malaria",
    parent: "3822",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382212",
    description:
      "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; for zika and other diseases transmitted by mosquitoes of the genus Aedes",
    parent: "3822",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382213",
    description:
      "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; for blood grouping",
    parent: "3822",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382219",
    description:
      "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; n.e.c.in item 3822.1",
    parent: "3822",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382290",
    description:
      "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, or put up in the form of kits, other than those of heading 30.06; certified reference materials, n.e.c. in heading 3822",
    parent: "3822",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3823",
    description:
      "Industrial monocarboxylic fatty acids; acid oils from refining; industrial fatty alcohols",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382311",
    description:
      "Industrial monocarboxylic fatty acids, acid oils from refining; stearic acid",
    parent: "3823",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382312",
    description:
      "Industrial monocarboxylic fatty acids, acid oils from refining; oleic acid",
    parent: "3823",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382313",
    description:
      "Industrial monocarboxylic fatty acids, acid oils from refining; tall oil fatty acids",
    parent: "3823",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382319",
    description:
      "Industrial monocarboxylic fatty acids; acid oils from refining; (other than stearic acid, oleic acid or tall oil fatty acids)",
    parent: "3823",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382370",
    description: "Industrial fatty alcohols",
    parent: "3823",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3824",
    description:
      "Prepared binders for foundry moulds or cores; chemical products and preparations of the chemical or allied industries (including those consisting of mixtures of natural products), not elsewhere specified or included",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382410",
    description: "Binders, prepared; for foundry moulds or cores",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382430",
    description:
      "Metal carbides, non-agglomerated; mixed together or with metallic binders",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382440",
    description: "Cements, mortars or concretes; their prepared additives",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382450",
    description: "Mortars and concretes; non-refractory",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382460",
    description: "Sorbitol; other than that of subheading no. 2905.44",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382481",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing oxirane (ethylene oxide)",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382482",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing polychlorinated biphenyls (PCBs), polychlorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382483",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing tris(2,3-dibromopropyl) phosphate",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382484",
    description:
      "Chemical products, mixtures and preparations; containing aldrin, camphechlor (toxaphene), chlordane, chlordecone, DDT (chlorfenotane, 1,1,1-trichloro-2,2-bis(p-chlorophenyl)ethane), dieldrin, endosulfan, endrin, heptachlor or mirex",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382485",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing 1,2,3,4,5,6-hexachlorocyclohexane (HCH (ISO)), including lindane (ISO, INN)",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382486",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing pentachlorobenzene (ISO) or hexachlorobenzene (ISO)",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382487",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing perfluorooctane sulphonic acid, its salts, perfluorooctane sulphonamides, or perfluorooctane sulphonyl fluoride",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382488",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing tetra-, penta-, hexa-, hepta- or octabromodiphenyl ethers",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382489",
    description:
      "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing short-chain chlorinated paraffins",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382491",
    description:
      "Chemical products, mixtures and preparations; consisting mainly of (5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl methyl methylphosphonate and bis[(5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl] methylphosphonate",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382492",
    description:
      "Chemical products, mixtures and preparations; polyglycol esters of methylphosphonic acid",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382499",
    description:
      "Chemical products, mixtures and preparations; n.e.c. heading 3824",
    parent: "3824",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3825",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; municipal waste; sewage sludge; other residual products.",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382510",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; municipal waste",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382520",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; sewage sludge",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382530",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; clinical waste",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382541",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; halogenated waste organic solvents",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382549",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; waste organic solvents, other than halogenated",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382550",
    description:
      "Residual products of chemical or allied industries, not elsewhere specified or included; wastes of metal pickling liquors, hydraulic fluids, brake fluids and anti-freeze fluids",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382561",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; (other than sewage sludge, municipal waste or waste covered in 27.10); other wastes n.e.c. in 3825; those mainly containing organic constituents",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382569",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; (other than sewage sludge, municipal waste or waste covered by 27.10); other wastes n.e.c. in 3825; except those mainly containing organic constituents",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382590",
    description:
      "Residual products of the chemical or allied industries, not elsewhere specified or included; n.e.c. in 3825 or 27.10",
    parent: "3825",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3826",
    description:
      "Biodiesel and mixtures thereof; not containing or containing less than 70% by weight of petroleum oils or oils obtained from bituminous minerals",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382600",
    description:
      "Biodiesel and mixtures thereof; not containing or containing less than 70% by weight of petroleum oils or oils obtained from bituminous minerals",
    parent: "3826",
    level: "6",
  },
  {
    section: "VI",
    hscode: "3827",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included",
    parent: "38",
    level: "4",
  },
  {
    section: "VI",
    hscode: "382711",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing chlorofluorocarbons (CFCs), whether or not containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbon",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382712",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing hydrobromofluorocarbons (HBFCs)",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382713",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing carbon tetrachloride",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382714",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing 1,1,1-trichloroethane (methyl chloroform)",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382720",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing bromochlorodifluoromethane (Halon-1211), bromotrifluoromethane (Halon-1301) or dibromotetrafluoroethanes (Halon-2402)",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382731",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, but not containing chlorofluorocarbons (CFCs); containing substances of su",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382732",
    description:
      "Mixtures containing halogenated methane, ethane, propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, not chlorofluorocarbons (CFCs); containing substances of subheadings 2903.71 to 2903.75",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382739",
    description:
      "Mixtures containing halogenated methane, ethane, or propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, but not chlorofluorocarbons (CFCs); n.e.c. in subheading 3827.3",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382740",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, but not containing chlorofluorocarbons (CFCs); containing bromomethane (me",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382751",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing trifluoromethan (HFC-23) or perfluorocarbons (PFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); containing trifluoromethane (HFC-2",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382759",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing trifluoromethan (HFC-23) or perfluorocarbons (PFCs) not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures n.e.c. in subheading 38",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382761",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); containing 15% or more by mass of 1,1,1-trifluoroethan",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382762",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheading above,",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382763",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures not included in the subheadings above,",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382764",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheadings above,",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382765",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheadings above,",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382768",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheadings above,",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382769",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); n.e.c. in items no. 3827.5 and 3827.6, not containing",
    parent: "3827",
    level: "6",
  },
  {
    section: "VI",
    hscode: "382790",
    description:
      "Mixtures containing halogenated derivatives of methane, ethane or propane; n.e.c. in subheading no 3827",
    parent: "3827",
    level: "6",
  },
  {
    section: "VII",
    hscode: "39",
    description: "Plastics and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VII",
    hscode: "3901",
    description: "Polymers of ethylene, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390110",
    description:
      "Ethylene polymers; in primary forms, polyethylene having a specific gravity of less than 0.94",
    parent: "3901",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390120",
    description:
      "Ethylene polymers; in primary forms, polyethylene having a specific gravity of 0.94 or more",
    parent: "3901",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390130",
    description:
      "Ethylene polymers; in primary forms, ethylene-vinyl acetate copolymers",
    parent: "3901",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390140",
    description:
      "Ethylene polymers; in primary forms, ethylene-alpha-olefin copolymers, having a specific gravity of less than 0.94",
    parent: "3901",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390190",
    description:
      "Ethylene polymers; in primary forms, n.e.c. in heading no. 3901",
    parent: "3901",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3902",
    description: "Polymers of propylene or of other olefins, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390210",
    description:
      "Propylene, other olefin polymers; polypropylene in primary forms",
    parent: "3902",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390220",
    description:
      "Propylene, other olefin polymers; polyisobutylene in primary forms",
    parent: "3902",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390230",
    description:
      "Propylene, other olefin polymers; propylene copolymers in primary forms",
    parent: "3902",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390290",
    description:
      "Propylene, other olefin polymers; n.e.c. in heading no. 3902, in primary forms",
    parent: "3902",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3903",
    description: "Polymers of styrene, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390311",
    description: "Styrene polymers; expansible polystyrene, in primary forms",
    parent: "3903",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390319",
    description:
      "Styrene polymers; (other than expansible polystyrene), in primary forms",
    parent: "3903",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390320",
    description:
      "Styrene polymers; styrene-acrylonitrile (SAN) copolymers, in primary forms",
    parent: "3903",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390330",
    description:
      "Styrene polymers; acrylonitrile-butadiene-styrene (ABS) copolymers, in primary forms",
    parent: "3903",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390390",
    description:
      "Styrene polymers; in primary forms, n.e.c. in heading no. 3903",
    parent: "3903",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3904",
    description:
      "Polymers of vinyl chloride or of other halogenated olefins, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390410",
    description:
      "Vinyl chloride, other halogenated olefin polymers; poly(vinyl chloride), not mixed with any other substances, in primary forms",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390421",
    description:
      "Vinyl chloride, other halogenated olefin polymers; non-plasticised poly(vinyl chloride), in primary forms, mixed with other substances",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390422",
    description:
      "Vinyl chloride, other halogenated olefin polymers; plasticised poly(vinyl chloride), in primary forms, mixed with other substances",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390430",
    description:
      "Vinyl chloride, other halogenated olefin polymers; vinyl chloride-vinyl acetate copolymers, in primary forms",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390440",
    description:
      "Vinyl chloride, other halogenated olefin polymers; vinyl chloride copolymers, in primary forms n.e.c. in heading no. 3904",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390450",
    description:
      "Vinyl chloride, other halogenated olefin polymers; vinylidene chloride polymers, in primary forms",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390461",
    description:
      "Halogenated olefin polymers; fluoro-polymers, polytetrafluoroethylene, in primary forms",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390469",
    description:
      "Halogenated olefin polymers; fluoro-polymers (other than polytetrafluoroethylene), in primary forms",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390490",
    description:
      "Vinyl chloride, other halogenated olefin polymers; n.e.c. in heading no. 3904",
    parent: "3904",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3905",
    description:
      "Polymers of vinyl acetate or of other vinyl esters, in primary forms; other vinyl polymers in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390512",
    description: "Poly(vinyl acetate); in aqueous dispersion, in primary forms",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390519",
    description:
      "Poly(vinyl acetate); (other than in aqueous dispersion), in primary forms",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390521",
    description:
      "Vinyl acetate copolymers; in aqueous dispersion, in primary forms",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390529",
    description:
      "Vinyl acetate copolymers; (other than in aqueous dispersion), in primary forms",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390530",
    description:
      "Poly(vinyl alcohol); whether or not containing unhydrolysed acetate groups",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390591",
    description:
      "Vinyl acetate, vinyl ester polymers, vinyl polymers; n.e.c. in heading no. 3905, in primary forms, copolymers",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390599",
    description:
      "Vinyl acetate, vinyl ester polymers, vinyl polymers; n.e.c. in heading no. 3905, in primary forms, other than copolymers",
    parent: "3905",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3906",
    description: "Acrylic polymers in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390610",
    description:
      "Acrylic polymers; poly(methyl methacrylate), in primary forms",
    parent: "3906",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390690",
    description:
      "Acrylic polymers; (other than polymethyl methacrylate), in primary forms",
    parent: "3906",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3907",
    description:
      "Polyacetals, other polyethers and epoxide resins, in primary forms; polycarbonates, alkyd resins, polyallyl esters and other polyesters, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390710",
    description: "Polyacetals; in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390721",
    description:
      "Polyethers other than polyacetals; in primary forms, bis(polyoxyethylene) methylphosphonate",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390729",
    description:
      "Polyethers other than polyacetals, and bis(polyoxyethylene) methylphosphonate; in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390730",
    description: "Epoxide resins; in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390740",
    description: "Polycarbonates; in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390750",
    description: "Alkyd resins; in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390761",
    description:
      "Poly(ethylene terephthalate); in primary forms, having a viscosity of 78ml/g or higher",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390769",
    description:
      "Poly(ethylene terephthalate); in primary forms, having a viscosity of less than 78ml/g",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390770",
    description: "Poly(lactic acid); in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390791",
    description:
      "Polyesters; n.e.c. in heading no. 3907, unsaturated, in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390799",
    description:
      "Polyesters; n.e.c. in heading no. 3907, saturated, in primary forms",
    parent: "3907",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3908",
    description: "Polyamides in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390810",
    description:
      "Polyamides; polyamide-6, -11, -12, -6,6, -6,9, -6,10 or -6,12, in primary forms",
    parent: "3908",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390890",
    description: "Polyamides; n.e.c. in heading no. 3908, in primary forms",
    parent: "3908",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3909",
    description:
      "Amino-resins, phenolic resins and polyurethanes, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "390910",
    description: "Amino-resins; urea and thiourea resins, in primary forms",
    parent: "3909",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390920",
    description: "Amino-resins; melamine resins, in primary forms",
    parent: "3909",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390931",
    description:
      "Amino-resins; n.e.c. in heading no. 3909, in primary forms, poly(methylene phenyl isocyanate) (Crude MDI, polymeric MDI)",
    parent: "3909",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390939",
    description:
      "Amino-resins; n.e.c. in heading no. 3909, in primary forms, other than poly(methylene phenyl isocyanate) (Crude MDI, polymeric MDI)",
    parent: "3909",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390940",
    description: "Phenolic resins; in primary forms",
    parent: "3909",
    level: "6",
  },
  {
    section: "VII",
    hscode: "390950",
    description: "Polyurethanes; in primary forms",
    parent: "3909",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3910",
    description: "Silicones in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391000",
    description: "Silicones; in primary forms",
    parent: "3910",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3911",
    description:
      "Petroleum resins, coumarone-indene resins, polyterpenes, polysulphides, polysulphones and similar products of chemical synthesis n.e.c. in chapter 39, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391110",
    description:
      "Petroleum resins, coumarone, indene or coumarone-indene resins and polyterpenes; in primary forms",
    parent: "3911",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391120",
    description:
      "Petroleum resins, poly(1,3-phenylene methylphosphonate), in primary forms",
    parent: "3911",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391190",
    description:
      "Polysulphides, polysulphones and similar products of chemical synthesis n.e.c. in chapter 39; in primary forms",
    parent: "3911",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3912",
    description:
      "Cellulose and its chemical derivatives, n.e.c. or included, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391211",
    description: "Cellulose acetates; non-plasticised, in primary forms",
    parent: "3912",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391212",
    description: "Cellulose acetates; plasticised, in primary forms",
    parent: "3912",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391220",
    description: "Cellulose nitrates (including collodions); in primary forms",
    parent: "3912",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391231",
    description:
      "Cellulose ethers; carboxymethylcellulose and its salts, in primary forms",
    parent: "3912",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391239",
    description:
      "Cellulose ethers; (other than carboxymethylcellulose and its salts), in primary forms",
    parent: "3912",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391290",
    description:
      "Cellulose and its chemical derivatives; n.e.c. in item no. 3912, in primary forms",
    parent: "3912",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3913",
    description:
      "Natural polymers (e.g. alginic acid) and modified natural polymers (e.g. hardened proteins, chemical derivatives of natural rubber), n.e.c. or included, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391310",
    description:
      "Polymers, natural; alginic acid, its salts and esters, in primary forms",
    parent: "3913",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391390",
    description:
      "Polymers, natural and modified natural; in primary forms (excluding alginic acid, its salts and esters)",
    parent: "3913",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3914",
    description:
      "Ion-exchangers; based on polymers of heading no. 3901 to 3913, in primary forms",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391400",
    description:
      "Ion-exchangers; based on polymers of heading no. 3901 to 3913, in primary forms",
    parent: "3914",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3915",
    description: "Waste, parings and scrap, of plastics",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391510",
    description: "Ethylene polymers; waste, parings and scrap",
    parent: "3915",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391520",
    description: "Styrene polymers; waste, parings and scrap",
    parent: "3915",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391530",
    description: "Vinyl chloride polymers; waste, parings and scrap",
    parent: "3915",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391590",
    description:
      "Plastics n.e.c. in heading no. 3915; waste, parings and scrap",
    parent: "3915",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3916",
    description:
      "Monofilament of which any cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked, of plastics",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391610",
    description:
      "Ethylene polymers; monofilament, of which any cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked",
    parent: "3916",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391620",
    description:
      "Vinyl chloride polymers; monofilament, of which any cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked",
    parent: "3916",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391690",
    description:
      "Plastics; monofilament, of plastics n.e.c. in heading no. 3916, cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked",
    parent: "3916",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3917",
    description:
      "Tubes, pipes and hoses and fittings thereof (for example, joints, elbows, flanges), of plastics",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391710",
    description:
      "Plastics; artificial guts (sausage casings) of hardened protein or of cellulosic materials",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391721",
    description:
      "Plastics; tubes, pipes and hoses thereof, rigid, of polymers of ethylene",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391722",
    description:
      "Plastics; tubes, pipes and hoses thereof, rigid, of polymers of propylene",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391723",
    description:
      "Plastics; tubes, pipes and hoses thereof, rigid, of polymers of vinyl chloride",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391729",
    description:
      "Plastics; tubes, pipes and hoses thereof, rigid, of plastics n.e.c. in heading no. 3917",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391731",
    description:
      "Plastics; tubes, pipes and hoses thereof, flexible, having a minimum burst pressure of 27.6MPa",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391732",
    description:
      "Plastics; tubes, pipes and hoses thereof, other than those of item no. 3917.31, not reinforced or otherwise combined with other materials, without fittings",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391733",
    description:
      "Plastics; tubes, pipes and hoses thereof, other than those of item no. 3917.31, not reinforced or otherwise combined with other materials, with fittings",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391739",
    description:
      "Plastics; tubes, pipes and hoses thereof, n.e.c. in item no. 3917.30",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391740",
    description:
      "Plastics; tube, pipe and hose fittings (e.g. joints, elbows, flanges)",
    parent: "3917",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3918",
    description:
      "Floor coverings of plastics, self-adhesive or not, in rolls or tiles; wall or ceiling coverings of plastics, in rolls of a width not less than 45cm",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391810",
    description:
      "Floor, wall or ceiling coverings; of polymers of vinyl chloride, whether or not self-adhesive, in rolls or in the form of tiles",
    parent: "3918",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391890",
    description:
      "Floor, wall or ceiling coverings; of plastics (excluding polymers of vinyl chloride), whether or not self-adhesive, in rolls or in the form of tiles",
    parent: "3918",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3919",
    description:
      "Self-adhesive plates, sheets, film, foil, tape, strip and other flat shapes, of plastics, whether or not in rolls",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "391910",
    description:
      "Plastics; plates, sheets, film, foil, tape, strip, other flat shapes thereof, self-adhesive, in rolls of a width not exceeding 20cm",
    parent: "3919",
    level: "6",
  },
  {
    section: "VII",
    hscode: "391990",
    description:
      "Plastics; plates, sheets, film, foil, tape, strip, other flat shapes thereof, self-adhesive, other than in rolls of a width not exceeding 20cm",
    parent: "3919",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3920",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive); non-cellular and not reinforced, laminated, supported or similarly combined with other materials, n.e.c. in chapter 39",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392010",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polymers of ethylene, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392020",
    description:
      "Plastics; of polymers of propylene, plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392030",
    description:
      "Plastics; of polymers of styrene, plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392043",
    description:
      "Plastics; polymers of vinyl chloride, containing by weight not less than 6% of plasticisers; plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392049",
    description:
      "Plastics; polymers of vinyl chloride, containing by weight, less than 6% of plasticisers; plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392051",
    description:
      "Plastics; of acrylic polymers, polymethyl methacrylate, plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392059",
    description:
      "Plastics; of acrylic polymers (excluding polymethyl methacrylate), plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392061",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polycarbonates, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392062",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of poly(ethylene terephthalate), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392063",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of unsaturated polyesters, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392069",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polyesters n.e.c. in heading no. 3920, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392071",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of regenerated cellulose; non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392073",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of cellulose acetate, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392079",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of cellulose derivatives n.e.c. in heading no. 3920, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392091",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of poly(vinyl butyral), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392092",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polyamides, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392093",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of amino-resins, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392094",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of phenolic resins, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392099",
    description:
      "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of plastics n.e.c. in heading no. 3920, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
    parent: "3920",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3921",
    description:
      "Plastic plates, sheets, film, foil and strip n.e.c. in chapter 39",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392111",
    description:
      "Plastics; plates, sheets, film, foil and strip, of polymers of styrene, cellular",
    parent: "3921",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392112",
    description:
      "Plastics; plates, sheets, film, foil and strip, of polymers of vinyl chloride, cellular",
    parent: "3921",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392113",
    description:
      "Plastics; plates, sheets, film, foil and strip, of polyurethanes, cellular",
    parent: "3921",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392114",
    description:
      "Plastics; plates, sheets, film, foil and strip, of regenerated cellulose, cellular",
    parent: "3921",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392119",
    description:
      "Plastics; plates, sheets, film, foil and strip, of plastics n.e.c. in heading no. 3921, cellular",
    parent: "3921",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392190",
    description:
      "Plastics; plates, sheets, film, foil and strip, other than cellular",
    parent: "3921",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3922",
    description:
      "Sanitary ware; baths, shower-baths, sinks, wash-basins, bidets, lavatory pans, seats and covers, flushing cisterns and sanitary ware, of plastics",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392210",
    description: "Plastics; baths, shower-baths, sinks and wash-basins",
    parent: "3922",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392220",
    description: "Plastics; lavatory seats and covers",
    parent: "3922",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392290",
    description:
      "Plastics; bidets, lavatory pans, flushing cisterns and similar sanitary ware n.e.c. in heading no. 3922",
    parent: "3922",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3923",
    description:
      "Plastic articles for the conveyance or packing of goods; stoppers, lids, caps and other closures of plastics",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392310",
    description:
      "Plastics; boxes, cases, crates and similar articles for the conveyance or packing of goods",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392321",
    description:
      "Ethylene polymers; sacks and bags (including cones), for the conveyance or packing of goods",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392329",
    description:
      "Plastics; sacks and bags (including cones), for the conveyance or packing of goods, of plastics other than ethylene polymers",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392330",
    description:
      "Plastics; carboys, bottles, flasks and similar articles, for the conveyance or packing of goods",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392340",
    description:
      "Plastics; spools, cops, bobbins and similar supports, for the conveyance or packing of goods",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392350",
    description:
      "Plastics; stoppers, lids, caps and other closures, for the conveyance or packing of goods",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392390",
    description:
      "Plastics; articles for the conveyance or packing of goods n.e.c. in heading no. 3923",
    parent: "3923",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3924",
    description:
      "Tableware, kitchenware, other household articles and hygienic or toilet articles, of plastics",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392410",
    description: "Plastics; tableware and kitchenware",
    parent: "3924",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392490",
    description: "Plastics; household articles and hygienic or toilet articles",
    parent: "3924",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3925",
    description: "Plastics; builders' wares n.e.c. or included",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392510",
    description:
      "Plastics; builders' ware, reservoirs, tanks, vats and similar containers of a capacity exceeding 300 litres",
    parent: "3925",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392520",
    description:
      "Plastics; builders' ware, doors, windows and their frames and thresholds for doors",
    parent: "3925",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392530",
    description:
      "Plastics; builders' ware, shutters, blinds (including venetian blinds) and similar articles and parts thereof",
    parent: "3925",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392590",
    description:
      "Plastics; builders' ware, n.e.c. or included in heading no. 3925",
    parent: "3925",
    level: "6",
  },
  {
    section: "VII",
    hscode: "3926",
    description:
      "Articles of plastics and articles of other materials of heading no. 3901 to 3914, n.e.c. in chapter 39",
    parent: "39",
    level: "4",
  },
  {
    section: "VII",
    hscode: "392610",
    description: "Plastics; office or school supplies",
    parent: "3926",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392620",
    description:
      "Plastics; articles of apparel and clothing accessories (including gloves, mittens and mitts)",
    parent: "3926",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392630",
    description: "Plastics; fittings for furniture, coachwork or the like",
    parent: "3926",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392640",
    description: "Plastics; statuettes and other ornamental articles",
    parent: "3926",
    level: "6",
  },
  {
    section: "VII",
    hscode: "392690",
    description: "Plastics; other articles n.e.c. in chapter 39",
    parent: "3926",
    level: "6",
  },
  {
    section: "VII",
    hscode: "40",
    description: "Rubber and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VII",
    hscode: "4001",
    description:
      "Natural rubber, balata, gutta-percha, guayule, chicle and similar gums; in primary forms or in plates, sheets or strip",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400110",
    description:
      "Rubber; natural rubber latex, whether or not pre-vulcanised, in primary forms or in plates, sheets or strip",
    parent: "4001",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400121",
    description: "Rubber; natural (excluding latex), in smoked sheets",
    parent: "4001",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400122",
    description:
      "Rubber; technically specified natural rubber (TSNR), in primary forms or in plates, sheets or strip (excluding latex and smoked sheets)",
    parent: "4001",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400129",
    description:
      "Rubber; natural (excluding latex, technically specified natural rubber and smoked sheets), in primary forms or in plates, sheets or strip",
    parent: "4001",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400130",
    description:
      "Balata, gutta-percha, guayule, chicle and similar natural gums; in primary forms or in plates, sheets or strip",
    parent: "4001",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4002",
    description:
      "Synthetic rubber and factice derived from oils, in primary forms or in plates, sheets or strip; mixtures of heading no. 4001 and 4002, in primary forms or in plates, sheets or strip",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400211",
    description:
      "Rubber; synthetic, styrene-butadiene rubber (SBR) and carboxylated styrene-butadiene rubber (XSBR) latex, in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400219",
    description:
      "Rubber; synthetic, styrene-butadiene rubber (SBR) and carboxylated styrene-butadiene rubber (XSBR), (other than latex), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400220",
    description:
      "Rubber; synthetic, butadiene rubber (BR), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400231",
    description:
      "Rubber; synthetic, isobutene-isoprene (butyl) rubber (IIR), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400239",
    description:
      "Rubber; synthetic, halo-isobutene-isoprene rubber (CIIR or BIIR), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400241",
    description:
      "Rubber; synthetic, chloroprene (chlorobutadiene) rubber (CR), latex, in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400249",
    description:
      "Rubber; synthetic, chloroprene (chlorobutadiene) rubber (CR), (other than latex), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400251",
    description:
      "Rubber; synthetic, acrylonitrile-butadiene rubber (NBR), latex, in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400259",
    description:
      "Rubber; synthetic, acrylonitrile-butadiene rubber (NBR), (other than latex), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400260",
    description:
      "Rubber; synthetic, isoprene rubber (IR), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400270",
    description:
      "Rubber; synthetic, ethylene-propylene-non-conjugated diene rubber (EPDM), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400280",
    description:
      "Rubber; mixtures of natural and synthetic rubbers of heading no. 4001 and 4002, in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400291",
    description:
      "Rubber; synthetic, n.e.c. in heading 4002, latex, in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400299",
    description:
      "Rubber; synthetic, n.e.c. in heading 4002, (other than latex), in primary forms or in plates, sheets or strip",
    parent: "4002",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4003",
    description:
      "Reclaimed rubber in primary forms or in plates, sheets or strip",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400300",
    description:
      "Rubber; reclaimed rubber, in primary forms or in plates, sheets or strip",
    parent: "4003",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4004",
    description:
      "Waste, parings and scrap of rubber (other than hard rubber) and powders and granules obtained therefrom",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400400",
    description:
      "Rubber; waste, parings and scrap of rubber (other than hard rubber) and powders and granules obtained therefrom",
    parent: "4004",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4005",
    description:
      "Compounded rubber, unvulcanised, in primary forms or in plates, sheets or strip",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400510",
    description:
      "Rubber; unvulcanised, compounded with carbon black or silica, in primary forms or in plates, sheets or strip",
    parent: "4005",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400520",
    description:
      "Rubber; unvulcanised, compounded, solutions and dispersions other than those of item no. 4005.10",
    parent: "4005",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400591",
    description:
      "Rubber; unvulcanised, (compounded other than with carbon black or silica), in plates, sheets and strip",
    parent: "4005",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400599",
    description:
      "Rubber; unvulcanised, (compounded other than with carbon black or silica), in primary forms, (other than plates, sheets, strip, solutions or dispersions)",
    parent: "4005",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4006",
    description:
      "Unvulcanised rubber in other forms (e.g. rods, tubes and profile shapes) and articles (e.g. discs and rings)",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400610",
    description:
      "Rubber; unvulcanised, camel-back strips for retreading rubber tyres",
    parent: "4006",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400690",
    description:
      "Rubber; unvulcanised, other than camel back strips for retreading rubber tyres",
    parent: "4006",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4007",
    description: "Vulcanised rubber thread and cord",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400700",
    description: "Rubber; vulcanised, thread and cord",
    parent: "4007",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4008",
    description:
      "Plates, sheets, strip, rods and profile shapes, of vulcanised rubber other than hard rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400811",
    description:
      "Rubber; vulcanised (other than hard rubber), in plates, sheets and strip of cellular rubber",
    parent: "4008",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400819",
    description:
      "Rubber; vulcanised (other than hard rubber), cellular rubber, (other than in plates, sheets or strip)",
    parent: "4008",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400821",
    description:
      "Rubber; vulcanised (other than hard rubber), in plates, sheets and strip, of non-cellular rubber",
    parent: "4008",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400829",
    description:
      "Rubber; vulcanised (other than hard rubber), non-cellular rubber, in forms other than plates, sheets or strip",
    parent: "4008",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4009",
    description:
      "Tubes, pipes and hoses, of vulcanised rubber (other than hard rubber), with or without their fittings (e.g. joints, elbows, flanges)",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "400911",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, not reinforced or otherwise combined with other materials, without fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400912",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, not reinforced or otherwise combined with other materials, with fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400921",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with metal, without fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400922",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with metal, with fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400931",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with textile materials, without fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400932",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with textile materials, with fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400941",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined with materials other than metal or textiles, without fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "400942",
    description:
      "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined with materials other than metal or textiles, with fittings",
    parent: "4009",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4010",
    description:
      "Conveyor or transmission belts or belting, of vulcanised rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401011",
    description:
      "Rubber; vulcanised, conveyor belts or belting, reinforced only with metal",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401012",
    description:
      "Rubber; vulcanised, conveyor belts or belting, reinforced only with textile materials",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401019",
    description:
      "Rubber; vulcanised, conveyor belts or belting, (reinforced with other than metal only or textile materials only)",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401031",
    description:
      "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), V-ribbed, of an outside circumference exceeding 60cm but not exceeding 180 cm",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401032",
    description:
      "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), other than V-ribbed, of an outside circumference exceeding 60cm but not exceeding 180 cm",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401033",
    description:
      "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), V-ribbed, of an outside circumference exceeding 180cm but not exceeding 240 cm",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401034",
    description:
      "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), other than V-ribbed, of an outside circumference exceeding 180cm but not exceeding 240 cm",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401035",
    description:
      "Rubber; vulcanised, endless synchronous belts, of an outside circumference exceeding 60 cm but not exceeding 150 cm",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401036",
    description:
      "Rubber; vulcanised, endless synchronous belts, of an outside circumference exceeding 150 cm but not exceeding 198 cm",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401039",
    description:
      "Rubber; vulcanised, conveyor or transmission belts or belting, n.e.c. in heading no. 4010",
    parent: "4010",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4011",
    description: "New pneumatic tyres, of rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401110",
    description:
      "Rubber; new pneumatic tyres, of a kind used on motor cars (including station wagons and racing cars)",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401120",
    description:
      "Rubber; new pneumatic tyres, of a kind used on buses or lorries",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401130",
    description: "Rubber; new pneumatic tyres, of a kind used on aircraft",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401140",
    description: "Rubber; new pneumatic tyres, of a kind used on motorcycles",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401150",
    description: "Rubber; new pneumatic tyres, of a kind used on bicycles",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401170",
    description:
      "Rubber; new pneumatic tyres, of a kind used on agricultural or forestry vehicles and machines",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401180",
    description:
      "Rubber; new pneumatic tyres, of a kind used on construction, mining or industrial handling vehicles and machines",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401190",
    description:
      "Rubber; new pneumatic tyres, of a kind used on light commercial vehicles",
    parent: "4011",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4012",
    description:
      "Retreaded or used pneumatic tyres of rubber; solid or cushion tyres, tyre treads and tyre flaps, of rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401211",
    description:
      "Retreaded tyres; of a kind used on motor cars (including station wagons and racing cars)",
    parent: "4012",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401212",
    description: "Retreaded tyres; of a kind used on motor buses or lorries",
    parent: "4012",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401213",
    description: "Retreaded tyres; of a kind used on aircraft",
    parent: "4012",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401219",
    description:
      "Retreaded tyres; other than of a kind used on motor cars (including station wagons and racing cars), buses and lorries and aircraft",
    parent: "4012",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401220",
    description: "Rubber; used pneumatic tyres",
    parent: "4012",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401290",
    description: "Rubber; tyres n.e.c. in heading no. 4012",
    parent: "4012",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4013",
    description: "Inner tubes, of rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401310",
    description:
      "Rubber; inner tubes, of a kind used on motorcars (including station wagons and racing cars), buses and lorries",
    parent: "4013",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401320",
    description: "Rubber; inner tubes, of a kind used on bicycles",
    parent: "4013",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401390",
    description: "Rubber; inner tubes, n.e.c. in heading no. 4013",
    parent: "4013",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4014",
    description:
      "Hygienic or pharmaceutical articles (including teats), of vulcanised rubber other than hard rubber, with or without fittings of hard rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401410",
    description:
      "Rubber; vulcanised (other than hard rubber), sheath contraceptives",
    parent: "4014",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401490",
    description:
      "Rubber; vulcanised (other than hard rubber), hygienic or pharmaceutical articles (excluding sheath contraceptives), with or without fittings of hard rubber",
    parent: "4014",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4015",
    description:
      "Articles of apparel and clothing accessories (including gloves, mittens and mitts), for all purposes, of vulcanised rubber other than hard rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401512",
    description:
      "Rubber; vulcanised (other than hard rubber), gloves, of a kind used for medical, surgical, dental or veterinary purposes",
    parent: "4015",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401519",
    description:
      "Rubber; vulcanised (other than hard rubber), gloves, mittens and mitts other than surgical gloves",
    parent: "4015",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401590",
    description:
      "Rubber; vulcanised (other than hard rubber), articles of apparel and clothing accessories (other than gloves, mittens and mitts)",
    parent: "4015",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4016",
    description:
      "Articles of vulcanised rubber other than hard rubber, n.e.c. in chapter 40",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401610",
    description:
      "Rubber; vulcanised (other than hard rubber), moulded rubber mats and mats of non-rectangular shape made by cutting from the piece, of cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401691",
    description:
      "Rubber; vulcanised (other than hard rubber), floor coverings and mats, of non-cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401692",
    description:
      "Rubber; vulcanised (other than hard rubber), erasers, of non-cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401693",
    description:
      "Rubber; vulcanised (other than hard rubber), gaskets, washers and other seals, of non-cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401694",
    description:
      "Rubber; vulcanised (other than hard rubber), boat or dock fenders, whether or not inflatable, of non-cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401695",
    description:
      "Rubber; vulcanised (other than hard rubber), inflatable articles (other than boat or dock fenders), of non-cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "401699",
    description:
      "Rubber; vulcanised (other than hard rubber), articles n.e.c. in heading no. 4016, of non-cellular rubber",
    parent: "4016",
    level: "6",
  },
  {
    section: "VII",
    hscode: "4017",
    description:
      "Hard rubber (e.g. ebonite) in all forms, including waste and scrap; articles of hard rubber",
    parent: "40",
    level: "4",
  },
  {
    section: "VII",
    hscode: "401700",
    description:
      "Rubber; ebonite and other hard rubbers in all forms, including waste and scrap, and articles of hard rubber",
    parent: "4017",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "41",
    description: "Raw hides and skins (other than furskins) and leather",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VIII",
    hscode: "4101",
    description:
      "Raw hides and skins of bovine (including buffalo) or equine animals (fresh, salted, dried, limed, pickled, otherwise preserved but not tanned, parchment dressed or further prepared), whether or not dehaired or split",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410120",
    description:
      "Raw hides and skins; whole, unsplit, of bovine or equine animals, of a weight per skin not exceeding 8kg when simply dried, 10kg when dry-salted or 16kg when fresh, wet-salted or otherwise preserved",
    parent: "4101",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410150",
    description:
      "Hides and skins; raw, whole, of bovine or equine animals, of a weight per skin exceeding 16 kg",
    parent: "4101",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410190",
    description:
      "Hides and skins; other than whole, but including butts, bends and bellies, of bovine (including. buffalo) and equine animals, fresh, salted or preserved, but not tanned, parchment dressed or further prepared, whether or not dehaired or split",
    parent: "4101",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4102",
    description:
      "Raw skins of sheep or lambs (fresh, salted, dried, limed, pickled or otherwise preserved, but not further prepared), whether or not with wool on or split",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410210",
    description:
      "Skins; raw, of sheep or lambs, fresh, or salted, dried, limed, pickled or otherwise preserved, (but not tanned, parchment-dressed or further prepared), with wool on",
    parent: "4102",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410221",
    description:
      "Skins; raw, of sheep or lambs, pickled (but not tanned, parchment-dressed or further preserved), without wool on",
    parent: "4102",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410229",
    description:
      "Hides and skins; raw, of animals n.e.c. in this chapter, fresh, salted, dried, limed, pickled or otherwise preserved, (but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
    parent: "4102",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4103",
    description:
      "Raw hides and skins n.e.c in headings no. 4101, 4102; fresh, salted, dried, pickled or otherwise preserved, not further prepared, whether or not dehaired or split",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410320",
    description:
      "Hides and skins; raw, of reptiles (fresh or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
    parent: "4103",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410330",
    description:
      "Hides and skins; raw, of swine, (fresh or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
    parent: "4103",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410390",
    description:
      "Hides and skins; raw, of animals n.e.c. in this chapter, fresh, salted, dried, limed, pickled or otherwise preserved, (but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
    parent: "4103",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4104",
    description:
      "Tanned or crust hides and skins of bovine (including buffalo) or equine animals, without hair on, whether or not split, but not further prepared",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410411",
    description:
      "Tanned or crust hides and skins; without hair on, bovine or equine, in the wet state (including wet-blue), full grains, unsplit; grain splits",
    parent: "4104",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410419",
    description:
      "Tanned or crust hides and skins; bovine or equine, without hair on, in the wet state (including wet-blue), excluding full grains, unsplit; grain splits",
    parent: "4104",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410441",
    description:
      "Tanned or crust hides and skins; bovine or equine, without hair on, in the dry state (crust), full grains, unsplit; grain splits",
    parent: "4104",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410449",
    description:
      "Tanned or crust hides and skins; bovine or equine, without hair on, in the dry state (crust), (other than full grains, unsplit; grain splits)",
    parent: "4104",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4105",
    description:
      "Tanned or crust skins of sheep and lambs, without wool on, whether or not split, but not further prepared",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410510",
    description:
      "Tanned or crust skins of sheep or lambs, without wool on, whether or not split, but not further prepared, in the wet state (including wet-blue)",
    parent: "4105",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410530",
    description:
      "Tanned or crust skins; of sheep or lambs, without wool on, whether or not split, but not further prepared, in the dry state (crust)",
    parent: "4105",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4106",
    description:
      "Tanned or crust hides and skins of other animals, without wool or hair on, whether or not split, but not further prepared",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410621",
    description:
      "Tanned or crust hides and skins; of goats or kids, without wool or hair on, whether or not split, but not further prepared, in the wet state (including wet-blue)",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410622",
    description:
      "Tanned or crust hides and skins; of goats or kids, without hair on, whether or not split, but not further prepared, in the dry state (crust)",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410631",
    description:
      "Tanned or crust hides and skins; of swine, without hair on, whether or not split, but not further prepared, in the wet state (including wet-blue)",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410632",
    description:
      "Tanned or crust hides and skins; of swine, without hair on, whether or not split, but not further prepared, in the dry state (crust)",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410640",
    description:
      "Tanned or crust hides and skins; of reptiles, whether or not split, but not further prepared",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410691",
    description:
      "Tanned or crust hides and skins; of animals other than equine, ovine, bovine, goats or kids, swine and reptiles, without wool or hair on, whether or not split, but not further prepared, in the wet state (including wet-blue)",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410692",
    description:
      "Tanned or crust hides and skins; of animals other than equine, ovine, bovine, goats or kids, swine and reptiles, without wool or hair on, whether or not split, but not further prepared, in the dry state (crust)",
    parent: "4106",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4107",
    description:
      "Leather further prepared after tanning or crusting, including parchment-dressed leather, of bovine (including buffalo) or equine animals, without hair on, whether or not split, other than leather of heading 41.14",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "410711",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, whole hides and skins, full grain, unsplit",
    parent: "4107",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410712",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, whole hides and skins, grain splits",
    parent: "4107",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410719",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed, of bovine (including buffalo) or equine animals, without hair on, split or not, other than leather of heading 41.14, (other than grain splits and full grains, unsplit)",
    parent: "4107",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410791",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, not whole hides and skins, but including sides, full grain, unsplit",
    parent: "4107",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410792",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, not whole hides and skins, but including sides, grain splits",
    parent: "4107",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "410799",
    description:
      "Leather; further prepared after tanning or crusting, incl. parchment-dressed, of bovine (including buffalo) or equine animals, no hair, excluding leather of heading 41.14, and whole hides and skins, and sides, (full grains, unsplit and grain splits)",
    parent: "4107",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4112",
    description:
      "Leather further prepared after tanning or crusting, including parchment dressed leather, of sheep or lamb, without wool on, whether or not split, other than leather of heading 41.14",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "411200",
    description:
      "Leather; further prepared after tanning or crusting, including parchment dressed leather, of sheep or lamb, without wool on, whether or not split, other than leather of heading 41.14",
    parent: "4112",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4113",
    description:
      "Leather further prepared after tanning or crusting, including parchment-dressed leather, of animals (other than ovine), without wool or hair on, whether or not split, other than leather of heading 41.14",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "411310",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed leather, without hair on, whether or not split, other than leather of heading 41.14, of goats and kids",
    parent: "4113",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "411320",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed leather, without hair on, whether or not split, other than leather of heading 41.14, of swine",
    parent: "4113",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "411330",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of reptiles, whether or not split, other than leather of heading 41.14",
    parent: "4113",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "411390",
    description:
      "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of animals (other than sheep and lambs, goats and kids, swine and reptiles), without wool or hair on, whether or not split, other than leather of heading 41.14",
    parent: "4113",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4114",
    description:
      "Chamois (including combination chamois) leather; patent leather and patent laminated leather; metallised leather",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "411410",
    description: "Leather; chamois (including combination chamois)",
    parent: "4114",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "411420",
    description:
      "Leather; patent leather and laminated patent leather; metallised leather",
    parent: "4114",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4115",
    description:
      "Composition leather with a basis of leather or leather fibre, in slabs, sheets or strip, in rolls or not; parings and other waste of leather or of composition leather, not suitable for the manufacture of leather articles; leather dust, powder and flour",
    parent: "41",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "411510",
    description:
      "Leather; composition leather with a basis of leather or leather fibre, in slabs, sheets or strip, whether or not in rolls",
    parent: "4115",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "411520",
    description:
      "Leather; parings and other waste, of leather or composition leather; not suitable for the manufacture of leather articles; leather dust, powder and flour",
    parent: "4115",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "42",
    description:
      "Articles of leather; saddlery and harness; travel goods, handbags and similar containers; articles of animal gut (other than silk-worm gut)",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VIII",
    hscode: "4201",
    description:
      "Saddlery and harness for any animal (including traces, leads, knee pads, muzzles, saddle cloths, saddle bags, dog coats and the like) of any material",
    parent: "42",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "420100",
    description:
      "Saddlery and harness; for any animal (including traces, leads, knee pads, muzzles, saddle cloths, saddle bags, dog coats and the like), of any materials",
    parent: "4201",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4202",
    description:
      "Trunks; suit, camera, jewellery, cutlery cases; travel, tool, similar bags; wholly or mainly covered by leather, composition leather, plastic sheeting, textile materials, vulcanised fibre, paperboard",
    parent: "42",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "420211",
    description:
      "Cases and containers; trunks, suit-cases, vanity-cases, executive-cases, brief-cases, school satchels and similar containers, with outer surface of leather or of composition leather",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420212",
    description:
      "Cases and containers; trunks, suit-cases, vanity-cases, executive-cases, brief-cases, school satchels and similar containers, with outer surface of plastics or of textile materials",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420219",
    description:
      "Cases and containers; trunks, suit-cases, vanity-cases, executive-cases, brief-cases, school satchels and similar containers, of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420221",
    description:
      "Cases and containers; handbags (whether or not with shoulder strap and including those without handle), with outer surface of leather or of composition leather",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420222",
    description:
      "Cases and containers; handbags (whether or not with shoulder strap and including those without handle), with outer surface of sheeting of plastics or of textile materials",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420229",
    description:
      "Cases and containers; handbags (whether or not with shoulder strap and including those without handle), of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420231",
    description:
      "Cases and containers; of a kind normally carried in the pocket or in the handbag, with outer surface of leather or of composition leather",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420232",
    description:
      "Cases and containers; of a kind normally carried in the pocket or in the handbag, with outer surface of sheeting of plastics or of textile materials",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420239",
    description:
      "Cases and containers; of a kind normally carried in the pocket or in the handbag, of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420291",
    description:
      "Cases and containers; n.e.c. in heading 4202, with outer surface of leather or of composition leather",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420292",
    description:
      "Cases and containers; n.e.c. in heading 4202, with outer surface of sheeting of plastics or of textile materials",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420299",
    description:
      "Cases and containers; n.e.c. in heading 4202, of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
    parent: "4202",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4203",
    description:
      "Articles of apparel and clothing accessories, of leather or of composition leather",
    parent: "42",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "420310",
    description:
      "Apparel; articles of apparel, of leather or of composition leather",
    parent: "4203",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420321",
    description:
      "Clothing accessories; gloves, mittens and mitts, specially designed for use in sports, of leather or composition leather, padded",
    parent: "4203",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420329",
    description:
      "Clothing accessories; gloves, mittens and mitts, n.e.c. in heading no. 4203, of leather or composition leather, not specially designed for use in sports",
    parent: "4203",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420330",
    description:
      "Clothing accessories; belts and bandoliers, of leather or of composition leather",
    parent: "4203",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "420340",
    description:
      "Clothing accessories; of leather or of composition leather, n.e.c. in heading no. 4203",
    parent: "4203",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4205",
    description: "Leather or composition leather articles n.e.c. in chapter 42",
    parent: "42",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "420500",
    description:
      "Leather articles; n.e.c. in chapter 42, of leather or composition leather",
    parent: "4205",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4206",
    description:
      "Articles of gut (other than silk-worm gut), of goldbeater's skin, of bladders or of tendons",
    parent: "42",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "420600",
    description:
      "Articles of gut (other than silk-worm gut), of goldbeater's skin, of bladders or of tendons",
    parent: "4206",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "43",
    description: "Furskins and artificial fur; manufactures thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "VIII",
    hscode: "4301",
    description:
      "Raw furskins (including heads, tails, paws, other pieces or cuttings, suitable for furriers' use), excluding raw hides and skins of heading no. 4101, 4102 or 4103",
    parent: "43",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "430110",
    description:
      "Furskins; raw, of mink, whole, with or without head, tail or paws",
    parent: "4301",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430130",
    description:
      "Furskins; raw, of Astrakhan, Broadtail, Caracul, Persian and similar lamb, Indian, Chinese, Mongolian or Tibetan lamb, whole, with or without head, tail or paws",
    parent: "4301",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430160",
    description:
      "Furskins; raw, of fox, whole, with or without head, tail or paws",
    parent: "4301",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430180",
    description:
      "Furskins; raw, of animals n.e.c. in heading no. 4301, whole, with or without head, tail or paws (excluding goods of heading no. 4101, 4102 and 4103)",
    parent: "4301",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430190",
    description:
      "Furskins; raw, heads, tails, paws and other pieces or cuttings, suitable for furrier's use, excluding goods of heading no. 4101, 4102 and 4103",
    parent: "4301",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4302",
    description:
      "Tanned or dressed furskins (including heads, tails, paws, other pieces, cuttings), unassembled, or assembled (without addition of other materials), excluding those of heading no. 4303",
    parent: "43",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "430211",
    description:
      "Furskins; tanned or dressed, of mink, whole, with or without head, tail or paws, not assembled",
    parent: "4302",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430219",
    description:
      "Furskins; tanned or dressed, whole, with or without head, tail or paws, not assembled, n.e.c. in heading no. 4302, excluding goods or heading no. 4303",
    parent: "4302",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430220",
    description:
      "Furskins; tanned or dressed, heads, tails, paws and other pieces or cuttings, not assembled, excluding goods of heading no. 4303",
    parent: "4302",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430230",
    description:
      "Furskins; tanned or dressed, whole skins and pieces or cuttings thereof, assembled, excluding goods of heading no. 4303",
    parent: "4302",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4303",
    description:
      "Articles of apparel, clothing accessories and other articles of furskin",
    parent: "43",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "430310",
    description: "Furskin articles; apparel and clothing accessories",
    parent: "4303",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "430390",
    description:
      "Furskin articles; other than apparel and clothing accessories",
    parent: "4303",
    level: "6",
  },
  {
    section: "VIII",
    hscode: "4304",
    description: "Artificial fur and articles thereof",
    parent: "43",
    level: "4",
  },
  {
    section: "VIII",
    hscode: "430400",
    description: "Fur, artificial; articles thereof",
    parent: "4304",
    level: "6",
  },
  {
    section: "IX",
    hscode: "44",
    description: "Wood and articles of wood; wood charcoal",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IX",
    hscode: "4401",
    description:
      "Fuel wood, in logs, billets, twigs, faggots or similar forms; wood in chip or particles; sawdust and wood waste and scrap, whether or not agglomerated in logs, briquettes, pellets or similar forms",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440111",
    description:
      "Wood; for fuel, in logs, in billets, in twigs, in faggots or similar forms, whether or not agglomerated, coniferous",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440112",
    description:
      "Wood; for fuel, in logs, in billets, in twigs, in faggots or similar forms, whether or not agglomerated, non-coniferous",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440121",
    description:
      "Wood; for fuel, in chips or particles, coniferous, whether or not agglomerated",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440122",
    description:
      "Wood; for fuel, in chips or particles, non-coniferous, whether or not agglomerated",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440131",
    description:
      "Wood; for fuel, sawdust and wood waste and scrap, agglomerated in wood pellets",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440132",
    description:
      "Wood; for fuel, sawdust and wood waste and scrap, agglomerated in wood briquettes",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440139",
    description:
      "Wood; for fuel, sawdust and wood waste and scrap, agglomerated in logs or similar forms, other than wood pellets or wood briquettes",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440141",
    description:
      "Wood; for fuel, sawdust and wood waste and scrap, not agglomerated; sawdust",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440149",
    description:
      "Wood; for fuel, sawdust and wood waste and scrap, not agglomerated and not including sawdust",
    parent: "4401",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4402",
    description:
      "Wood charcoal (including shell or nut charcoal), whether or not agglomerated",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440210",
    description: "Wood; charcoal of bamboo, whether or not agglomerated",
    parent: "4402",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440220",
    description: "Wood; charcoal of nut or shell, whether or not agglomerated",
    parent: "4402",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440290",
    description:
      "Wood; charcoal of wood other than bamboo, nut or shell, whether or not agglomerated",
    parent: "4402",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4403",
    description:
      "Wood in the rough, whether or not stripped of bark or sapwood, or roughly squared",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440311",
    description:
      "Wood; coniferous species, in the rough, whether or not stripped of bark or sapwood, or roughly squared; treated with paint, stains, creosote or other preservatives",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440312",
    description:
      "Wood; non-coniferous species, in the rough, whether or not stripped of bark or sapwood, or roughly squared; treated with paint, stains, creosote or other preservatives",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440321",
    description:
      "Wood; coniferous species, of pine (Pinus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which the smallest cross-sectional dimension is 15 cm or more",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440322",
    description:
      "Wood; coniferous species, of pine (Pinus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440323",
    description:
      "Wood; coniferous species, of fir (Abies spp.) and spruce (Picea spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which the smallest cross-sectional dimension is 15 cm or more",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440324",
    description:
      "Wood; coniferous species, of fir (Abies spp.) and spruce (Picea spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440325",
    description:
      "Wood; coniferous species n.e.c. in headings 4403.21 or 4403.23, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which the smallest cross-sectional dimension is 15 cm or more",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440326",
    description:
      "Wood; coniferous species n.e.c in headings 4403.22 or 4403.24, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440341",
    description:
      "Wood, tropical; as specified in Subheading Note 2 to this Chapter, dark red meranti, light red meranti and meranti bakau, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440342",
    description:
      "Wood, tropical; teak, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440349",
    description:
      "Wood, tropical; other than dark red meranti, light red meranti meranti bakau and teak, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440391",
    description:
      "Wood; oak, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440393",
    description:
      "Wood; of beech (Fagus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which the smallest cross-sectional dimension is 15 cm or more",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440394",
    description:
      "Wood; of beech (Fagus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440395",
    description:
      "Wood; of birch (Betula spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which the smallest cross-sectional dimension is 15 cm or more",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440396",
    description:
      "Wood; of birch (Betula spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440397",
    description:
      "Wood; of poplar and aspen (Populus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440398",
    description:
      "Wood; of eucalyptus (Eucalyptus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440399",
    description:
      "Wood; in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, n.e.c. in heading no. 4403",
    parent: "4403",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4404",
    description:
      "Hoopwood; split poles; piles, pickets, stakes of wood, pointed, not sawn lengthwise; wooden sticks, roughly trimmed, not turned, bent, etc., suitable for walking sticks, umbrellas, tool handles, etc.",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440410",
    description:
      "Wood; coniferous, split poles, piles, pickets, stakes, pointed but not sawn lengthwise; sticks for umbrellas, tool handles etc, roughly trimmed but not turned or bent; chipwood etc, hoopwood",
    parent: "4404",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440420",
    description:
      "Wood; non-coniferous, split poles, piles, pickets, stakes, pointed but not sawn lengthwise; sticks for umbrellas, tool handles etc, roughly trimmed but not turned or bent; chipwood etc, hoopwood",
    parent: "4404",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4405",
    description: "Wood wool; wood flour",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440500",
    description: "Wood; wood wool and wood flour",
    parent: "4405",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4406",
    description: "Railway or tramway sleepers (cross-ties) of wood",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440611",
    description:
      "Wood; railway or tramway sleepers (cross-ties), not impregnated, coniferous",
    parent: "4406",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440612",
    description:
      "Wood; railway or tramway sleepers (cross-ties), not impregnated, non-coniferous",
    parent: "4406",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440691",
    description:
      "Wood; railway or tramway sleepers (cross-ties), impregnated, coniferous",
    parent: "4406",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440692",
    description:
      "Wood; railway or tramway sleepers (cross-ties), impregnated, non-coniferous",
    parent: "4406",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4407",
    description:
      "Wood sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440711",
    description:
      "Wood; coniferous species, of pine (Pinus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440712",
    description:
      "Wood; coniferous species, of fir (Abies spp.) and spruce (Picea spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440713",
    description:
      "Wood; coniferous species, of S-P-F (spruce (Picea spp.), pine (Pinus spp.) and fir (Abies spp.)), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440714",
    description:
      "Wood; coniferous species, of Hem-fir (western hemlock (Tsuga heterophylla) and fir (Abies spp.))",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440719",
    description:
      "Wood; coniferous species, other than of pine (Pinus spp.) or fir (Abies spp.) or spruce (Picea spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440721",
    description:
      "Wood, tropical; as specified in Subheading Note 2 to this Chapter, mahogany (Swietenia spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440722",
    description:
      "Wood, tropical; virola, imbuia and balsa, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440723",
    description:
      "Wood, tropical; teak, sawn or chipped lengthwise, sliced or peeled, planed, square dressed, structural, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440725",
    description:
      "Wood, tropical; dark red meranti, light red meranti and meranti bakau, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440726",
    description:
      "Wood, tropical; white lauan, white meranti, white seraya, yellow meranti and alan, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440727",
    description:
      "Wood, tropical; sapelli, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440728",
    description:
      "Wood, tropical; iroko, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440729",
    description:
      "Wood, tropical, n.e.c. in item no. 4407.2, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440791",
    description:
      "Wood; oak (Quercus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440792",
    description:
      "Wood; beech (Fagus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440793",
    description:
      "Wood; maple (Acer spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440794",
    description:
      "Wood; cherry (Prunus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440795",
    description:
      "Wood; ash (Fraxinus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, thicker than 6mm",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440796",
    description:
      "Wood; of birch (Betula spp.), sawn or chipped lengthwise, sliced or peeled, of a thickness exceeding 6mm, whether or not planed, sanded or finger-jointed",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440797",
    description:
      "Wood; of poplar and aspen (Populus spp.), sawn or chipped lengthwise, sliced or peeled, of a thickness exceeding 6mm, whether or not planed, sanded or finger-jointed",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440799",
    description:
      "Wood; sawn or chipped lengthwise, sliced or peeled, of a thickness exceeding 6mm, whether or not planed, sanded or finger-jointed, n.e.c. in heading no. 4407",
    parent: "4407",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4408",
    description:
      "Sheets for veneering (including those obtained by slicing laminated wood), for plywood or for similar laminated wood and other wood, sawn lengthwise, sliced or peeled, planed or not, sanded, spliced or end-jointed, of a thickness not exceeding 6 mm",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440810",
    description:
      "Wood; coniferous, sheets for veneering (including those obtained by slicing laminated wood), for plywood or similar laminated wood and other wood, sawn lengthwise, sliced or peeled, planed or not, sanded, spliced or end-jointed, not over 6 mm thick",
    parent: "4408",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440831",
    description:
      "Wood, tropical; as specified in Subheading Note 2 to this Chapter, dark red meranti, light red meranti, meranti bakau, sheets for veneer, plywood or other wood, sawn lengthwise, sliced or peeled, planed or not, sanded or end-jointed, not thicker than 6mm",
    parent: "4408",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440839",
    description:
      "Wood, of tropical wood; as in Subheading note 2 to this Chapter, n.e.c. in heading no. 4408.31, sheets for veneer or plywood, other wood sawn length wise, sliced or peeled, whether or not planed, sanded or end-jointed, not thicker than 6mm",
    parent: "4408",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440890",
    description:
      "Wood; n.e.c. in heading no. 4408, sheets for veneer or plywood, other wood sawn lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, not exceeding 6mm in thickness",
    parent: "4408",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4409",
    description:
      "Wood (including strips, friezes for parquet flooring, not assembled), continuously shaped (tongued, grooved, v-jointed, beaded or the like) along any edges, ends or faces, whether or not planed, sanded or end-jointed",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "440910",
    description:
      "Wood; coniferous (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
    parent: "4409",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440921",
    description:
      "Wood; bamboo (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
    parent: "4409",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440922",
    description:
      "Wood; tropical (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
    parent: "4409",
    level: "6",
  },
  {
    section: "IX",
    hscode: "440929",
    description:
      "Wood; non-coniferous, other than bamboo or tropical wood, (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
    parent: "4409",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4410",
    description:
      "Particle board, oriented strand board (OSB) and similar board (e.g. waferboard) of wood or other ligneous materials, whether or not agglomerated with resins or other organic binding substances",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441011",
    description:
      "Particle board of wood, whether or not agglomerated with resins or other organic binding substances",
    parent: "4410",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441012",
    description:
      "Oriented strand board (OSB) of wood, whether or not agglomerated with resins or other organic binding substances",
    parent: "4410",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441019",
    description:
      "Wafer board and similar board of wood n.e.c. in item no. 4410.1, whether or not agglomerated with resins or other organic binding substances",
    parent: "4410",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441090",
    description:
      "Particle board, oriented strand board (OSB) and similar board of ligneous materials other than wood, whether or not agglomerated with resins or other organic binding substances",
    parent: "4410",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4411",
    description:
      "Fibreboard of wood or other ligneous materials, whether or not bonded with resins or other organic substances",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441112",
    description:
      "Medium density fibreboard (MDF), of a thickness not exceeding 5 mm",
    parent: "4411",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441113",
    description:
      "Medium density fibreboard (MDF), of a thickness exceeding 5 mm but not exceeding 9 mm",
    parent: "4411",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441114",
    description:
      "Medium density fibreboard (MDF), of a thickness exceeding 9 mm",
    parent: "4411",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441192",
    description:
      "Fibreboard (other than MDF) of a density exceeding 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances",
    parent: "4411",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441193",
    description:
      "Fibreboard (other than MDF) of a density exceeding 0.5g/cm3 but not 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances",
    parent: "4411",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441194",
    description:
      "Fibreboard (other than MDF) of a density not exceeding 0.5g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances",
    parent: "4411",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4412",
    description: "Plywood, veneered panels and similar laminated wood",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441210",
    description:
      "Plywood, veneered panels and similar laminated wood; of bamboo",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441231",
    description:
      "Plywood; consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with at least one outer ply of tropical wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441233",
    description:
      "Plywood; with sheets of wood only; not bamboo; each ply 6mm or less, with at least one outer ply of alder, ash, beech, birch, cherry, chestnut, elm, eucalyptus, hickory, horse chestnut, lime, maple, oak, plane, poplar, aspen, robinia, tulipwood or walnut",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441234",
    description:
      "Plywood; consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with at least one outer ply of non-coniferous wood not listed in subheading 4412.33",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441239",
    description:
      "Plywood; consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with both outer plies of coniferous wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441241",
    description:
      "Plywood, veneered panels and similar laminated wood; laminated veneered lumber (LVL); with at least one outer ply of tropical wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441242",
    description:
      "Laminated veneered lumber (LVL); with at least one outer ply of non-coniferous wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441249",
    description:
      "Laminated veneered lumber (LVL); with both outer plies of coniferous wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441251",
    description:
      "Blockboard, laminboard and battenboard; with at least one outer layer of tropical wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441252",
    description:
      "Blockboard, laminboard and battenboard; with at least one outer ply of non-coniferous wood, (not containing particle board)",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441259",
    description:
      "Blockboard, laminboard and battenboard; with both outer plies of coniferous wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441291",
    description:
      "Plywood; n.e.c. in heading 4412, with at least one outer ply of tropical wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441292",
    description:
      "Plywood; n.e.c. in heading 4412, with at least one outer ply of non-coniferous wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441299",
    description:
      "Plywood; n.e.c. in heading 4412, with both outer plies of coniferous wood",
    parent: "4412",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4413",
    description: "Densified wood, in blocks, plates, strips or profile shapes",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441300",
    description:
      "Wood; densified wood, in blocks, plates, strips or profile shapes",
    parent: "4413",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4414",
    description:
      "Wooden frames; for paintings, photographs, mirrors or similar objects",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441410",
    description:
      "Wooden frames; for paintings, photographs, mirrors or similar objects; of tropical wood",
    parent: "4414",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441490",
    description:
      "Wooden frames; for paintings, photographs, mirrors or similar objects; not of tropical wood",
    parent: "4414",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4415",
    description:
      "Packing cases, boxes, crates, drums and similar packings, of wood; cable-drums of wood; pallets, box pallets and other load boards, of wood; pallet collars of wood",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441510",
    description:
      "Wood; cases, boxes, crates, drums, similar packings and cable-drums",
    parent: "4415",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441520",
    description:
      "Wood; pallets, box pallets and other load boards; pallet collars",
    parent: "4415",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4416",
    description:
      "Casks, barrels, vats, tubs and other coopers' products and parts thereof, of wood, including staves",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441600",
    description:
      "Wood; casks, barrels, vats, tubs and other coopers' products and parts thereof, of wood, including staves",
    parent: "4416",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4417",
    description:
      "Tools, tool bodies, tool handles, broom or brush bodies and handles, of wood; boot or shoe lasts and trees, of wood",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441700",
    description:
      "Wood; tools, tool bodies, tool handles, broom or brush bodies and handles, boot and shoe lasts and trees, of wood",
    parent: "4417",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4418",
    description:
      "Builders' joinery and carpentry of wood, including cellular wood panels, assembled flooring panels, shingles and shakes",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441811",
    description:
      "Wood; windows, French-windows and their frames; of tropical wood",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441819",
    description:
      "Wood; windows, French-windows and their frames; (of other than tropical wood)",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441821",
    description:
      "Wood; doors and their frames and thresholds, of tropical wood;",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441829",
    description:
      "Wood; doors and their frames and thresholds, (of other than tropical wood)",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441830",
    description:
      "wood; posts and beams other than products of subheadings 4418.81 to 4418.89",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441840",
    description: "Wood; shuttering for concrete constructional work",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441850",
    description: "Wood; shingles and shakes",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441873",
    description:
      "Wood; assembled flooring panels, of bamboo or with at least the top layer (wear layer) of bamboo",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441874",
    description:
      "Wood; assembled flooring panels, not of bamboo or with at least the top layer (wear layer) of bamboo, for mosaic floors",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441875",
    description:
      "Wood; assembled flooring panels, not of bamboo or with at least the top layer (wear layer) of bamboo, multilayer",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441879",
    description:
      "Wood; assembled flooring panels, n.e.c in headings 4418.73, 4418.74 or 4418.75",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441881",
    description:
      "Wood; engineered structural timber products, glue-laminated timber (glulam)",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441882",
    description:
      "Wood; engineered structural timber products, cross-laminated timber (CLT or X-lam)",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441883",
    description: "Wood; engineered structural timber products, I beams",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441889",
    description:
      "Wood; engineered structural timber products, other than glue-laminated timber (glulam), cross-laminated timber (CLT or X-lam), or I beams",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441891",
    description:
      "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418, of bamboo",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441892",
    description:
      "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418, cellular wood panels",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441899",
    description:
      "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418, other than of bamboo or cellular wood panels",
    parent: "4418",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4419",
    description: "Tableware and kitchenware, of wood",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "441911",
    description:
      "Tableware and kitchenware, of wood; of bamboo, bread boards, chopping boards and similar boards",
    parent: "4419",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441912",
    description: "Tableware and kitchenware, of wood; of bamboo, chopsticks",
    parent: "4419",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441919",
    description:
      "Tableware and kitchenware, of wood; of bamboo, n.e.c. in heading 4419",
    parent: "4419",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441920",
    description: "Tableware and kitchenware, of wood; of tropical wood",
    parent: "4419",
    level: "6",
  },
  {
    section: "IX",
    hscode: "441990",
    description:
      "Tableware and kitchenware, of wood; not of bamboo or tropical wood",
    parent: "4419",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4420",
    description:
      "Wood marquetry and inlaid wood; caskets and cases for jewellery or cutlery, and similar articles of wood; statuettes and other ornaments of wood; wooden articles of furniture not falling in chapter 94",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "442011",
    description: "Wood; statuettes and other ornaments, of tropical wood",
    parent: "4420",
    level: "6",
  },
  {
    section: "IX",
    hscode: "442019",
    description:
      "Wood; statuettes and other ornaments, of other than tropical wood",
    parent: "4420",
    level: "6",
  },
  {
    section: "IX",
    hscode: "442090",
    description:
      "Wood; marquetry and inlaid wood, caskets and cases for jewellery or cutlery and similar articles of wood, wooden articles of furniture not falling in chapter 94",
    parent: "4420",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4421",
    description: "Wooden articles n.e.c. in heading no. 4414 to 4420",
    parent: "44",
    level: "4",
  },
  {
    section: "IX",
    hscode: "442110",
    description: "Wood; clothes hangers",
    parent: "4421",
    level: "6",
  },
  {
    section: "IX",
    hscode: "442120",
    description: "Wood; coffins",
    parent: "4421",
    level: "6",
  },
  {
    section: "IX",
    hscode: "442191",
    description:
      "Wood; of bamboo, articles n.e.c. in heading no. 4414 to 4420 (excluding clothes hangers)",
    parent: "4421",
    level: "6",
  },
  {
    section: "IX",
    hscode: "442199",
    description:
      "Wood; not of bamboo, articles n.e.c. in heading no. 4414 to 4420 (excluding clothes hangers)",
    parent: "4421",
    level: "6",
  },
  {
    section: "IX",
    hscode: "45",
    description: "Cork and articles of cork",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IX",
    hscode: "4501",
    description:
      "Natural cork, raw or simply prepared; waste cork; crushed, granulated or ground cork",
    parent: "45",
    level: "4",
  },
  {
    section: "IX",
    hscode: "450110",
    description: "Cork; natural cork, raw or simply prepared",
    parent: "4501",
    level: "6",
  },
  {
    section: "IX",
    hscode: "450190",
    description: "Cork; waste cork, crushed, granulated or ground cork",
    parent: "4501",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4502",
    description:
      "Natural cork, debacked or roughly squared, or in rectangular (including square) blocks, plates, sheets or strip, (including sharp-edged blanks for corks or stoppers)",
    parent: "45",
    level: "4",
  },
  {
    section: "IX",
    hscode: "450200",
    description:
      "Cork; natural cork, debacked or roughly squared, or in rectangular (including square) blocks, plates, sheets or strip, (including sharp-edged blanks for corks or stoppers)",
    parent: "4502",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4503",
    description: "Cork; articles of natural cork",
    parent: "45",
    level: "4",
  },
  {
    section: "IX",
    hscode: "450310",
    description: "Cork; corks and stoppers, of natural cork",
    parent: "4503",
    level: "6",
  },
  {
    section: "IX",
    hscode: "450390",
    description: "Cork; articles of natural cork other than corks and stoppers",
    parent: "4503",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4504",
    description:
      "Agglomerated cork (with or without a binding substance) and articles of agglomerated cork",
    parent: "45",
    level: "4",
  },
  {
    section: "IX",
    hscode: "450410",
    description:
      "Cork; blocks, plates, sheets and strip, tiles of any shape, solid cylinders (including discs), of agglomerated cork (with or without a binding substance)",
    parent: "4504",
    level: "6",
  },
  {
    section: "IX",
    hscode: "450490",
    description:
      "Cork; articles of agglomerated cork (with or without a binding substance), n.e.c. in heading no. 4504",
    parent: "4504",
    level: "6",
  },
  {
    section: "IX",
    hscode: "46",
    description:
      "Manufactures of straw, esparto or other plaiting materials; basketware and wickerwork",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "IX",
    hscode: "4601",
    description:
      "Plaits and similar products of plaiting materials, assembled into strips or not; plaiting materials, plaits and the like bound together in parallel strands or woven in sheet form, finished articles or not",
    parent: "46",
    level: "4",
  },
  {
    section: "IX",
    hscode: "460121",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; mats, matting and screens, of bamboo",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460122",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; mats, matting and screens, of rattan",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460129",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; mats, matting and screens, of vegetable materials other than bamboo or rattan",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460192",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; (not mats, matting or screens), of bamboo",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460193",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; (not mats, matting or screens), of rattan",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460194",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; (not mats, matting or screens), of vegetable materials other than bamboo or rattan",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460199",
    description:
      "Plaiting materials, plaits and similar products of plaiting materials; products of non-vegetable materials",
    parent: "4601",
    level: "6",
  },
  {
    section: "IX",
    hscode: "4602",
    description:
      "Basketwork, wickerwork and other articles, made directly to shape from plaiting materials or made up from goods of heading no. 4601; articles of loofah",
    parent: "46",
    level: "4",
  },
  {
    section: "IX",
    hscode: "460211",
    description:
      "Basketwork, wickerwork and other articles; of bamboo, made directly to shape from plaiting materials or made up from goods of heading no. 4601",
    parent: "4602",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460212",
    description:
      "Basketwork, wickerwork and other articles; of rattan, made directly to shape from plaiting materials or made up from goods of heading no. 4601",
    parent: "4602",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460219",
    description:
      "Basketwork, wickerwork and other articles; of vegetable materials (not bamboo or rattan), made directly to shape from plaiting materials or made up from goods of heading no. 4601; articles of loofah",
    parent: "4602",
    level: "6",
  },
  {
    section: "IX",
    hscode: "460290",
    description:
      "Basketwork, wickerwork and other articles; of non-vegetable materials, made directly to shape from plaiting materials or made up from goods of heading no. 4601",
    parent: "4602",
    level: "6",
  },
  {
    section: "X",
    hscode: "47",
    description:
      "Pulp of wood or other fibrous cellulosic material; recovered (waste and scrap) paper or paperboard",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "X",
    hscode: "4701",
    description: "Wood pulp, mechanical wood pulp",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470100",
    description: "Wood pulp; mechanical wood pulp",
    parent: "4701",
    level: "6",
  },
  {
    section: "X",
    hscode: "4702",
    description: "Chemical wood pulp, dissolving grades",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470200",
    description: "Wood pulp; chemical wood pulp, dissolving grades",
    parent: "4702",
    level: "6",
  },
  {
    section: "X",
    hscode: "4703",
    description:
      "Chemical wood pulp, soda or sulphate, other than dissolving grades",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470311",
    description:
      "Wood pulp; chemical wood pulp, soda or sulphate, (other than dissolving grades), unbleached, of coniferous wood",
    parent: "4703",
    level: "6",
  },
  {
    section: "X",
    hscode: "470319",
    description:
      "Wood pulp; chemical wood pulp, soda or sulphate, (other than dissolving grades), unbleached, of non-coniferous wood",
    parent: "4703",
    level: "6",
  },
  {
    section: "X",
    hscode: "470321",
    description:
      "Wood pulp; chemical wood pulp, soda or sulphate, (other than dissolving grades), semi-bleached or bleached, of coniferous wood",
    parent: "4703",
    level: "6",
  },
  {
    section: "X",
    hscode: "470329",
    description:
      "Wood pulp; chemical wood pulp, soda or sulphate, (other than dissolving grades), semi-bleached or bleached, of non-coniferous wood",
    parent: "4703",
    level: "6",
  },
  {
    section: "X",
    hscode: "4704",
    description: "Chemical wood pulp, sulphite, other than dissolving grades",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470411",
    description:
      "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), unbleached, of coniferous wood",
    parent: "4704",
    level: "6",
  },
  {
    section: "X",
    hscode: "470419",
    description:
      "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), unbleached, of non-coniferous wood",
    parent: "4704",
    level: "6",
  },
  {
    section: "X",
    hscode: "470421",
    description:
      "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), semi-bleached or bleached, of coniferous wood",
    parent: "4704",
    level: "6",
  },
  {
    section: "X",
    hscode: "470429",
    description:
      "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), semi-bleached or bleached, of non-coniferous wood",
    parent: "4704",
    level: "6",
  },
  {
    section: "X",
    hscode: "4705",
    description:
      "Wood pulp obtained by a combination of mechanical and chemical pulping processes",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470500",
    description:
      "Wood pulp; obtained by a combination of mechanical and chemical pulping processes",
    parent: "4705",
    level: "6",
  },
  {
    section: "X",
    hscode: "4706",
    description:
      "Pulps of fibres derived from recovered (waste and scrap) paper or paperboard or of other fibrous cellulosic material",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470610",
    description: "Pulp; cotton linters pulp",
    parent: "4706",
    level: "6",
  },
  {
    section: "X",
    hscode: "470620",
    description:
      "Pulp; of fibres derived from recovered (waste and scrap) paper or paperboard",
    parent: "4706",
    level: "6",
  },
  {
    section: "X",
    hscode: "470630",
    description: "Pulp; of bamboo",
    parent: "4706",
    level: "6",
  },
  {
    section: "X",
    hscode: "470691",
    description:
      "Pulp; of fibrous cellulosic material, other than of bamboo or fibres derived from recovered (waste and scrap) paper or paperboard or from cotton linters pulp, mechanical",
    parent: "4706",
    level: "6",
  },
  {
    section: "X",
    hscode: "470692",
    description:
      "Pulp; of fibrous cellulosic material, other than of bamboo or fibres derived from recovered (waste and scrap) paper or paperboard or from cotton linters pulp, chemical",
    parent: "4706",
    level: "6",
  },
  {
    section: "X",
    hscode: "470693",
    description:
      "Pulp; of fibrous cellulosic material, other than of bamboo or fibres derived from recovered (waste and scrap) paper or paperboard or from cotton linters pulp, obtained by a combination of mechanical and chemical processes",
    parent: "4706",
    level: "6",
  },
  {
    section: "X",
    hscode: "4707",
    description: "Waste and scrap of paper and paperboard",
    parent: "47",
    level: "4",
  },
  {
    section: "X",
    hscode: "470710",
    description:
      "Paper or paperboard; waste and scrap, of unbleached kraft paper or paperboard or corrugated paper or paperboard",
    parent: "4707",
    level: "6",
  },
  {
    section: "X",
    hscode: "470720",
    description:
      "Paper or paperboard; waste and scrap, paper or paperboard made mainly of bleached chemical pulp, not coloured in the mass",
    parent: "4707",
    level: "6",
  },
  {
    section: "X",
    hscode: "470730",
    description:
      "Paper or paperboard; waste and scrap, paper or paperboard made mainly of mechanical pulp (e.g. newspapers, journals and similar printed matter)",
    parent: "4707",
    level: "6",
  },
  {
    section: "X",
    hscode: "470790",
    description:
      "Paper or paperboard; waste and scrap, of paper or paperboard n.e.c. in heading no. 4707 and of unsorted waste and scrap",
    parent: "4707",
    level: "6",
  },
  {
    section: "X",
    hscode: "48",
    description:
      "Paper and paperboard; articles of paper pulp, of paper or paperboard",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "X",
    hscode: "4801",
    description: "Newsprint, in rolls or sheets",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480100",
    description:
      "Newsprint; made of fibres obtained essentially by a chemi-mechanical process or of a weight, per m2, of more than 57g but not more than 65g, in rolls or sheets",
    parent: "4801",
    level: "6",
  },
  {
    section: "X",
    hscode: "4802",
    description:
      "Uncoated paper and paperboard, used for writing, printing or other graphics, non perforated punch-cards and punch tape paper, in rolls or rectangular sheets, of any size, other than paper of heading 4801 or 4803; hand-made paper and paperboard",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480210",
    description: "Hand-made paper or paperboard",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480220",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); of a kind used as a base for photo-sensitive, heat-sensitive or electro-sensitive paper or paperboard, in rolls or sheets",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480240",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); wallpaper base, in rolls or sheets",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480254",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weighing less than 40g/m2, in rolls or sheets",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480255",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weighing 40g/m2 to 150g/m2, in rolls",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480256",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weight 40-150g/m2, in sheets 435mm or less by 297mm or less (unfolded)",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480257",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weight 40-150g/m2, n.e.c. in item no. 4802.55 or 4802.56",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480258",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weighing more than 150g/m2",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480261",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); over 10% by weight of mechanical or chemi-mechanical processed fibre, in rolls",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480262",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); over 10% by weight of mechanical or chemi-mechanical processed fibre, in sheets 435mm or less by 297mm or less (unfolded)",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "480269",
    description:
      "Uncoated paper and paperboard (not 4801 or 4803); over 10% by weight of mechanical or chemi-mechanical processed fibre, other than rolls, other than sheets 435mm or less by 297mm or less (unfolded)",
    parent: "4802",
    level: "6",
  },
  {
    section: "X",
    hscode: "4803",
    description:
      "Tissue, towel, napkin stock or similar; for household or sanitary uses, cellulose wadding, webs of cellulose fibres, in rolls over 36cm in width or rectangular sheets with one side exceeding 36cm when unfolded",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480300",
    description:
      "Tissue, towel, napkin stock or similar; for household or sanitary use, cellulose, wadding webs of cellulose fibres, in rolls exceeding 36cm in width or rectangular sheets with one side more than 36cm in unfolded state",
    parent: "4803",
    level: "6",
  },
  {
    section: "X",
    hscode: "4804",
    description:
      "Uncoated kraft paper and paperboard, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480411",
    description:
      "Kraft paper and paperboard; kraftliner, uncoated, unbleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480419",
    description:
      "Kraft paper and paperboard; kraftliner, uncoated, bleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480421",
    description:
      "Kraft paper and paperboard; sack kraft paper, uncoated, unbleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480429",
    description:
      "Kraft paper and paperboard; sack kraft paper, uncoated, bleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480431",
    description:
      "Kraft paper and paperboard; uncoated, unbleached, weight 150g/m2 or less, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480439",
    description:
      "Kraft paper and paperboard; uncoated, bleached, weight 150g/m2 or less, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480441",
    description:
      "Kraft paper and paperboard; uncoated, unbleached, weight more than 150g/m2 but less than 225g/m2, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480442",
    description:
      "Kraft paper and paperboard; uncoated, weight between 150 and 225g/m2, bleached uniformly throughout, more than 95% of total fibre content consists of chemically processed wood fibres, in rolls or sheets",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480449",
    description:
      "Kraft paper and paperboard; uncoated, weight more than 150g/m2 but less than 225g/m2, in rolls or sheets, n.e.c. in item no. 4804.4, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480451",
    description:
      "Kraft paper and paperboard; uncoated, unbleached, weight 225g/m2 or more, in rolls or sheets, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480452",
    description:
      "Kraft paper and paperboard; uncoated, weight 225g/m2 or more, bleached uniformly throughout, more than 95% of total fibre content consists of chemically processed wood fibres, in rolls or sheets",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "480459",
    description:
      "Kraft paper and paperboard; uncoated, weight 225g/m2 or more, in rolls or sheets, n.e.c. in item no. 4804.5, other than that of heading no. 4802 or 4803",
    parent: "4804",
    level: "6",
  },
  {
    section: "X",
    hscode: "4805",
    description: "Uncoated paper and paperboard n.e.c., in rolls or sheets",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480511",
    description:
      "Paper and paperboard; uncoated, semi-chemical fluting paper, rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480512",
    description:
      "Paper and paperboard; uncoated, straw fluting paper, rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480519",
    description:
      "Paper and paperboard; uncoated, fluting paper other than semi-chemical or straw, rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480524",
    description:
      "Paper & paperboard; uncoated, testliner (recycled linerboard), weight 150g/m2, or less, in rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480525",
    description:
      "Paper & paperboard; uncoated, testliner (recycled linerboard), weight over 150g/m2, in rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480530",
    description:
      "Paper and paperboard; sulphite wrapping paper, uncoated, in rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480540",
    description:
      "Paper and paperboard; filter paper and paperboard, uncoated, in rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480550",
    description:
      "Paper and paperboard; felt paper and paperboard, uncoated, in rolls or sheets",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480591",
    description:
      "Paper and paperboard; uncoated, weight 150g/m2 or less, in rolls or sheets, n.e.c. in heading no.4805",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480592",
    description:
      "Paper and paperboard; uncoated, weight more than 150g/m2 but less than 225 g/m2, in rolls or sheets, n.e.c. in heading no. 4805",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "480593",
    description:
      "Paper and paperboard; uncoated, weight 225/m2 or more, in rolls or sheets, n.e.c. in heading no. 4805",
    parent: "4805",
    level: "6",
  },
  {
    section: "X",
    hscode: "4806",
    description:
      "Vegetable parchment, greaseproof papers, tracing papers, glassine and other glazed transparent or translucent papers, in rolls or sheets",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480610",
    description: "Paper; vegetable parchment, in rolls or sheets",
    parent: "4806",
    level: "6",
  },
  {
    section: "X",
    hscode: "480620",
    description: "Paper; greaseproof papers, in rolls or sheets",
    parent: "4806",
    level: "6",
  },
  {
    section: "X",
    hscode: "480630",
    description: "Paper; tracing papers, in rolls or sheets",
    parent: "4806",
    level: "6",
  },
  {
    section: "X",
    hscode: "480640",
    description:
      "Paper; glassine and other glazed transparent or translucent papers, in rolls or sheets",
    parent: "4806",
    level: "6",
  },
  {
    section: "X",
    hscode: "4807",
    description:
      "Composite paper and paperboard, (made by sticking layers together with an adhesive), not surface-coated or impregnated, whether or not internally reinforced, in rolls or sheets",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480700",
    description:
      "Paper and paperboard; composite (made by sticking layers together with an adhesive), not surface-coated or impregnated, whether or not internally reinforced, in rolls or sheets",
    parent: "4807",
    level: "6",
  },
  {
    section: "X",
    hscode: "4808",
    description:
      "Paper and paperboard, corrugated (with or without glued flat surface sheets), creped, crinkled, embossed or perforated, in rolls or sheets other than paper of the kind described in heading 4803",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480810",
    description:
      "Paper and paperboard; corrugated, whether or not perforated, in rolls or sheets, other than paper of heading 4803",
    parent: "4808",
    level: "6",
  },
  {
    section: "X",
    hscode: "480840",
    description:
      "Paper and paperboard; kraft paper, creped or crinkled, whether or not embossed or perforated, in rolls or sheets, other than paper of heading 4803",
    parent: "4808",
    level: "6",
  },
  {
    section: "X",
    hscode: "480890",
    description:
      "Paper and paperboard; other than corrugated (with or without glued flat surface sheets) or kraft paper, creped or crinkled, whether or not embossed or perforated, in rolls or sheets, other than paper of heading 4803",
    parent: "4808",
    level: "6",
  },
  {
    section: "X",
    hscode: "4809",
    description:
      "Carbon paper, self copy paper, and other copying or transfer papers (including coated or impregnated paper for duplicator stencils or offset plates), whether or not printed, in rolls or sheets",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "480920",
    description:
      "Paper; self-copy paper, whether or not printed, in rolls or sheets",
    parent: "4809",
    level: "6",
  },
  {
    section: "X",
    hscode: "480990",
    description:
      "Paper; carbon paper and other copying or transfer papers (including coated or impregnated paper for duplicator stencils or offset plates), whether or not printed, in rolls or sheets",
    parent: "4809",
    level: "6",
  },
  {
    section: "X",
    hscode: "4810",
    description:
      "Paper and paperboard, coated one or both sides with kaolin (china clay) or inorganic substances, with binder or not, no other coating, surface coloured or not, surface decorated or printed, in rolls or rectangular (including square) sheets, of any size",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481013",
    description:
      "Paper and paperboard; coated with kaolin or other inorganic substances, for printing & writing, graphics, containing no, or not more than 10% by weight of total fibres obtained by mechanical or chemi-mechanical process, in rolls",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481014",
    description:
      "Paper and paperboard; coated with kaolin or other inorganic substances, for printing/writing/graphics, having 10% or less by weight of total fibres got mechanical/chemi-mechanical process, sheets, sides 435mm or less by 297mm or less, unfolded,",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481019",
    description:
      "Paper and paperboard; coated with kaolin or other inorganic substances, for printing/writing/graphics, having 10% or less by weight of total fibres got by mechanical/chemi-mechanical process, sides exceeding 435mm and 297mm, unfolded, sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481022",
    description:
      "Paper and paperboard; coated with kaolin or other inorganic substances only, having more than 10% of mechanical or chemi-mechanical processed fibres, for writing, printing or other graphic purposes, light-weight coated paper, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481029",
    description:
      "Paper and paperboard; coated with kaolin or other inorganic substances only, having more than 10% of mechanically processed fibres, (excluding light-weight paper), for writing, printing or other graphic purposes, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481031",
    description:
      "Kraft paper and paperboard; uniformly bleached throughout, coated with inorganic substances, more than 95% of chemically processed wood fibres, weight 150g/m2 or less, for non-graphic purposes, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481032",
    description:
      "Kraft paper and paperboard; uniformly bleached throughout, coated with inorganic substances, more than 95% of chemically processed wood fibres, weight more than 150g/m2, for non-graphic purposes, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481039",
    description:
      "Kraft paper and paperboard; coated with kaolin or other inorganic substances only, for non-graphic purposes, n.e.c. in item no. 4810.31 and 4810.32, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481092",
    description:
      "Paper and paperboard; multi-ply, coated with kaolin or other inorganic substances only, for non-graphic purposes, n.e.c. in heading no. 4810, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "481099",
    description:
      "Paper and paperboard; coated with inorganic substances only, whether or not surface-coloured, surface-decorated or printed, n.e.c. in heading no. 4810, in rolls or sheets",
    parent: "4810",
    level: "6",
  },
  {
    section: "X",
    hscode: "4811",
    description:
      "Paper, paperboard, cellulose wadding and webs of cellulose fibres, coated, impregnated, covered, surface-coloured, decorated or printed, rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481110",
    description:
      "Paper and paperboard; tarred, bituminised or asphalted, in rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "481141",
    description:
      "Paper and paperboard; self-adhesive, in rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "481149",
    description:
      "Paper and paperboard; gummed or adhesive paper and paperboard (excluding self-adhesive), in rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "481151",
    description:
      "Paper and paperboard; coated, impregnated or covered with plastics (excluding adhesives), bleached, weighing more than 150g/m2, other than goods of heading no. 4803, 4809, or 4810",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "481159",
    description:
      "Paper and paperboard; coated, impregnated or covered with plastics (excluding adhesives), other than bleached and weighing more than 150g/m2, other than goods of heading no. 4803, 4809, or 4810",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "481160",
    description:
      "Paper and paperboard; coated, impregnated or covered with wax, paraffin wax, stearin, oil or glycerol, other than goods of heading no. 4803, 4809, or 4810",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "481190",
    description:
      "Paper, paperboard, cellulose wadding and webs of soft cellulose fibres; coated, impregnated, covered, surface-decorated or surface-coloured, n.e.c. in heading no. 4811, in rolls or sheets",
    parent: "4811",
    level: "6",
  },
  {
    section: "X",
    hscode: "4812",
    description: "Filter blocks, slabs and plates of paper pulp",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481200",
    description: "Paper pulp; filter blocks, slabs and plates of paper pulp",
    parent: "4812",
    level: "6",
  },
  {
    section: "X",
    hscode: "4813",
    description:
      "Cigarette paper, whether or not cut to size or in the form of booklets or tubes",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481310",
    description: "Paper, cigarette; in the form of booklets or tubes",
    parent: "4813",
    level: "6",
  },
  {
    section: "X",
    hscode: "481320",
    description: "Paper, cigarette; in rolls of a width not exceeding 5cm",
    parent: "4813",
    level: "6",
  },
  {
    section: "X",
    hscode: "481390",
    description:
      "Paper, cigarette; (other than in rolls of a width not exceeding 5cm, or in booklets or tubes)",
    parent: "4813",
    level: "6",
  },
  {
    section: "X",
    hscode: "4814",
    description:
      "Wallpaper and similar wall coverings; window transparencies of paper",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481420",
    description:
      "Wallpaper and similar wall coverings; coated or covered on the face side, with a grained, embossed, coloured, design-printed or otherwise decorated layer of plastics",
    parent: "4814",
    level: "6",
  },
  {
    section: "X",
    hscode: "481490",
    description:
      "Wallpaper and similar wall coverings and window transparencies of paper; n.e.c. in heading 4814",
    parent: "4814",
    level: "6",
  },
  {
    section: "X",
    hscode: "4816",
    description:
      "Carbon paper, self-copy paper and other copying or transfer papers, (other than those of heading no. 4809), duplicator stencils and offset plates, of paper whether or not put up in boxes",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481620",
    description:
      "Paper; self-copy paper (other than those of heading no. 4809), whether or not put up in boxes",
    parent: "4816",
    level: "6",
  },
  {
    section: "X",
    hscode: "481690",
    description:
      "Paper; carbon paper and other copying or transfer papers (other than those of heading no. 4809), n.e.c. in item no. 4816.20",
    parent: "4816",
    level: "6",
  },
  {
    section: "X",
    hscode: "4817",
    description:
      "Envelopes, letter cards, plain postcards and correspondence cards, of paper, paperboard; boxes, pouches, wallets and writing compendiums, of paper or paperboard containing assortment of paper stationery",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481710",
    description: "Paper and paperboard; envelopes",
    parent: "4817",
    level: "6",
  },
  {
    section: "X",
    hscode: "481720",
    description:
      "Paper and paperboard; letter cards, plain postcards and correspondence cards",
    parent: "4817",
    level: "6",
  },
  {
    section: "X",
    hscode: "481730",
    description:
      "Paper and paperboard; boxes, pouches, wallets and writing compendiums containing an assortment of paper stationery",
    parent: "4817",
    level: "6",
  },
  {
    section: "X",
    hscode: "4818",
    description:
      "Toilet paper, width 36cm or less or cut to size/shape; handkerchiefs, tissues, towels, serviettes, bed sheets and similar household or hospital articles, apparel and clothing accessories of paper pulp, paper, cellulose wadding or webs of cellulose fibres",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481810",
    description: "Paper articles; toilet paper",
    parent: "4818",
    level: "6",
  },
  {
    section: "X",
    hscode: "481820",
    description:
      "Paper articles; handkerchiefs, cleansing or facial tissues and towels",
    parent: "4818",
    level: "6",
  },
  {
    section: "X",
    hscode: "481830",
    description:
      "Paper articles; tablecloths and serviettes, of paper, cellulose wadding or fibres",
    parent: "4818",
    level: "6",
  },
  {
    section: "X",
    hscode: "481850",
    description:
      "Paper articles; apparel and clothing accessories of paper, cellulose wadding or fibres",
    parent: "4818",
    level: "6",
  },
  {
    section: "X",
    hscode: "481890",
    description:
      "Paper articles; articles of paper, cellulose wadding or fibres, n.e.c. in heading no. 4818",
    parent: "4818",
    level: "6",
  },
  {
    section: "X",
    hscode: "4819",
    description:
      "Cartons, boxes, cases, bags and the like, of paper, paperboard, cellulose wadding or fibres; box files, letter trays and the like, of paper or paperboard, of a kind used in offices, shops or the like",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "481910",
    description:
      "Paper and paperboard; cartons, boxes and cases, of corrugated paper or paperboard",
    parent: "4819",
    level: "6",
  },
  {
    section: "X",
    hscode: "481920",
    description:
      "Paper and paperboard; folding cartons, boxes and cases, of non-corrugated paper or paperboard",
    parent: "4819",
    level: "6",
  },
  {
    section: "X",
    hscode: "481930",
    description:
      "Paper and paperboard; sacks and bags of paper, paperboard, cellulose wadding or fibres, having a base of a width of 40cm or more",
    parent: "4819",
    level: "6",
  },
  {
    section: "X",
    hscode: "481940",
    description:
      "Paper and paperboard; sacks and bags, including cones, of paper, paperboard, cellulose wadding or fibres, having a base width less than 40cm",
    parent: "4819",
    level: "6",
  },
  {
    section: "X",
    hscode: "481950",
    description:
      "Paper and paperboard; packing containers, including record sleeves, of paper, paperboard, cellulose wadding or fibres, n.e.c. in heading no. 4819",
    parent: "4819",
    level: "6",
  },
  {
    section: "X",
    hscode: "481960",
    description:
      "Paper and paperboard; box files, letter trays, storage boxes and similar articles, used in offices, shops or the like of paper, paperboard, cellulose wadding or webs of cellulose fibres",
    parent: "4819",
    level: "6",
  },
  {
    section: "X",
    hscode: "4820",
    description:
      "Registers, account books, diaries and similar; albums for samples or collections, of paper or paperboard",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "482010",
    description:
      "Paper and paperboard; registers, account books, note books, order books, receipt books, letter pads, memorandum pads, diaries and similar articles",
    parent: "4820",
    level: "6",
  },
  {
    section: "X",
    hscode: "482020",
    description: "Paper and paperboard; exercise books",
    parent: "4820",
    level: "6",
  },
  {
    section: "X",
    hscode: "482030",
    description: "Paper and paperboard; binders, folders and file covers",
    parent: "4820",
    level: "6",
  },
  {
    section: "X",
    hscode: "482040",
    description:
      "Paper and paperboard; manifold business forms and interleaved carbon sets",
    parent: "4820",
    level: "6",
  },
  {
    section: "X",
    hscode: "482050",
    description: "Paper and paperboard; albums for samples or for collections",
    parent: "4820",
    level: "6",
  },
  {
    section: "X",
    hscode: "482090",
    description: "Paper or paperboard; stationery n.e.c. in heading no. 4820",
    parent: "4820",
    level: "6",
  },
  {
    section: "X",
    hscode: "4821",
    description:
      "Paper or paperboard labels of all kinds, whether or not printed",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "482110",
    description: "Paper and paperboard; labels or all kinds, printed",
    parent: "4821",
    level: "6",
  },
  {
    section: "X",
    hscode: "482190",
    description: "Paper and paperboard; labels of all kinds, unprinted",
    parent: "4821",
    level: "6",
  },
  {
    section: "X",
    hscode: "4822",
    description:
      "Bobbins, spools, cops and similar supports of paper pulp, paper or paperboard (whether or not perforated or hardened)",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "482210",
    description:
      "Paper pulp, paper or paperboard; bobbins, spools, cops and similar supports, of a kind used for winding textile yarn (whether or not perforated or hardened)",
    parent: "4822",
    level: "6",
  },
  {
    section: "X",
    hscode: "482290",
    description:
      "Paper pulp, paper or paperboard; bobbins, spools, cops and similar supports, other than of a kind used for winding textile yarn (whether or not perforated or hardened)",
    parent: "4822",
    level: "6",
  },
  {
    section: "X",
    hscode: "4823",
    description:
      "Paper, paperboard, cellulose wadding and webs of cellulose fibres; cut to size or shape, articles of paper pulp, paper and paper-board, cellulose wadding or webs of cellulose fibres, n.e.c. in chapter 48",
    parent: "48",
    level: "4",
  },
  {
    section: "X",
    hscode: "482320",
    description: "Paper and paperboard; filter paper and paperboard",
    parent: "4823",
    level: "6",
  },
  {
    section: "X",
    hscode: "482340",
    description:
      "Paper and paperboard; rolls, sheets and dials, printed for self-recording apparatus",
    parent: "4823",
    level: "6",
  },
  {
    section: "X",
    hscode: "482361",
    description:
      "Paper and paperboard; trays, dishes, plates, cups and the like, of bamboo paper or paperboard",
    parent: "4823",
    level: "6",
  },
  {
    section: "X",
    hscode: "482369",
    description:
      "Paper and paperboard; trays, dishes, plates, cups and the like, of paper or paperboard other than of bamboo",
    parent: "4823",
    level: "6",
  },
  {
    section: "X",
    hscode: "482370",
    description: "Paper pulp; moulded or pressed articles or paper pulp",
    parent: "4823",
    level: "6",
  },
  {
    section: "X",
    hscode: "482390",
    description:
      "Paper pulp, paper, paperboard, cellulose wadding or webs of cellulose fibres; articles n.e.c. in heading no. 4823",
    parent: "4823",
    level: "6",
  },
  {
    section: "X",
    hscode: "49",
    description:
      "Printed books, newspapers, pictures and other products of the printing industry; manuscripts, typescripts and plans",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "X",
    hscode: "4901",
    description:
      "Printed books, brochures, leaflets and similar printed matter, whether or not in single sheets",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490110",
    description: "Printed matter; in single sheets, whether or not folded",
    parent: "4901",
    level: "6",
  },
  {
    section: "X",
    hscode: "490191",
    description:
      "Printed matter; dictionaries, encyclopaedias and serial instalments thereof",
    parent: "4901",
    level: "6",
  },
  {
    section: "X",
    hscode: "490199",
    description:
      "Printed matter; books, brochures, leaflets and similar printed matter n.e.c. in item no. 4901.10 or 4901.91",
    parent: "4901",
    level: "6",
  },
  {
    section: "X",
    hscode: "4902",
    description:
      "Newspapers, journals and periodicals, whether or not illustrated or containing advertising material",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490210",
    description:
      "Newspapers, journals and periodicals; whether or not illustrated or containing advertising material, appearing at least four times a week",
    parent: "4902",
    level: "6",
  },
  {
    section: "X",
    hscode: "490290",
    description:
      "Newspapers, journals and periodicals; whether or not illustrated or containing advertising material, appearing less frequently than four times a week",
    parent: "4902",
    level: "6",
  },
  {
    section: "X",
    hscode: "4903",
    description: "Children's picture, drawing or colouring books",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490300",
    description:
      "Printed matter; children's picture, drawing or colouring books",
    parent: "4903",
    level: "6",
  },
  {
    section: "X",
    hscode: "4904",
    description:
      "Music, printed or in manuscript, whether or not bound or illustrated",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490400",
    description:
      "Music; printed or in manuscript, whether or not bound or illustrated",
    parent: "4904",
    level: "6",
  },
  {
    section: "X",
    hscode: "4905",
    description:
      "Maps and hydrographic or similar charts of all kinds, including atlases, wall maps, topographical plans and globes, printed",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490520",
    description:
      "Maps and hydrographic or similar charts; printed in book form, including atlases, topographical plans and similar",
    parent: "4905",
    level: "6",
  },
  {
    section: "X",
    hscode: "490590",
    description:
      "Maps and hydrographic or similar charts; (printed other than in book form), including wall maps, topographical plans and similar",
    parent: "4905",
    level: "6",
  },
  {
    section: "X",
    hscode: "4906",
    description:
      "Plans and drawings; for architectural, engineering, industrial, commercial, topographical or similar, being originals drawn by hand; hand-written texts; photo- graphic reproductions; their carbon copies",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490600",
    description:
      "Plans and drawings; for architectural, engineering, industrial, commercial, topographical or similar, being originals drawn by hand; hand-written texts; photo- graphic reproductions; their carbon copies",
    parent: "4906",
    level: "6",
  },
  {
    section: "X",
    hscode: "4907",
    description:
      "Unused postage, revenue or similar stamps of current or new issue in the country in which they have, or will have, a recognised face value; stamp-impressed paper; cheque forms; banknotes, stock, share or bond certificates and the like of similar title",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490700",
    description:
      "Unused postage, revenue or similar stamps of current or new issue in the country in which they have, or will have, a recognised face value; stamp-impressed paper; cheque forms; banknotes, stock, share or bond certificates and the like of similar title",
    parent: "4907",
    level: "6",
  },
  {
    section: "X",
    hscode: "4908",
    description: "Transfers (decalcomanias)",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490810",
    description: "Printed matter; transfers (decalcomanias), vitrifiable",
    parent: "4908",
    level: "6",
  },
  {
    section: "X",
    hscode: "490890",
    description:
      "Printed matter; transfers (decalcomanias), other than vitrifiable",
    parent: "4908",
    level: "6",
  },
  {
    section: "X",
    hscode: "4909",
    description:
      "Printed or illustrated postcards; printed cards bearing personal greetings, messages or announcements, whether or not illustrated, with or without envelopes or trimmings",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "490900",
    description:
      "Printed or illustrated postcards; printed cards bearing personal greetings, messages or announcements, whether or not illustrated, with or without envelopes or trimmings",
    parent: "4909",
    level: "6",
  },
  {
    section: "X",
    hscode: "4910",
    description: "Calendars of any kind, printed, including calendar blocks",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "491000",
    description: "Calendars; printed, of any kind, including calendar blocks",
    parent: "4910",
    level: "6",
  },
  {
    section: "X",
    hscode: "4911",
    description:
      "Printed matter, n.e.c., including printed pictures and photographs",
    parent: "49",
    level: "4",
  },
  {
    section: "X",
    hscode: "491110",
    description:
      "Printed matter; trade advertising material, commercial catalogues and the like",
    parent: "4911",
    level: "6",
  },
  {
    section: "X",
    hscode: "491191",
    description:
      "Printed matter; pictures, designs and photographs, n.e.c. in item no. 4911.10",
    parent: "4911",
    level: "6",
  },
  {
    section: "X",
    hscode: "491199",
    description: "Printed matter; n.e.c. in heading no. 4911",
    parent: "4911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "50",
    description: "Silk",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5001",
    description: "Silk-worm cocoons suitable for reeling",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500100",
    description: "Silk; silk-worm cocoons suitable for reeling",
    parent: "5001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5002",
    description: "Raw silk (not thrown)",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500200",
    description: "Silk; raw silk (not thrown)",
    parent: "5002",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5003",
    description:
      "Silk waste (including cocoons unsuitable for reeling, yarn waste and garnetted stock)",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500300",
    description:
      "Silk waste (including cocoons unsuitable for reeling, yarn waste and garnetted stock)",
    parent: "5003",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5004",
    description:
      "Silk; yarn (other than yarn spun from silk waste), not put up for retail sale",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500400",
    description:
      "Silk; yarn (other than yarn spun from silk waste), not put up for retail sale",
    parent: "5004",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5005",
    description: "Yarn spun from silk waste, not put up for retail sale",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500500",
    description: "Silk; yarn spun from silk waste, not put up for retail sale",
    parent: "5005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5006",
    description:
      "Silk yarn and yarn spun from silk waste, put up for retail sale; silk-worm gut",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500600",
    description:
      "Silk yarn and yarn spun from silk waste; put up for retail sale, and silk-worm gut",
    parent: "5006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5007",
    description: "Woven fabrics of silk or of silk waste",
    parent: "50",
    level: "4",
  },
  {
    section: "XI",
    hscode: "500710",
    description: "Silk; woven fabrics of noil silk",
    parent: "5007",
    level: "6",
  },
  {
    section: "XI",
    hscode: "500720",
    description:
      "Silk; woven fabrics, containing 85% or more by weight of silk or of silk waste other than noil silk",
    parent: "5007",
    level: "6",
  },
  {
    section: "XI",
    hscode: "500790",
    description: "Silk; woven fabrics n.e.c. in heading no. 5007",
    parent: "5007",
    level: "6",
  },
  {
    section: "XI",
    hscode: "51",
    description:
      "Wool, fine or coarse animal hair; horsehair yarn and woven fabric",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5101",
    description: "Wool, not carded or combed",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510111",
    description:
      "Wool; (not carded or combed), greasy (including fleece-washed wool), shorn",
    parent: "5101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510119",
    description:
      "Wool; (other than shorn), greasy (including fleece-washed wool), not carded or combed",
    parent: "5101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510121",
    description:
      "Wool; (not carded or combed), degreased, (not carbonised), shorn",
    parent: "5101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510129",
    description:
      "Wool; (not carded or combed), degreased, (not carbonised), (other than shorn)",
    parent: "5101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510130",
    description: "Wool; (not carded or combed), carbonised",
    parent: "5101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5102",
    description: "Fine or coarse animal hair, not carded or combed",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510211",
    description:
      "Hair; fine animal hair, not carded or combed, of kashmir (cashmere) goats",
    parent: "5102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510219",
    description:
      "Hair; fine animal hair, not carded or combed, other than of kashmir (cashmere) goats",
    parent: "5102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510220",
    description: "Hair; coarse animal hair, not carded or combed",
    parent: "5102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5103",
    description:
      "Waste of wool or of fine or coarse animal hair, including yarn waste but excluding garnetted stock",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510310",
    description:
      "Wool and hair; noils of wool or of fine animal hair, including yarn waste, but excluding garnetted stock",
    parent: "5103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510320",
    description:
      "Wool and hair; waste of wool or of fine animal hair, including yarn waste, but excluding garnetted stock and noils of wool or of fine animal hair",
    parent: "5103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510330",
    description:
      "Wool and hair; waste of coarse animal hair, including yarn waste, but excluding garnetted stock",
    parent: "5103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5104",
    description: "Wool, or fine or coarse animal hair; garnetted stock",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510400",
    description:
      "Wool and hair; garnetted stock of wool or of fine or coarse animal hair",
    parent: "5104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5105",
    description:
      "Wool and fine or coarse animal hair; carded or combed (including combed wool in fragments)",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510510",
    description: "Wool; carded",
    parent: "5105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510521",
    description: "Wool; wool tops and other combed wool, in fragments",
    parent: "5105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510529",
    description:
      "Wool; wool tops and other combed wool, other than in fragments",
    parent: "5105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510531",
    description:
      "Hair; fine animal hair, carded or combed, of kashmir (cashmere) goats",
    parent: "5105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510539",
    description:
      "Hair; fine animal hair, carded or combed, other than of kashmir (cashmere) goats",
    parent: "5105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510540",
    description: "Hair; coarse animal hair, carded or combed",
    parent: "5105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5106",
    description: "Yarn of carded wool, not put up for retail sale",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510610",
    description:
      "Yarn; of carded wool, containing 85% or more by weight of wool, not put up for retail sale",
    parent: "5106",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510620",
    description:
      "Yarn; of carded wool, containing less than 85% by weight of wool, not put up for retail sale",
    parent: "5106",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5107",
    description: "Yarn of combed wool, not put up for retail sale",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510710",
    description:
      "Yarn; of combed wool, containing 85% or more by weight of wool, not put up for retail sale",
    parent: "5107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510720",
    description:
      "Yarn; of combed wool, containing less than 85% by weight of wool, not put up for retail sale",
    parent: "5107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5108",
    description:
      "Yarn of fine animal hair (carded or combed), not put up for retail sale",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510810",
    description:
      "Yarn; of fine animal hair, carded, not put up for retail sale",
    parent: "5108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510820",
    description:
      "Yarn; of fine animal hair, combed, not put up for retail sale",
    parent: "5108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5109",
    description: "Yarn of wool or of fine animal hair, put up for retail sale",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "510910",
    description:
      "Yarn; of wool or of fine animal hair, containing 85% or more by weight of wool or fine animal hair, put up for retail sale",
    parent: "5109",
    level: "6",
  },
  {
    section: "XI",
    hscode: "510990",
    description:
      "Yarn; of wool or of fine animal hair, containing less than 85% by weight of wool or fine animal hair, put up for retail sale",
    parent: "5109",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5110",
    description:
      "Yarn of coarse animal hair or of horsehair (including gimped horsehair yarn), whether or not put up for retail sale",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "511000",
    description:
      "Yarn; of coarse animal hair or of horsehair (including gimped horsehair yarn), whether or not put up for retail sale",
    parent: "5110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5111",
    description: "Woven fabrics of carded wool or of carded fine animal hair",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "511111",
    description:
      "Fabrics, woven; of carded wool or of carded fine animal hair, containing 85% or more by weight of wool or of fine animal hair, of a weight not exceeding 300g/m2",
    parent: "5111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511119",
    description:
      "Fabrics, woven; of carded wool or of carded fine animal hair, containing 85% or more by weight of wool or of fine animal hair, of a weight exceeding 300g/m2",
    parent: "5111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511120",
    description:
      "Fabrics, woven; of carded wool or carded fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made filaments",
    parent: "5111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511130",
    description:
      "Fabrics, woven; of carded wool or carded fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made staple fibres",
    parent: "5111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511190",
    description:
      "Fabrics, woven; of carded wool or carded fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with fibres n.e.c. in heading no. 5111",
    parent: "5111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5112",
    description: "Woven fabrics of combed wool or of combed fine animal hair",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "511211",
    description:
      "Fabrics, woven; of combed wool or combed fine animal hair, containing 85% or more by weight of wool or fine animal hair, of a weight not exceeding 200g/m2",
    parent: "5112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511219",
    description:
      "Fabrics, woven; of combed wool or combed fine animal hair, containing 85% or more by weight of wool or fine animal hair, of a weight exceeding 200g/m2",
    parent: "5112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511220",
    description:
      "Fabrics, woven; of combed wool or combed fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made filaments",
    parent: "5112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511230",
    description:
      "Fabrics, woven; of combed wool or combed fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made staple fibres",
    parent: "5112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "511290",
    description:
      "Fabrics, woven; of combed wool or combed fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with fibres n.e.c. in heading no. 5112",
    parent: "5112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5113",
    description: "Woven fabrics of coarse animal hair or of horsehair",
    parent: "51",
    level: "4",
  },
  {
    section: "XI",
    hscode: "511300",
    description: "Fabrics, woven; of coarse animal hair or of horsehair",
    parent: "5113",
    level: "6",
  },
  {
    section: "XI",
    hscode: "52",
    description: "Cotton",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5201",
    description: "Cotton; not carded or combed",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520100",
    description: "Cotton; not carded or combed",
    parent: "5201",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5202",
    description: "Cotton waste (including yarn waste and garnetted stock)",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520210",
    description: "Cotton; yarn waste (including thread waste)",
    parent: "5202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520291",
    description: "Cotton; garnetted stock waste",
    parent: "5202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520299",
    description:
      "Cotton; waste other than garnetted stock and yarn (including thread) waste",
    parent: "5202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5203",
    description: "Cotton, carded or combed",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520300",
    description: "Cotton; carded or combed",
    parent: "5203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5204",
    description: "Cotton sewing thread, whether or not put up for retail sale",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520411",
    description:
      "Cotton; sewing thread, containing 85% or more by weight of cotton, not put up for retail sale",
    parent: "5204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520419",
    description:
      "Cotton; sewing thread, containing less than 85% by weight of cotton, not put up for retail sale",
    parent: "5204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520420",
    description: "Cotton; sewing thread, put up for retail sale",
    parent: "5204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5205",
    description:
      "Cotton yarn (other than sewing thread), containing 85% or more by weight of cotton, not put up for retail sale",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520511",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, measuring 714.29 decitex or more, (not exceeding 14 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520512",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520513",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520514",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520515",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520521",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, measuring 714.29 decitex or more, (not exceeding 14 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520522",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520523",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520524",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520526",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 125 but not less than 106.38 decitex (over 80 but not over 94 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520527",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 106.38 but not less than 83.33 decitex (over 94 but not over 120 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520528",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, measuring less than 83.33 decitex (exceeding 120 metric number), not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520531",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520532",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520533",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520534",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520535",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, less than 125 decitex (exceeding 80 metric number), per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520541",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520542",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520543",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520544",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520546",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 124 to 106.38 decitex (81 to 94 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520547",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 106.37 to 83.33 decitex (95 to 120 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520548",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, less than 83.33 decitex (exceeding 120 metric number) per single yarn, not for retail sale",
    parent: "5205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5206",
    description:
      "Cotton yarn (other than sewing thread), containing less than 85% by weight of cotton, not put up for retail sale",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520611",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, measuring 714.29 decitex or more (not exceeding 14 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520612",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520613",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520614",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520615",
    description:
      "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520621",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, measuring 714.29 decitex or more, (not exceeding 14 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520622",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520623",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520624",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520625",
    description:
      "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520631",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520632",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520633",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520634",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520635",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, less than 125 decitex (exceeding 80 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520641",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520642",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520643",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520644",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520645",
    description:
      "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, less than 125 decitex (exceeding 80 metric number) per single yarn, not for retail sale",
    parent: "5206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5207",
    description:
      "Cotton yarn (other than sewing thread), put up for retail sale",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520710",
    description:
      "Cotton yarn; (not sewing thread), containing 85% or more by weight of cotton, put up for retail sale",
    parent: "5207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520790",
    description:
      "Cotton yarn; (not sewing thread), containing less than 85% by weight of cotton, put up for retail sale",
    parent: "5207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5208",
    description:
      "Woven fabrics of cotton, containing 85% or more by weight of cotton, weighing not more than 200 g/m2",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520811",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, plain weave, weighing not more than 100g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520812",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520813",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520819",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, of weaves n.e.c. in item no. 5208.1, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520821",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, plain weave, weighing not more than 100g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520822",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520823",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520829",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, of weaves n.e.c. in item no. 5208.2, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520831",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, plain weave, weighing not more than 100g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520832",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520833",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520839",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, of weaves n.e.c. in item no. 5208.3 weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520841",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, plain weave, weighing not more than 100g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520842",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, weighing more than 100g/m2 but not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520843",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520849",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, of weaves n.e.c. in item no. 5208.4, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520851",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, printed, plain weave, weighing not more than 100g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520852",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, printed, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520859",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, printed, of weaves n.e.c. in item no. 5208.5, weighing not more than 200g/m2",
    parent: "5208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5209",
    description:
      "Woven fabrics of cotton, containing 85% or more by weight of cotton, weighing more than 200g/m2",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "520911",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, plain weave, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520912",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520919",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, of weaves n.e.c. in item no. 5209.1, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520921",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, plain weave, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520922",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520929",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, bleached, of weaves n.e.c. in item no. 5209.2, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520931",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, plain weave, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520932",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520939",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, dyed, of weaves n.e.c. in item no. 5209.3, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520941",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, plain weave, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520942",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, weighing more than 200g/m2, denim",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520943",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520949",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, of weaves n.e.c. in item no. 5209.4, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520951",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, printed, plain weave, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520952",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, printed, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "520959",
    description:
      "Fabrics, woven; containing 85% or more by weight of cotton, printed, of weaves n.e.c. in item no. 5209.5, weighing more than 200g/m2",
    parent: "5209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5210",
    description:
      "Woven fabrics of cotton, containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing not more than 200 g/m2",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "521011",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, plain weave, weighing 200g/m2 or less",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521019",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, of weaves n.e.c. in item no. 5210.1, weighing 200g/m2 or less",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521021",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, bleached, plain weave, weighing 200g/m2 or less",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521029",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, bleached, of weaves n.e.c. in item no. 5210.2",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521031",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, dyed, plain weave",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521032",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, dyed, 3-thread or 4-thread twill, including cross twill",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521039",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, dyed, of weaves n.e.c. in item no. 5210.3",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521041",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, of yarns of different colours, plain weave",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521049",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, of yarns of different colours, of weaves n.e.c. in item no. 5210.4",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521051",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, printed, plain weave",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521059",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, printed, of weaves n.e.c. in item no. 5210.5",
    parent: "5210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5211",
    description:
      "Woven fabrics of cotton, containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "521111",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, plain weave, weighing more than 200g/m2",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521112",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, 3- or 4-thread twill, including cross twill, weighing more than 200g/m2",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521119",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, of weaves n.e.c. in item no. 5211.1, weighing more than 200g/m2",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521120",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, bleached",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521131",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, dyed, plain weave",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521132",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, dyed, 3-thread or 4-thread twill, including cross twill",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521139",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, dyed, of weaves n.e.c. in item no. 5211.3",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521141",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, plain weave",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521142",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, denim",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521143",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, 3-thread or 4-thread twill, including cross twill",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521149",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, of weaves n.e.c. in item no. 5211.4",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521151",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, printed, plain weave",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521152",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, printed, 3-thread or 4-thread twill, including cross twill",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521159",
    description:
      "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, printed, of weaves n.e.c. in item no. 5211.5",
    parent: "5211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5212",
    description: "Other woven fabrics of cotton, n.e.c. in chapter 52",
    parent: "52",
    level: "4",
  },
  {
    section: "XI",
    hscode: "521211",
    description:
      "Fabrics, woven; of cotton, unbleached, weighing not more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521212",
    description:
      "Fabrics, woven; of cotton, bleached, weighing not more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521213",
    description:
      "Fabrics, woven; of cotton, dyed, weighing not more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521214",
    description:
      "Fabrics, woven; of cotton, of yarns of different colours, weighing not more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521215",
    description:
      "Fabrics, woven; of cotton, printed, weighing not more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521221",
    description:
      "Fabrics, woven; of cotton, unbleached, weighing more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521222",
    description:
      "Fabrics, woven; of cotton, bleached, weighing more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521223",
    description:
      "Fabrics, woven; of cotton, dyed, weighing more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521224",
    description:
      "Fabrics, woven; of cotton, of yarns of different colours, weighing more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "521225",
    description:
      "Fabrics, woven; of cotton, printed, weighing more than 200g/m2, n.e.c. in chapter 52",
    parent: "5212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "53",
    description:
      "Vegetable textile fibres; paper yarn and woven fabrics of paper yarn",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5301",
    description:
      "Flax, raw or processed but not spun; flax tow and waste (including yarn waste and garnetted stock)",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530110",
    description: "Flax; raw or retted, but not spun",
    parent: "5301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530121",
    description: "Flax; broken or scutched, but not spun",
    parent: "5301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530129",
    description: "Flax; hackled or otherwise processed, but not spun",
    parent: "5301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530130",
    description:
      "Flax; tow and waste, including yarn waste and garnetted stock",
    parent: "5301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5302",
    description:
      "True hemp (cannabis sativa L.), raw or processed but not spun; tow and waste of true hemp (including yarn waste and garnetted stock)",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530210",
    description: "Hemp (cannabis sativa L.); raw or retted, but not spun",
    parent: "5302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530290",
    description:
      "Hemp (cannabis sativa L.); processed (other than retted) (but not spun), true hemp tow and waste (including yarn waste and garnetted stock)",
    parent: "5302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5303",
    description:
      "Jute and other textile bast fibres (not flax, true hemp and ramie), raw or processed but not spun; tow and waste of these fibres, including yarn waste and garnetted stock",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530310",
    description:
      "Jute and other textile bast fibres; raw or retted, but not spun, (excluding flax, hemp (cannabis sativa L.), and ramie)",
    parent: "5303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530390",
    description:
      "Jute and other textile bast fibres; processed but not spun, tow and waste of these fibres, including yarn waste and garnetted stock (excluding flax, hemp (cannabis sativa L.), and ramie)",
    parent: "5303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5305",
    description:
      "Coconut, abaca (Manila hemp or Musa textilis Nee), ramie and other vegetable textile fibres n.e.c., raw or processed but not spun; tow, noils and waste of these fibres (including yarn waste and garnetted stock)",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530500",
    description:
      "Coconut, abaca (Manila hemp or Musa textilis Nee), ramie and other vegetable textile fibres n.e.c., raw or processed but not spun; tow, noils and waste of these fibres (including yarn waste and garnetted stock)",
    parent: "5305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5306",
    description: "Flax yarn",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530610",
    description: "Yarn; of flax, single",
    parent: "5306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530620",
    description: "Yarn; of flax, multiple (folded) or cabled",
    parent: "5306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5307",
    description:
      "Yarn of jute or of other textile bast fibres of heading no. 5305",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530710",
    description: "Yarn; of jute or of other textile bast fibres, single",
    parent: "5307",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530720",
    description:
      "Yarn; of jute or of other textile bast fibres, multiple (folded) or cabled",
    parent: "5307",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5308",
    description: "Yarn of other vegetable textile fibres; paper yarn",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530810",
    description: "Yarn; of coir",
    parent: "5308",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530820",
    description: "Yarn; of hemp (cannabis sativa L.)",
    parent: "5308",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530890",
    description:
      "Yarn; of vegetable textile fibres n.e.c. in heading no. 5306, 5307 and 5308",
    parent: "5308",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5309",
    description: "Woven fabrics of flax",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "530911",
    description:
      "Fabrics, woven; of flax, containing 85% or more flax, unbleached or bleached",
    parent: "5309",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530919",
    description:
      "Fabrics, woven; of flax, containing 85% or more flax, other than bleached or unbleached",
    parent: "5309",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530921",
    description:
      "Fabrics, woven; of flax, containing less than 85% flax, unbleached or bleached",
    parent: "5309",
    level: "6",
  },
  {
    section: "XI",
    hscode: "530929",
    description:
      "Fabrics, woven; of flax, containing less than 85% flax, other than unbleached or bleached",
    parent: "5309",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5310",
    description:
      "Woven fabrics of jute, other textile bast fibres of heading no. 5303",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "531010",
    description:
      "Fabrics, woven; of jute or of other textile bast fibres of heading no. 5303, unbleached",
    parent: "5310",
    level: "6",
  },
  {
    section: "XI",
    hscode: "531090",
    description:
      "Fabrics, woven; of jute or of other textile bast fibres of heading no. 5303, other than unbleached",
    parent: "5310",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5311",
    description:
      "Woven fabrics of other vegetable textile fibres; woven fabrics of paper yarn",
    parent: "53",
    level: "4",
  },
  {
    section: "XI",
    hscode: "531100",
    description:
      "Fabrics, woven; of vegetable textile fibres n.e.c. in heading no. 5309 and 5310, woven fabrics of paper yarn",
    parent: "5311",
    level: "6",
  },
  {
    section: "XI",
    hscode: "54",
    description:
      "Man-made filaments; strip and the like of man-made textile materials",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5401",
    description:
      "Sewing thread of man-made filaments, whether or not put up for retail sale",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540110",
    description:
      "Sewing thread; of synthetic filaments, whether or not put up for retail sale",
    parent: "5401",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540120",
    description:
      "Sewing thread; of artificial filaments, whether or not put up for retail sale",
    parent: "5401",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5402",
    description:
      "Synthetic filament yarn (other than sewing thread), not put up for retail sale, including synthetic monofilament of less than 67 decitex",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540211",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of high tenacity yarn of nylon or other polyamides, textured or not; of aramids, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540219",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of high tenacity nylon or other polyamides, textured or not; other than aramids, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540220",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of high tenacity yarn of polyesters, whether or not textured, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540231",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of nylon or other polyamides, measuring per single yarn not more than 50 decitex, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540232",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of nylon or other polyamides, measuring per single yarn more than 50 decitex, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540233",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of polyesters, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540234",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of polypropylene, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540239",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, other than of nylon or other polymides, polyesters, or polypropylene, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540244",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, elastomeric, single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540245",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of nylon or other polymides (not high tenacity or textured), single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540246",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polyesters (not high tenacity or textured), partially oriented, single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540247",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), polyesters (not high tenacity or textured), not partially oriented, single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540248",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polypropylene (not high tenacity or textured), single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540249",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, single, untwisted or twisted 50 turns or less per metre, n.e.c. in heading no. 5402, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540251",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of nylon or other polymides (not high tenacity or textured), single, twisted more than 50 turns per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540252",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polyesters (not high tenacity or textured), single, twisted more than 50 turns per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540253",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polypropylene (not high tenacity or textured), single, twisted more than 50 turns per metre, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540259",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, single, twisted more than 50 turns per metre, n.e.c. in heading no. 5402, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540261",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of nylon or other polymides (not high tenacity or textured), multiple (folded) or cabled, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540262",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polyesters (not high tenacity or textured), multiple (folded) or cabled, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540263",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polypropylene, other than high tenacity or textured yarn, multiple (folded) or cabled, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540269",
    description:
      "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, multiple (folded) or cabled, n.e.c. in heading no. 5402, not for retail sale, not sewing thread",
    parent: "5402",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5403",
    description:
      "Artificial filament yarn (other than sewing thread), not put up for retail sale, including artificial monofilament of less than 67 decitex",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540310",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), of high tenacity viscose rayon, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540331",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), of viscose rayon (not high tenacity), single, untwisted or twisted 120 turns per metre or less, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540332",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), of viscose rayon (not high tenacity), single, twisted more than 120 turns per metre, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540333",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), of cellulose acetate, single, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540339",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), single, n.e.c. in heading no. 5403, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540341",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), of viscose rayon (not high tenacity), multiple (folded) or cabled, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540342",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), of cellulose acetate, multiple (folded) or cabled, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540349",
    description:
      "Yarn, artificial; filament, monofilament (less than 67 decitex), multiple (folded) or cabled, n.e.c. in heading no. 5403, not for retail sale, not sewing thread",
    parent: "5403",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5404",
    description:
      "Synthetic monofilament of 67 decitex or more, of which no cross-sectional dimension exceeds 1mm; strip and the like (e.g. artificial straw) of synthetic textile materials of an apparent width not exceeding 5mm",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540411",
    description:
      "Elastomeric monofilament; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
    parent: "5404",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540412",
    description:
      "Monofilament of polypropylene; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
    parent: "5404",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540419",
    description:
      "Monofilament n.e.c. in heading no 5404; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
    parent: "5404",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540490",
    description:
      "Filament, synthetic; strip and the like (e.g.. artificial straw), of synthetic textile materials of an apparent width not exceeding 5mm",
    parent: "5404",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5405",
    description:
      "Artificial monofilament of 67 decitex or more, no cross-sectional dimension exceeds 1mm; strip and the like (e.g. artificial straw), of artificial textile materials of a width not exceeding 5mm",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540500",
    description:
      "Monofilament, synthetic; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm, strip and the like (e.g. artificial straw), of synthetic textile materials with width not over 5mm",
    parent: "5405",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5406",
    description:
      "Man-made filament yarn (other than sewing thread), put up for retail sale",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540600",
    description:
      "Man-made filament yarn (other than sewing thread), put up for retail sale",
    parent: "5406",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5407",
    description:
      "Woven fabrics of synthetic filament yarn, including woven fabrics obtained from materials of heading no. 5404",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540710",
    description:
      "Fabrics, woven; from high tenacity yarn, of nylon, other polyamides or of polyesters",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540720",
    description:
      "Fabrics, woven; from strip or the like, of synthetic textile materials",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540730",
    description:
      "Fabrics, woven; from synthetic filament yarn, adhesive or thermal bonded",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540741",
    description:
      "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, unbleached or bleached",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540742",
    description:
      "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, dyed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540743",
    description:
      "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, of yarns of different colours",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540744",
    description:
      "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, printed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540751",
    description:
      "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, unbleached or bleached",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540752",
    description:
      "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, dyed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540753",
    description:
      "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, of yarns of different colours",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540754",
    description:
      "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, printed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540761",
    description:
      "Fabrics, woven; containing 85% or more by weight of non-textured polyester filaments",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540769",
    description:
      "Fabrics, woven; containing less than 85% by weight of non-textured polyester filaments",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540771",
    description:
      "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), unbleached or bleached",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540772",
    description:
      "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), dyed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540773",
    description:
      "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), of yarns of different colours",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540774",
    description:
      "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), printed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540781",
    description:
      "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, mixed mainly or solely with cotton, bleached or unbleached",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540782",
    description:
      "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, mixed mainly or solely with cotton, dyed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540783",
    description:
      "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, mixed mainly or solely with cotton, of yarns of different colours",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540784",
    description:
      "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, printed",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540791",
    description:
      "Fabrics, woven; of synthetic filament yarn, bleached or unbleached, n.e.c. in heading no. 5407",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540792",
    description:
      "Fabrics, woven; of synthetic filament yarn, dyed, n.e.c. in heading 5407",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540793",
    description:
      "Fabrics, woven; of synthetic filament yarn, of yarns of different colours, n.e.c. in heading no. 5407",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540794",
    description:
      "Fabrics, woven; of synthetic filament yarn, printed, n.e.c. in heading no. 5407",
    parent: "5407",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5408",
    description:
      "Woven fabrics of artificial filament yarn including woven fabrics obtained from materials of heading no. 5404",
    parent: "54",
    level: "4",
  },
  {
    section: "XI",
    hscode: "540810",
    description:
      "Fabrics, woven; of viscose rayon, high tenacity, artificial filament yarn",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540821",
    description:
      "Fabrics, woven; of artificial filament yarn, containing 85% or more by weight of artificial filament, strip or the like, bleached or unbleached",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540822",
    description:
      "Fabrics, woven; of artificial filament yarn, containing 85% or more by weight of artificial filament, strip or the like, dyed",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540823",
    description:
      "Fabrics, woven; containing 85% or more by weight of artificial filament, strip or the like, of yarns of different colours",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540824",
    description:
      "Fabrics, woven; of artificial filament yarn, containing 85% or more by weight of artificial filament, strip or the like, printed",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540831",
    description:
      "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, unbleached or bleached",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540832",
    description:
      "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, dyed",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540833",
    description:
      "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, of yarns of different colours",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "540834",
    description:
      "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, printed",
    parent: "5408",
    level: "6",
  },
  {
    section: "XI",
    hscode: "55",
    description: "Man-made staple fibres",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5501",
    description: "Synthetic filament tow",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550111",
    description:
      "Fibres; synthetic filament tow, of nylon or other polyamides, of aramids",
    parent: "5501",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550119",
    description:
      "Fibres; synthetic filament tow, of nylon or other polyamides, of other than aramids",
    parent: "5501",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550120",
    description: "Fibres; synthetic filament tow, of polyesters",
    parent: "5501",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550130",
    description: "Fibres; synthetic filament tow, acrylic or modacrylic",
    parent: "5501",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550140",
    description: "Fibres; synthetic filament tow, of polypropylene",
    parent: "5501",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550190",
    description:
      "Fibres; synthetic filament tow, of synthetic materials n.e.c. in heading no. 5501",
    parent: "5501",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5502",
    description: "Artificial filament tow",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550210",
    description: "Fibres; artificial filament tow of cellulose acetate",
    parent: "5502",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550290",
    description:
      "Fibres; artificial filament tow, other than cellulose acetate",
    parent: "5502",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5503",
    description:
      "Synthetic staple fibres, not carded, combed or otherwise processed for spinning",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550311",
    description:
      "Fibres; synthetic staple fibres, of aramids, not carded, combed or otherwise processed for spinning",
    parent: "5503",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550319",
    description:
      "Fibres; synthetic staple fibres, of nylon or other polyamides other than aramids, not carded, combed or otherwise processed for spinning",
    parent: "5503",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550320",
    description:
      "Fibres; synthetic staple fibres, of polyesters, not carded, combed or otherwise processed for spinning",
    parent: "5503",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550330",
    description:
      "Fibres; synthetic staple fibres, acrylic or modacrylic, not carded, combed or otherwise processed for spinning",
    parent: "5503",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550340",
    description:
      "Fibres; synthetic staple fibres, of polypropylene, not carded, combed or otherwise processed for spinning",
    parent: "5503",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550390",
    description:
      "Fibres; synthetic staple fibres, of synthetic materials n.e.c. in heading no. 5503, not carded, combed or otherwise processed for spinning",
    parent: "5503",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5504",
    description:
      "Artificial staple fibres, not carded, combed or otherwise processed for spinning",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550410",
    description:
      "Fibres; artificial staple fibres, of viscose, not carded, combed or otherwise processed for spinning",
    parent: "5504",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550490",
    description:
      "Fibres; artificial staple fibres, other than of viscose, not carded, combed or otherwise processed for spinning",
    parent: "5504",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5505",
    description:
      "Waste (including noils, yarn waste and garnetted stock), of man-made fibres",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550510",
    description:
      "Fibres; waste (including noils, yarn waste and garnetted stock), of synthetic fibres",
    parent: "5505",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550520",
    description:
      "Fibres; waste (including noils, yarn waste and garnetted stock), of artificial fibres",
    parent: "5505",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5506",
    description:
      "Synthetic staple fibres, carded, combed or otherwise processed for spinning",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550610",
    description:
      "Fibres; synthetic staple fibres, of nylon or other polyamides, carded, combed or otherwise processed for spinning",
    parent: "5506",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550620",
    description:
      "Fibres; synthetic staple fibres, of polyesters, carded, combed or otherwise processed for spinning",
    parent: "5506",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550630",
    description:
      "Fibres; synthetic staple fibres, acrylic or modacrylic, carded, combed or otherwise processed for spinning",
    parent: "5506",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550640",
    description:
      "Fibres; synthetic staple fibres, of polypropylene, carded, combed or otherwise processed for spinning",
    parent: "5506",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550690",
    description:
      "Fibres; synthetic staple fibres, n.e.c. in heading no. 5506, carded, combed or otherwise processed for spinning",
    parent: "5506",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5507",
    description:
      "Artificial staple fibres, carded, combed or otherwise processed for spinning",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550700",
    description:
      "Fibres; artificial staple fibres, carded, combed or otherwise processed for spinning",
    parent: "5507",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5508",
    description:
      "Sewing thread of man-made staple fibres, whether or not put up for retail sale",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550810",
    description:
      "Sewing thread; of synthetic staple fibres, whether or not put up for retail sale",
    parent: "5508",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550820",
    description:
      "Sewing thread; of artificial staple fibres, whether or not put up for retail sale",
    parent: "5508",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5509",
    description:
      "Yarn (other than sewing thread) of synthetic staple fibres, not put up for retail sale",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "550911",
    description:
      "Yarn; (not sewing thread), single, of synthetic staple fibres, containing 85% or more by weight of nylon or other polyamides, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550912",
    description:
      "Yarn; (not sewing thread), multiple (folded) or cabled yarn, of synthetic staple fibres, containing 85% or more by weight of nylon or other polyamides, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550921",
    description:
      "Yarn; (not sewing thread), single, of synthetic staple fibres, containing 85% or more by weight of polyester, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550922",
    description:
      "Yarn; (not sewing thread), multiple (folded) or cabled yarn, of synthetic staple fibres, containing 85% or more by weight of polyester, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550931",
    description:
      "Yarn; (not sewing thread), single, of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550932",
    description:
      "Yarn; (not sewing thread), multiple (folded) or cabled, of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550941",
    description:
      "Yarn; (not sewing thread), single, containing 85% or more by weight of synthetic staple fibres, n.e.c. in heading no. 5509, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550942",
    description:
      "Yarn; (not sewing thread), multiple (folded) or cabled yarn, containing 85% or more by weight of synthetic staple fibres, n.e.c. in heading no. 5509, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550951",
    description:
      "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with artificial staple fibres, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550952",
    description:
      "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with wool or fine animal hair, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550953",
    description:
      "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with cotton, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550959",
    description:
      "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with fibres n.e.c. in item no. 5509.5, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550961",
    description:
      "Yarn; (not sewing thread), of acrylic or modacrylic staple fibres, mixed mainly or solely with wool or fine animal hair, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550962",
    description:
      "Yarn; (not sewing thread), of acrylic or modacrylic staple fibres, mixed mainly or solely with cotton, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550969",
    description:
      "Yarn; (not sewing thread), of acrylic or modacrylic staple fibres, mixed mainly or solely with fibres n.e.c. in item no. 5509.6, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550991",
    description:
      "Yarn; (not sewing thread), of synthetic staple fibres, mixed mainly or solely with wool or fine animal hair, n.e.c. in heading no. 5509, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550992",
    description:
      "Yarn; (not sewing thread), of synthetic staple fibres, mixed mainly or solely with cotton, n.e.c. in heading no. 5509, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "550999",
    description:
      "Yarn; (not sewing thread), of synthetic staple fibres, mixed mainly or solely with fibres (other than wool, fine animal hair or cotton), n.e.c. in heading no. 5509, not put up for retail sale",
    parent: "5509",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5510",
    description:
      "Yarn (other than sewing thread) of artificial staple fibres, not put up for retail sale",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551011",
    description:
      "Yarn; (not sewing thread), single, of artificial staple fibres, containing 85% or more by weight of artificial staple fibres, not put up for retail sale",
    parent: "5510",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551012",
    description:
      "Yarn; (not sewing thread), multiple (folded) or cabled yarn, of artificial staple fibres, containing 85% or more by weight of artificial staple fibres, not put up for retail sale",
    parent: "5510",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551020",
    description:
      "Yarn; (not sewing thread), of artificial staple fibres, mixed mainly or solely with wool or fine animal hair, not put up for retail sale",
    parent: "5510",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551030",
    description:
      "Yarn; (not sewing thread), of artificial staple fibres, mixed mainly or solely with cotton, not put up for retail sale",
    parent: "5510",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551090",
    description:
      "Yarn; (not sewing thread), of artificial staple fibres, mixed mainly or solely with fibres (other than wool, fine animal hair or cotton), not put up for retail sale",
    parent: "5510",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5511",
    description:
      "Yarn (not sewing thread), of man-made staple fibres, put up for retail sale",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551110",
    description:
      "Yarn; (not sewing thread), of synthetic staple fibres, containing 85% or more by weight of synthetic staple fibres, put up for retail sale",
    parent: "5511",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551120",
    description:
      "Yarn; (not sewing thread), of synthetic staple fibres, containing less than 85% by weight of synthetic staple fibres, put up for retail sale",
    parent: "5511",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551130",
    description:
      "Yarn; (not sewing thread), of artificial staple fibres, put up for retail sale",
    parent: "5511",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5512",
    description:
      "Woven fabrics of synthetic staple fibres, containing 85% or more by weight of synthetic staple fibres",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551211",
    description:
      "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of polyester staple fibres, unbleached or bleached",
    parent: "5512",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551219",
    description:
      "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of polyester staple fibres, other than unbleached or bleached",
    parent: "5512",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551221",
    description:
      "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic staple fibres, unbleached or bleached",
    parent: "5512",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551229",
    description:
      "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic staple fibres, other than unbleached or bleached",
    parent: "5512",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551291",
    description:
      "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of such fibres n.e.c. in heading no. 5512, unbleached or bleached",
    parent: "5512",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551299",
    description:
      "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of such fibres n.e.c. in heading no. 5512, other than unbleached or bleached",
    parent: "5512",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5513",
    description:
      "Woven fabrics of synthetic staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, of a weight not exceeding 170g/m2",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551311",
    description:
      "Fabrics, woven; plain weave, of polyester staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, of a weight not exceeding 170g/m2, unbleached or bleached",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551312",
    description:
      "Fabrics, woven; 3-thread or 4-thread twill, of polyester staple fibres, containing less than 85% by weight of such, mixed mainly or solely with cotton, not exceeding 170g/m2, unbleached or bleached",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551313",
    description:
      "Fabrics, woven; of polyester staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, not exceeding 170g/m2, unbleached or bleached",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551319",
    description:
      "Fabrics, woven; containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, not exceeding 170g/m2, unbleached or bleached",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551321",
    description:
      "Fabrics, woven; plain weave, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551323",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551329",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551331",
    description:
      "Fabrics, woven; plain weave, of yarns of different colours, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551339",
    description:
      "Fabrics, woven; of yarns of different colours, containing less than 85% of synthetic staple fibres (other than polyester, plain weave), mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551341",
    description:
      "Fabrics, woven; plain weave, printed, of polyester staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551349",
    description:
      "Fabrics, woven; printed, containing less than 85% by weight of synthetic staple fibres (other than polyester, plain weave), mixed mainly or solely with cotton, not exceeding 170g/m2",
    parent: "5513",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5514",
    description:
      "Woven fabrics of synthetic staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, of a weight exceeding 170g/m2",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551411",
    description:
      "Fabrics, woven; plain weave, unbleached or bleached, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551412",
    description:
      "Fabrics, woven; 3- or 4-thread twill, including cross twill, unbleached or bleached, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, over 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551419",
    description:
      "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of synthetic staple fibres n.e.c. in item no. 55.14.1, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551421",
    description:
      "Fabrics, woven; plain weave, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551422",
    description:
      "Fabrics, woven; 3- or 4-thread twill, including cross twill, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551423",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2, n.e.c. in heading no. 5514",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551429",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551430",
    description:
      "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of synthetic staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551441",
    description:
      "Fabrics, woven; plain weave, printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551442",
    description:
      "Fabrics, woven; 3- or 4-thread twill, including cross twill, printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551443",
    description:
      "Fabrics, woven; printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, weight exceeding 170g/m2, n.e.c. in heading no. 5514",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551449",
    description:
      "Fabrics, woven; printed, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, exceeding 170g/m2",
    parent: "5514",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5515",
    description:
      "Woven fabrics of synthetic staple fibres, n.e.c. in chapter 55",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551511",
    description:
      "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with viscose rayon staple fibres",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551512",
    description:
      "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with man-made filaments",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551513",
    description:
      "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with wool or fine animal hair",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551519",
    description:
      "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with fibres n.e.c. in item no. 5515.1",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551521",
    description:
      "Fabrics, woven; of acrylic or modacrylic staple fibres n.e.c. in chapter 55, mixed mainly or solely with man-made filaments",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551522",
    description:
      "Fabrics, woven; of acrylic or modacrylic staple fibres n.e.c. in chapter 55, mixed mainly or solely with wool or fine animal hair",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551529",
    description:
      "Fabrics, woven; of acrylic or modacrylic staple fibres n.e.c. in chapter 55, mixed mainly or solely with fibres n.e.c. in item no. 5515.2",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551591",
    description:
      "Fabrics, woven; of synthetic staple fibres n.e.c. in chapter 55, mixed mainly or solely with man-made filaments",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551599",
    description:
      "Fabrics, woven; of synthetic staple fibres n.e.c. in chapter 55, mixed mainly or solely with fibres n.e.c. in heading no. 5515",
    parent: "5515",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5516",
    description: "Woven fabrics of artificial staple fibres",
    parent: "55",
    level: "4",
  },
  {
    section: "XI",
    hscode: "551611",
    description:
      "Fabrics, woven; unbleached or bleached, containing 85% or more by weight of artificial staple fibres",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551612",
    description:
      "Fabrics, woven; dyed, containing 85% or more by weight of artificial staple fibres",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551613",
    description:
      "Fabrics, woven; of yarns of different colours, containing 85% or more by weight of artificial staple fibres",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551614",
    description:
      "Fabrics, woven; printed, containing 85% or more by weight of artificial staple fibres",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551621",
    description:
      "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with manmade filaments",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551622",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with man-made filaments",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551623",
    description:
      "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with man-made filaments",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551624",
    description:
      "Fabrics, woven; printed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with man-made filaments",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551631",
    description:
      "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551632",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551633",
    description:
      "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551634",
    description:
      "Fabrics, woven; printed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551641",
    description:
      "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551642",
    description:
      "Fabrics, woven; dyed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551643",
    description:
      "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551644",
    description:
      "Fabrics, woven; printed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551691",
    description:
      "Fabrics, woven; unbleached or bleached, of artificial staple fibres, n.e.c. in heading no. 5516",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551692",
    description:
      "Fabrics, woven; dyed, of artificial staple fibres, n.e.c. in heading no. 5516",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551693",
    description:
      "Fabrics, woven; of yarns of different colours, of artificial staple fibres, n.e.c. in heading no. 5516",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "551694",
    description:
      "Fabrics, woven; printed, of artificial staple fibres, n.e.c. in heading no. 5516",
    parent: "5516",
    level: "6",
  },
  {
    section: "XI",
    hscode: "56",
    description:
      "Wadding, felt and nonwovens, special yarns; twine, cordage, ropes and cables and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5601",
    description:
      "Wadding of textile materials and articles thereof; textile fibres, not exceeding 5 mm in length (flock), textile dust and mill neps",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560121",
    description: "Wadding; other articles thereof, of cotton",
    parent: "5601",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560122",
    description: "Wadding; other articles thereof, of man-made fibres",
    parent: "5601",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560129",
    description:
      "Wadding; other articles thereof, other than of cotton or man-made fibres",
    parent: "5601",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560130",
    description: "Wadding; textile flock and dust and mill neps",
    parent: "5601",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5602",
    description:
      "Felt; whether or not impregnated, coated, covered or laminated",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560210",
    description:
      "Felt; needleloom felt and stitch-bonded fibre fabrics, whether or not impregnated, coated, covered or laminated",
    parent: "5602",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560221",
    description:
      "Felt; of wool or fine animal hair (excluding needleloom felt or stitch-bonded fibre fabrics), not impregnated, coated, covered nor laminated",
    parent: "5602",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560229",
    description:
      "Felt; of textile materials other than wool or fine animal hair (excluding needleloom felt and stitch-bonded fibre fabrics), not impregnated, coated, covered or laminated",
    parent: "5602",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560290",
    description:
      "Felt; impregnated, coated, covered or laminated (excluding needleloom felt and stitch-bonded fibre fabrics)",
    parent: "5602",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5603",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560311",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing not more than 25g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560312",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing more than 25g/m2 but not more than 70g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560313",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing more than 70g/m2 but not more than 150g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560314",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing more than 150g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560391",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing not more than 25g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560392",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing more than 25g/m2 but not more than 70g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560393",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing more than 70g/m2 but not more than 150g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560394",
    description:
      "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing more than 150g/m2)",
    parent: "5603",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5604",
    description:
      "Rubber thread and cord, textile covered; textile yarn and strip and the like of heading no. 5404, 5405; impregnated, coated, covered or sheathed with rubber or plastics",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560410",
    description: "Rubber thread and cord; textile covered",
    parent: "5604",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560490",
    description:
      "Yarn; textile yarn, strip, and the like of heading no. 5404 or 5405, impregnated, coated, covered, or sheathed with rubber or plastics, n.e.c. in heading no. 5604",
    parent: "5604",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5605",
    description:
      "Yarn; metallised, whether or not gimped, of textile yarn, or strip or the like of heading no. 5404 or 5405, combined with metal in the form of thread, strip or powder or covered with metal",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560500",
    description:
      "Yarn; metallised, whether or not gimped, of textile yarn, or strip or the like of heading no. 5404 or 5405, combined with metal in the form of thread, strip or powder or covered with metal",
    parent: "5605",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5606",
    description:
      "Yarn and strip and the like of heading no. 5404 or 5405, gimped (other than those of heading no. 5606 and gimped horsehair yarn); chenille yarn (including flock chenille yarn); loop wale-yarn",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560600",
    description:
      "Yarn and strip and the like of heading no. 5404 or 5405; gimped, (other than those of heading no. 5406 and gimped horsehair yarn); chenille yarn (including flock chenille yarn); loop wale-yarn",
    parent: "5606",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5607",
    description:
      "Twine, cordage, ropes and cables, whether or not plaited or braided; whether or not impregnated, coated, covered or sheathed with rubber or plastics",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560721",
    description:
      "Twine; binder or baler twine, of sisal or other textile fibres of the genus agave",
    parent: "5607",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560729",
    description:
      "Twine, cordage, ropes, cables; of sisal or other textile fibres of the genus agave (excluding binder or baler twine), whether or not plaited, braided or rubber or plastic impregnated, coated, covered or sheathed",
    parent: "5607",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560741",
    description:
      "Twine; binder or baler twine, of polyethylene or polypropylene",
    parent: "5607",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560749",
    description:
      "Twine, cordage, ropes, cables; of polyethylene or polypropylene (excluding binder or baler twine), whether or not plaited, braided or rubber or plastic impregnated, coated, covered or sheathed",
    parent: "5607",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560750",
    description:
      "Twine, cordage, ropes, cables; of synthetic fibres other than polyethylene or polypropylene, whether or not plaited, braided or impregnated, coated, covered or sheathed with rubber or plastics",
    parent: "5607",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560790",
    description:
      "Twine, cordage, ropes, cables; of materials n.e.c. in heading no. 5607, whether or not plaited, braided or impregnated, coated, covered, or sheathed with rubber or plastics",
    parent: "5607",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5608",
    description:
      "Twine, cordage or rope; knotted netting, made up fishing nets and other made up nets, of textile materials",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560811",
    description:
      "Twine, cordage or rope; fishing nets, made up, of man made textile materials",
    parent: "5608",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560819",
    description:
      "Twine, cordage or rope; knotted netting, for other than fishing, of man-made textile materials",
    parent: "5608",
    level: "6",
  },
  {
    section: "XI",
    hscode: "560890",
    description:
      "Twine, cordage or rope; knotted netting, of other than man-made textiles",
    parent: "5608",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5609",
    description:
      "Articles of yarn, strip or the like of heading no. 5404 or 5405; twine, cordage, rope or cables n.e.c. or included",
    parent: "56",
    level: "4",
  },
  {
    section: "XI",
    hscode: "560900",
    description:
      "Yarn; articles of yarn, strip or the like of heading no. 5404 and 5405, twine, cordage, rope or cables n.e.c. or included",
    parent: "5609",
    level: "6",
  },
  {
    section: "XI",
    hscode: "57",
    description: "Carpets and other textile floor coverings",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5701",
    description:
      "Carpets and other textile floor coverings; knotted, whether or not made up",
    parent: "57",
    level: "4",
  },
  {
    section: "XI",
    hscode: "570110",
    description:
      "Carpets and other textile floor coverings; knotted, of wool or fine animal hair, whether or not made up",
    parent: "5701",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570190",
    description:
      "Carpets and other textile floor coverings; knotted, of textile materials (other than wool or fine animal hair), whether or not made up",
    parent: "5701",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5702",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), whether or not made up, including kelem, schumacks, karamanie and similar hand-woven rugs",
    parent: "57",
    level: "4",
  },
  {
    section: "XI",
    hscode: "570210",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), whether or not made up, including kelem, schumacks, karamanie and similar hand-woven rugs",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570220",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), whether or not made up, of coconut fibres (coir)",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570231",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570232",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570239",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made, wool or fine animal hair), of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570241",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, of pile construction, made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570242",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, of pile construction, made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570249",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made, wool or fine animal hair), of pile construction, made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570250",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), not of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570291",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, (not of pile construction), made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570292",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, (not of pile construction), made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570299",
    description:
      "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made or wool or fine animal hair, not of pile construction), made up, n.e.c. in item no. 5702.10 or 5702.20",
    parent: "5702",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5703",
    description:
      "Carpets and other textile floor coverings (including turf); tufted, whether or not made up",
    parent: "57",
    level: "4",
  },
  {
    section: "XI",
    hscode: "570310",
    description:
      "Carpets and other textile floor coverings (including turf); tufted, of wool or fine animal hair, whether or not made up",
    parent: "5703",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570321",
    description:
      "Carpets and other textile floor coverings; tufted, of nylon or other polyamides, whether or not made up",
    parent: "5703",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570329",
    description:
      "Carpets; tufted, of nylon or other polyamides, whether or not made up",
    parent: "5703",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570331",
    description:
      "Carpets and other textile floor coverings; tufted, of other man-made textile materials (other than polyamides), whether or not made up",
    parent: "5703",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570339",
    description:
      "Carpets; tufted, of man-made textile materials (other than polyamides), whether of not made up",
    parent: "5703",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570390",
    description:
      "Carpets and other textile floor coverings; tufted, of textile materials (other than man-made, wool or fine animal hair), whether or not made up",
    parent: "5703",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5704",
    description:
      "Carpets and other textile floor coverings; of felt, (not tufted or flocked), whether or not made up",
    parent: "57",
    level: "4",
  },
  {
    section: "XI",
    hscode: "570410",
    description:
      "Textile floor coverings; felt tiles, (not tufted or flocked), whether or not made up, having a maximum surface area of 0.3m2",
    parent: "5704",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570420",
    description:
      "Carpets and other textile floor coverings; of felt, (not tufted or flocked), whether or not made up, having a maximum surface area exceeding 0.3 m2 but not exceeding 1 m2",
    parent: "5704",
    level: "6",
  },
  {
    section: "XI",
    hscode: "570490",
    description:
      "Carpets and other textile floor coverings; of felt, (not tufted or flocked), in the piece, whether or not made up, having a maximum surface area exceeding 1 m2",
    parent: "5704",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5705",
    description:
      "Carpets and other textile floor coverings; n.e.c. in chapter 57, whether or not made up",
    parent: "57",
    level: "4",
  },
  {
    section: "XI",
    hscode: "570500",
    description:
      "Carpets and other textile floor coverings; n.e.c. in chapter 57, whether or not made up",
    parent: "5705",
    level: "6",
  },
  {
    section: "XI",
    hscode: "58",
    description:
      "Fabrics; special woven fabrics, tufted textile fabrics, lace, tapestries, trimmings, embroidery",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5801",
    description:
      "Fabrics; woven pile and chenille fabrics, other than fabrics of heading no. 5802 or 5806",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580110",
    description:
      "Fabrics; woven pile, of wool or fine animal hair, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580121",
    description:
      "Fabrics; woven pile, of cotton, uncut weft pile fabrics, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580122",
    description:
      "Fabrics; woven pile, of cotton, cut corduroy, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580123",
    description:
      "Fabrics; woven pile, of cotton, weft pile fabrics other than uncut and corduroy, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580126",
    description:
      "Fabrics; chenille, of cotton, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580127",
    description:
      "Fabrics; woven pile, of cotton, warp pile fabrics, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580131",
    description:
      "Fabrics; woven pile, of man-made fibres, uncut weft pile fabrics, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580132",
    description:
      "Fabrics; woven pile, of man-made fibres, cut corduroy, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580133",
    description:
      "Fabrics; woven pile, of man-made fibres, other weft pile fabrics, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580136",
    description:
      "Fabrics; chenille, of man-made fibres, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580137",
    description:
      "Fabrics; woven pile, of man-made fibres, warp pile fabrics, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580190",
    description:
      "Fabrics; woven pile and chenille, of textile materials n.e.c. in heading no. 5801, other than fabrics of heading no. 5802 or 5806",
    parent: "5801",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5802",
    description:
      "Fabrics; terry towelling and similar woven terry fabrics other than narrow fabrics of heading no. 5806; tufted textile fabrics, excluding products of heading no. 5703",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580210",
    description:
      "Fabrics; terry towelling and similar woven terry fabrics, of cotton, whether bleached or unbleached, excluding narrow fabrics of heading no. 5806",
    parent: "5802",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580220",
    description:
      "Fabrics; terry towelling and similar woven terry fabrics, of textile materials, excluding cotton, excluding narrow fabrics of heading no. 5806",
    parent: "5802",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580230",
    description:
      "Fabrics; tufted textile fabrics, excluding products of heading no. 5703",
    parent: "5802",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5803",
    description: "Gauze; other than narrow fabrics of heading no. 5806",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580300",
    description: "Gauze; other than narrow fabrics of heading no. 5806",
    parent: "5803",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5804",
    description:
      "Tulles and other net fabrics; not including woven, knitted or crocheted fabrics; lace in the piece, in strips or in motifs, (other than fabrics of headings 60.02 to 60.06)",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580410",
    description:
      "Tulles and other net fabrics; excluding woven, knitted or crocheted fabrics, (other than fabrics of headings 60.02 to 60.06)",
    parent: "5804",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580421",
    description:
      "Lace; mechanically made, of man-made fibres in the piece, in strips or in motifs, (other than fabrics of headings 60.02 to 60.06)",
    parent: "5804",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580429",
    description:
      "Lace; mechanically made, of textile materials, (other than man-made fibres), in the piece, in strips or motifs, (other than fabrics of headings 60.02 to 60.06)",
    parent: "5804",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580430",
    description:
      "Lace; hand-made, in the piece, in strips or motifs, (other than fabrics of headings 60.02 to 60.06)",
    parent: "5804",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5805",
    description:
      "Tapestries; hand-woven, (Gobelins, Flanders, Aubusson, Beauvais and the like) and needle-worked tapestries (e.g. petit point, cross-stitch) whether or not made up",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580500",
    description:
      "Tapestries; hand-woven, (Gobelins, Flanders, Aubusson, Beauvais and the like) and needle-worked tapestries (e.g. petit point, cross-stitch) whether or not made up",
    parent: "5805",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5806",
    description:
      "Fabrics; narrow woven, other than goods of heading 5807; narrow fabrics consisting of warp without weft assembled by means of an adhesive (bolducs)",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580610",
    description:
      "Fabrics; woven pile (including terry towelling and similar terry fabrics) and chenille fabrics (excluding goods of heading 5807)",
    parent: "5806",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580620",
    description:
      "Fabrics; narrow (excluding pile fabrics), containing by weight 5% or more of elastomeric yarn or rubber thread",
    parent: "5806",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580631",
    description:
      "Fabrics; narrow woven fabrics, n.e.c. in heading no. 5806, of cotton (excluding goods of heading no. 5807)",
    parent: "5806",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580632",
    description:
      "Fabrics, narrow woven fabrics, n.e.c. in heading no. 5806, of man-made fibres (excluding goods of heading no. 5807)",
    parent: "5806",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580639",
    description:
      "Fabrics; narrow woven fabrics, n.e.c. in heading no. 5806, of textile materials n.e.c. in item no. 5806.3 (excluding goods of heading no. 5807)",
    parent: "5806",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580640",
    description:
      "Fabrics; narrow woven, consisting of warp without weft, assembled by means of an adhesive (bolducs)",
    parent: "5806",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5807",
    description:
      "Labels, badges and similar articles; of textile materials, in the piece, in strips or cut to shape or size, not embroidered",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580710",
    description:
      "Labels, badges and similar articles; woven, of textile materials, in the piece, in strips or cut to shape or size, not embroidered",
    parent: "5807",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580790",
    description:
      "Labels, badges and similar articles; (other than woven), of textile materials, in the piece, in strips or cut to shape or size, not embroidered",
    parent: "5807",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5808",
    description:
      "Braids in the piece; ornamental trimmings in the piece, without embroidery, other than knitted or crocheted; tassels, pompons and similar articles",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580810",
    description: "Braids; in the piece",
    parent: "5808",
    level: "6",
  },
  {
    section: "XI",
    hscode: "580890",
    description:
      "Ornamental trimmings; tassels, pompons and similar articles; ornamental trimmings in the piece, without embroidery, other than knitted or crocheted",
    parent: "5808",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5809",
    description:
      "Fabrics, woven; of metal thread and metallised yarn of heading no. 5605, of a kind used in apparel, as furnishing fabrics or similar purposes; n.e.c. or included",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "580900",
    description:
      "Fabrics, woven; of metal thread and metallised yarn of heading no. 5605, of a kind used in apparel, as furnishing fabrics or similar purposes; n.e.c. or included",
    parent: "5809",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5810",
    description: "Embroidery; in the piece, in strips or in motifs",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "581010",
    description:
      "Embroidery; without visible ground, in the piece, in strips or in motifs",
    parent: "5810",
    level: "6",
  },
  {
    section: "XI",
    hscode: "581091",
    description:
      "Embroidery; with visible ground, of cotton, in the piece, in strips or in motifs",
    parent: "5810",
    level: "6",
  },
  {
    section: "XI",
    hscode: "581092",
    description:
      "Embroidery; with visible ground, of man-made fibres, in the piece, in strips or in motifs",
    parent: "5810",
    level: "6",
  },
  {
    section: "XI",
    hscode: "581099",
    description:
      "Embroidery; with visible ground, of textile materials (other than cotton and man-made fibres), in the piece, in strips or in motifs",
    parent: "5810",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5811",
    description:
      "Quilted textile products; in the piece, composed of one or more layers of textile materials assembled with padding by stitching or otherwise (excluding embroidery of heading no. 5810)",
    parent: "58",
    level: "4",
  },
  {
    section: "XI",
    hscode: "581100",
    description:
      "Quilted textile products; in the piece, composed of one or more layers of textile materials assembled with padding by stitching or otherwise (excluding embroidery of heading no. 5810)",
    parent: "5811",
    level: "6",
  },
  {
    section: "XI",
    hscode: "59",
    description:
      "Textile fabrics; impregnated, coated, covered or laminated; textile articles of a kind suitable for industrial use",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "5901",
    description:
      "Textile fabrics, gum or amylaceous substance coated, used for outer book covers and like; tracing cloth, prepared painting canvas; buckram and similar stiffened textile fabrics used for hat foundation",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590110",
    description:
      "Textile fabrics; coated with gum or amylaceous substances, of a kind used for the outer covers of books or the like",
    parent: "5901",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590190",
    description:
      "Textile fabrics; coated with gum or amylaceous substances, tracing cloth, prepared painting canvas, buckram and similar stiffened textile fabrics for hat foundations, (excluding book covers)",
    parent: "5901",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5902",
    description:
      "Textile fabrics; tyrecord of high tenacity yarn of nylon or other polyamides polyesters or viscose rayon",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590210",
    description:
      "Textile fabrics; tyrecord of high tenacity yarn of nylon or other polyamides",
    parent: "5902",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590220",
    description: "Textile fabrics; tyrecord of high tenacity yarn of polyester",
    parent: "5902",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590290",
    description:
      "Textile fabrics; tyrecord of high tenacity yarn of viscose rayon",
    parent: "5902",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5903",
    description:
      "Textile fabrics impregnated, coated, covered or laminated with plastics, other than those of heading no. 5902",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590310",
    description:
      "Textile fabrics; impregnated, coated, covered or laminated with poly(vinyl chloride)",
    parent: "5903",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590320",
    description:
      "Textile fabrics; impregnated, coated, covered or laminated with polyurethane",
    parent: "5903",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590390",
    description:
      "Textile fabrics; impregnated, coated, covered or laminated with plastics, (excluding polyvinyl chloride, polyurethane and those of heading no. 5902)",
    parent: "5903",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5904",
    description:
      "Linoleum, whether or not cut to shape; floor coverings consisting of a coating or covering applied on a textile backing, whether or not cut to shape",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590410",
    description: "Linoleum, whether or not cut to shape",
    parent: "5904",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590490",
    description:
      "Textiles floor coverings; consisting of a coating or covering applied on a textile backing, whether or not cut to shape, other than linoleum",
    parent: "5904",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5905",
    description: "Textile wall coverings",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590500",
    description:
      "Textile wall coverings of fabrics impregnated, coated, covered or laminated",
    parent: "5905",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5906",
    description:
      "Textile fabrics, rubberised; other than those of heading no. 5902",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590610",
    description:
      "Textile fabrics, rubberised; (excluding those of heading no. 5902), adhesive tape of a width not exceeding 20cm",
    parent: "5906",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590691",
    description:
      "Textile fabrics, rubberised; (excluding those of heading no. 5902 and adhesive tape of a width not exceeding 20cm), knitted or crocheted",
    parent: "5906",
    level: "6",
  },
  {
    section: "XI",
    hscode: "590699",
    description:
      "Textile fabrics, rubberised; (excluding those of heading no. 5902 and adhesive tape of a width not exceeding 20cm), not knitted or crocheted",
    parent: "5906",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5907",
    description:
      "Textile fabrics; otherwise impregnated, coated or covered; painted canvas being theatrical scenery, studio back-cloths or the like",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590700",
    description:
      "Textile fabrics; otherwise impregnated, coated or covered, painted canvas being theatrical scenery, studio back-cloths or the like",
    parent: "5907",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5908",
    description:
      "Textile wicks, woven, plaited or knitted; for lamps, stoves, lighters, candles or the like; incandescent gas mantles and tubular knitted gas mantle fabric therefor, whether or not impregnated",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590800",
    description:
      "Textile wicks, woven, plaited or knitted; for lamps, stoves, lighters, candles or the like; incandescent gas mantles and tubular knitted gas mantle fabric therefor, whether or not impregnated",
    parent: "5908",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5909",
    description:
      "Textile hose piping and similar textile tubing; with or without lining, armour or accessories of other materials",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "590900",
    description:
      "Textile hosepiping and similar textile tubing; with or without lining, armour or accessories of other materials",
    parent: "5909",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5910",
    description:
      "Textiles; transmission or conveyor belts or belting, of textile material, whether or not impregnated, coated, covered or laminated with plastics, or reinforced with metal or other material",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "591000",
    description:
      "Textiles; transmission or conveyor belts or belting, of textile material, whether or not impregnated, coated, covered or laminated with plastics, or reinforced with metal or other material",
    parent: "5910",
    level: "6",
  },
  {
    section: "XI",
    hscode: "5911",
    description:
      "Textile products and articles for technical uses; specified in note 7 to this chapter",
    parent: "59",
    level: "4",
  },
  {
    section: "XI",
    hscode: "591110",
    description:
      "Textile fabric, felt & felt-lined woven fabrics, coated/covered/laminated with rubber, leather or other material, for card clothing, similar fabrics used for technical purposes, including rubber impregnated narrow velvet fabrics to cover weaving spindles",
    parent: "5911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "591120",
    description:
      "Textile products and articles for technical uses; bolting cloth, whether or not made up",
    parent: "5911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "591131",
    description:
      "Textiles; fabrics and felts, endless or fitted with linking devices, of a kind used in paper-making or similar machines, weighing less than 650g/m2",
    parent: "5911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "591132",
    description:
      "Textiles; fabrics and felts, endless or fitted with linking devices, of a kind used in paper-making or similar machines, weighing 650g/m2 or more",
    parent: "5911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "591140",
    description:
      "Textile products and articles for technical uses; straining cloth of a kind used in oil presses and the like, including that of human hair",
    parent: "5911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "591190",
    description:
      "Textile products and articles for technical uses; n.e.c. in heading no. 5911",
    parent: "5911",
    level: "6",
  },
  {
    section: "XI",
    hscode: "60",
    description: "Fabrics; knitted or crocheted",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "6001",
    description:
      "Fabrics; pile fabrics, including long pile fabrics and terry fabrics, knitted or crocheted",
    parent: "60",
    level: "4",
  },
  {
    section: "XI",
    hscode: "600110",
    description: "Fabrics; long pile fabrics, knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600121",
    description:
      "Fabrics; looped pile fabrics, of cotton, knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600122",
    description:
      "Fabrics; looped pile fabrics, of man-made fibres, knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600129",
    description:
      "Fabrics; looped pile fabrics, of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600191",
    description:
      "Fabrics; pile fabrics (excluding long pile and loop pile), of cotton, knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600192",
    description:
      "Fabrics; pile fabrics (excluding long pile and loop pile), of man-made fibres, knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600199",
    description:
      "Fabrics; pile fabrics (excluding long pile and loop pile), of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6001",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6002",
    description:
      "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width not exceeding 30cm, containing by weight 5% or more of elastomeric yarn or rubber thread",
    parent: "60",
    level: "4",
  },
  {
    section: "XI",
    hscode: "600240",
    description:
      "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width not exceeding 30 cm, containing by weight 5% or more of elastomeric yarn but not containing rubber thread",
    parent: "6002",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600290",
    description:
      "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width not exceeding 30 cm, containing by weight 5% or more of elastomeric yarn or rubber thread",
    parent: "6002",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6003",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm,",
    parent: "60",
    level: "4",
  },
  {
    section: "XI",
    hscode: "600310",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of wool or fine animal hair",
    parent: "6003",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600320",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of cotton",
    parent: "6003",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600330",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of synthetic fibres",
    parent: "6003",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600340",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of artificial fibres",
    parent: "6003",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600390",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, other than of wool and fine animal hair, cotton, synthetic or artificial fibres",
    parent: "6003",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6004",
    description:
      "Fabrics; knitted or crocheted fabrics of a width exceeding 30 cm, other than those of heading 60.01, containing by weight 5% or more of elastomeric yarn or rubber thread",
    parent: "60",
    level: "4",
  },
  {
    section: "XI",
    hscode: "600410",
    description:
      "Fabrics; knitted or crocheted fabrics of a width exceeding 30 cm, other than those of heading 60.01, containing by weight 5% or more of elastomeric yarn but not containing rubber thread",
    parent: "6004",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600490",
    description:
      "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width exceeding 30 cm, containing by weight 5% or more of elastomeric yarn or rubber thread,",
    parent: "6004",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6005",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04",
    parent: "60",
    level: "4",
  },
  {
    section: "XI",
    hscode: "600521",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, unbleached or bleached",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600522",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, dyed",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600523",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, yarns of different colours",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600524",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, printed",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600535",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres specified in Subheading Note 1 to this Chapter",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600536",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, bleached or unbleached",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600537",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, dyed",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600538",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, yarns of different colours",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600539",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, printed",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600541",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, bleached or unbleached",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600542",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, dyed",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600543",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, of yarns of different colours",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600544",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, printed",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600590",
    description:
      "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, excluding those made from cotton or synthetic or artificial fibres",
    parent: "6005",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6006",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04",
    parent: "60",
    level: "4",
  },
  {
    section: "XI",
    hscode: "600610",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of wool or fine animal hair",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600621",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, unbleached or bleached",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600622",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, dyed",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600623",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, of yarns of different colours",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600624",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, printed",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600631",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, unbleached or bleached",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600632",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, dyed",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600633",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, of yarns of different colours",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600634",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, printed",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600641",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, unbleached or bleached",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600642",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, dyed",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600643",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, of yarns of different colours",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600644",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, printed",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "600690",
    description:
      "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04,and other than those made of wool, fine animal hair, cotton, synthetic or artificial fibres",
    parent: "6006",
    level: "6",
  },
  {
    section: "XI",
    hscode: "61",
    description: "Apparel and clothing accessories; knitted or crocheted",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "6101",
    description:
      "Coats; men's or boys' overcoats, car-coats, capes, cloaks, anoraks, ski-jackets, wind-cheaters, wind-jackets and similar articles; knitted or crocheted, other than those of heading no. 6103",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610120",
    description:
      "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of cotton, knitted or crocheted (excluding those of heading no. 6103)",
    parent: "6101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610130",
    description:
      "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of man-made fibres, knitted or crocheted, (excluding those of heading no. 6103)",
    parent: "6101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610190",
    description:
      "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of textile materials n.e.c. in heading no. 6101, knitted or crocheted (excluding those of heading no. 6103)",
    parent: "6101",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6102",
    description:
      "Coats; women's or girls' overcoats, car-coats, capes, cloaks, anoraks, ski-jackets, wind-cheaters, wind-jackets and similar articles, knitted or crocheted, other than those of heading no. 6104",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610210",
    description:
      "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of wool or fine animal hair, knitted or crocheted (excluding those of heading no. 6104)",
    parent: "6102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610220",
    description:
      "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of cotton, knitted or crocheted (excluding those of heading no. 6104)",
    parent: "6102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610230",
    description:
      "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of man-made fibres, knitted or crocheted (excluding those of heading no. 6104)",
    parent: "6102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610290",
    description:
      "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of textile materials n.e.c. in heading no. 6102, knitted or crocheted (excluding those of heading no. 6104)",
    parent: "6102",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6103",
    description:
      "Suits, ensembles, jackets, blazers, trousers, bib and brace overalls, breeches, shorts (not swimwear); men's or boys', knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610310",
    description: "Suits; men's or boys', knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610322",
    description: "Ensembles; men's or boys', of cotton, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610323",
    description:
      "Ensembles; men's or boys', of synthetic fibres, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610329",
    description:
      "Ensembles; men's or boys', of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610331",
    description:
      "Jackets and blazers; men's or boys', of wool or fine animal hair, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610332",
    description:
      "Jackets and blazers; men's or boys', of cotton, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610333",
    description:
      "Jackets and blazers; men's or boys', of synthetic fibres, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610339",
    description:
      "Jackets and blazers; men's or boys', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610341",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of wool or fine animal hair, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610342",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of cotton, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610343",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of synthetic fibres, knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610349",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
    parent: "6103",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6104",
    description:
      "Suits, ensembles, jackets, dresses, skirts, divided skirts, trousers, bib and brace overalls, breeches and shorts (not swimwear), women's or girls', knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610413",
    description:
      "Suits; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610419",
    description:
      "Suits; women's or girls', of textile materials (other than synthetic fibres), knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610422",
    description:
      "Ensembles; women's or girls', of cotton, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610423",
    description:
      "Ensembles; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610429",
    description:
      "Ensembles; women's or girls', of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610431",
    description:
      "Jackets; women's or girls', of wool or fine animal hair, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610432",
    description: "Jackets; women's or girls', of cotton, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610433",
    description:
      "Jackets; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610439",
    description:
      "Jackets; women's or girls', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610441",
    description:
      "Dresses; women's or girls', of wool or fine animal hair, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610442",
    description: "Dresses; women's or girls', of cotton, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610443",
    description:
      "Dresses; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610444",
    description:
      "Dresses; women's or girls', of artificial fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610449",
    description:
      "Dresses; women's or girls', of textile materials (other than wool or fine animal hair, cotton, synthetic or artificial fibres), knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610451",
    description:
      "Skirts and divided skirts; women's or girls', of wool or fine animal hair, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610452",
    description:
      "Skirts and divided skirts; women's or girls', of cotton, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610453",
    description:
      "Skirts and divided skirts; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610459",
    description:
      "Skirts and divided skirts; women's or girls', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610461",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of wool or fine animal hair, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610462",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of cotton, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610463",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610469",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
    parent: "6104",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6105",
    description: "Shirts; men's or boys', knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610510",
    description: "Shirts; men's or boys', of cotton, knitted or crocheted",
    parent: "6105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610520",
    description:
      "Shirts; men's or boys', of man-made fibres, knitted or crocheted",
    parent: "6105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610590",
    description:
      "Shirts; men's or boys', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6105",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6106",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610610",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of cotton, knitted or crocheted",
    parent: "6106",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610620",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of man-made fibres, knitted or crocheted",
    parent: "6106",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610690",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6106",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6107",
    description:
      "Underpants, briefs, nightshirts, pyjamas, bathrobes, dressing gowns and similar articles; men's or boys', knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610711",
    description:
      "Underpants and briefs; men's or boys', of cotton, knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610712",
    description:
      "Underpants and briefs; men's or boys', of man-made fibres, knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610719",
    description:
      "Underpants and briefs; men's or boys', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610721",
    description:
      "Nightshirts and pyjamas; men's or boys', of cotton, knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610722",
    description:
      "Nightshirts and pyjamas; men's or boys', of man-made fibres, knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610729",
    description:
      "Nightshirts and pyjamas; men's or boys', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610791",
    description:
      "Bathrobes, dressing gowns and similar articles; men's or boys', of cotton, knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610799",
    description:
      "Bathrobes, dressing gowns and similar articles; men's or boys', of textile materials (other than cotton), knitted or crocheted",
    parent: "6107",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6108",
    description:
      "Slips, petticoats, briefs, panties, nightdresses, pyjamas, negligees, bathrobes, dressing gowns and similar articles; women's or girls', knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610811",
    description:
      "Slips and petticoats; women's or girls', of man-made fibres, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610819",
    description:
      "Slips and petticoats; women's or girls', of textile materials (other than man-made fibres), knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610821",
    description:
      "Briefs and panties; women's or girls', of cotton, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610822",
    description:
      "Briefs and panties; women's or girls', of man-made fibres, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610829",
    description:
      "Briefs and panties; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610831",
    description:
      "Nightdresses and pyjamas; women's or girls', of cotton, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610832",
    description:
      "Nightdresses and pyjamas; women's or girls', of man-made fibres, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610839",
    description:
      "Nightdresses and pyjamas; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610891",
    description:
      "Negligees, bathrobes, dressing gowns and similar articles; women's or girls', of cotton, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610892",
    description:
      "Negligees, bathrobes, dressing gowns and similar articles; women's or girls', of man-made fibres, knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610899",
    description:
      "Negligees, bathrobes, dressing gowns and similar articles; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
    parent: "6108",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6109",
    description: "T-shirts, singlets and other vests; knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "610910",
    description:
      "T-shirts, singlets and other vests; of cotton, knitted or crocheted",
    parent: "6109",
    level: "6",
  },
  {
    section: "XI",
    hscode: "610990",
    description:
      "T-shirts, singlets and other vests; of textile materials (other than cotton), knitted or crocheted",
    parent: "6109",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6110",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611011",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted, of wool or fine animal hair",
    parent: "6110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611012",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted, of fibres from kashmir (cashmere) goats",
    parent: "6110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611019",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted, of fine animal hair other than that of kashmir (cashmere) goats",
    parent: "6110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611020",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; of cotton, knitted or crocheted",
    parent: "6110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611030",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; of man-made fibres, knitted or crocheted",
    parent: "6110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611090",
    description:
      "Jerseys, pullovers, cardigans, waistcoats and similar articles; of textile materials (other than wool or fine animal hair, cotton or man-made fibres), knitted or crocheted",
    parent: "6110",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6111",
    description:
      "Garments and clothing accessories, babies'; knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611120",
    description:
      "Garments and clothing accessories; babies', of cotton, knitted or crocheted",
    parent: "6111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611130",
    description:
      "Garments and clothing accessories; babies', of synthetic fibres, knitted or crocheted",
    parent: "6111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611190",
    description:
      "Garments and clothing accessories; babies', of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
    parent: "6111",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6112",
    description: "Track suits, ski suits and swimwear; knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611211",
    description: "Track suits; of cotton, knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611212",
    description: "Track suits; of synthetic fibres, knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611219",
    description:
      "Track suits; of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611220",
    description: "Ski suits; knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611231",
    description:
      "Swimwear; men's or boys', of synthetic fibres, knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611239",
    description:
      "Swimwear; men's or boys', of textile materials (other than synthetic fibres), knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611241",
    description:
      "Swimwear; women's or girls', of synthetic fibres, knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611249",
    description:
      "Swimwear; women's or girls', of textile materials (other than synthetic fibres), knitted or crocheted",
    parent: "6112",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6113",
    description:
      "Garments made up of knitted or crocheted fabrics of heading no. 5903, 5906 and 5907",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611300",
    description:
      "Garments made up of knitted or crocheted fabrics of heading no. 5903, 5906 and 5907",
    parent: "6113",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6114",
    description: "Garments; knitted or crocheted, n.e.c. in chapter 61",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611420",
    description:
      "Garments; of cotton, knitted or crocheted, n.e.c. in chapter 61",
    parent: "6114",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611430",
    description:
      "Garments; of man-made fibres, knitted or crocheted, n.e.c. in chapter 61",
    parent: "6114",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611490",
    description:
      "Garments; of textile materials (other than cotton or man-made fibres), knitted or crocheted, n.e.c. in chapter 61",
    parent: "6114",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6115",
    description:
      "Hosiery; panty hose, tights, stockings, socks and other hosiery, including graduated compression hosiery (for example, stockings for varicose veins) and footwear without applied soles, knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611510",
    description:
      "Graduated compression hosiery (for example, stockings for varicose veins), knitted or crocheted",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611521",
    description:
      "Hosiery; panty hose and tights (other than graduated compression hosiery), of synthetic fibres, measuring per single yarn less than 67 decitex, knitted or crocheted",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611522",
    description:
      "Hosiery; panty hose and tights (other than graduated compression hosiery), of synthetic fibres, measuring per single yarn 67 decitex or more, knitted or crocheted",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611529",
    description:
      "Hosiery; panty hose and tights (other than graduated compression hosiery), of textile materials (other than synthetic fibres), knitted or crocheted",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611530",
    description:
      "Hosiery; women's, full-length or knee-length (other than graduated compression hosiery), measuring per single yarn less than 67 decitex, knitted or crocheted",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611594",
    description:
      "Hosiery and footwear; without applied soles, of wool or fine animal hair, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, women's full or knee-length hosiery measuring per single yarn less than 67 decitex)",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611595",
    description:
      "Hosiery and footwear; without applied soles, of cotton, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611596",
    description:
      "Hosiery and footwear; without applied soles, of synthetic fibres, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611599",
    description:
      "Hosiery and footwear; without applied soles, of textile materials n.e.c. in item no. 6115.9, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
    parent: "6115",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6116",
    description: "Gloves, mittens and mitts; knitted or crocheted",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611610",
    description:
      "Gloves, mittens and mitts; knitted or crocheted, impregnated, coated, covered or laminated with plastics or rubber",
    parent: "6116",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611691",
    description:
      "Gloves, mittens and mitts; of wool or fine animal hair, knitted or crocheted, (other than impregnated, coated, covered or laminated with plastics or rubber)",
    parent: "6116",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611692",
    description:
      "Gloves, mittens and mitts; of cotton, knitted or crocheted, (other than impregnated, coated, covered or laminated with plastics or rubber)",
    parent: "6116",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611693",
    description:
      "Gloves, mittens and mitts; of synthetic fibres, knitted or crocheted, (other than impregnated, coated, covered or laminated with plastics or rubber)",
    parent: "6116",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611699",
    description:
      "Gloves, mittens and mitts; of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted, (other than impregnated, coated, covered or laminated with plastics or rubber)",
    parent: "6116",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6117",
    description:
      "Clothing accessories; made up, knitted or crocheted, knitted or crocheted parts of garments or of clothing accessories",
    parent: "61",
    level: "4",
  },
  {
    section: "XI",
    hscode: "611710",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like; knitted or crocheted",
    parent: "6117",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611780",
    description:
      "Clothing accessories; knitted or crocheted, n.e.c. in heading no. 6117",
    parent: "6117",
    level: "6",
  },
  {
    section: "XI",
    hscode: "611790",
    description: "Clothing; parts, knitted or crocheted",
    parent: "6117",
    level: "6",
  },
  {
    section: "XI",
    hscode: "62",
    description: "Apparel and clothing accessories; not knitted or crocheted",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "6201",
    description:
      "Overcoats, car-coats, capes, cloaks, anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles, men's or boys', other than those of heading no. 6203 (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620120",
    description:
      "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, of wool or fine animal hair, other than those of heading no. 6203 (not knitted or crocheted)",
    parent: "6201",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620130",
    description:
      "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, of cotton, other than those of heading no. 6203 (not knitted or crocheted)",
    parent: "6201",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620140",
    description:
      "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, of man-made fibres, other than those of heading no. 6203 (not knitted or crocheted)",
    parent: "6201",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620190",
    description:
      "Coats; men's or boys', overcoats, rain-coats, car-coats, capes, cloaks and similar, of textile materials (other than wool, fine animal hair, cotton or man-made fibres), other than those of heading no. 6203 (not knitted or crocheted)",
    parent: "6201",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6202",
    description:
      "Coats; women's or girls' overcoats, carcoats, capes, cloaks, anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles, other than those of heading no. 6204 (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620220",
    description:
      "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks anoraks (including ski-jackets) and similar articles, of wool or fine animal hair, other than those of heading no. 6204 (not knitted or crocheted)",
    parent: "6202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620230",
    description:
      "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks anoraks (including ski-jackets) and similar articles, of cotton, other than those of heading no. 6204 (not knitted or crocheted)",
    parent: "6202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620240",
    description:
      "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks anoraks (including ski-jackets) and similar articles, of man-made fibres, other than those of heading no. 6204 (not knitted or crocheted)",
    parent: "6202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620290",
    description:
      "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of textile materials (other than wool, fine animal hair, cotton or man-made fibres), other than those of heading no. 6204 (not knitted or crocheted)",
    parent: "6202",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6203",
    description:
      "Suits, ensembles, jackets, blazers, trousers, bib and brace overalls, breeches and shorts (other than swimwear); men's or boys' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620311",
    description:
      "Suits; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620312",
    description:
      "Suits; men's or boys', of synthetic fibres (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620319",
    description:
      "Suits; men's or boys', of textile materials n.e.c. in item no. 6203.1 (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620322",
    description:
      "Ensembles; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620323",
    description:
      "Ensembles; men's or boys', of synthetic fibres (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620329",
    description:
      "Ensembles; men's or boys', of textile materials n.e.c. in item no. 6203.2 (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620331",
    description:
      "Jackets and blazers; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620332",
    description:
      "Jackets and blazers; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620333",
    description:
      "Jackets and blazers; men's or boys', of synthetic fibres (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620339",
    description:
      "Jackets and blazers; men's or boys', of textile materials n.e.c. in item no. 6203.3 (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620341",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620342",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620343",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of synthetic fibres (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620349",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of textile materials (other than wool, fine animal hair, cotton or synthetic fibres), (not knitted or crocheted)",
    parent: "6203",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6204",
    description:
      "Suits, ensembles, jackets, dresses, skirts, divided skirts, trousers, bib and brace overalls, breeches and shorts (other than swimwear); women's or girls' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620411",
    description:
      "Suits; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620412",
    description:
      "Suits; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620413",
    description:
      "Suits; women's or girls', of synthetic fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620419",
    description:
      "Suits; women's or girls', of textile materials n.e.c. in item no. 6204.1 (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620421",
    description:
      "Ensembles; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620422",
    description:
      "Ensembles; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620423",
    description:
      "Ensembles; women's or girls', of synthetic fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620429",
    description:
      "Ensembles; women's or girls', of textile materials n.e.c. in item no. 6204.2 (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620431",
    description:
      "Jackets and blazers; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620432",
    description:
      "Jackets and blazers; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620433",
    description:
      "Jackets and blazers; women's or girls', of synthetic fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620439",
    description:
      "Jackets and blazers; women's or girls', of textile materials n.e.c. in item no. 6204.3 (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620441",
    description:
      "Dresses; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620442",
    description:
      "Dresses; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620443",
    description:
      "Dresses; women's or girls', of synthetic fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620444",
    description:
      "Dresses; women's or girls', of artificial fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620449",
    description:
      "Dresses; women's or girls', of textile materials n.e.c. in item no. 6204.4 (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620451",
    description:
      "Skirts and divided skirts; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620452",
    description:
      "Skirts and divided skirts; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620453",
    description:
      "Skirts and divided skirts; women's or girls', of synthetic fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620459",
    description:
      "Skirts and divided skirts; women's or girls', of textile materials n.e.c. in item no. 6204.5 (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620461",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620462",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620463",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of synthetic fibres (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620469",
    description:
      "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of textile materials (other than wool, fine animal hair, cotton or synthetic fibres), (not knitted or crocheted)",
    parent: "6204",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6205",
    description: "Shirts; men's or boys' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620520",
    description: "Shirts; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620530",
    description:
      "Shirts; men's or boys', of man-made fibres (not knitted or crocheted)",
    parent: "6205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620590",
    description:
      "Shirts; men's or boys', of textile materials n.e.c. in heading no. 6205 (not knitted or crocheted)",
    parent: "6205",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6206",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620610",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of silk or silk waste (not knitted or crocheted)",
    parent: "6206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620620",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
    parent: "6206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620630",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620640",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of man-made fibres (not knitted or crocheted)",
    parent: "6206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620690",
    description:
      "Blouses, shirts and shirt-blouses; women's or girls', of textile materials n.e.c. in heading no. 6206 (not knitted or crocheted)",
    parent: "6206",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6207",
    description:
      "Singlets and other vests, underpants, briefs, night-shirts, pyjamas, bathrobes, dressing gowns and similar articles; men's or boys' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620711",
    description:
      "Underpants and briefs; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620719",
    description:
      "Underpants and briefs; men's or boys', of textile materials other than cotton (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620721",
    description:
      "Nightshirts and pyjamas; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620722",
    description:
      "Nightshirts and pyjamas; men's or boys', of man-made fibres (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620729",
    description:
      "Nightshirts and pyjamas; men's or boys', of textile materials other than cotton or man-made fibres (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620791",
    description:
      "Singlets and other vests, bathrobes, dressing gowns and similar articles; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620799",
    description:
      "Singlets and other vests, bathrobes, dressing gowns and similar articles; men's or boys', of textile materials other than cotton (not knitted or crocheted)",
    parent: "6207",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6208",
    description:
      "Singlets and other vests, slips, petticoats, briefs, panties, nightdresses, pyjamas, negligees, bathrobes, dressing gowns and similar articles; women's or girls' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620811",
    description:
      "Slips and petticoats; women's or girls', of man-made fibres (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620819",
    description:
      "Slips and petticoats; women's or girls', of textile materials other than man-made fibres (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620821",
    description:
      "Nightdresses and pyjamas; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620822",
    description:
      "Nightdresses and pyjamas; women's or girls', of man-made fibres (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620829",
    description:
      "Nightdresses and pyjamas; women's or girls', of textile materials other than cotton or man-made fibres (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620891",
    description:
      "Singlets and other vests, briefs, panties, negligees, bathrobes, dressing gowns and similar articles; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620892",
    description:
      "Singlets and other vests, briefs, panties, negligees, bathrobes, dressing gowns etc.; women's or girls', of man-made fibres (not knitted or crocheted), excluding incontinence or other sanitary garments or garment liners of heading no. 96.19",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620899",
    description:
      "Singlets and other vests, briefs, panties, negligees, bathrobes, dressing gowns and similar articles; women's or girls', of textile materials other than cotton or man-made fibres (not knitted or crocheted)",
    parent: "6208",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6209",
    description:
      "Garments and clothing accessories; babies' (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "620920",
    description:
      "Garments and clothing accessories; babies', of cotton (not knitted or crocheted)",
    parent: "6209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620930",
    description:
      "Garments and clothing accessories; babies', of synthetic fibres (not knitted or crocheted)",
    parent: "6209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "620990",
    description:
      "Garments and clothing accessories; babies', of textile materials other than cotton or synthetic fibres (not knitted or crocheted)",
    parent: "6209",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6210",
    description:
      "Garments made up of fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621010",
    description: "Garments; of felt or non-wovens (not knitted or crocheted)",
    parent: "6210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621020",
    description:
      "Garments; overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, men's or boys', of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
    parent: "6210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621030",
    description:
      "Garments; overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, women's or girls', of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
    parent: "6210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621040",
    description:
      "Garments; men's or boys', n.e.c. in item no. 6210.2, of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
    parent: "6210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621050",
    description:
      "Garments; women's or girls', n.e.c. in item no. 6210.3, of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
    parent: "6210",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6211",
    description:
      "Track suits, swimwear and other garments (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621111",
    description: "Swimwear; men's or boys', (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621112",
    description: "Swimwear; women's or girls', (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621120",
    description: "Ski suits; (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621132",
    description:
      "Track suits and other garments n.e.c.; men's or boys', of cotton (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621133",
    description:
      "Track suits and other garments n.e.c.; men's or boys', of man-made fibres (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621139",
    description:
      "Track suits and other garments n.e.c.; men's or boys', of textile materials n.e.c. in item no. 6211.3 (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621142",
    description:
      "Track suits and other garments n.e.c.; women's or girls', of cotton (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621143",
    description:
      "Track suits and other garments n.e.c.; women's or girls', of man-made fibres (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621149",
    description:
      "Track suits and other garments n.e.c.; women's or girls', of textile materials n.e.c. in item no. 6211.4 (not knitted or crocheted)",
    parent: "6211",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6212",
    description:
      "Brassieres, girdles, corsets, braces, suspenders, garters and similar articles and parts thereof; whether or not knitted or crocheted",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621210",
    description: "Brassieres; whether or not knitted or crocheted",
    parent: "6212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621220",
    description:
      "Girdles and panty-girdles; whether or not knitted or crocheted",
    parent: "6212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621230",
    description: "Corselettes; whether or not knitted or crocheted",
    parent: "6212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621290",
    description:
      "Braces, suspenders, garters and similar articles; whether or not knitted or crocheted, n.e.c. in heading no. 6212",
    parent: "6212",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6213",
    description: "Handkerchiefs (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621320",
    description: "Handkerchiefs; of cotton (not knitted or crocheted)",
    parent: "6213",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621390",
    description:
      "Handkerchiefs; of textile materials other than cotton (not knitted or crocheted)",
    parent: "6213",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6214",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621410",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like; of silk or silk waste (not knitted or crocheted)",
    parent: "6214",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621420",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like; of wool or fine animal hair (not knitted or crocheted)",
    parent: "6214",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621430",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like; of synthetic fibres (not knitted or crocheted)",
    parent: "6214",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621440",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like; of artificial fibres (not knitted or crocheted)",
    parent: "6214",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621490",
    description:
      "Shawls, scarves, mufflers, mantillas, veils and the like; of textile materials n.e.c. in heading no. 6214 (not knitted or crocheted)",
    parent: "6214",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6215",
    description: "Ties, bow ties and cravats (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621510",
    description:
      "Ties, bow ties and cravats; of silk or silk waste (not knitted or crocheted)",
    parent: "6215",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621520",
    description:
      "Ties, bow ties and cravats; of man-made fibres (not knitted or crocheted)",
    parent: "6215",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621590",
    description:
      "Ties, bow ties and cravats; of textile materials other than silk or man-made fibres (not knitted or crocheted)",
    parent: "6215",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6216",
    description: "Gloves, mittens and mitts (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621600",
    description: "Gloves, mittens and mitts (not knitted or crocheted)",
    parent: "6216",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6217",
    description:
      "Clothing accessories n.e.c.; parts of garments or accessories other than those of heading no. 6212 (not knitted or crocheted)",
    parent: "62",
    level: "4",
  },
  {
    section: "XI",
    hscode: "621710",
    description:
      "Clothing accessories; other than those of heading no. 6212 (not knitted or crocheted)",
    parent: "6217",
    level: "6",
  },
  {
    section: "XI",
    hscode: "621790",
    description:
      "Clothing; parts of garments or of clothing accessories, other than those of heading no. 6212 (not knitted or crocheted)",
    parent: "6217",
    level: "6",
  },
  {
    section: "XI",
    hscode: "63",
    description:
      "Textiles, made up articles; sets; worn clothing and worn textile articles; rags",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XI",
    hscode: "6301",
    description: "Blankets and travelling rugs",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630110",
    description: "Blankets; electric",
    parent: "6301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630120",
    description:
      "Blankets (other than electric blankets) and travelling rugs; of wool or of fine animal hair",
    parent: "6301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630130",
    description:
      "Blankets (other than electric blankets) and travelling rugs; of cotton",
    parent: "6301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630140",
    description:
      "Blankets (other than electric blankets) and travelling rugs; of synthetic fibres",
    parent: "6301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630190",
    description: "Blankets and travelling rugs; n.e.c. in heading no. 6301",
    parent: "6301",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6302",
    description: "Bed linen, table linen, toilet linen and kitchen linen",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630210",
    description: "Bed linen; knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630221",
    description: "Bed linen; of cotton, printed, not knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630222",
    description:
      "Bed linen; of man-made fibres, printed, not knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630229",
    description:
      "Bed linen; of textile materials (other than cotton or man-made fibres), printed, not knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630231",
    description: "Bed linen; of cotton (not printed, knitted or crocheted)",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630232",
    description:
      "Bed linen; of man-made fibres (not printed, knitted or crocheted)",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630239",
    description:
      "Bed linen; of textile materials other than cotton or man-made fibres (not printed, knitted or crocheted)",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630240",
    description: "Table linen; knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630251",
    description: "Table linen; of cotton, not knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630253",
    description: "Table linen; of man-made fibres, not knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630259",
    description:
      "Table linen; of textile materials (other than cotton or man-made fibres), not knitted or crocheted",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630260",
    description:
      "Kitchen and toilet linen; of terry towelling or similar terry fabrics, of cotton",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630291",
    description:
      "Toilet and kitchen linen; of cotton, excluding terry towelling or similar terry fabrics",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630293",
    description: "Toilet and kitchen linen; of man-made fibres",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630299",
    description:
      "Toilet and kitchen linen; of textile materials (other than cotton or man-made fibres)",
    parent: "6302",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6303",
    description:
      "Curtains (including drapes) and interior blinds; curtain or bed valances",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630312",
    description:
      "Curtains (including drapes) and interior blinds; curtain or bed valances, knitted or crocheted, of synthetic fibres",
    parent: "6303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630319",
    description:
      "Curtains (including drapes) and interior blinds; curtain or bed valances, knitted or crocheted, of textile materials other than synthetic fibres",
    parent: "6303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630391",
    description:
      "Curtains (including drapes) and interior blinds, curtain or bed valances; of cotton, not knitted or crocheted",
    parent: "6303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630392",
    description:
      "Curtains (including drapes) and interior blinds, curtain or bed valances; of synthetic fibres, not knitted or crocheted",
    parent: "6303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630399",
    description:
      "Curtains (including drapes) and interior blinds, curtain or bed valances; of textile materials other than cotton or synthetic fibres, not knitted or crocheted",
    parent: "6303",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6304",
    description: "Furnishing articles; excluding those of heading no. 9404",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630411",
    description: "Bedspreads; knitted or crocheted",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630419",
    description: "Bedspreads; not knitted or crocheted",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630420",
    description:
      "Furnishing articles; excluding those of heading no. 9404, bed nets, specified in Subheading Note 1 to this Chapter",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630491",
    description:
      "Furnishing articles; excluding those of heading no. 9404, n.e.c. in heading 6304, knitted or crocheted",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630492",
    description:
      "Furnishing articles; of cotton, not knitted or crocheted (excluding bedspreads and articles of heading no. 9404)",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630493",
    description:
      "Furnishing articles; of synthetic fibres, not knitted or crocheted (excluding bedspreads and articles of heading no. 9404)",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630499",
    description:
      "Furnishing articles; of textile materials other than cotton or synthetic fibres, not knitted or crocheted (excluding bedspreads and articles of heading no. 9404)",
    parent: "6304",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6305",
    description: "Sacks and bags, of a kind used for the packing of goods",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630510",
    description:
      "Sacks and bags; of a kind used for the packing of goods, of jute or of other textile bast fibres of heading no. 5303",
    parent: "6305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630520",
    description:
      "Sacks and bags; of a kind used for the packing of goods, of cotton",
    parent: "6305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630532",
    description:
      "Sacks and bags; of a kind used for the packing of goods, of man-made textile materials, flexible intermediate bulk containers",
    parent: "6305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630533",
    description:
      "Sacks and bags; of a kind used for the packing of goods, of man-made textile materials, of polyethylene or polypropylene strip or the like, not flexible intermediate bulk containers",
    parent: "6305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630539",
    description:
      "Sacks and bags; of a kind used for the packing of goods, of man-made textile materials, not of polyethylene or polypropylene strip or the like, not flexible intermediate bulk containers",
    parent: "6305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630590",
    description:
      "Sacks and bags; of a kind used for the packing of goods, of textile materials (other than jute, cotton or man-made textile materials)",
    parent: "6305",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6306",
    description:
      "Tarpaulins, awnings and sunblinds; tents (including temporary canopies and similar articles); sails for boats, sailboards or landcraft; camping goods",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630612",
    description: "Tarpaulins, awnings and sunblinds; of synthetic fibres",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630619",
    description:
      "Tarpaulins, awnings and sunblinds; of textile materials other than synthetic fibres",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630622",
    description:
      "Tents (including temporary canopies and similar articles); of synthetic fibres",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630629",
    description:
      "Tents (including temporary canopies and similar articles); of textile materials other than synthetic fibres",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630630",
    description: "Sails; for boats, sailboards or landcraft",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630640",
    description: "Camping goods; pneumatic mattresses",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630690",
    description:
      "Camping goods; (of textile materials), n.e.c in heading no. 6306",
    parent: "6306",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6307",
    description:
      "Textiles; made up articles n.e.c. in chapter 63, including dress patterns",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630710",
    description:
      "Cloths; floor cloths, dish-cloths, dusters and similar cleaning cloths",
    parent: "6307",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630720",
    description: "Life-jackets and life-belts",
    parent: "6307",
    level: "6",
  },
  {
    section: "XI",
    hscode: "630790",
    description:
      "Textiles; made up articles (including dress patterns), n.e.c. in chapter 63, n.e.c. in heading no. 6307",
    parent: "6307",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6308",
    description:
      "Textiles; sets of woven fabric and yarn, with or without accessories, for making into rugs, tapestries, embroidered tablecloths, serviettes and similar textile articles, in packings for retail sale",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630800",
    description:
      "Fabrics, woven and yarn; in sets, whether or not with accessories, for making up into rugs, tapestries, embroidered table cloths or serviettes or similar textile articles, packaged for retail sale",
    parent: "6308",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6309",
    description: "Textiles; worn clothing and other worn articles",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "630900",
    description: "Clothing; worn, and other worn articles",
    parent: "6309",
    level: "6",
  },
  {
    section: "XI",
    hscode: "6310",
    description:
      "Rags; used or new, scrap twine, cordage, rope and cables and worn out articles of twine, cordage, rope or cables, of textile materials",
    parent: "63",
    level: "4",
  },
  {
    section: "XI",
    hscode: "631010",
    description:
      "Rags; used or new, scrap twine, cordage, rope and cables and worn out articles of twine, cordage, rope or cables, of textile materials; sorted",
    parent: "6310",
    level: "6",
  },
  {
    section: "XI",
    hscode: "631090",
    description:
      "Rags; used or new, scrap twine, cordage, rope and cables and worn out articles of twine, cordage, rope or cables, of textile materials; other than sorted",
    parent: "6310",
    level: "6",
  },
  {
    section: "XII",
    hscode: "64",
    description: "Footwear; gaiters and the like; parts of such articles",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XII",
    hscode: "6401",
    description:
      "Footwear; waterproof, with outer soles and uppers of rubber or plastics, (uppers not fixed to the sole nor assembled by stitch, rivet, nail, screw, plug or similar)",
    parent: "64",
    level: "4",
  },
  {
    section: "XII",
    hscode: "640110",
    description:
      "Footwear; waterproof with metal toe-cap, rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
    parent: "6401",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640192",
    description:
      "Footwear; waterproof, covering the ankle (but not the knee), rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
    parent: "6401",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640199",
    description:
      "Footwear; waterproof, n.e.c. in heading no. 6401, rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
    parent: "6401",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6402",
    description:
      "Footwear; with outer soles and uppers of rubber or plastics (excluding waterproof footwear)",
    parent: "64",
    level: "4",
  },
  {
    section: "XII",
    hscode: "640212",
    description:
      "Sports footwear; with outer soles and uppers of rubber or plastics, ski-boots, cross-country ski footwear and snowboard boots",
    parent: "6402",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640219",
    description:
      "Sports footwear; (other than ski-boots, snowboard boots or cross-country ski footwear), with outer soles and uppers of rubber or plastics",
    parent: "6402",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640220",
    description:
      "Footwear; with outer soles and uppers of rubber or plastics, upper straps or thongs assembled to the sole by plugs",
    parent: "6402",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640291",
    description:
      "Footwear; n.e.c. in heading no. 6402, covering the ankle, with outer soles and uppers of rubber or plastics",
    parent: "6402",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640299",
    description:
      "Footwear; n.e.c. in heading no. 6402, (other than just covering the ankle), with outer soles and uppers of rubber or plastics",
    parent: "6402",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6403",
    description:
      "Footwear; with outer soles of rubber, plastics, leather or composition leather and uppers of leather",
    parent: "64",
    level: "4",
  },
  {
    section: "XII",
    hscode: "640312",
    description:
      "Sports footwear; with outer soles of rubber, plastics, leather or composition leather and uppers of leather, ski-boots, snowboard boots and cross-country ski footwear",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640319",
    description:
      "Sports footwear; (other than ski-boots, snowboard boots or cross-country ski footwear), with outer soles of rubber, plastics, leather or composition leather and uppers of leather",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640320",
    description:
      "Footwear; with outer soles of leather, uppers consisting of leather straps across instep and around the big toe",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640340",
    description:
      "Footwear; with metal toe-cap, outer soles of rubber, plastics, leather or composition leather, uppers of leather",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640351",
    description:
      "Footwear; n.e.c. in heading no. 6403, with outer soles and uppers of leather, covering the ankle",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640359",
    description:
      "Footwear; n.e.c. in heading no. 6403, (not covering the ankle), outer soles and uppers of leather",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640391",
    description:
      "Footwear; n.e.c. in heading no. 6403, covering the ankle, outer soles of rubber, plastics or composition leather, uppers of leather",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640399",
    description:
      "Footwear; n.e.c. in heading no. 6403, (not covering the ankle), outer soles of rubber, plastics or composition leather, uppers of leather",
    parent: "6403",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6404",
    description:
      "Footwear; with outer soles of rubber, plastics, leather or composition leather and uppers of textile materials",
    parent: "64",
    level: "4",
  },
  {
    section: "XII",
    hscode: "640411",
    description:
      "Sports footwear; tennis shoes, basketball shoes, gym shoes, training shoes and the like, with outer soles of rubber or plastics and uppers of textile materials",
    parent: "6404",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640419",
    description:
      "Footwear; (other than sportswear), with outer soles of rubber or plastics and uppers of textile materials",
    parent: "6404",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640420",
    description:
      "Footwear; outer soles of leather or composition leather, uppers of textile materials",
    parent: "6404",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6405",
    description: "Footwear; other footwear n.e.c. in chapter 64",
    parent: "64",
    level: "4",
  },
  {
    section: "XII",
    hscode: "640510",
    description:
      "Footwear; with uppers of leather or composition leather, n.e.c. in chapter 64",
    parent: "6405",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640520",
    description:
      "Footwear; with uppers of textile materials, n.e.c. in chapter 64",
    parent: "6405",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640590",
    description: "Footwear; n.e.c. in chapter 64",
    parent: "6405",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6406",
    description:
      "Footwear; parts of footwear; removable in-soles, heel cushions and similar articles; gaiters, le.g.ings and similar articles, and parts thereof",
    parent: "64",
    level: "4",
  },
  {
    section: "XII",
    hscode: "640610",
    description:
      "Footwear; parts, uppers and parts thereof, other than stiffeners",
    parent: "6406",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640620",
    description:
      "Footwear; parts, outer soles and heels, of rubber or plastics",
    parent: "6406",
    level: "6",
  },
  {
    section: "XII",
    hscode: "640690",
    description: "Footwear; parts, n.e.c. in heading 6406",
    parent: "6406",
    level: "6",
  },
  {
    section: "XII",
    hscode: "65",
    description: "Headgear and parts thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XII",
    hscode: "6501",
    description:
      "Hat-forms, hat bodies and hoods of felt, neither blocked to shape nor with made brims; plateaux and manchons (including slit manchons) of felt",
    parent: "65",
    level: "4",
  },
  {
    section: "XII",
    hscode: "650100",
    description:
      "Hat-forms, hat bodies and hoods of felt, neither blocked to shape nor with made brims; plateaux and manchons (including slit manchons) of felt",
    parent: "6501",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6502",
    description:
      "Hat-shapes; plaited or made by assembling strips of any material, neither blocked to shape, nor with made brims, nor lined, nor trimmed",
    parent: "65",
    level: "4",
  },
  {
    section: "XII",
    hscode: "650200",
    description:
      "Hat-shapes; plaited or made by assembling strips of any material, neither blocked to shape, nor with made brims, nor lined, nor trimmed",
    parent: "6502",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6504",
    description:
      "Hats and other headgear; plaited or made by assembling strips of any material, whether or not lined or trimmed",
    parent: "65",
    level: "4",
  },
  {
    section: "XII",
    hscode: "650400",
    description:
      "Hats and other headgear; plaited or made by assembling strips of any material, whether or not lined or trimmed",
    parent: "6504",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6505",
    description:
      "Hats and other headgear; knitted or crocheted, or made up from lace, felt or other textile fabric, in the piece (but not in strips), whether or not lined or trimmed; hair-nets of any material, whether or not lined or trimmed",
    parent: "65",
    level: "4",
  },
  {
    section: "XII",
    hscode: "650500",
    description:
      "Hats and other headgear; knitted or crocheted, or made up from lace, felt or other textile fabric, in the piece (but not in strips), whether or not lined or trimmed; hair-nets of any material, whether or not lined or trimmed",
    parent: "6505",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6506",
    description:
      "Headgear; n.e.c. in chapter 65, whether or not lined or trimmed",
    parent: "65",
    level: "4",
  },
  {
    section: "XII",
    hscode: "650610",
    description: "Headgear; safety, whether or not lined or trimmed",
    parent: "6506",
    level: "6",
  },
  {
    section: "XII",
    hscode: "650691",
    description:
      "Headgear; (other than safety headgear), of rubber or plastics, whether or not lined or trimmed",
    parent: "6506",
    level: "6",
  },
  {
    section: "XII",
    hscode: "650699",
    description:
      "Headgear; (other than safety headgear), (of materials other than rubber or plastic), whether or not lined or trimmed",
    parent: "6506",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6507",
    description:
      "Head-bands, linings, covers, hat foundations, hat frames, peaks and chinstraps, for headgear",
    parent: "65",
    level: "4",
  },
  {
    section: "XII",
    hscode: "650700",
    description:
      "Head-bands, linings, covers, hat foundations, hat frames, peaks and chinstraps; for headgear",
    parent: "6507",
    level: "6",
  },
  {
    section: "XII",
    hscode: "66",
    description:
      "Umbrellas, sun umbrellas, walking-sticks, seat sticks, whips, riding crops; and parts thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XII",
    hscode: "6601",
    description:
      "Umbrellas; sun umbrellas (including walking stick umbrellas, garden umbrellas and similar umbrellas)",
    parent: "66",
    level: "4",
  },
  {
    section: "XII",
    hscode: "660110",
    description: "Umbrellas and sun umbrellas; garden or similar umbrellas",
    parent: "6601",
    level: "6",
  },
  {
    section: "XII",
    hscode: "660191",
    description:
      "Umbrellas and sun umbrellas; having a telescopic shaft, (excluding garden or similar umbrellas)",
    parent: "6601",
    level: "6",
  },
  {
    section: "XII",
    hscode: "660199",
    description:
      "Umbrellas and sun umbrellas; n.e.c. in heading no. 6601 (including walking stick umbrellas)",
    parent: "6601",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6602",
    description:
      "Walking-sticks, seat-sticks, whips, riding-crops and the like",
    parent: "66",
    level: "4",
  },
  {
    section: "XII",
    hscode: "660200",
    description:
      "Walking-sticks, seat-sticks, whips, riding-crops and the like",
    parent: "6602",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6603",
    description:
      "Trimmings, parts and accessories of articles of heading no. 6601 or 6602",
    parent: "66",
    level: "4",
  },
  {
    section: "XII",
    hscode: "660320",
    description: "Umbrella frames; including frames mounted on shafts (sticks)",
    parent: "6603",
    level: "6",
  },
  {
    section: "XII",
    hscode: "660390",
    description:
      "Trimmings, accessories and parts of articles of heading no. 6601 or 6602; n.e.c. in heading no. 6603",
    parent: "6603",
    level: "6",
  },
  {
    section: "XII",
    hscode: "67",
    description:
      "Feathers and down, prepared; and articles made of feather or of down; artificial flowers; articles of human hair",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XII",
    hscode: "6701",
    description:
      "Skin and other parts of birds with their feather or down; feathers, parts of feather, down and articles thereof (other than goods of heading no. 0505 and worked quills and scapes)",
    parent: "67",
    level: "4",
  },
  {
    section: "XII",
    hscode: "670100",
    description:
      "Skins and other parts of birds with their feathers or down; feathers, parts of feathers, down and articles thereof (other than goods of heading no. 0505 and worked quills and scapes)",
    parent: "6701",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6702",
    description:
      "Flowers, foliage and fruit, artificial, and parts thereof; articles made of artificial flowers, foliage or fruit",
    parent: "67",
    level: "4",
  },
  {
    section: "XII",
    hscode: "670210",
    description:
      "Flowers, foliage and fruit, artificial, and parts thereof; articles made of artificial flowers, foliage or fruit, of plastics",
    parent: "6702",
    level: "6",
  },
  {
    section: "XII",
    hscode: "670290",
    description:
      "Flowers, foliage and fruit, artificial, and parts thereof; articles made of artificial flowers, foliage or fruit, of materials other than plastics",
    parent: "6702",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6703",
    description:
      "Human hair, dressed, thinned, bleached or otherwise worked; wool or other animal hair or other textile materials, prepared for use in making wigs or the like",
    parent: "67",
    level: "4",
  },
  {
    section: "XII",
    hscode: "670300",
    description:
      "Human hair, dressed, thinned, bleached or otherwise worked; wool or other animal hair or other textile materials, prepared for use in making wigs or the like",
    parent: "6703",
    level: "6",
  },
  {
    section: "XII",
    hscode: "6704",
    description:
      "Wigs, false beards, eyebrows and eyelashes, switches and the like, of human or animal hair or of textile materials; articles of human hair, n.e.c. or included",
    parent: "67",
    level: "4",
  },
  {
    section: "XII",
    hscode: "670411",
    description: "Wigs; complete, of synthetic textile materials",
    parent: "6704",
    level: "6",
  },
  {
    section: "XII",
    hscode: "670419",
    description:
      "False beards, eyebrows and eyelashes, switches and the like; of synthetic textile materials",
    parent: "6704",
    level: "6",
  },
  {
    section: "XII",
    hscode: "670420",
    description:
      "Wigs, false beards, eyebrows and eyelashes, switches and the like and other articles n.e.c.; of human hair",
    parent: "6704",
    level: "6",
  },
  {
    section: "XII",
    hscode: "670490",
    description:
      "Wigs, false beards, eyebrows and eyelashes, switches and the like and other articles n.e.c.; of animal hair or of textile materials other than synthetic",
    parent: "6704",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "68",
    description:
      "Stone, plaster, cement, asbestos, mica or similar materials; articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XIII",
    hscode: "6801",
    description:
      "Stone; setts, curbstones and flagstones, of natural stone (except slate)",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680100",
    description:
      "Stone; setts, curbstones and flagstones, of natural stone (except slate)",
    parent: "6801",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6802",
    description:
      "Monumental or building stone, worked (except slate) and articles thereof (not of heading no. 6801) mosaic cubes etc., of natural stone including slate; artificially coloured granules of natural stone",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680210",
    description:
      "Tiles, cubes and similar articles; whether or not rectangular (including square), largest face of which is capable of being enclosed in square, side less than 7cm, coloured granules, chippings, powder",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680221",
    description:
      "Marble, travertine and alabaster; simply cut or sawn, with a flat or even surface",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680223",
    description:
      "Granite; articles thereof, simply cut or sawn, with a flat or even surface",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680229",
    description:
      "Stone; monumental or building stone, n.e.c. in item no. 6802.2, articles thereof, simply cut or sawn, with a flat or even surface",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680291",
    description:
      "Marble, travertine and alabaster; articles thereof, (other than simply cut or sawn, with a flat or even surface)",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680292",
    description:
      "Stone; calcareous (excluding marble, travertine, alabaster) articles thereof, (other than simply cut or sawn, with a flat or even surface)",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680293",
    description:
      "Granite; articles thereof, (other than simply cut or sawn, with a flat or even surface)",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680299",
    description:
      "Stone; natural (excluding marble, travertine, alabaster, other calcareous stone or granite), monumental or building stone, (other than simply cut or sawn, with a flat or even surface)",
    parent: "6802",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6803",
    description:
      "Slate, worked; and articles of slate or of agglomerated slate",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680300",
    description:
      "Slate, worked; and articles of slate or of agglomerated slate",
    parent: "6803",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6804",
    description:
      "Millstones, grindstones, grinding wheels, etc without frameworks, for grinding, sharpening, polishing, etc and parts thereof, natural stone, agglomerated natural or artificial abrasives or of ceramics",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680410",
    description: "Millstones and grindstones; for milling, grinding or pulping",
    parent: "6804",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680421",
    description:
      "Millstones, grindstones, grinding wheels and the like; of agglomerated synthetic or natural diamond",
    parent: "6804",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680422",
    description:
      "Millstones, grindstones, grinding wheels and the like; of other agglomerated abrasives or of ceramics",
    parent: "6804",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680423",
    description:
      "Millstones, grindstones, grinding wheels and the like; of natural stone",
    parent: "6804",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680430",
    description:
      "Stones; hand sharpening or polishing stones, of natural stone, agglomerated natural or artificial abrasives or ceramics, with or without parts of other materials",
    parent: "6804",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6805",
    description:
      "Abrasive powder or grain; natural or artificial, on a base of textile material, of paper, paperboard or of other material, whether or not cut to shape or sewn or otherwise made up",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680510",
    description:
      "Abrasive powder or grain; natural or artificial, on a base of woven textile fabric only, whether or not cut to shape or sewn or otherwise made up",
    parent: "6805",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680520",
    description:
      "Abrasive powder or grain; natural or artificial, on a base of paper or paperboard only, whether or not cut to shape or sewn or otherwise made up",
    parent: "6805",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680530",
    description:
      "Abrasive powder or grain; natural or artificial, on a base of materials n.e.c. in heading no. 6805, whether or not cut to shape or sewn or otherwise made up",
    parent: "6805",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6806",
    description:
      "Slag, rock wool and similar mineral wools; exfoliated vermiculite, expanded clays, foamed slag, mixtures and articles of heat, sound insulating or sound-absorbing mineral materials",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680610",
    description:
      "Slag wool, rock wool and similar mineral wools (including intermixtures thereof), in bulk, sheets or rolls",
    parent: "6806",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680620",
    description:
      "Exfoliated vermiculite, expanded clays, foamed slag and similar expanded mineral materials (including intermixtures thereof)",
    parent: "6806",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680690",
    description:
      "Minerals; mixtures and articles of heat-insulating, sound-insulating or sound-absorbing mineral materials, other than those of heading no. 6811 or 6812 or of chapter 69",
    parent: "6806",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6807",
    description:
      "Asphalt or similar material; articles (e.g. petroleum bitumen or coal tar pitch)",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680710",
    description:
      "Asphalt or similar material; articles (e.g. petroleum bitumen or coal tar pitch) in rolls",
    parent: "6807",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680790",
    description:
      "Asphalt or similar material; articles (e.g. petroleum bitumen or coal tar pitch) other than in rolls",
    parent: "6807",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6808",
    description:
      "Panels, boards, tiles, blocks and the like; of vegetable fibre, of straw, shavings, chips, particles, sawdust or other waste, of wood, agglomerated with cement, plaster or other mineral binders",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680800",
    description:
      "Panels, boards, tiles, blocks and the like; of vegetable fibre, of straw, shavings, chips, particles, sawdust or other waste, of wood, agglomerated with cement, plaster or other mineral binders",
    parent: "6808",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6809",
    description: "Plaster or compositions based on plaster; articles thereof",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "680911",
    description:
      "Plaster, or plaster compositions; boards, sheets, panels, tiles and similar articles, faced or reinforced with paper or paperboard only, not ornamented",
    parent: "6809",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680919",
    description:
      "Plaster, or plaster compositions; boards, sheets, panels, tiles and similar articles, (other than faced or reinforced with paper or paperboard only), not ornamented",
    parent: "6809",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "680990",
    description:
      "Plaster articles or articles of compositions based on plaster; n.e.c. in heading no. 6809",
    parent: "6809",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6810",
    description:
      "Cement, concrete or artificial stone; whether or not reinforced, articles thereof",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "681011",
    description:
      "Cement, concrete or artificial stone; building blocks or bricks, whether or not reinforced",
    parent: "6810",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681019",
    description:
      "Cement, concrete or artificial stone; tiles, flagstones and similar, (excluding building blocks and bricks) whether or not reinforced",
    parent: "6810",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681091",
    description:
      "Cement, concrete or artificial stone; prefabricated structural components for building or civil engineering, whether or not reinforced",
    parent: "6810",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681099",
    description:
      "Cement, concrete or artificial stone; articles (other than prefabricated structural components for building or civil engineering), whether or not reinforced, n.e.c. in heading no. 6810",
    parent: "6810",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6811",
    description: "Asbestos-cement, of cellulose fibre-cement or the like",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "681140",
    description: "Asbestos-cement; articles or the like, containing asbestos",
    parent: "6811",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681181",
    description:
      "Cellulose fibre-cement; articles or the like; corrugated sheets, not containing asbestos",
    parent: "6811",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681182",
    description:
      "Cellulose fibre-cement; articles or the like, sheets, panels, tiles and similar articles (other than corrugated sheets), not containing asbestos",
    parent: "6811",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681189",
    description:
      "Cellulose fibre-cement; articles or the like, other than corrugated sheets and other sheets, panels, tiles and similar articles, not containing asbestos",
    parent: "6811",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6812",
    description:
      "Fabricated asbestos fibres; mixtures with a basis of asbestos or of asbestos and magnesium carbonate; articles of such mixtures or of asbestos (e.g. thread, woven fabric, clothing, footwear), whether or not reinforced, not goods of heading 6811 or 6813",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "681280",
    description:
      "Fabricated crocidolite (blue asbestos) fibres, mixtures with a basis of crocidolite (blue asbestos), articles of crocidolite (blue asbestos), whether or not reinforced, not goods of heading 6811 or 6813",
    parent: "6812",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681291",
    description:
      "Asbestos or mixtures with a basis of asbestos (other than crocidolite); clothing, clothing accessories, footwear and headgear, whether or not reinforced, not goods of heading 6811 or 6813",
    parent: "6812",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681299",
    description:
      "Asbestos or mixtures with a basis of asbestos (other than crocidolite); fibres, mixtures or articles n.e.c. in heading no. 6812, whether or not reinforced, not goods of heading 6811 or 6813",
    parent: "6812",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6813",
    description:
      "Friction material and articles thereof (e.g. sheets, rolls, strips, segments, discs, washers, pads) not mounted; for brakes, clutches or the like, with a basis of asbestos, other mineral substances, or cellulose",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "681320",
    description:
      "Friction material and articles thereof (e.g. sheets, rolls, strips, segments, discs, washers, pads) not mounted; for brakes, clutches or the like, with a basis of asbestos",
    parent: "6813",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681381",
    description:
      "Brake linings and pads; with a basis of mineral substances or cellulose (other than asbestos)",
    parent: "6813",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681389",
    description:
      "Friction material and articles thereof (e.g. sheets, rolls, strips, segments, discs, washers, pads) not mounted; for clutches or the like (not brake linings and pads), with a basis of mineral substances or cellulose (other than asbestos)",
    parent: "6813",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6814",
    description:
      "Mica; worked, articles of, including agglomerated or reconstituted mica; whether or not on a support of paper, paperboard or other materials",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "681410",
    description:
      "Mica; plates, sheets and strips of agglomerated or reconstituted mica, whether or not on a support of paper, paperboard or other materials",
    parent: "6814",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681490",
    description:
      "Mica; worked mica and articles of mica (excluding plates, sheets and strips) whether or not on a support of paper, paperboard or other materials",
    parent: "6814",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6815",
    description:
      "Stone or other mineral substances; articles thereof (including carbon fibres, articles of carbon fibres and articles of peat), not elsewhere specified or included",
    parent: "68",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "681511",
    description:
      "Stone or other mineral substances not elsewhere specified or included; carbon fibres for non-electrical uses",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681512",
    description:
      "Stone or other mineral substances not elsewhere specified or included; fabrics of carbon fibres for non-electrical uses",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681513",
    description:
      "Stone or other mineral substances not elsewhere specified or included; articles of carbon fibres for non-electrical uses",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681519",
    description:
      "Stone or other mineral substances not elsewhere specified or included; non-electrical articles of graphite or carbon n.e.c. in heading 6815",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681520",
    description: "Peat; articles of peat n.e.c. or included",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681591",
    description:
      "Stone articles and articles of other mineral substances; containing magnesite, magnesia in the form of periclase, dolomite including in the form of dolime, or chromite",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "681599",
    description:
      "Stone articles and articles of other mineral substances; n.e.c. or included in heading no. 6815",
    parent: "6815",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "69",
    description: "Ceramic products",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XIII",
    hscode: "6901",
    description:
      "Bricks, blocks, tiles and other ceramic goods of siliceous fossil meals (e.g. kieselguhr, tripolite or diatomite) or of similar siliceous earths",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690100",
    description:
      "Bricks, blocks, tiles and other ceramic goods of siliceous fossil meals (e.g. kieselguhr, tripolite or diatomite) or of similar siliceous earths",
    parent: "6901",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6902",
    description:
      "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; other than those of siliceous fossil meals or similar siliceous earths",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690210",
    description:
      "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; containing by weight, singly or together, more than 50% of the elements Mg, Ca or Cr, expressed as MgO, CaO or Cr2o3",
    parent: "6902",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690220",
    description:
      "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; containing by weight more than 50% of alumina (Al2o3), of silica (SiO2) or of a mixture or compound of these",
    parent: "6902",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690290",
    description:
      "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; n.e.c. in item no. 6902.1 or 6902.2",
    parent: "6902",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6903",
    description:
      "Ceramic goods; (e.g. retorts, crucibles, muffles, nozzles, plugs, supports cupels, tubes, pipes, sheaths, rods and slide gates) excluding those of siliceous fossil meals or of similar siliceous earths",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690310",
    description:
      "Refractory ceramic goods; containing, by weight, more than 50% of free carbon, excluding those of siliceous fossil meals or similar earths",
    parent: "6903",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690320",
    description:
      "Refractory ceramic goods; containing by weight more than 50% of alumina or of a mixture or compound of alumina and of silica, excluding those of siliceous fossil meals or similar earths",
    parent: "6903",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690390",
    description:
      "Refractory ceramic goods; composition of which n.e.c. in heading no. 6903, other than those of siliceous fossil meals or similar earths",
    parent: "6903",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6904",
    description:
      "Ceramic building bricks, floor blocks, support or filler tiles and the like",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690410",
    description: "Ceramic building bricks",
    parent: "6904",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690490",
    description:
      "Ceramic flooring blocks, supports or filler tiles and the like (excluding building bricks)",
    parent: "6904",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6905",
    description:
      "Roofing tiles, chimney-pots, cowls, chimney liners, architectural ornaments and other ceramic constructional goods",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690510",
    description: "Ceramic roofing tiles",
    parent: "6905",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690590",
    description:
      "Ceramic chimney-pots, cowls, chimney liners, architectural ornaments and other constructional goods (excluding roofing tiles)",
    parent: "6905",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6906",
    description: "Ceramic pipes, conduits, guttering and pipe fittings",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690600",
    description: "Ceramic pipes, conduits, guttering and pipe fittings",
    parent: "6906",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6907",
    description:
      "Ceramic flags and paving, hearth or wall tiles; ceramic mosaic cubes and the like, whether or not on a backing; finishing ceramics",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690721",
    description:
      "Ceramic tiles; flags and paving, hearth or wall tiles other than those of subheadings 6907.30 and 6907.40, of a water absorption coefficient by weight not over 0.5%",
    parent: "6907",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690722",
    description:
      "Ceramic tiles; flags and paving, hearth or wall tiles other than those of subheadings 6907.30 and 6907.40, of a water absorption coefficient by weight over 0.5% but not over 10%",
    parent: "6907",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690723",
    description:
      "Ceramic tiles; flags and paving, hearth or wall tiles other than those of subheadings 6907.30 and 6907.40, of a water absorption coefficient by weight over 10%",
    parent: "6907",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690730",
    description:
      "Mosaic cubes and the like, other than those of subheading 6907.40",
    parent: "6907",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690740",
    description: "Finishing ceramics",
    parent: "6907",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6909",
    description:
      "Ceramic ware for laboratory, chemical, other technical uses; ceramic troughs, tubs, similar receptacles used in agriculture; ceramic pots, jars and similar used in the conveyance or packing of goods",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "690911",
    description:
      "Ceramic wares; for laboratory, chemical or other technical uses, of porcelain or china",
    parent: "6909",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690912",
    description:
      "Ceramic wares; for laboratory, chemical or other technical uses, articles having a hardness equivalent to 9 or more on the Mohs scale",
    parent: "6909",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690919",
    description:
      "Ceramic wares; for laboratory, chemical or other technical uses, other than articles having a hardness equivalent to 9 or more on the Mohs scale or of porcelain or china",
    parent: "6909",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "690990",
    description:
      "Ceramic wares; pots, jars and similar articles of a kind used for the conveyance or packing of goods and ceramic troughs, tubs and similar receptacles used in agriculture",
    parent: "6909",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6910",
    description:
      "Ceramic sinks, wash basins, wash basin pedestals, baths, bidets, water closet pans, flushing cisterns, urinals and similar sanitary fixtures",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "691010",
    description:
      "Ceramic sinks, wash basins, wash basin pedestals, baths, bidets, water closet pans, flushing cisterns, urinals and similar sanitary fixtures; of porcelain or china",
    parent: "6910",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "691090",
    description:
      "Ceramic sinks, wash basins, wash basin pedestals, baths, bidets, water closet pans, flushing cisterns, urinals and similar sanitary fixtures; of other than porcelain or china",
    parent: "6910",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6911",
    description:
      "Tableware, kitchenware, other household articles and toilet articles; of porcelain or china",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "691110",
    description: "Tableware and kitchenware; of porcelain or china",
    parent: "6911",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "691190",
    description:
      "Household and toilet articles; n.e.c. in heading no. 6911, of porcelain or china",
    parent: "6911",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6912",
    description:
      "Ceramic tableware, kitchenware, other household articles and toilet articles; other than of porcelain or china",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "691200",
    description:
      "Ceramic tableware, kitchenware, other household articles and toilet articles; other than of porcelain or china",
    parent: "6912",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6913",
    description: "Statuettes and other ornamental ceramic articles",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "691310",
    description:
      "Ceramic statuettes and other ornamental ceramic articles, of porcelain or china",
    parent: "6913",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "691390",
    description:
      "Ceramic statuettes and other ornamental ceramic articles; other than of porcelain or china",
    parent: "6913",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "6914",
    description: "Ceramic articles; n.e.c. in chapter 69",
    parent: "69",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "691410",
    description: "Ceramic articles n.e.c. in chapter 69; of porcelain or china",
    parent: "6914",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "691490",
    description:
      "Ceramic articles n.e.c. in chapter 69; other than of porcelain or china",
    parent: "6914",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "70",
    description: "Glass and glassware",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XIII",
    hscode: "7001",
    description:
      "Glass; cullet and other waste and scrap of glass, excluding glass from cathode ray tubes or other activated glass of heading 85.49, glass in the mass",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700100",
    description:
      "Glass; cullet and other waste and scrap of glass, excluding glass from cathode ray tubes or other activated glass of heading 85.49, glass in the mass",
    parent: "7001",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7002",
    description:
      "Glass in balls (other than microspheres of heading no. 7018), rods or tubes, unworked",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700210",
    description:
      "Glass; unworked, in balls (other than microspheres of heading no. 7018)",
    parent: "7002",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700220",
    description: "Glass; unworked, in rods",
    parent: "7002",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700231",
    description:
      "Glass; unworked, in tubes, of fused quartz or other fused silica",
    parent: "7002",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700232",
    description:
      "Glass; unworked, tubes, of glass having a linear coefficient of expansion not exceeding 5 x 10 (to the minus 6), (or 0.000005) per Kelvin within a temperature range of 0-300 degrees C",
    parent: "7002",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700239",
    description:
      "Glass; unworked, in tubes, other than of glass having a linear coefficient of expansion not exceeding 5 x 10 (to the minus 6, (or 0.000005) ) per Kelvin within a temperature range of 0-300 degrees C, not fused quartz or other fused silica",
    parent: "7002",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7003",
    description:
      "Glass; cast glass and rolled glass in sheets or profiles, whether or not having an absorbent, reflecting or non-reflecting layer, but not otherwise worked",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700312",
    description:
      "Glass; cast glass and rolled glass, non-wired sheets, coloured through the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer",
    parent: "7003",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700319",
    description:
      "Glass; cast glass and rolled glass, non-wired sheets, (excluding those coloured throughout the mass (body tinted) opacified, flashed or having an absorbent or reflecting layer)",
    parent: "7003",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700320",
    description:
      "Glass; cast glass and rolled glass, wired sheets, whether or not having an absorbent or reflecting layer but not otherwise worked",
    parent: "7003",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700330",
    description:
      "Glass; cast glass and rolled glass, profiles, not otherwise worked",
    parent: "7003",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7004",
    description:
      "Glass; drawn glass and blown glass, in sheets, whether or not having an absorbent, reflecting or non-reflecting layer, but not otherwise worked",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700420",
    description:
      "Glass; drawn and blown, in sheets, coloured throughout the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer, but not otherwise worked",
    parent: "7004",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700490",
    description:
      "Glass; drawn and blown, in sheets, (other than glass coloured throughout the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer)",
    parent: "7004",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7005",
    description:
      "Glass; float glass and surface ground or polished glass, in sheets, whether or not having an absorbent, reflecting or non-reflecting layer, but not otherwise worked",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700510",
    description:
      "Glass; float glass and surface ground or polished glass, in sheets, non-wired, having an absorbent reflecting or non-reflecting layer",
    parent: "7005",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700521",
    description:
      "Glass; float glass and surface ground or polished glass, in sheets, non-wired, coloured throughout the mass (body tinted), opacified, flashed or merely surface ground",
    parent: "7005",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700529",
    description:
      "Glass; float glass and surface ground or polished glass, in sheets, non-wired, (other than coloured throughout the mass (body tinted), opacified, flashed or merely surface ground)",
    parent: "7005",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700530",
    description:
      "Glass; float glass and surface ground or polished glass, in sheets, wired glass, whether or not having an absorbent or reflecting layer",
    parent: "7005",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7006",
    description:
      "Glass of heading no. 7003, 7004 or 7005, bent, edge-worked, engraved, drilled, enamelled or otherwise worked, not framed or fitted with other materials",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700600",
    description:
      "Glass of heading no. 7003, 7004 or 7005; bent, edge-worked, engraved, drilled, enamelled or otherwise worked, but not framed or fitted with other materials",
    parent: "7006",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7007",
    description:
      "Safety glass, consisting of toughened (tempered) or laminated glass",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700711",
    description:
      "Glass; safety glass, toughened (tempered), of size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels",
    parent: "7007",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700719",
    description:
      "Glass; safety glass, toughened (tempered), (not of a size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels)",
    parent: "7007",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700721",
    description:
      "Glass; safety glass, laminated, of size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels",
    parent: "7007",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700729",
    description:
      "Glass; safety glass, laminated, (not of a size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels)",
    parent: "7007",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7008",
    description: "Glass; multiple-walled insulating units of glass",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700800",
    description: "Glass; multiple-walled insulating units of glass",
    parent: "7008",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7009",
    description:
      "Glass mirrors; whether or not framed, including rear-view mirrors",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "700910",
    description: "Glass; rear-view mirrors for vehicles",
    parent: "7009",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700991",
    description:
      "Glass mirrors; unframed, excluding rear-view mirrors for vehicles",
    parent: "7009",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "700992",
    description:
      "Glass mirrors; framed, excluding rear-view mirrors for vehicles",
    parent: "7009",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7010",
    description:
      "Carboys, bottles, flasks, jars, pots, phials, ampoules, containers of glass of a kind used for the conveyance or packing of goods; preserving jars of glass; stoppers, lids and other closures of glass",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701010",
    description:
      "Glass; ampoules, of a kind used for the conveyance or packing of goods",
    parent: "7010",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701020",
    description: "Glass; stoppers, lids and other closures",
    parent: "7010",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701090",
    description:
      "Glass; carboys, bottles, flasks, jars, pots, phials and other containers of glass, (not ampoules), used for the conveyance or packing of goods",
    parent: "7010",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7011",
    description:
      "Glass envelopes (including bulbs and tubes), open and glass parts thereof, without fittings, for electric lamps and light sources, cathode-ray tubes or the like",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701110",
    description:
      "Glass envelopes (including bulbs and tubes); open, and glass parts thereof, without fittings, for electric lighting",
    parent: "7011",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701120",
    description:
      "Glass envelopes (including bulbs and tubes); open, and glass parts thereof, without fittings, for cathode-ray tubes",
    parent: "7011",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701190",
    description:
      "Glass envelopes (including bulbs and tubes); open, and glass parts thereof, without fittings, other than for electric lighting and cathode-ray tubes",
    parent: "7011",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7013",
    description:
      "Glassware of a kind used for table, kitchen, toilet, office, indoor decoration or similar purposes (other than of heading no. 7010 or 7018)",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701310",
    description:
      "Glassware; of a kind used for table, kitchen, toilet, office, indoor decoration or similar purposes (other than of heading no. 7010 or 7018), of glass-ceramics",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701322",
    description: "Stemware drinking glasses, of lead crystal",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701328",
    description:
      "Stemware drinking glasses, other than of lead crystal or glass-ceramics",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701333",
    description: "Glassware; drinking glasses (not stemware), of lead crystal",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701337",
    description:
      "Glassware; drinking glasses (not stemware), other than of lead crystal or glass-ceramics",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701341",
    description:
      "Glassware of a kind used for table or kitchen purposes (not drinking glasses), of lead crystal",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701342",
    description:
      "Glassware of a kind used for table or kitchen purposes (not drinking glasses), of glass having a linear coefficient of expansion not exceeding 5 x 10 (to the minus 6), (or 0.000005) per Kelvin within a temperature range of 0-300 degrees C",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701349",
    description:
      "Glassware of a kind used for table or kitchen purposes (not drinking glasses or of glass-ceramics), of glass n.e.c. in item no. 7013.4",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701391",
    description: "Glassware; n.e.c. in heading no. 7013, of lead crystal",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701399",
    description:
      "Glassware; n.e.c. in heading no. 7013, other than of lead crystal",
    parent: "7013",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7014",
    description:
      "Signalling glassware and optical elements of glass (other than those of heading no. 7015), not optically worked",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701400",
    description: "Glassware; signalling, (not optically worked)",
    parent: "7014",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7015",
    description:
      "Clock, watch and similar glasses, glasses for non-corrective or corrective spectacles, curved, bent, hallowed etc, not optically worked; hollow glass spheres and their segments for manufacture",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701510",
    description:
      "Glasses for corrective spectacles; curved, bent, hollowed or the like, not optically worked",
    parent: "7015",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701590",
    description:
      "Glasses; clock or watch and similar, glasses for non-corrective spectacles, curved, bent, hollowed etc, (not optically worked), hollow glass spheres and segments, for the manufacture of such glasses",
    parent: "7015",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7016",
    description:
      "Glass; paving blocks, slabs, bricks, tiles etc, of pressed, moulded glass, whether or not wired, glass smallwares for decorative purposes leaded lights and the like; multicellular or foam glass",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701610",
    description:
      "Glass cubes and other glass smallwares; whether or not on a backing, for mosaics or similar decorative purposes",
    parent: "7016",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701690",
    description:
      "Multicellular or foam glass; in blocks, panels, plates, shells or similar forms; paving blocks, slabs, bricks and other articles of pressed or moulded glass",
    parent: "7016",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7017",
    description:
      "Laboratory, hygienic or pharmaceutical glassware, whether or not graduated or calibrated",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701710",
    description:
      "Glassware; laboratory, hygienic or pharmaceutical, whether or not graduated or calibrated, of fused quartz or other fused silica",
    parent: "7017",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701720",
    description:
      "Glassware; laboratory, hygienic or pharmaceutical, whether or not graduated or calibrated, having a linear co-efficient of expansion not over 5 x 10 (to the minus 6), (or 0.000005)) per Kelvin with a temperature of 0-300 degrees C",
    parent: "7017",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701790",
    description:
      "Glassware; laboratory, hygienic or pharmaceutical, whether or not graduated or calibrated, of glass n.e.c. in heading no. 7017",
    parent: "7017",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7018",
    description:
      "Glass beads, imitation pearls, precious or semi-precious stones and similar glass smallwares, statuettes and other ornaments of worked glass; glass microspheres not exceeding 1mm in diameter",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701810",
    description:
      "Glass; beads, imitation pearls, imitation precious or semi-precious stones and similar glass smallwares",
    parent: "7018",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701820",
    description: "Glass microspheres; not exceeding 1mm in diameter",
    parent: "7018",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701890",
    description:
      "Glass; articles thereof, statuettes and other ornaments of lamp worked glass, other than imitation jewellery",
    parent: "7018",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7019",
    description:
      "Glass fibres (including glass wool) and articles thereof (e.g. yarn, rovings, woven fabrics)",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "701911",
    description:
      "Glass fibres; (including glass wool), chopped strands, of a length of not more than 50mm",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701912",
    description: "Glass fibres; (including glass wool), rovings",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701913",
    description: "Glass fibres; (including glass wool), yarns and slivers",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701914",
    description:
      "Glass fibres; (including glass wool), mechanically bonded mats",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701915",
    description: "Glass fibres; (including glass wool), chemically bonded mats",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701919",
    description:
      "Glass fibres; (including glass wool), threads and mats, other than mechanically or chemically bonded mats",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701961",
    description:
      "Glass fibres; mechanically bonded fabrics and closed woven fabrics of rovings",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701962",
    description:
      "Glass fibres; non-woven mechanically bonded fabrics and closed fabrics of rovings",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701963",
    description:
      "Glass fibres; mechanically bonded fabrics and closed woven fabrics, plain weave, of yarns, not coated or laminated (other than rovings)",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701964",
    description:
      "Glass fibres; closed woven fabrics, plain weave, of yarns, coated or laminated, (other than rovings)",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701965",
    description:
      "Glass fibres; open woven fabrics of a width not exceeding 30cm",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701966",
    description: "Glass fibres; open woven fabrics of a width exceeding 30cm",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701969",
    description: "Glass fibres; fabrics n.e.c. in item no. 7019.6",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701971",
    description: "Glass fibres; chemically bonded fabrics",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701972",
    description:
      "Glass fibres; chemically bonded fabrics, closed fabrics n.e.c. in heading 7019",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701973",
    description:
      "Glass fibres; chemically bonded fabrics, open fabrics n.e.c. in heading 7019",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701980",
    description: "Glass fibres; glass wool and articles thereof",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "701990",
    description: "Glass fibres; n.e.c. in heading no. 7019",
    parent: "7019",
    level: "6",
  },
  {
    section: "XIII",
    hscode: "7020",
    description: "Glass; articles n.e.c. in chapter 70",
    parent: "70",
    level: "4",
  },
  {
    section: "XIII",
    hscode: "702000",
    description: "Glass; articles n.e.c. in chapter 70",
    parent: "7020",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "71",
    description:
      "Natural, cultured pearls; precious, semi-precious stones; precious metals, metals clad with precious metal, and articles thereof; imitation jewellery; coin",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XIV",
    hscode: "7101",
    description:
      "Pearls; natural or cultured, whether or not worked or graded but not strung, mounted or set; pearls, natural or cultured, temporarily strung for the convenience of transport",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710110",
    description:
      "Pearls; natural, whether or not worked or graded (but not strung, mounted or set), temporarily strung for the convenience of transport",
    parent: "7101",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710121",
    description:
      "Pearls; cultured, unworked, whether or not graded (but not strung, mounted or set), temporarily strung for the convenience of transport",
    parent: "7101",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710122",
    description:
      "Pearls; cultured, worked, whether or not graded (but not strung, mounted or set), temporarily strung for the convenience of transport",
    parent: "7101",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7102",
    description: "Diamonds, whether or not worked, but not mounted or set",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710210",
    description:
      "Diamonds; whether or not worked, but not mounted or set, unsorted",
    parent: "7102",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710221",
    description:
      "Diamonds; industrial, unworked or simply sawn, cleaved or bruted, but not mounted or set",
    parent: "7102",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710229",
    description:
      "Diamonds; industrial, (other than unworked or simply sawn, cleaved or bruted), but not mounted or set",
    parent: "7102",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710231",
    description:
      "Diamonds; non-industrial, unworked or simply sawn, cleaved or bruted, but not mounted or set",
    parent: "7102",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710239",
    description:
      "Diamonds; non-industrial, (other than unworked or simply sawn, cleaved or bruted), but not mounted or set",
    parent: "7102",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7103",
    description:
      "Precious (excluding diamond) and semi-precious stone; worked, graded, not strung, mounted, set; ungraded precious (excluding diamond) and semi-precious stone, temporarily strung for convenience of transport",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710310",
    description:
      "Stones; precious (other than diamonds) and semi-precious stones, unworked or simply sawn or roughly shaped, not strung, mounted or set",
    parent: "7103",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710391",
    description:
      "Stones; rubies, sapphires and emeralds, worked (other than simply sawn or roughly shaped), not strung, mounted or set",
    parent: "7103",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710399",
    description:
      "Stones; precious (other than diamonds) and semi-precious stones, (other than rubies, sapphires and emeralds), worked other than simply sawn or roughly shaped, not strung, mounted or set",
    parent: "7103",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7104",
    description:
      "Stones; synthetic or reconstructed precious or semi-precious, whether or not worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semi-precious stones, temporarily strung for convenience of transport",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710410",
    description:
      "Stones; piezo-electric quartz, whether or not worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semi-precious stones, temporarily strung for convenience of transport",
    parent: "7104",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710421",
    description: "Stones; diamonds, unworked or simply sawn or roughly shaped",
    parent: "7104",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710429",
    description:
      "Stones; synthetic or reconstructed precious or semi-precious n.e.c. in heading 7104, unworked or simply sawn or roughly shaped",
    parent: "7104",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710491",
    description:
      "Stones; diamonds, n.e.c. in heading 7104, worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semi-precious stones, temporarily strung for convenience of transport",
    parent: "7104",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710499",
    description:
      "Stones; synthetic or reconstructed precious or semi-precious n.e.c. in heading 7104, worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semi-precious stones, temporarily strung for convenience of transport",
    parent: "7104",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7105",
    description:
      "Dust and powder of natural or synthetic precious or semi-precious stone",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710510",
    description:
      "Stones; precious and semi-precious, dust and powder, of diamonds",
    parent: "7105",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710590",
    description:
      "Stones; precious and semi-precious, dust and powder, of natural or synthetic precious or semi-precious stones, excluding diamonds",
    parent: "7105",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7106",
    description:
      "Silver (including silver plated with gold or platinum); unwrought or in semi-manufactured forms, or in powder form",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710610",
    description: "Metals; silver powder",
    parent: "7106",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710691",
    description: "Metals; silver, unwrought, (but not powder)",
    parent: "7106",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710692",
    description: "Metals; silver, semi-manufactured",
    parent: "7106",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7107",
    description:
      "Base metals clad with silver; not further worked than semi-manufactured",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710700",
    description:
      "Base metals clad with silver; not further worked than semi-manufactured",
    parent: "7107",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7108",
    description:
      "Gold (including gold plated with platinum) unwrought or in semi-manufactured forms, or in powder form",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710811",
    description: "Metals; gold, non-monetary, powder",
    parent: "7108",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710812",
    description: "Metals; gold, non-monetary, unwrought (but not powder)",
    parent: "7108",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710813",
    description: "Metals; gold, semi-manufactured",
    parent: "7108",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "710820",
    description: "Gold, monetary",
    parent: "7108",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7109",
    description:
      "Base metals or silver, clad with gold, not further worked than semi-manufactured",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "710900",
    description:
      "Base metals or silver; clad with gold, not further worked than semi-manufactured",
    parent: "7109",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7110",
    description:
      "Platinum; unwrought or in semi-manufactured forms, or in powder form",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711011",
    description: "Metals; platinum, unwrought or in powder form",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711019",
    description: "Metals; platinum, semi-manufactured",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711021",
    description: "Metals; palladium, unwrought or in powder form",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711029",
    description: "Metals; palladium, semi-manufactured",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711031",
    description: "Metals; rhodium, unwrought or in powder form",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711039",
    description: "Metals; rhodium, semi-manufactured",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711041",
    description:
      "Metals; iridium, osmium, ruthenium, unwrought or in powder form",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711049",
    description: "Metals; iridium, osmium, ruthenium, semi-manufactured",
    parent: "7110",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7111",
    description:
      "Base metals, silver or gold, clad with platinum; not further worked than semi-manufactured",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711100",
    description:
      "Base metals, silver or gold, clad with platinum; not further worked than semi-manufactured",
    parent: "7111",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7112",
    description:
      "Waste and scrap of precious metal or of metal clad with precious metal; other waste and scrap containing precious metal compounds, of a kind uses principally for the recovery of precious metal other than goods of heading 85.49",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711230",
    description:
      "Waste and scrap of precious metal or of metal clad with precious metal; ash containing precious metal or precious metal compounds",
    parent: "7112",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711291",
    description:
      "Waste and scrap of precious metals; of gold, including metal clad with gold but excluding sweepings containing other precious metals",
    parent: "7112",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711292",
    description:
      "Waste and scrap of precious metals; of platinum, including metal clad with platinum but excluding sweepings containing other precious metals",
    parent: "7112",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711299",
    description:
      "Waste and scrap of precious metals; waste and scrap of precious metals including metal clad with precious metals, other than that of gold and platinum and excluding ash which contains precious metal or precious metal compounds",
    parent: "7112",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7113",
    description:
      "Jewellery articles and parts thereof, of precious metal or of metal clad with precious metal",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711311",
    description:
      "Jewellery; of silver, whether or not plated or clad with other precious metal, and parts thereof",
    parent: "7113",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711319",
    description:
      "Jewellery; of precious metal (excluding silver) whether or not plated or clad with precious metal, and parts thereof",
    parent: "7113",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711320",
    description:
      "Jewellery; of base metal clad with precious metal, and parts thereof",
    parent: "7113",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7114",
    description:
      "Articles of goldsmiths' or silversmiths' wares and parts thereof, of precious metal or of metal clad with precious metal",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711411",
    description:
      "Silversmiths' wares; and parts thereof, of silver, whether or not plated or clad with other precious metal",
    parent: "7114",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711419",
    description:
      "Goldsmiths' wares; articles of and parts thereof, of precious metal (excluding silver) whether or not plated or clad with precious metal",
    parent: "7114",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711420",
    description:
      "Goldsmiths' and silversmiths' wares; articles of and parts thereof, of base metal clad with precious metal",
    parent: "7114",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7115",
    description:
      "Articles of precious metal or of metal clad with precious metal",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711510",
    description:
      "Metal; catalysts in the form of wire cloth or grill, of platinum",
    parent: "7115",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711590",
    description:
      "Metal; precious or metal clad with precious metal, other than that of item no. 7115.10",
    parent: "7115",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7116",
    description:
      "Articles of natural or cultured pearls, precious or semi-precious stones (natural, synthetic or reconstructed)",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711610",
    description: "Pearls; articles of natural or cultured pearls",
    parent: "7116",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711620",
    description:
      "Stones; precious or semi-precious stones (natural, synthetic or reconstructed) articles of",
    parent: "7116",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7117",
    description: "Imitation jewellery",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711711",
    description:
      "Jewellery; imitation, cuff links and studs, of base metal, whether or not plated with precious metal",
    parent: "7117",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711719",
    description:
      "Jewellery; imitation, (excluding cuff links and studs), of base metal, whether or not plated with precious metal",
    parent: "7117",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711790",
    description:
      "Jewellery; imitation, of other than base metal, whether or not plated with precious metal",
    parent: "7117",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "7118",
    description: "Coin",
    parent: "71",
    level: "4",
  },
  {
    section: "XIV",
    hscode: "711810",
    description: "Coin (other than gold coin), not being legal tender",
    parent: "7118",
    level: "6",
  },
  {
    section: "XIV",
    hscode: "711890",
    description: "Coin; other than coin of item no. 7118.10",
    parent: "7118",
    level: "6",
  },
  {
    section: "XV",
    hscode: "72",
    description: "Iron and steel",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7201",
    description:
      "Pig iron and spiegeleisen in pigs, blocks or other primary forms",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720110",
    description:
      "Iron; non-alloy pig iron containing by weight 0.5% or less of phosphorus, in pigs, blocks or other primary forms",
    parent: "7201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720120",
    description:
      "Iron; non-alloy pig iron containing by weight more than 0.5% of phosphorus, in pigs, blocks or other primary forms",
    parent: "7201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720150",
    description:
      "Iron; alloy pig iron; spiegeleisen, in pigs, blocks or other primary forms",
    parent: "7201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7202",
    description: "Ferro-alloys",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720211",
    description:
      "Ferro-alloys; ferro-manganese, containing by weight more than 2% of carbon",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720219",
    description:
      "Ferro-alloys; ferro-manganese, containing by weight 2% or less of carbon",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720221",
    description:
      "Ferro-alloys; ferro-silicon, containing by weight more than 55% of silicon",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720229",
    description:
      "Ferro-alloys; ferro-silicon, containing by weight 55% or less of silicon",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720230",
    description: "Ferro-alloys; ferro-silico-manganese",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720241",
    description:
      "Ferro-alloys; ferro-chromium, containing by weight more than 4% of carbon",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720249",
    description:
      "Ferro-alloys; ferro-chromium, containing by weight 4% or less of carbon",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720250",
    description: "Ferro-alloys; ferro-silico-chromium",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720260",
    description: "Ferro-alloys; ferro-nickel",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720270",
    description: "Ferro-alloys; ferro-molybdenum",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720280",
    description: "Ferro-alloys; ferro-tungsten and ferro-silico-tungsten",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720291",
    description: "Ferro-alloys; ferro-titanium and ferro-silico-titanium",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720292",
    description: "Ferro-alloys; ferro-vanadium",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720293",
    description: "Ferro-alloys; ferro-niobium",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720299",
    description: "Ferro-alloys; n.e.c. in heading no. 7202",
    parent: "7202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7203",
    description:
      "Ferrous products obtained by direct reduction of iron ore and other spongy ferrous products, in lumps, pellets or the like; iron having a minimum purity of 99.94%, in lumps, pellets or similar forms",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720310",
    description:
      "Ferrous products; obtained by direct reduction of iron ore, in lumps, pellets or similar forms",
    parent: "7203",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720390",
    description:
      "Ferrous products; spongy ferrous products and iron having a minimum purity by weight of 99.94%, in lumps, pellets or similar forms",
    parent: "7203",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7204",
    description:
      "Ferrous waste and scrap; remelting scrap ingots of iron or steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720410",
    description: "Ferrous waste and scrap; of cast iron",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720421",
    description: "Ferrous waste and scrap; of stainless steel",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720429",
    description:
      "Ferrous waste and scrap; of alloy steel (excluding stainless)",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720430",
    description: "Ferrous waste and scrap; of tinned iron or steel",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720441",
    description:
      "Ferrous waste and scrap; turnings, shavings, chips, milling waste, sawdust, filings, trimmings and stampings, whether or not in bundles",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720449",
    description: "Ferrous waste and scrap; n.e.c. in heading no. 7204",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720450",
    description: "Ferrous products; remelting scrap ingots",
    parent: "7204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7205",
    description:
      "Granules and powders, of pig iron, spiegeleisen, iron or steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720510",
    description: "Iron or steel, pig iron, spiegeleisen; granules thereof",
    parent: "7205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720521",
    description: "Alloy steel powders",
    parent: "7205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720529",
    description:
      "Iron or steel, pig iron, spiegeleisen; powders (excluding alloy steel)",
    parent: "7205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7206",
    description:
      "Iron and non-alloy steel in ingots or other primary forms (excluding iron of heading no. 7203)",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720610",
    description:
      "Iron or non-alloy steel; ingots (excluding iron of heading no. 7203)",
    parent: "7206",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720690",
    description:
      "Iron or non-alloy steel; primary forms (excluding ingots and iron of heading no. 7203)",
    parent: "7206",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7207",
    description: "Iron or non-alloy steel; semi-finished products thereof",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720711",
    description:
      "Iron or non-alloy steel; semi-finished products of iron or non-alloy steel; containing by weight less than 0.25% of carbon, of rectangular (including square) cross-section, width less than twice thickness",
    parent: "7207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720712",
    description:
      "Iron or non-alloy steel; semi-finished products of iron or non-alloy steel; containing by weight less than 0.25% of carbon, of rectangular (other than square) cross-section",
    parent: "7207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720719",
    description:
      "Iron or non-alloy steel; semi-finished products of iron or non-alloy steel, containing by weight less than 0.25% of carbon, other than rectangular or square cross-section",
    parent: "7207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720720",
    description:
      "Iron or non-alloy steel; semi-finished products of iron or non-alloy steel, containing by weight 0.25% or more of carbon",
    parent: "7207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7208",
    description:
      "Iron or non-alloy steel; flat-rolled products of a width of 600mm or more, hot-rolled, not clad, plated or coated",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720810",
    description:
      "Iron or non-alloy steel; in coils, flat-rolled, of a width 600mm or more, hot-rolled, with patterns in relief",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720825",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, pickled, of a thickness of 4.75mm or more",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720826",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, pickled, of a thickness of 3mm or more but less than 4.75mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720827",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, pickled, of a thickness of less than 3mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720836",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness exceeding 10mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720837",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness of 4.75mm or more but not exceeding 10mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720838",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness of 3mm or more but less than 4.75mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720839",
    description:
      "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness of less than 3mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720840",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, with patterns in relief",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720851",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness exceeding 10mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720852",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness of 4.75mm or more but not exceeding 10mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720853",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness of 3mm or more but less than 4.75mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720854",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness of less than 3mm",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720890",
    description:
      "Iron or non-alloy steel; flat-rolled, hot-rolled, of a width 600mm or more, n.e.c. in heading no. 7208",
    parent: "7208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7209",
    description:
      "Iron or non-alloy steel; flat-rolled products, width 600mm or more, cold-rolled (cold-reduced), not clad, plated or coated",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "720915",
    description:
      "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness of 3mm or more",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720916",
    description:
      "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness exceeding 1mm but less than 3mm",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720917",
    description:
      "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness of 0.5mm or more but not exceeding 1mm",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720918",
    description:
      "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness of less than 0.5mm",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720925",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness of 3mm or more",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720926",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness exceeding 1mm but less than 3mm",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720927",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness of 0.5mm or more but not exceeding 1mm",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720928",
    description:
      "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness of less than 0.5mm",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "720990",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, cold-rolled, n.e.c. in heading no. 7209",
    parent: "7209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7210",
    description:
      "Iron or non-alloy steel; flat-rolled products, width 600mm or more, clad, plated or coated",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721011",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with tin, thickness of 0.5mm or more",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721012",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with tin, thickness of less than 0.5mm",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721020",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with lead, including terne-plate",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721030",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, electrolytically plated or coated with zinc",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721041",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, corrugated, plated or coated with zinc (not electrolytically)",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721049",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, (not corrugated), plated or coated with zinc (not electrolytically)",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721050",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with chromium oxides or with chromium and chromium oxides",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721061",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with aluminium zinc-alloys",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721069",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with aluminium, other than plated or coated with aluminium zinc-alloys",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721070",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, painted, varnished or coated with plastics",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721090",
    description:
      "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with materials n.e.c. in heading no. 7210",
    parent: "7210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7211",
    description:
      "Iron or non-alloy steel; flat-rolled products, width less than 600mm, not clad, plated or coated",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721113",
    description:
      "Iron or non-alloy steel; flat-rolled, hot-rolled, rolled on four faces or in a closed box pass, of a width more than 150mm but less than 600mm, 4mm thick or more, not in coils, without patterns in relief",
    parent: "7211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721114",
    description:
      "Iron or non-alloy steel; flat-rolled, hot-rolled, of a width less than 600mm, 4.75mm thick or more, excluding those of item no. 7211.13",
    parent: "7211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721119",
    description:
      "Iron or non-alloy steel; flat-rolled, hot-rolled, of a width less than 600mm, less than 4.75mm thick, excluding those of item no. 7211.13",
    parent: "7211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721123",
    description:
      "Iron or non-alloy steel; flat-rolled, cold-rolled, of a width less than 600mm, containing by weight less than 0.25% of carbon",
    parent: "7211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721129",
    description:
      "Iron or non-alloy steel; flat-rolled, cold-rolled, of a width less than 600mm, containing by weight 0.25% or more of carbon",
    parent: "7211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721190",
    description:
      "Iron or non-alloy steel; flat-rolled, n.e.c. in heading no. 7211, width less than 600mm",
    parent: "7211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7212",
    description:
      "Iron or non-alloy steel; flat-rolled products, width less than 600mm, clad, plated or coated",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721210",
    description:
      "Iron or non-alloy steel; flat-rolled, width less than 600mm, plated or coated with tin",
    parent: "7212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721220",
    description:
      "Iron or non-alloy steel; flat-rolled, of a width less than 600mm, electrolytically plated or coated with zinc",
    parent: "7212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721230",
    description:
      "Iron or non-alloy steel; flat-rolled, width less than 600mm, plated or coated with zinc (not electrolytically)",
    parent: "7212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721240",
    description:
      "Iron or non-alloy steel; flat-rolled, width less than 600mm, painted, varnished or coated with plastics",
    parent: "7212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721250",
    description:
      "Iron or non-alloy steel; flat-rolled, width less than 600mm, plated or coated, (excluding tin, zinc or plastic)",
    parent: "7212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721260",
    description:
      "Iron or non-alloy steel; flat-rolled, width less than 600mm, clad",
    parent: "7212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7213",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721310",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing indentations, ribs, grooves or other deformations produced during the rolling process",
    parent: "7213",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721320",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, of free-cutting steel",
    parent: "7213",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721391",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, n.e.c. in heading no. 7213, of circular cross-section measuring less than 14mm in diameter",
    parent: "7213",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721399",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, n.e.c. in heading no. 7213, of circular cross-section measuring 14mm or more in diameter",
    parent: "7213",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7214",
    description:
      "Iron or non-alloy steel; bars and rods, not further worked than forged, hot-rolled, hot drawn or hot-extruded, but including those twisted after rolling",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721410",
    description:
      "Iron or non-alloy steel; bars and rods, forged, hot-rolled, hot-drawn or hot-extruded, but including those twisted after rolling",
    parent: "7214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721420",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, containing indentations, ribs, grooves or other deformations produced during the rolling process or twisted after rolling",
    parent: "7214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721430",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, including those twisted after rolling, of free-cutting steel",
    parent: "7214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721491",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, n.e.c. in heading no. 7214, of rectangular (other than square) cross-section",
    parent: "7214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721499",
    description:
      "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, n.e.c. in heading no. 7214, other than of rectangular cross-section",
    parent: "7214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7215",
    description: "Iron or non-alloy steel; bars and rods, n.e.c. in chapter 72",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721510",
    description:
      "Iron or non-alloy steel; bars and rods, of free-cutting steel, cold-formed or cold-finished, n.e.c. in chapter 72",
    parent: "7215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721550",
    description:
      "Iron or non-alloy steel; bars and rods, n.e.c. in chapter 72, cold-formed or cold-finished, (not free-cutting)",
    parent: "7215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721590",
    description:
      "Iron or non-alloy steel; bars and rods, n.e.c. in chapter 72, n.e.c. in heading no. 7215",
    parent: "7215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7216",
    description: "Iron or non-alloy steel, angles, shapes and sections",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721610",
    description:
      "Iron or non-alloy steel; U, I or H sections, hot-rolled, hot-drawn or extruded, of a height of less than 80mm",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721621",
    description:
      "Iron or non-alloy steel; L sections, hot-rolled, hot-drawn or extruded, of a height of less than 80mm",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721622",
    description:
      "Iron or non-alloy steel; T sections, hot-rolled, hot-drawn or extruded, of a height less than 80mm",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721631",
    description:
      "Iron or non-alloy steel; U sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721632",
    description:
      "Iron or non-alloy steel; I sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721633",
    description:
      "Iron or non-alloy steel; H sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721640",
    description:
      "Iron or non-alloy steel; L or T sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721650",
    description:
      "Iron or non-alloy steel; angles, shapes and sections, n.e.c. in heading no. 7216, hot-rolled, hot-drawn or extruded",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721661",
    description:
      "Iron or non-alloy steel; angles, shapes and sections, cold-formed or cold-finished, obtained from flat-rolled products",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721669",
    description:
      "Iron or non-alloy steel; angles, shapes and sections, cold-formed or cold-finished, (not obtained from flat-rolled products)",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721691",
    description:
      "Iron or non-alloy steel; angles, shapes and sections, n.e.c. in heading no. 7216, cold-formed or cold-finished, from flat-rolled products",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721699",
    description:
      "Iron or non-alloy steel; angles, shapes and sections, n.e.c. in heading no. 7216",
    parent: "7216",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7217",
    description: "Wire of iron or non-alloy steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721710",
    description:
      "Iron or non-alloy steel; wire, (not plated or coated), whether or not polished",
    parent: "7217",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721720",
    description: "Iron or non-alloy steel; wire, plated or coated with zinc",
    parent: "7217",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721730",
    description:
      "Iron or non-alloy steel; wire, plated or coated with base metals (other than zinc)",
    parent: "7217",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721790",
    description: "Iron or non-alloy steel; wire, n.e.c. in heading no. 7217",
    parent: "7217",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7218",
    description:
      "Stainless steel in ingots or other primary forms; semi-finished products of stainless steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721810",
    description: "Steel, stainless; ingots and other primary forms",
    parent: "7218",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721891",
    description:
      "Steel, stainless; semi-finished products, of rectangular (other than square) cross-section",
    parent: "7218",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721899",
    description:
      "Steel, stainless; semi-finished products, other than of rectangular cross-section",
    parent: "7218",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7219",
    description:
      "Stainless steel; flat-rolled products of width of 600mm or more",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "721911",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness exceeding 10mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721912",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness of 4.75mm or more but not exceeding 10mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721913",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness of 3mm or more but less than 4.75mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721914",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness of less than 3mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721921",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness exceeding 10mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721922",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness of 4.75mm or more but not exceeding 10mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721923",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness of 3mm or more but less than 4.75mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721924",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness of less than 3mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721931",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled or cold-reduced, of a thickness of 4.75mm or more",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721932",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness of 3mm or more but less than 4.75mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721933",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness exceeding 1mm but less than 3mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721934",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness of 0.5mm or more but not exceeding 1mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721935",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness of less than 0.5mm",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "721990",
    description:
      "Steel, stainless; flat-rolled, width 600mm or more, n.e.c. in heading no. 7219",
    parent: "7219",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7220",
    description:
      "Stainless steel; flat-rolled products of width less than 600mm",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722011",
    description:
      "Steel, stainless; flat-rolled, width less than 600mm, hot-rolled, of a thickness of 4.75mm or more",
    parent: "7220",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722012",
    description:
      "Steel, stainless; flat-rolled, width less than 600mm, hot-rolled, of a thickness of less than 4.75mm",
    parent: "7220",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722020",
    description:
      "Steel, stainless; flat-rolled, width less than 600mm, cold-rolled",
    parent: "7220",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722090",
    description:
      "Steel, stainless; flat-rolled, width less than 600mm, n.e.c. in heading no 7220",
    parent: "7220",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7221",
    description:
      "Stainless steel bars and rods, hot-rolled, in irregularly wound coils",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722100",
    description:
      "Steel, stainless; bars and rods, hot-rolled, in irregularly wound coils",
    parent: "7221",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7222",
    description: "Stainless steel bars and rods, angles, shapes and sections",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722211",
    description:
      "Steel, stainless; bars and rods, hot-rolled, hot-drawn or extruded, of circular cross-section",
    parent: "7222",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722219",
    description:
      "Steel, stainless; bars and rods, hot-rolled, hot-drawn or extruded, other than of circular cross-section",
    parent: "7222",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722220",
    description:
      "Steel, stainless; bars and rods, cold-formed or cold-finished",
    parent: "7222",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722230",
    description: "Steel, stainless; bars and rods, n.e.c. in heading no. 7222",
    parent: "7222",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722240",
    description: "Steel, stainless; angles, shapes and sections",
    parent: "7222",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7223",
    description: "Stainless steel wire",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722300",
    description: "Steel, stainless; wire",
    parent: "7223",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7224",
    description:
      "Alloy steel in ingots or other primary forms, semi-finished products of other alloy steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722410",
    description: "Steel, alloy; ingots and other primary forms",
    parent: "7224",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722490",
    description: "Steel, alloy; semi-finished products",
    parent: "7224",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7225",
    description: "Alloy steel flat-rolled products, of a width 600mm or more",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722511",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, of silicon-electrical steel, grain-oriented",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722519",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, of silicon-electrical steel, (other than grain-oriented)",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722530",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, hot-rolled, in coils",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722540",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, hot-rolled, not in coils",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722550",
    description: "Steel, alloy; flat-rolled, width 600mm or more, cold-rolled",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722591",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, n.e.c. in heading no. 7225, electrolytically plated or coated with zinc",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722592",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, n.e.c. in heading no. 7225, plated or coated with zinc (other than electrolytically)",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722599",
    description:
      "Steel, alloy; flat-rolled, width 600mm or more, n.e.c. in heading no. 7225, (other than plated or coated with zinc)",
    parent: "7225",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7226",
    description:
      "Alloy steel flat-rolled products, of a width of less than 600mm",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722611",
    description:
      "Steel, alloy; flat-rolled, width less than 600mm, of silicon-electrical steel, grain-oriented",
    parent: "7226",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722619",
    description:
      "Steel, alloy; flat-rolled, width less than 600mm, of silicon-electrical steel, other than grain-oriented",
    parent: "7226",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722620",
    description:
      "Steel, alloy; flat-rolled, width less than 600mm, of high speed steel",
    parent: "7226",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722691",
    description:
      "Steel, alloy; flat-rolled, width less than 600mm, (excluding silicon-electrical or high speed steel), hot-rolled",
    parent: "7226",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722692",
    description:
      "Steel, alloy; flat-rolled, width less than 600mm, (excluding silicon-electrical or high speed steel), cold-rolled",
    parent: "7226",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722699",
    description:
      "Steel, alloy; flat-rolled, width less than 600mm, n.e.c. in item no. 7226.9",
    parent: "7226",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7227",
    description:
      "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722710",
    description:
      "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils, of high speed steel",
    parent: "7227",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722720",
    description:
      "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils, of silico-manganese steel",
    parent: "7227",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722790",
    description:
      "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils, n.e.c. in heading no. 7227",
    parent: "7227",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7228",
    description:
      "Alloy steel bars, rods, shapes and sections; hollow drill bars and rods, of alloy or non-alloy steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722810",
    description: "Steel, alloy; bars and rods, of high speed steel",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722820",
    description: "Steel, alloy; bars and rods, of silico-manganese steel",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722830",
    description:
      "Steel, alloy; bars and rods, hot-rolled, hot-drawn or extruded",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722840",
    description: "Steel, alloy; bars and rods, forged",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722850",
    description: "Steel, alloy; bars and rods, cold-formed or cold-finished",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722860",
    description: "Steel, alloy; bars and rods n.e.c. in heading no. 7228",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722870",
    description: "Steel, alloy; angles, shapes and sections",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722880",
    description: "Steel, alloy or non-alloy; hollow drill bars and rods",
    parent: "7228",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7229",
    description: "Wire of other alloy steel",
    parent: "72",
    level: "4",
  },
  {
    section: "XV",
    hscode: "722920",
    description: "Steel, alloy; wire, of silico-manganese steel",
    parent: "7229",
    level: "6",
  },
  {
    section: "XV",
    hscode: "722990",
    description:
      "Steel, alloy; wire, of materials other than silico-manganese steel",
    parent: "7229",
    level: "6",
  },
  {
    section: "XV",
    hscode: "73",
    description: "Iron or steel articles",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7301",
    description:
      "Iron or steel sheet piling, whether or not drilled, punched or made from assembled elements; welded angles, shapes and sections, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730110",
    description:
      "Iron or steel; sheet piling, whether or not drilled, punched or made from assembled elements",
    parent: "7301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730120",
    description: "Iron or steel; angles, shapes and sections, welded",
    parent: "7301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7302",
    description:
      "Railway or tramway track constructions of iron or steel; rails, check and track rails, switch blades, crossing frogs, point rods, sleepers, fish-plates, chair wedges, sole plates, bedplates, ties and the like",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730210",
    description:
      "Iron or steel, railway or tramway track construction material; rails",
    parent: "7302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730230",
    description:
      "Iron or steel, railway or tramway track construction material; switch blades, crossing frogs, point rods and other crossing pieces",
    parent: "7302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730240",
    description:
      "Iron or steel, railway or tramway track construction material; fish-plates and sole plates",
    parent: "7302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730290",
    description:
      "Iron or steel, railway or tramway track construction material; n.e.c. in heading no. 7302",
    parent: "7302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7303",
    description: "Tubes, pipes and hollow profiles, of cast iron",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730300",
    description: "Cast iron; tubes, pipes and hollow profiles",
    parent: "7303",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7304",
    description:
      "Tubes, pipes and hollow profiles, seamless, of iron (other than cast iron) or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730411",
    description:
      "Iron or steel (excluding cast iron); seamless, line pipe of a kind used for oil or gas pipelines, of stainless steel",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730419",
    description:
      "Iron or steel (excluding cast iron or stainless steel); seamless, line pipe of a kind used for oil or gas pipelines",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730422",
    description:
      "Steel, stainless; seamless, drill pipe, of a kind used in drilling for oil or gas",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730423",
    description:
      "Iron or steel (excluding cast iron or stainless steel); seamless, drill pipe, of a kind used in drilling for oil or gas",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730424",
    description:
      "Steel, stainless; seamless, casing and tubing, of a kind used in drilling for oil or gas",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730429",
    description:
      "Iron or steel (excluding cast iron or stainless steel); seamless, casing and tubing, of a kind used in drilling for oil or gas",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730431",
    description:
      "Iron or non-alloy steel (excluding cast iron); seamless, cold-drawn or cold-rolled, tubes, pipes and hollow profiles of circular cross-section",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730439",
    description:
      "Iron or non-alloy steel (excluding cast iron); seamless, (excluding cold-drawn or cold-rolled), tubes, pipes and hollow profiles of circular cross-section",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730441",
    description:
      "Steel, stainless; cold-drawn or cold-rolled (cold-reduced), tubes and pipes of circular cross-section",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730449",
    description:
      "Steel, stainless; (excluding cold-drawn or cold-rolled), tubes pipes and hollow profiles of circular cross-section",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730451",
    description:
      "Steel, alloy (not stainless steel); seamless, cold-drawn or cold-rolled (cold-reduced), tubes, pipes and hollow profiles of circular cross-section",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730459",
    description:
      "Steel, alloy (not stainless steel); (excluding cold-drawn or cold-rolled), tubes, pipes and hollow profiles of circular cross-section",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730490",
    description:
      "Iron or steel (excluding cast iron); seamless, tubes, pipes and hollow profiles, seamless, n.e.c. in heading no. 7304",
    parent: "7304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7305",
    description:
      "Iron or steel (excluding cast iron); tubes and pipes (e.g. welded, riveted or similarly closed), having circular cross-sections, external diameter of which exceeds 406.4mm, not seamless",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730511",
    description:
      "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (not seamless), longitudinally submerged arc welded, having circular cross-sections, external diameter exceeds 406.4mm",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730512",
    description:
      "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (not seamless), longitudinally welded (not submerged arc welded), having circular cross-sections, external diameter exceeds 406.4mm",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730519",
    description:
      "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (not seamless), (not longitudinally welded), having circular cross-sections, external diameter exceeds 406.4mm",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730520",
    description:
      "Iron or steel (excluding cast iron); casing of a kind used in drilling for oil or gas (not seamless), having circular cross-sections, external diameter exceeds 406.4mm",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730531",
    description:
      "Iron or steel (excluding cast iron); tubes and pipes (other than line pipe or casing of a kind used for oil or gas pipelines), longitudinally welded, having circular cross-sections, external diameter exceeds 406.4mm, (not seamless)",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730539",
    description:
      "Iron or steel (excluding cast iron); tubes and pipes (other than line pipe or casing of a kind used for oil or gas pipelines), welded (not longitudinally welded), having circular cross-sections, external diameter exceeds 406.4mm, (not seamless)",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730590",
    description:
      "Iron or steel (excluding cast iron); tubes and pipes n.e.c. in heading no. 7305, having circular cross-sections, external diameter exceeds 406.4mm, (not seamless)",
    parent: "7305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7306",
    description:
      "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), n.e.c. in chapter 73",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730611",
    description:
      "Steel; stainless; line pipe of a kind used for oil or gas pipelines n.e.c. in chapter 73, welded, (not seamless)",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730619",
    description:
      "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (other than of stainless steel or seamless), n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730621",
    description:
      "Steel, stainless; casing and tubing of a kind used in drilling for oil and gas, n.e.c. in chapter 73, welded, (not seamless)",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730629",
    description:
      "Iron or steel (excluding cast iron); casing and tubing of a kind used in drilling for oil and gas (other than stainless steel or seamless), n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730630",
    description:
      "Iron or non-alloy steel (excluding cast iron); tubes and pipes (not seamless), welded, of circular cross-section, n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730640",
    description:
      "Steel, stainless; tubes, pipes and hollow profiles, welded, of circular cross-section, n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730650",
    description:
      "Steel, alloy; tubes, pipes and hollow profiles (other than stainless steel or seamless), welded, of circular cross-section, n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730661",
    description:
      "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), welded, of square or rectangular cross-section, n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730669",
    description:
      "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), n.e.c. in chapter 73, welded, of non-circular cross-section (not square or rectangular cross-section)",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730690",
    description:
      "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), n.e.c. in chapter 73",
    parent: "7306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7307",
    description:
      "Tube or pipe fittings (e.g. couplings, elbows, sleeves), of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730711",
    description: "Cast iron; cast fittings, of non-malleable cast iron",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730719",
    description:
      "Iron or steel; cast fittings, other than of non-malleable cast iron",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730721",
    description:
      "Steel, stainless; tube or pipe fittings, flanges, of stainless steel",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730722",
    description:
      "Steel, stainless; tube or pipe fittings, threaded elbows, bends and sleeves",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730723",
    description:
      "Steel, stainless; tube or pipe fittings, butt welding fittings",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730729",
    description:
      "Steel, stainless; tube or pipe fittings, n.e.c. in item no. 7307.2",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730791",
    description:
      "Iron or steel; tube or pipe fittings, flanges, other than stainless steel",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730792",
    description:
      "Iron or steel; tube or pipe fittings, threaded elbows, bends and sleeves, other than stainless steel",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730793",
    description:
      "Iron or steel; tube or pipe fittings, butt welding fittings, other than stainless steel",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730799",
    description:
      "Iron or steel; tube or pipe fittings, n.e.c. in item no. 7307.9, other than stainless steel",
    parent: "7307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7308",
    description:
      "Structures of iron or steel and parts thereof; plates, rods, angles, shapes, sections, tubes and the like, prepared for use in structures",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730810",
    description:
      "Iron or steel; structures and parts thereof, bridges and bridge-sections",
    parent: "7308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730820",
    description:
      "Iron or steel; structures and parts thereof, towers and lattice masts",
    parent: "7308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730830",
    description:
      "Iron or steel; structures and parts thereof, doors, windows and their frames and thresholds for doors",
    parent: "7308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730840",
    description:
      "Iron or steel; structures and parts thereof, props and similar equipment for scaffolding, shuttering or pit-propping",
    parent: "7308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "730890",
    description:
      "Iron or steel; structures and parts thereof, n.e.c. in heading 7308",
    parent: "7308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7309",
    description:
      "Reservoirs, tanks, vats and similar containers; for any material (excluding compressed or liquefied gas), of iron or steel, capacity exceeding 300l, whether or not lined or heat insulated",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "730900",
    description:
      "Reservoirs, tanks, vats and similar containers; for any material (excluding compressed or liquefied gas), of iron or steel, capacity exceeding 300l, whether or not lined or heat insulated",
    parent: "7309",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7310",
    description:
      "Tanks, casks, drums, cans, boxes and similar containers, for any material (excluding compressed or liquefied gas), of iron or steel, capacity not exceeding 300l, whether or not lined or heat-insulated",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731010",
    description:
      "Tanks, casks, drums, cans, boxes and similar containers, for any material (excluding compressed or liquefied gas), 50l or more capacity but not exceeding 300l",
    parent: "7310",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731021",
    description:
      "Cans; which are to be closed by soldering or crimping, for any material (excluding compressed or liquefied gas), less than 50l capacity, of iron or steel",
    parent: "7310",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731029",
    description:
      "Tanks, casks, drums, boxes and similar containers for any material (excluding compressed or liquefied gas) less than 50l capacity, n.e.c. in item no. 7310.2, of iron or steel",
    parent: "7310",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7311",
    description: "Containers for compressed or liquefied gas, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731100",
    description: "Containers for compressed or liquefied gas, of iron or steel",
    parent: "7311",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7312",
    description:
      "Stranded wire, ropes, cables, plaited bands, slings and the like, of iron or steel, not electrically insulated",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731210",
    description:
      "Iron or steel; stranded wire, ropes and cables, not electrically insulated",
    parent: "7312",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731290",
    description:
      "Iron or steel; plaited bands, slings and the like, not electrically insulated",
    parent: "7312",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7313",
    description:
      "Barbed wire of iron or steel; twisted hoop or single flat wire, barbed or not and loosely twisted double wire, of a kind used for fencing, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731300",
    description:
      "Iron of steel; barbed wire, twisted hoop or single flat wire and loosely twisted double wire, used for fencing",
    parent: "7313",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7314",
    description:
      "Cloth (including endless bands), grill, netting and fencing, of iron or steel wire; expanded metal of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731412",
    description:
      "Iron or steel; woven cloth, endless bands for machinery, of stainless steel",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731414",
    description:
      "Iron or steel; woven cloth, of stainless steel, (other than endless bands for machinery)",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731419",
    description: "Iron or steel; woven cloth, other than of stainless steel",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731420",
    description:
      "Iron or steel wire; grill, netting and fencing, welded at intersections, of wire with a maximum cross-sectional dimension of 3mm or more and mesh size 100cm2 or more",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731431",
    description:
      "Iron or steel wire; grill, netting and fencing, welded at the intersection, n.e.c. in item no. 7314.20, plated or coated with zinc",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731439",
    description:
      "Iron or steel wire; grill, netting and fencing, welded at the intersection, n.e.c. in item no. 7314.20, (other than plated or coated with zinc)",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731441",
    description:
      "Iron or steel wire; grill, netting and fencing, plated or coated with zinc",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731442",
    description:
      "Iron or steel wire; grill, netting and fencing, coated with plastic",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731449",
    description:
      "Iron or steel wire; grill, netting and fencing, coated with materials other than zinc or plastic",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731450",
    description: "Iron or steel; expanded metal",
    parent: "7314",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7315",
    description: "Chain and parts thereof, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731511",
    description: "Chain; articulated link, roller, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731512",
    description:
      "Chain; articulated link, (other than roller), of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731519",
    description: "Chain; articulated link parts, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731520",
    description:
      "Chain; skid, articulated link chain and parts thereof, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731581",
    description: "Chain; stud-link chain, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731582",
    description: "Chain; welded link chain, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731589",
    description: "Chain; n.e.c. in heading no. 7315, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731590",
    description: "Chain; parts n.e.c. in heading no. 7315, of iron or steel",
    parent: "7315",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7316",
    description: "Anchors, grapnels and parts thereof, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731600",
    description: "Iron or steel; anchors, grapnels and parts thereof",
    parent: "7316",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7317",
    description:
      "Nails, tacks, drawing pins, corrugated nails, staples (not those of heading no. 8305) and the like, of iron or steel, with heads of other material or not, but excluding articles with heads of copper",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731700",
    description:
      "Iron or steel; nails, tacks, drawing pins, corrugated nails, staples (not those of heading no. 8305) and the like, with heads of other material or not, but excluding articles with heads of copper",
    parent: "7317",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7318",
    description:
      "Screws, bolts, nuts, coach screws, screw hooks, rivets, cotters, cotter-pins, washers (including spring washers) and similar articles, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731811",
    description: "Iron or steel; threaded coach screws",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731812",
    description: "Iron or steel; threaded wood screws other than coach screws",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731813",
    description: "Iron or steel; threaded screw hooks and screw rings",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731814",
    description: "Iron or steel; threaded self-tapping screws",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731815",
    description:
      "Iron or steel; threaded screws and bolts n.e.c. in item no. 7318.1, whether or not with their nuts or washers",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731816",
    description: "Iron or steel; threaded nuts",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731819",
    description:
      "Iron or steel; threaded screws, bolts and nuts n.e.c. in item no. 7318.1",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731821",
    description:
      "Iron or steel; non-threaded spring washers and other lock washers",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731822",
    description:
      "Iron or steel; non-threaded washers, excluding spring and lock",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731823",
    description: "Iron or steel; non-threaded rivets",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731824",
    description: "Iron or steel; non-threaded cotters and cotter-pins",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731829",
    description:
      "Iron or steel; non-threaded articles, n.e.c. in item no. 7318.2",
    parent: "7318",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7319",
    description:
      "Sewing and knitting needles, bodkins, crochet hooks, embroidery stilettos and similar articles, for use in the hand, of iron or steel; safety pins and other pins of iron or steel, not elsewhere specified or included",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "731940",
    description: "Safety pins and other pins; of iron or steel",
    parent: "7319",
    level: "6",
  },
  {
    section: "XV",
    hscode: "731990",
    description:
      "Sewing and knitting needles, bodkins, crochet hooks, embroidery stilettos and similar articles, for use in the hand, not elsewhere specified or included, of iron or steel",
    parent: "7319",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7320",
    description: "Springs and leaves for springs, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732010",
    description: "Iron or steel; leaf-springs and leaves therefor",
    parent: "7320",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732020",
    description: "Iron or steel; helical springs and leaves for springs",
    parent: "7320",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732090",
    description: "Iron or steel; springs n.e.c. in heading no. 7320",
    parent: "7320",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7321",
    description:
      "Stoves, ranges, grates, cookers (those with subsidiary boilers for central heating), barbecues, braziers, gas-rings, plate warmers and similar non-electric domestic appliances and parts, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732111",
    description:
      "Cooking appliances and plate warmers; for gas fuel or for both gas and other fuels, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732112",
    description:
      "Cooking appliances and plate warmers; for liquid fuel, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732119",
    description:
      "Cooking appliances and plate warmers; for solid fuel and fuels other than gas or liquid, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732181",
    description:
      "Domestic appliances; non-electric, (other than cookers and plate warmers), for gas fuel or for both gas and other fuels, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732182",
    description:
      "Domestic appliances; non-electric, (other than cookers and plate warmers), for liquid fuel, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732189",
    description:
      "Domestic appliances; non-electric, (other than cookers and plate warmers), for solid fuel and fuels other than gas or liquid, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732190",
    description:
      "Domestic appliances; non-electric, parts thereof, of iron or steel",
    parent: "7321",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7322",
    description:
      "Radiators for central heating, not electrically heated and parts thereof, of iron or steel; air heaters, hot air distributors not electrically heated, with motor fan or blower",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732211",
    description:
      "Radiators and parts thereof; for central heating, (not electrically heated), of cast iron",
    parent: "7322",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732219",
    description:
      "Radiators and parts thereof; for central heating, (not electrically heated), of iron or steel other than cast iron",
    parent: "7322",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732290",
    description:
      "Air heaters and hot air distributors, (not electrically heated), incorporating a motor-driven fan or blower and parts thereof, of iron or steel",
    parent: "7322",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7323",
    description:
      "Table, kitchen, other household articles and parts, of iron or steel; iron or steel wool; pot scourers and scouring or polishing pads, gloves and the like, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732310",
    description:
      "Iron or steel; wool, pot scourers and scouring or polishing pads, gloves and the like",
    parent: "7323",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732391",
    description:
      "Cast iron; table, kitchen and other household articles and parts thereof, of cast iron, not enamelled",
    parent: "7323",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732392",
    description:
      "Cast iron; table, kitchen and other household articles and parts thereof, of cast iron, enamelled",
    parent: "7323",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732393",
    description:
      "Steel, stainless; table, kitchen and other household articles and parts thereof",
    parent: "7323",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732394",
    description:
      "Iron (excluding cast) or steel; table, kitchen and other household articles and parts thereof, enamelled",
    parent: "7323",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732399",
    description:
      "Iron or steel; table, kitchen and other household articles and parts thereof, of iron or steel n.e.c. in heading no. 7323",
    parent: "7323",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7324",
    description: "Sanitary ware and parts thereof, of iron or steel",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732410",
    description: "Steel; sinks and wash basins, of stainless steel",
    parent: "7324",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732421",
    description: "Cast iron, baths, whether or not enamelled",
    parent: "7324",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732429",
    description: "Iron (other than cast) or steel; baths",
    parent: "7324",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732490",
    description:
      "Iron or steel; sanitary ware and parts thereof, excluding sinks, wash basins and baths",
    parent: "7324",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7325",
    description: "Iron or steel; cast articles",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732510",
    description: "Iron; articles of non-malleable cast iron",
    parent: "7325",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732591",
    description:
      "Iron; grinding balls and similar articles for mills, other than of non-malleable cast iron",
    parent: "7325",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732599",
    description:
      "Iron or steel; cast articles, excluding grinding balls and similar articles for mills, other than of non-malleable cast iron",
    parent: "7325",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7326",
    description: "Iron or steel; articles, n.e.c. in chapter 73",
    parent: "73",
    level: "4",
  },
  {
    section: "XV",
    hscode: "732611",
    description:
      "Iron or steel; grinding balls and similar articles for mills, forged or stamped, but not further worked",
    parent: "7326",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732619",
    description:
      "Iron or steel; articles n.e.c. in item no. 7326.11, forged or stamped, but not further worked",
    parent: "7326",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732620",
    description: "Iron or steel; wire articles",
    parent: "7326",
    level: "6",
  },
  {
    section: "XV",
    hscode: "732690",
    description: "Iron or steel; articles n.e.c. in heading 7326",
    parent: "7326",
    level: "6",
  },
  {
    section: "XV",
    hscode: "74",
    description: "Copper and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7401",
    description: "Copper mattes; cement copper (precipitated copper)",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740100",
    description: "Copper mattes; cement copper (precipitated copper)",
    parent: "7401",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7402",
    description: "Copper; unrefined, copper anodes for electrolytic refining",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740200",
    description: "Copper; unrefined, copper anodes for electrolytic refining",
    parent: "7402",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7403",
    description: "Copper; refined and copper alloys, unwrought",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740311",
    description:
      "Copper; refined, unwrought, cathodes and sections of cathodes",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740312",
    description: "Copper; refined, unwrought, wire-bars",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740313",
    description: "Copper; refined, unwrought, billets",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740319",
    description: "Copper; refined, unwrought, n.e.c. in item no. 7403.1",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740321",
    description: "Copper; copper-zinc base alloys (brass) unwrought",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740322",
    description: "Copper; copper-tin base alloys (bronze) unwrought",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740329",
    description:
      "Copper; copper alloys n.e.c. in heading no. 7403 (other than master alloys of heading no. 7405)",
    parent: "7403",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7404",
    description: "Copper; waste and scrap",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740400",
    description: "Copper; waste and scrap",
    parent: "7404",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7405",
    description: "Copper; master alloys",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740500",
    description: "Copper; master alloys of copper",
    parent: "7405",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7406",
    description: "Copper; powders and flakes",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740610",
    description: "Copper; powders of non-lamellar structure",
    parent: "7406",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740620",
    description: "Copper; powders of lamellar structure, flakes",
    parent: "7406",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7407",
    description: "Copper; bars, rods and profiles",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740710",
    description: "Copper; bars, rods and profiles, of refined copper",
    parent: "7407",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740721",
    description:
      "Copper; bars, rods and profiles, of copper-zinc base alloys (brass)",
    parent: "7407",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740729",
    description:
      "Copper; bars, rods and profiles, of copper alloys (other than copper-zinc base alloys)",
    parent: "7407",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7408",
    description: "Copper wire",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740811",
    description:
      "Copper; wire, of refined copper, of which the maximum cross-sectional dimension exceeds 6mm",
    parent: "7408",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740819",
    description:
      "Copper; wire, of refined copper, of which the maximum cross-sectional dimension is 6mm or less",
    parent: "7408",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740821",
    description: "Copper; wire, of copper-zinc base alloys (brass)",
    parent: "7408",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740822",
    description:
      "Copper; wire, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
    parent: "7408",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740829",
    description:
      "Copper; wire, of copper alloys (other than copper-zinc base alloys, copper-nickel base alloys or copper-nickel-zinc base alloys)",
    parent: "7408",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7409",
    description:
      "Copper plates, sheets and strip; of a thickness exceeding 0.15mm",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "740911",
    description:
      "Copper; strip, of a thickness exceeding 0.15mm, of refined copper, in coils",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740919",
    description:
      "Copper; plates and sheets, of a thickness exceeding 0.15mm, of refined copper, not in coils",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740921",
    description:
      "Copper; strip, of a thickness exceeding 0.15mm, of copper-zinc base alloys (brass), in coils",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740929",
    description:
      "Copper; plates and sheets, of a thickness exceeding 0.15mm, of copper-zinc base alloys (brass), not in coils",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740931",
    description:
      "Copper; strip, of a thickness exceeding 0.15mm, of copper-tin base alloys (bronze), in coils",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740939",
    description:
      "Copper; plates and sheets, of a thickness exceeding 0.15mm, of copper-tin base alloys, not in coils",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740940",
    description:
      "Copper; plates, sheets and strip, of a thickness exceeding 0.15mm, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "740990",
    description:
      "Copper; plates, sheets and strip, of a thickness exceeding 0.15mm, of copper alloys (other than copper-zinc base alloys, copper-tin base alloys, copper-nickel base alloys or copper-nickel-zinc base alloys)",
    parent: "7409",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7410",
    description:
      "Copper foil (whether or not printed or backed with paper, paperboard, plastics or similar backing materials) of a thickness (excluding any backing) not exceeding 0.15mm",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741011",
    description:
      "Copper; foil, not backed, of a thickness not exceeding 0.15mm, of refined copper",
    parent: "7410",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741012",
    description:
      "Copper; foil, not backed, of a thickness not exceeding 0.15mm, of copper alloys",
    parent: "7410",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741021",
    description:
      "Copper; foil, backed with paper, paperboard, plastics or similar backing material, of a thickness (excluding any backing) not exceeding 0.15mm, of refined copper",
    parent: "7410",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741022",
    description:
      "Copper; foil, backed with paper, paperboard, plastics or similar backing material, of a thickness (excluding any backing) not exceeding 0.15mm, of copper alloys",
    parent: "7410",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7411",
    description: "Copper tubes and pipes",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741110",
    description: "Copper; tubes and pipes, of refined copper",
    parent: "7411",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741121",
    description: "Copper; tubes and pipes, of copper-zinc base alloys (brass)",
    parent: "7411",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741122",
    description:
      "Copper; tubes and pipes, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
    parent: "7411",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741129",
    description:
      "Copper; tubes and pipes, of copper alloys (other than copper-zinc, copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel-silver))",
    parent: "7411",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7412",
    description:
      "Copper; tube or pipe fittings (e.g. couplings, elbows, sleeves)",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741210",
    description:
      "Copper; tube or pipe fittings (e.g. couplings, elbows, sleeves) of refined copper",
    parent: "7412",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741220",
    description:
      "Copper; tube or pipe fittings (e.g. couplings, elbows, sleeves) of copper alloys",
    parent: "7412",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7413",
    description:
      "Copper; stranded wire, cables, plaited bands and the like, not electrically insulated",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741300",
    description:
      "Copper; stranded wire, cables, plaited bands and the like, not electrically insulated",
    parent: "7413",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7415",
    description:
      "Copper, nails, tacks, drawing pins, staples (not those of heading no. 8305) and the like, of copper or iron or steel with heads of copper; screws bolts, nuts, screws hooks, rivets, cotters, washers",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741510",
    description:
      "Copper; nails and tacks, drawing pins, staples and similar articles of copper, or of iron or steel with copper heads",
    parent: "7415",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741521",
    description: "Copper; washers, (including spring washers), not threaded",
    parent: "7415",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741529",
    description:
      "Copper; rivets, cotters, cotter-pins and similar articles, not threaded",
    parent: "7415",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741533",
    description: "Copper; screws, bolts and nuts, threaded",
    parent: "7415",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741539",
    description: "Copper; articles n.e.c. in heading no. 7415",
    parent: "7415",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7418",
    description:
      "Copper; table, kitchen or other household articles and parts thereof; pot scourers, scouring, polishing pads, gloves and the like; sanitary ware and parts thereof",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741810",
    description:
      "Copper; table, kitchen or other household articles and parts thereof; pot scourers and scouring or polishing pads, gloves and the like",
    parent: "7418",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741820",
    description: "Copper; sanitary ware and parts thereof",
    parent: "7418",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7419",
    description: "Copper; articles thereof n.e.c. in chapter 74",
    parent: "74",
    level: "4",
  },
  {
    section: "XV",
    hscode: "741920",
    description:
      "Copper; cast, moulded, stamped or forged, but not further worked",
    parent: "7419",
    level: "6",
  },
  {
    section: "XV",
    hscode: "741980",
    description: "Copper; articles thereof n.e.c. in chapter 74",
    parent: "7419",
    level: "6",
  },
  {
    section: "XV",
    hscode: "75",
    description: "Nickel and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7501",
    description:
      "Nickel mattes; nickel oxide sinters and other intermediate products of nickel metallurgy",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750110",
    description: "Nickel; nickel mattes",
    parent: "7501",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750120",
    description:
      "Nickel; oxide sinters and other intermediate products of nickel metallurgy",
    parent: "7501",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7502",
    description: "Nickel; unwrought",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750210",
    description: "Nickel; unwrought, not alloyed",
    parent: "7502",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750220",
    description: "Nickel; unwrought, alloys",
    parent: "7502",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7503",
    description: "Nickel; waste and scrap",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750300",
    description: "Nickel; waste and scrap",
    parent: "7503",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7504",
    description: "Nickel; powders and flakes",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750400",
    description: "Nickel; powders and flakes",
    parent: "7504",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7505",
    description: "Nickel; bars, rods, profiles and wire",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750511",
    description: "Nickel; bars, rods and profiles, not alloyed",
    parent: "7505",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750512",
    description: "Nickel; bars, rods and profiles, of nickel alloys",
    parent: "7505",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750521",
    description: "Nickel; wire, not alloyed",
    parent: "7505",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750522",
    description: "Nickel; wire, of nickel alloys",
    parent: "7505",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7506",
    description: "Nickel; plates, sheets, strip and foil",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750610",
    description: "Nickel; plates, sheets, strip and foil, not alloyed",
    parent: "7506",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750620",
    description: "Nickel; plates, sheets, strip and foil, of nickel alloys",
    parent: "7506",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7507",
    description:
      "Nickel; tubes, pipes and tube or pipe fittings (e.g. couplings, elbows, sleeves)",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750711",
    description: "Nickel; tubes and pipes, not alloyed",
    parent: "7507",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750712",
    description: "Nickel; tubes and pipes, of nickel alloys",
    parent: "7507",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750720",
    description: "Nickel; tube and pipe fittings",
    parent: "7507",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7508",
    description: "Nickel; articles thereof n.e.c. in chapter 75",
    parent: "75",
    level: "4",
  },
  {
    section: "XV",
    hscode: "750810",
    description: "Nickel; cloth, grill and netting, of nickel wire",
    parent: "7508",
    level: "6",
  },
  {
    section: "XV",
    hscode: "750890",
    description: "Nickel; articles thereof n.e.c. in item no. 7508.1",
    parent: "7508",
    level: "6",
  },
  {
    section: "XV",
    hscode: "76",
    description: "Aluminium and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7601",
    description: "Aluminium; unwrought",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760110",
    description: "Aluminium; unwrought, (not alloyed)",
    parent: "7601",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760120",
    description: "Aluminium; unwrought, alloys",
    parent: "7601",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7602",
    description: "Aluminium; waste and scrap",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760200",
    description: "Aluminium; waste and scrap",
    parent: "7602",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7603",
    description: "Aluminium; powders and flakes",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760310",
    description: "Aluminium; powders of non-lamellar structure",
    parent: "7603",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760320",
    description: "Aluminium; powders of lamellar structure, flakes",
    parent: "7603",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7604",
    description: "Aluminium; bars, rods and profiles",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760410",
    description: "Aluminium; (not alloyed), bars, rods and profiles",
    parent: "7604",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760421",
    description: "Aluminium; alloys, hollow profiles",
    parent: "7604",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760429",
    description:
      "Aluminium; alloys, bars, rods and profiles, other than hollow",
    parent: "7604",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7605",
    description: "Aluminium wire",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760511",
    description:
      "Aluminium; (not alloyed), wire, maximum cross-sectional dimension exceeds 7mm",
    parent: "7605",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760519",
    description:
      "Aluminium; (not alloyed), wire, maximum cross-sectional dimension is 7mm or less",
    parent: "7605",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760521",
    description:
      "Aluminium; alloys, wire, maximum cross-sectional dimension exceeding 7mm",
    parent: "7605",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760529",
    description:
      "Aluminium; alloys, wire, maximum cross-sectional dimension is 7mm or less",
    parent: "7605",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7606",
    description:
      "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760611",
    description:
      "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, (not alloyed), rectangular (including square)",
    parent: "7606",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760612",
    description:
      "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, alloys, rectangular (including square)",
    parent: "7606",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760691",
    description:
      "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, not alloyed, (not rectangular or square)",
    parent: "7606",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760692",
    description:
      "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, alloys, (not rectangular or square)",
    parent: "7606",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7607",
    description:
      "Aluminium foil (whether or not printed or backed with paper, paperboard, plastics or similar backing materials) of a thickness (excluding any backing) not exceeding 0.2mm",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760711",
    description:
      "Aluminium; foil, (not backed), rolled (but not further worked), of a thickness not exceeding 0.2mm",
    parent: "7607",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760719",
    description:
      "Aluminium; foil, (not backed), of a thickness not exceeding 0.2mm, not rolled",
    parent: "7607",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760720",
    description:
      "Aluminium; foil, backed with paper, paperboard, plastics or similar backing materials, of a thickness (excluding any backing) not exceeding 0.2mm",
    parent: "7607",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7608",
    description: "Aluminium; tubes and pipes",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760810",
    description: "Aluminium; tubes and pipes, not alloyed",
    parent: "7608",
    level: "6",
  },
  {
    section: "XV",
    hscode: "760820",
    description: "Aluminium; tubes and pipes, alloys",
    parent: "7608",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7609",
    description:
      "Aluminium; tube or pipe fittings (e.g. couplings, elbows, sleeves)",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "760900",
    description:
      "Aluminium; tube or pipe fittings (e.g. couplings, elbows, sleeves)",
    parent: "7609",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7610",
    description:
      "Aluminium; structures (excluding prefabricated buildings of heading no. 9406) and parts (e.g. bridges and sections, towers, lattice masts, etc) plates, rods, profiles and tubes for structures",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761010",
    description:
      "Aluminium; structures (excluding prefabricated buildings of heading no. 9406) and parts of structures, doors, windows and their frames and thresholds for doors",
    parent: "7610",
    level: "6",
  },
  {
    section: "XV",
    hscode: "761090",
    description:
      "Aluminium; structures (excluding prefabricated buildings of heading no. 9406) and parts of structures, n.e.c. in heading no. 7610, plates, rods, profiles, tubes and the like",
    parent: "7610",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7611",
    description:
      "Aluminium; reservoirs, tanks, vats and the like for material (not compressed or liquefied gas) of capacity over 300l, whether or not lined, heat-insulated, not fitted with mechanical, thermal equipment",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761100",
    description:
      "Aluminium; reservoirs, tanks, vats and similar containers, for material (not compressed or liquefied gas), of a capacity over 300l, whether or not lined, not fitted with mechanical/thermal equipment",
    parent: "7611",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7612",
    description:
      "Aluminium casks, drums, cans, boxes etc (including rigid, collapsible tubular containers), for materials other than compressed, liquefied gas, 300l capacity or less, lined, heat-insulated or not",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761210",
    description:
      "Aluminium; collapsible tubular containers, for any material, (not compressed or liquefied gas), 300l capacity or less, whether or not lined, not fitted with mechanical/thermal equipment",
    parent: "7612",
    level: "6",
  },
  {
    section: "XV",
    hscode: "761290",
    description:
      "Aluminium; casks, drums, cans, boxes and the like for any material (not compressed or liquefied gas), 300l capacity or less, whether or not lined or heat-insulated, no mechanical or thermal equipment",
    parent: "7612",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7613",
    description: "Aluminium; containers for compressed or liquefied gas",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761300",
    description: "Aluminium; containers for compressed or liquefied gas",
    parent: "7613",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7614",
    description:
      "Aluminium; stranded wire, cables, plaited bands and the like, (not electrically insulated)",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761410",
    description:
      "Aluminium; stranded wire, cables, plaited bands and the like, (not electrically insulated), with steel core",
    parent: "7614",
    level: "6",
  },
  {
    section: "XV",
    hscode: "761490",
    description:
      "Aluminium; stranded wire, cables, plaited bands and the like, (not electrically insulated), other than steel core",
    parent: "7614",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7615",
    description:
      "Aluminium; table, kitchen or other household articles and parts thereof, pot scourers and scouring or polishing pads, gloves and the like, sanitary ware and parts thereof",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761510",
    description:
      "Aluminium; table, kitchen or other household articles and parts thereof; pot scourers and scouring or polishing pads, gloves and the like",
    parent: "7615",
    level: "6",
  },
  {
    section: "XV",
    hscode: "761520",
    description: "Aluminium; sanitary ware and parts thereof",
    parent: "7615",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7616",
    description: "Aluminium; articles n.e.c. in chapter 76",
    parent: "76",
    level: "4",
  },
  {
    section: "XV",
    hscode: "761610",
    description:
      "Aluminium; nails, tacks, staples (other than those of heading no. 8305), screws, bolts, nuts, screw hooks, rivets, cotters, cotter-pins, washers and similar articles",
    parent: "7616",
    level: "6",
  },
  {
    section: "XV",
    hscode: "761691",
    description:
      "Aluminium; cloth, grill, netting and fencing, of aluminium wire",
    parent: "7616",
    level: "6",
  },
  {
    section: "XV",
    hscode: "761699",
    description: "Aluminium; articles n.e.c. in heading 7616",
    parent: "7616",
    level: "6",
  },
  {
    section: "XV",
    hscode: "78",
    description: "Lead and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7801",
    description: "Lead; unwrought",
    parent: "78",
    level: "4",
  },
  {
    section: "XV",
    hscode: "780110",
    description: "Lead; unwrought, refined",
    parent: "7801",
    level: "6",
  },
  {
    section: "XV",
    hscode: "780191",
    description:
      "Lead; unwrought, unrefined, containing by weight antimony as the principal other element",
    parent: "7801",
    level: "6",
  },
  {
    section: "XV",
    hscode: "780199",
    description:
      "Lead; unwrought, unrefined, not containing by weight antimony as the principal other element",
    parent: "7801",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7802",
    description: "Lead; waste and scrap",
    parent: "78",
    level: "4",
  },
  {
    section: "XV",
    hscode: "780200",
    description: "Lead; waste and scrap",
    parent: "7802",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7804",
    description:
      "Lead; plates, sheets, strip and foil, lead powders and flakes",
    parent: "78",
    level: "4",
  },
  {
    section: "XV",
    hscode: "780411",
    description:
      "Lead; sheets, strip and foil, of a thickness (excluding any backing) not exceeding 0.2mm",
    parent: "7804",
    level: "6",
  },
  {
    section: "XV",
    hscode: "780419",
    description:
      "Lead; plates, sheets, strip and foil, of a thickness (excluding any backing) exceeding 0.2mm",
    parent: "7804",
    level: "6",
  },
  {
    section: "XV",
    hscode: "780420",
    description: "Lead; powders and flakes",
    parent: "7804",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7806",
    description: "Lead; articles n.e.c. in chapter 78",
    parent: "78",
    level: "4",
  },
  {
    section: "XV",
    hscode: "780600",
    description: "Lead; articles n.e.c. in chapter 78",
    parent: "7806",
    level: "6",
  },
  {
    section: "XV",
    hscode: "79",
    description: "Zinc and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "7901",
    description: "Zinc; unwrought",
    parent: "79",
    level: "4",
  },
  {
    section: "XV",
    hscode: "790111",
    description:
      "Zinc; unwrought, (not alloyed), containing by weight 99.99% or more of zinc",
    parent: "7901",
    level: "6",
  },
  {
    section: "XV",
    hscode: "790112",
    description:
      "Zinc; unwrought, (not alloyed), containing by weight less than 99.99% of zinc",
    parent: "7901",
    level: "6",
  },
  {
    section: "XV",
    hscode: "790120",
    description: "Zinc; unwrought, alloys",
    parent: "7901",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7902",
    description: "Zinc; waste and scrap",
    parent: "79",
    level: "4",
  },
  {
    section: "XV",
    hscode: "790200",
    description: "Zinc; waste and scrap",
    parent: "7902",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7903",
    description: "Zinc; dust, powders and flakes",
    parent: "79",
    level: "4",
  },
  {
    section: "XV",
    hscode: "790310",
    description: "Zinc dust",
    parent: "7903",
    level: "6",
  },
  {
    section: "XV",
    hscode: "790390",
    description: "Zinc; powders and flakes",
    parent: "7903",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7904",
    description: "Zinc; bars, rods, profiles and wire",
    parent: "79",
    level: "4",
  },
  {
    section: "XV",
    hscode: "790400",
    description: "Zinc; bars, rods, profiles and wire",
    parent: "7904",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7905",
    description: "Zinc; plates, sheets, strip and foil",
    parent: "79",
    level: "4",
  },
  {
    section: "XV",
    hscode: "790500",
    description: "Zinc; plates, sheets, strip and foil",
    parent: "7905",
    level: "6",
  },
  {
    section: "XV",
    hscode: "7907",
    description: "Zinc; articles n.e.c. in chapter 79",
    parent: "79",
    level: "4",
  },
  {
    section: "XV",
    hscode: "790700",
    description: "Zinc; articles n.e.c. in chapter 79",
    parent: "7907",
    level: "6",
  },
  {
    section: "XV",
    hscode: "80",
    description: "Tin; articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "8001",
    description: "Tin; unwrought",
    parent: "80",
    level: "4",
  },
  {
    section: "XV",
    hscode: "800110",
    description: "Tin; unwrought, not alloyed",
    parent: "8001",
    level: "6",
  },
  {
    section: "XV",
    hscode: "800120",
    description: "Tin; unwrought, alloys",
    parent: "8001",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8002",
    description: "Tin; waste and scrap",
    parent: "80",
    level: "4",
  },
  {
    section: "XV",
    hscode: "800200",
    description: "Tin; waste and scrap",
    parent: "8002",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8003",
    description: "Tin; bars, rods, profiles and wire",
    parent: "80",
    level: "4",
  },
  {
    section: "XV",
    hscode: "800300",
    description: "Tin; bars, rods, profiles and wire",
    parent: "8003",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8007",
    description: "Tin; articles n.e.c. in chapter 80",
    parent: "80",
    level: "4",
  },
  {
    section: "XV",
    hscode: "800700",
    description: "Tin; articles n.e.c. in chapter 80",
    parent: "8007",
    level: "6",
  },
  {
    section: "XV",
    hscode: "81",
    description: "Metals; n.e.c., cermets and articles thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "8101",
    description:
      "Tungsten (wolfram); articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810110",
    description:
      "Tungsten (wolfram); articles thereof, including waste and scrap, powders",
    parent: "8101",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810194",
    description:
      "Tungsten (wolfram); unwrought, including bars and rods obtained simply by sintering",
    parent: "8101",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810196",
    description: "Tungsten (wolfram); wire",
    parent: "8101",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810197",
    description: "Tungsten (wolfram); waste and scrap",
    parent: "8101",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810199",
    description: "Tungsten (wolfram); articles n.e.c. in heading no. 8101",
    parent: "8101",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8102",
    description: "Molybdenum; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810210",
    description:
      "Molybdenum; articles thereof, including waste and scrap, powders",
    parent: "8102",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810294",
    description:
      "Molybdenum; unwrought, including bars and rods obtained simply by sintering",
    parent: "8102",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810295",
    description:
      "Molybdenum; bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil",
    parent: "8102",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810296",
    description: "Molybdenum; wire",
    parent: "8102",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810297",
    description: "Molybdenum; waste and scrap",
    parent: "8102",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810299",
    description: "Molybdenum; articles n.e.c. in heading no. 8102",
    parent: "8102",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8103",
    description: "Tantalum; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810320",
    description:
      "Tantalum; unwrought, including bars and rods obtained simply by sintering, powders",
    parent: "8103",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810330",
    description: "Tantalum; waste and scrap",
    parent: "8103",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810391",
    description: "Tantalum; crucibles",
    parent: "8103",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810399",
    description: "Tantalum; articles n.e.c. in heading no. 8103",
    parent: "8103",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8104",
    description: "Magnesium; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810411",
    description:
      "Magnesium; unwrought, containing at least 99.8% by weight of magnesium",
    parent: "8104",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810419",
    description:
      "Magnesium; unwrought, containing less than 99.8% by weight of magnesium",
    parent: "8104",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810420",
    description: "Magnesium; waste and scrap",
    parent: "8104",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810430",
    description:
      "Magnesium; raspings, turnings and granules, graded according to size, powders",
    parent: "8104",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810490",
    description: "Magnesium; articles n.e.c. in heading no. 8104",
    parent: "8104",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8105",
    description:
      "Cobalt; mattes and other intermediate products of cobalt metallurgy, cobalt and articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810520",
    description:
      "Cobalt; mattes and other intermediate products of cobalt metallurgy, unwrought cobalt, powders",
    parent: "8105",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810530",
    description: "Cobalt; waste and scrap",
    parent: "8105",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810590",
    description: "Cobalt; articles n.e.c. in heading no. 8105",
    parent: "8105",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8106",
    description: "Bismuth; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810610",
    description:
      "Bismuth; articles thereof, including waste and scrap, containing more than 99.99% of bismuth, by weight",
    parent: "8106",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810690",
    description:
      "Bismuth; including articles n.e.c. in heading 8106, including waste and scrap, containing less than or equal to 99.99% of bismuth, by weight",
    parent: "8106",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8108",
    description: "Titanium; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810820",
    description: "Titanium; unwrought, powders",
    parent: "8108",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810830",
    description: "Titanium; waste and scrap",
    parent: "8108",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810890",
    description: "Titanium; other than unwrought, n.e.c. in heading no. 8108",
    parent: "8108",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8109",
    description: "Zirconium; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "810921",
    description:
      "Zirconium; unwrought, powders, containing less than 1 part hafnium to 500 parts zirconium by weight",
    parent: "8109",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810929",
    description:
      "Zirconium; unwrought, powders, containing not less than 1 part hafnium to 500 parts zirconium by weight",
    parent: "8109",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810931",
    description:
      "Zirconium; waste and scrap, containing less than 1 part hafnium to 500 parts zirconium by weight",
    parent: "8109",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810939",
    description:
      "Zirconium; waste and scrap, containing not less than 1 part hafnium to 500 parts zirconium by weight",
    parent: "8109",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810991",
    description:
      "Zirconium; other than unwrought, n.e.c. in heading no. 8109, containing less than 1 part hafnium to 500 parts zirconium by weight",
    parent: "8109",
    level: "6",
  },
  {
    section: "XV",
    hscode: "810999",
    description:
      "Zirconium; other than unwrought, n.e.c. in heading no. 8109, containing not less than 1 part hafnium to 500 parts zirconium by weight",
    parent: "8109",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8110",
    description: "Antimony; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "811010",
    description: "Antimony and articles thereof; unwrought antimony, powders",
    parent: "8110",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811020",
    description: "Antimony; waste and scrap",
    parent: "8110",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811090",
    description:
      "Antimony and articles thereof; wrought, other than waste and scrap",
    parent: "8110",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8111",
    description: "Manganese; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "811100",
    description: "Manganese; articles thereof, including waste and scrap",
    parent: "8111",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8112",
    description:
      "Beryllium, chromium, hafnium, rhenium, thallium, cadmium, germanium, vanadium, gallium, indium and niobium (columbium), articles of these metals, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "811212",
    description: "Beryllium and articles thereof; unwrought beryllium, powders",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811213",
    description: "Beryllium; waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811219",
    description:
      "Beryllium and articles thereof; wrought other than waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811221",
    description: "Chromium and articles thereof; unwrought chromium, powders",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811222",
    description: "Chromium; waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811229",
    description:
      "Chromium and articles thereof; wrought other than waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811231",
    description:
      "Hafnium and articles thereof; unwrought, powders, waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811239",
    description:
      "Hafnium and articles thereof; wrought, other than powders, waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811241",
    description:
      "Rhenium and articles thereof; unwrought, powders, waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811249",
    description:
      "Rhenium and articles thereof; wrought, other than powders, waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811251",
    description: "Thallium and articles thereof; unwrought thallium, powders",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811252",
    description: "Thallium; waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811259",
    description:
      "Thallium and articles thereof; other than unwrought thallium, powders or waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811261",
    description: "Cadmium; waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811269",
    description: "Cadmium; other than waste and scrap",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811292",
    description:
      "Gallium, germanium, indium, niobium (columbium) and vanadium; articles thereof, unwrought, including waste and scrap, powders",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "811299",
    description:
      "Gallium, germanium, indium, niobium (columbium) and vanadium; articles thereof, other than unwrought including waste and scrap and powders",
    parent: "8112",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8113",
    description: "Cermets; articles thereof, including waste and scrap",
    parent: "81",
    level: "4",
  },
  {
    section: "XV",
    hscode: "811300",
    description: "Cermets; articles thereof, including waste and scrap",
    parent: "8113",
    level: "6",
  },
  {
    section: "XV",
    hscode: "82",
    description:
      "Tools, implements, cutlery, spoons and forks, of base metal; parts thereof, of base metal",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "8201",
    description:
      "Tools, hand; spades, shovels, mattocks, picks, hoes, forks, rakes; axes, bill hooks etc; secateurs and pruners of any kind; scythes, sickles, hay knives, hedge shears, timber wedges and other tools used in agriculture, horticulture, forestry",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820110",
    description: "Tools, hand; spades and shovels",
    parent: "8201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820130",
    description: "Tools, hand; mattocks, picks, hoes and rakes",
    parent: "8201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820140",
    description:
      "Tools, hand; axes, bill hooks and similar hewing tools, of a kind used in agriculture, horticulture or forestry",
    parent: "8201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820150",
    description: "Tools, hand; one-handed secateurs (including poultry shears)",
    parent: "8201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820160",
    description:
      "Tools, hand; hedge shears, two-handed pruning shears and similar two-handed shears",
    parent: "8201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820190",
    description:
      "Tools, hand; forks, scythes, sickles, hay knives, timber wedges, and other hand tools of a kind used in agriculture, horticulture or forestry n.e.c. in heading 8201",
    parent: "8201",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8202",
    description:
      "Tools, hand; saws and blades for saws of all kinds (including slitting, slotting or toothless saw blades)",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820210",
    description: "Tools, hand; hand saws",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820220",
    description: "Tools, hand; band saw blades",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820231",
    description:
      "Tools, hand; circular saw blades (including slitting or slotting saw blades), with working part of steel",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820239",
    description:
      "Tools, hand; circular saw blades (including slitting or slotting saw blades), with working part of materials (other than steel)",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820240",
    description: "Tools, hand; chain saw blades",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820291",
    description: "Tools, hand; straight saw blades, for working metal",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820299",
    description: "Tools, hand; saw blades n.e.c. in heading no. 8202",
    parent: "8202",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8203",
    description:
      "Tools, hand; files, rasps, pliers (including cutting pliers), pincers, tweezers, metal cutting shears, pipe cutters, bolt croppers, perforating punches and similar",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820310",
    description: "Tools, hand; files, rasps and similar tools",
    parent: "8203",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820320",
    description:
      "Tools, hand; pliers (including cutting pliers), pincers, tweezers and similar tools",
    parent: "8203",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820330",
    description: "Tools, hand; metal cutting shears and similar tools",
    parent: "8203",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820340",
    description:
      "Tools, hand; pipe-cutters, bolt croppers, perforating punches and similar tools",
    parent: "8203",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8204",
    description:
      "Tools, hand; hand-operated spanners and wrenches (including torque meter wrenches but not including tap wrenches), interchangeable spanner sockets, with or without handles",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820411",
    description:
      "Tools, hand; hand-operated spanners and wrenches (including torque meter wrenches but not including tap wrenches), non-adjustable",
    parent: "8204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820412",
    description:
      "Tools, hand; hand-operated spanners and wrenches (including torque meter wrenches but not including tap wrenches), adjustable",
    parent: "8204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820420",
    description:
      "Tools, hand; interchangeable spanner sockets, with or without handles",
    parent: "8204",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8205",
    description:
      "Tools, hand; (including glaziers' diamonds) n.e.c.; blow lamps; vices, clamps etc, other than accessories for and parts of, machine-tools or water-jet cutting machines; anvils; portable forges; hand or pedal operated grinding wheels with frameworks",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820510",
    description: "Tools, hand; drilling, threading or tapping tools",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820520",
    description: "Tools, hand; hammers and sledge hammers",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820530",
    description:
      "Tools, hand; planes, chisels, gauges and similar cutting tools for working wood",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820540",
    description: "Tools, hand; screwdrivers",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820551",
    description: "Tools, hand; household tools",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820559",
    description:
      "Tools, hand; other hand tools (including glaziers diamonds), excluding household tools, drilling, threading or tapping tools, hammers and sledge hammers, planes, chisels, gouges and similar cutting tools for working wood, and screwdrivers",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820560",
    description: "Tools, hand; blow lamps",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820570",
    description: "Tools, hand; vices, clamps and the like",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820590",
    description:
      "Tools, hand; n.e.c. in heading 8205, including anvils, portable forges, hand or pedal-operated grinding wheels with frameworks, and sets of articles of two or more of the subheadings in heading 8205",
    parent: "8205",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8206",
    description:
      "Tools, hand; two or more of heading no. 8202 to 8205, put up in sets for retail sale",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820600",
    description:
      "Tools, hand; two or more of heading no. 8202 to 8205, put up in sets for retail sale",
    parent: "8206",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8207",
    description:
      "Tools, interchangeable; for hand tools, whether or not power-operated, or for machine tools (pressing, stamping, punching, drilling etc), including dies for drawing or extruding metal, and rock drilling or earth boring tools",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820713",
    description:
      "Tools, interchangeable; rock drilling or earth boring tools, with working part of cermets, whether or not power operated",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820719",
    description:
      "Tools, interchangeable; rock drilling or earth boring tools, with working part (other than of cermets), whether or not power operated, including parts",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820720",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), dies for drawing or extruding metal",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820730",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), tools for pressing, stamping or punching",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820740",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), tools for tapping or threading",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820750",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), tools for drilling (other than rock)",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820760",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for boring or broaching",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820770",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for milling",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820780",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for turning",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820790",
    description:
      "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for screw-driving or uses n.e.c. in heading no. 8207",
    parent: "8207",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8208",
    description:
      "Knives and cutting blades, for machines or for mechanical appliances",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820810",
    description:
      "Tools; knives and cutting blades, for machines or for mechanical appliances, for metal working",
    parent: "8208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820820",
    description:
      "Tools; knives and cutting blades, for wood working machines or mechanical appliances",
    parent: "8208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820830",
    description:
      "Tools; knives and cutting blades, for kitchen appliances or for machines used by the food industry",
    parent: "8208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820840",
    description:
      "Tools; knives and cutting blades, for agricultural, horticultural or forestry machines or mechanical appliances",
    parent: "8208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "820890",
    description:
      "Tools; knives and cutting blades, for machines or mechanical appliances, n.e.c. in heading no. 8208",
    parent: "8208",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8209",
    description:
      "Tools; plates, sticks, tips and the like for tools, unmounted, of sintered metal carbides or cermets",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "820900",
    description:
      "Tools; plates, sticks, tips and the like for tools, unmounted, of sintered metal carbides or cermets",
    parent: "8209",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8210",
    description:
      "Tools; hand-operated mechanical appliances, weighing 10kg or less, used in the preparation, conditioning or serving of food or drink",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "821000",
    description:
      "Tools; hand-operated mechanical appliances, weighing 10kg or less, used in the preparation, conditioning or serving of food or drink",
    parent: "8210",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8211",
    description:
      "Knives; with cutting blades, serrated or not (including pruning knives), other than knives of heading no. 8208, and blades therefore",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "821110",
    description:
      "Knives; with cutting blades, serrated or not (including pruning knives), sets of assorted articles, excluding knives and blades of heading no. 8208",
    parent: "8211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821191",
    description:
      "Knives; table knives, having fixed cutting blades, serrated or not, excluding knives and blades of heading no. 8208",
    parent: "8211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821192",
    description:
      "Knives; having fixed cutting blades, (other than table knives), serrated or not, excluding knives and blades of heading no. 8208",
    parent: "8211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821193",
    description:
      "Knives; with cutting blades, (having other than fixed blades), serrated or not, excluding knives and blades of heading no. 8208",
    parent: "8211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821194",
    description:
      "Blades; cutting, serrated or not, excluding those of heading no. 8208",
    parent: "8211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821195",
    description: "Knives; with handles of base metal",
    parent: "8211",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8212",
    description:
      "Razors and razor blades; (including razor blade blanks in strips)",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "821210",
    description: "Razors",
    parent: "8212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821220",
    description:
      "Razors; safety razor blades, including razor blade blanks in strips",
    parent: "8212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821290",
    description: "Razors; parts n.e.c. in heading no. 8212",
    parent: "8212",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8213",
    description:
      "Scissors; tailors' shears and similar shears, and blades therefore",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "821300",
    description:
      "Scissors; tailors' shears, similar shears and blades therefore",
    parent: "8213",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8214",
    description:
      "Cutlery; other articles, (e.g. hair clippers, butchers' or kitchen cleavers, choppers and mincing knives, paper knives), manicure or pedicure sets and instruments (including nail files)",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "821410",
    description:
      "Cutlery; paper knives, letter openers, erasing knives, pencil sharpeners and blades therefore",
    parent: "8214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821420",
    description:
      "Manicure or pedicure sets and instruments; (including nail files)",
    parent: "8214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821490",
    description: "Cutlery; hair clippers and mincing knives",
    parent: "8214",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8215",
    description:
      "Cutlery; spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter knives, sugar tongs and similar kitchen or tableware",
    parent: "82",
    level: "4",
  },
  {
    section: "XV",
    hscode: "821510",
    description:
      "Cutlery; sets of assorted articles (e.g. spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter-knives, sugar tongs and similar), with at least one article plated with precious metal",
    parent: "8215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821520",
    description:
      "Cutlery; sets of assorted articles (e.g. spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter knives, sugar tongs and similar), not plated with precious metal",
    parent: "8215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821591",
    description:
      "Cutlery; (e.g. spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter-knives, sugar tongs and similar), plated with precious metal, not in sets",
    parent: "8215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "821599",
    description: "Cutlery; other than plated with precious metal",
    parent: "8215",
    level: "6",
  },
  {
    section: "XV",
    hscode: "83",
    description: "Metal; miscellaneous products of base metal",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XV",
    hscode: "8301",
    description:
      "Padlocks and locks (key, combination, electrically operated) of base metal; clasps and frames with clasps incorporating locks, of base metal, keys for any or the foregoing articles, of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830110",
    description:
      "Padlocks; (key, combination or electrically operated), of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830120",
    description:
      "Locks; of a kind used for motor vehicles (key, combination or electrically operated), of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830130",
    description:
      "Locks; of a kind used for furniture (key, combination or electrically operated), of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830140",
    description:
      "Locks; (other than those for motor vehicles or furniture), (key, combination or electrically operated), of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830150",
    description:
      "Clasps and frames with clasps; incorporating locks, of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830160",
    description:
      "Locks; parts of padlocks, locks, clasps and frames with clasps incorporating locks, of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830170",
    description: "Keys; presented separately, of base metal",
    parent: "8301",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8302",
    description:
      "Base metal mountings, fittings and similar articles for furniture, doors, staircases, windows, trunks, chests etc, castors with mountings of base metal, automatic door closers of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830210",
    description:
      "Hinges; suitable for furniture, doors, staircases, windows, blinds, coachwork, saddlery, trunks, chests, caskets or the like, of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830220",
    description: "Castors; with mountings, of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830230",
    description:
      "Mountings, fittings and similar articles; for motor vehicles, of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830241",
    description:
      "Mountings, fittings and similar articles; of base metal, suitable for buildings",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830242",
    description:
      "Mountings, fittings and similar articles; suitable for furniture of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830249",
    description:
      "Mountings, fittings and similar articles; suitable for other than buildings or furniture, of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830250",
    description:
      "Hat-racks, hat-pegs, brackets and similar fixtures, of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830260",
    description: "Automatic door closures; of base metal",
    parent: "8302",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8303",
    description:
      "Safes; armoured or reinforced, strong-boxes, doors and safe deposit lockers for strong-rooms, cash or deed boxes and the like, of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830300",
    description:
      "Safes; armoured or reinforced, strong-boxes, doors and safe deposit lockers for strong-rooms, cash or deed boxes and the like, of base metal",
    parent: "8303",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8304",
    description:
      "Office equipment; filing cabinets, card-index cabinets, paper trays and rests, pen trays, office-stamp stands and the like, of base metal, other than office furniture of heading no. 9403",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830400",
    description:
      "Office equipment; filing cabinets, card-index cabinets, paper trays, paper rests, pen trays, office-stamp stands and similar office or desk equipment, of base metal, other than office furniture of heading no. 9403",
    parent: "8304",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8305",
    description:
      "Stationery; fittings for loose-leaf binders or files, letter clips, letter corners, paper clips, indexing tags and the like, staples in strips (for offices, upholstery, packaging), of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830510",
    description:
      "Stationery; fittings for loose-leaf binders or files, of base metal",
    parent: "8305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830520",
    description:
      "Stationery; staples in strips, (e.g. for offices, upholstery, packaging), of base metal",
    parent: "8305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830590",
    description:
      "Stationery; letter clips, letter corners, paper clips, indexing tags and similar office articles, including parts, of base metal",
    parent: "8305",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8306",
    description:
      "Bells, gongs and the like; non-electric, statuettes, other ornaments, photograph, picture, similar frames, mirrors, of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830610",
    description: "Bells, gongs and the like; non-electric, of base metal",
    parent: "8306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830621",
    description:
      "Statuettes and other ornaments; of base metal plated with precious metal",
    parent: "8306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830629",
    description:
      "Statuettes and other ornaments; of base metal other than plated with precious metal",
    parent: "8306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830630",
    description:
      "Photograph, picture or similar frames, mirrors; of base metal",
    parent: "8306",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8307",
    description: "Tubing; flexible, with or without fittings, of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830710",
    description: "Tubing; flexible, with or without fittings, of iron or steel",
    parent: "8307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830790",
    description:
      "Tubing; flexible, with or without fittings of base metal, other than those of iron or steel",
    parent: "8307",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8308",
    description:
      "Clasps, frames with clasps, buckles, buckle-clasps, hooks, eyes, eyelets etc for clothing & accessories, footwear, jewellery, wrist-watches, books, awnings, leather goods, travel goods, saddlery etc, tubular etc rivets, beads, spangles, of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830810",
    description:
      "Hooks, eyes and eyelets; of base metal, of a kind used for clothing, footwear, awnings, handbags, travel goods or other made up articles",
    parent: "8308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830820",
    description: "Rivets; tubular or bifurcated, of base metal",
    parent: "8308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830890",
    description:
      "Clasps, frames with clasps, buckles, buckle clasps; of base metal, of a kind used for clothing & accessories, footwear, jewellery, wrist-watches, books, awnings, leather goods, travel goods, saddlery etc, including parts",
    parent: "8308",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8309",
    description:
      "Stoppers, caps, lids (including crown corks, screw caps, pouring stoppers); capsules for bottles, threaded bungs, bung covers, seals and other packaging accessories, of base metal",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "830910",
    description: "Stoppers; corks, of base metal",
    parent: "8309",
    level: "6",
  },
  {
    section: "XV",
    hscode: "830990",
    description: "Stoppers; caps and lids, of base metal",
    parent: "8309",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8310",
    description:
      "Sign plates, name plates, address plates and similar plates, numbers, letters and other symbols, of base metal, excluding those of heading no. 9405",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "831000",
    description:
      "Sign plates, name-plates, address-plates and similar plates, numbers, letters and other symbols; of base metal, excluding those of heading no. 9405",
    parent: "8310",
    level: "6",
  },
  {
    section: "XV",
    hscode: "8311",
    description:
      "Wires, rods, tubes, plates, electrodes of base metal or metal carbides; of a kind used for soldering, brazing, welding; wires and rods for metal spraying",
    parent: "83",
    level: "4",
  },
  {
    section: "XV",
    hscode: "831110",
    description: "Electrodes; coated, of base metal, for electric arc-welding",
    parent: "8311",
    level: "6",
  },
  {
    section: "XV",
    hscode: "831120",
    description: "Wire; cored, of base metal, for electric arc-welding",
    parent: "8311",
    level: "6",
  },
  {
    section: "XV",
    hscode: "831130",
    description:
      "Rods and wire; coated rods and cored wire, of base metal, for soldering, brazing or welding by flame",
    parent: "8311",
    level: "6",
  },
  {
    section: "XV",
    hscode: "831190",
    description:
      "Wires, rods, tubes, plates, electrodes of base metal or metal carbides; of a kind used for soldering, brazing, welding; wires and rods for metal spraying; n.e.c. in item no. 8311",
    parent: "8311",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "84",
    description:
      "Machinery and mechanical appliances, boilers, nuclear reactors; parts thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVI",
    hscode: "8401",
    description:
      "Nuclear reactors; fuel elements (cartridges), non-irradiated, for nuclear reactors, machinery and apparatus for isotopic separation",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840110",
    description: "Nuclear reactors",
    parent: "8401",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840120",
    description:
      "Machinery and apparatus; for isotopic separation, and parts thereof",
    parent: "8401",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840130",
    description: "Fuel elements (cartridges); non-irradiated",
    parent: "8401",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840140",
    description: "Nuclear reactors; parts thereof",
    parent: "8401",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8402",
    description:
      "Boilers; steam or other vapour generating (other than central heating hot water boilers, capable also of producing low pressure steam), super heated water boilers",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840211",
    description:
      "Boilers; watertube boilers with a steam production exceeding 45t per hour",
    parent: "8402",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840212",
    description:
      "Boilers; watertube boilers with a steam production not exceeding 45t per hour",
    parent: "8402",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840219",
    description:
      "Boilers; vapour generating boilers, including hybrid boilers n.e.c. in heading no. 8402",
    parent: "8402",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840220",
    description: "Boilers; super-heated water boilers",
    parent: "8402",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840290",
    description: "Boilers; parts of steam or other vapour generating boilers",
    parent: "8402",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8403",
    description: "Central heating boilers; excluding those of heading no. 8402",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840310",
    description:
      "Boilers; central heating boilers (excluding those of heading no. 8402)",
    parent: "8403",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840390",
    description:
      "Boilers; parts of central heating boilers (excluding those of heading no. 8402)",
    parent: "8403",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8404",
    description:
      "Auxiliary plant for use with boilers of heading no. 8402 or 8403; e.g. economisers, super-heaters, soot removers, gas recoverers), condensers for steam or other vapour power units",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840410",
    description:
      "Boilers; auxiliary plant, for use with boilers of heading no. 8402 or 8403 (e.g. economisers, super-heaters, soot removers, gas recoverers)",
    parent: "8404",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840420",
    description: "Boilers; condensers, for steam or other vapour power units",
    parent: "8404",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840490",
    description:
      "Boilers; parts of auxiliary plant, for use with boilers of heading no. 8402 and 8403 and parts of condensers for steam or other vapour power units",
    parent: "8404",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8405",
    description:
      "Generators for producer or water gas with or without their purifiers acetylene gas generators and similar water process gas generators, with or without their purifiers",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840510",
    description:
      "Generators; producer gas, water gas, acetylene gas and similar water process gas generators, with or without their purifiers",
    parent: "8405",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840590",
    description:
      "Generators; parts of producer gas, water gas, acetylene gas and similar water process gas generators, with or without their purifiers",
    parent: "8405",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8406",
    description: "Turbines; steam and other vapour turbines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840610",
    description:
      "Turbines; steam and other vapour turbines, for marine propulsion",
    parent: "8406",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840681",
    description:
      "Turbines; steam and other vapour turbines, (for other than marine propulsion), of an output exceeding 40MW",
    parent: "8406",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840682",
    description:
      "Turbines; steam and other vapour turbines, (for other than marine propulsion), of an output not exceeding 40MW",
    parent: "8406",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840690",
    description: "Turbines; parts of steam and other vapour turbines",
    parent: "8406",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8407",
    description: "Reciprocating or rotary internal combustion piston engines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840710",
    description:
      "Engines; for aircraft, spark-ignition reciprocating or rotary internal combustion piston engines",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840721",
    description:
      "Engines; outboard motors for marine propulsion, spark-ignition reciprocating or rotary internal combustion piston engines",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840729",
    description:
      "Engines; for marine propulsion, (other than outboard motors), spark-ignition reciprocating or rotary internal combustion piston engines",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840731",
    description:
      "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity not exceeding 50cc",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840732",
    description:
      "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity exceeding 50cc but not exceeding 250cc",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840733",
    description:
      "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity exceeding 250cc but not exceeding 1000cc",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840734",
    description:
      "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity exceeding 1000cc",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840790",
    description:
      "Engines; rotary internal combustion piston engines, for other than aircraft or marine propulsion",
    parent: "8407",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8408",
    description:
      "Compression-ignition internal combustion piston engines (diesel or semi-diesel engines)",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840810",
    description:
      "Engines; for marine propulsion, compression-ignition internal combustion piston engines (diesel or semi-diesel engines)",
    parent: "8408",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840820",
    description:
      "Engines; compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of a kind used for the propulsion of vehicles of chapter 87",
    parent: "8408",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840890",
    description:
      "Engines; compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of a kind used for other than marine propulsion or the vehicles of chapter 87",
    parent: "8408",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8409",
    description:
      "Parts suitable for use solely or principally with the engines of heading no. 8407 or 8408",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "840910",
    description:
      "Engines; parts of aircraft engines (spark-ignition reciprocating or rotary internal combustion piston engines)",
    parent: "8409",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840991",
    description:
      "Engines; parts, suitable for use solely or principally with spark-ignition internal combustion piston engines (for other than aircraft)",
    parent: "8409",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "840999",
    description:
      "Engines; parts for internal combustion piston engines (excluding spark-ignition)",
    parent: "8409",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8410",
    description: "Turbines; hydraulic water wheels and regulators therefor",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841011",
    description:
      "Turbines; hydraulic turbines and water wheels, of a power not exceeding 1000kW",
    parent: "8410",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841012",
    description:
      "Turbines; hydraulic turbines and water wheels, of a power exceeding 1000kW but not exceeding 10000kW",
    parent: "8410",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841013",
    description:
      "Turbines; hydraulic turbines and water wheels, of a power exceeding 10000kW",
    parent: "8410",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841090",
    description:
      "Turbines; parts of hydraulic turbines and water wheels, including regulators",
    parent: "8410",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8411",
    description: "Turbo-jets, turbo-propellers and other gas turbines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841111",
    description: "Turbo-jets; of a thrust not exceeding 25kN",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841112",
    description: "Turbo-jets; of a thrust exceeding 25kN",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841121",
    description: "Turbo-propellers; of a power not exceeding 1100kW",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841122",
    description: "Turbo-propellers; of a power exceeding 1100kW",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841181",
    description:
      "Turbines; gas-turbines (excluding turbo-jets and turbo-propellers), of a power not exceeding 5000kW",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841182",
    description:
      "Turbines; gas-turbines (excluding turbo-jets and turbo-propellers), of a power exceeding 5000kW",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841191",
    description: "Turbines; parts of turbo-jets and turbo-propellers",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841199",
    description:
      "Turbines; parts of gas turbines (excluding turbo-jets and turbo-propellers)",
    parent: "8411",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8412",
    description:
      "Engines and motors; n.e.c. (e.g. reaction engines, hydraulic power engines, pneumatic power engines)",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841210",
    description: "Engines; reaction engines, other than turbo-jets",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841221",
    description:
      "Engines; hydraulic power engines and motors, linear acting (cylinders)",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841229",
    description:
      "Engines; hydraulic power engines and motors, other than linear acting (cylinders)",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841231",
    description:
      "Engines; pneumatic power engines and motors, linear acting (cylinders)",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841239",
    description:
      "Engines; pneumatic power engines and motors, other than linear acting (cylinders)",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841280",
    description:
      "Engines; pneumatic power engines and motors, n.e.c. in heading no. 8412",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841290",
    description: "Engines; parts, for engines and motors of heading no. 8412",
    parent: "8412",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8413",
    description:
      "Pumps; for liquids, whether or not fitted with measuring device, liquid elevators",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841311",
    description:
      "Pumps; fitted or designed to be fitted with a measuring device, for dispensing fuel or lubricants, of the type used in filling-stations or in garages",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841319",
    description:
      "Pumps; for liquids, fitted or designed to be fitted with a measuring device, other than pumps for dispensing fuel or lubricants",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841320",
    description:
      "Pumps; hand, fitted or designed to be fitted with a measuring device, for liquids, other than those of item no. 8413.11 or 8413.19",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841330",
    description:
      "Pumps; fuel, lubricating or cooling medium pumps for internal combustion piston engines",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841340",
    description: "Pumps; concrete pumps",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841350",
    description:
      "Pumps; reciprocating positive displacement pumps, n.e.c. in heading no. 8413, for liquids",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841360",
    description:
      "Pumps; rotary positive displacement pumps, n.e.c. in heading no. 8413, for liquids",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841370",
    description: "Pumps; centrifugal, n.e.c. in heading no. 8413, for liquids",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841381",
    description: "Pumps and liquid elevators; n.e.c. in heading no. 8413",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841382",
    description: "Liquid elevators",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841391",
    description: "Pumps; parts thereof",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841392",
    description: "Liquid elevators; parts thereof",
    parent: "8413",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8414",
    description:
      "Air or vacuum pumps, air or other gas compressors and fans; ventilating or recycling hoods incorporating a fan; gas-tight biological safety cabinets whether or not fitted with filters",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841410",
    description: "Pumps; vacuum",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841420",
    description: "Pumps; hand or foot-operated air pumps",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841430",
    description: "Compressors; of a kind used in refrigerating equipment",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841440",
    description:
      "Compressors; air compressors mounted on a wheeled chassis for towing",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841451",
    description:
      "Fans; table, floor, wall, window, ceiling or roof fans, with a self-contained electric motor of an output not exceeding 125W",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841459",
    description: "Fans; n.e.c. in item no. 8414.51",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841460",
    description:
      "Hoods; ventilating or recycling hoods incorporating a fan, whether or not fitted with filters, having a maximum horizontal side not exceeding 120cm",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841470",
    description:
      "Gas-tight biological safety cabinets; whether or not fitted with filters, having a maximum horizontal side not exceeding 120cm",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841480",
    description:
      "Pumps and compressors; for air, vacuum or gas, n.e.c. in heading no. 8414",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841490",
    description:
      "Pumps and compressors; parts, of air or vacuum pumps, air or other gas compressors and fans, ventilating or recycling hoods incorporating a fan",
    parent: "8414",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8415",
    description:
      "Air conditioning machines; comprising a motor driven fan and elements for changing the temperature and humidity, including those machines in which the humidity cannot be separately regulated",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841510",
    description:
      "Air conditioning machines; comprising a motor-driven fan and elements for changing the temperature and humidity, of a kind designed to be fixed to a window, wall, ceiling or floor, self-contained or split-system",
    parent: "8415",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841520",
    description:
      "Air conditioning machines; comprising a motor driven fan and elements for changing the temperature and humidity, of a kind used for persons, in motor vehicles",
    parent: "8415",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841581",
    description:
      "Air conditioning machines; containing a motor driven fan, other than window or wall types, incorporating a refrigerating unit and a valve for reversal of the cooling/heat cycle (reversible heat pumps)",
    parent: "8415",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841582",
    description:
      "Air conditioning machines; containing a motor driven fan, other than window or wall types, incorporating a refrigerating unit",
    parent: "8415",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841583",
    description:
      "Air conditioning machines; containing a motor driven fan, other than window or wall types, not incorporating a refrigerating unit",
    parent: "8415",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841590",
    description:
      "Air conditioning machines; with motor driven fan and elements for temperature control, parts thereof",
    parent: "8415",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8416",
    description:
      "Furnace burners for liquid fuel, for pulverised solid fuel or for gas; mechanical grates, mechanical ash dischargers and similar appliances",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841610",
    description: "Furnaces; furnace burners, for liquid fuel",
    parent: "8416",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841620",
    description:
      "Furnaces; furnace burners, for pulverized solid fuel or gas, including combination burners",
    parent: "8416",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841630",
    description:
      "Furnace accessories; mechanical stokers, mechanical grates, mechanical ash dischargers and similar appliances",
    parent: "8416",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841690",
    description:
      "Furnaces; parts of furnace burners, for liquid fuel, pulverized solid fuel or gas, mechanical stokers, grates, ash dischargers and the like",
    parent: "8416",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8417",
    description:
      "Furnaces and ovens; industrial or laboratory, including incinerators, non-electric",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841710",
    description:
      "Furnaces and ovens; non-electric, for the roasting, melting or other heat-treatment of ores, pyrites or of metals, for industrial or laboratory use",
    parent: "8417",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841720",
    description: "Ovens; non-electric, bakery ovens, including biscuit ovens",
    parent: "8417",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841780",
    description:
      "Furnaces and ovens; including incinerators, non-electric, for industrial or laboratory use, n.e.c. in heading no. 8417",
    parent: "8417",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841790",
    description:
      "Furnaces and ovens; parts of non-electric furnaces and ovens (including incinerators), of industrial or laboratory use",
    parent: "8417",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8418",
    description:
      "Refrigerators, freezers and other refrigerating or freezing equipment, electric or other; heat pumps other than air conditioning machines of heading no. 8415",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841810",
    description:
      "Refrigerators and freezers; combined refrigerator-freezers, fitted with separate external doors, electric or other",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841821",
    description:
      "Refrigerators; for household use, compression-type, electric or other",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841829",
    description:
      "Refrigerators; household, electric or not, other than compression-type",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841830",
    description: "Freezers; of the chest type, not exceeding 800l capacity",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841840",
    description: "Freezers; of the upright type, not exceeding 900l capacity",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841850",
    description:
      "Furniture incorporating refrigerating or freezing equipment; for storage and display, n.e.c. in item no. 8418.1, 8418.2, 8418.3 or 8418.4 (chests, cabinets, display counters, show-cases and the like)",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841861",
    description:
      "Heat pumps; other than air conditioning machines of heading no. 8415",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841869",
    description:
      "Refrigerating or freezing equipment; n.e.c. in heading no. 8418",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841891",
    description:
      "Refrigerating or freezing equipment; parts, furniture designed to receive refrigerating or freezing equipment",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841899",
    description:
      "Refrigerating or freezing equipment; parts thereof, other than furniture",
    parent: "8418",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8419",
    description:
      "Machinery, plant (not domestic), or laboratory equipment; electrically heated or not, (excluding items in 85.14) for the treatment of materials by a process involving change of temperature; including instantaneous or non electric storage water heaters",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "841911",
    description:
      "Heaters; instantaneous gas water heaters, for domestic or other purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841912",
    description: "Heaters; solar water heaters, non-electric",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841919",
    description:
      "Heaters; instantaneous or storage water heaters, non-electric, (other than instantaneous gas or solar water heaters)",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841920",
    description:
      "Sterilizers; for medical, surgical or laboratory use, not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841933",
    description:
      "Dryers; lyophilisation apparatus, freeze drying units and spray dryers, not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841934",
    description:
      "Dryers; for agricultural products, not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841935",
    description:
      "Dryers; for wood, paper pulp, paper or paperboard, not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841939",
    description:
      "Dryers; for products n.e.c. in heading no. 8419, not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841940",
    description:
      "Distilling or rectifying plant; not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841950",
    description: "Heat exchange units; not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841960",
    description:
      "Machinery; for liquefying air or gas, not used for domestic purposes",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841981",
    description:
      "Machinery, plant and equipment; for making hot drinks, for cooking or heating food",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841989",
    description:
      "Machinery, plant and laboratory equipment; for treating materials by change of temperature, other than for making hot drinks or cooking or heating food",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "841990",
    description:
      "Machinery, plant and laboratory equipment; parts of equipment for treating materials by a process involving a change of temperature",
    parent: "8419",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8420",
    description:
      "Machines; calendering or other rolling machines, for other than metal or glass and cylinders therefor",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842010",
    description:
      "Machines; calendering or other rolling machines, for other than metal or glass",
    parent: "8420",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842091",
    description:
      "Machines; parts, cylinders for calendering or other rolling machines, for other than metal or glass",
    parent: "8420",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842099",
    description:
      "Machines; parts, (other than cylinders), for calendering or other rolling machines, for other than metal or glass",
    parent: "8420",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8421",
    description:
      "Centrifuges, including centrifugal dryers; filtering or purifying machinery and apparatus for liquids or gases",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842111",
    description: "Centrifuges; cream separators",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842112",
    description: "Centrifuges; clothes-dryers",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842119",
    description:
      "Centrifuges; n.e.c. in heading no. 8421, including centrifugal dryers (but not clothes-dryers)",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842121",
    description: "Machinery; for filtering or purifying water",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842122",
    description:
      "Machinery; for filtering or purifying beverages other than water",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842123",
    description:
      "Machinery; filtering or purifying machinery, oil or petrol filters for internal combustion engines",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842129",
    description:
      "Machinery; for filtering or purifying liquids, n.e.c. in item no. 8421.2",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842131",
    description:
      "Machinery; intake air filters for internal combustion engines",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842132",
    description:
      "Machinery; catalytic converters or particulate filters, whether or not combined, for purifying or filtering exhaust gases from internal combustion engines",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842139",
    description:
      "Machinery; for filtering or purifying gases, other than intake air filters, catalytic converters or particulate filters for internal combustion engines",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842191",
    description:
      "Centrifuges; parts thereof, including parts for centrifugal dryers",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842199",
    description: "Machinery; parts for filtering or purifying liquids or gases",
    parent: "8421",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8422",
    description:
      "Dish washing machines; machinery for cleaning, drying, filling, closing, sealing, capsuling or labelling bottles, cans, boxes, bags, etc, machinery for aerating beverages",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842211",
    description: "Dish washing machines; of the household type",
    parent: "8422",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842219",
    description: "Dish washing machines; of other than household type",
    parent: "8422",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842220",
    description:
      "Machinery; for cleaning or drying bottles or other containers",
    parent: "8422",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842230",
    description:
      "Machinery; for filling, closing, sealing, capsuling or labelling bottles, cans, bags or other containers, machinery for aerating beverages",
    parent: "8422",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842240",
    description: "Machinery; for packing or wrapping",
    parent: "8422",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842290",
    description: "Machinery; parts of machinery of heading no. 8422",
    parent: "8422",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8423",
    description:
      "Weighing machines; excluding balances of a sensitivity of 5cg or better, including weight operated counting or checking machines and weights of all kinds",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842310",
    description:
      "Weighing machines; personal (including baby scales) and household scales",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842320",
    description:
      "Weighing machines; scales for continuous weighing of goods on conveyors",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842330",
    description:
      "Weighing machines; constant weight scales and scales for discharging a predetermined weight of material into a bag or container, including hopper scales",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842381",
    description:
      "Weighing machines; other than personal, conveyor or constant weight scales, having a maximum weighing capacity not exceeding 30kg (excluding balances of a sensitivity of 5cg or better)",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842382",
    description:
      "Weighing machines; other than personal, conveyor or constant weight scales, having a maximum weighing capacity exceeding 30kg but not exceeding 5000kg",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842389",
    description:
      "Weighing machines; other than personal, conveyor or constant weight scales, having a maximum weighing capacity exceeding 5000kg",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842390",
    description:
      "Weighing machines; weights of all kinds, parts of weighing machinery",
    parent: "8423",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8424",
    description:
      "Mechanical appliances for projecting, dispersing or spraying liquids or powders; fire extinguishers, spray guns, steam, sand blasting machines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842410",
    description: "Fire extinguishers; whether or not charged",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842420",
    description: "Spray guns and similar appliances",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842430",
    description:
      "Mechanical appliances; steam or sand blasting machines and similar jet projecting machines",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842441",
    description:
      "Mechanical appliances; agricultural or horticultural sprayers; portable sprayers",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842449",
    description:
      "Mechanical appliances; agricultural or horticultural sprayers; other than portable sprayers",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842482",
    description:
      "Mechanical appliances; agricultural or horticultural, n.e.c. in heading 8424",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842489",
    description:
      "Mechanical appliances; for projecting, dispersing or spraying liquids or powders, for other than agricultural or horticultural use, whether or not hand-operated",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842490",
    description:
      "Mechanical appliances; parts of machines projecting, dispersing or spraying liquids or powders, whether or not hand-operated",
    parent: "8424",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8425",
    description:
      "Pulley tackle and hoists other than skip hoists; winches and capstans; jacks",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842511",
    description:
      "Pulley tackle and hoists; powered by an electric motor (excluding skip hoists or hoists of a kind used for raising vehicles)",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842519",
    description:
      "Pulley tackle and hoists; not powered by an electric motor (excluding skip hoists or hoists of a kind used for raising vehicles)",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842531",
    description: "Winches; capstans; powered by an electric motor",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842539",
    description: "Winches; capstans; not powered by an electric motor",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842541",
    description:
      "Jacks; built-in jacking systems of a type used in garages, for raising vehicles",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842542",
    description:
      "Jacks and hoists; hydraulic, of a kind used for raising vehicles",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842549",
    description:
      "Jacks and hoists; (other than hydraulic), of a kind used for raising vehicles",
    parent: "8425",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8426",
    description:
      "Derricks, cranes, including cable cranes, mobile lifting frames, straddle carriers and works trucks fitted with a crane",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842611",
    description: "Cranes; overhead travelling cranes on fixed support",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842612",
    description: "Cranes; mobile lifting frames on tyres and straddle carriers",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842619",
    description: "Cranes; transporter, gantry and bridge cranes",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842620",
    description: "Cranes; tower cranes",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842630",
    description: "Cranes; portal or pedestal jib cranes",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842641",
    description:
      "Cranes; self-propelled derricks and cranes, on tyres, n.e.c. in heading no. 8426",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842649",
    description:
      "Cranes; self-propelled derricks and cranes, not on tyres, n.e.c. in heading no. 8426",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842691",
    description: "Cranes and derricks; designed for mounting on road vehicles",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842699",
    description:
      "Cranes and derricks; for other than mounting on road vehicles, n.e.c. in heading no. 8426",
    parent: "8426",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8427",
    description:
      "Fork-lift and other works trucks; fitted with lifting or handling equipment",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842710",
    description:
      "Fork-lift and other works trucks; fitted with lifting or handling equipment, self-propelled by electric motor",
    parent: "8427",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842720",
    description:
      "Fork-lift and other works trucks; fitted with lifting or handling equipment, self-propelled by other than electric motor",
    parent: "8427",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842790",
    description:
      "Fork-lift and other works trucks; fitted with lifting or handling equipment, not self-propelled",
    parent: "8427",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8428",
    description:
      "Lifting, handling, loading or unloading machinery; n.e.c. in heading no. 8425, 8426 or 8427 (e.g. lifts, escalators, conveyors, teleferics)",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842810",
    description: "Lifts and skip hoists",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842820",
    description: "Elevators and conveyors; pneumatic",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842831",
    description:
      "Elevators and conveyors; continuous-action, for goods and materials, specially designed for underground use, n.e.c. in item no. 8428.20",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842832",
    description:
      "Elevators and conveyors; continuous-action, for goods or materials, bucket type, n.e.c. in item no. 8428.20 or 8428.31",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842833",
    description:
      "Elevators and conveyors; continuous-action, for goods or materials, belt type, n.e.c. in item no. 8428.20 or 8428.31",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842839",
    description:
      "Elevators and conveyors; continuous-action, for goods or materials, n.e.c. in item no. 8428.20, 8428.31, 8428.32 or 8428.33",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842840",
    description: "Escalators and moving walkways",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842860",
    description:
      "Teleferics, chair-lifts, ski-draglines, traction mechanisms for funiculars",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842870",
    description: "Industrial robots",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842890",
    description:
      "Lifting, handling, loading or unloading machinery; n.e.c. in heading no. 8425, 8426, 8427 or 8428",
    parent: "8428",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8429",
    description:
      "Bulldozers, graders, levellers, scrapers, angledozers, mechanical shovels, excavators, shovel loaders, tamping machines and road rollers, self-propelled",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "842911",
    description: "Bulldozers and angledozers; self-propelled, track laying",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842919",
    description:
      "Bulldozers and angledozers; self-propelled, other than track laying",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842920",
    description: "Graders and levellers",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842930",
    description: "Scrapers; self-propelled",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842940",
    description: "Tamping machines and road rollers; self-propelled",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842951",
    description: "Front-end shovel loaders",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842952",
    description:
      "Mechanical shovels, excavators and shovel loaders; with a 360 degree revolving super structure",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "842959",
    description:
      "Mechanical shovels, excavators and shovel loaders; n.e.c. in item no. 8429.50",
    parent: "8429",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8430",
    description:
      "Moving, grading, levelling, scraping, excavating, tamping, compacting, extracting or boring machinery, for earth, minerals, or ores; pile drivers and extractors; snow ploughs and snow blowers",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843010",
    description: "Pile-drivers and pile-extractors",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843020",
    description: "Snow-ploughs and snow-blowers",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843031",
    description:
      "Coal or rock cutters and tunnelling machinery; self-propelled",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843039",
    description:
      "Coal or rock cutters and tunnelling machinery; not self-propelled",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843041",
    description:
      "Boring or sinking machinery; self-propelled, n.e.c. in heading no. 8430",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843049",
    description: "Boring and sinking machinery; not self-propelled",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843050",
    description:
      "Machinery; for handling earth, minerals or ores, self-propelled, n.e.c. in heading no. 8430",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843061",
    description: "Machinery; for tamping or compacting, not self-propelled",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843069",
    description:
      "Machinery; for moving, levelling, scraping, grading, excavating earth minerals or ores; not self propelled n.e.c in 84.30",
    parent: "8430",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8431",
    description:
      "Machinery parts; used solely or principally with the machinery of heading no. 8425 to 8430",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843110",
    description: "Machinery; parts of the machinery of heading no. 8425",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843120",
    description: "Machinery; parts of the machinery of heading no. 8427",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843131",
    description: "Lifts, skip hoists or escalators; parts thereof",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843139",
    description:
      "Machinery; parts of the machinery of heading no. 8428, (other than lifts, skip hoists or escalators)",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843141",
    description:
      "Machinery parts; buckets, shovels, grabs and grips, for the machinery of heading no. 8426 and 8430",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843142",
    description: "Machinery parts; bulldozer or angledozer blades",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843143",
    description:
      "Boring or sinking machinery; parts for boring or sinking machinery of subheading 8430.41 or 8430.49",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843149",
    description:
      "Machinery; parts of machines handling earth, minerals or ores and n.e.c. in heading no. 8431",
    parent: "8431",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8432",
    description:
      "Agricultural, horticultural or forestry machinery for soil preparation or cultivation; lawn or sports-ground rollers",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843210",
    description: "Ploughs; for soil preparation",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843221",
    description: "Harrows; disc harrows",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843229",
    description:
      "Harrows; (excluding disc), scarifiers, cultivators, weeders and hoes",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843231",
    description:
      "Seeders, planters and transplanters; no-till direct seeders, planters and transplanters",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843239",
    description:
      "Seeders, planters and transplanters; other than no-till direct seeders, planters and transplanters",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843241",
    description:
      "Spreaders and distributors; for manure and fertilizers, for agricultural, horticultural or forestry use; manure spreaders",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843242",
    description:
      "Spreaders and distributors; for manure and fertilizers, for agricultural, horticultural or forestry use; fertiliser distributors",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843280",
    description: "Rollers; for lawns or sports-grounds",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843290",
    description:
      "Machinery; parts of machinery for soil preparation or cultivation or for rollers for lawns or sports-grounds",
    parent: "8432",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8433",
    description:
      "Harvesting and threshing machinery, straw and fodder balers, grass or hay mowers; machines for cleaning, sorting or grading eggs, fruit or other agricultural produce, other than machinery of heading no 8437",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843311",
    description:
      "Mowers; lawn, parks or sports-grounds, powered, with the cutting device rotating in a horizontal plane",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843319",
    description:
      "Mowers; for lawns, parks or sports-grounds, other than with the cutting device rotating in a horizontal plane",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843320",
    description:
      "Mowers; n.e.c. in item no. 8433.1 (including cutter bars for tractor mounting)",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843330",
    description: "Haymaking machinery",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843340",
    description: "Balers; straw or fodder balers, including pick-up balers",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843351",
    description: "Combine harvester-threshers",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843352",
    description: "Threshing machinery; other than combine harvester-threshers",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843353",
    description: "Harvesting machinery; for roots or tubers",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843359",
    description: "Harvesting machinery; n.e.c. in heading no. 8433",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843360",
    description:
      "Machines; for cleaning, sorting or grading eggs, fruit or other agricultural produce",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843390",
    description:
      "Harvesting machinery; parts, including parts of threshing machinery, straw or fodder balers and grass or hay mowers",
    parent: "8433",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8434",
    description: "Milking machines and dairy machinery",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843410",
    description: "Milking machines",
    parent: "8434",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843420",
    description: "Dairy machinery",
    parent: "8434",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843490",
    description: "Milking machines and dairy machinery; parts thereof",
    parent: "8434",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8435",
    description:
      "Presses, crushers and similar machinery; used in the manufacture of wine, cider, fruit juices or similar beverages",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843510",
    description:
      "Presses, crushers and similar machinery; used in the manufacture of wine, cider, fruit juices or similar beverages",
    parent: "8435",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843590",
    description:
      "Presses, crushers and similar machinery; parts, used in the manufacture of wine, cider, fruit juices or similar beverages",
    parent: "8435",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8436",
    description:
      "Agricultural, horticultural, forestry, poultry-keeping, bee-keeping machinery; including germination plant fitted with mechanical or thermal equipment; poultry incubators and brooders",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843610",
    description: "Machinery; for preparing animal feeding stuffs",
    parent: "8436",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843621",
    description: "Poultry incubators and brooders",
    parent: "8436",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843629",
    description:
      "Poultry-keeping machinery; other than incubators and brooders",
    parent: "8436",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843680",
    description:
      "Machinery; for agricultural, horticultural or forestry use and n.e.c. in heading no. 8436",
    parent: "8436",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843691",
    description:
      "Machinery; parts of poultry-keeping machinery or poultry incubators and brooders",
    parent: "8436",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843699",
    description:
      "Machinery; parts of that machinery for agricultural, horticultural or forestry use n.e.c. in heading no. 8436",
    parent: "8436",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8437",
    description:
      "Machines for cleaning, sorting, grading seed, grain, dried leguminous vegetables; machinery used in the milling industry for the working of cereals or dried leguminous vegetables, not farm type machinery",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843710",
    description:
      "Machines; for cleaning, sorting or grading seed, grain or dried leguminous vegetables",
    parent: "8437",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843780",
    description:
      "Machinery; for use in the milling industry or for the working of cereals or dried leguminous vegetables, other than farm-type machinery",
    parent: "8437",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843790",
    description:
      "Machines; parts of those for cleaning, sorting or grading seed, grain or dried leguminous vegetables or for milling or working cereals or dried leguminous vegetables (not farm-type machinery)",
    parent: "8437",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8438",
    description:
      "Machinery n.e.c. in this chapter, for the industrial preparation or manufacture of food or drink; other than machinery for extraction or preparation of animal or fixed vegetable or microbial fats or oils",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843810",
    description:
      "Machinery; industrial, for bakery and for the manufacture of macaroni, spaghetti or similar products",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843820",
    description:
      "Machinery; industrial, for the manufacture of confectionery, cocoa or chocolate",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843830",
    description: "Machinery; industrial, for sugar manufacture",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843840",
    description: "Machinery; industrial, brewery machinery",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843850",
    description:
      "Machinery; industrial, for the preparation of meat or poultry",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843860",
    description:
      "Machinery; industrial, for the preparation of fruits, nuts or vegetables",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843880",
    description:
      "Machinery; used in the industrial preparation or manufacture of food or drink, n.e.c. in heading no. 8438",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843890",
    description:
      "Machinery; parts of those machines used in the industrial preparation or manufacture of food or drink",
    parent: "8438",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8439",
    description:
      "Machinery; for making pulp of fibrous cellulosic material, or for making or finishing paper or paperboard",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "843910",
    description: "Machinery; for making pulp of fibrous cellulosic material",
    parent: "8439",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843920",
    description: "Machinery; for making paper or paperboard",
    parent: "8439",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843930",
    description: "Machinery; for finishing paper or paperboard",
    parent: "8439",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843991",
    description:
      "Machinery; parts of machinery for making pulp of fibrous cellulosic material",
    parent: "8439",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "843999",
    description:
      "Machinery; parts of machinery for making or finishing paper or paperboard",
    parent: "8439",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8440",
    description: "Book-binding machinery; including book-sewing machines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844010",
    description: "Book-binding machinery; including book-sewing machines",
    parent: "8440",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844090",
    description:
      "Book-binding machinery; including book-sewing machines, parts thereof",
    parent: "8440",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8441",
    description:
      "Machines; for making up paper pulp, paper or paperboard, including cutting machines of all kinds",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844110",
    description:
      "Machines; cutting, of all kinds, for making up paper pulp, paper or paperboard",
    parent: "8441",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844120",
    description:
      "Machines; for making bags, sacks or envelopes of paper pulp, paper or paperboard",
    parent: "8441",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844130",
    description:
      "Machines; for making cartons, boxes, cases, tubes, drums or similar containers (other than by moulding), of paper pulp, paper or paperboard",
    parent: "8441",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844140",
    description:
      "Machines; for moulding articles, in paper pulp, paper or paperboard",
    parent: "8441",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844180",
    description:
      "Machinery; n.e.c. in heading no. 8441, for making up paper pulp, paper or paperboard",
    parent: "8441",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844190",
    description:
      "Machinery; parts of machinery for making up paper pulp, paper or paperboard, including cutting machines of all kinds",
    parent: "8441",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8442",
    description:
      "Machinery, apparatus and equipment (excluding machines of headings 8456 to 8465) for preparing or making printing components; plates, cylinders and other printing components; lithographic stones prepared for printing purposes",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844230",
    description:
      "Machinery, apparatus and equipment (excluding machines of heading no. 8456 to 8465) for preparing or making printing components",
    parent: "8442",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844240",
    description:
      "Machinery, apparatus and equipment (excluding machines of heading no. 8456 to 8465) for preparing or making printing components; parts thereof",
    parent: "8442",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844250",
    description:
      "Plates, cylinders and other printing components; lithographic stones prepared for printing purposes (for example, planed, grained or polished)",
    parent: "8442",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8443",
    description:
      "Printing machinery; used for printing by means of plates, cylinders and other printing components of heading 84.42; other printers, copying machines and facsimile machines, whether or not combined; parts and accessories thereof",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844311",
    description: "Printing machinery; offset, reel-fed",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844312",
    description:
      "Printing machinery; offset, sheet-fed, office type (sheet size not exceeding 22 x 36cm in the unfolded state)",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844313",
    description: "Printing machinery; offset, n.e.c. in item no. 8443.1",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844314",
    description:
      "Printing machinery; letterpress, reel-fed, excluding flexographic printing",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844315",
    description:
      "Printing machinery; letterpress, other than reel-fed, excluding flexographic printing",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844316",
    description: "Printing machinery; flexographic",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844317",
    description: "Printing machinery; gravure",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844319",
    description:
      "Printing machinery; used for printing by means of plates, cylinders and other printing components of heading 84.42, n.e.c. in item no. 8443.1",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844331",
    description:
      "Printing, copying, and facsimile machines; machines which perform two or more of the functions of printing, copying or facsimile transmission, capable of connecting to an automatic data processing machine or to a network",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844332",
    description:
      "Printing, copying, and facsimile machines; single-function printing, copying or facsimile machines, capable of connecting to an automatic data processing machine or to a network",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844339",
    description:
      "Printing, copying, and facsimile machines; single-function printing, copying or facsimile machines, not capable of connecting to an automatic data processing machine or to a network",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844391",
    description:
      "Printing machinery used for printing by means of plates, cylinders and other printing components of heading 8442; parts and accessories",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844399",
    description:
      "Printing machinery; parts and accessories, n.e.c. in item no. 8443.91",
    parent: "8443",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8444",
    description:
      "Textile machinery; for extruding, drawing, texturing or cutting man-made textile materials",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844400",
    description:
      "Textile machinery; for extruding, drawing, texturing or cutting man-made textile materials",
    parent: "8444",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8445",
    description:
      "Textile machinery; spinning, doubling, twisting machines, textile reeling or winding machines and machines for preparing textile yarns for use on machines of heading no. 8446 and 8447",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844511",
    description:
      "Textile machinery; carding machines for preparing textile fibres",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844512",
    description:
      "Textile machinery; combing machines for preparing textile fibres",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844513",
    description:
      "Textile machinery; drawing or roving machines for preparing textile fibres",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844519",
    description:
      "Textile machinery; n.e.c. in heading no. 8445, for preparing textile fibres",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844520",
    description: "Textile machinery; spinning machines",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844530",
    description: "Textile machinery; doubling or twisting machines",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844540",
    description:
      "Textile machinery; winding (including weft-winding) or reeling machines",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844590",
    description:
      "Textile machinery; involved in textile fibre or textile yarn preparation and n.e.c. in heading no. 8445",
    parent: "8445",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8446",
    description: "Weaving machines (looms)",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844610",
    description:
      "Weaving machines (looms); for weaving fabrics of a width 30cm or less",
    parent: "8446",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844621",
    description:
      "Weaving machines (looms); for weaving fabrics of a width exceeding 30cm, shuttle type, power looms",
    parent: "8446",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844629",
    description:
      "Weaving machines (looms); for weaving fabrics of a width exceeding 30cm, shuttle type, other than power looms",
    parent: "8446",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844630",
    description:
      "Weaving machines (looms); for weaving fabrics of a width exceeding 30cm, shuttleless type",
    parent: "8446",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8447",
    description:
      "Knitting machines, stitch-bonding machines and machines for making gimped yarn, tulle, lace, embroidery, trimmings, braid or net and machines for tufting",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844711",
    description:
      "Knitting machines; circular, with cylinder diameter not exceeding 165mm",
    parent: "8447",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844712",
    description:
      "Knitting machines; circular, with cylinder diameter exceeding 165mm",
    parent: "8447",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844720",
    description: "Knitting machines; flat, stitch-bonding machines",
    parent: "8447",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844790",
    description:
      "Machines; for making gimped yarn, tulle, lace, embroidery, trimmings, braid or net and machines for tufting",
    parent: "8447",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8448",
    description:
      "Machinery, auxiliary; for use with machines of heading no. 8444 to 8447 (e.g. dobbies, jacquards, automatic stop motions, shuttle changing mechanisms) parts, accessories for machines of heading no. 8444, 8447",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844811",
    description:
      "Machinery, auxiliary; dobbies and jacquards, card reducing, copying, punching or assembling machines for use therewith",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844819",
    description:
      "Machinery, auxiliary; for machines of heading no. 8444, 8445, 8446 or 8447, n.e.c. in item no. 8448.11",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844820",
    description:
      "Machines; parts and accessories of machines or auxiliary machinery of heading no. 8444",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844831",
    description: "Machines, card clothing; parts and accessories",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844832",
    description:
      "Machines; parts and accessories of machines or auxiliary machinery for preparing textile fibres, other than card clothing",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844833",
    description:
      "Machines; parts and accessories of machines or auxiliary machinery, spindles, spindle flyers, spinning rings and ring travellers",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844839",
    description:
      "Machines; parts and accessories of machines or auxiliary machinery of heading no. 8445, n.e.c. in item no. 8448.3",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844842",
    description:
      "Weaving machines (looms); parts including their auxiliary machinery, and accessories thereof, reeds for looms, healds and heald-frames",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844849",
    description:
      "Weaving machines (looms); parts including their auxiliary machinery, and accessories thereof n.e.c. in item no. 8448.4",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844851",
    description:
      "Machines; parts and accessories of machines of heading no. 8447 or auxiliary machinery, sinkers, needles and other articles used in forming stitches",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "844859",
    description:
      "Machines; parts and accessories of machines or auxiliary machinery of heading no. 8447, other than sinkers, needles and other articles used in forming stitches",
    parent: "8448",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8449",
    description:
      "Machinery; for manufacture or finishing felt or non-wovens in the piece or in shapes, including machinery for making felt hats, blocks for making hats",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "844900",
    description:
      "Machinery; for manufacture or finishing felt or non-wovens in the piece or in shapes, including machinery for making felt hats, blocks for making hats",
    parent: "8449",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8450",
    description:
      "Household or laundry-type washing machines; including machines which both wash and dry",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845011",
    description:
      "Washing machines; household or laundry-type, fully-automatic, (of a dry linen capacity not exceeding 10kg)",
    parent: "8450",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845012",
    description:
      "Washing machines; household or laundry-type, with built-in centrifugal drier, (not fully-automatic), of a dry linen capacity not exceeding 10kg",
    parent: "8450",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845019",
    description:
      "Washing machines; household or laundry-type, not fully-automatic, without built-in centrifugal drier, of a dry linen capacity not exceeding 10kg",
    parent: "8450",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845020",
    description:
      "Washing machines; household or laundry-type, of a dry linen capacity exceeding 10kg",
    parent: "8450",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845090",
    description: "Washing machines; parts for household or laundry-type",
    parent: "8450",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8451",
    description:
      "Machinery (not of heading no. 8450) for washing, cleaning, wringing, drying, ironing, pressing, bleaching, dyeing, dressing, finishing, coating or impregnating textile yarn, fabrics or made up articles",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845110",
    description: "Dry-cleaning machines",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845121",
    description: "Drying machines; of a dry linen capacity not exceeding 10kg",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845129",
    description: "Drying machines; of a dry linen capacity exceeding 10kg",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845130",
    description: "Ironing machines and presses (including fusing presses)",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845140",
    description: "Machines; for washing, bleaching or dyeing",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845150",
    description:
      "Machines; for reeling, unreeling, folding, cutting or pinking textile fabrics",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845180",
    description:
      "Machinery; for wringing, dressing, finishing, coating or impregnating textile yarns, fabrics or made up textile articles; for applying paste to base fabric used in manufacture of floor coverings",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845190",
    description: "Machinery; parts, of the machinery of heading no. 8451",
    parent: "8451",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8452",
    description:
      "Sewing machines; other than book-sewing machines of heading no. 8440; furniture, bases and covers specially designed for sewing machines; sewing machine needles",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845210",
    description: "Sewing machines; of the household type",
    parent: "8452",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845221",
    description: "Sewing machines; (not household type), automatic units",
    parent: "8452",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845229",
    description: "Sewing machines; not household or automatic unit type",
    parent: "8452",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845230",
    description: "Sewing machine needles",
    parent: "8452",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845290",
    description:
      "Sewing machines; furniture, bases and covers for sewing machines and parts thereof, and other parts of sewing machines",
    parent: "8452",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8453",
    description:
      "Machinery for preparing, tanning or working hides, skins or leather or for making or repairing footwear or other articles of hides, skins or leather, other than sewing machines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845310",
    description:
      "Machinery; for preparing, tanning or working hides, skins or leather, other than sewing machines",
    parent: "8453",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845320",
    description:
      "Machinery; for making or repairing footwear, other than sewing machines",
    parent: "8453",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845380",
    description:
      "Machinery; for making or repairing articles of hides, skins or leather, other than sewing machines",
    parent: "8453",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845390",
    description:
      "Machinery; parts of those for preparing, tanning or working hides, skins or leather, for making or repairing footwear or other articles of hides, skin or leather, other than sewing machines",
    parent: "8453",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8454",
    description:
      "Converters, ladles, ingot moulds and casting machines; of a kind used metallurgy or in metal foundries",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845410",
    description:
      "Converters; of a type used in metallurgy or in metal foundries",
    parent: "8454",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845420",
    description:
      "Ingot moulds and ladles; of a kind used in metallurgy or in metal foundries",
    parent: "8454",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845430",
    description:
      "Casting machines; of a kind used in metallurgy or in metal foundries",
    parent: "8454",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845490",
    description:
      "Machines; parts of converters, ladles, ingot moulds and casting machines, of a kind used in metallurgy or in metal foundries",
    parent: "8454",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8455",
    description: "Metal-rolling mills and rolls therefor",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845510",
    description: "Metal-rolling mills; tube mills",
    parent: "8455",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845521",
    description:
      "Metal-rolling mills; hot or combination hot and cold rolling mills",
    parent: "8455",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845522",
    description: "Metal-rolling mills; cold",
    parent: "8455",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845530",
    description: "Metal-rolling mills; rolls thereof",
    parent: "8455",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845590",
    description: "Metal-rolling mills; parts thereof",
    parent: "8455",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8456",
    description:
      "Machine-tools; for working any material by removal of material, by laser or other light or photon beam, ultrasonic, electro-discharge, electro-chemical, electron beam, ionic-beam, or plasma arc processes; water-jet cutting machines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845611",
    description:
      "Machine-tools; for working any material by removal of material; operated by laser",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845612",
    description:
      "Machine-tools; for working any material by removal of material; operated by other light or photon beam processes (not laser)",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845620",
    description:
      "Machine-tools; for working any material by removal of material, operated by ultrasonic processes",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845630",
    description:
      "Machine-tools; for working any material by removal of material, operated by electro-discharge processes",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845640",
    description:
      "Machine tools; for working any material by removal of material; operated by plasma arc processes;",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845650",
    description:
      "Machine tools; for working any material by removal of material; operated by water-jet cutting machines",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845690",
    description:
      "Machine tools; for working any material by removal of material; operated by other processes n.e.c. in heading 8456",
    parent: "8456",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8457",
    description:
      "Machining centres, unit construction machines (single station) and multi-station transfer machines for working metal",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845710",
    description: "Machining centres; for working metal",
    parent: "8457",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845720",
    description:
      "Machines; unit construction machines (single station), for working metal",
    parent: "8457",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845730",
    description:
      "Metal machines; multi-station transfer machines, for working metal",
    parent: "8457",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8458",
    description: "Lathes for removing metal",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845811",
    description:
      "Lathes; for removing metal, horizontal, numerically controlled",
    parent: "8458",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845819",
    description:
      "Lathes; for removing metal, horizontal, other than numerically controlled",
    parent: "8458",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845891",
    description:
      "Lathes; for removing metal, numerically controlled, other than horizontal lathes",
    parent: "8458",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845899",
    description:
      "Lathes; for removing metal, other than horizontal or numerically controlled lathes",
    parent: "8458",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8459",
    description:
      "Machine-tools; (including way-type unit head machines) for drilling, boring, milling, threading or tapping by removing metal, other than lathes of heading no. 8458",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "845910",
    description:
      "Machine-tools; way-type unit head machines, for drilling, boring, milling, threading or tapping by removing metal, other than lathes of heading no. 8458",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845921",
    description:
      "Machine-tools; for drilling by removing metal, numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845929",
    description:
      "Machine-tools; for drilling by removing metal, other than numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845931",
    description:
      "Machine-tools; for boring-milling by removing metal, numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845939",
    description:
      "Machine-tools; for boring-milling by removing metal, other than numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845941",
    description:
      "Machine-tools; for boring by removing metal, numerically controlled boring machines, n.e.c. in heading 8459",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845949",
    description:
      "Machine-tools; for boring by removing metal, not numerically controlled boring machines, n.e.c. in heading 8459",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845951",
    description:
      "Machine-tools; for milling by removing metal, knee-type, numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845959",
    description:
      "Machine-tools; for milling by removing metal, knee-type, other than numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845961",
    description:
      "Machine-tools; for milling by removing metal, (not knee-type), numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845969",
    description:
      "Machine-tools; for milling by removing metal, not knee-type, other than numerically controlled",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "845970",
    description: "Machine-tools; for threading or tapping by removing metal",
    parent: "8459",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8460",
    description:
      "Machine-tools; for deburring, sharpening, grinding, honing, lapping, polishing or otherwise finishing metal, sintered metal carbides or cermets by means of grinding stones, abrasives or polishing products",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846012",
    description:
      "Machine-tools; flat-surface grinding machines, numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846019",
    description:
      "Machine-tools; flat-surface grinding machines, other than numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846022",
    description:
      "Machine-tools; grinding machines (excluding flat-surface), centreless, numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846023",
    description:
      "Machine-tools; cylindrical grinding machines (excluding flat-surface and centreless), numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846024",
    description:
      "Machine-tools; grinding machines (excluding flat-surface, cylindrical and centreless), numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846029",
    description:
      "Machine-tools; grinding machines (excluding flat-surface), other than numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846031",
    description:
      "Machine-tools; sharpening (tool or cutter grinding) machines, numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846039",
    description:
      "Machine-tools; sharpening (tool or cutter grinding) machines, other than numerically controlled",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846040",
    description: "Machine-tools; for honing or lapping",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846090",
    description:
      "Machine-tools; for deburring, grinding, polishing or otherwise finishing metal, sintered metal carbides or cermets by means of grinding stones, abrasives or polishing products, n.e.c. in heading no. 8460",
    parent: "8460",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8461",
    description:
      "Machine-tools; for planing, shaping, slotting, broaching, gear cutting and grinding, finishing, sawing, cutting off and other tools working by removing metal, sintered metal carbides or cermets n.e.c.",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846120",
    description:
      "Machine-tools; shaping or slotting machines, working by removing metal, sintered metal carbides or cermets",
    parent: "8461",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846130",
    description:
      "Machine-tools; broaching machines, working by removing metal, sintered metal carbides or cermets",
    parent: "8461",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846140",
    description:
      "Machine-tools; gear cutting, gear grinding or gear finishing machines, working by removing metal, sintered metal carbides or cermets",
    parent: "8461",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846150",
    description:
      "Machine-tools; sawing or cutting-off machines, working by removing metal, sintered metal carbides or cermets",
    parent: "8461",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846190",
    description:
      "Machine-tools; planing machines, and other machine-tools n.e.c. in heading no. 8461; working by removing metal, sinistered metal carbides or cerments.",
    parent: "8461",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8462",
    description:
      "Machine-tools (including presses) for working metal by forging, hammering or die forging (excluding rolling mills); machine-tools (including presses, slitting lines and cut-to-length lines) for working metal by bending, folding, straightening, flattening,",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846211",
    description:
      "Machine-tools; forging and die-forging machines (including presses), closed die forging machines, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846219",
    description:
      "Machine-tools; hot forming machines, hot hammers, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846222",
    description:
      "Machine-tools; bending, folding, straightening or flattening machines (including press brakes) for flat products, for working metal, numerically controlled",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846223",
    description:
      "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled press brakes",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846224",
    description:
      "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled panel benders",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846225",
    description:
      "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled roll forming machines",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846226",
    description:
      "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled bending, folding, straightening or fattening machines (not press brakes, panel benders or roll forming machines)",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846229",
    description:
      "Machine-tools; bending, folding, straightening or flattening machines (including press brakes), for working metal, numerically controlled n.e.c. in item 84.62.2",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846232",
    description:
      "Machine-tools; slitting lines and cut-to-length lines, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846233",
    description:
      "Machine-tools; shearing machines (excluding presses) for flat products, numerically controlled, other than combined punching and shearing machines, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846239",
    description:
      "Machine-tools; shearing machines (excluding presses) for flat products, other than numerically controlled, other than combined punching and shearing machines, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846242",
    description:
      "Machine-tools; punching, notching or nibbling machines (excluding presses) for flat products including combined punching and shearing machines, numerically controlled, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846249",
    description:
      "Machine-tools; punching, notching or nibbling machines (excluding presses) for flat products including combined punching and shearing machines, other than numerically controlled, for working metal",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846251",
    description:
      "Machine-tools; for working tube, pipe, hollow section and bar (excluding presses), for working metal, numerically controlled",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846259",
    description:
      "Machine-tools; for working tube, pipe, hollow section and bar (excluding presses), for working metal, not numerically controlled",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846261",
    description: "Machine-tools; cold metal working presses, hydraulic presses",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846262",
    description:
      "Machine-tools; cold metal working presses, mechanical presses",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846263",
    description: "Machine-tools; cold metal working presses, servo-presses",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846269",
    description:
      "Machine-tools; cold metal working presses, other than hydraulic, mechanical or servo-presses",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846290",
    description:
      "Machine-tools; (including presses) for working metal by forging, hammering or die-forging, for bending, folding, straightening, flattening, shearing, punching, notching or nibbling metal, n.e.c. in heading 8462",
    parent: "8462",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8463",
    description:
      "Machine-tools; n.e.c. for working metal, sintered metal carbides or cermets without removing material",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846310",
    description:
      "Machine-tools; for working metal, sintered metal carbides or cermets, without removing material, draw-benches for bars, tubes, profiles, wire or the like",
    parent: "8463",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846320",
    description:
      "Machine-tools; for working metal, sintered metal carbides or cermets, without removing material, thread rolling machines",
    parent: "8463",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846330",
    description:
      "Machine-tools; machines for working wire, without removing material",
    parent: "8463",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846390",
    description:
      "Machine-tools; for working metal, sintered metal carbides or cermets, without removing material, n.e.c. in heading no. 8463",
    parent: "8463",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8464",
    description:
      "Machine-tools; for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846410",
    description:
      "Machine-tools; sawing machines, for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass",
    parent: "8464",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846420",
    description:
      "Machine-tools; grinding or polishing machines, for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass",
    parent: "8464",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846490",
    description:
      "Machine-tools; for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass, (other than sawing, grinding or polishing machines)",
    parent: "8464",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8465",
    description:
      "Machine-tools; (including machines for nailing, stapling, glueing or otherwise assembling) for working wood, cork, bone, hard plastics or rubber or similar hard materials",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846510",
    description:
      "Machine-tools; which can carry out different types of machining operations without tool change between such operations, for working wood, cork, bone, hard rubber, hard plastics or similar",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846520",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; machining centres",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846591",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; sawing machines",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846592",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; planing, milling or moulding (by cutting) machines",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846593",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; grinding, sanding or polishing machines",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846594",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; bending or assembling machines",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846595",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; drilling or morticing machines",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846596",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; splitting, slicing or paring machines",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846599",
    description:
      "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; n.e.c. in heading no. 8465",
    parent: "8465",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8466",
    description:
      "Parts & accessories suited for use only/mainly with machines of headings 8456-8465, including work/tool holders, self-opening dieheads, dividing heads & other special attachments for the machines; tool holders for any type of tool for working in the hand",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846610",
    description:
      "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; tool holders and self-opening dieheads",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846620",
    description:
      "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; work holders",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846630",
    description:
      "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; dividing heads and other special attachments for machines",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846691",
    description:
      "Parts & accessories suited for use solely/principally; for the machines of heading no. 8464, n.e.c. in heading no. 8466",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846692",
    description:
      "Parts & accessories suited for use solely/principally for the machines of heading no. 8465, n.e.c. in heading no. 8466",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846693",
    description:
      "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; n.e.c. in heading no. 8466",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846694",
    description:
      "Machine-tools; parts and accessories, for the machines of heading no. 8462 or 8463, n.e.c. in heading no. 8466",
    parent: "8466",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8467",
    description:
      "Tools; for working in the hand, pneumatic, hydraulic or with self-contained electric or non-electric motor",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846711",
    description:
      "Tools; for working in the hand, pneumatic, rotary type (including combined rotary-percussion)",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846719",
    description:
      "Tools; for working in the hand, pneumatic, other than rotary type",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846721",
    description:
      "Tools; for working in the hand, with self-contained electric motor; drills of all kinds",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846722",
    description:
      "Tools; for working in the hand, with self-contained electric motor; saws",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846729",
    description:
      "Tools; for working in the hand, with self-contained electric motor; other than saws and drills",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846781",
    description:
      "Tools; for working in the hand, chain saws with self-contained non-electric motor",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846789",
    description:
      "Tools; for working in the hand, (other than chain saws), hydraulic or with self-contained non-electric motor, (not pneumatic)",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846791",
    description:
      "Tools; for working in the hand, parts of chain saws, with self-contained non-electric motor",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846792",
    description: "Tools; for working in the hand, parts of pneumatic tools",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846799",
    description:
      "Tools; for working in the hand, parts thereof for other than chain saws and pneumatic tools",
    parent: "8467",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8468",
    description:
      "Machinery and apparatus for soldering, brazing, welding, whether or not capable of cutting, other than those of heading no. 8515; gas-operated surface tempering machines and appliances",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "846810",
    description:
      "Machinery and apparatus; hand-held blow pipes for soldering, brazing or welding, whether or not capable of cutting",
    parent: "8468",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846820",
    description:
      "Machinery and apparatus; gas operated machinery and apparatus n.e.c. in item no. 8468.10, for soldering, brazing or welding, whether or not capable of cutting",
    parent: "8468",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846880",
    description:
      "Machinery and apparatus; for soldering, brazing or welding, whether or not capable of cutting, n.e.c. in heading no. 8468",
    parent: "8468",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "846890",
    description:
      "Machinery and apparatus; parts, soldering, brazing or welding, whether or not capable of cutting, parts thereof",
    parent: "8468",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8470",
    description:
      "Calculating machines and pocket-size data recording, reproducing and displaying machines with calculating functions; accounting machines, postage-franking machines, ticket-issuing machines and similar, incorporating a calculating device; cash registers",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847010",
    description:
      "Calculating machines; electronic calculators capable of operation without an external source of electric power and pocket-size data recording, reproducing and displaying machines with calculating functions",
    parent: "8470",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847021",
    description:
      "Calculating machines; electronic, incorporating a printing device, needing an external source of power",
    parent: "8470",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847029",
    description:
      "Calculating machines; electronic, (not incorporating a printing device), needing an external power source",
    parent: "8470",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847030",
    description: "Calculating machines; non-electronic",
    parent: "8470",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847050",
    description: "Cash registers",
    parent: "8470",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847090",
    description:
      "Machines incorporating a calculating device; n.e.c. in heading no. 8470",
    parent: "8470",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8471",
    description:
      "Automatic data processing machines and units thereof, magnetic or optical readers, machines for transcribing data onto data media in coded form and machines for processing such data, not elsewhere specified or included",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847130",
    description:
      "Automatic data processing machines; portable, weighing not more than 10kg, consisting of at least a central processing unit, a keyboard and a display",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847141",
    description:
      "Automatic data processing machines; comprising in the same housing at least a central processing unit and an input and output unit, whether or not combined, n.e.c. in item no. 8471.30",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847149",
    description:
      "Automatic data processing machines; presented in the form of systems, n.e.c. in item no. 8471.30 or 8471.41",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847150",
    description:
      "Units of automatic data processing machines; processing units other than those of item no. 8471.41 or 8471.49, whether or not containing in the same housing one or two of the following types of unit: storage units, input units or output units",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847160",
    description:
      "Units of automatic data processing machines; input or output units, whether or not containing storage units in the same housing",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847170",
    description: "Units of automatic data processing machines; storage units",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847180",
    description:
      "Units of automatic data processing machines; n.e.c. in item no. 8471.50, 8471.60 or 8471.70",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847190",
    description:
      "Magnetic or optical readers, machines for transcribing data onto data media in coded form and machines for processing such data, not elsewhere specified or included",
    parent: "8471",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8472",
    description: "Office machines; not elsewhere classified",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847210",
    description: "Office machines; duplicating machines",
    parent: "8472",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847230",
    description:
      "Office machines; for sorting or folding mail or for inserting mail in envelopes or bands, machines for opening, closing or sealing mail and machines for affixing or cancelling postage stamps",
    parent: "8472",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847290",
    description: "Office machines; not elsewhere classified",
    parent: "8472",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8473",
    description:
      "Machinery; parts and accessories (other than covers, carrying cases and the like) suitable for use solely or principally with machines of headings 84.70 to 84.72",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847321",
    description:
      "Calculating machines; parts and accessories of the electronic calculating machines of item no. 8470.10, 8470.21 or 8470.29 (other than covers, carrying cases and the like)",
    parent: "8473",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847329",
    description:
      "Machinery; parts and accessories of the machines of item no. 8470.30. 8470.50 or 8470.90 (other than covers, carrying cases and the like)",
    parent: "8473",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847330",
    description:
      "Machinery; parts and accessories (other than covers, carrying cases and the like) of the machines of heading no. 8471",
    parent: "8473",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847340",
    description:
      "Machinery; parts and accessories (other than covers, carrying cases and the like) of the machines of heading no. 8472",
    parent: "8473",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847350",
    description:
      "Machines; parts and accessories (other than covers, carrying cases and the like) equally suitable for use with machines of two or more of the headings 8470 to 8472",
    parent: "8473",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8474",
    description:
      "Machinery for sorting, screening, separating, washing, crushing, grinding, mixing or kneading earth, stone, ores in solid form, shaping, moulding machinery for solid mineral fuels",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847410",
    description:
      "Machines; for sorting, screening, separating or washing earth, stone, ores or other mineral substances",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847420",
    description:
      "Machines; for crushing or grinding earth, stone, ores or other mineral substances",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847431",
    description: "Machines; concrete or mortar mixers",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847432",
    description: "Machines; for mixing mineral substances with bitumen",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847439",
    description:
      "Machines; for mixing or kneading mineral substances, excluding concrete mixers and machines for mixing mineral substances with bitumen",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847480",
    description:
      "Machines; for agglomerating, shaping or moulding solid mineral fuels, ceramic paste, unhardened cements, plastering materials in powder or paste form, machines for forming foundry moulds of sand",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847490",
    description:
      "Machines, for sorting, screening, separating, washing, crushing etc mineral substances, for agglomerating, shaping or moulding solid fuels, ceramic pastes etc, for forming foundry moulds of sand; parts",
    parent: "8474",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8475",
    description:
      "Machines; for assembling electric or electronic lamps, tubes, valves, flashbulbs, in glass envelopes, machines for manufacturing or hot working glass or glassware",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847510",
    description:
      "Machines; for assembling electric or electronic lamps, tubes, valves or flashbulbs, in glass envelopes",
    parent: "8475",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847521",
    description:
      "Machines; for manufacturing or hot working glass or glassware, for making optical fibres and preforms thereof",
    parent: "8475",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847529",
    description:
      "Machines; for manufacturing or hot working glass or glassware, not for making optical fibres and preforms thereof",
    parent: "8475",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847590",
    description:
      "Machines; parts, of those for assembling electric or electronic lamps, tubes, valves or flash-bulbs, in glass envelopes and manufacturing or hot working glass or glassware",
    parent: "8475",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8476",
    description:
      "Automatic goods-vending machines (e.g. postage stamp, cigarette, food or beverage machines), including money-changing machines",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847621",
    description:
      "Machines; automatic beverage-vending machines, incorporating heating or refrigerating devices",
    parent: "8476",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847629",
    description:
      "Machines; automatic beverage-vending machines, not incorporating heating or refrigerating devices",
    parent: "8476",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847681",
    description:
      "Machines; automatic goods-vending machines, (e.g. postage stamp, cigarette, food or money-changing machines, excluding beverage-vending machines), incorporating heating or refrigerating devices",
    parent: "8476",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847689",
    description:
      "Machines; automatic goods-vending machines, (e.g. postage stamp, cigarette, food or money-changing machines, excluding beverage-vending machines), not incorporating heating or refrigerating devices",
    parent: "8476",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847690",
    description: "Machines; parts of automatic goods-vending machines",
    parent: "8476",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8477",
    description:
      "Machinery; for working rubber or plastics or for the manufacture of products from these materials, n.e.c. in this chapter",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847710",
    description:
      "Machinery; injection-moulding machines, for working rubber or plastics or for the manufacture of products from these materials",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847720",
    description:
      "Machinery; extruders, for working rubber or plastics or for the manufacture of products from these materials",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847730",
    description:
      "Machinery; blow moulding machines, for working rubber or plastics or for the manufacture of products from these materials",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847740",
    description:
      "Machinery; vacuum moulding machines and other thermoforming machines, for working rubber or plastics or for the manufacture of products from these materials",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847751",
    description:
      "Machinery; for moulding or retreading pneumatic tyres or for moulding or otherwise forming inner tubes",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847759",
    description:
      "Machinery; for moulding or forming, for working rubber or plastics or for the manufacture of products from these materials, n.e.c. in this chapter",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847780",
    description:
      "Machinery; for working rubber or plastics or for the manufacture of products from these materials, n.e.c. in this chapter",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847790",
    description:
      "Machinery; parts of the machines of heading no. 8477, n.e.c. in item no. 8477.90",
    parent: "8477",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8478",
    description:
      "Machinery; for preparing or making up tobacco, n.e.c. in this chapter",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847810",
    description:
      "Machinery; for preparing or making up tobacco, n.e.c. in this chapter",
    parent: "8478",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847890",
    description:
      "Machinery; parts of those for preparing or making up tobacco, n.e.c. in this chapter",
    parent: "8478",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8479",
    description:
      "Machinery and mechanical appliances; having individual functions, n.e.c. in this chapter",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "847910",
    description:
      "Machinery and mechanical appliances; for public works, building or the like",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847920",
    description:
      "Machinery; for the extraction or preparation of animal or fixed vegetable or microbial fats or oils",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847930",
    description:
      "Machinery and mechanical appliances; presses for the manufacture of particle or fibre building board of wood or other ligneous materials and other machinery for treating wood or cork",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847940",
    description: "Machines; for making rope or cable",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847950",
    description:
      "Machinery and mechanical appliances; industrial robots, n.e.c. or included",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847960",
    description: "Machinery and mechanical appliances; evaporative air coolers",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847971",
    description:
      "Machinery and mechanical appliances; passenger boarding bridges, of a kind used in airports",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847979",
    description:
      "Machinery and mechanical appliances; passenger boarding bridges, other than of a kind used in airports",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847981",
    description:
      "Machines and mechanical appliances; for treating metal, including electric wire coil-winders",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847982",
    description:
      "Machines; for mixing, kneading, crushing, grinding, screening, sifting, homogenising, emulsifying or stirring",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847983",
    description: "Machines and mechanical appliances; cold isostatic presses",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847989",
    description:
      "Machines and mechanical appliances; having individual functions, n.e.c. or included in this chapter",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "847990",
    description:
      "Machines and mechanical appliances; parts, of those having individual functions",
    parent: "8479",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8480",
    description:
      "Moulding boxes for metal foundry, moulding patterns, moulds for metals (excluding ingot moulds), metal carbides, glass, mineral materials, rubber or plastics",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848010",
    description: "Moulding boxes; for metal foundry",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848020",
    description:
      "Mould bases; for metal, metal carbides, glass, mineral materials, rubber or plastics",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848030",
    description:
      "Moulding patterns; of metal, metal carbides, glass, mineral materials, rubber or plastics",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848041",
    description:
      "Moulds; for metal or metal carbides, injection or compression types",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848049",
    description:
      "Moulds; for metal or metal carbides, other than injection or compression types",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848050",
    description: "Moulds; for glass",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848060",
    description: "Moulds; for mineral materials",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848071",
    description:
      "Moulds; for rubber or plastics, injection or compression types",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848079",
    description:
      "Moulds; for rubber or plastics, other than injection or compression types",
    parent: "8480",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8481",
    description:
      "Taps, cocks, valves and similar appliances for pipes, boiler shells, tanks, vats or the like, including pressure-reducing valves and thermostatically controlled valves",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848110",
    description:
      "Valves; pressure reducing, for pipes, boiler shells, tanks, vats or the like",
    parent: "8481",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848120",
    description: "Valves; for oleohydraulic or pneumatic transmissions",
    parent: "8481",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848130",
    description:
      "Valves; check (nonreturn) valves, for pipes, boiler shells, tanks, vats or the like",
    parent: "8481",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848140",
    description:
      "Valves; safety or relief valves, for pipes, boiler shells, tanks, vats or the like",
    parent: "8481",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848180",
    description:
      "Taps, cocks, valves and similar appliances; for pipes, boiler shells, tanks, vats or the like, including thermostatically controlled valves",
    parent: "8481",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848190",
    description: "Taps, cocks, valves and similar appliances; parts thereof",
    parent: "8481",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8482",
    description: "Ball or roller bearings",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848210",
    description: "Ball bearings",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848220",
    description:
      "Bearings; tapered roller bearings, including cone and tapered roller assemblies",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848230",
    description: "Bearings; spherical roller bearings",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848240",
    description:
      "Bearings; needle roller bearings, including cage and needle roller assemblies",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848250",
    description:
      "Bearings; cylindrical roller bearings, including cage and roller assemblies n.e.c. in heading no. 8482",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848280",
    description:
      "Bearings; n.e.c. in heading no. 8482, including combined ball/roller",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848291",
    description: "Bearings; parts, balls, needles and rollers",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848299",
    description: "Bearings; parts, (other than balls, needles and rollers)",
    parent: "8482",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8483",
    description:
      "Transmission shafts (including cam and crank) and cranks; bearing housings and plain shaft bearings; gears and gearing; ball or roller screws; gear boxes and other speed changers; flywheels and pulleys; clutches and shaft couplings",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848310",
    description:
      "Transmission shafts (including cam shafts and crank shafts) and cranks",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848320",
    description: "Bearing housings, incorporating ball or roller bearings",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848330",
    description:
      "Bearing housings, not incorporating ball or roller bearings and plain shaft bearings",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848340",
    description:
      "Gears and gearing; (not toothed wheels, chain sprockets and other transmission elements presented separately); ball or roller screws; gear boxes and other speed changers, including torque converters",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848350",
    description: "Pulleys and flywheels, including pulley blocks",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848360",
    description: "Clutches and shaft couplings (including universal joints)",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848390",
    description:
      "Transmission components; toothed wheels, chain sprockets and other transmission elements presented separately; parts",
    parent: "8483",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8484",
    description:
      "Gaskets and similar joints of metal sheeting combined with other material or of two or more layers of metal; sets or assortments of gaskets and similar joints, dissimilar in composition, put up in pouches, envelopes or similar packings; mechanical seals",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848410",
    description:
      "Gaskets and similar joints; of metal sheeting combined with other material or two or more layers of metal",
    parent: "8484",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848420",
    description: "Seals; mechanical",
    parent: "8484",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848490",
    description:
      "Gasket sets or assortments of gaskets and similar joints; dissimilar in composition, put up in pouches, envelopes or similar packings",
    parent: "8484",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8485",
    description: "Machines for additive manufacturing",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848510",
    description: "Machines for additive manufacturing; by metal deposit",
    parent: "8485",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848520",
    description:
      "Machines for additive manufacturing; by plastic or rubber deposit",
    parent: "8485",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848530",
    description:
      "Machines for additive manufacturing; by plaster, cement, ceramics or glass deposit",
    parent: "8485",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848580",
    description:
      "Machines for additive manufacturing; by other than metal, plastic, rubber, plaster, cement, ceramics or glass deposits",
    parent: "8485",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848590",
    description: "Machines for additive manufacturing; parts",
    parent: "8485",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8486",
    description:
      "Machines and apparatus of a kind used solely or principally for the manufacture of semiconductor boules or wafers, semiconductor devices, electronic integrated circuits or flat panel displays; machines & apparatus specified in note 11 (C) to this Chapter",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848610",
    description:
      "Machines and apparatus of a kind used solely or principally for the manufacture of semiconductor boules or wafers",
    parent: "8486",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848620",
    description:
      "Machines and apparatus of a kind used solely or principally for the manufacture of semiconductor devices or of electronic integrated circuits",
    parent: "8486",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848630",
    description:
      "Machines and apparatus of a kind used solely or principally for the manufacture of flat panel displays",
    parent: "8486",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848640",
    description:
      "Machines and apparatus of a kind used solely or principally for the manufacture or repair of masks and reticles, assembling semiconductor devices or electronic integrated circuits, or for lifting, handling, loading or unloading items of heading 8486",
    parent: "8486",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848690",
    description:
      "Machines and apparatus of heading 8486; parts and accessories",
    parent: "8486",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8487",
    description:
      "Machinery parts; not containing electrical connectors, insulators, coils, contacts or other electrical features, n.e.c. in this chapter",
    parent: "84",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "848710",
    description: "Ships' or boats' propellers and blades therefor",
    parent: "8487",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "848790",
    description:
      "Machinery parts; not containing electrical connectors, insulators, coils, contacts or other electrical features, n.e.c. in chapter 84, other than ships' or boats' propellers and blades therefor",
    parent: "8487",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "85",
    description:
      "Electrical machinery and equipment and parts thereof; sound recorders and reproducers; television image and sound recorders and reproducers, parts and accessories of such articles",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVI",
    hscode: "8501",
    description: "Electric motors and generators (excluding generating sets)",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850110",
    description: "Electric motors; of an output not exceeding 37.5W",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850120",
    description:
      "Electric motors; universal AC/DC of an output exceeding 37.5W",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850131",
    description:
      "Electric motors and generators; DC, of an output not exceeding 750W",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850132",
    description:
      "Electric motors and generators; DC, of an output exceeding 750W but not exceeding 75kW",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850133",
    description:
      "Electric motors and generators; DC, of an output exceeding 75kW but not exceeding 375kW",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850134",
    description:
      "Electric motors and generators; DC, of an output exceeding 375kW",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850140",
    description: "Electric motors; AC motors, single-phase",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850151",
    description:
      "Electric motors; AC motors, multi-phase, of an output not exceeding 750W",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850152",
    description:
      "Electric motors; AC motors, multi-phase, of an output exceeding 750W but not exceeding 75kW",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850153",
    description:
      "Electric motors; AC motors, multi-phase, of an output exceeding 75kW",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850161",
    description:
      "Generators; AC generators, (alternators), other than photovoltaic generators, of an output not exceeding 75kVA",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850162",
    description:
      "Electric generators; AC generators, (alternators), other than photovoltaic generators, of an output exceeding 75kVA but not exceeding 375kVA",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850163",
    description:
      "Electric generators; AC generators, (alternators), other than photovoltaic generators, of an output exceeding 375kVA but not exceeding 750kVA",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850164",
    description:
      "Electric generators; AC generators, (alternators), other than photovoltaic generators, of an output exceeding 750kVA",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850171",
    description:
      "Electric generators; photovoltaic DC generators, of an output not exceeding 50W",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850172",
    description:
      "Electric generators; photovoltaic DC generators, of an output exceeding 50W",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850180",
    description:
      "Electric generators; (excluding generating sets), photovoltaic AC generators (alternators)",
    parent: "8501",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8502",
    description: "Electric generating sets and rotary converters",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850211",
    description:
      "Electric generating sets; with compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of an output not exceeding 75kVA",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850212",
    description:
      "Electric generating sets; with compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of an output exceeding 75kVA but not exceeding 375kVA",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850213",
    description:
      "Electric generating sets; with compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of an output exceeding 375kVA",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850220",
    description:
      "Electric generating sets; with spark-ignition internal combustion piston engines",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850231",
    description:
      "Electric generating sets; wind-powered, (excluding those with spark-ignition or compression-ignition internal combustion piston engines)",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850239",
    description:
      "Electric generating sets; (excluding those with spark-ignition or compression-ignition internal combustion piston engines), other than wind powered",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850240",
    description: "Electric rotary converters",
    parent: "8502",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8503",
    description:
      "Electric motors and generators; parts suitable for use solely or principally with the machines of heading no. 8501 or 8502",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850300",
    description:
      "Electric motors and generators; parts suitable for use solely or principally with the machines of heading no. 8501 or 8502",
    parent: "8503",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8504",
    description:
      "Electric transformers, static converters (e.g. rectifiers) and inductors",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850410",
    description: "Discharge lamps or tubes; ballasts therefor",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850421",
    description:
      "Electrical transformers; liquid dielectric, having a power handling capacity not exceeding 650kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850422",
    description:
      "Electrical transformers; liquid dielectric, having a power handling capacity exceeding 650kVA but not exceeding 10,000kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850423",
    description:
      "Electrical transformers; liquid dielectric, having a power handling capacity exceeding 10,000kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850431",
    description:
      "Electrical transformers; n.e.c. in item no. 8504.2, having a power handling capacity not exceeding 1kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850432",
    description:
      "Transformers; n.e.c. in item no. 8504.2, having a power handling capacity exceeding 1kVA but not exceeding 16kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850433",
    description:
      "Transformers; n.e.c. in item no. 8504.2, having a power handling capacity exceeding 16kVA but not exceeding 500kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850434",
    description:
      "Transformers; n.e.c. in item no. 8504.2, having a power handling capacity exceeding 500kVA",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850440",
    description: "Electrical static converters",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850450",
    description: "Electrical inductors; n.e.c. in heading no. 8504",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850490",
    description:
      "Electrical transformers, static converters and inductors; parts thereof",
    parent: "8504",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8505",
    description:
      "Electro-magnets; permanent magnets, intended permanent magnets; electro-magnetic, permanent magnet chucks, clamps, similar; electromagnetic couplings, clutches, brakes; electro-magnetic lifting heads",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850511",
    description:
      "Magnets; permanent magnets and articles intended to become permanent magnets after magnetisation, of metal",
    parent: "8505",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850519",
    description:
      "Magnets; permanent magnets and articles intended to become permanent magnets after magnetisation, other than of metal",
    parent: "8505",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850520",
    description: "Magnets; electro-magnetic couplings, clutches and brakes",
    parent: "8505",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850590",
    description:
      "Magnets; electro-magnets, holding devices and parts n.e.c. in heading no. 8505",
    parent: "8505",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8506",
    description: "Cells and batteries; primary",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850610",
    description: "Cells and batteries; primary, manganese dioxide",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850630",
    description: "Cells and batteries; primary, mercuric oxide",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850640",
    description: "Cells and batteries; primary, silver oxide",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850650",
    description: "Cells and batteries; primary, lithium",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850660",
    description: "Cells and batteries; primary, air-zinc",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850680",
    description:
      "Cells and batteries; primary, (other than manganese dioxide, mercuric oxide, silver oxide, lithium or air-zinc)",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850690",
    description: "Cells and batteries; primary, parts thereof",
    parent: "8506",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8507",
    description:
      "Electric accumulators, including separators therefor; whether or not rectangular (including square)",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850710",
    description:
      "Electric accumulators; lead-acid, of a kind used for starting piston engines, including separators, whether or not rectangular (including square)",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850720",
    description:
      "Electric accumulators; lead-acid, (other than for starting piston engines), including separators, whether or not rectangular (including square)",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850730",
    description:
      "Electric accumulators; nickel-cadmium, including separators, whether or not rectangular (including square)",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850750",
    description:
      "Electric accumulators; nickel-metal hydride, including separators, whether or not rectangular (including square)",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850760",
    description:
      "Electric accumulators; lithium-ion, including separators, whether or not rectangular (including square)",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850780",
    description:
      "Electric accumulators; other than lead-acid, nickel-cadmium, nickel-metal hydride and lithium-ion, including separators, whether or not rectangular (including square)",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850790",
    description: "Electric accumulators; parts n.e.c. in heading no. 8507",
    parent: "8507",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8508",
    description: "Vacuum cleaners",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850811",
    description:
      "Vacuum cleaners, with self-contained electric motor, of a power not exceeding 1,500 W and having a dust bag or other receptacle capacity not exceeding 20L",
    parent: "8508",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850819",
    description:
      "Vacuum cleaners, with self-contained electric motor, n.e.c. in item no. 8508.1",
    parent: "8508",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850860",
    description:
      "Vacuum cleaners, other than with a self-contained electric motor",
    parent: "8508",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850870",
    description: "Parts of vacuum cleaners",
    parent: "8508",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8509",
    description:
      "Electro-mechanical domestic appliances; with self-contained electric motor, other than vacuum cleaners of heading 85.08.",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "850940",
    description:
      "Electro-mechanical domestic appliances; food grinders and mixers, fruit or vegetable juice extractors, with self-contained electric motor",
    parent: "8509",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850980",
    description:
      "Electro-mechanical domestic appliances; with self-contained electric motor, other than vacuum cleaners of heading 85.08, n.e.c. in heading no. 8509",
    parent: "8509",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "850990",
    description:
      "Electro-mechanical domestic appliances; parts for the appliances of heading no. 8509",
    parent: "8509",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8510",
    description:
      "Shavers, hair clippers and hair removing appliances, with self-contained electric motor",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851010",
    description: "Shavers; with self-contained electric motor",
    parent: "8510",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851020",
    description: "Hair clippers; with a self-contained electric motor",
    parent: "8510",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851030",
    description: "Hair-removing appliances; with self-contained electric motor",
    parent: "8510",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851090",
    description:
      "Shavers and hair clippers; parts of those with self-contained electric motor",
    parent: "8510",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8511",
    description:
      "Ignition or starting equipment; used for spark-ignition or compression-ignition internal combustion engines; generators and cut outs used in conjunction with such engines",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851110",
    description:
      "Ignition or starting equipment; spark plugs, of a kind used for spark or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851120",
    description:
      "Ignition or starting equipment; ignition magnetos, magneto-dynamos and magnetic flywheels, of a kind used for spark or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851130",
    description:
      "Ignition or starting equipment; distributors and ignition coils of a kind used for spark-ignition or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851140",
    description:
      "Ignition or starting equipment; starter motors and dual purpose starter-generators, of a kind used for spark or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851150",
    description:
      "Ignition or starting equipment; generators n.e.c. in heading no. 8511, of a kind used for spark or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851180",
    description:
      "Ignition or starting equipment; n.e.c. in heading no. 8511, of a kind used for spark or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851190",
    description:
      "Ignition or starting equipment; parts of the equipment of heading no. 8511, for use in spark-ignition or compression-ignition internal combustion engines",
    parent: "8511",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8512",
    description:
      "Lighting or visual signalling equipment (excluding articles of heading no. 8539), windscreen wipers, defrosters and demisters; electrical, of a kind used for cycles or motor vehicles",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851210",
    description:
      "Lighting or visual signalling equipment; electrical, of a kind used on bicycles, excluding articles of heading no. 8539",
    parent: "8512",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851220",
    description:
      "Lighting or visual signalling equipment; electrical, of a kind used on motor vehicles (excluding articles of heading no. 8539)",
    parent: "8512",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851230",
    description:
      "Sound signalling equipment; electrical, used on cycles or motor vehicles (excluding articles of heading no. 8539)",
    parent: "8512",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851240",
    description:
      "Windscreen wipers, defrosters and demisters; electrical, of kinds used for cycles or motor vehicles",
    parent: "8512",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851290",
    description:
      "Lighting or signalling equipment; electrical, (excluding articles of heading no. 8539), windscreen wipers, defrosters and demisters; parts, of those kinds used for cycles or motor vehicles",
    parent: "8512",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8513",
    description:
      "Lamps; portable, electric, designed to function by their own source of energy (e.g. dry batteries, accumulators, magnetos), excluding lighting equipment of heading no. 8512",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851310",
    description:
      "Lamps; portable, electric, designed to function by their own source of energy (excluding lighting equipment of heading no. 8512)",
    parent: "8513",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851390",
    description:
      "Lamps; parts of portable, electric lamps of heading no. 8513, designed to function by their own source of energy",
    parent: "8513",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8514",
    description:
      "Industrial or laboratory electric furnaces and ovens (including those functioning by induction or dielectric loss); other industrial or laboratory equipment for the heat treatment of materials by induction or dielectric loss",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851411",
    description:
      "Furnaces and ovens; electric, for industrial or laboratory use, resistance heated; hot isostatic presses",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851419",
    description:
      "Furnaces and ovens; electric, for industrial or laboratory use, resistance heated; other than hot isostatic presses, for the manufacture of semiconductor devices on semiconductor wafers",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851420",
    description:
      "Furnaces and ovens; electric, for industrial or laboratory use, functioning by induction or dielectric loss",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851431",
    description:
      "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated, electron beam furnaces",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851432",
    description:
      "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated, plasma and vacuum arc furnaces",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851439",
    description:
      "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated, other than electron beam, plasma or vacuum arc furnaces",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851440",
    description:
      "Heating equipment; for the heat treatment of materials by induction or dielectric loss, industrial or laboratory, other than furnaces and ovens",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851490",
    description:
      "Furnaces, ovens and heating equipment; parts of the industrial or laboratory equipment of heading no. 8514",
    parent: "8514",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8515",
    description:
      "Electric (electrically heated gas) soldering, brazing, welding machines and apparatus, capable or not of cutting, electric machines and apparatus for hot spraying of metals or sintered carbides",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851511",
    description:
      "Brazing or soldering machines and apparatus; soldering irons and guns, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851519",
    description:
      "Brazing or soldering machines and apparatus; other than soldering irons and guns, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851521",
    description:
      "Welding machines and apparatus; for resistance welding of metal, fully or partly automatic, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851529",
    description:
      "Welding machines and apparatus; for resistance welding of metal, other than fully or partly automatic, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851531",
    description:
      "Welding machines and apparatus; for arc (including plasma arc) welding of metals, fully or partly automatic, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851539",
    description:
      "Welding machines and apparatus; for arc (including plasma arc) welding of metals, other than fully or partly automatic, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851580",
    description:
      "Welding machines and apparatus; n.e.c. in heading no. 8515, whether or not capable of cutting",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851590",
    description:
      "Welding, brazing or soldering machines; parts of the machines of heading no. 8515",
    parent: "8515",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8516",
    description:
      "Electric water, space, soil heaters; electro-thermic hair-dressing apparatus; hand dryers, irons; electro-thermic appliances for domestic purposes; electro heating resistors, not of heading no. 8545",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851610",
    description:
      "Heaters; electric, instantaneous or storage water and immersion heaters",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851621",
    description: "Heating apparatus; electric storage heating radiators",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851629",
    description:
      "Heating apparatus; electric soil heating apparatus and space heating apparatus (excluding storage heating radiators)",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851631",
    description: "Hair-dressing apparatus; electro-thermic hair dryers",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851632",
    description:
      "Hair-dressing apparatus; electro-thermic, other than hair dryers",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851633",
    description: "Hand-drying apparatus; electro-thermic",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851640",
    description: "Smoothing irons; electric",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851650",
    description: "Ovens; microwave, of a kind used for domestic purposes",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851660",
    description:
      "Ovens, cookers, cooking plates, boiling rings, grillers and roasters; of a kind used for domestic purposes (excluding microwaves)",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851671",
    description:
      "Electro-thermic appliances; coffee or tea makers, of a kind used for domestic purposes",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851672",
    description:
      "Electro-thermic appliances; toasters, of a kind used for domestic purposes",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851679",
    description:
      "Electro-thermic appliances; n.e.c. in heading no. 8516, used for domestic purposes",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851680",
    description:
      "Resistors; electric heating, other than those of heading no. 8545",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851690",
    description:
      "Electro-thermic appliances; parts, of heating resistors, of water, space and soil heaters, hair-dressing apparatus, hand dryers, smoothing irons and other domestic appliances of heading no. 8516",
    parent: "8516",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8517",
    description:
      "Telephone sets, including smartphones and other telephones for cellular/wireless networks; other apparatus for the transmission or reception of voice, images or other data (including wired/wireless networks), excluding items of 8443, 8525, 8527, or 8528",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851711",
    description: "Line telephone sets with cordless handsets",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851713",
    description:
      "Telephone sets; smartphones for cellular or other wireless networks",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851714",
    description:
      "Telephone sets; other than smartphones, for cellular or other wireless networks",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851718",
    description: "Telephone sets n.e.c. in item no. 8517.1",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851761",
    description: "Base stations",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851762",
    description:
      "Communication apparatus (excluding telephone sets or base stations); machines for the reception, conversion and transmission or regeneration of voice, images or other data, including switching and routing apparatus",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851769",
    description:
      "Communication apparatus (excluding telephone sets or base stations); machines for the transmission or reception of voice, images or other data (including wired/wireless networks), n.e.c. in item no. 8517.6",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851771",
    description:
      "Communication apparatus; parts, aerials and aerial reflectors of all kinds, part suitable for use therewith",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851779",
    description:
      "Communication apparatus; parts, other than aerials and aerial reflectors of all kinds",
    parent: "8517",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8518",
    description:
      "Microphones and their stands; loudspeakers, mounted or not in their enclosures; headphones and earphones, combined or not with a microphone, and sets of a microphone and one or more loudspeakers; audio-frequency and electric sound amplifiers and sets",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851810",
    description: "Microphones and stands therefor",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851821",
    description: "Loudspeakers; single, mounted in their enclosures",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851822",
    description: "Loudspeakers; multiple, mounted in the same enclosure",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851829",
    description: "Loudspeakers; not mounted in their enclosures",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851830",
    description:
      "Headphones and earphones, whether or not combined with a microphone, and sets consisting of a microphone and one or more loudspeakers",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851840",
    description: "Amplifiers; audio-frequency electric",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851850",
    description: "Amplifier sets; electric sound",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851890",
    description:
      "Microphones, headphones, earphones, amplifier equipment; parts of the equipment of heading no. 8518",
    parent: "8518",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8519",
    description: "Sound recording or reproducing apparatus",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "851920",
    description:
      "Sound recording or reproducing apparatus; operated by coins, banknotes, bank cards, tokens or by other means of payment",
    parent: "8519",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851930",
    description:
      "Sound recording or reproducing apparatus; turntables (record-decks)",
    parent: "8519",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851981",
    description:
      "Sound recording or reproducing apparatus; using magnetic, optical or semiconductor media, n.e.c. in item no 8519.20, 8519.30 or 8519.50",
    parent: "8519",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "851989",
    description:
      "Sound recording or reproducing apparatus; n.e.c. in heading no 8519",
    parent: "8519",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8521",
    description: "Video recording or reproducing apparatus",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852110",
    description: "Video recording or reproducing apparatus; magnetic tape-type",
    parent: "8521",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852190",
    description:
      "Video recording or reproducing apparatus; other than magnetic tape-type",
    parent: "8521",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8522",
    description:
      "Sound or video recording apparatus; parts and accessories suitable for use solely or principally with the apparatus of heading 8519 or 8521",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852210",
    description:
      "Sound recording or reproducing apparatus; parts and accessories thereof, pick-up cartridges",
    parent: "8522",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852290",
    description:
      "Sound or video recording or reproducing apparatus; parts and accessories thereof, other than pick-up cartridges",
    parent: "8522",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8523",
    description:
      "Discs, tapes, solid-state non-volatile storage devices, smart cards and other media for the recording of sound or of other phenomena, whether or not recorded, including matrices and masters for the production of discs, excluding products of Chapter 37",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852321",
    description:
      "Magnetic media; cards incorporating a magnetic stripe, whether or not recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852329",
    description:
      "Magnetic media; other than cards incorporating a magnetic stripe, whether or not recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852341",
    description: "Optical media; unrecorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852349",
    description: "Optical media; recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852351",
    description:
      "Semiconductor media; solid-state non-volatile storage devices, whether or not recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852352",
    description:
      "Semiconductor media; smart cards, whether or not recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852359",
    description:
      "Semiconductor media; other than smart cards, whether or not recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852380",
    description:
      "Media n.e.c. in heading 8523, whether or not recorded, excluding products of Chapter 37",
    parent: "8523",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8524",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852411",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens; of liquid crystals, without drivers or control circuits",
    parent: "8524",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852412",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens; of organic light-emitting diodes (OLED), without drivers or control circuits",
    parent: "8524",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852419",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens; of other than liquid crystals or organic light-emitting diodes (OLED), without drivers or control circuits",
    parent: "8524",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852491",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens; of liquid crystals, with drivers or control circuits",
    parent: "8524",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852492",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens; of organic light-emitting diodes (OLED), with drivers or control circuits",
    parent: "8524",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852499",
    description:
      "Flat panel display modules, whether or not incorporating touch-sensitive screens; of other than liquid crystals or organic light-emitting diodes (OLED), with drivers or control circuits",
    parent: "8524",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8525",
    description:
      "Transmission apparatus for radio-broadcasting or television, whether or not incorporating reception apparatus or sound recording or reproducing apparatus; television cameras, digital cameras and video camera recorders",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852550",
    description:
      "Transmission apparatus for radio-broadcasting or television, whether or not incorporating sound recording or reproducing apparatus, not incorporating reception apparatus",
    parent: "8525",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852560",
    description:
      "Transmission apparatus for radio-broadcasting or television, whether or not incorporating sound recording or reproducing apparatus, incorporating reception apparatus",
    parent: "8525",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852581",
    description:
      "Television cameras, digital cameras and video camera recorders; high-speed goods as specified in subheading note 1 to this chapter",
    parent: "8525",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852582",
    description:
      "Television cameras, digital cameras and video camera recorders; radiation-hardened or radiation-tolerant goods as specified in subheading note 2 to this chapter",
    parent: "8525",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852583",
    description:
      "Television cameras, digital cameras and video camera recorders; night vision goods as specified in subheading note 3 to this chapter",
    parent: "8525",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852589",
    description: "Television cameras; n.e.c. in item no 8525.8",
    parent: "8525",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8526",
    description:
      "Radar apparatus, radio navigational aid apparatus and radio remote control apparatus",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852610",
    description: "Radar apparatus",
    parent: "8526",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852691",
    description: "Radio navigational aid apparatus",
    parent: "8526",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852692",
    description: "Radio remote control apparatus",
    parent: "8526",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8527",
    description:
      "Reception apparatus for radio-broadcasting, whether or not combined, in the same housing, with sound recording or reproducing apparatus or a clock.",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852712",
    description:
      "Radio broadcast receivers capable of operating without an external power source; pocket-size radio cassette-players",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852713",
    description:
      "Radio broadcast receivers capable of operating without an external power source; apparatus (other than pocket-size radio cassette-players), combined with sound recording or reproducing apparatus",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852719",
    description:
      "Radio broadcast receivers capable of operating without an external power source; n.e.c. in item no. 8527.1",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852721",
    description:
      "Radio-broadcast receivers not capable of operating without an external source of power, of a kind used in motor vehicles; combined with sound recording or reproducing apparatus",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852729",
    description:
      "Radio-broadcast receivers not capable of operating without an external source of power, of a kind used in motor vehicles; not combined with sound recording or reproducing apparatus",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852791",
    description:
      "Radio-broadcast receivers n.e.c. in heading no. 8527; combined with sound recording or reproducing apparatus",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852792",
    description:
      "Radio-broadcast receivers n.e.c. in heading no. 8527; not combined with sound recording or reproducing apparatus but combined with a clock",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852799",
    description:
      "Radio-broadcast receivers n.e.c. in heading no. 8527; not combined with sound recording or reproducing apparatus and not combined with a clock",
    parent: "8527",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8528",
    description:
      "Monitors and projectors, not incorporating television reception apparatus; reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852842",
    description:
      "Monitors; cathode-ray tube, capable of directly connecting to and designed for use with an automatic data processing machine of heading 84.71",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852849",
    description:
      "Monitors; cathode-ray tube, n.e.c. in subheading 8528.42, whether or not colour",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852852",
    description:
      "Monitors; other than cathode-ray tube; capable of directly connecting to and designed for use with an automatic data processing machine of heading 84.71",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852859",
    description:
      "Monitors other than cathode-ray tube; n.e.c. in subheading 8528.52, whether or not colour",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852862",
    description:
      "Projectors; capable of directly connecting to and designed for use with an automatic data processing machine of heading 84.71",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852869",
    description:
      "Projectors; n.e.c. in subheading 8528.62, whether or not colour",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852871",
    description:
      "Reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus; not designed to incorporate a video display or screen",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852872",
    description:
      "Reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus; incorporating a colour video display or screen",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852873",
    description:
      "Reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus; incorporating a monochrome video display or screen",
    parent: "8528",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8529",
    description:
      "Transmission apparatus; parts suitable for use solely or principally with the apparatus of heading no. 8524 to 8528",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "852910",
    description:
      "Reception and transmission apparatus; aerials and aerial reflectors of all kinds and parts suitable for use therewith",
    parent: "8529",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "852990",
    description:
      "Reception and transmission apparatus; for use with the apparatus of heading no. 8524 to 8528, excluding aerials and aerial reflectors",
    parent: "8529",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8530",
    description:
      "Signalling, safety or traffic control equipment; for railways, tramways, roads, inland waterways, parking facilities, port installations, airfields, excluding those of heading no. 8608",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853010",
    description:
      "Signalling, safety or traffic control equipment; for railways or tramways (excluding those of heading no. 8608)",
    parent: "8530",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853080",
    description:
      "Signalling, safety or traffic control equipment; for roads, inland waterways, parking facilities, port installations or airfields (excluding those of heading no. 8608)",
    parent: "8530",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853090",
    description:
      "Signalling apparatus; parts of safety, traffic control equipment for railways, tramways, roads, inland waterways, airfields, parking facilities, port instalments (excluding those of heading no. 8608)",
    parent: "8530",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8531",
    description:
      "Signalling apparatus; electric sound or visual (e.g. bells, sirens, indicator panels, burglar or fire alarms), excluding those of heading no. 8512 or 8530",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853110",
    description:
      "Signalling apparatus; electric, sound or visual, burglar or fire alarms and similar, other than those of heading no. 8512 or 8530",
    parent: "8531",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853120",
    description:
      "Signalling apparatus; electric, sound or visual, indicator panels incorporating liquid crystal devices (LCD) or light-emitting diodes (LED), excluding those of heading no. 8512 or 8530",
    parent: "8531",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853180",
    description:
      "Signalling apparatus; electric, sound or visual, apparatus n.e.c. in heading no. 8531, excluding those of heading no. 8512 or 8530",
    parent: "8531",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853190",
    description:
      "Signalling apparatus; parts of the electric, sound or visual apparatus of heading no. 8531",
    parent: "8531",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8532",
    description:
      "Electrical capacitors; fixed, variable or adjustable (pre-set)",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853210",
    description:
      "Electrical capacitors; fixed, designed for use in 50/60 Hz circuits and having a reactive power handling capacity of not less than 0.5 kvar (power capacitors)",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853221",
    description: "Electrical capacitors; fixed, tantalum",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853222",
    description: "Electrical capacitors; fixed, aluminium electrolytic",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853223",
    description:
      "Electrical capacitors; fixed, ceramic dielectric, single layer",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853224",
    description: "Electrical capacitors; fixed, ceramic dielectric, multilayer",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853225",
    description:
      "Electrical capacitors; fixed, dielectric of paper or plastics",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853229",
    description: "Electrical capacitors; fixed, n.e.c. in heading no. 8532",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853230",
    description:
      "Electrical capacitors; variable or adjustable (pre-set) capacitors",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853290",
    description:
      "Electrical capacitors; parts of the capacitors of heading no. 8532",
    parent: "8532",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8533",
    description:
      "Electrical resistors (including rheostats and potentiometers), excluding heating resistors",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853310",
    description:
      "Electrical resistors; fixed carbon resistors, composition or film types (including rheostats and potentiometers but excluding heating resistors)",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853321",
    description:
      "Electrical resistors; fixed, for a power handling capacity not exceeding 20W (including rheostats and potentiometers but excluding heating resistors and carbon resistors)",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853329",
    description:
      "Electrical resistors; fixed, for a power handling capacity exceeding 20W (including rheostats and potentiometers but excluding heating resistors and carbon resistors)",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853331",
    description:
      "Electrical resistors; wirewound variable, including rheostats and potentiometers, for a power handling capacity not exceeding 20W (excluding heating)",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853339",
    description:
      "Electrical resistors; wirewound variable, including rheostats and potentiometers, for a power handling capacity exceeding 20W (excluding heating)",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853340",
    description:
      "Electrical resistors; variable, including rheostats and potentiometers (excluding heating)",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853390",
    description: "Resistors; parts of the resistors of heading no. 8533",
    parent: "8533",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8534",
    description: "Circuits; printed",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853400",
    description: "Circuits; printed",
    parent: "8534",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8535",
    description:
      "Electrical apparatus for switching, protecting electrical circuits, for making connections to or in electrical circuits; for a voltage exceeding 1000 volts",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853510",
    description:
      "Electrical apparatus; fuses, for a voltage exceeding 1000 volts",
    parent: "8535",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853521",
    description:
      "Electrical apparatus; automatic circuit breakers, for a voltage exceeding 1000 volts but less than 72.5kV",
    parent: "8535",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853529",
    description:
      "Electrical apparatus; automatic circuit breakers, for a voltage of 72.5kV or more",
    parent: "8535",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853530",
    description:
      "Electrical apparatus; isolating and make-and-break switches, for a voltage exceeding 1000 volts",
    parent: "8535",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853540",
    description:
      "Electrical apparatus; lightning arresters, voltage limiters and surge suppressors (for a voltage exceeding 1000 volts)",
    parent: "8535",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853590",
    description:
      "Electrical apparatus; n.e.c. in heading no. 8535, for switching or protecting electrical circuits, for a voltage exceeding 1000 volts",
    parent: "8535",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8536",
    description:
      "Electrical apparatus for switching, protecting electrical circuits, for making connections to or in electrical circuits, for a voltage not exceeding 1000 volts; connectors for optical fibres, optical fibre bundles or cables",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853610",
    description:
      "Electrical apparatus; fuses, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853620",
    description:
      "Electrical apparatus; automatic circuit breakers, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853630",
    description:
      "Electrical apparatus; for protecting electrical circuits, n.e.c. in heading no. 8536, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853641",
    description:
      "Electrical apparatus; relays, (for a voltage not exceeding 60 volts)",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853649",
    description:
      "Electrical apparatus; relays, for a voltage exceeding 60 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853650",
    description:
      "Electrical apparatus; switches n.e.c. in heading no. 8536, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853661",
    description:
      "Electrical apparatus; lamp-holders, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853669",
    description:
      "Electrical apparatus; plugs and sockets, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853670",
    description:
      "Connectors for optical fibres, optical fibre bundles or cables",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853690",
    description:
      "Electrical apparatus; n.e.c. in heading no. 8536, for switching or protecting electrical circuits, for a voltage not exceeding 1000 volts",
    parent: "8536",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8537",
    description:
      "Boards, panels, consoles, desks, cabinets, bases with apparatus of heading no. 8535, 8536 for electricity control and distribution, (other than switching apparatus of heading no. 8517)",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853710",
    description:
      "Boards, panels, consoles, desks and other bases; for electric control or the distribution of electricity, (other than switching apparatus of heading no. 8517), for a voltage not exceeding 1000 volts",
    parent: "8537",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853720",
    description:
      "Boards, panels, consoles, desks and other bases; for electric control or the distribution of electricity, (other than switching apparatus of heading no. 8517), for a voltage exceeding 1000 volts",
    parent: "8537",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8538",
    description:
      "Electrical apparatus; parts suitable for use solely or principally with the apparatus of heading no. 8535, 8536 and 8537",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853810",
    description:
      "Electrical apparatus; parts (e.g. boards, panels, consoles, desks, cabinets, other bases), for goods of heading no. 8537, not equipped with their apparatus",
    parent: "8538",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853890",
    description:
      "Electrical apparatus; parts suitable for use solely or principally with the apparatus of heading no. 8535, 8536 or 8537",
    parent: "8538",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8539",
    description:
      "Lamps; electric filament or discharge lamps, including sealed beam lamp units and ultra-violet or infra-red lamps, arc lamps, light-emitting diode (LED) light sources",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "853910",
    description: "Lamps; sealed beam units",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853921",
    description:
      "Lamps; filament, (excluding ultra-violet or infra-red), tungsten halogen",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853922",
    description:
      "Lamps; filament, (excluding ultra-violet or infra-red), of a power not exceeding 200W and for a voltage exceeding 100 volts, other than tungsten halogen",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853929",
    description:
      "Lamps; filament, (excluding ultra-violet or infra-red), n.e.c. in item no. 8539.2",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853931",
    description:
      "Lamps; discharge, (excluding ultra-violet), fluorescent, hot cathode",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853932",
    description:
      "Lamps; discharge, (excluding ultra-violet), mercury or sodium vapour lamps, metal halide lamps",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853939",
    description:
      "Lamps; discharge, (excluding ultra-violet, excluding fluorescent, hot cathode)",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853941",
    description: "Lamps; arc-lamps",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853949",
    description:
      "Lamps; ultra-violet or infra-red lamps, (excluding arc-lamps)",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853951",
    description:
      "Lamps; light-emitting diode (LED) light sources, light-emitting diode (LED) modules",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853952",
    description:
      "Lamps; light-emitting diode (LED) light sources, light-emitting diode (LED) lamps",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "853990",
    description: "Lamps; parts of the lamps of heading no. 8539",
    parent: "8539",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8540",
    description:
      "Thermionic, cold cathode or photo-cathode valves and tubes (e.g. vacuum, vapour, gas filled valves and tubes, mercury arc rectifying valves and tubes, cathode-ray and television camera tubes)",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854011",
    description:
      "Tubes; cathode-ray television picture tubes, including video monitor cathode-ray tubes, colour",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854012",
    description:
      "Tubes; cathode-ray television picture tubes, including video monitor cathode-ray tubes, monochrome",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854020",
    description:
      "Tubes; television camera tubes, image converters and intensifiers, other photo-cathode tubes",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854040",
    description:
      "Tubes; data/graphic display tubes, monochrome; data/graphic display tubes, colour, with a phosphor dot screen pitch smaller than 0.4mm",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854060",
    description: "Tubes; cathode ray, n.e.c. in heading no. 8540",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854071",
    description:
      "Tubes; microwave, magnetrons, excluding grid-controlled tubes",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854079",
    description:
      "Tubes; microwave (for example klystrons, travelling wave tubes, carlinotrons), excluding magnetrons and grid-controlled tubes",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854081",
    description: "Valves and tubes; receiver or amplifier",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854089",
    description: "Valves and tubes; n.e.c. in heading no. 8540",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854091",
    description: "Tubes; parts of cathode-ray tubes",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854099",
    description:
      "Valves and tubes; parts of the valves and tubes of heading no. 8540, excluding parts of cathode-ray tubes",
    parent: "8540",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8541",
    description:
      "Semiconductor devices (e.g. diodes, transistors, semiconductor based transducers); including photovoltaic cells assembled or not in modules or panels, light-emitting diodes (LED) assembled with other LEDs or not, mounted piezo-electric crystals",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854110",
    description:
      "Electrical apparatus; diodes, other than photosensitive or light-emitting diodes (LED)",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854121",
    description:
      "Electrical apparatus; transistors, (other than photosensitive), with a dissipation rate of less than 1W",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854129",
    description:
      "Electrical apparatus; transistors, (other than photosensitive), with a dissipation rate of 1W or more",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854130",
    description:
      "Electrical apparatus; thyristors, diacs and triacs, other than photosensitive devices",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854141",
    description:
      "Electrical apparatus; photosensitive semiconductor devices, light emitting diodes (LED)",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854142",
    description:
      "Electrical apparatus; photosensitive semiconductor devices, photovoltaic cells not assembled in modules or made up into panels",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854143",
    description:
      "Electrical apparatus; photosensitive semiconductor devices, photovoltaic cells assembled in modules or made up into panels",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854149",
    description:
      "Electrical apparatus; photosensitive semiconductor devices, diodes other than light emitting diodes and photovoltaic cells whether or not assembled in modules or made up into panels",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854151",
    description:
      "Electrical apparatus; photosensitive semiconductor devices, semiconductor-based transducers",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854159",
    description:
      "Electrical apparatus; photosensitive semiconductor devices n.e.c. in heading no. 8541",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854160",
    description: "Crystals; mounted piezo-electric",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854190",
    description:
      "Electrical apparatus; parts for diodes, transistors and similar semiconductor devices and photosensitive semiconductor devices",
    parent: "8541",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8542",
    description: "Electronic integrated circuits",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854231",
    description:
      "Electronic integrated circuits; processors and controllers, whether or not combined with memories, converters, logic circuits, amplifiers, clock and timing circuits, or other circuits",
    parent: "8542",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854232",
    description: "Electronic integrated circuits; memories",
    parent: "8542",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854233",
    description: "Electronic integrated circuits; amplifiers",
    parent: "8542",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854239",
    description: "Electronic integrated circuits; n.e.c. in heading no. 8542",
    parent: "8542",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854290",
    description: "Parts of electronic integrated circuits",
    parent: "8542",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8543",
    description:
      "Electrical machines and apparatus; having individual functions, not specified or included elsewhere in this chapter",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854310",
    description: "Electrical machines and apparatus; particle accelerators",
    parent: "8543",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854320",
    description: "Electrical machines and apparatus; signal generators",
    parent: "8543",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854330",
    description:
      "Electrical machines and apparatus; for electroplating, electrolysis or electrophoresis",
    parent: "8543",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854340",
    description:
      "Electrical machines and apparatus; electronic cigarettes and similar personal electric vaporising devices",
    parent: "8543",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854370",
    description:
      "Electrical machines and apparatus; having individual functions, not specified or included elsewhere in this chapter, n.e.c. in heading no. 8543",
    parent: "8543",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854390",
    description:
      "Electrical machines and apparatus; parts of the electrical goods of heading no. 8543",
    parent: "8543",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8544",
    description:
      "Insulated wire, cable and other electric conductors, connector fitted or not; optical fibre cables of individually sheathed fibres, whether or not assembled with electric conductors or fitted with connectors",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854411",
    description: "Insulated electric conductors; winding wire, of copper",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854419",
    description:
      "Insulated electric conductors; winding wire, (of other than copper)",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854420",
    description:
      "Insulated electric conductors; co-axial cable and other co-axial electric conductors",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854430",
    description:
      "Insulated electric conductors; ignition wiring sets and other wiring sets of a kind used in vehicles, aircraft or ships",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854442",
    description:
      "Insulated electric conductors; for a voltage not exceeding 1000 volts, fitted with connectors",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854449",
    description:
      "Insulated electric conductors; for a voltage not exceeding 1000 volts, not fitted with connectors",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854460",
    description:
      "Insulated electric conductors; for a voltage exceeding 1000 volts",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854470",
    description: "Insulated electric conductors; optical fibre cables",
    parent: "8544",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8545",
    description:
      "Carbon electrodes, carbon brushes, lamp carbons, battery carbons and other articles of graphite or other carbon; with or without metal, of a kind used for electrical purposes",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854511",
    description:
      "Carbon electrodes; with or without metal, of a kind used for furnaces",
    parent: "8545",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854519",
    description:
      "Carbon electrodes; with or without metal, of a kind used for other than furnaces",
    parent: "8545",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854520",
    description:
      "Carbon brushes; with or without metal, used for electrical purposes",
    parent: "8545",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854590",
    description:
      "Carbon; lamp carbons, battery carbons and other articles of graphite or other carbon, with or without metal, of a kind used for electrical purposes",
    parent: "8545",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8546",
    description: "Electrical insulators of any material",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854610",
    description: "Electrical insulators; of glass",
    parent: "8546",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854620",
    description: "Electrical insulators; of ceramics",
    parent: "8546",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854690",
    description: "Electrical insulators; other than of glass and ceramics",
    parent: "8546",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8547",
    description:
      "Insulating fittings; for electrical machines, appliances, equipment, excluding insulators of heading no. 8546, electrical conduit tubing and joints therefore",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854710",
    description:
      "Insulating fittings; of ceramics, for electrical machines, of insulating material only (except minor assembly parts), excluding those of heading no. 8546",
    parent: "8547",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854720",
    description:
      "Insulating fittings; of plastics, for electrical machines, of insulating material only (except minor assembly parts), excluding those of heading no. 8546",
    parent: "8547",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854790",
    description:
      "Insulating fittings; (other than of ceramics or plastics), for electrical machines, appliances and equipment, excluding insulators of heading no. 8546",
    parent: "8547",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8548",
    description:
      "Electrical parts of machinery or apparatus; not specified or elsewhere included in this chapter",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854800",
    description:
      "Electrical parts of machinery or apparatus; not specified or elsewhere included in this chapter",
    parent: "8548",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "8549",
    description: "Electrical and electronic waste and scrap",
    parent: "85",
    level: "4",
  },
  {
    section: "XVI",
    hscode: "854911",
    description:
      "Waste and scrap of lead-acid accumulators; spent lead-acid accumulators",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854912",
    description:
      "Waste and scrap; of primary cells, primary batteries and electric accumulators, spent or not, containing lead, cadmium or mercury, other than lead-acid accumulators",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854913",
    description:
      "Waste and scrap; of primary cells, primary batteries and electric accumulators, spent or not, sorted by chemical type and not containing lead, cadmium or mercury",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854914",
    description:
      "Waste and scrap; of primary cells, primary batteries and electric accumulators, spent or not, unsorted and not containing lead, cadmium or mercury",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854919",
    description:
      "Waste and scrap; of primary cells, primary batteries and electric accumulators, n.e.c. in item no 8549.1",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854921",
    description:
      "Electrical and electronic waste and scrap; of a kind used principally for the recovery of precious metal, containing primary cells and batteries, electric accumulators, mercury-switches, glass from cathode ray tubes or other activated glass, or electrical",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854929",
    description:
      "Waste and scrap; of a kind used principally for the recovery of precious metal n.e.c. in item no 8549.21",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854931",
    description:
      "Electrical and electronic waste and scrap; electrical and electronic assemblies and printed circuit boards, other than those used principally for the recovery of precious metal, containing primary cells and batteries, electric accumulators, mercury-switch",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854939",
    description:
      "Waste and scrap; electrical and electronic assemblies and printed circuit boards, other than those used principally for the recovery of precious metal n.e.c. in item no 8549.31",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854991",
    description: "Waste and scrap; n.e.c. in heading no 8549",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVI",
    hscode: "854999",
    description: "Waste and scrap; n.e.c. in item no 8549.91",
    parent: "8549",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "86",
    description:
      "Railway, tramway locomotives, rolling-stock and parts thereof; railway or tramway track fixtures and fittings and parts thereof; mechanical (including electro-mechanical) traffic signalling equipment of all kinds",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVII",
    hscode: "8601",
    description:
      "Rail locomotives; powered from an external source of electricity or by electric accumulators",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860110",
    description:
      "Rail locomotives; powered from an external source of electricity",
    parent: "8601",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860120",
    description: "Rail locomotives; powered by electric accumulators",
    parent: "8601",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8602",
    description:
      "Rail locomotives; (other than those of heading no. 8601), locomotive tenders",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860210",
    description: "Rail locomotives; diesel-electric powered",
    parent: "8602",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860290",
    description:
      "Rail locomotives and locomotive tenders; other than diesel-electric powered",
    parent: "8602",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8603",
    description:
      "Railway or tramway coaches, vans and trucks; self-propelled tenders, other than those of heading no. 8604",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860310",
    description:
      "Railway or tramway coaches, vans and trucks; self-propelled, powered from an external source of electricity (excluding those of heading no. 8604)",
    parent: "8603",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860390",
    description:
      "Railway or tramway coaches, vans and trucks; self-propelled, powered other than from an external source of electricity (excluding those of heading no. 8604)",
    parent: "8603",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8604",
    description:
      "Railway or tramway maintenance or service vehicles; whether or not self-propelled (e.g. workshops, cranes, ballast tampers, trackliners, testing coaches and track inspection vehicles)",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860400",
    description:
      "Railway or tramway maintenance or service vehicles; whether or not self-propelled (e.g. workshops, cranes, ballast tampers, trackliners, testing coaches and track inspection vehicles)",
    parent: "8604",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8605",
    description:
      "Railway or tramway coaches; passenger coaches, luggage vans, post office coaches and other special purpose railway or tramway coaches, not self-propelled (excluding those of heading no. 8604)",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860500",
    description:
      "Railway or tramway coaches; passenger coaches, luggage vans, post office coaches and other special purpose railway or tramway coaches, not self-propelled (excluding those of heading no. 8604)",
    parent: "8605",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8606",
    description: "Railway or tramway goods vans and wagons; not self-propelled",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860610",
    description:
      "Railway or tramway goods vans and wagons; tank wagons and the like, not self-propelled",
    parent: "8606",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860630",
    description:
      "Railway or tramway goods vans and wagons; self-discharging, not self-propelled, excluding those of item no. 8606.10",
    parent: "8606",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860691",
    description:
      "Railway or tramway goods vans and wagons; covered and closed, not self-propelled",
    parent: "8606",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860692",
    description:
      "Railway or tramway goods vans and wagons; open, with non-removable sides of a height exceeding 60cm, not self-propelled",
    parent: "8606",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860699",
    description:
      "Railway or tramway goods vans and wagons; n.e.c. in heading no. 8606, not self-propelled",
    parent: "8606",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8607",
    description:
      "Railway or tramway locomotives or rolling stock; parts thereof",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860711",
    description:
      "Railway or tramway locomotives or rolling stock; parts, driving bogies and bissel-bogies",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860712",
    description:
      "Railway or tramway locomotives or rolling stock; parts, bogies and bissel-bogies (excluding driving bogies and bissel-bogies)",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860719",
    description:
      "Railway or tramway locomotives or rolling stock; parts, axles and wheels, and parts thereof",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860721",
    description:
      "Railway or tramway locomotives or rolling stock; parts, air brakes and parts thereof",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860729",
    description:
      "Railway or tramway locomotives or rolling stock; parts, brakes (other than air brakes) and parts thereof",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860730",
    description:
      "Railway or tramway locomotives or rolling stock; parts, hooks and other coupling devices, buffers and parts thereof",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860791",
    description:
      "Railway or tramway locomotives; parts n.e.c. in heading no. 8607",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "860799",
    description:
      "Railway or tramway rolling stock; parts n.e.c. in heading no. 8607",
    parent: "8607",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8608",
    description:
      "Railway or tramway track fixtures and fittings; mechanical (including electro-mechanical) signalling, safety or traffic control equipment for railways, tramways, roads, inland waterways, parking facilities, port installations or airfields; parts thereof",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860800",
    description:
      "Railway or tramway track fixtures and fittings; mechanical (including electro-mechanical) signalling, safety or traffic control equipment for railways, tramways, roads, inland waterways, parking facilities, port installations or airfields; parts thereof",
    parent: "8608",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8609",
    description:
      "Containers; (including containers for transport of fluids) specially designed and equipped for carriage by one or more modes of transport",
    parent: "86",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "860900",
    description:
      "Containers; (including containers for transport of fluids) specially designed and equipped for carriage by one or more modes of transport",
    parent: "8609",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "87",
    description:
      "Vehicles; other than railway or tramway rolling stock, and parts and accessories thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVII",
    hscode: "8701",
    description: "Tractors; (other than tractors of heading no 8709)",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870110",
    description: "Tractors; single axle",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870121",
    description:
      "Tractors; road tractors for semi-trailers, with only compression-ignition internal combustion piston engine (diesel or semi-diesel)",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870122",
    description:
      "Tractors; road tractors for semi-trailers, with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motors for propulsion",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870123",
    description:
      "Tractors; road tractors for semi-trailers, with both spark-ignition internal combustion piston engine and electric motors for propulsion",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870124",
    description:
      "Tractors; road tractors for semi-trailers, with only electric motors for propulsion",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870129",
    description:
      "Tractors; road tractors for semi-trailers, with other propulsion methods n.e.c. in item no 8701.2",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870130",
    description: "Tractors; track-laying",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870191",
    description:
      "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power not exceeding 18kW",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870192",
    description:
      "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 18kW but not exceeding 37kW",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870193",
    description:
      "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 37kW but not exceeding 75kW",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870194",
    description:
      "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 75kW but not exceeding 130kW",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870195",
    description:
      "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 130kW",
    parent: "8701",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8702",
    description: "Vehicles; public transport passenger type",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870210",
    description:
      "Vehicles; public transport type (carries 10 or more persons, including driver), with only compression-ignition internal combustion piston engine (diesel or semi-diesel), new or used",
    parent: "8702",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870220",
    description:
      "Vehicles; public transport type (carries 10 or more persons, including driver), with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, new or used",
    parent: "8702",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870230",
    description:
      "Vehicles; public transport type (carries 10 or more persons, including driver), with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, new or used",
    parent: "8702",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870240",
    description:
      "Vehicles; public transport type (carries 10 or more persons, including driver), with only electric motor for propulsion, new or used",
    parent: "8702",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870290",
    description:
      "Vehicles; public transport type (carries 10 or more persons, including driver), n.e.c. in heading 8702, new or used",
    parent: "8702",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8703",
    description:
      "Motor cars and other motor vehicles; principally designed for the transport of persons (other than those of heading no. 8702), including station wagons and racing cars",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870310",
    description:
      "Vehicles; specially designed for travelling on snow, golf cars and similar vehicles",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870321",
    description:
      "Vehicles; with only spark-ignition internal combustion piston engine, cylinder capacity not over 1000cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870322",
    description:
      "Vehicles; with only spark-ignition internal combustion piston engine, cylinder capacity over 1000 but not over 1500cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870323",
    description:
      "Vehicles; with only spark-ignition internal combustion reciprocating piston engine, cylinder capacity over 1500 but not over 3000cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870324",
    description:
      "Vehicles; with only spark-ignition internal combustion reciprocating piston engine, cylinder capacity over 3000cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870331",
    description:
      "Vehicles; with only compression-ignition internal combustion piston engine (diesel or semi-diesel), cylinder capacity not over 1500cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870332",
    description:
      "Vehicles; with only compression-ignition internal combustion piston engine (diesel or semi-diesel), cylinder capacity over 1500 but not over 2500cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870333",
    description:
      "Vehicles; with only compression-ignition internal combustion piston engine (diesel or semi-diesel), cylinder capacity over 2500cc",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870340",
    description:
      "Vehicles; with both spark-ignition internal combustion piston engine and electric motor for propulsion, incapable of being charged by plugging to external source of electric power",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870350",
    description:
      "Vehicles; with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, incapable of being charged by plugging to external source of electric power",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870360",
    description:
      "Vehicles; with both spark-ignition internal combustion piston engine and electric motor for propulsion, capable of being charged by plugging to external source of electric power",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870370",
    description:
      "Vehicles; with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, capable of being charged by plugging to external source of electric power",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870380",
    description: "Vehicles; with only electric motor for propulsion",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870390",
    description:
      "Vehicles; for transport of persons (other than those of heading no. 8702) n.e.c. in heading no. 8703",
    parent: "8703",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8704",
    description: "Vehicles; for the transport of goods",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870410",
    description:
      "Vehicles; dumpers, designed for off-highway use, for transport of goods",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870421",
    description:
      "Vehicles; with only compression-ignition internal combustion piston engine (diesel or semi-diesel), for transport of goods, (of a gvw not exceeding 5 tonnes), n.e.c. in item no 8704.1",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870422",
    description:
      "Vehicles; with only compression-ignition internal combustion piston engine (diesel or semi-diesel), for transport of goods, (of a g.v.w. exceeding 5 tonnes but not exceeding 20 tonnes), n.e.c. in item no 8704.1",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870423",
    description:
      "Vehicles; with only compression-ignition internal combustion piston engine (diesel or semi-diesel), for transport of goods, (of a g.v.w. exceeding 20 tonnes), n.e.c. in item no 8704.1",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870431",
    description:
      "Vehicles; with only spark-ignition internal combustion piston engine, for transport of goods, (of a g.v.w. not exceeding 5 tonnes), n.e.c. in item no 8704.1",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870432",
    description:
      "Vehicles; with only spark-ignition internal combustion piston engine, for transport of goods, (of a g.v.w. exceeding 5 tonnes), n.e.c. in item no 8704.1",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870441",
    description:
      "Vehicles; with both compression-ignition internal combustion piston engine (diesel/semi-diesel) and electric motor as motor for propulsion, unassembled as in section 14, (gvw not exceeding 5000kg), for the transport of goods, vans",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870442",
    description:
      "Vehicles; with both compression-ignition internal combustion piston engine (diesel/semi-diesel) and electric motors for propulsion, of a g.v.w. exceeding 5,000kg but not exceeding 20,000kg",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870443",
    description:
      "Vehicles; with both compression-ignition internal combustion piston engine (diesel/semi-diesel) and electric motors for propulsion, of a g.v.w. exceeding 20,000kg",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870451",
    description:
      "Vehicles; with both spark-ignition internal combustion piston engine and electric motors for propulsion, of a g.v.w. not exceeding 5,000kg",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870452",
    description:
      "Vehicles; with both spark-ignition internal combustion piston engine and electric motors for propulsion, of a g.v.w. exceeding 5,000kg",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870460",
    description: "Vehicles; with only electric motor for propulsion",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870490",
    description: "Vehicles; for transport of goods, n.e.c. in heading no. 8704",
    parent: "8704",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8705",
    description:
      "Special purpose motor vehicles; not those for the transport of persons or goods (e.g. breakdown lorries, road sweeper lorries, spraying lorries, mobile workshops, mobile radiological units etc)",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870510",
    description: "Vehicles; crane lorries",
    parent: "8705",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870520",
    description: "Vehicles; mobile drilling derricks",
    parent: "8705",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870530",
    description: "Vehicles; fire fighting vehicles",
    parent: "8705",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870540",
    description: "Vehicles; concrete-mixer lorries",
    parent: "8705",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870590",
    description:
      "Vehicles; break-down lorries, road-sweepers, spraying lorries, mobile workshops, mobile radiological units, and other special purpose vehicles n.e.c. in heading no. 8705",
    parent: "8705",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8706",
    description:
      "Chassis; fitted with engines, for the motor vehicles of heading no. 8701 to 8705",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870600",
    description:
      "Chassis; fitted with engines, for the motor vehicles of heading no. 8701 to 8705",
    parent: "8706",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8707",
    description:
      "Bodies; (including cabs) for the motor vehicles of heading no. 8701 to 8705",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870710",
    description:
      "Vehicles; bodies (including cabs) for the motor vehicles of heading no. 8703",
    parent: "8707",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870790",
    description:
      "Vehicles; bodies (including cabs) for the motor vehicles of heading no. 8701, 8702, 8704 or 8705",
    parent: "8707",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8708",
    description:
      "Motor vehicles; parts and accessories, of heading no. 8701 to 8705",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870810",
    description:
      "Vehicles; bumpers and parts thereof, for the vehicles of heading no. 8701 to 8705",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870821",
    description: "Vehicles; parts of bodies, safety seat belts",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870822",
    description:
      "Vehicles; parts and accessories, front windscreens (windshields), rear windows and other windows specified in subheading note 1 to this chapter",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870829",
    description:
      "Vehicles; parts and accessories, of bodies, other than safety seat belts",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870830",
    description: "Vehicle parts; brakes, servo-brakes and parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870840",
    description: "Vehicle parts; gear boxes and parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870850",
    description:
      "Vehicle parts; drive-axles with differential, whether or not provided with other transmission components, and non-driving axles; parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870870",
    description: "Vehicle parts; road wheels and parts and accessories thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870880",
    description:
      "Vehicle parts; suspension systems and parts thereof (including shock-absorbers)",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870891",
    description: "Vehicle parts; radiators and parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870892",
    description:
      "Vehicle parts; silencers (mufflers) and exhaust pipes; parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870893",
    description: "Vehicle parts; clutches and parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870894",
    description:
      "Vehicle parts; steering wheels, steering columns and steering boxes; parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870895",
    description:
      "Vehicle parts; safety airbags with inflater system; parts thereof",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870899",
    description: "Vehicle parts and accessories; n.e.c. in heading no. 8708",
    parent: "8708",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8709",
    description:
      "Works trucks, self-propelled, (not fitted with lifting or handling equipment), for factories, warehouses etc, for short distance transport of goods, tractors used on railway station platforms; parts thereof",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "870911",
    description:
      "Vehicles; electrical, self-propelled, (not fitted with lifting or handling equipment), of the type used for short distance transport of goods in factories, warehouses, dock areas or airports",
    parent: "8709",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870919",
    description:
      "Vehicles; (not electrical), self-propelled, without handling equipment, used for short distance transport of goods in factories, airports and such, and tractors of the type used on railway station platforms",
    parent: "8709",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "870990",
    description: "Vehicles; parts of the vehicles of heading no. 8709",
    parent: "8709",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8710",
    description:
      "Tanks and other armoured fighting vehicles; motorised, whether or not fitted with weapons, and parts of such vehicles",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871000",
    description:
      "Tanks and other armoured fighting vehicles; motorised, whether or not fitted with weapons, and parts of such vehicles",
    parent: "8710",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8711",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, with or without side-cars; side-cars",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871110",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, with internal combustion piston engine of a cylinder capacity not exceeding 50cc, with or without side-cars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871120",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, internal combustion piston engine, of cylinder capacity exceeding 50cc but not exceeding 250cc, with or without side-cars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871130",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, internal combustion piston engine, of cylinder capacity exceeding 250cc but not exceeding 500cc, with or without side-cars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871140",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with auxiliary motor, internal combustion piston engine of cylinder capacity exceeding 500cc but not exceeding 800cc, with or without sidecars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871150",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with auxiliary motor, with internal combustion piston engine of a cylinder capacity exceeding 800cc, with or without side-cars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871160",
    description:
      "Motorcycles (including mopeds) and cycles; fitted with auxiliary motor, with electric motor for propulsion, with or without side-cars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871190",
    description:
      "Motorcycles (including mopeds) and cycles; n.e.c. in heading no. 8711, fitted with auxiliary motor, with or without side-cars; side-cars",
    parent: "8711",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8712",
    description:
      "Bicycles and other cycles; including delivery tricycles, not motorised",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871200",
    description:
      "Bicycles and other cycles; including delivery tricycles, not motorised",
    parent: "8712",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8713",
    description:
      "Carriages for disabled persons; whether or not motorised or otherwise mechanically propelled",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871310",
    description: "Carriages for disabled persons; not mechanically propelled",
    parent: "8713",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871390",
    description: "Carriages for disabled persons; mechanically propelled",
    parent: "8713",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8714",
    description: "Vehicles; parts and accessories of heading no. 8711 to 8713",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871410",
    description: "Motorcycles (including mopeds); parts and accessories",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871420",
    description:
      "Carriages for disabled persons; parts and accessories thereof",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871491",
    description: "Cycles; frames and forks, and parts thereof",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871492",
    description: "Cycles; parts thereof, wheel rims and spokes",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871493",
    description:
      "Cycles; parts thereof, hubs (other than coaster braking hubs and hub brakes) and free-wheel sprocket-wheels",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871494",
    description:
      "Cycles; parts thereof, brakes, including coaster braking hubs and hub-brakes, and parts thereof",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871495",
    description: "Cycles; parts thereof, saddles",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871496",
    description: "Cycles; parts, pedals and crank-gear, and parts thereof",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871499",
    description: "Cycles; parts thereof, n.e.c. in item no. 8714.9",
    parent: "8714",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8715",
    description: "Baby carriages and parts thereof",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871500",
    description: "Baby carriages and parts thereof",
    parent: "8715",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8716",
    description:
      "Trailers and semi-trailers; other vehicles, not mechanically propelled; parts thereof",
    parent: "87",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "871610",
    description:
      "Trailers and semi-trailers; of the caravan type, for housing or camping",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871620",
    description:
      "Trailers and semi-trailers; self-loading or self-unloading, for agricultural purposes",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871631",
    description: "Tanker trailers and tanker semi-trailers",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871639",
    description: "Trailers and semi-trailers; (other than tanker type)",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871640",
    description: "Trailers and semi-trailers; n.e.c. in item no. 8716.3",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871680",
    description: "Vehicles; n.e.c. in heading no. 8716",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "871690",
    description:
      "Trailers, semi-trailers and other vehicles not mechanically propelled; parts thereof for heading no. 8716",
    parent: "8716",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "88",
    description: "Aircraft, spacecraft, and parts thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVII",
    hscode: "8801",
    description:
      "Balloons and dirigibles; gliders, hang gliders and other non-powered aircraft.",
    parent: "88",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "880100",
    description:
      "Balloons and dirigibles; gliders, hang gliders and other non-powered aircraft.",
    parent: "8801",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8802",
    description:
      "Aircraft n.e.c. in heading no. 8801, except unmanned aircraft of heading 8806, (e.g. helicopters, aeroplanes); spacecraft (including satellites) and suborbital and spacecraft launch vehicles",
    parent: "88",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "880211",
    description:
      "Helicopters, except unmanned; of an unladen weight not exceeding 2000kg",
    parent: "8802",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880212",
    description:
      "Helicopters, except unmanned; of an unladen weight exceeding 2000kg",
    parent: "8802",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880220",
    description:
      "Aeroplanes and other aircraft, except unmanned; of an unladen weight not exceeding 2000kg",
    parent: "8802",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880230",
    description:
      "Aeroplanes and other aircraft, except unmanned; of an unladen weight exceeding 2000kg but not exceeding 15,000kg",
    parent: "8802",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880240",
    description:
      "Aeroplanes and other aircraft, except unmanned; of an unladen weight exceeding 15,000kg",
    parent: "8802",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880260",
    description:
      "Spacecraft; (including satellites) and suborbital and spacecraft launch vehicles",
    parent: "8802",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8804",
    description:
      "Parachutes (including dirigible parachutes and paragliders) and rotochutes; parts thereof and accessories thereto",
    parent: "88",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "880400",
    description:
      "Parachutes (including dirigible parachutes and paragliders) and rotochutes; parts thereof and accessories thereto",
    parent: "8804",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8805",
    description:
      "Aircraft launching gear, deck-arrestor or similar gear, ground flying trainers; parts of the foregoing articles",
    parent: "88",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "880510",
    description:
      "Aircraft launching gear, deck-arrestor or similar gear and parts thereof",
    parent: "8805",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880521",
    description:
      "Ground flying trainers and parts thereof; air combat simulators and parts thereof",
    parent: "8805",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880529",
    description:
      "Ground flying trainers and parts thereof; other than air combat simulators and parts thereof",
    parent: "8805",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8806",
    description: "Unmanned aircraft",
    parent: "88",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "880610",
    description: "Unmanned aircraft; for carriage of passengers",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880621",
    description:
      "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of not more than 250g",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880622",
    description:
      "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 250g but not more than 7kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880623",
    description:
      "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 7kg but not more than 25kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880624",
    description:
      "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 25kg but not more than 150kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880629",
    description:
      "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 150kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880691",
    description:
      "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight not more than 250g",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880692",
    description:
      "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 250g but not more than 7kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880693",
    description:
      "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 7kg but not more than 25kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880694",
    description:
      "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 25kg but not more than 150kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880699",
    description:
      "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 150kg",
    parent: "8806",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8807",
    description: "Aircraft; parts of goods of heading 8801, 8802 or 8806",
    parent: "88",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "880710",
    description:
      "Aircraft and spacecraft; propellers and rotors and parts thereof",
    parent: "8807",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880720",
    description: "Aircraft and spacecraft; under-carriages and parts thereof",
    parent: "8807",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880730",
    description:
      "Aircraft and spacecraft; parts of aeroplanes, helicopters or unmanned aircraft n.e.c. in heading no. 8807",
    parent: "8807",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "880790",
    description: "Aircraft and spacecraft; parts thereof n.e.c. in chapter 88",
    parent: "8807",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "89",
    description: "Ships, boats and floating structures",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVII",
    hscode: "8901",
    description:
      "Cruise ships, excursion boats, ferry-boats, cargo ships, barges and similar vessels for the transport of persons or goods",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890110",
    description:
      "Cruise ships, excursion boats and similar vessels, principally designed for the transport of persons, ferry boats of all kinds",
    parent: "8901",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890120",
    description: "Tankers",
    parent: "8901",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890130",
    description: "Vessels, refrigerated; other than tankers",
    parent: "8901",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890190",
    description:
      "Vessels; n.e.c. in heading no. 8901, for the transport of goods and other vessels for the transport of both persons and goods",
    parent: "8901",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8902",
    description:
      "Fishing vessels, factory ships and other vessels; for processing or preserving fishery products",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890200",
    description:
      "Fishing vessels, factory ships and other vessels; for processing or preserving fishery products",
    parent: "8902",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8903",
    description:
      "Yachts and other vessels; for pleasure or sports, rowing boats and canoes",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890311",
    description:
      "Yachts and other vessels; for pleasure or sports, inflatable (including rigid hull inflatable), fitted or designed to be fitted with a motor, unladen (net) weight (excluding the motor) not exceeding 100kg",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890312",
    description:
      "Yachts and other vessels; for pleasure or sports, inflatable (including rigid hull inflatable), not designed to be used with a motor and unladen (net) weight not exceeding 100kg",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890319",
    description:
      "Yachts and other vessels; for pleasure or sports, inflatable (including rigid hull inflatable), unladen (net) weight exceeding 100kg",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890321",
    description:
      "Sailboats; (other than inflatable) with or without auxiliary motor, for pleasure or sports, of a length not exceeding 7.5m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890322",
    description:
      "Sailboats; (other than inflatable) with or without auxiliary motor, for pleasure or sports, of a length exceeding 7.5m but not exceeding 24m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890323",
    description:
      "Sailboats; (other than inflatable) with or without auxiliary motor, for pleasure or sports, of a length exceeding 24m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890331",
    description:
      "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable, of a length not exceeding 7.5m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890332",
    description:
      "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable, of a length exceeding 7.5m but not exceeding 24m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890333",
    description:
      "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable, of a length exceeding 24m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890393",
    description:
      "Vessels; (other than sailboats and motorboats), for pleasure or sports, other than inflatable, of a length not exceeding 7.5m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890399",
    description:
      "Vessels; (other than sailboats and motorboats), for pleasure or sports, other than inflatable, of a length exceeding 7.5m",
    parent: "8903",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8904",
    description: "Tugs and pusher craft",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890400",
    description: "Tugs and pusher craft",
    parent: "8904",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8905",
    description:
      "Light-vessels, fire-floats, dredgers, floating cranes, other vessels; the navigability of which is subsidiary to main function; floating docks, floating, submersible drilling, production platforms",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890510",
    description: "Dredgers",
    parent: "8905",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890520",
    description: "Floating or submersible drilling or production platforms",
    parent: "8905",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890590",
    description:
      "Vessels; light, fire-floats, floating cranes and other vessels, the navigability of which is subsidiary to their main function, floating docks",
    parent: "8905",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8906",
    description:
      "Vessels; other, including warships and lifeboats, other than rowing boats",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890610",
    description: "Vessels; warships",
    parent: "8906",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890690",
    description:
      "Vessels; other, including lifeboats other than rowing boats, other than warships",
    parent: "8906",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8907",
    description:
      "Boats, floating structures, other (for e.g. rafts, tanks, coffer-dams, landing stages, buoys and beacons)",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890710",
    description: "Rafts; inflatable",
    parent: "8907",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "890790",
    description:
      "Floating structures; tanks, coffer-dams, landing stages, buoys and beacons",
    parent: "8907",
    level: "6",
  },
  {
    section: "XVII",
    hscode: "8908",
    description: "Vessels and other floating structures; for breaking up",
    parent: "89",
    level: "4",
  },
  {
    section: "XVII",
    hscode: "890800",
    description: "Vessels and other floating structures; for breaking up",
    parent: "8908",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "90",
    description:
      "Optical, photographic, cinematographic, measuring, checking, medical or surgical instruments and apparatus; parts and accessories",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVIII",
    hscode: "9001",
    description:
      "Optical fibres and optical fibre bundles; optical fibre cables not of heading no. 8544; sheets, plates of polarising material; lenses, prisms, mirrors, of any material; unmounted; not non optical glass",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900110",
    description:
      "Optical fibres, optical fibre bundles and cables; excluding those of heading no. 8544",
    parent: "9001",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900120",
    description:
      "Optical elements; polarising material, sheets and plates thereof",
    parent: "9001",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900130",
    description:
      "Lenses, contact; unmounted, of any material, excluding elements of glass not optically worked",
    parent: "9001",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900140",
    description:
      "Lenses, spectacle; unmounted, of glass, excluding elements of glass not optically worked",
    parent: "9001",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900150",
    description: "Lenses, spectacle; unmounted, of materials other than glass",
    parent: "9001",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900190",
    description:
      "Optical elements; lenses n.e.c. in heading no. 9001, prisms, mirrors and other optical elements, unmounted, of any material (excluding elements of glass not optically worked)",
    parent: "9001",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9002",
    description:
      "Lenses, prisms, mirrors and other optical elements, of any material, mounted, being parts or fittings for instruments or apparatus, other than such elements of glass not optically worked",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900211",
    description:
      "Lenses; objective, for cameras, projectors or photographic enlargers or reducers, mounted, being parts or fittings for instruments or apparatus, of any material (excluding glass not optically worked)",
    parent: "9002",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900219",
    description:
      "Lenses; objective, (other than for cameras, projectors or photographic enlargers or reducers), mounted, of any material (excluding elements of glass not optically worked)",
    parent: "9002",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900220",
    description:
      "Filters; mounted as parts or fittings for instruments or apparatus, of any material (excluding elements of glass not optically worked)",
    parent: "9002",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900290",
    description:
      "Optical elements; n.e.c. in heading no. 9002 (e.g. prisms and mirrors), mounted, being parts or fittings for instruments or apparatus, of any material (excluding elements of glass not optically worked)",
    parent: "9002",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9003",
    description:
      "Frames and mountings; for spectacles, goggles or the like, and parts",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900311",
    description:
      "Frames and mountings; for spectacles, goggles or the like, of plastics",
    parent: "9003",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900319",
    description:
      "Frames and mountings; for spectacles, goggles or the like, of materials other than plastics",
    parent: "9003",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900390",
    description:
      "Frames and mountings; parts for spectacles, goggles or the like",
    parent: "9003",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9004",
    description:
      "Spectacles, goggles and the like; corrective, protective or other",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900410",
    description: "Sunglasses; corrective, protective or other",
    parent: "9004",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900490",
    description:
      "Spectacles, goggles and the like; (other than sunglasses) corrective, protective or other",
    parent: "9004",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9005",
    description:
      "Binoculars, monoculars, other optical telescopes, mountings therefore; other astronomical instruments, mountings therefore, but not including instruments for radio-astronomy",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900510",
    description: "Binoculars",
    parent: "9005",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900580",
    description:
      "Monoculars; other optical telescopes and astronomical instruments, excluding instruments for radio-astronomy",
    parent: "9005",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900590",
    description:
      "Binoculars, monoculars, other optical telescopes, astronomical instruments (excluding those of radio-astronomy); parts and accessories (including mountings)",
    parent: "9005",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9006",
    description:
      "Cameras, photographic (excluding cinematographic); photographic flashlight apparatus and flashbulbs other than discharge lamps of heading no. 8539",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900630",
    description:
      "Cameras, photographic (excluding cinematographic); specially designed for underwater use, aerial survey, medical or surgical examination of internal organs; comparison cameras for forensic or criminological use",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900640",
    description:
      "Cameras, photographic (excluding cinematographic); instant print cameras",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900653",
    description:
      "Cameras, photographic (excluding cinematographic), for roll film of a width of 35mm",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900659",
    description:
      "Cameras, photographic (excluding cinematographic); n.e.c. in heading no 9006",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900661",
    description:
      "Photographic flashlight apparatus; discharge lamp (electronic)",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900669",
    description:
      "Photographic flashlight apparatus; n.e.c. in heading no. 9006",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900691",
    description:
      "Cameras, photographic (excluding cinematographic); parts and accessories",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900699",
    description:
      "Photographic flashlight apparatus; parts and accessories, for other than cameras",
    parent: "9006",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9007",
    description:
      "Cinematographic cameras and projectors, whether or not incorporating sound recording or reproducing apparatus",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900710",
    description:
      "Cameras, cinematographic; whether or not incorporating sound recording apparatus",
    parent: "9007",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900720",
    description:
      "Projectors, cinematographic; whether or not incorporating sound recording or reproducing apparatus",
    parent: "9007",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900791",
    description:
      "Cameras, cinematographic; parts and accessories, whether or not incorporating sound recording apparatus",
    parent: "9007",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900792",
    description:
      "Projectors, cinematographic; parts and accessories, whether or not incorporating sound reproducing apparatus",
    parent: "9007",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9008",
    description:
      "Image projectors, other than cinematographic; photographic (other than cinematographic) enlargers and reducers",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "900850",
    description:
      "Image projectors, photographic enlargers and reducers, excluding cinematographic",
    parent: "9008",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "900890",
    description:
      "Photographic (other than cinematographic) image projectors, enlargers, and reducers; parts and accessories",
    parent: "9008",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9010",
    description:
      "Photographic (including cinematographic) laboratory apparatus and equipment, n.e.c. in chapter 90; negatoscopes; projection screens",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901010",
    description:
      "Photographic laboratory apparatus and equipment; for automatically developing photographic (including cinematographic) film or paper in rolls or for automatically exposing developed film to rolls of paper",
    parent: "9010",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901050",
    description:
      "Photographic laboratory apparatus and equipment; n.e.c. in item no. 9010.10, for photographic (including cinematographic) laboratories; negatoscopes",
    parent: "9010",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901060",
    description:
      "Photographic laboratory apparatus and equipment (including cinematographic); projection screens",
    parent: "9010",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901090",
    description:
      "Photographic laboratory apparatus and equipment (including cinematographic); parts and accessories",
    parent: "9010",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9011",
    description:
      "Microscopes, compound optical; including those for photomicrography, cinephotomicrography or microprojection",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901110",
    description: "Microscopes, compound optical; stereoscopic microscopes",
    parent: "9011",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901120",
    description:
      "Microscopes, compound optical; for photomicrography, cinephotomicrography or microprojection",
    parent: "9011",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901180",
    description:
      "Microscopes, compound optical; (other than stereoscopic and microscopes for photomicrography, cinephotomicrography or microprojection)",
    parent: "9011",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901190",
    description:
      "Microscopes, compound optical; parts and accessories (including those for photomicrography, cinephotomicrography or microprojection)",
    parent: "9011",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9012",
    description:
      "Microscopes (excluding optical microscopes); diffraction apparatus",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901210",
    description:
      "Microscopes (excluding optical microscopes); diffraction apparatus",
    parent: "9012",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901290",
    description:
      "Microscopes (excluding optical microscopes); diffraction apparatus; parts and accessories",
    parent: "9012",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9013",
    description:
      "Lasers, other than laser diodes; other optical appliances and instruments n.e.c. in this chapter",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901310",
    description:
      "Optical appliances and instruments; telescopic sights for fitting to arms; periscopes; telescopes designed to form parts of machines, appliances, instruments or apparatus of this chapter",
    parent: "9013",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901320",
    description: "Lasers; other than laser diodes",
    parent: "9013",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901380",
    description:
      "Optical devices, appliances and instruments; n.e.c. in heading no. 9013",
    parent: "9013",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901390",
    description:
      "Optical appliances and instruments; parts and accessories for articles of heading no. 9013",
    parent: "9013",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9014",
    description:
      "Navigational instruments and appliances; direction finding compasses",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901410",
    description:
      "Navigational instruments and appliances; direction finding compasses",
    parent: "9014",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901420",
    description:
      "Navigational instruments and appliances; for aeronautical or space navigation (excluding compasses)",
    parent: "9014",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901480",
    description:
      "Navigational instruments and appliances; for navigation other than aeronautical or space navigation (excluding direction finding compasses)",
    parent: "9014",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901490",
    description:
      "Navigational instruments and appliances; parts and accessories",
    parent: "9014",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9015",
    description:
      "Surveying (including photogrammetrical surveying), hydrographic, oceanographic, hydrological, meteorological or geophysical instruments and appliances, excluding compasses, rangefinders",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901510",
    description: "Rangefinders",
    parent: "9015",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901520",
    description:
      "Surveying equipment; theodolites and tachymeters (tacheometers)",
    parent: "9015",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901530",
    description: "Surveying equipment; levels",
    parent: "9015",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901540",
    description:
      "Surveying equipment; photogrammetrical surveying instruments and appliances",
    parent: "9015",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901580",
    description:
      "Surveying equipment; articles n.e.c. in heading no. 9015, including hydrographic, oceanographic, hydrological, meteorological or geophysical instruments and appliances (excluding compasses)",
    parent: "9015",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901590",
    description:
      "Surveying equipment; parts and accessories for articles of heading no. 9015",
    parent: "9015",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9016",
    description:
      "Balances; of a sensitivity of 5cg or better, with or without weights",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901600",
    description:
      "Balances; of a sensitivity of 5cg or better, with or without weights",
    parent: "9016",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9017",
    description:
      "Drawing, marking-out, mathematical calculating instruments (drafting machines, protractors, drawing sets etc); instruments for measuring length (e.g. measuring rods, tapes, micrometers, callipers) n.e.c.",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901710",
    description: "Drafting tables and machines; whether or not automatic",
    parent: "9017",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901720",
    description: "Drawing, marking-out or mathematical calculating instruments",
    parent: "9017",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901730",
    description: "Mathematical equipment; micrometers, callipers and gauges",
    parent: "9017",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901780",
    description:
      "Mathematical instruments and equipment; n.e.c. in heading no. 9017",
    parent: "9017",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901790",
    description:
      "Drawing, marking-out equipment and mathematical instruments; parts and accessories",
    parent: "9017",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9018",
    description:
      "Instruments and appliances used in medical, surgical, dental or veterinary sciences, including scintigraphic apparatus, other electro-medical apparatus and sight testing instruments",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901811",
    description:
      "Medical, surgical instruments and appliances; electro-cardiographs",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901812",
    description:
      "Medical, surgical instruments and appliances; ultrasonic scanning apparatus",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901813",
    description:
      "Medical, surgical instruments and appliances; magnetic resonance imaging apparatus",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901814",
    description:
      "Medical, surgical instruments and appliances; scintigraphic apparatus",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901819",
    description:
      "Medical, surgical instruments and appliances; electro-diagnostic apparatus (including apparatus for functional exploratory examination or for checking physiological parameters), n.e.c. in item no. 9018.1",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901820",
    description:
      "Medical, surgical instruments and appliances; ultra-violet or infra-red ray apparatus",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901831",
    description:
      "Medical, surgical instruments and appliances; syringes, with or without needles",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901832",
    description:
      "Medical, surgical instruments and appliances; tubular metal needles and needles for sutures",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901839",
    description:
      "Medical, surgical instruments and appliances; catheters, cannulae and the like",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901841",
    description:
      "Dental instruments and appliances; dental drill engines, whether or not combined on a single base with other dental equipment",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901849",
    description:
      "Dental instruments and appliances; other than dental drill engines",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901850",
    description: "Ophthalmic instruments and appliances",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901890",
    description:
      "Medical, surgical or dental instruments and appliances; n.e.c. in heading no. 9018",
    parent: "9018",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9019",
    description:
      "Mechano-therapy, massage appliances; psychological aptitude testing apparatus; ozone, oxygen, aerosol therapy, artificial respiration or other therapeutic respiration apparatus",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "901910",
    description:
      "Mechano-therapy appliances; massage apparatus and psychological aptitude-testing apparatus",
    parent: "9019",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "901920",
    description:
      "Therapeutic respiration apparatus; ozone, oxygen, aerosol therapy apparatus; artificial respiration or other therapeutic respiration apparatus",
    parent: "9019",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9020",
    description:
      "Breathing appliances and gas masks; excluding protective masks having neither mechanical parts nor replaceable filters and excluding apparatus of item no. 9019.20",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902000",
    description:
      "Breathing appliances and gas masks; excluding protective masks having neither mechanical parts nor replaceable filters and excluding apparatus of item no. 9019.20",
    parent: "9020",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9021",
    description:
      "Orthopaedic appliances; including crutches, surgical belts and trusses; splints and other fracture appliances; artificial parts of the body; hearing aids and other which are worn, carried or implanted in the body to compensate for a defect or disability",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902110",
    description: "Orthopaedic or fracture appliances",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902121",
    description: "Dental fittings; artificial teeth",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902129",
    description: "Dental fittings; other than artificial teeth",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902131",
    description: "Artificial parts of the body",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902139",
    description: "Artificial parts of the body; excluding artificial joints",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902140",
    description: "Hearing aids (excluding parts and accessories)",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902150",
    description:
      "Pacemakers; for stimulating heart muscles (excluding parts and accessories)",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902190",
    description:
      "Appliances; worn, carried or implanted in the body, to compensate for a defect or disability",
    parent: "9021",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9022",
    description:
      "Apparatus based on the use of x-rays or of alpha, beta, gamma or other ionising radiations, whether or not for medical, surgical, dental or veterinary uses, including radiography or radiotherapy apparatus, x-ray tubes and other x-ray generators, high tens",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902212",
    description:
      "Apparatus based on the use of x-rays; including radiography or radiotherapy apparatus, whether or not for medical, surgical, dental or veterinary uses, computed tomography apparatus",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902213",
    description:
      "Apparatus based on the use of x-rays; including radiography or radiotherapy apparatus, for dental uses, excluding computed tomography apparatus",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902214",
    description:
      "Apparatus based on the use of x-rays; including radiography or radiotherapy apparatus, for medical, surgical or veterinary uses, not dental uses, excluding computed tomography apparatus",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902219",
    description:
      "Apparatus based on the use of x-rays, including radiography or radiotherapy apparatus; for other than medical, surgical, dental or veterinary uses",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902221",
    description:
      "Apparatus based on the use of alpha, beta, gamma or other ionising radiations, including radiography or radiotherapy apparatus; for medical, surgical, dental or veterinary uses",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902229",
    description:
      "Apparatus based on the use of alpha, beta, gamma or other ionising radiations, including radiography or radiotherapy apparatus; (for other than medical, surgical, dental or veterinary uses)",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902230",
    description: "X-ray tubes",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902290",
    description:
      "Apparatus based on use of x-rays and similar; parts and accessories (x-ray generators, tubes, high tension generators, control panels and desks, screens, examination or treatment tables, chairs and like",
    parent: "9022",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9023",
    description:
      "Instruments, apparatus and models, designed for demonstrational purposes (in education or exhibitions), unsuitable for other uses",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902300",
    description:
      "Instruments, apparatus and models; designed for demonstrational purposes (in education or exhibitions), unsuitable for other uses",
    parent: "9023",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9024",
    description:
      "Machines and appliances for testing the hardness, strength, compressibility, elasticity of other mechanical properties of materials (e.g. metals, wood, textiles, paper, plastics)",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902410",
    description:
      "Machines and appliances; for testing the hardness, strength, compressibility, elasticity or other mechanical properties of metals",
    parent: "9024",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902480",
    description:
      "Machines and appliances; for testing the hardness, strength, compressibility, elasticity or other mechanical properties of materials other than metals",
    parent: "9024",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902490",
    description:
      "Machines and appliances; parts and accessories for those testing hardness, strength, compressibility, elasticity or other mechanical properties of materials (e.g. metal, wood, textiles, paper, plastics)",
    parent: "9024",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9025",
    description:
      "Hydrometers and similar floating instruments, thermometers, pyrometers, barometers, hygrometers and psychrometers, recording or not",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902511",
    description:
      "Thermometers and pyrometers; liquid filled, for direct reading, not combined with other instruments",
    parent: "9025",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902519",
    description:
      "Thermometers and pyrometers; (other than liquid filled, for direct reading), not combined with other instruments",
    parent: "9025",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902580",
    description:
      "Hydrometers and similar floating instruments, barometers, hygrometers, psychrometers, thermometers, pyrometers; recording or not, any combination of these instruments (excluding thermometers and barometers not combined with other instruments)",
    parent: "9025",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902590",
    description:
      "Hydrometers and similar floating instruments, barometers, hygrometers, psychrometers, thermometers, pyrometers; recording or not, any combination of these instruments, parts and accessories",
    parent: "9025",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9026",
    description:
      "Instruments, apparatus for measuring or checking the flow, level, pressure of liquids, gases (e.g. flow meters, heat meters etc), not instruments and apparatus of heading no. 9014, 9015, 9028 or 9032",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902610",
    description:
      "Instruments and apparatus; for measuring or checking the flow or level of liquids",
    parent: "9026",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902620",
    description:
      "Instruments and apparatus; for measuring or checking pressure",
    parent: "9026",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902680",
    description:
      "Instruments and apparatus; for measuring or checking variables of liquids or gases (excluding pressure or the flow and level of liquids and those of heading no. 9014, 9015, 9028 and 9032)",
    parent: "9026",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902690",
    description:
      "Instruments and apparatus; parts and accessories for those measuring or checking the flow, level, pressure or other variables of liquids or gases (excluding those of heading no. 9014, 9015, 9028 or 9032)",
    parent: "9026",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9027",
    description:
      "Instruments and apparatus; for physical or chemical analysis (e.g. polarimeters, spectrometers), for measuring or checking viscosity, porosity, etc, for measuring quantities of heat, sound or light",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902710",
    description:
      "Instruments and apparatus; gas or smoke analysis apparatus, for physical or chemical analysis",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902720",
    description: "Chromatographs and electrophoresis instruments",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902730",
    description:
      "Spectrometers, spectrophotometers and spectrographs; using optical radiations (UV, visible, IR)",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902750",
    description:
      "Instruments and apparatus; using optical radiations (UV, visible, IR), (other than spectrometers, spectrophotometers and spectrographs)",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902781",
    description:
      "Instruments and apparatus; for physical or chemical analysis, for measuring or checking viscosity, porosity, expansion, surface tension or quantities of heat, sound or light, mass spectrometers",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902789",
    description:
      "Instruments and apparatus; for physical or chemical analysis, for measuring or checking viscosity, porosity, expansion, surface tension or quantities of heat, sound or light, exposure meters",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902790",
    description: "Microtomes and parts and accessories thereof",
    parent: "9027",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9028",
    description:
      "Gas, liquid or electricity supply or production meters, including calibrating meters therefor",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902810",
    description:
      "Meters; gas, supply or production meters, including calibrating meters thereof",
    parent: "9028",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902820",
    description:
      "Meters; liquid supply or production meters, including calibrating meters thereof",
    parent: "9028",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902830",
    description:
      "Meters; electricity supply or production meters, including calibrating meters thereof",
    parent: "9028",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902890",
    description:
      "Meters; parts and accessories of gas, liquid, electricity supply or production meters, including calibrating meters thereof",
    parent: "9028",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9029",
    description:
      "Revolution counter, production counters, taximeters, mileometers, pedometers and the like, speed indicators and tachometers, other than those of heading no. 9015, stroboscopes",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "902910",
    description:
      "Meters and counters; revolution counters, production counters, taximeters, mileometers, pedometers and the like",
    parent: "9029",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902920",
    description: "Meters; speed indicators and tachometers; stroboscopes",
    parent: "9029",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "902990",
    description:
      "Meters and counters; parts and accessories for revolution and production counters, taximeters, mileometers, pedometers and the like; speed indicators, tachometers (excluding heading no. 9015), stroboscopes",
    parent: "9029",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9030",
    description:
      "Instruments, apparatus for measuring, checking electrical quantities not meters of heading no. 9028; instruments, apparatus for measuring or detecting alpha, beta, gamma, x-ray, cosmic and other radiations",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "903010",
    description:
      "Instruments and apparatus; for measuring or detecting ionising radiations",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903020",
    description: "Oscilloscopes and oscillographs",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903031",
    description:
      "Multimeters; for measuring or checking voltage, current, resistance or power (other than those for measuring or checking semiconductor wafer or devices), without a recording device",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903032",
    description:
      "Multimeters; for measuring or checking voltage, current, resistance or power, with a recording device",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903033",
    description:
      "Instruments and apparatus; for measuring or checking voltage, current, resistance or power, without a recording device (excluding multimeters)",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903039",
    description:
      "Instruments and apparatus; for measuring or checking voltage, current, resistance or power, with a recording device (excluding multimeters)",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903040",
    description:
      "Instruments and apparatus; specially designed for telecommunications (e.g. cross-talk meters, gain measuring instruments, distortion factor meters, psophometers)",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903082",
    description:
      "Instruments and apparatus; for measuring or checking semiconductor wafers or devices (including integrated circuits)",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903084",
    description:
      "Instruments and apparatus; n.e.c. in heading no. 9030, with a recording device",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903089",
    description:
      "Instruments and apparatus; n.e.c. in heading no. 9030, without a recording device",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903090",
    description:
      "Instruments, apparatus for measuring, checking electrical quantities, not meters of heading no. 9028; parts and accessories, for measuring or detecting alpha, beta, gamma, x-ray, cosmic and other radiations",
    parent: "9030",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9031",
    description:
      "Measuring or checking instruments, appliances and machines, n.e.c. or included in this chapter; profile projectors",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "903110",
    description: "Machines; for balancing mechanical parts",
    parent: "9031",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903120",
    description: "Test benches",
    parent: "9031",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903141",
    description:
      "Optical instruments and appliances; for inspecting semiconductor wafers or devices or for inspecting photomasks or reticles used in manufacturing semiconductor devices, n.e.c. in chapter 90",
    parent: "9031",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903149",
    description:
      "Optical instruments and appliances; for measuring or checking, n.e.c. in chapter 90",
    parent: "9031",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903180",
    description:
      "Instruments, appliances and machines; for measuring or checking n.e.c. in chapter 90",
    parent: "9031",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903190",
    description:
      "Instruments, appliances and machines; parts and accessories for those measuring or checking devices of heading no. 9031",
    parent: "9031",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9032",
    description:
      "Regulating or controlling instruments and apparatus; automatic type",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "903210",
    description:
      "Regulating or controlling instruments and apparatus; automatic type, thermostats",
    parent: "9032",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903220",
    description:
      "Regulating or controlling instruments and apparatus; automatic, manostats",
    parent: "9032",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903281",
    description:
      "Regulating or controlling instruments and apparatus; automatic, hydraulic or pneumatic",
    parent: "9032",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903289",
    description:
      "Regulating or controlling instruments and apparatus; automatic, other than hydraulic or pneumatic",
    parent: "9032",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "903290",
    description:
      "Regulating or controlling instruments and apparatus; automatic, parts and accessories",
    parent: "9032",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9033",
    description:
      "Machines and appliances, instruments or apparatus of chapter 90; parts and accessories n.e.c. in chapter 90",
    parent: "90",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "903300",
    description:
      "Machines and appliances, instruments or apparatus of chapter 90; parts and accessories n.e.c. in chapter 90",
    parent: "9033",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "91",
    description: "Clocks and watches and parts thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVIII",
    hscode: "9101",
    description:
      "Wrist-watches, pocket-watches, stop-watches and other watches; with case of precious metal or of metal clad with precious metal",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910111",
    description:
      "Wrist-watches; electrically operated, with or without a stop-watch, with case of precious metal or of metal clad with precious metal, with mechanical display only",
    parent: "9101",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910119",
    description:
      "Wrist-watches; electrically operated, with or without a stop-watch, with case of precious metal or metal clad with precious metal, without mechanical display",
    parent: "9101",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910121",
    description:
      "Wrist-watches; (not electrically operated), automatic winding, whether or not incorporating a stop-watch facility, case of precious metal or of metal clad with precious metal",
    parent: "9101",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910129",
    description:
      "Wrist-watches; (not electrically operated), (not automatic winding), whether or not incorporating a stop-watch facility, case of precious metal or of metal clad with precious metal",
    parent: "9101",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910191",
    description:
      "Pocket-watches and other watches, including stop-watches; (excluding wrist-watches), with case of precious metal or of metal clad with precious metal, electrically operated",
    parent: "9101",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910199",
    description:
      "Pocket-watches and other watches, including stop-watches; (excluding wrist-watches), with case of precious metal or of metal clad with precious metal, not electrically operated",
    parent: "9101",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9102",
    description:
      "Wrist-watches, pocket-watches, stop-watches and other watches, other than those of heading no. 9101",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910211",
    description:
      "Wrist-watches; electrically operated, with or without a stop-watch, (other than those of heading no. 9101) with mechanical display only",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910212",
    description:
      "Wrist-watches; electrically operated, with or without a stop-watch, (other than those of heading no. 9101) with opto-electronic display only",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910219",
    description:
      "Wrist-watches; electrically operated, with or without a stop-watch, (other than those of heading no. 9101) without mechanical or opto-electronic display",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910221",
    description:
      "Wrist-watches; whether or not incorporating a stop-watch facility, with automatic winding",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910229",
    description:
      "Wrist-watches; whether or not incorporating a stop-watch facility, with other than automatic winding",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910291",
    description:
      "Pocket watches and other watches, including stop-watches; (excluding wrist-watches), other than those of heading no. 9101, electrically operated",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910299",
    description:
      "Pocket watches and other watches, including stop-watches; (excluding wrist-watches), other than those of heading no. 9101, other than electrically operated",
    parent: "9102",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9103",
    description:
      "Clocks; with watch movements, excluding clocks of heading no. 9104",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910310",
    description:
      "Clocks; with watch movements, electrically operated, excluding clocks of heading no. 9104",
    parent: "9103",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910390",
    description:
      "Clocks; with watch movements, other than electrically operated, excluding clocks of heading no. 9104",
    parent: "9103",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9104",
    description:
      "Instrument panel clocks and clocks of a similar type for vehicles, aircraft, spacecraft or vessels",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910400",
    description:
      "Clocks; instrument panel clocks and clocks of a similar type for vehicles, aircraft, spacecraft or vessels",
    parent: "9104",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9105",
    description: "Clocks, other, n.e.c.",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910511",
    description:
      "Clocks; (excluding those with watch movements and instrument panel clocks), alarm clocks, electrically operated",
    parent: "9105",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910519",
    description:
      "Clocks; (excluding those with watch movements and instrument panel clocks), alarm clocks, other than electrically operated",
    parent: "9105",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910521",
    description:
      "Clocks; (excluding those with watch movements and instrument panel clocks), wall clocks, electrically operated",
    parent: "9105",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910529",
    description:
      "Clocks; (excluding those with watch movements and instrument panel clocks), wall clocks, other than electrically operated",
    parent: "9105",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910591",
    description:
      "Clocks; (excluding those with watch movements and instrument panel clocks), (other than alarm or wall clocks), electrically operated",
    parent: "9105",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910599",
    description:
      "Clocks; (excluding those with watch movements and instrument panel clocks), other than alarm or wall clocks, other than electrically operated",
    parent: "9105",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9106",
    description:
      "Time of day recording apparatus and apparatus for measuring, recording or otherwise indicating intervals of time, with clock, watch movement or synchronous motor",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910610",
    description:
      "Time recording apparatus; time-registers, time recorders, with clock, watch movement or synchronous motor",
    parent: "9106",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910690",
    description:
      "Time recording apparatus; with clock or watch movement or with synchronous motor, n.e.c. in heading no. 9106",
    parent: "9106",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9107",
    description:
      "Time switches; with clock, watch movement or synchronous motor",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910700",
    description:
      "Time switches; with clock, watch movement or synchronous motor",
    parent: "9107",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9108",
    description: "Watch movements; complete and assembled",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910811",
    description:
      "Watch movements; complete and assembled, electrically operated, with mechanical display only or with a device to which a mechanical display can be incorporated",
    parent: "9108",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910812",
    description:
      "Watch movements; complete and assembled, electrically operated, by means of solar cells, with opto-electronic display",
    parent: "9108",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910819",
    description:
      "Watch movements; complete and assembled, electrically operated, by means of solar cells, without mechanical display or device including such or opto-electronic display",
    parent: "9108",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910820",
    description:
      "Watch movements; complete and assembled, with automatic winding",
    parent: "9108",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910890",
    description:
      "Watch movements; complete and assembled, not automatic winding or electrically operated",
    parent: "9108",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9109",
    description: "Clock movements; complete and assembled",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "910910",
    description:
      "Clock movements; complete and assembled, electrically operated",
    parent: "9109",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "910990",
    description:
      "Clock movements; complete and assembled, other than electrically operated",
    parent: "9109",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9110",
    description:
      "Watch or clock movements, complete, unassembled or partly assembled (movement sets); incomplete watch or clock movements, assembled; rough watch or clock movements",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "911011",
    description:
      "Watches; complete movements, unassembled or partly assembled (movement sets)",
    parent: "9110",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911012",
    description: "Watches; incomplete movements, assembled",
    parent: "9110",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911019",
    description: "Watches; rough movements",
    parent: "9110",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911090",
    description:
      "Clocks; movements, whether or not complete, incomplete, assembled or unassembled",
    parent: "9110",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9111",
    description: "Watch cases and parts thereof",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "911110",
    description:
      "Watch cases; of precious metal or of metal clad with precious metal",
    parent: "9111",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911120",
    description:
      "Watch cases; of base metal, whether or not gold-plated or silver-plated",
    parent: "9111",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911180",
    description: "Watch cases; n.e.c. in heading no. 9111",
    parent: "9111",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911190",
    description: "Watch cases and parts thereof",
    parent: "9111",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9112",
    description:
      "Clock cases and cases of a similar type for other goods of this chapter and parts thereof",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "911220",
    description:
      "Clock cases and similar cases for other goods of chapter 91; other than watch cases",
    parent: "9112",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911290",
    description:
      "Clock cases and similar cases for other goods of chapter 91; other than watch cases, parts thereof",
    parent: "9112",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9113",
    description: "Watch straps, watch bands, watch bracelets and parts thereof",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "911310",
    description:
      "Watch straps, watch bands, watch bracelets, and parts thereof; of precious metal or of metal clad with precious metal",
    parent: "9113",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911320",
    description:
      "Watch straps, watch bands, watch bracelets, and parts thereof; of base metal, whether or not gold- or silver-plated",
    parent: "9113",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911390",
    description:
      "Watch straps, watch bands, watch bracelets, and parts thereof; n.e.c. in heading no. 9113",
    parent: "9113",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9114",
    description: "Clock or watch parts; n.e.c. in chapter 91",
    parent: "91",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "911430",
    description: "Clock or watch parts; dials",
    parent: "9114",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911440",
    description: "Clock or watch parts; plates and bridges",
    parent: "9114",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "911490",
    description:
      "Clock or watch parts; other than springs (including hair-springs), dials, plates, and bridges",
    parent: "9114",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "92",
    description: "Musical instruments; parts and accessories of such articles",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XVIII",
    hscode: "9201",
    description:
      "Pianos; including automatic pianos, harpsichords and other keyboard stringed instruments",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920110",
    description:
      "Musical instruments; pianos, upright, including automatic pianos",
    parent: "9201",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920120",
    description: "Musical instruments; pianos, grand",
    parent: "9201",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920190",
    description:
      "Musical instruments; harpsichords and other keyboard stringed instruments n.e.c. in heading no. 9201",
    parent: "9201",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9202",
    description:
      "Musical instruments; string, n.e.c. in heading no. 9201, (e.g. guitars, violins, harps)",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920210",
    description:
      "Musical instruments; string, played with a bow (e.g. violins)",
    parent: "9202",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920290",
    description:
      "Musical instruments; string, played other than with a bow (e.g. guitars and harps)",
    parent: "9202",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9205",
    description:
      "Musical instruments; wind (e.g. keyboard pipe organs, accordions, clarinets, trumpets, bagpipes), other than fairground organs and mechanical street organs",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920510",
    description:
      "Musical instruments; brass-wind (e.g. trumpets), other than fairground organs and mechanical street organs",
    parent: "9205",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920590",
    description:
      "Musical instruments; wind, other than brass, (eg. clarinet, bagpipes, pipe organs), other than fairground organs and mechanical street organs",
    parent: "9205",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9206",
    description:
      "Musical instruments; percussion (e.g. drums, xylophones, cymbals, castanets, maracas)",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920600",
    description:
      "Musical instruments; percussion (e.g. drums, xylophones, cymbals, castanets, maracas)",
    parent: "9206",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9207",
    description:
      "Musical instruments; the sound of which is produced or must be amplified, electrically (e.g. organs, guitars, accordions)",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920710",
    description:
      "Musical instruments; keyboard, (other than accordions), the sound of which is produced or must be amplified electrically",
    parent: "9207",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920790",
    description:
      "Musical instruments; (other than keyboard), the sound of which is produced or must be amplified electrically",
    parent: "9207",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9208",
    description:
      "Musical boxes, fairground and mechanical street organs, mechanical singing birds, musical saws and musical instruments n.e.c. in chapter 92; decoy calls of all kinds; whistles; call horns and other mouth-blown sound signalling instruments",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920810",
    description: "Musical boxes",
    parent: "9208",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920890",
    description:
      "Fairground and mechanical street organs, mechanical singing birds, musical saws and musical instruments n.e.c. in chapter 92; decoy calls of all kinds; whistles; call horns and other mouth-blown sound signalling instruments",
    parent: "9208",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "9209",
    description:
      "Musical instrument parts (for example, mechanisms for musical boxes) and accessories (for example, cards, discs and rolls for mechanical instruments); metronomes, tuning forks and pitch pipes",
    parent: "92",
    level: "4",
  },
  {
    section: "XVIII",
    hscode: "920930",
    description: "Musical instrument strings",
    parent: "9209",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920991",
    description: "Musical instruments; parts and accessories for pianos",
    parent: "9209",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920992",
    description:
      "Musical instruments; parts and accessories for string musical instruments other than keyboard instruments",
    parent: "9209",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920994",
    description:
      "Musical instruments; parts and accessories for the musical instruments the sound of which is produced or must be amplified electrically (e.g. organs, guitars and accordions)",
    parent: "9209",
    level: "6",
  },
  {
    section: "XVIII",
    hscode: "920999",
    description:
      "Musical instruments; parts and accessories for musical instruments n.e.c. in heading no. 9209; metronomes, tuning forks and pitch pipes",
    parent: "9209",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "93",
    description: "Arms and ammunition; parts and accessories thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XIX",
    hscode: "9301",
    description:
      "Military weapons; other than revolvers, pistols and arms of heading no. 9307",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930110",
    description:
      "Military weapons; artillery weapons (e.g. guns, howitzers, and mortars)",
    parent: "9301",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930120",
    description:
      "Military weapons; rocket launchers, flame-throwers, grenade launchers, torpedo tubes and similar projectors",
    parent: "9301",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930190",
    description:
      "Military weapons; other than revolvers, pistols, and arms of heading 9307, n.e.c. in heading 9301",
    parent: "9301",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "9302",
    description:
      "Revolvers and pistols; other than those of heading no. 9303 or 9304",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930200",
    description:
      "Revolvers and pistols; other than those of heading no. 9303 or 9304",
    parent: "9302",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "9303",
    description:
      "Firearms; other similar devices (e.g. sporting shotguns and rifles, muzzle-loading firearms, very pistols, devices for firing flares or blank ammunition, captive bolt humane killers, line throwing guns)",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930310",
    description: "Firearms; muzzle-loading",
    parent: "9303",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930320",
    description:
      "Firearms; sporting, hunting or target-shooting shotguns, including combination shotgun-rifles",
    parent: "9303",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930330",
    description:
      "Firearms; sporting, hunting or target-shooting rifles n.e.c. in heading no. 9303",
    parent: "9303",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930390",
    description: "Firearms; n.e.c. in heading no. 9303",
    parent: "9303",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "9304",
    description:
      "Firearms; (e.g. spring, air or gas guns and pistols, truncheons), excluding those of heading no. 9307",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930400",
    description:
      "Firearms; (e.g. spring, air or gas guns and pistols, truncheons), excluding those of heading no. 9307",
    parent: "9304",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "9305",
    description:
      "Firearms; parts and accessories of articles of heading no. 9301 to 9304",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930510",
    description: "Firearms; parts and accessories, of revolvers or pistols",
    parent: "9305",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930520",
    description:
      "Firearms; parts and accessories, of shotguns or rifles of heading 9303",
    parent: "9305",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930591",
    description:
      "Firearms; parts and accessories, of military weapons of heading 9301",
    parent: "9305",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930599",
    description:
      "Firearms; parts and accessories, of firearms other than the military weapons of heading 9301",
    parent: "9305",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "9306",
    description:
      "Bombs, grenades, torpedoes, mines, missiles and similar munitions of war and parts thereof; cartridges and other ammunition, projectiles and parts thereof, including shot and cartridge wads",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930621",
    description: "Ammunition; shotgun cartridges",
    parent: "9306",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930629",
    description: "Ammunition; parts of shotgun cartridges",
    parent: "9306",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930630",
    description:
      "Ammunition; cartridges and parts thereof n.e.c. in heading no. 9306",
    parent: "9306",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "930690",
    description: "Ammunition; n.e.c. in chapter 93",
    parent: "9306",
    level: "6",
  },
  {
    section: "XIX",
    hscode: "9307",
    description:
      "Arms; swords, cutlasses, bayonets, lances and the like, parts thereof and scabbards and sheaths therefor",
    parent: "93",
    level: "4",
  },
  {
    section: "XIX",
    hscode: "930700",
    description:
      "Arms; swords, cutlasses, bayonets, lances and the like, parts thereof and scabbards and sheaths therefor",
    parent: "9307",
    level: "6",
  },
  {
    section: "XX",
    hscode: "94",
    description:
      "Furniture; bedding, mattresses, mattress supports, cushions and similar stuffed furnishings; lamps and lighting fittings, n.e.c.; illuminated signs, illuminated name-plates and the like; prefabricated buildings",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XX",
    hscode: "9401",
    description:
      "Seats (not those of heading no. 9402), whether or not convertible into beds and parts thereof",
    parent: "94",
    level: "4",
  },
  {
    section: "XX",
    hscode: "940110",
    description: "Seats; of a kind used for aircraft",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940120",
    description: "Seats; of a kind used for motor vehicles",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940131",
    description:
      "Seats; swivel with variable height adjustment of wood, excluding medical, surgical, dental, veterinary or barber furniture",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940139",
    description:
      "Seats; swivel with variable height adjustment of other than wood, excluding medical, surgical, dental, veterinary or barber furniture",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940141",
    description:
      "Seats; convertible into beds of wood, other than garden seats or camping equipment",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940149",
    description:
      "Seats; convertible into beds of other than wood, other than garden seats or camping equipment",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940152",
    description: "Seats; of bamboo",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940153",
    description: "Seats; of rattan",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940159",
    description:
      "Seats; of cane, osier or similar materials, other than bamboo or rattan",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940161",
    description:
      "Seats; with wooden frames, upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940169",
    description:
      "Seats; with wooden frames, not upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940171",
    description:
      "Seats; with metal frames, upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940179",
    description:
      "Seats; with metal frames, not upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940180",
    description:
      "Seats; n.e.c. in heading no. 9401, (excluding medical, surgical, dental, veterinary or barber furniture)",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940191",
    description:
      "Seats; parts, of wood, (other than for use in the assembly of motor vehicles as determined by the minister, other than automotive)",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940199",
    description:
      "Seats; parts, (of other than wood) for use in the assembly of motor vehicles as determined by the minister",
    parent: "9401",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9402",
    description:
      "Furniture; medical, surgical, dental or veterinary (e.g. operating tables, hospital beds, dentists' chairs) barbers' chairs; parts",
    parent: "94",
    level: "4",
  },
  {
    section: "XX",
    hscode: "940210",
    description:
      "Chairs; dentists', barbers' or similar chairs having rotating as well as both reclining and elevating movements, and parts thereof",
    parent: "9402",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940290",
    description:
      "Furniture; for medical, surgical, veterinary use (e.g. operating tables, examination tables, hospital beds with mechanical fittings) and parts thereof",
    parent: "9402",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9403",
    description: "Furniture and parts thereof, n.e.c. in chapter 94",
    parent: "94",
    level: "4",
  },
  {
    section: "XX",
    hscode: "940310",
    description: "Furniture; metal, for office use",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940320",
    description: "Furniture; metal, other than for office use",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940330",
    description: "Furniture; wooden, for office use",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940340",
    description: "Furniture; wooden, for kitchen use",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940350",
    description: "Furniture; wooden, for bedroom use",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940360",
    description:
      "Furniture; wooden, other than for office, kitchen or bedroom use",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940370",
    description: "Furniture; plastic",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940382",
    description: "Furniture; of bamboo",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940383",
    description: "Furniture; of rattan",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940389",
    description:
      "Furniture; of cane, osier, or similar materials (other than bamboo or rattan)",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940391",
    description: "Furniture; parts, of wood",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940399",
    description: "Furniture; parts, of other than wood",
    parent: "9403",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9404",
    description:
      "Mattress supports; articles of bedding (e.g. mattresses, quilts, eiderdowns, cushions pouffes and pillows), fitted with springs or stuffed, whether or not covered",
    parent: "94",
    level: "4",
  },
  {
    section: "XX",
    hscode: "940410",
    description: "Mattress supports",
    parent: "9404",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940421",
    description:
      "Mattresses; of cellular rubber or plastics, whether or not covered",
    parent: "9404",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940429",
    description:
      "Mattresses; of other materials, not cellular rubber or plastics",
    parent: "9404",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940430",
    description: "Sleeping bags",
    parent: "9404",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940440",
    description: "Quilts, bedspreads, eiderdowns and duvets (comforters)",
    parent: "9404",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940490",
    description:
      "Bedding and similar furnishing articles; n.e.c. in heading no. 9404 (e.g. quilts, eiderdowns, cushions, pouffes and pillows)",
    parent: "9404",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9405",
    description:
      "Luminaires and light fittings; including searchlights, spotlights and parts thereof, n.e.c.; illuminated signs, name-plates and the like, having permanently fixed light source and parts thereof n.e.c. or included",
    parent: "94",
    level: "4",
  },
  {
    section: "XX",
    hscode: "940511",
    description:
      "Luminaires and light fittings; chandeliers and electric ceiling or wall light fittings; (excluding those used for lighting public open spaces or thoroughfares), for use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940519",
    description:
      "Chandeliers and electric ceiling or wall light fittings; (excluding those used for lighting public open spaces or thoroughfares), for use other than with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940521",
    description:
      "Luminaires and light fittings; electric, table, desk, bedside or floor-standing, for use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940529",
    description:
      "Luminaires and light fittings; electric, table, desk, bedside or floor-standing, for other than use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940531",
    description:
      "Luminaires and light fittings; electric, lighting strings of a kind used for Christmas trees, for use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940539",
    description:
      "Luminaires and light fittings; electric, lighting strings of a kind used for Christmas trees, for other than use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940541",
    description:
      "Luminaires and light fittings; electric, photovoltaic, designed for use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940542",
    description:
      "Luminaires and light fittings; electric, designed for use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940549",
    description:
      "Luminaires and light fittings; electric, designed for other than use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940550",
    description: "Luminaires and light fittings; non-electric",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940561",
    description:
      "Luminaires; illuminated signs, illuminated name-plates and the like, designed for use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940569",
    description:
      "Luminaires; illuminated signs, illuminated name-plates and the like, designed for other than use solely with light-emitting diode (LED) light sources",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940591",
    description: "Lamps and light fittings; parts thereof, of glass",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940592",
    description: "Lamps and light fittings; parts thereof, of plastics",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940599",
    description:
      "Lamps and light fittings; parts thereof, of materials other than glass or plastics",
    parent: "9405",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9406",
    description: "Buildings; prefabricated",
    parent: "94",
    level: "4",
  },
  {
    section: "XX",
    hscode: "940610",
    description: "Buildings; prefabricated, of wood",
    parent: "9406",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940620",
    description: "Buildings; modular building units, of steel",
    parent: "9406",
    level: "6",
  },
  {
    section: "XX",
    hscode: "940690",
    description: "Buildings; prefabricated, not of wood",
    parent: "9406",
    level: "6",
  },
  {
    section: "XX",
    hscode: "95",
    description:
      "Toys, games and sports requisites; parts and accessories thereof",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XX",
    hscode: "9503",
    description:
      "Tricycles, scooters, pedal cars and similar wheeled toys; dolls' carriages; dolls; other toys; reduced-size (scale) models and similar recreational models, working or not; puzzles of all kinds",
    parent: "95",
    level: "4",
  },
  {
    section: "XX",
    hscode: "950300",
    description:
      "Tricycles, scooters, pedal cars and similar wheeled toys; dolls' carriages; dolls; other toys; reduced-size (scale) models and similar recreational models, working or not; puzzles of all kinds",
    parent: "9503",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9504",
    description:
      "Video game consoles and machines, articles for funfair, table or parlour games, including pintables, billiards, special tables for casino games and automatic bowling alley equipment",
    parent: "95",
    level: "4",
  },
  {
    section: "XX",
    hscode: "950420",
    description: "Billiard articles and accessories of all kinds",
    parent: "9504",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950430",
    description:
      "Games; operated by coins, banknotes, bank cards, tokens or by other means of payment, other than billiard articles and accesssories, and automatic bowling alley equipment",
    parent: "9504",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950440",
    description: "Games; playing cards",
    parent: "9504",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950450",
    description:
      "Games; video game consoles and machines, other than those of subheading 9504.30",
    parent: "9504",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950490",
    description:
      "Games; articles for funfair, table or parlour games, including pintables, special tables for casino games, automatic bowling alley equipment, n.e.c. in heading 9504",
    parent: "9504",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9505",
    description:
      "Festive, carnival or other entertainment articles, including conjuring tricks and novelty jokes",
    parent: "95",
    level: "4",
  },
  {
    section: "XX",
    hscode: "950510",
    description: "Christmas festivity articles",
    parent: "9505",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950590",
    description:
      "Festive, carnival or other entertainment articles including novelty jokes and conjuring tricks; other than Christmas festivity articles",
    parent: "9505",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9506",
    description:
      "Gymnastics, athletics, other sports (including table tennis) or outdoor games equipment, n.e.c. in this chapter, swimming pools and paddling pools",
    parent: "95",
    level: "4",
  },
  {
    section: "XX",
    hscode: "950611",
    description: "Skis; for snow",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950612",
    description: "Ski-fastenings (ski-bindings); for snow-skis",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950619",
    description: "Snow-ski equipment",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950621",
    description: "Sailboards; for water sport",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950629",
    description:
      "Water sport equipment; water-skis, surf-boards and other water-sport equipment, excluding sailboards",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950631",
    description: "Golf clubs; complete",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950632",
    description: "Golf balls",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950639",
    description: "Golf equipment; other than clubs and balls",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950640",
    description: "Table-tennis articles and equipment",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950651",
    description: "Lawn-tennis rackets; whether or not strung",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950659",
    description: "Tennis, badminton and similar rackets; whether or not strung",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950661",
    description: "Lawn-tennis balls",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950662",
    description: "Balls; inflatable",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950669",
    description:
      "Balls; (other than inflatable or for lawn-tennis, golf or table-tennis)",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950670",
    description:
      "Skates; ice and roller, including skating boots with skates attached",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950691",
    description: "Athletics and gymnastics equipment",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950699",
    description:
      "Equipment for outdoor games and recreation n.e.c. in heading no. 9506",
    parent: "9506",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9507",
    description:
      "Fishing rods, fish-hooks and other line fishing tackle; fish landing nets and the like; decoy birds (not those of heading no. 9208 or 9705) and similar hunting or shooting requisites",
    parent: "95",
    level: "4",
  },
  {
    section: "XX",
    hscode: "950710",
    description: "Fishing rods",
    parent: "9507",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950720",
    description: "Fish-hooks; whether or not snelled",
    parent: "9507",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950730",
    description: "Fishing reels",
    parent: "9507",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950790",
    description:
      "Fishing tackle n.e.c., butterfly nets, decoy birds (other than those of heading no. 9208 or 9705) and similar hunting or shooting requisites",
    parent: "9507",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9508",
    description:
      "Travelling circuses and travelling menageries, amusement park rides and water park amusements, fairground amusements, including shooting galleries and travelling theatres",
    parent: "95",
    level: "4",
  },
  {
    section: "XX",
    hscode: "950810",
    description: "Travelling circuses and travelling menageries",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950821",
    description:
      "Amusement park rides and water park amusements; Roller coasters",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950822",
    description:
      "Amusement park rides and water park amusements; carousels, swings and roundabouts",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950823",
    description:
      "Amusement park rides and water park amusements; dodge'em cars",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950824",
    description:
      "Amusement park rides and water park amusements; motion simulators and moving theatres",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950825",
    description: "Amusement park rides and water park amusements; water rides",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950826",
    description:
      "Amusement park rides and water park amusements; water park amusements",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950829",
    description:
      "Amusement park rides and water park amusements; other than roller coasters, carousels, swings, roundabouts, dodge'em cars, motion simulators and moving theatres, water rides and water park amusements",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950830",
    description: "Fairground amusements; including shooting galleries",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "950840",
    description: "Travelling theatres",
    parent: "9508",
    level: "6",
  },
  {
    section: "XX",
    hscode: "96",
    description: "Miscellaneous manufactured articles",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XX",
    hscode: "9601",
    description:
      "Ivory, bone, tortoise-shell, horn, antlers, coral, mother-of-pearl and other animal carving material and articles of these materials; worked, (including articles obtained by moulding)",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960110",
    description: "Ivory and articles thereof; worked",
    parent: "9601",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960190",
    description:
      "Bone, tortoise shell, horn, antlers, coral, mother-of-pearl and other animal carving material and articles thereof (including articles obtained by moulding)",
    parent: "9601",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9602",
    description:
      "Vegetable, mineral carving material and articles of these materials, moulded or carved articles of wax, stearin, natural gums, resins or modelling pastes, worked unhardened gelatin (not heading no. 3503)",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960200",
    description:
      "Vegetable, mineral carving material and articles of these materials, moulded or carved articles of wax, stearin, natural gums, resins or modelling pastes, worked unhardened gelatin (not heading no. 3503)",
    parent: "9602",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9603",
    description:
      "Brooms, brushes (including parts of machines), hand operated floor sweepers, mops and feather dusters; knots and tufts for broom or brush making; paint pads and rollers; squeegees",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960310",
    description:
      "Brooms and brushes; consisting of twigs or other vegetable materials bound together, with or without handles",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960321",
    description: "Brushes; toothbrushes",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960329",
    description:
      "Brushes; shaving, hair, nail, eyelash and other toilet brushes for use on the person, including brushes as parts of appliances",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960330",
    description:
      "Brushes; artists' brushes, writing brushes and similar brushes for the application of cosmetics",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960340",
    description:
      "Brushes; paint, distemper, varnish or similar brushes (not those of item no. 9603.30), paint pads and rollers",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960350",
    description:
      "Brushes; constituting parts of machines, appliances or vehicles",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960390",
    description:
      "Brooms, brushes, mops, feather dusters, squeegees, hand operated mechanical floor sweepers; (not motorised), prepared knots and tufts for brooms or brush making n.e.c.",
    parent: "9603",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9604",
    description: "Hand sieves and hand riddles",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960400",
    description: "Hand sieves and hand riddles",
    parent: "9604",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9605",
    description:
      "Travel sets; for personal toilet, sewing, shoe or clothes cleaning",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960500",
    description:
      "Travel sets; for personal toilet, sewing, shoe or clothes cleaning",
    parent: "9605",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9606",
    description:
      "Buttons, press-fasteners, snap-fasteners and press-studs, button moulds and other parts of these articles; button blanks",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960610",
    description:
      "Press-fasteners, snap-fasteners, press-studs and parts therefor",
    parent: "9606",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960621",
    description: "Buttons; of plastics, not covered with textile material",
    parent: "9606",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960622",
    description: "Buttons; of base metal, not covered with textile material",
    parent: "9606",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960629",
    description:
      "Buttons; of other than base metal or plastics, not covered with textile material",
    parent: "9606",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960630",
    description: "Button moulds and other parts of buttons; button blanks",
    parent: "9606",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9607",
    description: "Slide fasteners and parts thereof",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960711",
    description: "Slide fasteners; fitted with chain scoops of base metal",
    parent: "9607",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960719",
    description:
      "Slide fasteners; other than those fitted with chain scoops of base metal",
    parent: "9607",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960720",
    description: "Slide fasteners; parts",
    parent: "9607",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9608",
    description:
      "Pens; ball-point, felt tipped, other porous tipped pens; fountain pens, stylograph pens duplicating stylos, propelling or sliding pencils; parts of the foregoing, excluding those of heading no. 9609",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960810",
    description: "Pens; ball point",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960820",
    description: "Pens; felt tipped and other porous-tipped pens and markers",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960830",
    description: "Pens; fountain, stylograph and other pens",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960840",
    description: "Pencils; propelling or sliding",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960850",
    description:
      "Pen and pencil sets; of articles from two or more of the foregoing sub-headings",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960860",
    description:
      "Pens; ball-point, refills comprising the ball point and ink-reservoir",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960891",
    description: "Pens; nibs and nib points",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960899",
    description:
      "Pens and pencils; duplicating stylos, pen-holders, pencil-holders, and similar holders, parts of the articles of heading 9608, including caps and clips",
    parent: "9608",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9609",
    description:
      "Pencils (not of heading no. 9608), crayons, pencil leads, pastels, drawing charcoals, writing or drawing chalks and tailors' chalks",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "960910",
    description: "Pencils and crayons; with leads encased in sheath",
    parent: "9609",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960920",
    description: "Pencil leads; black or coloured",
    parent: "9609",
    level: "6",
  },
  {
    section: "XX",
    hscode: "960990",
    description:
      "Pastels, drawing charcoals, writing or drawing chalks, tailors' chalk",
    parent: "9609",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9610",
    description:
      "Slates and boards, with writing or drawing surfaces, whether or not framed",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961000",
    description:
      "Slates and boards; with writing or drawing surfaces, whether or not framed",
    parent: "9610",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9611",
    description:
      "Stamps; date, numbering, sealing stamps and the like (including devices for printing or embossing labels), designed for operating by hand; hand operated composing sticks and printing sets",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961100",
    description:
      "Stamps; date, numbering, sealing stamps and the like (including devices for printing or embossing labels), designed for operating by hand; hand operated composing sticks and printing sets",
    parent: "9611",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9612",
    description:
      "Typewriter, similar ribbons, inked, otherwise prepared for giving impressions, whether or not on spools or in cartridges; ink pads, whether or not inked, with or without boxes",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961210",
    description:
      "Ribbons; for typewriters and the like, inked or otherwise prepared, for giving impressions, whether or not on spools or in cartridges",
    parent: "9612",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961220",
    description: "Ink pads; whether or not inked, with or without boxes",
    parent: "9612",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9613",
    description:
      "Cigarette lighters and other lighters, whether or not mechanical or electrical and parts thereof other than flints and wicks",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961310",
    description: "Lighters; pocket, cigarette, gas fuelled, non-refillable",
    parent: "9613",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961320",
    description: "Lighters; pocket, cigarette, gas fuelled, refillable",
    parent: "9613",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961380",
    description:
      "Lighters; whether or not mechanical or electrical, n.e.c. in heading no. 9613",
    parent: "9613",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961390",
    description:
      "Lighters; parts for cigarette lighters and other lighters, whether or not mechanical or electrical, other than flints and wicks",
    parent: "9613",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9614",
    description:
      "Smoking pipes (including pipe bowls) and cigar or cigarette holders, and parts thereof",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961400",
    description:
      "Smoking pipes (including pipe bowls) and cigar or cigarette holders, and parts thereof",
    parent: "9614",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9615",
    description:
      "Combs, hair-slides and similar; hairpins, curling pins, curling grips and hair curlers and the like, other than those of heading no. 8516 and parts thereof",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961511",
    description: "Combs, hair slides and the like; of hard rubber or plastics",
    parent: "9615",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961519",
    description:
      "Combs, hair slides and the like; of other than hard rubber or plastics",
    parent: "9615",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961590",
    description:
      "Hairpins, curling pins, curling grips, hair curlers and the like (not those of heading no. 8516) and parts thereof",
    parent: "9615",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9616",
    description:
      "Scent sprays and similar toilet sprays and mounts and heads therefor; powder-puffs and pads for the application of cosmetics or toilet preparations",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961610",
    description:
      "Scent sprays and similar toilet sprays, and mounts and heads therefor",
    parent: "9616",
    level: "6",
  },
  {
    section: "XX",
    hscode: "961620",
    description:
      "Powder puffs and pads; for the application of cosmetics or toilet preparations",
    parent: "9616",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9617",
    description:
      "Vacuum flasks and other vacuum vessels, complete with cases; parts thereof other than glass inners",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961700",
    description:
      "Vacuum flasks and other vacuum vessels, complete with cases; parts thereof other than glass inners",
    parent: "9617",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9618",
    description:
      "Tailors' dummies and other lay figures; automata and other animated displays used for shop window dressing",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961800",
    description:
      "Tailors' dummies and other lay figures; automata and other animated displays used for shop window dressing",
    parent: "9618",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9619",
    description:
      "Sanitary towels (pads) and tampons, napkins (diapers), napkin liners and similar articles, of any material",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "961900",
    description:
      "Sanitary towels (pads) and tampons, napkins (diapers), napkin liners and similar articles, of any material",
    parent: "9619",
    level: "6",
  },
  {
    section: "XX",
    hscode: "9620",
    description: "Monopods, bipods, tripods and similar articles",
    parent: "96",
    level: "4",
  },
  {
    section: "XX",
    hscode: "962000",
    description: "Monopods, bipods, tripods and similar articles",
    parent: "9620",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "97",
    description: "Works of art; collectors' pieces and antiques",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "XXI",
    hscode: "9701",
    description:
      "Paintings, drawings and pastels, executed entirely by hand; not drawings of heading no. 4906 and not hand-painted, hand-decorated manufactured articles; collages, mosaics and similar decorative plaques",
    parent: "97",
    level: "4",
  },
  {
    section: "XXI",
    hscode: "970121",
    description:
      "Paintings, drawings and pastels; executed entirely by hand, other than drawings of heading no. 4906, of an age exceeding 100 years",
    parent: "9701",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970122",
    description:
      "Mosaics; executed entirely by hand, other than drawings of heading no. 4906, of an age exceeding 100 years",
    parent: "9701",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970129",
    description:
      "Artwork; other than paintings, drawings, pastels mosaics, executed entirely by hand, other than drawings of heading no. 4906, of an age exceeding 100 years",
    parent: "9701",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970191",
    description:
      "Paintings, drawings and pastels; executed entirely by hand, other than drawings of heading no. 4906, of an age not exceeding 100 years",
    parent: "9701",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970192",
    description:
      "Mosaics; executed entirely by hand, other than drawings of heading no. 4906, of an age not exceeding 100 years",
    parent: "9701",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970199",
    description:
      "Artwork; other than paintings, drawings, pastels mosaics, executed entirely by hand, other than drawings of heading no. 4906, of an age not exceeding 100 years",
    parent: "9701",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "9702",
    description: "Engravings, prints and lithographs; original",
    parent: "97",
    level: "4",
  },
  {
    section: "XXI",
    hscode: "970210",
    description:
      "Engravings, prints and lithographs; original of an age exceeding 100 years",
    parent: "9702",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970290",
    description:
      "Engravings, prints and lithographs; original of an age not exceeding 100 years",
    parent: "9702",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "9703",
    description: "Sculptures and statuary; original, in any material",
    parent: "97",
    level: "4",
  },
  {
    section: "XXI",
    hscode: "970310",
    description:
      "Sculptures and statuary; original, in any material, of an age exceeding 100 years",
    parent: "9703",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970390",
    description:
      "Sculptures and statuary; original, in any material, of an age not exceeding 100 years",
    parent: "9703",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "9704",
    description:
      "Stamps, postage or revenue; stamp-postmarks, first-day covers, postal stationery (stamped paper) and like, used or unused, other than those of heading 4907",
    parent: "97",
    level: "4",
  },
  {
    section: "XXI",
    hscode: "970400",
    description:
      "Stamps, postage or revenue; stamp-postmarks, first-day covers, postal stationery (stamped paper) and like, used or unused, other than those of heading 4907",
    parent: "9704",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "9705",
    description:
      "Collections and collectors' pieces; of archaeological, ethnographic, historical, zoological, botanical, mineralogical, anatomical, palaeontological or numismatic interest",
    parent: "97",
    level: "4",
  },
  {
    section: "XXI",
    hscode: "970510",
    description:
      "Collections and collectors' pieces; of archaeological, ethnographic or historical interest",
    parent: "9705",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970521",
    description:
      "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical or palaeontological interest, human specimens and parts thereof",
    parent: "9705",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970522",
    description:
      "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical or palaeontological interest, extinct or endangered species and parts thereof",
    parent: "9705",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970529",
    description:
      "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical or palaeontological interest, other than human species, extinct or endangered species and parts thereof",
    parent: "9705",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970531",
    description:
      "Collections and collectors' pieces; of numismatic interest, of an age exceeding 100 years",
    parent: "9705",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970539",
    description:
      "Collections and collectors' pieces; of numismatic interest, of an age not exceeding 100 years",
    parent: "9705",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "9706",
    description: "Antiques; of an age exceeding one hundred years",
    parent: "97",
    level: "4",
  },
  {
    section: "XXI",
    hscode: "970610",
    description: "Antiques; of an age exceeding 250 years",
    parent: "9706",
    level: "6",
  },
  {
    section: "XXI",
    hscode: "970690",
    description:
      "Antiques; of an age exceeding 100 years but not exceeding 250 years",
    parent: "9706",
    level: "6",
  },
  {
    section: "TOTAL",
    hscode: "99",
    description: "Commodities not specified according to kind",
    parent: "TOTAL",
    level: "2",
  },
  {
    section: "TOTAL",
    hscode: "9999",
    description: "Commodities not specified according to kind",
    parent: "99",
    level: "4",
  },
  {
    section: "TOTAL",
    hscode: "999999",
    description: "Commodities not specified according to kind",
    parent: "9999",
    level: "6",
  },
  {
    section: "TOTAL",
    hscode: "TOTAL",
    description: "Total of all HS2022 commodities",
    parent: "TOTAL",
    level: "5",
  },
];

export const HarmonizationCodes =
  HS_CODE_CHAPTERS_HEADINGS_AND_SUBHEADINGS.filter(
    (code) => code.hscode.length >= 6,
  );
